import React, { createElement } from 'react';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("path", {
  d: "M3.953 10.512a5.24 5.24 0 006.996 3.141c.625-.262 1.184-.641 1.666-1.122s.859-1.041 1.122-1.666c.272-.647.412-1.331.412-2.037s-.137-1.394-.412-2.037c-.262-.625-.641-1.184-1.122-1.666s-1.041-.859-1.666-1.122a5.226 5.226 0 00-2.037-.413c-.716 0-1.431.144-2.066.413-.509.216-1.372.769-1.875 1.291l-.003.003V.984h7.241c.262-.003.262-.372.262-.491 0-.122 0-.487-.266-.491H4.377a.343.343 0 00-.344.341v6.066c0 .197.244.338.472.384.444.094.544-.047.653-.197l.016-.019c.166-.247.681-.766.688-.772a4.262 4.262 0 013.037-1.25c1.147 0 2.222.444 3.028 1.25a4.245 4.245 0 011.256 3.019 4.236 4.236 0 01-1.25 3.019 4.336 4.336 0 01-3.047 1.25 4.136 4.136 0 01-2.159-.597l.003-3.688c0-.491.213-1.028.572-1.431a2.09 2.09 0 011.588-.716c.594 0 1.15.225 1.566.634.409.406.637.95.637 1.528a2.179 2.179 0 01-2.206 2.197c-.238 0-.672-.106-.691-.109-.25-.075-.356.272-.391.387-.134.441.069.528.109.541.397.125.659.147 1.003.147a3.173 3.173 0 003.169-3.169c0-1.734-1.422-3.144-3.166-3.144-.856 0-1.659.328-2.263.919-.575.566-.903 1.319-.903 2.069v.019c-.003.094-.003 2.306-.006 3.031l-.003-.003c-.328-.363-.653-.919-.869-1.488-.084-.222-.275-.184-.534-.103-.125.034-.469.141-.391.394zm3.722-.865c0 .106.097.2.156.253l.019.019c.1.097.194.147.281.147a.181.181 0 00.131-.05c.044-.041.537-.544.588-.591l.553.55c.05.056.106.088.172.088.088 0 .184-.053.284-.156.238-.244.119-.375.063-.438l-.559-.559.584-.588c.128-.137.016-.284-.097-.397-.162-.162-.322-.206-.422-.112l-.581.581-.588-.588a.16.16 0 00-.113-.047c-.078 0-.172.053-.275.156-.181.181-.219.306-.125.406l.588.584-.584.584c-.053.05-.078.103-.075.156zm1.278-7.931c-.938 0-1.938.191-2.669.506a.207.207 0 00-.134.181.753.753 0 00.069.337c.047.116.166.425.4.334a6.689 6.689 0 012.334-.444 6.35 6.35 0 012.469.497c.622.263 1.206.644 1.844 1.194a.22.22 0 00.147.059c.125 0 .244-.122.347-.237.169-.191.287-.35.119-.509a6.858 6.858 0 00-2.1-1.356 7.326 7.326 0 00-2.825-.563zM14.006 13.3c-.113-.113-.209-.178-.294-.203s-.162-.006-.222.053l-.056.056a6.32 6.32 0 01-6.938 1.356 6.336 6.336 0 01-2.013-1.356 6.046 6.046 0 01-1.356-2.012c-.288-.713-.381-1.247-.413-1.422-.003-.016-.006-.028-.006-.037-.041-.206-.231-.222-.503-.178-.112.019-.459.072-.428.319v.006a7.261 7.261 0 002.04 3.994 7.266 7.266 0 0010.288 0l.059-.059c.069-.084.134-.225-.159-.516z"
});

function Svg500Px(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("path", {
  d: "M6.5 1.5a1.5 1.5 0 113.001.001A1.5 1.5 0 016.5 1.5z"
});

var _ref2 = /*#__PURE__*/createElement("path", {
  d: "M10 5l5.15-2.221-.371-.929L8.5 4h-1L1.221 1.85l-.371.929L6 5v4l-2.051 6.634.935.355L7.786 9.5h.429l2.902 6.489.935-.355L10.001 9z"
});

function SvgAccessibility(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1, _ref2);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("path", {
  d: "M16 10.985l-1.545 1.03L11.5 8H7V7h4V5H7V4l-2-.5V10h5.5l3.268 4.357 3.119-2.079zM8 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 018 1.5z"
});

var _ref2$1 = /*#__PURE__*/createElement("path", {
  d: "M10.609 12.349a5 5 0 11-6.398-7.295L3.233 3.88a6.5 6.5 0 108.415 9.588l-1.039-1.119z"
});

function SvgAccessibility2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2, _ref2$1);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M3 0v16h12V0H3zm6 4.005a1.995 1.995 0 110 3.99 1.995 1.995 0 010-3.99zM12 12H6v-1a2 2 0 012-2h2a2 2 0 012 2v1zM1 1h1.5v3H1V1zM1 5h1.5v3H1V5zM1 9h1.5v3H1V9zM1 13h1.5v3H1v-3z"
});

function SvgAddressBook(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  d: "M14.5 8h.5a1 1 0 001-1V5h-1.5v3zM14.5 1v3h.5a1 1 0 001-1V1h-1.5zM14 9V0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h13V9zM8 4.005a1.995 1.995 0 110 3.99 1.995 1.995 0 010-3.99zM3 15H2V1h1v14zm8-3H5v-1a2 2 0 012-2h2a2 2 0 012 2v1zM14.5 12h.5a1 1 0 001-1V9h-1.5v3z"
});

function SvgAddressBook2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4);
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/createElement("path", {
  d: "M13.5 1h-11a.5.5 0 00-.5.5V3H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1.5a.5.5 0 00.5.5h11c.827 0 1.5-.673 1.5-1.5v-12c0-.827-.673-1.5-1.5-1.5zM5 15H3v-1a1 1 0 000-2v-1a1 1 0 000-2V8a1 1 0 000-2V5a1 1 0 000-2V2h2v13zm7-9h-1.611C10.138 6.693 10 7.575 10 8.5s.138 1.807.389 2.5H12v3h-1c-.528 0-1.035-.218-1.468-.629-.334-.317-.623-.749-.86-1.283C8.239 11.113 8 9.839 8 8.5s.239-2.613.672-3.588c.237-.534.527-.965.86-1.283C9.965 3.217 10.472 3 11 3h1v3z"
});

function SvgAddressBook3(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5);
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/createElement("path", {
  d: "M14 4h-3V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2H2C.9 4 0 4.9 0 6v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM6 2h4v2H6V2zm6 9H9v3H7v-3H4V9h3V6h2v3h3v2z"
});

function SvgAidKit(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6);
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/createElement("path", {
  d: "M14 4h-3V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2H2C.9 4 0 4.9 0 6v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM6 2h4v2H6V2zm9 12c0 .551-.449 1-1 1H2c-.551 0-1-.449-1-1V6c0-.551.449-1 1-1h12c.551 0 1 .449 1 1v8z"
});

var _ref2$2 = /*#__PURE__*/createElement("path", {
  d: "M12 11H9v3H7v-3H4V9h3V6h2v3h3z"
});

function SvgAidKit2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7, _ref2$2);
}

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/createElement("path", {
  d: "M12 9.999L9.143 7.142 16 1.999l-2-2-8.571 3.429L2.731.729C1.953-.049.867-.235.317.315s-.364 1.636.414 2.414l2.698 2.698L0 13.999l2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2h-4z"
});

function SvgAirplane(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8);
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/createElement("path", {
  d: "M13 7h-2.1L6.5 1H4l3.2 6H3.5l-2-2H0l2 3.5L0 12h1.5l2-2h3.7L4 16h2.5l4.4-6H13c1.65 0 3-.675 3-1.5S14.65 7 13 7z"
});

function SvgAirplane2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9);
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a = /*#__PURE__*/createElement("path", {
  d: "M14.658 8.06l-3.289 1.197-8.331-3.885-2.349.855 6.452 4.569-3.289 1.197-2.563-1.195-1.292.47 3.13 3.117 12.216-4.446a1 1 0 00-.684-1.88z"
});

function SvgAirplane3(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a);
}

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b = /*#__PURE__*/createElement("path", {
  d: "M15.342 13.06l-3.289-1.197-3.885-8.331-2.349-.855 2.005 7.647-3.289-1.197L3.34 6.564l-1.292-.47.394 4.4 12.216 4.446a1 1 0 00.684-1.88z"
});

function SvgAirplane4(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b);
}

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c = /*#__PURE__*/createElement("path", {
  d: "M8 2a7 7 0 100 14A7 7 0 008 2zm0 12.625a5.624 5.624 0 110-11.25 5.624 5.624 0 110 11.25zm6.606-10.138a3 3 0 00-4.98-3.321 8.008 8.008 0 014.98 3.322zM6.374 1.166a3 3 0 00-4.98 3.321 8.006 8.006 0 014.98-3.322z"
});

var _ref2$3 = /*#__PURE__*/createElement("path", {
  d: "M11 8H9V6H7v2H5v2h2v2h2v-2h2z"
});

function SvgAlarmAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c, _ref2$3);
}

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d = /*#__PURE__*/createElement("path", {
  d: "M8 2a7 7 0 100 14A7 7 0 008 2zm0 12.625a5.624 5.624 0 110-11.25 5.624 5.624 0 110 11.25zm6.606-10.138a3 3 0 00-4.98-3.321 8.008 8.008 0 014.98 3.322zM6.374 1.166a3 3 0 00-4.98 3.321 8.006 8.006 0 014.98-3.322z"
});

var _ref2$4 = /*#__PURE__*/createElement("path", {
  d: "M11.457 11.043l-1.414 1.414L8 10.414l-2.043 2.043-1.414-1.414L6.586 9 4.543 6.957l1.414-1.414L8 7.586l2.043-2.043 1.414 1.414L9.414 9l2.043 2.043z"
});

function SvgAlarmCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d, _ref2$4);
}

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e = /*#__PURE__*/createElement("path", {
  d: "M8 2a7 7 0 100 14A7 7 0 008 2zm0 12.625a5.624 5.624 0 110-11.25 5.624 5.624 0 110 11.25zm6.606-10.138a3 3 0 00-4.98-3.321 8.008 8.008 0 014.98 3.322zM6.374 1.166a3 3 0 00-4.98 3.321 8.006 8.006 0 014.98-3.322z"
});

var _ref2$5 = /*#__PURE__*/createElement("path", {
  d: "M11 6.5l-4 4L5.5 9l-1 1L7 12.5l5-5z"
});

function SvgAlarmCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e, _ref2$5);
}

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f = /*#__PURE__*/createElement("path", {
  d: "M8 2a7 7 0 100 14A7 7 0 008 2zm0 12.625a5.624 5.624 0 110-11.25 5.624 5.624 0 110 11.25zm6.606-10.138a3 3 0 00-4.98-3.321 8.008 8.008 0 014.98 3.322zM6.374 1.166a3 3 0 00-4.98 3.321 8.006 8.006 0 014.98-3.322z"
});

var _ref2$6 = /*#__PURE__*/createElement("path", {
  d: "M8 9V5H7v5h4V9z"
});

function SvgAlarm(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f, _ref2$6);
}

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g = /*#__PURE__*/createElement("path", {
  d: "M8 3a1 1 0 01-1-1V1a1 1 0 012 0v1a1 1 0 01-1 1zM12.5 11H12V8a4 4 0 00-8 0v3h-.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM13.5 16h-11a.5.5 0 010-1h11a.5.5 0 010 1zM3 4a.997.997 0 01-.707-.293l-1-1a.999.999 0 111.414-1.414l1 1A.999.999 0 013 4zM2 9H1a1 1 0 010-2h1a1 1 0 010 2zM13 4a.999.999 0 01-.707-1.707l1-1a.999.999 0 111.414 1.414l-1 1A.997.997 0 0113 4zM15 9h-1a1 1 0 010-2h1a1 1 0 010 2z"
});

function SvgAlarm2(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g);
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h = /*#__PURE__*/createElement("path", {
  d: "M14.5 4h-13c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h13c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zM12 12.5c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V8.286L7 9.715v3.786c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V8.001l6-2v6.5zM13.5 3h-11a.5.5 0 010-1h11a.5.5 0 010 1zM12.5 1h-9a.5.5 0 010-1h9a.5.5 0 010 1z"
});

function SvgAlbum(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h);
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i = /*#__PURE__*/createElement("path", {
  d: "M6 2v9H4V2h2zm1-1H3v11h4V1zm9 14v-2H0v2zm-3-3V5H9v7z"
});

function SvgAlignBottom(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i);
}

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j = /*#__PURE__*/createElement("path", {
  d: "M14 9H9V7h3V3H9V0H7v3H4v4h3v2H2v4h5v3h2v-3h5V9zm-1 3H3v-2h10v2z"
});

function SvgAlignCenterHorizontal(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j);
}

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k = /*#__PURE__*/createElement("path", {
  d: "M7 14V9h2v3h4V9h3V7h-3V4H9v3H7V2H3v5H0v2h3v5h4zm-3-1V3h2v10H4z"
});

function SvgAlignCenterVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k);
}

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l = /*#__PURE__*/createElement("path", {
  d: "M14 10H5v2h9v-2zm1-1v4H4V9h11zM1 0h2v16H1zm3 3h7v4H4z"
});

function SvgAlignLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l);
}

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m = /*#__PURE__*/createElement("path", {
  d: "M2 10h9v2H2v-2zM1 9v4h11V9H1zm14-9h-2v16h2zm-3 3H5v4h7z"
});

function SvgAlignRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m);
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n = /*#__PURE__*/createElement("path", {
  d: "M6 14V5H4v9h2zm1 1H3V4h4v11zm9-14v2H0V1zm-3 3v7H9V4z"
});

function SvgAlignTop(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n);
}

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o = /*#__PURE__*/createElement("path", {
  d: "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-.163-.147-.019-.35.178-.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-.403 6.041-1.238.294-.125.544.197.253.409z"
});

var _ref2$7 = /*#__PURE__*/createElement("path", {
  d: "M15.191 13c-.225-.287-1.481-.137-2.047-.069-.172.019-.197-.128-.044-.238 1.003-.703 2.647-.5 2.838-.266.194.238-.05 1.884-.991 2.672-.144.122-.281.056-.219-.103.216-.528.688-1.709.463-1.997zM11.053 11.838l.003.003c.387-.341 1.084-.95 1.478-1.278.156-.125.128-.334.006-.509-.353-.488-.728-.884-.728-1.784v-3c0-1.272.088-2.438-.847-3.313-.738-.706-1.963-.956-2.9-.956-1.831 0-3.875.684-4.303 2.947-.047.241.131.369.287.403l1.866.203c.175-.009.3-.181.334-.356.159-.778.813-1.156 1.547-1.156.397 0 .847.144 1.081.5.269.397.234.938.234 1.397v.25c-1.116.125-2.575.206-3.619.666-1.206.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-.322 3.172-1.403.35.506.463.753 1.103 1.284a.395.395 0 00.456-.044zm-1.94-4.694c0 .75.019 1.375-.359 2.041-.306.544-.791.875-1.331.875-.737 0-1.169-.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v.416z"
});

function SvgAmazon(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o, _ref2$7);
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p = /*#__PURE__*/createElement("path", {
  d: "M15.947 9.276l-2-4A.5.5 0 0013.5 5H11V3.5a.5.5 0 00-.5-.5H9V2H6v1H.5a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h1.769A2.002 2.002 0 004 16a2.002 2.002 0 001.731-3h5.538A2.002 2.002 0 0013 16a2.002 2.002 0 001.731-3h.769a.5.5 0 00.5-.5v-3a.499.499 0 00-.053-.224zM11 6h2.191l1 2H11V6zm4 6H1V4h9v4.5a.5.5 0 00.5.5h4.191l.309.618V12z"
});

var _ref2$8 = /*#__PURE__*/createElement("path", {
  d: "M6 5H4v2H2v2h2v2h2V9h2V7H6z"
});

function SvgAmbulance(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p, _ref2$8);
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q = /*#__PURE__*/createElement("path", {
  d: "M3.871 3.504a.999.999 0 00-1.742 0C1.336 4.719 1 7.02 1 9.012v6.492a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.012c0-1.992-.336-4.293-1.129-5.508zM3 14.5a.5.5 0 01-1 0v-6a.5.5 0 011 0v.504l.008.008H3V14.5zM8.871 3.504a.999.999 0 00-1.742 0C6.336 4.719 6 7.02 6 9.012v6.492a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.012c0-1.992-.336-4.293-1.129-5.508zM8 14.5a.5.5 0 01-1 0v-6a.5.5 0 011 0v.504l.008.008H8V14.5zM13.871 3.504a.999.999 0 00-1.742 0C11.336 4.719 11 7.02 11 9.012v6.492a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.012c0-1.992-.336-4.293-1.129-5.508zM13 14.5a.5.5 0 01-1 0v-6a.5.5 0 011 0v.504l.008.008H13V14.5z"
});

function SvgAmmo(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$q);
}

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r = /*#__PURE__*/createElement("path", {
  d: "M12.992 7.09c-.942-.328-1.966.383-1.992 1.384a.504.504 0 00.672.496c.276-.102.274-.312.332-.549.059-.239.238-.423.495-.427.173.005.51.126.51.493a1.532 1.532 0 01-.97 1.431 1.488 1.488 0 01-.814.077c-.378-.065-.57-.288-.859-.475a2.696 2.696 0 00-.59-.409c-1.661-.856-3.973.382-3.777 2.375a.508.508 0 00.729.412c.233-.119.241-.325.296-.546.169-.68.748-1.206 1.475-1.172.262.003.681.174.906.412.368.387.396.889.335 1.388-.202 1.645-1.518 3.067-3.241 3.029-2.721-.029-3.824-3.624-2.291-5.608.507-.656 1.228-1.103 2.02-1.331.284-.082.647-.023.8-.335a.491.491 0 00-.327-.688c-.682-.235-1.28-.379-1.774-.958a2.507 2.507 0 01-.6-1.588c.016-1.146.917-2.23 2.171-2.346h-.013a2.447 2.447 0 012.593 2.328.572.572 0 01-.576.604.635.635 0 01-.271-.081c-.385-.249-.079-.702-.402-.977-.337-.286-.869-.014-.833.427-.005.386.196.79.47 1.052.79.754 2.175.397 2.422-.718.366-1.752-1.146-3.492-2.776-3.858a3.665 3.665 0 00-3.603 1.244c-.948 1.149-1.111 2.826-.366 4.122.236.413.557.775.934 1.06-1.466.73-2.512 2.32-2.557 4.001-.06 2.269 1.64 4.082 3.807 4.525 1.979.404 4.168-.377 5.256-2.125.513-.824.752-1.874.568-2.804a2.5 2.5 0 001.752-.403c1.072-.732 1.738-2.886.09-3.46z"
});

function SvgAmpersand(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$r);
}

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s = /*#__PURE__*/createElement("path", {
  d: "M14 9v2.066c-1.258 1.285-3.016 2.526-5 2.852V8.001h3v-1L9 5.83A3.001 3.001 0 008 .001 3 3 0 007 5.83L4 7.001v1h3v5.917c-1.984-.326-3.742-1.567-5-2.852V9H0v1c0 2 4 6 8 6s8-4 8-6V9h-2zM9 3a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgAnchor(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$s);
}

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t = /*#__PURE__*/createElement("path", {
  d: "M14 6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1zM2 6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1zm1.5 5.5A1.5 1.5 0 005 13v2c0 .55.45 1 1 1s1-.45 1-1v-2h2v2c0 .55.45 1 1 1s1-.45 1-1v-2a1.5 1.5 0 001.5-1.5V6h-9v5.5zM12.472 5a4.5 4.5 0 00-2.025-3.276l.5-1.001a.5.5 0 00-.895-.447L9.55 1.28l-.13-.052a4.504 4.504 0 00-2.84 0l-.13.052L5.948.276a.5.5 0 00-.895.447l.5 1.001A4.499 4.499 0 003.528 5v.5H12.5V5h-.028zM6.5 4a.5.5 0 01-.001-1h.002A.5.5 0 016.5 4zm3 0a.5.5 0 01-.001-1h.003a.5.5 0 01-.001 1z"
});

function SvgAndroid(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$t);
}

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u = /*#__PURE__*/createElement("path", {
  d: "M15 13h-3.046a10.96 10.96 0 00-3.176-6.778l-.068-.067 1.929-2.357a1 1 0 10-1.548-1.266L.228 13.364l-.001.001-.002.002A1 1 0 00.998 15h14a1 1 0 000-2zM8.075 6.933A9.925 9.925 0 0110.951 13h-7.84l4.964-6.067z"
});

function SvgAngle(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$u);
}

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm3.002 10.699C10.39 11.181 9.275 10.5 8 10.5s-2.389.681-3.002 1.699l-1.286-.772C4.586 9.973 6.179 9 8 9s3.414.973 4.288 2.427l-1.286.772zm.983-7.82a.5.5 0 01-.364.606c-.275.07-.602.189-.89.334A.998.998 0 019.999 7a1 1 0 01-1-1l.002-.054c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 01.606.364zm-7.97 0a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606z"
});

function SvgAngry(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$v);
}

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1.001 5.946c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.998 7a1 1 0 01-1-1L9 5.946zM4.015 4.379a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606zm6.987 7.82C10.39 11.181 9.275 10.5 8 10.5s-2.389.681-3.002 1.699l-1.286-.772C4.586 9.973 6.179 9 8 9s3.414.973 4.288 2.427l-1.286.772z"
});

function SvgAngry2(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$w);
}

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x = /*#__PURE__*/createElement("path", {
  d: "M11.182 11.932a.75.75 0 01-.53-1.281c1.462-1.462 1.462-3.841 0-5.303s-3.841-1.462-5.303 0C4.641 6.056 4.251 6.998 4.251 8s.39 1.943 1.098 2.652a.75.75 0 11-1.061 1.061c-.992-.992-1.538-2.31-1.538-3.712s.546-2.721 1.538-3.712c2.047-2.047 5.378-2.047 7.425 0s2.047 5.378 0 7.425a.748.748 0 01-.53.22z"
});

var _ref2$9 = /*#__PURE__*/createElement("path", {
  d: "M13.127 13.877a.75.75 0 01-.53-1.281c2.534-2.534 2.534-6.658 0-9.192s-6.658-2.534-9.192 0a6.508 6.508 0 000 9.192.75.75 0 11-1.061 1.061C.833 12.146.001 10.137.001 8s.832-4.146 2.343-5.657C3.855.832 5.864 0 8.001 0s4.146.832 5.657 2.343c1.511 1.511 2.343 3.52 2.343 5.657s-.832 4.146-2.343 5.657a.748.748 0 01-.53.22z"
});

var _ref3 = /*#__PURE__*/createElement("path", {
  d: "M9.5 15h-.501L9 9.732A1.999 1.999 0 008 6a2 2 0 00-1 3.732L6.999 15H6.5a.5.5 0 000 1h3a.5.5 0 000-1z"
});

function SvgAntenna(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$x, _ref2$9, _ref3);
}

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y = /*#__PURE__*/createElement("path", {
  d: "M5 16h6l-2-2V6.732A1.999 1.999 0 008 3a2 2 0 00-1 3.732V14l-2 2zm6.122-13.5c.549.685.878 1.554.878 2.5s-.329 1.815-.878 2.5l.781.625C12.589 7.269 13 6.183 13 5s-.411-2.269-1.097-3.125l-.781.625zm-7.025-.625C3.411 2.731 3 3.817 3 5s.411 2.269 1.097 3.125l.781-.625C4.329 6.815 4 5.946 4 5s.329-1.815.878-2.5l-.781-.625zM1.755 0C.657 1.37 0 3.108 0 5s.657 3.63 1.755 5l.781-.625C1.575 8.177 1 6.656 1 5S1.575 1.824 2.536.625L1.755 0zm12.49 0l-.781.625C14.425 1.823 15 3.344 15 5s-.575 3.176-1.536 4.375l.781.625C15.343 8.63 16 6.892 16 5s-.657-3.63-1.755-5z"
});

function SvgAntenna2(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$y);
}

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z = /*#__PURE__*/createElement("path", {
  d: "M8 4.958c-1.321-1.351-7-2.22-7 4.193 0 3.962 5.016 8.348 6.999 6.35h.002C9.984 17.499 15 13.113 15 9.151c0-6.413-5.679-5.544-7-4.193zm5.017 5.706c-.376 1.45-1.622 2.798-3.086 3.751 1.53-1.821 2.473-4.905 1.561-7.296a9.02 9.02 0 00-.923-1.822c1.797.603 3.279 2.166 2.448 5.368zM7.505 3.188c.213-.051.415-.117.608-.196-.07.323-.113.663-.113 1.007h.333c.29-1.355 1.381-2.938 2.835-2.938 0-.745-.505-1.063-1.074-1.063C9.553.266 9.081.747 8.7 1.427c-.206.367-.421.87-.557 1.433a2.89 2.89 0 00-.124-.477C7.402.648 5.251-.365 3.216.121a4.305 4.305 0 00-.656.214c.026.196.072.393.142.59.617 1.735 2.767 2.748 4.803 2.262z"
});

function SvgApple(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$z);
}

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A = /*#__PURE__*/createElement("path", {
  d: "M12.367 8.501c-.02-2.026 1.652-2.998 1.727-3.046-.94-1.375-2.404-1.564-2.926-1.585-1.246-.126-2.431.734-3.064.734-.631 0-1.607-.715-2.64-.696-1.358.02-2.61.79-3.31 2.006-1.411 2.448-.361 6.076 1.014 8.061.672.972 1.473 2.064 2.525 2.025 1.013-.04 1.396-.656 2.621-.656s1.569.656 2.641.635c1.09-.02 1.781-.991 2.448-1.966.772-1.128 1.089-2.219 1.108-2.275-.024-.011-2.126-.816-2.147-3.236zm-2.014-5.946c.558-.677.935-1.617.832-2.555-.804.033-1.779.536-2.356 1.212-.518.6-.971 1.557-.85 2.476.898.07 1.815-.456 2.373-1.132z"
});

function SvgAppleinc(props) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$A);
}

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B = /*#__PURE__*/createElement("path", {
  d: "M13.5 3H12V1.5a.5.5 0 00-1 0v1a.5.5 0 00-1 0v1.793l-.549.549A3.98 3.98 0 007 4.001c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4c0-.923-.314-1.774-.841-2.451l.549-.549h1.793a.5.5 0 000-1h1a.5.5 0 000-1zM10 8c0 1.654-1.346 3-3 3S4 9.654 4 8s1.346-3 3-3a2.98 2.98 0 011.737.556L7.259 7.034a1 1 0 10.707.707l1.478-1.478C9.794 6.754 10 7.353 10 8z"
});

var _ref2$a = /*#__PURE__*/createElement("path", {
  d: "M13.063 8a6.09 6.09 0 00-.228-1.653.562.562 0 10-1.082.306 4.943 4.943 0 01-4.752 6.285A4.943 4.943 0 012.063 8a4.943 4.943 0 016.285-4.752.561.561 0 10.306-1.082A6.07 6.07 0 00.938 8.001c0 1.746.742 3.321 1.927 4.428l-1.718 1.718a.5.5 0 00.708.707l1.801-1.801c.96.637 2.11 1.01 3.346 1.01s2.386-.372 3.346-1.01l1.801 1.801a.498.498 0 00.708 0 .5.5 0 000-.707l-1.718-1.718a6.046 6.046 0 001.927-4.428z"
});

function SvgArchery(props) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$B, _ref2$a);
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C = /*#__PURE__*/createElement("path", {
  d: "M4 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM3 12.625a.376.376 0 01-.375.375h-.25A.376.376 0 012 12.625v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375v.25zM4 10H1V5h3v5zm0-6H1V3h3v1zm6-3H7c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM9 12.625a.376.376 0 01-.375.375h-.25A.376.376 0 018 12.625v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375v.25zM10 10H7V5h3v5zm0-6H7V3h3v1zm6-3h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-1 11.625a.376.376 0 01-.375.375h-.25a.376.376 0 01-.375-.375v-.25c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375v.25zM16 10h-3V5h3v5zm0-6h-3V3h3v1z"
});

function SvgArchive(props) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$C);
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D = /*#__PURE__*/createElement("path", {
  d: "M11.5 16l-4-4L16 3.5 12.5 0 4 8.5l-4-4V16h11.5z"
});

function SvgArrowDownLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$D);
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E = /*#__PURE__*/createElement("path", {
  d: "M13 1.586L5.043 9.543 2 6.5V14h7.5l-3.043-3.043L14.414 3z"
});

function SvgArrowDownLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$E);
}

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F = /*#__PURE__*/createElement("path", {
  d: "M12.293 2.293L4 10.586V7a1 1 0 00-2 0v6a1.002 1.002 0 001 1v.001h6a1 1 0 000-2H5.414l8.293-8.293a.997.997 0 000-1.414.999.999 0 00-1.414 0z"
});

function SvgArrowDownLeft3(props) {
  return /*#__PURE__*/createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$F);
}

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G = /*#__PURE__*/createElement("path", {
  d: "M4.828 8.343L2 5.515V14h8.485l-2.828-2.828 6.01-8.132-.707-.707z"
});

function SvgArrowDownLeft4(props) {
  return /*#__PURE__*/createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$G);
}

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$H = /*#__PURE__*/createElement("path", {
  d: "M7.5 11h7l-3 3H2V4.5l3-3v7L12.5 1 15 3.5z"
});

function SvgArrowDownLeft5(props) {
  return /*#__PURE__*/createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$H);
}

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$I = /*#__PURE__*/createElement("path", {
  d: "M16 4.5l-4 4L3.5 0 0 3.5 8.5 12l-4 4H16V4.5z"
});

function SvgArrowDownRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$I);
}

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$J = /*#__PURE__*/createElement("path", {
  d: "M1.586 3l7.957 7.957L6.5 14H14V6.5l-3.043 3.043L3 1.586z"
});

function SvgArrowDownRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$J);
}

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$K = /*#__PURE__*/createElement("path", {
  d: "M2.293 3.707L10.586 12H7a1 1 0 000 2h6a1.002 1.002 0 001-1h.001V7a1 1 0 00-2 0v3.586L3.708 2.293a.997.997 0 00-1.414 0 .999.999 0 000 1.414z"
});

function SvgArrowDownRight3(props) {
  return /*#__PURE__*/createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$K);
}

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$L = /*#__PURE__*/createElement("path", {
  d: "M8.343 11.172L5.515 14H14V5.515l-2.828 2.828-8.132-6.01-.707.707z"
});

function SvgArrowDownRight4(props) {
  return /*#__PURE__*/createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$L);
}

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$M = /*#__PURE__*/createElement("path", {
  d: "M11 8.5v-7l3 3V14H4.5l-3-3h7L1 3.5 3.5 1z"
});

function SvgArrowDownRight5(props) {
  return /*#__PURE__*/createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$M);
}

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$N = /*#__PURE__*/createElement("path", {
  d: "M16 5.5l-3-3-5 5-5-5-3 3 8 8z"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$N);
}

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$O = /*#__PURE__*/createElement("path", {
  d: "M8 16l8-8h-5V0H5v8H0l8 8zm-.961-2.375l-.25-.25h2.422l-.25.25H7.039zm1.672.25l-.25.25h-.922l-.25-.25h1.422zm-2.172-.75l-.25-.25h3.422l-.25.25H6.539zm-.5-.5l-.25-.25h4.422l-.25.25H6.039zm-.5-.5l-.25-.25h5.422l-.25.25H5.539zm-.5-.5l-.25-.25h6.422l-.25.25H5.039zm-.5-.5l-.25-.25h7.422l-.25.25H4.539zm-.5-.5l-.25-.25h8.422l-.25.25H4.039zm-.5-.5l-.25-.25h9.422l-.25.25H3.539zm-.5-.5l-.25-.25h10.422l-.25.25H3.039zm4.75 4.75h.422L8 14.586l-.211-.211zM10 8.625H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zM10 1v.125H6V1h4zM6 9v-.125h4V9h3.586l-.125.125H2.539L2.414 9H6z"
});

function SvgArrowDown10(props) {
  return /*#__PURE__*/createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$O);
}

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$P = /*#__PURE__*/createElement("path", {
  d: "M7.5 16l6-6h-4L8 0H7L5.5 10h-4z"
});

function SvgArrowDown11(props) {
  return /*#__PURE__*/createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$P);
}

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$Q = /*#__PURE__*/createElement("path", {
  d: "M14 9.5v-4l-5 5V0H6v10.5l-5-5v4L7.5 16z"
});

function SvgArrowDown12(props) {
  return /*#__PURE__*/createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$Q);
}

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$R = /*#__PURE__*/createElement("path", {
  d: "M0 9l8 7 8-7h-5.819L12 0H4l1.82 9H0zm5.18-8h5.639l-1.82 9h4.339l-5.339 4.671L2.66 10h4.339l-1.82-9z"
});

function SvgArrowDown13(props) {
  return /*#__PURE__*/createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$R);
}

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$S = /*#__PURE__*/createElement("path", {
  d: "M8 16l7-16-7 3-7-3z"
});

function SvgArrowDown14(props) {
  return /*#__PURE__*/createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$S);
}

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$T = /*#__PURE__*/createElement("path", {
  d: "M0 4l8 8 8-8-8 4z"
});

function SvgArrowDown15(props) {
  return /*#__PURE__*/createElement("svg", _extends$T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$T);
}

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$U = /*#__PURE__*/createElement("path", {
  d: "M5 0h6v1H5zm0 2h6v1H5zm0 2h6v1H5zm3 12l7-7h-4V6H5v3H1z"
});

function SvgArrowDown16(props) {
  return /*#__PURE__*/createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$U);
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$V = /*#__PURE__*/createElement("path", {
  d: "M16 5.5l-2-2-6 6-6-6-2 2 8 8 8-8z"
});

function SvgArrowDown2(props) {
  return /*#__PURE__*/createElement("svg", _extends$V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$V);
}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$W = /*#__PURE__*/createElement("path", {
  d: "M16 5.5L14.5 4 8 10.5 1.5 4 0 5.5l8 8 8-8z"
});

function SvgArrowDown3(props) {
  return /*#__PURE__*/createElement("svg", _extends$W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$W);
}

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$X = /*#__PURE__*/createElement("path", {
  d: "M16 5.5l-1-1-7 7-7-7-1 1 8 8 8-8z"
});

function SvgArrowDown4(props) {
  return /*#__PURE__*/createElement("svg", _extends$X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$X);
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$Y = /*#__PURE__*/createElement("path", {
  d: "M3.5 6L8 10.5 12.5 6h-9z"
});

function SvgArrowDown5(props) {
  return /*#__PURE__*/createElement("svg", _extends$Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$Y);
}

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Z = /*#__PURE__*/createElement("path", {
  d: "M8 15.5L15.5 8H11V0H5v8H.5z"
});

function SvgArrowDown6(props) {
  return /*#__PURE__*/createElement("svg", _extends$Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$Z);
}

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$_ = /*#__PURE__*/createElement("path", {
  d: "M2.5 10L8 15.5l5.5-5.5H9V1H7v9z"
});

function SvgArrowDown7(props) {
  return /*#__PURE__*/createElement("svg", _extends$_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$_);
}

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$$ = /*#__PURE__*/createElement("path", {
  d: "M13.707 9.707l-5 5a.999.999 0 01-1.414 0l-5-5a.999.999 0 111.414-1.414L7 11.586V2a1 1 0 012 0v9.586l3.293-3.293a.997.997 0 011.414 0 .999.999 0 010 1.414z"
});

function SvgArrowDown8(props) {
  return /*#__PURE__*/createElement("svg", _extends$$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$$);
}

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$10 = /*#__PURE__*/createElement("path", {
  d: "M8 16l8-8h-5V0H5v8H0l8 8zM6 9V1h4v8h3.586L8 14.586 2.414 9H6z"
});

function SvgArrowDown9(props) {
  return /*#__PURE__*/createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$10);
}

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$11 = /*#__PURE__*/createElement("path", {
  d: "M10.5 16l3-3-5-5 5-5-3-3-8 8z"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$11);
}

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$12 = /*#__PURE__*/createElement("path", {
  d: "M0 8l8 8v-5h8V5H8V0L0 8zm2.375-.961l.25-.25v2.422l-.25-.25V7.039zm-.25 1.672l-.25-.25v-.922l.25-.25v1.422zm.75-2.172l.25-.25v3.422l-.25-.25V6.539zm.5-.5l.25-.25v4.422l-.25-.25V6.039zm.5-.5l.25-.25v5.422l-.25-.25V5.539zm.5-.5l.25-.25v6.422l-.25-.25V5.039zm.5-.5l.25-.25v7.422l-.25-.25V4.539zm.5-.5l.25-.25v8.422l-.25-.25V4.039zm.5-.5l.25-.25v9.422l-.25-.25V3.539zm.5-.5l.25-.25v10.422l-.25-.25V3.039zm-4.75 4.75v.422L1.414 8l.211-.211zM7.375 10V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zm.5 0V6h.25v4h-.25zM15 10h-.125V6H15v4zM7 6h.125v4H7v3.586l-.125-.125V2.539L7 2.414V6z"
});

function SvgArrowLeft10(props) {
  return /*#__PURE__*/createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$12);
}

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$13 = /*#__PURE__*/createElement("path", {
  d: "M0 8.5l6-6v4L16 8v1L6 10.5v4z"
});

function SvgArrowLeft11(props) {
  return /*#__PURE__*/createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$13);
}

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$14 = /*#__PURE__*/createElement("path", {
  d: "M6.5 2h4l-5 5H16v3H5.5l5 5h-4L0 8.5z"
});

function SvgArrowLeft12(props) {
  return /*#__PURE__*/createElement("svg", _extends$14({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$14);
}

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$15 = /*#__PURE__*/createElement("path", {
  d: "M7 0L0 8l7 8v-5.82L16 12V4L7 5.82V0zm8 5.18v5.639l-9-1.82v4.339L1.329 8 6 2.661V7l9-1.82z"
});

function SvgArrowLeft13(props) {
  return /*#__PURE__*/createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$15);
}

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$16 = /*#__PURE__*/createElement("path", {
  d: "M0 8l16 7-3-7 3-7z"
});

function SvgArrowLeft14(props) {
  return /*#__PURE__*/createElement("svg", _extends$16({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$16);
}

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$17 = /*#__PURE__*/createElement("path", {
  d: "M12 0L4 8l8 8-4-8z"
});

function SvgArrowLeft15(props) {
  return /*#__PURE__*/createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$17);
}

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$18 = /*#__PURE__*/createElement("path", {
  d: "M15 5h1v6h-1zm-2 0h1v6h-1zm-2 0h1v6h-1zM0 8l7-7v4h3v6H7v4z"
});

function SvgArrowLeft16(props) {
  return /*#__PURE__*/createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$18);
}

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$19 = /*#__PURE__*/createElement("path", {
  d: "M10.5 16l2-2-6-6 6-6-2-2-8 8 8 8z"
});

function SvgArrowLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$19({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$19);
}

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$1a = /*#__PURE__*/createElement("path", {
  d: "M10.5 16l1.5-1.5L5.5 8 12 1.5 10.5 0l-8 8 8 8z"
});

function SvgArrowLeft3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1a);
}

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1b = /*#__PURE__*/createElement("path", {
  d: "M10.5 16l1-1-7-7 7-7-1-1-8 8 8 8z"
});

function SvgArrowLeft4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1b);
}

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1c = /*#__PURE__*/createElement("path", {
  d: "M10 3.5L5.5 8l4.5 4.5v-9z"
});

function SvgArrowLeft5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1c);
}

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1d = /*#__PURE__*/createElement("path", {
  d: "M.5 8L8 15.5V11h8V5H8V.5z"
});

function SvgArrowLeft6(props) {
  return /*#__PURE__*/createElement("svg", _extends$1d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1d);
}

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1e = /*#__PURE__*/createElement("path", {
  d: "M6 2.5L.5 8 6 13.5V9h9V7H6z"
});

function SvgArrowLeft7(props) {
  return /*#__PURE__*/createElement("svg", _extends$1e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1e);
}

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1f = /*#__PURE__*/createElement("path", {
  d: "M6.293 13.707l-5-5a.999.999 0 010-1.414l5-5a.999.999 0 111.414 1.414L4.414 7H14a1 1 0 010 2H4.414l3.293 3.293a.997.997 0 010 1.414.999.999 0 01-1.414 0z"
});

function SvgArrowLeft8(props) {
  return /*#__PURE__*/createElement("svg", _extends$1f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1f);
}

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1g = /*#__PURE__*/createElement("path", {
  d: "M0 8l8 8v-5h8V5H8V0L0 8zm7-2h8v4H7v3.586L1.414 8 7 2.414V6z"
});

function SvgArrowLeft9(props) {
  return /*#__PURE__*/createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1g);
}

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1h = /*#__PURE__*/createElement("path", {
  d: "M15 0H9a1 1 0 000 2h3.586L2 12.586V9a1 1 0 00-2 0v6a1 1 0 001 1h6a1 1 0 000-2H3.414L14 3.414V7a1 1 0 002 0V1a1 1 0 00-1-1z"
});

function SvgArrowResize(props) {
  return /*#__PURE__*/createElement("svg", _extends$1h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1h);
}

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1i = /*#__PURE__*/createElement("path", {
  d: "M0 1v6a1 1 0 002 0V3.414L12.586 14H9a1 1 0 000 2h6a1 1 0 001-1V9a1 1 0 00-2 0v3.586L3.414 2H7a1 1 0 000-2H1a1 1 0 00-1 1z"
});

function SvgArrowResize2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1i);
}

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1j = /*#__PURE__*/createElement("path", {
  d: "M11.293 5.707L12.586 7H3.414l1.293-1.293a.997.997 0 000-1.414 1 1 0 00-1.414 0l-3 3a.999.999 0 000 1.414l3 3a.999.999 0 101.414-1.414L3.414 9h9.172l-1.293 1.293a1 1 0 001.414 1.414l3-3a.997.997 0 000-1.414l-3-3a1 1 0 00-1.414 1.414z"
});

function SvgArrowResize3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1j);
}

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1k = /*#__PURE__*/createElement("path", {
  d: "M10.293 11.293L9 12.586V3.414l1.293 1.293a.997.997 0 001.414 0 1 1 0 000-1.414l-3-3a.999.999 0 00-1.414 0l-3 3a.999.999 0 101.414 1.414L7 3.414v9.172l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a.997.997 0 001.414 0l3-3a1 1 0 00-1.414-1.414z"
});

function SvgArrowResize4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1k);
}

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1l = /*#__PURE__*/createElement("path", {
  d: "M8.5 0l3.043 3.043-8.5 8.5L0 8.5V16h7.5l-3.043-3.043 8.5-8.5L16 7.5V0z"
});

function SvgArrowResize5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1l);
}

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1m = /*#__PURE__*/createElement("path", {
  d: "M0 7.5l3.043-3.043 8.5 8.5L8.5 16H16V8.5l-3.043 3.043-8.5-8.5L7.5 0H0z"
});

function SvgArrowResize6(props) {
  return /*#__PURE__*/createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1m);
}

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1n = /*#__PURE__*/createElement("path", {
  d: "M15.5 8L11 12.5V9H5v3.5L.5 8 5 3.5V7h6V3.5L15.5 8z"
});

function SvgArrowResize7(props) {
  return /*#__PURE__*/createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1n);
}

function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1o = /*#__PURE__*/createElement("path", {
  d: "M8 .5L12.5 5H9v6h3.5L8 15.5 3.5 11H7V5H3.5L8 .5z"
});

function SvgArrowResize8(props) {
  return /*#__PURE__*/createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1o);
}

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1p = /*#__PURE__*/createElement("path", {
  d: "M24 0c13.255 0 24 10.74 24 24S37.255 48 24 48 0 37.26 0 24 10.745 0 24 0zm1.319 14.19a1.501 1.501 0 00-2.121 0 1.508 1.508 0 000 2.13l6.181 6.18H13.5a1.501 1.501 0 000 3h15.879l-6.181 6.18a1.508 1.508 0 000 2.13 1.5 1.5 0 002.12 0l8.485-8.49c.36-.36.472-.855.39-1.32.082-.465-.03-.96-.39-1.32z"
});

function SvgArrowRightFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1p);
}

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1q = /*#__PURE__*/createElement("path", {
  d: "M24 45C12.402 45 3 35.595 3 24S12.402 3 24 3s21 9.405 21 21-9.402 21-21 21zm0-45C10.745 0 0 10.74 0 24s10.745 24 24 24 24-10.74 24-24S37.255 0 24 0zm9.803 22.68l-8.484-8.49a1.501 1.501 0 00-2.121 0 1.508 1.508 0 000 2.13l6.181 6.18H13.5a1.501 1.501 0 000 3h15.879l-6.181 6.18a1.508 1.508 0 000 2.13 1.5 1.5 0 002.12 0l8.485-8.49c.36-.36.472-.855.39-1.32.082-.465-.03-.96-.39-1.32z"
});

function SvgArrowRightOutline(props) {
  return /*#__PURE__*/createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1q);
}

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1r = /*#__PURE__*/createElement("path", {
  d: "M5.5 0l-3 3 5 5-5 5 3 3 8-8z"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$1r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1r);
}

function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1s = /*#__PURE__*/createElement("path", {
  d: "M16 8L8 0v5H0v6h8v5l8-8zm-2.375.961l-.25.25V6.789l.25.25v1.922zm.25-1.672l.25.25v.922l-.25.25V7.289zm-.75 2.172l-.25.25V6.289l.25.25v2.922zm-.5.5l-.25.25V5.789l.25.25v3.922zm-.5.5l-.25.25V5.289l.25.25v4.922zm-.5.5l-.25.25V4.789l.25.25v5.922zm-.5.5l-.25.25V4.289l.25.25v6.922zm-.5.5l-.25.25V3.789l.25.25v7.922zm-.5.5l-.25.25V3.289l.25.25v8.922zm-.5.5l-.25.25V2.789l.25.25v9.922zm4.75-4.75v-.422l.211.211-.211.211zM8.625 6v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zm-.5 0v4h-.25V6h.25zM1 6h.125v4H1V6zm8 4h-.125V6H9V2.414l.125.125v10.922L9 13.586V10z"
});

function SvgArrowRight10(props) {
  return /*#__PURE__*/createElement("svg", _extends$1s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1s);
}

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1t = /*#__PURE__*/createElement("path", {
  d: "M16 8.5l-6-6v4L0 8v1l10 1.5v4z"
});

function SvgArrowRight11(props) {
  return /*#__PURE__*/createElement("svg", _extends$1t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1t);
}

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1u = /*#__PURE__*/createElement("path", {
  d: "M9.5 2h-4l5 5H0v3h10.5l-5 5h4L16 8.5z"
});

function SvgArrowRight12(props) {
  return /*#__PURE__*/createElement("svg", _extends$1u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1u);
}

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1v = /*#__PURE__*/createElement("path", {
  d: "M9 16l7-8-7-8v5.82L0 4v8l9-1.82V16zm-8-5.18V5.181l9 1.82V2.662l4.671 5.339L10 13.34V9.001l-9 1.82z"
});

function SvgArrowRight13(props) {
  return /*#__PURE__*/createElement("svg", _extends$1v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1v);
}

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1w = /*#__PURE__*/createElement("path", {
  d: "M16 8L0 1l3 7-3 7z"
});

function SvgArrowRight14(props) {
  return /*#__PURE__*/createElement("svg", _extends$1w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1w);
}

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1x = /*#__PURE__*/createElement("path", {
  d: "M4 16l8-8-8-8 4 8z"
});

function SvgArrowRight15(props) {
  return /*#__PURE__*/createElement("svg", _extends$1x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1x);
}

function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1y = /*#__PURE__*/createElement("path", {
  d: "M0 5h1v6H0zm2 0h1v6H2zm2 0h1v6H4zm12 3L9 1v4H6v6h3v4z"
});

function SvgArrowRight16(props) {
  return /*#__PURE__*/createElement("svg", _extends$1y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1y);
}

function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var _ref$1z = /*#__PURE__*/createElement("path", {
  d: "M5.5 0l-2 2 6 6-6 6 2 2 8-8-8-8z"
});

function SvgArrowRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1z);
}

function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var _ref$1A = /*#__PURE__*/createElement("path", {
  d: "M5.5 0L4 1.5 10.5 8 4 14.5 5.5 16l8-8-8-8z"
});

function SvgArrowRight3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1A);
}

function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var _ref$1B = /*#__PURE__*/createElement("path", {
  d: "M5.5 0l-1 1 7 7-7 7 1 1 8-8-8-8z"
});

function SvgArrowRight4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1B);
}

function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var _ref$1C = /*#__PURE__*/createElement("path", {
  d: "M6 12.5L10.5 8 6 3.5v9z"
});

function SvgArrowRight5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1C);
}

function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var _ref$1D = /*#__PURE__*/createElement("path", {
  d: "M15.5 8L8 .5V5H0v6h8v4.5z"
});

function SvgArrowRight6(props) {
  return /*#__PURE__*/createElement("svg", _extends$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1D);
}

function _extends$1E() { _extends$1E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var _ref$1E = /*#__PURE__*/createElement("path", {
  d: "M10 13.5L15.5 8 10 2.5V7H1v2h9z"
});

function SvgArrowRight7(props) {
  return /*#__PURE__*/createElement("svg", _extends$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1E);
}

function _extends$1F() { _extends$1F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var _ref$1F = /*#__PURE__*/createElement("path", {
  d: "M9.707 13.707l5-5a.999.999 0 000-1.414l-5-5a.999.999 0 10-1.414 1.414L11.586 7H2a1 1 0 000 2h9.586l-3.293 3.293a.997.997 0 000 1.414.999.999 0 001.414 0z"
});

function SvgArrowRight8(props) {
  return /*#__PURE__*/createElement("svg", _extends$1F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1F);
}

function _extends$1G() { _extends$1G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var _ref$1G = /*#__PURE__*/createElement("path", {
  d: "M16 8L8 0v5H0v6h8v5l8-8zm-7 2H1V6h8V2.414L14.586 8 9 13.586V10z"
});

function SvgArrowRight9(props) {
  return /*#__PURE__*/createElement("svg", _extends$1G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1G);
}

function _extends$1H() { _extends$1H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var _ref$1H = /*#__PURE__*/createElement("path", {
  d: "M0 11.5l4-4 8.5 8.5 3.5-3.5L7.5 4l4-4H0v11.5z"
});

function SvgArrowUpLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$1H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1H);
}

function _extends$1I() { _extends$1I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var _ref$1I = /*#__PURE__*/createElement("path", {
  d: "M14.414 13L6.457 5.043 9.5 2H2v7.5l3.043-3.043L13 14.414z"
});

function SvgArrowUpLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1I);
}

function _extends$1J() { _extends$1J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var _ref$1J = /*#__PURE__*/createElement("path", {
  d: "M13.707 12.293L5.414 4H9a1 1 0 000-2H3a1.002 1.002 0 00-1 1h-.001v6a1 1 0 002 0V5.414l8.293 8.293a.997.997 0 001.414 0 .999.999 0 000-1.414z"
});

function SvgArrowUpLeft3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1J);
}

function _extends$1K() { _extends$1K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var _ref$1K = /*#__PURE__*/createElement("path", {
  d: "M7.657 4.828L10.485 2H2v8.485l2.828-2.828 8.132 6.01.707-.707z"
});

function SvgArrowUpLeft4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1K);
}

function _extends$1L() { _extends$1L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var _ref$1L = /*#__PURE__*/createElement("path", {
  d: "M7.5 5h7l-3-3H2v9.5l3 3v-7l7.5 7.5 2.5-2.5z"
});

function SvgArrowUpLeft5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1L);
}

function _extends$1M() { _extends$1M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var _ref$1M = /*#__PURE__*/createElement("path", {
  d: "M4.5 0l4 4L0 12.5 3.5 16 12 7.5l4 4V0H4.5z"
});

function SvgArrowUpRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$1M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1M);
}

function _extends$1N() { _extends$1N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var _ref$1N = /*#__PURE__*/createElement("path", {
  d: "M3 14.414l7.957-7.957L14 9.5V2H6.5l3.043 3.043L1.586 13z"
});

function SvgArrowUpRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1N);
}

function _extends$1O() { _extends$1O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var _ref$1O = /*#__PURE__*/createElement("path", {
  d: "M3.707 13.707L12 5.414V9a1 1 0 002 0V3a1.002 1.002 0 00-1-1v-.001H7a1 1 0 000 2h3.586l-8.293 8.293a.997.997 0 000 1.414.999.999 0 001.414 0z"
});

function SvgArrowUpRight3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1O);
}

function _extends$1P() { _extends$1P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var _ref$1P = /*#__PURE__*/createElement("path", {
  d: "M11.172 7.657L14 10.485V2H5.515l2.828 2.828-6.01 8.132.707.707z"
});

function SvgArrowUpRight4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1P);
}

function _extends$1Q() { _extends$1Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var _ref$1Q = /*#__PURE__*/createElement("path", {
  d: "M8.5 5h-7l3-3H14v9.5l-3 3v-7L3.5 15 1 12.5z"
});

function SvgArrowUpRight5(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1Q);
}

function _extends$1R() { _extends$1R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var _ref$1R = /*#__PURE__*/createElement("path", {
  d: "M0 10.5l3 3 5-5 5 5 3-3-8-8z"
});

function SvgArrowUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$1R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1R);
}

function _extends$1S() { _extends$1S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var _ref$1S = /*#__PURE__*/createElement("path", {
  d: "M8 0L0 8h5v8h6V8h5L8 0zm.961 2.375l.25.25H6.789l.25-.25h1.922zm-1.672-.25l.25-.25h.922l.25.25H7.289zm2.172.75l.25.25H6.289l.25-.25h2.922zm.5.5l.25.25H5.789l.25-.25h3.922zm.5.5l.25.25H5.289l.25-.25h4.922zm.5.5l.25.25H4.789l.25-.25h5.922zm.5.5l.25.25H4.289l.25-.25h6.922zm.5.5l.25.25H3.789l.25-.25h7.922zm.5.5l.25.25H3.289l.25-.25h8.922zm.5.5l.25.25H2.789l.25-.25h9.922zm-4.75-4.75h-.422L8 1.414l.211.211zM6 7.375h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zm0 .5h4v.25H6v-.25zM6 15v-.125h4V15H6zm4-8v.125H6V7H2.414l.125-.125h10.922l.125.125H10z"
});

function SvgArrowUp10(props) {
  return /*#__PURE__*/createElement("svg", _extends$1S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1S);
}

function _extends$1T() { _extends$1T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var _ref$1T = /*#__PURE__*/createElement("path", {
  d: "M7.5 0l-6 6h4L7 16h1L9.5 6h4z"
});

function SvgArrowUp11(props) {
  return /*#__PURE__*/createElement("svg", _extends$1T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1T);
}

function _extends$1U() { _extends$1U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var _ref$1U = /*#__PURE__*/createElement("path", {
  d: "M1 6.5v4l5-5V16h3V5.5l5 5v-4L7.5 0z"
});

function SvgArrowUp12(props) {
  return /*#__PURE__*/createElement("svg", _extends$1U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1U);
}

function _extends$1V() { _extends$1V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var _ref$1V = /*#__PURE__*/createElement("path", {
  d: "M16 7L8 0 0 7h5.82L4 16h8l-1.82-9H16zm-5.18 8H5.181l1.82-9H2.662l5.339-4.671L13.34 6H9.001l1.82 9z"
});

function SvgArrowUp13(props) {
  return /*#__PURE__*/createElement("svg", _extends$1V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1V);
}

function _extends$1W() { _extends$1W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var _ref$1W = /*#__PURE__*/createElement("path", {
  d: "M8 0L1 16l7-3 7 3z"
});

function SvgArrowUp14(props) {
  return /*#__PURE__*/createElement("svg", _extends$1W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1W);
}

function _extends$1X() { _extends$1X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var _ref$1X = /*#__PURE__*/createElement("path", {
  d: "M16 12L8 4l-8 8 8-4z"
});

function SvgArrowUp15(props) {
  return /*#__PURE__*/createElement("svg", _extends$1X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1X);
}

function _extends$1Y() { _extends$1Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var _ref$1Y = /*#__PURE__*/createElement("path", {
  d: "M5 15h6v1H5zm0-2h6v1H5zm0-2h6v1H5zM8 0l7 7h-4v3H5V7H1z"
});

function SvgArrowUp16(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1Y);
}

function _extends$1Z() { _extends$1Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var _ref$1Z = /*#__PURE__*/createElement("path", {
  d: "M0 10.5l2 2 6-6 6 6 2-2-8-8-8 8z"
});

function SvgArrowUp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1Z);
}

function _extends$1_() { _extends$1_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var _ref$1_ = /*#__PURE__*/createElement("path", {
  d: "M0 10.5L1.5 12 8 5.5l6.5 6.5 1.5-1.5-8-8-8 8z"
});

function SvgArrowUp3(props) {
  return /*#__PURE__*/createElement("svg", _extends$1_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1_);
}

function _extends$1$() { _extends$1$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var _ref$1$ = /*#__PURE__*/createElement("path", {
  d: "M0 10.5l1 1 7-7 7 7 1-1-8-8-8 8z"
});

function SvgArrowUp4(props) {
  return /*#__PURE__*/createElement("svg", _extends$1$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$1$);
}

function _extends$20() { _extends$20 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var _ref$20 = /*#__PURE__*/createElement("path", {
  d: "M12.5 10L8 5.5 3.5 10h9z"
});

function SvgArrowUp5(props) {
  return /*#__PURE__*/createElement("svg", _extends$20({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$20);
}

function _extends$21() { _extends$21 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var _ref$21 = /*#__PURE__*/createElement("path", {
  d: "M8 .5L.5 8H5v8h6V8h4.5z"
});

function SvgArrowUp6(props) {
  return /*#__PURE__*/createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$21);
}

function _extends$22() { _extends$22 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var _ref$22 = /*#__PURE__*/createElement("path", {
  d: "M13.5 6L8 .5 2.5 6H7v9h2V6z"
});

function SvgArrowUp7(props) {
  return /*#__PURE__*/createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$22);
}

function _extends$23() { _extends$23 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var _ref$23 = /*#__PURE__*/createElement("path", {
  d: "M13.707 6.293l-5-5a.999.999 0 00-1.414 0l-5 5a.999.999 0 101.414 1.414L7 4.414V14a1 1 0 002 0V4.414l3.293 3.293a.997.997 0 001.414 0 .999.999 0 000-1.414z"
});

function SvgArrowUp8(props) {
  return /*#__PURE__*/createElement("svg", _extends$23({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$23);
}

function _extends$24() { _extends$24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var _ref$24 = /*#__PURE__*/createElement("path", {
  d: "M8 0L0 8h5v8h6V8h5L8 0zm2 7v8H6V7H2.414L8 1.414 13.586 7H10z"
});

function SvgArrowUp9(props) {
  return /*#__PURE__*/createElement("svg", _extends$24({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$24);
}

function _extends$25() { _extends$25 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var _ref$25 = /*#__PURE__*/createElement("path", {
  d: "M13.657 2.343C12.146.832 10.137 0 8 0S3.854.832 2.343 2.343C.832 3.854 0 5.863 0 8s.832 4.146 2.343 5.657A7.948 7.948 0 008 16a7.932 7.932 0 003.429-.77 1 1 0 10-.858-1.806A6.007 6.007 0 012 8.001c0-3.308 2.692-6 6-6s6 2.692 6 6v1c0 .551-.449 1-1 1s-1-.449-1-1v-4a1 1 0 00-1.912-.41A3.972 3.972 0 008 4.001c-2.206 0-4 1.794-4 4s1.794 4 4 4a3.987 3.987 0 002.712-1.062A2.995 2.995 0 0013 12.001c1.654 0 3-1.346 3-3v-1a7.948 7.948 0 00-2.343-5.657zM8 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
});

function SvgAtSign(props) {
  return /*#__PURE__*/createElement("svg", _extends$25({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$25);
}

function _extends$26() { _extends$26 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var _ref$26 = /*#__PURE__*/createElement("path", {
  d: "M12.999 3.23zM13.032 8c1.631-1.56 2.423-3.087 1.896-4-.301-.521-.99-.77-1.929-.77v.75c.659 0 1.137.148 1.28.395.113.195.05.496-.023.713-.139.417-.442.917-.876 1.444-.263.32-.567.643-.904.963a17.81 17.81 0 00-1.544-1.188 18.181 18.181 0 00-.257-1.93c.878-.26 1.675-.397 2.323-.397v-.75c-.706 0-1.553.141-2.482.413C9.981 1.451 9.054.001 8 .001s-1.981 1.45-2.516 3.642c-.929-.271-1.777-.412-2.482-.412-.939 0-1.629.249-1.93.77-.527.913.265 2.44 1.896 4-1.631 1.56-2.423 3.087-1.896 4 .301.521.99.77 1.93.77.706 0 1.553-.141 2.482-.412.535 2.192 1.462 3.642 2.516 3.642s1.981-1.45 2.516-3.642c.929.271 1.777.412 2.482.412.939 0 1.629-.249 1.93-.77.527-.913-.265-2.44-1.896-4zm-1.117 0c-.291.248-.601.493-.927.734a22.214 22.214 0 000-1.468c.327.241.637.486.927.734zm-1.957 3.389c-.36-.128-.728-.274-1.098-.435a21.617 21.617 0 001.27-.733c-.045.403-.103.793-.172 1.169zm-.833-1.44c-.372.214-.748.416-1.125.603a20.765 20.765 0 01-2.211-1.275 20.545 20.545 0 010-2.552A20.568 20.568 0 018 5.45a20.765 20.765 0 012.211 1.275 20.545 20.545 0 010 2.552c-.349.231-.711.456-1.086.672zm-3.255.271a20.984 20.984 0 001.27.733c-.37.162-.738.307-1.098.435a16.788 16.788 0 01-.172-1.168zm-.857-1.486A16.378 16.378 0 014.086 8c.291-.248.601-.494.927-.734a22.214 22.214 0 000 1.468zm1.029-4.122c.36.128.728.274 1.098.435a21.617 21.617 0 00-1.27.733 16.7 16.7 0 01.172-1.168zm3.458.79a21.617 21.617 0 00-.64-.355c.37-.162.738-.307 1.098-.435.069.375.127.766.172 1.168a20.984 20.984 0 00-.63-.378zM6.581 2.607c.24-.639.521-1.151.813-1.48.152-.172.381-.376.607-.376s.454.205.607.376c.292.329.573.841.813 1.48.146.388.273.812.382 1.265-.58.202-1.185.45-1.801.743a18.213 18.213 0 00-1.801-.743c.109-.453.237-.877.382-1.265zM2.62 6.532c-.434-.527-.736-1.026-.876-1.444-.073-.218-.135-.518-.023-.713.143-.247.621-.395 1.28-.395.648 0 1.445.137 2.323.397a18.181 18.181 0 00-.257 1.93c-.561.387-1.079.787-1.544 1.188a10.77 10.77 0 01-.904-.963zm.382 5.488c-.659 0-1.137-.148-1.28-.395-.113-.195-.05-.496.023-.713.139-.417.442-.917.876-1.444.263-.32.567-.643.904-.963.465.402.982.801 1.544 1.188.055.679.142 1.327.257 1.93-.878.26-1.675.397-2.323.397zm6.417 1.373c-.24.639-.521 1.151-.813 1.48-.152.172-.381.376-.607.376s-.454-.205-.607-.376c-.292-.329-.573-.841-.813-1.48a10.738 10.738 0 01-.382-1.265c.58-.202 1.185-.45 1.801-.743.616.292 1.221.541 1.801.743-.109.453-.236.877-.382 1.265zm4.837-2.481c.073.218.135.518.023.713-.143.248-.622.395-1.28.395-.648 0-1.445-.137-2.323-.397.115-.603.202-1.251.257-1.93a18.168 18.168 0 001.544-1.188c.338.321.641.643.904.963.434.527.736 1.026.876 1.444z"
});

function SvgAtom(props) {
  return /*#__PURE__*/createElement("svg", _extends$26({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$26);
}

function _extends$27() { _extends$27 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var _ref$27 = /*#__PURE__*/createElement("path", {
  d: "M12.999 3.23zM13.032 8c1.631-1.56 2.423-3.087 1.896-4-.301-.521-.99-.77-1.929-.77v.75c.659 0 1.137.148 1.28.395.113.195.05.496-.023.713-.139.417-.442.917-.876 1.444-.263.32-.567.643-.904.963a17.81 17.81 0 00-1.544-1.188 18.181 18.181 0 00-.257-1.93c.878-.26 1.675-.397 2.323-.397v-.75c-.706 0-1.553.141-2.482.413C9.981 1.451 9.054.001 8 .001s-1.981 1.45-2.516 3.642c-.929-.271-1.777-.412-2.482-.412-.939 0-1.629.249-1.93.77-.527.913.265 2.44 1.896 4-1.631 1.559-2.423 3.087-1.896 4 .301.521.99.77 1.93.77.706 0 1.553-.141 2.482-.412.535 2.192 1.462 3.642 2.516 3.642s1.981-1.45 2.516-3.642c.929.271 1.777.412 2.482.412.939 0 1.629-.249 1.93-.77.527-.913-.265-2.441-1.896-4zm-1.117 0c-.291.248-.601.493-.927.734a22.214 22.214 0 000-1.468c.327.241.637.486.927.734zm-1.957 3.389c-.36-.128-.728-.274-1.098-.435a21.617 21.617 0 001.27-.733c-.045.403-.103.793-.172 1.169zm-.833-1.44c-.372.214-.748.416-1.125.603a20.765 20.765 0 01-2.211-1.275 20.553 20.553 0 010-2.553A20.568 20.568 0 018 5.449a20.765 20.765 0 012.211 1.275 20.545 20.545 0 010 2.553c-.349.231-.711.456-1.086.672zm-3.255.271a20.984 20.984 0 001.27.733c-.37.162-.738.307-1.098.435a16.788 16.788 0 01-.172-1.168zm-.857-1.486A16.378 16.378 0 014.086 8c.291-.248.601-.494.927-.734a22.214 22.214 0 000 1.468zm1.029-4.122c.36.128.728.274 1.098.435a21.617 21.617 0 00-1.27.733 16.7 16.7 0 01.172-1.168zm3.458.79a21.617 21.617 0 00-.64-.355c.37-.162.738-.307 1.098-.435.069.375.127.766.172 1.168a20.984 20.984 0 00-.63-.378zM6.581 2.607c.24-.639.521-1.151.813-1.48.152-.172.381-.376.607-.376s.454.205.607.376c.292.329.573.841.813 1.48.146.388.273.812.382 1.265-.58.202-1.185.45-1.801.743a18.213 18.213 0 00-1.801-.743c.109-.453.237-.877.382-1.265zM2.62 6.532c-.434-.527-.736-1.026-.876-1.444-.073-.218-.135-.518-.023-.713.143-.247.621-.395 1.28-.395.648 0 1.445.137 2.323.397a18.181 18.181 0 00-.257 1.93c-.561.387-1.079.787-1.544 1.188a10.77 10.77 0 01-.904-.963zm.382 5.488c-.659 0-1.137-.148-1.28-.395-.113-.195-.05-.496.023-.713.139-.417.442-.917.876-1.444.263-.32.567-.643.904-.963.465.402.982.801 1.544 1.188.055.679.142 1.327.257 1.93-.878.26-1.675.397-2.323.397zm6.417 1.373c-.24.639-.521 1.151-.813 1.48-.152.172-.381.376-.607.376s-.454-.205-.607-.376c-.292-.329-.573-.841-.813-1.48a10.738 10.738 0 01-.382-1.265c.58-.202 1.185-.45 1.801-.743.616.292 1.221.541 1.801.743-.109.453-.236.877-.382 1.265zm4.837-2.481c.073.218.135.518.023.713-.143.248-.622.395-1.28.395-.648 0-1.445-.137-2.323-.397.115-.603.202-1.251.257-1.93a18.168 18.168 0 001.544-1.188c.338.321.641.643.904.963.434.527.736 1.027.876 1.444zM6.75 8a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z"
});

function SvgAtom2(props) {
  return /*#__PURE__*/createElement("svg", _extends$27({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$27);
}

function _extends$28() { _extends$28 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var _ref$28 = /*#__PURE__*/createElement("path", {
  d: "M10.404 5.11L9.389 4.096 4.314 9.17a2.152 2.152 0 103.045 3.044l6.09-6.089a3.588 3.588 0 00-5.075-5.074L1.98 7.444l-.014.013c-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0l.013-.014.001.001 4.365-4.364-1.015-1.014-4.365 4.363-.013.013c-1.392 1.392-3.656 1.392-5.048 0a3.572 3.572 0 01.014-5.06l-.001-.001L9.39 2.065c.839-.84 2.205-.84 3.045 0s.839 2.205 0 3.044l-6.09 6.089a.718.718 0 01-1.015-1.014l5.075-5.075z"
});

function SvgAttachment(props) {
  return /*#__PURE__*/createElement("svg", _extends$28({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$28);
}

function _extends$29() { _extends$29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var _ref$29 = /*#__PURE__*/createElement("path", {
  d: "M13 4H4a4 4 0 000 8h9v-1H4a3 3 0 110-6h9a2 2 0 110 4H6a1 1 0 010-2h7V6H6a2 2 0 100 4h7a3 3 0 100-6z"
});

function SvgAttachment2(props) {
  return /*#__PURE__*/createElement("svg", _extends$29({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$29);
}

function _extends$2a() { _extends$2a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var _ref$2a = /*#__PURE__*/createElement("path", {
  d: "M6.25 4H15v9H6.25c-.147 0-.469-.133-.573-.237L1.414 8.5l4.263-4.263C5.781 4.133 6.103 4 6.25 4zm0-1c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l4.439 4.439c.292.292.868.53 1.28.53h9c.412 0 .75-.338.75-.75v-9.5a.752.752 0 00-.75-.75h-9z"
});

var _ref2$b = /*#__PURE__*/createElement("path", {
  d: "M14 6.5L12.5 5l-2 2-2-2L7 6.5l2 2-2 2L8.5 12l2-2 2 2 1.5-1.5-2-2z"
});

function SvgBackspace(props) {
  return /*#__PURE__*/createElement("svg", _extends$2a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2a, _ref2$b);
}

function _extends$2b() { _extends$2b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var _ref$2b = /*#__PURE__*/createElement("path", {
  d: "M15.25 3h-9c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l4.439 4.439c.292.292.868.53 1.28.53h9c.412 0 .75-.338.75-.75v-9.5a.752.752 0 00-.75-.75zM14 10.5L12.5 12l-2-2-2 2L7 10.5l2-2-2-2L8.5 5l2 2 2-2L14 6.5l-2 2 2 2z"
});

function SvgBackspace2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2b);
}

function _extends$2c() { _extends$2c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var _ref$2c = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm3 9L7.5 8 11 5.5zm-4 0L3.5 8 7 5.5z"
});

function SvgBackward(props) {
  return /*#__PURE__*/createElement("svg", _extends$2c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2c);
}

function _extends$2d() { _extends$2d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var _ref$2d = /*#__PURE__*/createElement("path", {
  d: "M9 2.5v5l5-5v11l-5-5v5L3.5 8z"
});

function SvgBackward2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2d);
}

function _extends$2e() { _extends$2e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var _ref$2e = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$c = /*#__PURE__*/createElement("path", {
  d: "M6 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

var _ref3$1 = /*#__PURE__*/createElement("path", {
  d: "M5.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 015.5 5zm0-1C4.122 4 3 5.122 3 6.5S4.122 9 5.5 9 8 7.878 8 6.5 6.878 4 5.5 4zM11 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

var _ref4 = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0110.5 5zm0-1C9.121 4 8 5.122 8 6.5S9.121 9 10.5 9 13 7.878 13 6.5 11.879 4 10.5 4zM6 11h4v1H6v-1z"
});

function SvgBaffled(props) {
  return /*#__PURE__*/createElement("svg", _extends$2e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2e, _ref2$c, _ref3$1, _ref4);
}

function _extends$2f() { _extends$2f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var _ref$2f = /*#__PURE__*/createElement("path", {
  d: "M6 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM11 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

var _ref2$d = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4 6.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 6.5zm6 5.5H6v-1h4v1zm.5-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0110.5 8z"
});

function SvgBaffled2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2f, _ref2$d);
}

function _extends$2g() { _extends$2g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var _ref$2g = /*#__PURE__*/createElement("path", {
  d: "M11 3v-.5a2.5 2.5 0 00-4-2 2.5 2.5 0 00-4 2v1.7l-2 .3V15h2l1 1 10-1.5V4l-3-1zM3 14H2V5.361l1-.15V14zM8.5 1c.827 0 1.5.673 1.5 1.5v.65l-2 .3V2.5c0-.454-.122-.88-.333-1.247.239-.16.525-.253.833-.253zM4 2.5a1.502 1.502 0 012.333-1.247A2.483 2.483 0 006 2.5v1.25l-2 .3V2.5zm9 11.139l-8 1.2V6.361l8-1.2v8.478z"
});

function SvgBag(props) {
  return /*#__PURE__*/createElement("svg", _extends$2g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2g);
}

function _extends$2h() { _extends$2h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var _ref$2h = /*#__PURE__*/createElement("path", {
  d: "M11 3v-.5a2.5 2.5 0 00-4-2 2.5 2.5 0 00-4 2v1.7l-2 .3V15h2l1 1 10-1.5V4l-3-1zM2 13.125v-.25h1v.25H2zm1 .25v.25H2v-.25h1zm-1-.75v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zm0-.5v-.25h1v.25H2zM2 14v-.125h1V14H2zm9.875-8.67l.25-.037v8.478l-.25.037V5.33zm-.25 8.515l-.25.037V5.404l.25-.037v8.478zm.75-8.59l.25-.037v8.478l-.25.037V5.255zm-1.25.187v8.478l-.25.037V5.479l.25-.037zm-3.25.488l.25-.037v8.478l-.25.037V5.93zm-.25 8.515l-.25.037V6.004l.25-.037v8.478zm.75-8.59l.25-.037v8.478l-.25.037V5.855zm.5-.075l.25-.037v8.478l-.25.037V5.78zm.5-.075l.25-.037v8.478l-.25.037V5.705zm.5-.075l.25-.037v8.478l-.25.037V5.63zm.5-.075l.25-.037v8.478l-.25.037V5.555zM8.5 1c.827 0 1.5.673 1.5 1.5v.65l-2 .3V2.5c0-.454-.122-.88-.333-1.247.239-.16.525-.253.833-.253zM7.125 6.042v8.478l-.25.037V6.079l.25-.037zm-1.5.225v8.478l-.25.037V6.304l.25-.037zm.25-.037l.25-.037v8.478l-.25.037V6.23zm.5-.075l.25-.037v8.478l-.25.037V6.155zM4 2.5a1.502 1.502 0 012.333-1.247A2.483 2.483 0 006 2.5v1.25l-2 .3V2.5zm1 3.861l.125-.019v8.478L5 14.839V6.361zm8 7.278l-.125.019V5.18L13 5.161v8.478z"
});

function SvgBag2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2h);
}

function _extends$2i() { _extends$2i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var _ref$2i = /*#__PURE__*/createElement("path", {
  d: "M6 7.5V7H0v.5A1.5 1.5 0 001.5 9h3A1.5 1.5 0 006 7.5zM10 7.5A1.5 1.5 0 0011.5 9h3A1.5 1.5 0 0016 7.5V7h-6v.5z"
});

var _ref2$e = /*#__PURE__*/createElement("path", {
  d: "M9 2h3.15l-2.087 3.757a.5.5 0 00.874.486L13 2.53l2.063 3.713a.5.5 0 00.874-.486l-2.5-4.5A.498.498 0 0013 1H9a1 1 0 00-2 0H3a.498.498 0 00-.437.257l-2.5 4.5a.5.5 0 00.874.486L3 2.53l2.063 3.713a.5.5 0 00.874-.486L3.85 2H7v12l-3 1v1h8v-1l-3-1V2z"
});

function SvgBalance(props) {
  return /*#__PURE__*/createElement("svg", _extends$2i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2i, _ref2$e);
}

function _extends$2j() { _extends$2j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var _ref$2j = /*#__PURE__*/createElement("path", {
  d: "M14 7c0-3.866-2.686-7-6-7S2 3.134 2 7c0 3.478 2.174 6.363 5.023 6.907L6.5 16h3l-.523-2.093C11.826 13.363 14 10.478 14 7zM4.417 8h-1.5a6.842 6.842 0 01.229-3h1.5a6.701 6.701 0 00-.302 2c0 .341.025.675.074 1z"
});

function SvgBalloon(props) {
  return /*#__PURE__*/createElement("svg", _extends$2j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2j);
}

function _extends$2k() { _extends$2k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var _ref$2k = /*#__PURE__*/createElement("path", {
  d: "M0 3h2v10H0zm3 0h1v10H3zm2 0h1v10H5zm3 0h1v10H8zm4 0h1v10h-1zm3 0h1v10h-1zm-5 0h.5v10H10zM7 3h.5v10H7zm6.5 0h.5v10h-.5z"
});

function SvgBarcode(props) {
  return /*#__PURE__*/createElement("svg", _extends$2k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2k);
}

function _extends$2l() { _extends$2l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var _ref$2l = /*#__PURE__*/createElement("path", {
  d: "M0 2h2v10H0zm3 0h1v10H3zm2 0h1v10H5zm3 0h1v10H8zm4 0h1v10h-1zm3 0h1v10h-1zm-5 0h.5v10H10zM7 2h.5v10H7zm6.5 0h.5v10h-.5zM0 13h1v1H0zm3 0h1v1H3zm2 0h1v1H5zm5 0h1v1h-1zm5 0h1v1h-1zm-3 0h2v1h-2zm-5 0h2v1H7z"
});

function SvgBarcode2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2l);
}

function _extends$2m() { _extends$2m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var _ref$2m = /*#__PURE__*/createElement("path", {
  d: "M12.012 13.737l-.004-.004-.011-.012-.003-.004-.007-.008-.001-.001-.003-.003-.001-.001-.003-.003-.004-.004-.001-.001-.003-.003-.001-.001-.003-.003-.001-.001-.004-.004-.003-.004-.001-.001-.003-.003-.001-.001-.003-.003-.001-.001-.003-.004-.001-.001-.002-.003-.001-.002a.002.002 0 00-.002-.002l-.001-.002-.002-.003-.001-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.004-.001-.001-.002-.002-.001-.001-.002-.002-.001-.001-.007-.008-.001-.001-.002-.003-.001-.001-.002-.003-.006-.006-.003-.003-.001-.001-.003-.003-.008-.01-.003-.003v-.001a3.834 3.834 0 01-.111-.13l.208-.175a7.351 7.351 0 01-.538-.737l-.253.17a7.475 7.475 0 01-.154-.239l-.002-.003v-.001l-.009-.014-.001-.001-.002-.003-.001-.001-.004-.006-.002-.003-.001-.002-.001-.002-.001-.002-.001-.002-.002-.002-.002-.003-.001-.002-.001-.002-.001-.002-.001-.002-.002-.003-.001-.001-.003-.004-.001-.002-.002-.003-.001-.001-.002-.003-.001-.001-.003-.005-.003-.004-.001-.001-.002-.004-.001-.001-.003-.005-.003-.005-.003-.004v-.001l-.008-.014-.003-.005-.008-.014a7.47 7.47 0 01-.318-.6l.294-.139a7.396 7.396 0 01-.293-.751l-.308.107a7.275 7.275 0 01-.177-.589l-.004-.017-.004-.017-.004-.017-.004-.017-.001-.005-.003-.011-.001-.005-.003-.011-.001-.005-.004-.017-.004-.017-.004-.017-.004-.017-.004-.017a7.53 7.53 0 01-.063-.306l.333-.061a7.476 7.476 0 01-.094-.769l-.269.02V7.95l.269.02c.018-.26.05-.517.094-.769l-.333-.061a7.53 7.53 0 01.063-.306l.004-.017.004-.017.004-.017.004-.017.004-.017.001-.005.003-.011.001-.005.003-.011.001-.005.004-.017.004-.017.004-.017.004-.017c.051-.2.11-.396.177-.589l.308.107c.084-.257.182-.507.293-.751l-.294-.139c.097-.205.203-.406.318-.6l.008-.014.003-.005.008-.014v-.001l.003-.004.003-.005.003-.005.001-.001.002-.004.001-.001.003-.004.003-.004.001-.001.002-.003.001-.001.002-.003.001-.001.003-.004.001-.001.002-.003.001-.002.001-.002.001-.002.001-.002.002-.003.002-.003.001-.002.001-.002.001-.002.001-.002.002-.003.004-.006.001-.001.002-.003.001-.001.009-.014v-.001l.002-.003c.05-.081.102-.16.154-.239l.253.17c.165-.257.345-.503.538-.737l-.208-.175.1-.117a.127.127 0 00.011-.013l.003-.003.008-.01.003-.003.001-.001.003-.003.006-.006.002-.003.001-.001.002-.003.001-.001.007-.008.001-.001.002-.002.001-.001.002-.002.001-.001.003-.004.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.003-.003.001-.001.002-.003.001-.002.002-.002.001-.002.002-.003.001-.001.003-.004.001-.001.003-.003.001-.001.003-.003.001-.001.003-.004.004-.004.001-.001.003-.003.001-.001.003-.003.001-.001.004-.004.003-.003.001-.001.003-.003.001-.001.007-.008.003-.004.011-.012.004-.004c.134-.144.273-.282.418-.415C11.112 1.71 9.387 1.013 7.5 1.013s-3.612.697-4.93 1.848c.145.133.284.271.418.415l.004.004.011.012.003.004.007.008.001.001.003.003.001.001.003.003.004.004.001.001.003.003.001.001.003.003.001.001.003.004.003.004.001.001.003.003.001.001.003.003.001.001.003.004.001.001.002.003.001.002.002.002.001.002.002.003.001.001.003.003.002.002.002.002.002.002.002.002.002.002.002.002.003.004.001.001.002.002.001.001.002.002.001.001.007.008.001.001.002.003.001.001.002.003.006.006.003.003.001.001.003.003.008.01.003.003a3.834 3.834 0 01.111.13l-.208.175c.194.234.374.48.538.737l.253-.17c.053.079.104.158.154.239l.002.003v.001l.009.014.001.001.002.003.001.001.004.006.002.003.001.002.002.002.001.002.001.002.002.003.002.003.001.002.001.002.001.002.001.002.002.003.001.001.003.004.001.001.002.003.001.001.002.003.001.001.003.004.003.004.001.001.002.004.001.001.003.005.003.005.003.004v.001l.008.014.003.005.009.014c.115.195.221.395.318.6l-.294.139c.111.244.208.494.293.751l.308-.107c.067.193.126.389.177.589l.004.017.004.017.004.017.004.017.001.005.003.011.001.005.003.011.001.005.004.017.004.017.004.017.004.017.004.017c.023.101.044.203.063.306l-.333.061c.044.252.076.509.094.769l.269-.02v1.111l-.269-.02c-.018.26-.05.517-.094.769l.333.061a7.53 7.53 0 01-.063.306l-.004.017-.004.017-.004.017-.004.017-.004.017-.001.005-.003.011-.001.005-.003.011-.001.005-.004.017-.004.017-.004.017-.004.017c-.051.2-.11.396-.177.589l-.308-.107a7.255 7.255 0 01-.293.751l.294.139a7.145 7.145 0 01-.318.6l-.009.014-.003.005-.008.014v.001l-.003.004-.003.005-.003.005-.001.001-.002.004-.001.001-.003.004-.003.005-.001.001-.002.003-.001.001-.002.003-.001.002-.003.004-.001.001-.002.003-.001.002-.001.002-.001.002-.001.002-.002.003-.002.002-.001.002-.001.002-.002.002-.001.002-.002.003-.004.006-.001.001-.002.003-.001.001-.009.014v.001l-.002.003a8.15 8.15 0 01-.154.239l-.253-.17a7.679 7.679 0 01-.538.737l.208.175-.1.117a.127.127 0 00-.011.013v.001l-.003.003-.008.01-.003.003-.001.001-.003.003-.006.006-.002.003-.001.001-.002.003-.001.001-.007.008-.001.001-.002.002-.001.001-.002.002-.001.001-.003.004-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.003.003-.001.001-.002.003-.001.002a.002.002 0 01-.002.002l-.001.002-.002.003-.001.001-.003.004-.001.001-.003.003-.001.001-.003.003-.001.001-.003.004-.003.004-.001.001-.003.003-.001.001-.003.003-.001.001-.004.004-.003.003-.001.001-.003.003-.001.001-.007.008-.003.004-.011.012-.004.004a7.437 7.437 0 01-.418.415C3.888 15.303 5.613 16 7.5 16s3.612-.697 4.93-1.848a7.437 7.437 0 01-.418-.415zm-8.859-1.473l-.266-.179c.178-.264.337-.543.472-.83l.271.128a7.207 7.207 0 00.272-.7l-.283-.098c.104-.3.186-.61.243-.923l.282.052c.041-.236.07-.475.087-.716l-.281-.021a6.324 6.324 0 000-.956L4.231 8a7.103 7.103 0 00-.087-.716l-.282.052a6.396 6.396 0 00-.243-.923l.283-.098a6.817 6.817 0 00-.203-.542l-.07-.159-.271.128a6.473 6.473 0 00-.472-.83l.266-.179a7.108 7.108 0 00-.506-.694l-.27.228a6.24 6.24 0 00-.598-.619c-1.11 1.308-1.78 3-1.78 4.85s.67 3.542 1.78 4.85c.212-.193.413-.401.598-.62l.27.228c.183-.221.352-.453.506-.694zM13.22 3.65a6.606 6.606 0 00-.598.62l-.27-.228a6.989 6.989 0 00-.506.694l.266.179a6.243 6.243 0 00-.472.83l-.271-.128a7.07 7.07 0 00-.272.701l.283.098c-.104.3-.186.61-.243.923l-.282-.052c-.041.236-.07.475-.087.716l.281.021a6.324 6.324 0 000 .956l-.281.021c.017.241.046.48.087.716l.282-.052c.057.312.139.623.243.923l-.283.098c.06.183.127.363.203.541l.069.159.271-.128c.136.287.295.566.472.83l-.266.179c.154.241.323.472.506.694l.27-.228c.184.219.385.427.598.62 1.11-1.308 1.78-3 1.78-4.85s-.67-3.542-1.78-4.85z"
});

function SvgBaseball(props) {
  return /*#__PURE__*/createElement("svg", _extends$2m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2m);
}

function _extends$2n() { _extends$2n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var _ref$2n = /*#__PURE__*/createElement("path", {
  d: "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838a13.625 13.625 0 00-1.453 4.331c-.025.172-.05.344-.069.519-.009.094-.019.188-.025.281-.009.119-.003.156.059.256.187.303.409.584.659.838.512.525 1.134.928 1.794 1.241 1.503.709 3.2.966 4.85 1.022 1.703.056 3.453-.084 5.081-.616 1.391-.453 2.731-1.244 3.503-2.522.084-.137.025-.341.009-.5a11.71 11.71 0 00-.297-1.66 13.737 13.737 0 00-.728-2.159c-1.088-2.525-3.1-5.219-5.963-5.775a5.096 5.096 0 00-.978-.094zm.1 12.243c-1.784 0-3.728-.159-5.334-1.019-.625-.334-1.262-.819-1.563-1.484-.087-.194-.056-.269-.016-.497.028-.147.041-.291.106-.428.091-.191.184-.378.281-.566.328-.634.681-1.262 1.091-1.853.203-.291.419-.578.669-.828.175-.175.388-.362.634-.422.756-.181 1.334.694 1.794 1.134.222.213.519.453.85.412.228-.028.431-.206.594-.353.553-.497.997-1.112 1.456-1.691.228-.284.453-.572.7-.844.166-.184.347-.394.569-.513.397-.216.903.228 1.178.456.469.391.884.847 1.281 1.309.378.441.744.888 1.066 1.372.497.75.928 1.55 1.322 2.359.084.175.113.294.144.488.019.106.059.228.044.338-.022.153-.128.319-.206.444a3.074 3.074 0 01-.719.769c-1.166.903-2.744 1.203-4.178 1.338a18.56 18.56 0 01-1.762.078z"
});

function SvgBasecamp(props) {
  return /*#__PURE__*/createElement("svg", _extends$2n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2n);
}

function _extends$2o() { _extends$2o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var _ref$2o = /*#__PURE__*/createElement("path", {
  d: "M12.703 6L9.924 2.382a1 1 0 10-.793.609L11.442 6H4.558l2.311-3.009a1 1 0 10-.793-.609L3.297 6H0v2h1l1 8h12l1-8h1V6h-3.297zM5 14H3v-2h2v2zm0-4H3V8h2v2zm4 4H7v-2h2v2zm0-4H7V8h2v2zm4 4h-2v-2h2v2zm0-4h-2V8h2v2z"
});

function SvgBasket(props) {
  return /*#__PURE__*/createElement("svg", _extends$2o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2o);
}

function _extends$2p() { _extends$2p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var _ref$2p = /*#__PURE__*/createElement("path", {
  d: "M14.983 8a7.46 7.46 0 00-1.743-4.326A6.33 6.33 0 0011.05 8h3.932zm-2.53-5.131A7.468 7.468 0 008 1.017V8h1.923a7.477 7.477 0 012.53-5.131zM2.102 3.992a6.374 6.374 0 00-.342-.318A7.474 7.474 0 00.017 8h3.932a6.329 6.329 0 00-1.848-4.008zM5.077 8H7V1.017a7.468 7.468 0 00-4.453 1.852A7.486 7.486 0 015.077 8zm7.821 5.008c.111.111.225.217.342.318A7.474 7.474 0 0014.983 9h-3.932a6.329 6.329 0 001.848 4.008zM9.923 9H8v6.983a7.468 7.468 0 004.453-1.852A7.486 7.486 0 019.923 9zM.017 9a7.46 7.46 0 001.743 4.326A6.33 6.33 0 003.95 9H.018zm2.53 5.131A7.468 7.468 0 007 15.983V9H5.077a7.477 7.477 0 01-2.53 5.131z"
});

function SvgBasketball(props) {
  return /*#__PURE__*/createElement("svg", _extends$2p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2p);
}

function _extends$2q() { _extends$2q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var _ref$2q = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery0(props) {
  return /*#__PURE__*/createElement("svg", _extends$2q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2q);
}

function _extends$2r() { _extends$2r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var _ref$2r = /*#__PURE__*/createElement("path", {
  d: "M2 6h2v6H2V6z"
});

var _ref2$f = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2r, _ref2$f);
}

function _extends$2s() { _extends$2s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var _ref$2s = /*#__PURE__*/createElement("path", {
  d: "M2 6h4v6H2V6z"
});

var _ref2$g = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2s, _ref2$g);
}

function _extends$2t() { _extends$2t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var _ref$2t = /*#__PURE__*/createElement("path", {
  d: "M2 6h6v6H2V6z"
});

var _ref2$h = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery3(props) {
  return /*#__PURE__*/createElement("svg", _extends$2t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2t, _ref2$h);
}

function _extends$2u() { _extends$2u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var _ref$2u = /*#__PURE__*/createElement("path", {
  d: "M2 6h8v6H2V6z"
});

var _ref2$i = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery4(props) {
  return /*#__PURE__*/createElement("svg", _extends$2u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2u, _ref2$i);
}

function _extends$2v() { _extends$2v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var _ref$2v = /*#__PURE__*/createElement("path", {
  d: "M2 6h10v6H2V6z"
});

var _ref2$j = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery5(props) {
  return /*#__PURE__*/createElement("svg", _extends$2v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2v, _ref2$j);
}

function _extends$2w() { _extends$2w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var _ref$2w = /*#__PURE__*/createElement("path", {
  d: "M2 6h11v6H2V6z"
});

var _ref2$k = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 9H1V5h13v8zM16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgBattery6(props) {
  return /*#__PURE__*/createElement("svg", _extends$2w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2w, _ref2$k);
}

function _extends$2x() { _extends$2x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var _ref$2x = /*#__PURE__*/createElement("path", {
  d: "M16.5 7h-1v4h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM14 4h-3.622l-.491 1H14v8H8.226l-.813 1H14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM4.935 13H1V5h5.719l.8-1H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h3.414l.521-1z"
});

var _ref2$l = /*#__PURE__*/createElement("path", {
  d: "M11 8H7.3L10 2.5 4 10h3.625L4.5 16z"
});

function SvgBatteryCharging(props) {
  return /*#__PURE__*/createElement("svg", _extends$2x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$2x, _ref2$l);
}

function _extends$2y() { _extends$2y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var _ref$2y = /*#__PURE__*/createElement("path", {
  d: "M15 5a1 1 0 00-1 1v3H3.5A1.5 1.5 0 012 7.5V3a1 1 0 00-2 0v10h2v-2h12v2h2V6a1 1 0 00-1-1z"
});

var _ref2$m = /*#__PURE__*/createElement("path", {
  d: "M5.5 6.75a1.75 1.75 0 11-3.501-.001A1.75 1.75 0 015.5 6.75zM12.5 6h-5A1.5 1.5 0 006 7.5v1h8v-1A1.5 1.5 0 0012.5 6z"
});

function SvgBed(props) {
  return /*#__PURE__*/createElement("svg", _extends$2y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2y, _ref2$m);
}

function _extends$2z() { _extends$2z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var _ref$2z = /*#__PURE__*/createElement("path", {
  d: "M0 14h2v2h2v-2h8v2h2v-2h2v-1H0zm13-9H3l-3 7h16zM5.5 4C6.881 4 8 4.448 8 5c0-.552 1.119-1 2.5-1s2.5.448 2.5 1V1a1 1 0 00-1-1H4a1 1 0 00-1 1v4c0-.552 1.119-1 2.5-1z"
});

function SvgBed2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2z);
}

function _extends$2A() { _extends$2A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var _ref$2A = /*#__PURE__*/createElement("path", {
  d: "M4.641 3.206c.472 0 .897.041 1.284.125.388.081.716.219.994.406.275.188.487.438.644.75.15.309.225.697.225 1.156 0 .497-.112.909-.338 1.241-.228.331-.559.6-1.003.813.606.175 1.053.481 1.353.916.3.438.444.963.444 1.581 0 .5-.097.928-.287 1.291a2.535 2.535 0 01-.778.891c-.325.231-.7.4-1.119.509a5.052 5.052 0 01-1.287.166H.001V3.207h4.641zm-.282 3.975c.384 0 .703-.091.953-.275.25-.181.369-.481.369-.894 0-.228-.041-.419-.122-.566a.905.905 0 00-.334-.344 1.325 1.325 0 00-.478-.172 2.98 2.98 0 00-.556-.05H2.166v2.3H4.36zm.119 4.191c.213 0 .416-.019.606-.063a1.43 1.43 0 00.509-.209c.144-.097.266-.225.353-.394.088-.166.128-.378.128-.637 0-.506-.144-.869-.428-1.088-.284-.216-.662-.322-1.131-.322h-2.35v2.709h2.313zM11.331 11.338c.294.287.716.431 1.266.431.394 0 .738-.1 1.022-.3s.456-.412.522-.631h1.725c-.278.859-.697 1.469-1.272 1.838-.566.369-1.259.556-2.063.556a4.11 4.11 0 01-1.519-.269 3.22 3.22 0 01-1.15-.766 3.51 3.51 0 01-.725-1.188 4.382 4.382 0 01-.256-1.519c0-.534.088-1.031.262-1.491.178-.463.422-.859.747-1.194s.706-.6 1.156-.794a3.692 3.692 0 011.488-.291c.603 0 1.131.116 1.584.353.45.234.822.55 1.113.944s.497.847.625 1.353.172 1.034.137 1.588h-5.147c0 .559.188 1.094.484 1.378zm2.247-3.744c-.231-.256-.628-.397-1.106-.397-.313 0-.572.053-.778.159a1.564 1.564 0 00-.497.394 1.396 1.396 0 00-.262.503c-.05.172-.081.331-.091.469h3.188c-.047-.5-.219-.869-.453-1.128zM10.444 4h3.991v.972h-3.991V4z"
});

function SvgBehance(props) {
  return /*#__PURE__*/createElement("svg", _extends$2A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2A);
}

function _extends$2B() { _extends$2B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var _ref$2B = /*#__PURE__*/createElement("path", {
  d: "M6.316 7.009c.203-.147.3-.391.3-.728a.936.936 0 00-.097-.459.72.72 0 00-.272-.278 1.075 1.075 0 00-.388-.141 2.386 2.386 0 00-.453-.041H3.759v1.869H5.54c.313.003.572-.072.775-.222zM6.594 8.697c-.231-.175-.537-.262-.919-.262H3.759v2.203h1.878c.175 0 .338-.016.494-.05s.297-.088.416-.169c.119-.078.216-.184.287-.319s.106-.309.106-.519c0-.412-.116-.706-.347-.884z"
});

var _ref2$n = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-4.012 4.209h3.241V5h-3.241v-.791zm-2.025 6.516a2.06 2.06 0 01-.631.725 2.82 2.82 0 01-.909.416A4.007 4.007 0 015.879 12H2.001V4.003H5.77c.381 0 .728.034 1.044.1.313.066.581.178.806.331.222.153.397.356.522.609.122.25.184.566.184.938 0 .403-.091.737-.275 1.006s-.453.487-.816.659c.494.141.856.391 1.097.744.244.356.363.784.363 1.284.003.409-.075.759-.231 1.05zm6.528-1.237h-4.178c0 .456.156.891.394 1.125.238.231.581.35 1.028.35.322 0 .597-.081.831-.244.231-.162.372-.334.425-.512h1.4c-.225.697-.566 1.194-1.031 1.494-.459.3-1.022.45-1.675.45-.456 0-.866-.075-1.234-.219a2.613 2.613 0 01-.934-.622 2.854 2.854 0 01-.588-.966A3.562 3.562 0 019.22 9.11c0-.434.072-.838.213-1.213a2.815 2.815 0 011.544-1.616 3.013 3.013 0 011.206-.234c.491 0 .919.094 1.287.287.366.191.666.447.903.769s.403.688.509 1.1c.103.406.137.834.109 1.284z"
});

var _ref3$2 = /*#__PURE__*/createElement("path", {
  d: "M12.134 7.247c-.253 0-.466.044-.631.131s-.3.194-.403.319a1.131 1.131 0 00-.213.409 1.725 1.725 0 00-.072.381h2.588c-.037-.406-.178-.706-.366-.916-.194-.213-.512-.325-.903-.325z"
});

function SvgBehance2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2B, _ref2$n, _ref3$2);
}

function _extends$2C() { _extends$2C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var _ref$2C = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1zm-9-1.441L4.58 8.358l.747-.747 1.674 1.205 3.83-3.392.778.778-4.608 5.358z"
});

function SvgBellCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$2C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2C);
}

function _extends$2D() { _extends$2D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var _ref$2D = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1zm-5-3.5l-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2 1 1-2 2 2 2z"
});

function SvgBellCross(props) {
  return /*#__PURE__*/createElement("svg", _extends$2D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2D);
}

function _extends$2E() { _extends$2E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var _ref$2E = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1zm-5-4H5V7h6v2z"
});

function SvgBellMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$2E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2E);
}

function _extends$2F() { _extends$2F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var _ref$2F = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1zm-5-4H9v2H7V9H5V7h2V5h2v2h2v2z"
});

function SvgBellPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$2F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2F);
}

function _extends$2G() { _extends$2G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var _ref$2G = /*#__PURE__*/createElement("path", {
  d: "M16.023 12.5c0-4.5-4-3.5-4-7 0-.29-.028-.538-.079-.749-.263-1.766-1.44-3.183-2.965-3.615A.86.86 0 009 .945C9 .425 8.55 0 8 0S7 .425 7 .945c0 .065.007.129.021.191-1.71.484-2.983 2.208-3.02 4.273L4 5.5C4 9 0 8 0 12.5c0 1.191 2.665 2.187 6.234 2.439a2 2 0 003.532 0C13.334 14.688 16 13.691 16 12.5v-.011l.024.011zm-3.113.845c-.847.226-1.846.389-2.918.479a2 2 0 00-3.984 0c-1.072-.09-2.071-.253-2.918-.479-1.166-.311-1.724-.659-1.928-.845.204-.186.762-.534 1.928-.845 1.356-.362 3.1-.561 4.91-.561s3.554.199 4.91.561c1.166.311 1.724.659 1.928.845-.204.186-.762.534-1.928.845z"
});

function SvgBell(props) {
  return /*#__PURE__*/createElement("svg", _extends$2G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2G);
}

function _extends$2H() { _extends$2H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var _ref$2H = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1z"
});

function SvgBell2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2H);
}

function _extends$2I() { _extends$2I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var _ref$2I = /*#__PURE__*/createElement("path", {
  d: "M16 13a3 3 0 01-3-3V5.545c0-2.199-1.718-4.033-4-4.454V0H7v1.091c-2.282.421-4 2.255-4 4.454V10a3 3 0 01-3 3v1h6.712a1.414 1.414 0 102.574 0h6.713v-1zM15.483 6a.5.5 0 01-.498-.467A6.966 6.966 0 0012.759.867a.5.5 0 01.68-.734 7.96 7.96 0 012.543 5.334.5.5 0 01-.466.532L15.483 6zM.517 6l-.033-.001a.5.5 0 01-.466-.532A7.964 7.964 0 012.561.133a.5.5 0 11.68.734 6.966 6.966 0 00-2.226 4.666A.5.5 0 01.517 6z"
});

function SvgBell3(props) {
  return /*#__PURE__*/createElement("svg", _extends$2I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2I);
}

function _extends$2J() { _extends$2J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var _ref$2J = /*#__PURE__*/createElement("path", {
  d: "M15.5 7c-.453 0-.887.087-1.285.244l-2.853-4.992A.5.5 0 0010.928 2H9.499a.5.5 0 000 1h1.139l1.143 2H6.933l-.571-1H6.5a.5.5 0 000-1h-2a.5.5 0 000 1h.71l.784 1.372-1.14 1.901a3.504 3.504 0 00-4.853 3.228c0 1.93 1.57 3.5 3.5 3.5a3.505 3.505 0 003.464-3h1.122a1.5 1.5 0 102.57-1.455l1.906-3.177.785 1.374A3.495 3.495 0 0012 10.501c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm-12 6C2.122 13 1 11.879 1 10.5a2.503 2.503 0 013.331-2.357l-1.26 2.1a.5.5 0 00.429.758h2.45a2.504 2.504 0 01-2.45 2zm.883-3l.805-1.342A2.5 2.5 0 015.949 10H4.382zm3.703 0H6.964A3.505 3.505 0 005.71 7.788l.853-1.421L8.365 9.52c-.121.14-.216.302-.279.479zM9.5 11a.5.5 0 110-1 .5.5 0 010 1zm.299-1.97a1.48 1.48 0 00-.566-.006L7.505 6h4.112L9.799 9.03zM15.5 13a2.502 2.502 0 01-2.5-2.5c0-.747.33-1.419.851-1.877l1.214 2.125a.499.499 0 00.683.186.5.5 0 00.186-.682l-1.215-2.126A2.502 2.502 0 0118 10.5c0 1.379-1.122 2.5-2.5 2.5z"
});

function SvgBike(props) {
  return /*#__PURE__*/createElement("svg", _extends$2J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16"
  }, props), _ref$2J);
}

function _extends$2K() { _extends$2K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var _ref$2K = /*#__PURE__*/createElement("path", {
  d: "M2 5v10c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V5H2zm3 9H4V7h1v7zm2 0H6V7h1v7zm2 0H8V7h1v7zm2 0h-1V7h1v7zM13.25 2H10V.75A.753.753 0 009.25 0h-3.5A.753.753 0 005 .75V2H1.75a.752.752 0 00-.75.75V4h13V2.75a.752.752 0 00-.75-.75zM9 2H6v-.987h3V2z"
});

function SvgBin(props) {
  return /*#__PURE__*/createElement("svg", _extends$2K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2K);
}

function _extends$2L() { _extends$2L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var _ref$2L = /*#__PURE__*/createElement("path", {
  d: "M3 16h10l1-11H2zm7-14V0H6v2H1v3l1-1h12l1 1V2h-5zM9 2H7V1h2v1z"
});

function SvgBin2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2L);
}

function _extends$2M() { _extends$2M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var _ref$2M = /*#__PURE__*/createElement("path", {
  d: "M15 2.5C15 1.119 11.642 0 7.5 0S0 1.119 0 2.5c0 .098.017.194.05.288L1.993 14c0 1.105 2.464 2 5.504 2s5.504-.895 5.504-2l1.95-11.21a.88.88 0 00.05-.29zM2.944 1.679c1.257-.357 2.875-.554 4.556-.554s3.299.197 4.556.554c1.078.306 1.584.645 1.763.821-.179.176-.686.515-1.763.821-1.257.357-2.875.554-4.556.554s-3.299-.197-4.556-.554C1.866 3.015 1.36 2.676 1.181 2.5c.179-.176.686-.515 1.763-.821z"
});

function SvgBin3(props) {
  return /*#__PURE__*/createElement("svg", _extends$2M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2M);
}

function _extends$2N() { _extends$2N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

var _ref$2N = /*#__PURE__*/createElement("path", {
  d: "M7.5 0C3.358 0 0 1.119 0 2.5c0 .098.017.194.05.288L1.993 14c0 1.105 2.464 2 5.504 2s5.504-.895 5.504-2l1.95-11.21a.88.88 0 00.05-.29c0-1.381-3.358-2.5-7.5-2.5zm6.075 4.125h-.376a6.79 6.79 0 00.406-.173l-.03.173zm-2.083 8.5a7.476 7.476 0 00-.788-.25h1.436l-.043.25h-.605zm-8.596 0l-.043-.25h1.435a7.476 7.476 0 00-.788.25h-.605zm6.518-.5C8.817 12.044 8.171 12 7.496 12s-1.32.044-1.918.125H2.809l-.043-.25h9.461l-.043.25h-2.77zm-6.691-.5l-.043-.25h9.635l-.043.25H2.724zm-.087-.5l-.043-.25h9.808l-.043.25H2.636zm-.086-.5l-.043-.25h9.982l-.043.25H2.551zm-.087-.5l-.043-.25h10.156l-.043.25H2.464zm-.086-.5l-.043-.25h10.329l-.043.25H2.378zm-.087-.5l-.043-.25H12.75l-.043.25H2.291zm-.087-.5l-.043-.25h10.676l-.043.25H2.203zm-.086-.5l-.043-.25h10.85l-.043.25H2.118zm-.087-.5l-.043-.25h11.024l-.043.25H2.031zm-.087-.5l-.043-.25h11.197l-.043.25H1.943zm-.086-.5l-.043-.25h11.371l-.043.25H1.858zm-.087-.5l-.043-.25h11.544l-.043.25H1.77zm-.087-.5l-.043-.25h11.718l-.043.25H1.684zm-.086-.5l-.043-.25h3.601C5.893 4.956 6.681 5 7.501 5s1.608-.044 2.346-.125h3.599l-.043.25H1.598zm-.204-1.173c.128.06.264.118.407.173h-.377l-.03-.173zm1.147.423c.314.092.651.176 1.009.25H1.51l-.043-.25H2.54zm8.911.25c.357-.074.695-.158 1.009-.25h1.072l-.043.25h-2.037zM2.944 1.679c1.257-.357 2.875-.554 4.556-.554s3.299.197 4.556.554c1.078.306 1.584.645 1.763.821-.179.176-.686.515-1.763.821-1.257.357-2.875.554-4.556.554s-3.299-.197-4.556-.554C1.866 3.015 1.36 2.676 1.181 2.5c.179-.176.686-.515 1.763-.821z"
});

function SvgBin4(props) {
  return /*#__PURE__*/createElement("svg", _extends$2N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2N);
}

function _extends$2O() { _extends$2O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

var _ref$2O = /*#__PURE__*/createElement("path", {
  d: "M6 7h1v1H6V7zM8 7h1v1H8V7zM9 10h1v1H9v-1zM9 8h1v1H9V8zM10 7h1v1h-1V7zM4 9h1v1H4V9zM3 6h1v1H3V6zM3 8h1v1H3V8zM5 10h1v1H5v-1zM7 10h1v1H7v-1zM8 9h1v1H8V9zM6 9h1v1H6V9zM7 8h1v1H7V8zM5 8h1v1H5V8zM7 12h1v1H7v-1zM8 11h1v1H8v-1zM6 11h1v1H6v-1zM4 11h1v1H4v-1zM4 7h1v1H4V7zM10 11h1v1h-1v-1zM9 12h1v1H9v-1zM8 13h1v1H8v-1z"
});

var _ref2$o = /*#__PURE__*/createElement("path", {
  d: "M7.5 0C3.358 0 0 1.119 0 2.5c0 .098.017.194.05.288L1.993 14c0 1.105 2.464 2 5.504 2s5.504-.895 5.504-2l1.95-11.21a.88.88 0 00.05-.29c0-1.381-3.358-2.5-7.5-2.5zM13 7h-1v1h1v1h-1v1h-1v1h1v1h-1v1h1v1h-1v-1h-1v1H9v1H8v-1H7v1H6v-1H5v-1H4v1H3v-1h1v-1H3v-1h1v-1H3V9H2V8h1V7H2V6h1V5h1v1h1v1h1V6h1v1h1V6h1v1h1V6h1V5h1v1h1v1zm-.944-3.679c-1.257.357-2.875.554-4.556.554s-3.299-.197-4.556-.554C1.866 3.015 1.36 2.676 1.181 2.5c.179-.176.686-.515 1.763-.821 1.257-.357 2.875-.554 4.556-.554s3.299.197 4.556.554c1.078.306 1.584.645 1.763.821-.179.176-.685.515-1.763.821z"
});

var _ref3$3 = /*#__PURE__*/createElement("path", {
  d: "M6 13h1v1H6v-1zM11 8h1v1h-1V8zM10 9h1v1h-1V9zM11 6h1v1h-1V6zM5 12h1v1H5v-1z"
});

function SvgBin5(props) {
  return /*#__PURE__*/createElement("svg", _extends$2O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2O, _ref2$o, _ref3$3);
}

function _extends$2P() { _extends$2P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

var _ref$2P = /*#__PURE__*/createElement("path", {
  d: "M1 0h6v1H1zm8 0h6v1H9zm5.875 5H14V1h-4v4H6V1H2v4h-.875C.506 5 0 5.506 0 6.125v8.75C0 15.494.506 16 1.125 16h4.75C6.494 16 7 15.494 7 14.875V9h2v5.875C9 15.494 9.506 16 10.125 16h4.75c.619 0 1.125-.506 1.125-1.125v-8.75C16 5.506 15.494 5 14.875 5zM5.438 15H1.563C1.254 15 1 14.775 1 14.5s.253-.5.563-.5h3.875c.309 0 .563.225.563.5s-.253.5-.563.5zM8.5 8h-1c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h1c.275 0 .5.225.5.5s-.225.5-.5.5zm5.938 7h-3.875c-.309 0-.563-.225-.563-.5s.253-.5.563-.5h3.875c.309 0 .563.225.563.5s-.253.5-.563.5z"
});

function SvgBinoculars(props) {
  return /*#__PURE__*/createElement("svg", _extends$2P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2P);
}

function _extends$2Q() { _extends$2Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

var _ref$2Q = /*#__PURE__*/createElement("path", {
  d: "M15 7h-1l-1-5h-1.25L12 0H9l.25 2h-2.5L7 0H4l.25 2H3L2 7H1l-1 8v1h6V7h1V6h2v1h1v9h6v-1z"
});

function SvgBinoculars2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2Q);
}

function _extends$2R() { _extends$2R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

var _ref$2R = /*#__PURE__*/createElement("path", {
  d: "M13.657 2.343C12.146.832 10.137 0 8 0S3.854.832 2.343 2.343C.832 3.854 0 5.863 0 8s.832 4.146 2.343 5.657C3.854 15.168 5.863 16 8 16s4.146-.832 5.657-2.343C15.168 12.146 16 10.137 16 8s-.832-4.146-2.343-5.657zM14 8a5.97 5.97 0 01-1.111 3.475L4.525 3.111A5.97 5.97 0 018 2c3.308 0 6 2.692 6 6zM2 8a5.97 5.97 0 011.111-3.475l8.364 8.364A5.97 5.97 0 018 14c-3.308 0-6-2.692-6-6z"
});

function SvgBlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$2R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2R);
}

function _extends$2S() { _extends$2S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

var _ref$2S = /*#__PURE__*/createElement("path", {
  d: "M6 0v1.5a8.46 8.46 0 016.01 2.489 8.472 8.472 0 012.489 6.01h1.5c0-5.523-4.477-10-10-10z"
});

var _ref2$p = /*#__PURE__*/createElement("path", {
  d: "M6 3v1.5c1.469 0 2.85.572 3.889 1.611S11.5 8.531 11.5 10H13a7 7 0 00-7-7zM7.5 6l-1 1L3 8l-3 6.5.396.396 3.638-3.638a1 1 0 11.707.707l-3.638 3.638.396.396 6.5-3 1-3.5 1-1-2.5-2.5z"
});

function SvgBlog(props) {
  return /*#__PURE__*/createElement("svg", _extends$2S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2S, _ref2$p);
}

function _extends$2T() { _extends$2T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

var _ref$2T = /*#__PURE__*/createElement("path", {
  d: "M6 3v1.5c1.469 0 2.85.572 3.889 1.611S11.5 8.531 11.5 10H13a7 7 0 00-7-7zm0-3v1.5a8.46 8.46 0 016.01 2.489 8.472 8.472 0 012.489 6.01h1.5c0-5.523-4.477-10-10-10zM8.414 7.586a2 2 0 00-2.828 0L0 13.172V16h2.828l5.586-5.586a2 2 0 000-2.828zM2 14.5l-1-1 5-5 1 1-5 5z"
});

function SvgBlog2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2T);
}

function _extends$2U() { _extends$2U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

var _ref$2U = /*#__PURE__*/createElement("path", {
  d: "M14.966 6h-.897C13.52 6 13.038 5.535 13 5c0-2.854-2.301-5-5.175-5H5.203C2.331 0 .002 2.313 0 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165V7.174c0-.57-.46-1.173-1.034-1.173zM5 4h3c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm6 8H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
});

function SvgBlogger(props) {
  return /*#__PURE__*/createElement("svg", _extends$2U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2U);
}

function _extends$2V() { _extends$2V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

var _ref$2V = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM14 10.125C14 12.266 12.259 14 10.103 14h-4.2C3.747 14 2 12.266 2 10.125v-4.25C2 3.734 3.747 2 5.903 2h1.966c2.156 0 3.881 1.609 3.881 3.75.028.4.391.75.8.75h.672c.431 0 .775.453.775.881v2.744z"
});

var _ref2$q = /*#__PURE__*/createElement("path", {
  d: "M11 10c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1zM9 6c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1z"
});

function SvgBlogger2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2V, _ref2$q);
}

function _extends$2W() { _extends$2W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

var _ref$2W = /*#__PURE__*/createElement("path", {
  d: "M0 11v4h11c2 0 5-1.828 5-4H0zM8 1l-8 9h8zm1 2v7h5c0-5-5-7-5-7z"
});

function SvgBoat(props) {
  return /*#__PURE__*/createElement("svg", _extends$2W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2W);
}

function _extends$2X() { _extends$2X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

var _ref$2X = /*#__PURE__*/createElement("path", {
  d: "M10.024 7.453v-.135c1.817-.337 3.954-1.262 3.954-3.651 0-1.211-.572-2.221-1.497-2.81-.959-.622-2.204-.858-4.122-.858H1.007v.875c1.767.168 2.019.32 2.019 2.423v9.388c0 2.059-.238 2.245-2.025 2.424V16h6.265c2.103 0 4.004-.37 5.266-1.06 1.447-.757 2.355-2.053 2.355-3.668 0-2.355-1.918-3.499-4.862-3.819zM6 2.406c0-.505.05-.858.219-1.043.151-.135.589-.32 1.144-.32 1.38 0 2.726.841 2.726 3.079 0 2.002-1.11 2.927-3.533 2.927h-.555V2.406zM7.885 14.94C6.505 14.974 6 14.452 6 12.618V8.059h.488c2.911 0 4.391 1.178 4.391 3.483 0 2.372-1.598 3.382-2.995 3.399z"
});

function SvgBold(props) {
  return /*#__PURE__*/createElement("svg", _extends$2X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2X);
}

function _extends$2Y() { _extends$2Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

var _ref$2Y = /*#__PURE__*/createElement("path", {
  d: "M11.061 7.573A3.982 3.982 0 0012 5c0-2.206-1.794-4-4-4H3v14h6c2.206 0 4-1.794 4-4a4.002 4.002 0 00-1.939-3.427zM6 3h1.586c.874 0 1.586.897 1.586 2s-.711 2-1.586 2H6V3zm2.484 10H6V9h2.484c.913 0 1.656.897 1.656 2s-.743 2-1.656 2z"
});

function SvgBold2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2Y);
}

function _extends$2Z() { _extends$2Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

var _ref$2Z = /*#__PURE__*/createElement("path", {
  d: "M16 1v.414L15.414 2l.586.586V3h-1v1h-.414L14 3.414 13.414 4H13V3h-1v-.012a1.68 1.68 0 01-.583-.124c-.463-.189-.78-.548-1.087-.895-.302-.342-.588-.665-.988-.799-.505-.168-1.207-.298-1.677.041-.223.16-.391.427-.503.788h.088c.412 0 .75.337.75.75v.424a6.502 6.502 0 01-1.5 12.826A6.5 6.5 0 015 3.173v-.424c0-.413.338-.75.75-.75h.378C6.291 1.275 6.609.74 7.08.4c.644-.464 1.536-.526 2.578-.179.656.218 1.062.679 1.421 1.085.474.537.742.839 1.414.6l-.494-.494V.998h1v-1h.414l.586.586.586-.586h.414v1h1z"
});

function SvgBomb(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2Z);
}

function _extends$2_() { _extends$2_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

var _ref$2_ = /*#__PURE__*/createElement("path", {
  d: "M6 5.5l5 3-5 3v-6z"
});

var _ref2$r = /*#__PURE__*/createElement("path", {
  d: "M8 15.231a.499.499 0 01-.389-.186c-.588-.729-2.257-1.544-3.611-1.544-1.306 0-2.498.472-3.111 1.232a.5.5 0 01-.89-.314v-10.5a.5.5 0 01.111-.314c.798-.989 2.289-1.604 3.889-1.604 1.457 0 3.092.728 4 1.519.908-.791 2.543-1.519 4-1.519 1.601 0 3.091.615 3.889 1.604a.5.5 0 01.111.314v10.5a.5.5 0 01-.89.314c-.613-.76-1.805-1.232-3.111-1.232-1.353 0-3.023.815-3.611 1.544a.499.499 0 01-.389.186zM4 12.5c1.457 0 3.092.728 4 1.519.908-.791 2.543-1.519 4-1.519 1.121 0 2.187.301 3 .822V4.105c-.639-.685-1.769-1.104-3-1.104-1.353 0-3.023.815-3.611 1.545a.499.499 0 01-.778 0C7.023 3.817 5.353 3.001 4 3.001c-1.231 0-2.361.42-3 1.104v9.217c.813-.52 1.879-.822 3-.822z"
});

function SvgBookPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$2_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2_, _ref2$r);
}

function _extends$2$() { _extends$2$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

var _ref$2$ = /*#__PURE__*/createElement("path", {
  d: "M15.889 3.604C15.091 2.615 13.6 2 12 2s-3.091.615-3.889 1.604A.5.5 0 008 3.918a.5.5 0 00-.111-.314C7.091 2.615 5.6 2 4 2S.909 2.615.111 3.604A.5.5 0 000 3.918v10a.5.5 0 00.89.314C1.503 13.472 2.695 13 4.001 13s2.498.472 3.111 1.232a.5.5 0 00.389.186h1a.5.5 0 00.389-.186c.613-.76 1.805-1.232 3.111-1.232s2.498.472 3.111 1.232a.5.5 0 00.89-.314v-10a.5.5 0 00-.111-.314zM7 12.822C6.187 12.302 5.121 12 4 12s-2.187.301-3 .822V4.105c.639-.685 1.769-1.104 3-1.104s2.361.42 3 1.104v8.717zm8 0c-.813-.52-1.879-.822-3-.822s-2.187.301-3 .822V4.105c.639-.685 1.769-1.104 3-1.104s2.361.42 3 1.104v8.717z"
});

var _ref2$s = /*#__PURE__*/createElement("path", {
  d: "M10 5h4v1h-4V5zM10 7h4v1h-4V7zM10 9h3v1h-3V9zM2 5h4v1H2V5zM2 7h4v1H2V7zM2 9h3v1H2V9z"
});

function SvgBook(props) {
  return /*#__PURE__*/createElement("svg", _extends$2$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$2$, _ref2$s);
}

function _extends$30() { _extends$30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

var _ref$30 = /*#__PURE__*/createElement("path", {
  d: "M15.889 3.604C15.091 2.615 13.6 2 12 2s-3.091.615-3.889 1.604A.5.5 0 008 3.918a.5.5 0 00-.111-.314C7.091 2.615 5.6 2 4 2S.909 2.615.111 3.604A.5.5 0 000 3.918v10a.5.5 0 00.89.314C1.503 13.472 2.695 13 4.001 13s2.498.472 3.111 1.232a.5.5 0 00.389.186h1a.5.5 0 00.389-.186c.613-.76 1.805-1.232 3.111-1.232s2.498.472 3.111 1.232a.5.5 0 00.89-.314v-10a.5.5 0 00-.111-.314zM7 12.822C6.187 12.302 5.121 12 4 12s-2.187.301-3 .822V4.105c.639-.685 1.769-1.104 3-1.104s2.361.42 3 1.104v8.717zm8 0c-.813-.52-1.879-.822-3-.822s-2.187.301-3 .822V4.105c.639-.685 1.769-1.104 3-1.104s2.361.42 3 1.104v8.717z"
});

function SvgBook2(props) {
  return /*#__PURE__*/createElement("svg", _extends$30({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$30);
}

function _extends$31() { _extends$31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

var _ref$31 = /*#__PURE__*/createElement("path", {
  d: "M14 2v13H3.5a1.5 1.5 0 110-3H13V0H3C1.9 0 1 .9 1 2v12c0 1.1.9 2 2 2h12V2h-1z"
});

var _ref2$t = /*#__PURE__*/createElement("path", {
  d: "M3.501 13H3.5a.5.5 0 000 1H12.999v-1H3.501z"
});

function SvgBook3(props) {
  return /*#__PURE__*/createElement("svg", _extends$31({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$31, _ref2$t);
}

function _extends$32() { _extends$32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

var _ref$32 = /*#__PURE__*/createElement("path", {
  d: "M14 2v13H3.5a1.5 1.5 0 110-3H13V0H3C1.9 0 1 .9 1 2v12c0 1.1.9 2 2 2h12V2h-1zM5 .5h5v7L7.5 5 5 7.5v-7z"
});

var _ref2$u = /*#__PURE__*/createElement("path", {
  d: "M3.501 13H3.5a.5.5 0 000 1H12.999v-1H3.501z"
});

function SvgBookmark(props) {
  return /*#__PURE__*/createElement("svg", _extends$32({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$32, _ref2$u);
}

function _extends$33() { _extends$33 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

var _ref$33 = /*#__PURE__*/createElement("path", {
  d: "M3 0v16l5-5 5 5V0z"
});

function SvgBookmark2(props) {
  return /*#__PURE__*/createElement("svg", _extends$33({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$33);
}

function _extends$34() { _extends$34 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

var _ref$34 = /*#__PURE__*/createElement("path", {
  d: "M3 0v16l5-5 5 5V0H3zm9 13.586l-4-4-4 4V1h8v12.586z"
});

function SvgBookmark3(props) {
  return /*#__PURE__*/createElement("svg", _extends$34({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$34);
}

function _extends$35() { _extends$35 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

var _ref$35 = /*#__PURE__*/createElement("path", {
  d: "M13.059 0H1v14l1 2h12V1.882L13.059 0zm-.618 1l.5 1H10l-.5-1h2.941zM2 1h3.5L6 2H2.5L2 1zm11 14H3V3h3v6l2-2 2 2V3h3v12z"
});

function SvgBookmark4(props) {
  return /*#__PURE__*/createElement("svg", _extends$35({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$35);
}

function _extends$36() { _extends$36 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

var _ref$36 = /*#__PURE__*/createElement("path", {
  d: "M4 2v14l5-5 5 5V2zm8-2H2v14l1-1V1h9z"
});

function SvgBookmarks(props) {
  return /*#__PURE__*/createElement("svg", _extends$36({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$36);
}

function _extends$37() { _extends$37 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

var _ref$37 = /*#__PURE__*/createElement("path", {
  d: "M3.5 2h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zM3 5H1V4h2v1zM8.5 2h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zM8 5H6V4h2v1z"
});

var _ref2$v = /*#__PURE__*/createElement("path", {
  d: "M11.954 2.773l-2.679 1.35a.502.502 0 00-.222.671l4.5 8.93a.502.502 0 00.671.222l2.679-1.35a.502.502 0 00.222-.671l-4.5-8.93a.502.502 0 00-.671-.222z"
});

function SvgBooks(props) {
  return /*#__PURE__*/createElement("svg", _extends$37({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$37, _ref2$v);
}

function _extends$38() { _extends$38 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

var _ref$38 = /*#__PURE__*/createElement("path", {
  d: "M9 5V1h.25c.137 0 .25-.113.25-.25v-.5A.25.25 0 009.25 0h-2.5a.25.25 0 00-.25.25v.5c0 .137.112.25.25.25H7v4c0 1.588-2 2-2 3.508V15.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V8.508C11 7 9 6.588 9 5z"
});

function SvgBottle(props) {
  return /*#__PURE__*/createElement("svg", _extends$38({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$38);
}

function _extends$39() { _extends$39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

var _ref$39 = /*#__PURE__*/createElement("path", {
  d: "M9 5V1h.25c.137 0 .25-.113.25-.25v-.5A.25.25 0 009.25 0h-2.5a.25.25 0 00-.25.25v.5c0 .137.112.25.25.25H7v4c0 1.588-2 2-2 3.508V15.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V8.508C11 7 9 6.588 9 5zm1 9.745c-.531.158-1.232.255-2 .255s-1.469-.096-2-.255v-5c.531.158 1.232.255 2 .255s1.469-.096 2-.255v5z"
});

function SvgBottle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$39);
}

function _extends$3a() { _extends$3a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

var _ref$3a = /*#__PURE__*/createElement("path", {
  d: "M12 4.5c0-.827-.673-1.5-1.5-1.5a.5.5 0 01-.5-.5v-2a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v2a.5.5 0 01-.5.5C4.673 3 4 3.673 4 4.5v1c0 .384.145.734.383 1A1.494 1.494 0 004 7.5v1c0 .384.145.734.383 1a1.494 1.494 0 00-.383 1v1c0 .384.145.734.383 1a1.494 1.494 0 00-.383 1v1c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1zm-1 1c0 .276-.224.5-.5.5a.5.5 0 000 1 .5.5 0 01.5.5v1c0 .276-.224.5-.5.5a.5.5 0 000 1 .5.5 0 01.5.5v1c0 .276-.224.5-.5.5a.5.5 0 000 1 .5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1c0-.276.224-.5.5-.5a.5.5 0 000-1 .5.5 0 01-.5-.5v-1c0-.276.224-.5.5-.5a.5.5 0 000-1 .5.5 0 01-.5-.5v-1c0-.276.224-.5.5-.5a.5.5 0 000-1 .5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5C6.327 4 7 3.327 7 2.5V2h2v.5c0 .827.673 1.5 1.5 1.5a.5.5 0 01.5.5v1z"
});

function SvgBottle3(props) {
  return /*#__PURE__*/createElement("svg", _extends$3a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3a);
}

function _extends$3b() { _extends$3b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

var _ref$3b = /*#__PURE__*/createElement("path", {
  d: "M12 4.5c0-.827-.673-1.5-1.5-1.5a.5.5 0 01-.5-.5v-2a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v2a.5.5 0 01-.5.5C4.673 3 4 3.673 4 4.5v1c0 .384.145.734.383 1A1.494 1.494 0 004 7.5v1c0 .384.145.734.383 1a1.494 1.494 0 00-.383 1v1c0 .384.145.734.383 1a1.494 1.494 0 00-.383 1v1c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1c0-.384-.145-.734-.383-1 .238-.266.383-.616.383-1v-1zM10.25 15v-.25H10V15h-.25v-.25H9.5V15h-.25v-.25H9V15h-.25v-.25H8.5V15h-.25v-.25H8V15h-.25v-.25H7.5V15h-.25v-.25H7V15h-.25v-.25H6.5V15h-.25v-.25H6V15h-.25v-.25H5.5V15a.495.495 0 01-.25-.068v-.182h-.182A.495.495 0 015 14.5h.25v-.25H5V14h.25v-.25H5v-.25h.25v-.25h-.182a.496.496 0 01.182-.182v.182h.25V13h.25v-.067a.502.502 0 00.183-.183H6v-.25a.505.505 0 00-.067-.25H6V12h-.25v.067C5.676 12.024 5.591 12 5.5 12s-.176-.025-.25-.068v-.182h-.182A.495.495 0 015 11.5h.25v-.25H5V11h.25v-.25H5v-.25h.25v-.25h-.182a.496.496 0 01.182-.182v.182h.25V10h.25v-.067a.502.502 0 00.183-.183H6V9.5a.505.505 0 00-.067-.25H6V9h-.25v.067C5.676 9.024 5.591 9 5.5 9s-.176-.025-.25-.068V8.75h-.182A.495.495 0 015 8.5h.25v-.25H5V8h.25v-.25H5V7.5h.25v-.25h-.182a.504.504 0 01.182-.182v.182h.25V7h.25v-.067a.502.502 0 00.183-.183H6V6.5a.505.505 0 00-.067-.25H6V6h-.25v.067C5.676 6.024 5.591 6 5.5 6s-.176-.025-.25-.068V5.75h-.182A.495.495 0 015 5.5h.25v-.25H5V4.5a.5.5 0 01.5-.5C6.327 4 7 3.327 7 2.5V2h2v.5c0 .827.673 1.5 1.5 1.5a.5.5 0 01.5.5V5h-.25v.25H11v.25h-.25v.25h.182a.504.504 0 01-.182.182V5.75h-.25V6h-.25v.067a.502.502 0 00-.183.183H10v.25c0 .091.025.176.067.25H10V7h.25v-.067c.074.043.159.067.25.067s.176.025.25.068v.182h.182A.495.495 0 0111 7.5h-.25v.25H11V8h-.25v.25H11v.25h-.25v.25h.182a.496.496 0 01-.182.182V8.75h-.25V9h-.25v.067a.502.502 0 00-.183.183H10v.25c0 .091.025.176.067.25H10V10h.25v-.067c.074.043.159.067.25.067s.176.025.25.068v.182h.182a.495.495 0 01.068.25h-.25v.25H11V11h-.25v.25H11v.25h-.25v.25h.182a.496.496 0 01-.182.182v-.182h-.25V12h-.25v.067a.502.502 0 00-.183.183H10v.25c0 .091.025.176.067.25H10V13h.25v-.067c.074.043.159.067.25.067s.176.025.25.068v.182h.182a.495.495 0 01.068.25h-.25v.25H11V14h-.25v.25H11v.25h-.25v.25h.182a.496.496 0 01-.182.182v-.182h-.25V15h-.25z"
});

var _ref2$w = /*#__PURE__*/createElement("path", {
  d: "M5.25 8h.25v.25h-.25V8zM5.5 8.25h.25v.25H5.5v-.25zM5.75 8H6v.25h-.25V8zM5.25 8.5h.25v.25h-.25V8.5zM5.5 8.75h.25V9H5.5v-.25zM5.75 8.5H6v.25h-.25V8.5zM6 8.25h.25v.25H6v-.25zM6.25 8h.25v.25h-.25V8zM6.5 8.25h.25v.25H6.5v-.25zM6.75 8H7v.25h-.25V8zM6 8.75h.25V9H6v-.25zM6.25 8.5h.25v.25h-.25V8.5zM6.5 8.75h.25V9H6.5v-.25zM6.75 8.5H7v.25h-.25V8.5zM7 8.25h.25v.25H7v-.25zM7.25 8h.25v.25h-.25V8zM7.5 8.25h.25v.25H7.5v-.25zM7.75 8H8v.25h-.25V8zM7 8.75h.25V9H7v-.25zM7.25 8.5h.25v.25h-.25V8.5zM7.5 8.75h.25V9H7.5v-.25zM7.75 8.5H8v.25h-.25V8.5zM6 9.25h.25v.25H6v-.25zM6.25 9h.25v.25h-.25V9zM6.5 9.25h.25v.25H6.5v-.25zM6.75 9H7v.25h-.25V9zM6 9.75h.25V10H6v-.25zM6.25 9.5h.25v.25h-.25V9.5zM6.5 9.75h.25V10H6.5v-.25zM6.75 9.5H7v.25h-.25V9.5zM7 9.25h.25v.25H7v-.25zM7.25 9h.25v.25h-.25V9zM7.5 9.25h.25v.25H7.5v-.25zM7.75 9H8v.25h-.25V9zM7 9.75h.25V10H7v-.25zM7.25 9.5h.25v.25h-.25V9.5zM7.5 9.75h.25V10H7.5v-.25zM7.75 9.5H8v.25h-.25V9.5zM5.5 10.25h.25v.25H5.5v-.25zM5.75 10H6v.25h-.25V10zM5.25 10.5h.25v.25h-.25v-.25zM5.5 10.75h.25V11H5.5v-.25zM5.75 10.5H6v.25h-.25v-.25zM5.25 11h.25v.25h-.25V11zM5.5 11.25h.25v.25H5.5v-.25zM5.75 11H6v.25h-.25V11zM5.25 11.5h.25v.25h-.25v-.25zM5.5 11.75h.25V12H5.5v-.25zM5.75 11.5H6v.25h-.25v-.25zM6 10.25h.25v.25H6v-.25zM6.25 10h.25v.25h-.25V10zM6.5 10.25h.25v.25H6.5v-.25zM6.75 10H7v.25h-.25V10zM6 10.75h.25V11H6v-.25zM6.25 10.5h.25v.25h-.25v-.25zM6.5 10.75h.25V11H6.5v-.25zM6.75 10.5H7v.25h-.25v-.25zM7 10.25h.25v.25H7v-.25zM7.25 10h.25v.25h-.25V10zM7.5 10.25h.25v.25H7.5v-.25zM7.75 10H8v.25h-.25V10zM7 10.75h.25V11H7v-.25zM7.25 10.5h.25v.25h-.25v-.25zM7.5 10.75h.25V11H7.5v-.25zM7.75 10.5H8v.25h-.25v-.25zM6 11.25h.25v.25H6v-.25zM6.25 11h.25v.25h-.25V11zM6.5 11.25h.25v.25H6.5v-.25zM6.75 11H7v.25h-.25V11zM6 11.75h.25V12H6v-.25zM6.25 11.5h.25v.25h-.25v-.25zM6.5 11.75h.25V12H6.5v-.25zM6.75 11.5H7v.25h-.25v-.25zM7 11.25h.25v.25H7v-.25zM7.25 11h.25v.25h-.25V11zM7.5 11.25h.25v.25H7.5v-.25zM7.75 11H8v.25h-.25V11zM7 11.75h.25V12H7v-.25zM7.25 11.5h.25v.25h-.25v-.25zM7.5 11.75h.25V12H7.5v-.25zM7.75 11.5H8v.25h-.25v-.25zM5.5 13.25h.25v.25H5.5v-.25zM5.75 13H6v.25h-.25V13zM5.25 13.5h.25v.25h-.25v-.25zM5.5 13.75h.25V14H5.5v-.25zM5.75 13.5H6v.25h-.25v-.25zM6 12.25h.25v.25H6v-.25zM6.25 12h.25v.25h-.25V12zM6.5 12.25h.25v.25H6.5v-.25zM6.75 12H7v.25h-.25V12zM6 12.75h.25V13H6v-.25zM6.25 12.5h.25v.25h-.25v-.25zM6.5 12.75h.25V13H6.5v-.25zM6.75 12.5H7v.25h-.25v-.25zM7 12.25h.25v.25H7v-.25zM7.25 12h.25v.25h-.25V12zM7.5 12.25h.25v.25H7.5v-.25zM7.75 12H8v.25h-.25V12zM7 12.75h.25V13H7v-.25zM7.25 12.5h.25v.25h-.25v-.25zM7.5 12.75h.25V13H7.5v-.25zM7.75 12.5H8v.25h-.25v-.25zM6 13.25h.25v.25H6v-.25zM6.25 13h.25v.25h-.25V13zM6.5 13.25h.25v.25H6.5v-.25zM6.75 13H7v.25h-.25V13zM6 13.75h.25V14H6v-.25zM6.25 13.5h.25v.25h-.25v-.25zM6.5 13.75h.25V14H6.5v-.25zM6.75 13.5H7v.25h-.25v-.25zM7 13.25h.25v.25H7v-.25zM7.25 13h.25v.25h-.25V13zM7.5 13.25h.25v.25H7.5v-.25zM7.75 13H8v.25h-.25V13zM7 13.75h.25V14H7v-.25zM7.25 13.5h.25v.25h-.25v-.25zM7.5 13.75h.25V14H7.5v-.25zM7.75 13.5H8v.25h-.25v-.25zM5.25 14h.25v.25h-.25V14zM5.5 14.25h.25v.25H5.5v-.25zM5.75 14H6v.25h-.25V14zM5.25 14.5h.25v.25h-.25v-.25zM5.75 14.5H6v.25h-.25v-.25zM6 14.25h.25v.25H6v-.25zM6.25 14h.25v.25h-.25V14zM6.5 14.25h.25v.25H6.5v-.25zM6.75 14H7v.25h-.25V14zM6.25 14.5h.25v.25h-.25v-.25zM6.75 14.5H7v.25h-.25v-.25zM7 14.25h.25v.25H7v-.25zM7.25 14h.25v.25h-.25V14zM7.5 14.25h.25v.25H7.5v-.25zM7.75 14H8v.25h-.25V14zM7.25 14.5h.25v.25h-.25v-.25zM7.75 14.5H8v.25h-.25v-.25zM8 8.25h.25v.25H8v-.25zM8.25 8h.25v.25h-.25V8zM8.5 8.25h.25v.25H8.5v-.25zM8.75 8H9v.25h-.25V8zM8 8.75h.25V9H8v-.25zM8.25 8.5h.25v.25h-.25V8.5zM8.5 8.75h.25V9H8.5v-.25zM8.75 8.5H9v.25h-.25V8.5zM9 8.25h.25v.25H9v-.25zM9.25 8h.25v.25h-.25V8zM9.5 8.25h.25v.25H9.5v-.25zM9.75 8H10v.25h-.25V8zM9 8.75h.25V9H9v-.25zM9.25 8.5h.25v.25h-.25V8.5zM9.5 8.75h.25V9H9.5v-.25zM9.75 8.5H10v.25h-.25V8.5zM8 9.25h.25v.25H8v-.25zM8.25 9h.25v.25h-.25V9zM8.5 9.25h.25v.25H8.5v-.25zM8.75 9H9v.25h-.25V9zM8 9.75h.25V10H8v-.25zM8.25 9.5h.25v.25h-.25V9.5zM8.5 9.75h.25V10H8.5v-.25zM8.75 9.5H9v.25h-.25V9.5zM9 9.25h.25v.25H9v-.25zM9.25 9h.25v.25h-.25V9zM9.5 9.25h.25v.25H9.5v-.25zM9.75 9H10v.25h-.25V9zM9 9.75h.25V10H9v-.25zM9.25 9.5h.25v.25h-.25V9.5zM9.5 9.75h.25V10H9.5v-.25zM9.75 9.5H10v.25h-.25V9.5zM10 8.25h.25v.25H10v-.25zM10.25 8h.25v.25h-.25V8zM10.5 8.25h.25v.25h-.25v-.25zM10 8.75h.25V9H10v-.25zM10.25 8.5h.25v.25h-.25V8.5zM8 10.25h.25v.25H8v-.25zM8.25 10h.25v.25h-.25V10zM8.5 10.25h.25v.25H8.5v-.25zM8.75 10H9v.25h-.25V10zM8 10.75h.25V11H8v-.25zM8.25 10.5h.25v.25h-.25v-.25zM8.5 10.75h.25V11H8.5v-.25zM8.75 10.5H9v.25h-.25v-.25zM9 10.25h.25v.25H9v-.25zM9.25 10h.25v.25h-.25V10zM9.5 10.25h.25v.25H9.5v-.25zM9.75 10H10v.25h-.25V10zM9 10.75h.25V11H9v-.25zM9.25 10.5h.25v.25h-.25v-.25zM9.5 10.75h.25V11H9.5v-.25zM9.75 10.5H10v.25h-.25v-.25zM8 11.25h.25v.25H8v-.25zM8.25 11h.25v.25h-.25V11zM8.5 11.25h.25v.25H8.5v-.25zM8.75 11H9v.25h-.25V11zM8 11.75h.25V12H8v-.25zM8.25 11.5h.25v.25h-.25v-.25zM8.5 11.75h.25V12H8.5v-.25zM8.75 11.5H9v.25h-.25v-.25zM9 11.25h.25v.25H9v-.25zM9.25 11h.25v.25h-.25V11zM9.5 11.25h.25v.25H9.5v-.25zM9.75 11H10v.25h-.25V11zM9 11.75h.25V12H9v-.25zM9.25 11.5h.25v.25h-.25v-.25zM9.5 11.75h.25V12H9.5v-.25zM9.75 11.5H10v.25h-.25v-.25zM10 10.25h.25v.25H10v-.25zM10.25 10h.25v.25h-.25V10zM10.5 10.25h.25v.25h-.25v-.25zM10 10.75h.25V11H10v-.25zM10.25 10.5h.25v.25h-.25v-.25zM10.5 10.75h.25V11h-.25v-.25zM10 11.25h.25v.25H10v-.25zM10.25 11h.25v.25h-.25V11zM10.5 11.25h.25v.25h-.25v-.25zM10 11.75h.25V12H10v-.25zM10.25 11.5h.25v.25h-.25v-.25zM8 12.25h.25v.25H8v-.25zM8.25 12h.25v.25h-.25V12zM8.5 12.25h.25v.25H8.5v-.25zM8.75 12H9v.25h-.25V12zM8 12.75h.25V13H8v-.25zM8.25 12.5h.25v.25h-.25v-.25zM8.5 12.75h.25V13H8.5v-.25zM8.75 12.5H9v.25h-.25v-.25zM9 12.25h.25v.25H9v-.25zM9.25 12h.25v.25h-.25V12zM9.5 12.25h.25v.25H9.5v-.25zM9.75 12H10v.25h-.25V12zM9 12.75h.25V13H9v-.25zM9.25 12.5h.25v.25h-.25v-.25zM9.5 12.75h.25V13H9.5v-.25zM9.75 12.5H10v.25h-.25v-.25zM8 13.25h.25v.25H8v-.25zM8.25 13h.25v.25h-.25V13zM8.5 13.25h.25v.25H8.5v-.25zM8.75 13H9v.25h-.25V13zM8 13.75h.25V14H8v-.25zM8.25 13.5h.25v.25h-.25v-.25zM8.5 13.75h.25V14H8.5v-.25zM8.75 13.5H9v.25h-.25v-.25zM9 13.25h.25v.25H9v-.25zM9.25 13h.25v.25h-.25V13zM9.5 13.25h.25v.25H9.5v-.25zM9.75 13H10v.25h-.25V13zM9 13.75h.25V14H9v-.25zM9.25 13.5h.25v.25h-.25v-.25zM9.5 13.75h.25V14H9.5v-.25zM9.75 13.5H10v.25h-.25v-.25zM10 13.25h.25v.25H10v-.25zM10.25 13h.25v.25h-.25V13zM10.5 13.25h.25v.25h-.25v-.25zM10 13.75h.25V14H10v-.25zM10.25 13.5h.25v.25h-.25v-.25zM10.5 13.75h.25V14h-.25v-.25zM8 14.25h.25v.25H8v-.25zM8.25 14h.25v.25h-.25V14zM8.5 14.25h.25v.25H8.5v-.25zM8.75 14H9v.25h-.25V14zM8.25 14.5h.25v.25h-.25v-.25zM8.75 14.5H9v.25h-.25v-.25zM9 14.25h.25v.25H9v-.25zM9.25 14h.25v.25h-.25V14zM9.5 14.25h.25v.25H9.5v-.25zM9.75 14H10v.25h-.25V14zM9.25 14.5h.25v.25h-.25v-.25zM9.75 14.5H10v.25h-.25v-.25zM10 14.25h.25v.25H10v-.25zM10.25 14h.25v.25h-.25V14zM10.5 14.25h.25v.25h-.25v-.25zM10.25 14.5h.25v.25h-.25v-.25zM5.25 5h.25v.25h-.25V5zM5.5 5.25h.25v.25H5.5v-.25zM5.75 5H6v.25h-.25V5zM5.25 5.5h.25v.25h-.25V5.5zM5.5 5.75h.25V6H5.5v-.25zM5.75 5.5H6v.25h-.25V5.5zM6 5.25h.25v.25H6v-.25zM6.25 5h.25v.25h-.25V5zM6.5 5.25h.25v.25H6.5v-.25zM6.75 5H7v.25h-.25V5zM6 5.75h.25V6H6v-.25zM6.25 5.5h.25v.25h-.25V5.5zM6.5 5.75h.25V6H6.5v-.25zM6.75 5.5H7v.25h-.25V5.5zM7 5.25h.25v.25H7v-.25zM7.25 5h.25v.25h-.25V5zM7.5 5.25h.25v.25H7.5v-.25zM7.75 5H8v.25h-.25V5zM7 5.75h.25V6H7v-.25zM7.25 5.5h.25v.25h-.25V5.5zM7.5 5.75h.25V6H7.5v-.25zM7.75 5.5H8v.25h-.25V5.5zM5.5 7.25h.25v.25H5.5v-.25zM5.75 7H6v.25h-.25V7zM5.25 7.5h.25v.25h-.25V7.5zM5.5 7.75h.25V8H5.5v-.25zM5.75 7.5H6v.25h-.25V7.5zM6 6.25h.25v.25H6v-.25zM6.25 6h.25v.25h-.25V6zM6.5 6.25h.25v.25H6.5v-.25zM6.75 6H7v.25h-.25V6zM6 6.75h.25V7H6v-.25zM6.25 6.5h.25v.25h-.25V6.5zM6.5 6.75h.25V7H6.5v-.25zM6.75 6.5H7v.25h-.25V6.5zM7 6.25h.25v.25H7v-.25zM7.25 6h.25v.25h-.25V6zM7.5 6.25h.25v.25H7.5v-.25zM7.75 6H8v.25h-.25V6zM7 6.75h.25V7H7v-.25zM7.25 6.5h.25v.25h-.25V6.5zM7.5 6.75h.25V7H7.5v-.25zM7.75 6.5H8v.25h-.25V6.5zM6 7.25h.25v.25H6v-.25zM6.25 7h.25v.25h-.25V7zM6.5 7.25h.25v.25H6.5v-.25zM6.75 7H7v.25h-.25V7zM6 7.75h.25V8H6v-.25zM6.25 7.5h.25v.25h-.25V7.5zM6.5 7.75h.25V8H6.5v-.25zM6.75 7.5H7v.25h-.25V7.5zM7 7.25h.25v.25H7v-.25zM7.25 7h.25v.25h-.25V7zM7.5 7.25h.25v.25H7.5v-.25zM7.75 7H8v.25h-.25V7zM7 7.75h.25V8H7v-.25zM7.25 7.5h.25v.25h-.25V7.5zM7.5 7.75h.25V8H7.5v-.25zM7.75 7.5H8v.25h-.25V7.5zM8 5.25h.25v.25H8v-.25zM8.25 5h.25v.25h-.25V5zM8.5 5.25h.25v.25H8.5v-.25zM8.75 5H9v.25h-.25V5zM8 5.75h.25V6H8v-.25zM8.25 5.5h.25v.25h-.25V5.5zM8.5 5.75h.25V6H8.5v-.25zM8.75 5.5H9v.25h-.25V5.5zM9 5.25h.25v.25H9v-.25zM9.25 5h.25v.25h-.25V5zM9.5 5.25h.25v.25H9.5v-.25zM9.75 5H10v.25h-.25V5zM9 5.75h.25V6H9v-.25zM9.25 5.5h.25v.25h-.25V5.5zM9.5 5.75h.25V6H9.5v-.25zM9.75 5.5H10v.25h-.25V5.5zM10 5.25h.25v.25H10v-.25zM10.25 5h.25v.25h-.25V5zM10.5 5.25h.25v.25h-.25v-.25zM10 5.75h.25V6H10v-.25zM10.25 5.5h.25v.25h-.25V5.5zM8 6.25h.25v.25H8v-.25zM8.25 6h.25v.25h-.25V6zM8.5 6.25h.25v.25H8.5v-.25zM8.75 6H9v.25h-.25V6zM8 6.75h.25V7H8v-.25zM8.25 6.5h.25v.25h-.25V6.5zM8.5 6.75h.25V7H8.5v-.25zM8.75 6.5H9v.25h-.25V6.5zM9 6.25h.25v.25H9v-.25zM9.25 6h.25v.25h-.25V6zM9.5 6.25h.25v.25H9.5v-.25zM9.75 6H10v.25h-.25V6zM9 6.75h.25V7H9v-.25zM9.25 6.5h.25v.25h-.25V6.5zM9.5 6.75h.25V7H9.5v-.25zM9.75 6.5H10v.25h-.25V6.5zM8 7.25h.25v.25H8v-.25zM8.25 7h.25v.25h-.25V7zM8.5 7.25h.25v.25H8.5v-.25zM8.75 7H9v.25h-.25V7zM8 7.75h.25V8H8v-.25zM8.25 7.5h.25v.25h-.25V7.5zM8.5 7.75h.25V8H8.5v-.25zM8.75 7.5H9v.25h-.25V7.5zM9 7.25h.25v.25H9v-.25zM9.25 7h.25v.25h-.25V7zM9.5 7.25h.25v.25H9.5v-.25zM9.75 7H10v.25h-.25V7zM9 7.75h.25V8H9v-.25zM9.25 7.5h.25v.25h-.25V7.5zM9.5 7.75h.25V8H9.5v-.25zM9.75 7.5H10v.25h-.25V7.5zM10 7.25h.25v.25H10v-.25zM10.25 7h.25v.25h-.25V7zM10.5 7.25h.25v.25h-.25v-.25zM10 7.75h.25V8H10v-.25zM10.25 7.5h.25v.25h-.25V7.5zM10.5 7.75h.25V8h-.25v-.25z"
});

function SvgBottle4(props) {
  return /*#__PURE__*/createElement("svg", _extends$3b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3b, _ref2$w);
}

function _extends$3c() { _extends$3c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

var _ref$3c = /*#__PURE__*/createElement("path", {
  d: "M15.853.854A.499.499 0 0015.5 0c-2.356 0-4.47.275-6.284.818-1.94.58-3.598 1.484-4.926 2.686l-.041.037L1.707.999H2.5a.5.5 0 000-1H0v2.5a.5.5 0 001 0v-.793l2.542 2.542C2.504 5.387 1.688 6.76 1.108 8.343c-.736 2.011-1.109 4.418-1.109 7.156a.5.5 0 00.854.353l7.146-7.146 3 3v2l2 2v-2.707h2.707l-2-2h-2l-3-3L15.852.853zm-5.649 1.388c1.336-.624 2.682-1.015 4.015-1.168L8 7.293l-2.1-2.1c1.295-1.222 2.774-2.237 4.304-2.951zm-9.13 11.977c.153-1.333.544-2.679 1.168-4.015.714-1.53 1.729-3.008 2.951-4.304l2.1 2.1-6.219 6.219z"
});

function SvgBow(props) {
  return /*#__PURE__*/createElement("svg", _extends$3c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3c);
}

function _extends$3d() { _extends$3d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

var _ref$3d = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2 9a1 1 0 110-2 1 1 0 010 2zm0-4a1 1 0 110-2 1 1 0 010 2zm3 2a1 1 0 110-2 1 1 0 010 2z"
});

function SvgBowling(props) {
  return /*#__PURE__*/createElement("svg", _extends$3d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3d);
}

function _extends$3e() { _extends$3e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

var _ref$3e = /*#__PURE__*/createElement("path", {
  d: "M14.373 6.654c-.328-.693-.668-1.41-.668-2.32 0-.362.055-.782.113-1.228.132-1.012.268-2.059-.245-2.663a1.207 1.207 0 00-.646-.392V0h-.383l-.029.001L12.486 0l-.383.001v.05a1.213 1.213 0 00-.646.392c-.513.604-.377 1.651-.245 2.663.058.445.113.866.113 1.228 0 .91-.339 1.627-.668 2.32-.272.574-.551 1.164-.633 1.849-.121-.308-.262-.605-.401-.898-.375-.792-.763-1.611-.763-2.651 0-.413.063-.894.129-1.403.151-1.157.306-2.354-.28-3.043A1.387 1.387 0 007.97.06V.002h-.438l-.033.001-.033-.001-.438.001V.06c-.302.076-.55.226-.739.448-.586.69-.43 1.886-.28 3.043.066.509.129.99.129 1.403 0 1.04-.388 1.859-.763 2.651-.13.275-.262.552-.378.84-.09-.66-.362-1.233-.626-1.791-.328-.693-.668-1.41-.668-2.32 0-.362.055-.782.113-1.228.132-1.012.268-2.059-.245-2.663a1.207 1.207 0 00-.646-.392V0h-.383l-.029.001L2.484 0l-.383.001v.05a1.213 1.213 0 00-.646.392c-.513.604-.377 1.651-.245 2.663.058.445.113.866.113 1.228 0 .91-.339 1.627-.668 2.32-.323.682-.657 1.388-.657 2.247 0 1.666.705 3.824.895 4.254.183.416.645.714 1.224.811V14H2.526l.383-.001v-.033c.579-.096 1.041-.395 1.224-.811.102-.233.355-.97.566-1.861.207 1.643.77 3.341.946 3.74.209.475.737.817 1.399.927V16h.468l.438-.001v-.038c.662-.11 1.19-.451 1.399-.927.179-.406.759-2.157.956-3.827.215.93.481 1.707.587 1.947.183.416.645.714 1.224.811v.034H12.525l.383-.001v-.033c.58-.096 1.041-.395 1.224-.811.19-.431.895-2.589.895-4.254 0-.859-.334-1.565-.658-2.247zM6.958 1.073c.068-.079.195-.186.524-.197h.038c.328.011.456.118.524.197.283.333.23 1.131.134 1.927H6.824c-.096-.796-.149-1.594.134-1.927zM7.986 5h-.971l.001-.047c0-.3-.028-.624-.066-.953h1.102a8.49 8.49 0 00-.065 1zm.565 9.682c-.092.209-.488.435-1.042.442h-.02c-.553-.007-.95-.233-1.042-.442-.193-.439-.949-2.77-.949-4.509 0-.785.324-1.469.667-2.194.277-.585.58-1.225.738-1.979h1.189c.158.754.461 1.394.738 1.979.343.724.667 1.409.667 2.194 0 1.739-.756 4.071-.949 4.509z"
});

function SvgBowling2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3e);
}

function _extends$3f() { _extends$3f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

var _ref$3f = /*#__PURE__*/createElement("path", {
  d: "M14.331 2.783a.5.5 0 00-.624-.126L9.313 5.001H6.688L2.294 2.657a.5.5 0 00-.624.126C.593 4.112.001 5.787.001 7.5s.593 3.388 1.669 4.717a.499.499 0 00.624.126l4.394-2.344h2.625l4.394 2.344a.502.502 0 00.624-.126C15.408 10.888 16 9.213 16 7.5s-.593-3.388-1.669-4.717zM2.199 11.261A6.523 6.523 0 011.02 8h2.481a.5.5 0 000-1H1.02a6.526 6.526 0 011.179-3.261L6 5.766v3.467L2.199 11.26zm11.602 0L10 9.234V5.767l3.801-2.027a6.523 6.523 0 011.179 3.261h-2.481a.5.5 0 000 1h2.481a6.526 6.526 0 01-1.179 3.261z"
});

function SvgBowtie(props) {
  return /*#__PURE__*/createElement("svg", _extends$3f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3f);
}

function _extends$3g() { _extends$3g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

var _ref$3g = /*#__PURE__*/createElement("path", {
  d: "M13 1H3L0 4v10.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V4l-3-3zM8 13L3 9h3V6h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1H2.414z"
});

function SvgBoxAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$3g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3g);
}

function _extends$3h() { _extends$3h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

var _ref$3h = /*#__PURE__*/createElement("path", {
  d: "M13 1H3L0 4v10.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V4l-3-3zm-3 9v3H6v-3H3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1H2.414z"
});

function SvgBoxRemove(props) {
  return /*#__PURE__*/createElement("svg", _extends$3h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3h);
}

function _extends$3i() { _extends$3i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

var _ref$3i = /*#__PURE__*/createElement("path", {
  d: "M1 2h14v2H1zm1 12h12V5H2v9zm4-8h4v1H6V6z"
});

function SvgBox(props) {
  return /*#__PURE__*/createElement("svg", _extends$3i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3i);
}

function _extends$3j() { _extends$3j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

var _ref$3j = /*#__PURE__*/createElement("path", {
  d: "M12.5 16a.5.5 0 01-.5-.5V15c0-3.074.921-4.141 1.734-5.083C14.413 9.13 15 8.451 15 6.5 15 3.467 12.308 1 9 1S3 3.467 3 6.5V7a.487.487 0 01-.019.137L2.163 10H3.5a.5.5 0 01.5.5v2c0 .224.276.5.5.5h2a.5.5 0 01.5.5v2a.5.5 0 01-1 0V14H4.5c-.771 0-1.5-.729-1.5-1.5V11H1.5a.5.5 0 01-.481-.637L2 6.93V6.5c0-1.744.733-3.381 2.065-4.61C5.385.671 7.138 0 9 0s3.615.671 4.935 1.89C15.266 3.119 16 4.756 16 6.5c0 2.323-.767 3.212-1.509 4.071C13.724 11.459 13 12.298 13 15v.5a.5.5 0 01-.5.5z"
});

var _ref2$x = /*#__PURE__*/createElement("path", {
  d: "M9 2.5c-2.209 0-4 1.231-4 2.75v.25A2.5 2.5 0 007.5 8h1.768A1.999 1.999 0 0013 7V5.25c0-1.519-1.791-2.75-4-2.75z"
});

function SvgBrain(props) {
  return /*#__PURE__*/createElement("svg", _extends$3j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3j, _ref2$x);
}

function _extends$3k() { _extends$3k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

var _ref$3k = /*#__PURE__*/createElement("path", {
  d: "M13 2H4c-.816 0-1.556.327-2.097.857L.833 3.928A2.987 2.987 0 000 6c0 .874.382 1.678 1 2.233V15.5a.5.5 0 00.5.5h12a.499.499 0 00.354-.147l.999-.999A.499.499 0 0015 14.5V7.233c.618-.555 1-1.359 1-2.233 0-1.654-1.346-3-3-3zm-.599 5.96a.5.5 0 00.198.98c.137-.028.271-.066.401-.111V15H2V8.828c.128.045.26.083.396.111a.5.5 0 10.2-.98A2.01 2.01 0 011 6c0-1.103.897-2 2-2h9c1.103 0 2 .897 2 2 0 .948-.673 1.772-1.599 1.96z"
});

var _ref2$y = /*#__PURE__*/createElement("path", {
  d: "M4 5.5a.5.5 0 11-1 0 .5.5 0 011 0zM4 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM7 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM5 10.5a.5.5 0 11-1 0 .5.5 0 011 0zM8 9.5a.5.5 0 11-1 0 .5.5 0 011 0zM11 10.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 7.5a.5.5 0 11-1 0 .5.5 0 011 0zM8 12.5a.5.5 0 11-1 0 .5.5 0 011 0zM12 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM12 5.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgBread(props) {
  return /*#__PURE__*/createElement("svg", _extends$3k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3k, _ref2$y);
}

function _extends$3l() { _extends$3l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

var _ref$3l = /*#__PURE__*/createElement("path", {
  d: "M3.414 10H7V9h2v1h3.586L16 6.586V5c0-.55-.45-1-1-1h-3l-2-2H6L4 4H1c-.55 0-1 .45-1 1v1.586L3.414 10zm3-7h3.172l1 1H5.414l1-1zM13 11H9v1H7v-1H3L0 8v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8l-3 3z"
});

function SvgBriefcase(props) {
  return /*#__PURE__*/createElement("svg", _extends$3l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3l);
}

function _extends$3m() { _extends$3m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }

var _ref$3m = /*#__PURE__*/createElement("path", {
  d: "M14.5 5H11V3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2H1.5C.675 5 0 5.675 0 6.5v7c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-7c0-.825-.675-1.5-1.5-1.5zM6 3.002L6.002 3h3.996l.002.002V5H6V3.002z"
});

function SvgBriefcase2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3m);
}

function _extends$3n() { _extends$3n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }

var _ref$3n = /*#__PURE__*/createElement("path", {
  d: "M15 4h-4V3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-9-.998L6.002 3h3.996l.002.002V4H6v-.998zM15 8h-2v1.5c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5V8H5v1.5c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5V8H1V7h14v1z"
});

function SvgBriefcase3(props) {
  return /*#__PURE__*/createElement("svg", _extends$3n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3n);
}

function _extends$3o() { _extends$3o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }

var _ref$3o = /*#__PURE__*/createElement("path", {
  d: "M8 4a4 4 0 100 8 4 4 0 000-8zm0 6.5v-5c1.379 0 2.5 1.122 2.5 2.5S9.379 10.5 8 10.5zM8 13a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zM8 3a1 1 0 01-1-1V1a1 1 0 012 0v1a1 1 0 01-1 1zm7 4a1 1 0 010 2h-1a1 1 0 010-2h1zM3 8a1 1 0 01-1 1H1a1 1 0 010-2h1a1 1 0 011 1zm9.95 3.536l.707.707a1 1 0 01-1.414 1.414l-.707-.707a1 1 0 011.414-1.414zm-9.9-7.072l-.707-.707a.999.999 0 111.414-1.414l.707.707A.999.999 0 113.05 4.464zm9.9 0a.999.999 0 11-1.414-1.414l.707-.707a.999.999 0 111.414 1.414l-.707.707zm-9.9 7.072a1 1 0 011.414 1.414l-.707.707a1 1 0 01-1.414-1.414l.707-.707z"
});

function SvgBrightnessContrast(props) {
  return /*#__PURE__*/createElement("svg", _extends$3o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3o);
}

function _extends$3p() { _extends$3p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }

var _ref$3p = /*#__PURE__*/createElement("path", {
  d: "M8 6.594c-.775 0-1.406.631-1.406 1.406S7.225 9.406 8 9.406c.775 0 1.406-.631 1.406-1.406S8.775 6.594 8 6.594zM8 5a3 3 0 110 6 3 3 0 010-6zm6.707 8.293a.999.999 0 11-1.414 1.414l-2-2a.999.999 0 111.414-1.414l2 2zm-10-10a.999.999 0 11-1.414 1.414l-2-2a.999.999 0 111.414-1.414l2 2zm8.586-2a.999.999 0 111.414 1.414l-2 2a.999.999 0 11-1.414-1.414l2-2zm-10 10a.999.999 0 111.414 1.414l-2 2a.999.999 0 11-1.414-1.414l2-2zM8 0a1 1 0 011 1v2a1 1 0 01-2 0V1a1 1 0 011-1zm0 12a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zM0 8a1 1 0 011-1h2a1 1 0 010 2H1a1 1 0 01-1-1zm12 0a1 1 0 011-1h2a1 1 0 010 2h-2a1 1 0 01-1-1z"
});

function SvgBrightnessHigh(props) {
  return /*#__PURE__*/createElement("svg", _extends$3p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3p);
}

function _extends$3q() { _extends$3q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }

var _ref$3q = /*#__PURE__*/createElement("path", {
  d: "M7 3a1 1 0 112 0 1 1 0 01-2 0zM3 4a1 1 0 112 0 1 1 0 01-2 0zm4 9a1 1 0 112 0 1 1 0 01-2 0zm4-1a1 1 0 112 0 1 1 0 01-2 0zM2 8a1 1 0 112 0 1 1 0 01-2 0zm10 0a1 1 0 112 0 1 1 0 01-2 0zm-1-4a1 1 0 112 0 1 1 0 01-2 0zm-8 8a1 1 0 112 0 1 1 0 01-2 0zm5-7a3 3 0 100 6 3 3 0 000-6zm0 4.406c-.775 0-1.406-.631-1.406-1.406S7.225 6.594 8 6.594c.775 0 1.406.631 1.406 1.406S8.775 9.406 8 9.406z"
});

function SvgBrightnessLow(props) {
  return /*#__PURE__*/createElement("svg", _extends$3q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3q);
}

function _extends$3r() { _extends$3r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }

var _ref$3r = /*#__PURE__*/createElement("path", {
  d: "M8 6.594c-.775 0-1.406.631-1.406 1.406S7.225 9.406 8 9.406c.775 0 1.406-.631 1.406-1.406S8.775 6.594 8 6.594zM8 5a3 3 0 110 6 3 3 0 010-6zm5.707 7.293a.999.999 0 11-1.414 1.414l-1-1a.999.999 0 111.414-1.414l1 1zm-9-9a.999.999 0 11-1.414 1.414l-1-1a.999.999 0 111.414-1.414l1 1zm7.586-1a.999.999 0 111.414 1.414l-1 1a.999.999 0 11-1.414-1.414l1-1zm-9 9a.999.999 0 111.414 1.414l-1 1a.999.999 0 11-1.414-1.414l1-1zM8 1a1 1 0 011 1v1a1 1 0 01-2 0V2a1 1 0 011-1zm0 11a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zM1 8a1 1 0 011-1h1a1 1 0 010 2H2a1 1 0 01-1-1zm11 0a1 1 0 011-1h1a1 1 0 010 2h-1a1 1 0 01-1-1z"
});

function SvgBrightnessMedium(props) {
  return /*#__PURE__*/createElement("svg", _extends$3r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3r);
}

function _extends$3s() { _extends$3s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }

var _ref$3s = /*#__PURE__*/createElement("path", {
  d: "M15.707.293a.999.999 0 00-1.414 0l-3.75 3.75L9.5 3l-2 1.738L.399 6.899A.563.563 0 000 7.437v.5c0 2.154.839 4.178 2.361 5.701s3.547 2.361 5.701 2.361h.5A.562.562 0 009.1 15.6l2.161-7.101 1.738-2-1.043-1.043 3.75-3.75a.999.999 0 000-1.414zM8.146 14.875h-.083a6.945 6.945 0 01-2.398-.424L8.001 9l-3.876 4.651c-.343-.237-.667-.507-.967-.808s-.57-.625-.808-.967L7.001 8 1.55 10.336a6.93 6.93 0 01-.424-2.398v-.083L8.403 5.64l1.959 1.959-2.215 7.277z"
});

function SvgBroom(props) {
  return /*#__PURE__*/createElement("svg", _extends$3s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3s);
}

function _extends$3t() { _extends$3t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }

var _ref$3t = /*#__PURE__*/createElement("path", {
  d: "M3.45 15.992c-1.856 0-3.204-1.056-3.261-1.101A.5.5 0 01.5 14c1.49 0 1.838-.801 2.279-1.815C3.203 11.212 3.73 10 5.5 10c.668 0 1.295.26 1.767.732s.732 1.1.732 1.768c0 .668-.26 1.296-.732 1.768-1.144 1.144-2.429 1.724-3.818 1.724zM15.662.251a1.003 1.003 0 00-1.414.087L6.683 8.899a1.746 1.746 0 00-.297.472 3.234 3.234 0 011.413.83c.402.402.685.89.833 1.422.298-.124.565-.332.76-.618l6.435-9.439a1.003 1.003 0 00-.164-1.315z"
});

function SvgBrush(props) {
  return /*#__PURE__*/createElement("svg", _extends$3t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3t);
}

function _extends$3u() { _extends$3u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }

var _ref$3u = /*#__PURE__*/createElement("path", {
  d: "M8 3.188c.561 0 1.084.165 1.523.449L5.636 7.524a2.795 2.795 0 01-.449-1.523A2.816 2.816 0 018 3.188zM6.477 8.363l3.887-3.887c.284.439.449.962.449 1.523A2.815 2.815 0 018 8.811a2.795 2.795 0 01-1.523-.449zM14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM8 10a4 4 0 110-8 4 4 0 010 8z"
});

function SvgBubbleBlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$3u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3u);
}

function _extends$3v() { _extends$3v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }

var _ref$3v = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM11 4.282L9.282 6 11 7.718V9H9.718L8 7.282 6.282 9H5V7.718L6.718 6 5 4.282V3h1.282L8 4.718 9.718 3H11v1.282z"
});

function SvgBubbleCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$3v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3v);
}

function _extends$3w() { _extends$3w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }

var _ref$3w = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM7 9.414L3.793 5.707l.914-.914L7 6.586l4.293-3.793.914.914L7 9.414z"
});

function SvgBubbleCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$3w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3w);
}

function _extends$3x() { _extends$3x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }

var _ref$3x = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM5 8a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z"
});

function SvgBubbleDots(props) {
  return /*#__PURE__*/createElement("svg", _extends$3x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3x);
}

function _extends$3y() { _extends$3y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }

var _ref$3y = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM14 9.063a.95.95 0 01-.938.938H1.999V3.938A.95.95 0 012.937 3h10.125a.95.95 0 01.938.938v5.125zM4 7a1 1 0 112 0 1 1 0 01-2 0zm3 0a1 1 0 112 0 1 1 0 01-2 0zm3 0a1 1 0 112 0 1 1 0 01-2 0z"
});

function SvgBubbleDots2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3y);
}

function _extends$3z() { _extends$3z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }

var _ref$3z = /*#__PURE__*/createElement("path", {
  d: "M14.5 1h-13C.675 1 0 1.675 0 2.5v8c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zM6 8H4V6h2v2zm3 0H7V6h2v2zm3 0h-2V6h2v2z"
});

function SvgBubbleDots3(props) {
  return /*#__PURE__*/createElement("svg", _extends$3z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3z);
}

function _extends$3A() { _extends$3A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }

var _ref$3A = /*#__PURE__*/createElement("path", {
  d: "M4 6h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zm4.5-5h-13C.675 1 0 1.675 0 2.5v8c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zm-.5 9H8.076L5 12.73V10H2V3h12v7z"
});

function SvgBubbleDots4(props) {
  return /*#__PURE__*/createElement("svg", _extends$3A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3A);
}

function _extends$3B() { _extends$3B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }

var _ref$3B = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM3 10H2V2h1v8zm11-3H8v3.5L3.5 6 8 1.5V5h6v2z"
});

function SvgBubbleFirst(props) {
  return /*#__PURE__*/createElement("svg", _extends$3B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3B);
}

function _extends$3C() { _extends$3C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }

var _ref$3C = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM3 9c0-2.209 2.237-4 4.996-4V1.5l4.5 4.5-4.5 4.5V7.108c-1.528-.309-3.02.042-3.987 1.092a3.638 3.638 0 00-.877 1.719A3.234 3.234 0 013 9.001z"
});

function SvgBubbleForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$3C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3C);
}

function _extends$3D() { _extends$3D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }

var _ref$3D = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM3.132 2.082c.138.641.427 1.23.877 1.719.967 1.05 2.459 1.401 3.987 1.092V1.501l4.5 4.5-4.5 4.5v-3.5C5.237 7.001 3 5.21 3 3.001c0-.316.046-.623.132-.918z"
});

function SvgBubbleForward2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3D);
}

function _extends$3E() { _extends$3E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }

var _ref$3E = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm-3 6.494l-.004.004C11.421 6.586 8 10 8 10S4.582 6.589 4.512 6.508l-.006-.006h.001A2.124 2.124 0 118 4.125a2.125 2.125 0 113.5 2.369z"
});

function SvgBubbleHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$3E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3E);
}

function _extends$3F() { _extends$3F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }

var _ref$3F = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM8 10.5V7H2V5h6V1.5L12.5 6 8 10.5zm6-.5h-1V2h1v8z"
});

function SvgBubbleLast(props) {
  return /*#__PURE__*/createElement("svg", _extends$3F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3F);
}

function _extends$3G() { _extends$3G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }

var _ref$3G = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM13 7H7v3.5L2.5 6 7 1.5V5h6v2z"
});

function SvgBubbleLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$3G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3G);
}

function _extends$3H() { _extends$3H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }

var _ref$3H = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM10 8H4V7h6v1zm2-2H4V5h8v1z"
});

function SvgBubbleLines(props) {
  return /*#__PURE__*/createElement("svg", _extends$3H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3H);
}

function _extends$3I() { _extends$3I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }

var _ref$3I = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM14 9.063a.95.95 0 01-.938.938H1.999V3.938A.95.95 0 012.937 3h10.125a.95.95 0 01.938.938v5.125zM4 5h8v1H4zm0 2h6v1H4z"
});

function SvgBubbleLines2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3I);
}

function _extends$3J() { _extends$3J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }

var _ref$3J = /*#__PURE__*/createElement("path", {
  d: "M14.5 1h-13C.675 1 0 1.675 0 2.5v8c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zM7 9H3V8h4v1zm4-2H3V6h8v1zm2-2H3V4h10v1z"
});

function SvgBubbleLines3(props) {
  return /*#__PURE__*/createElement("svg", _extends$3J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3J);
}

function _extends$3K() { _extends$3K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }

var _ref$3K = /*#__PURE__*/createElement("path", {
  d: "M3 4h10v1H3zm0 2h8v1H3zm0 2h4v1H3zm11.5-7h-13C.675 1 0 1.675 0 2.5v8c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zm-.5 9H8.076L5 12.73V10H2V3h12v7z"
});

function SvgBubbleLines4(props) {
  return /*#__PURE__*/createElement("svg", _extends$3K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3K);
}

function _extends$3L() { _extends$3L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }

var _ref$3L = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM7 9H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3v1H4c-.265 0-.515.105-.705.295S3 5.736 3 6v1c0 .265.105.515.295.705S3.736 8 4 8h3v1zM6 7V6h4v1H6zm8 0c0 1.1-.9 2-2 2H9V8h3c.265 0 .515-.105.705-.295S13 7.264 13 7V6c0-.265-.105-.515-.295-.705S12.265 5 12 5H9V4h3c1.1 0 2 .9 2 2v1z"
});

function SvgBubbleLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$3L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3L);
}

function _extends$3M() { _extends$3M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }

var _ref$3M = /*#__PURE__*/createElement("path", {
  d: "M9 8a1 1 0 11-2 0 1 1 0 012 0zM9 3H7c-.551 0-1 .449-1 1v1h4V4c0-.551-.449-1-1-1z"
});

var _ref2$z = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM12 9.25c0 .412-.338.75-.75.75h-6.5A.753.753 0 014 9.25v-3.5c0-.412.338-.75.75-.75H5V4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v1h.25c.412 0 .75.338.75.75v3.5z"
});

function SvgBubbleLock(props) {
  return /*#__PURE__*/createElement("svg", _extends$3M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3M, _ref2$z);
}

function _extends$3N() { _extends$3N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }

var _ref$3N = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM12 7H4V5h8v2z"
});

function SvgBubbleMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$3N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3N);
}

function _extends$3O() { _extends$3O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }

var _ref$3O = /*#__PURE__*/createElement("path", {
  d: "M8 1C3.582 1 0 3.91 0 7.5c0 2.04 1.157 3.86 2.966 5.052.022.146.034.296.034.448 0 1.092-.929 2.048-2 2.572v.421c1.983-.045 4.034-.353 5.753-2.072.406.052.823.079 1.247.079 4.418 0 8-2.91 8-6.5S12.418 1 8 1zm1 10H7V9h2v2zm0-3H7V4h2v4z"
});

function SvgBubbleNotification(props) {
  return /*#__PURE__*/createElement("svg", _extends$3O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3O);
}

function _extends$3P() { _extends$3P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }

var _ref$3P = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM9 10H7V8h2v2zm0-4H7V2h2v4z"
});

function SvgBubbleNotification2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3P);
}

function _extends$3Q() { _extends$3Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }

var _ref$3Q = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM14 5c0 1.1-.9 2-2 2H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h5.5a.5.5 0 010 1H5.002L5 5.002v.996L5.002 6H12c.265 0 .515-.105.705-.295S13 5.265 13 5V4c0-.265-.105-.515-.295-.705S12.265 3 12 3H4c-.265 0-.515.105-.705.295S3 3.736 3 4v3c0 .265.105.515.295.705S3.736 8 4 8h6.5a.5.5 0 010 1H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v1z"
});

function SvgBubblePaperclip(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3Q);
}

function _extends$3R() { _extends$3R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }

var _ref$3R = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM12 7H9v3H7V7H4V5h3V2h2v3h3v2z"
});

function SvgBubblePlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$3R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3R);
}

function _extends$3S() { _extends$3S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }

var _ref$3S = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM7 8.25c0 .412-.338.75-.75.75h-2.5A.752.752 0 013 8.25V3l2-1.5V5h1.25c.412 0 .75.338.75.75v2.5zm6 0c0 .412-.338.75-.75.75h-2.5A.753.753 0 019 8.25V3l2-1.5V5h1.25c.412 0 .75.338.75.75v2.5z"
});

function SvgBubbleQuote(props) {
  return /*#__PURE__*/createElement("svg", _extends$3S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3S);
}

function _extends$3T() { _extends$3T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }

var _ref$3T = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm-1.636 9.918a3.642 3.642 0 00-.877-1.719C11.02 7.149 9.528 6.798 8 7.107v3.392l-4.5-4.5 4.5-4.5v3.5c2.759 0 4.996 1.791 4.996 4 0 .316-.046.623-.133.918z"
});

function SvgBubbleReply(props) {
  return /*#__PURE__*/createElement("svg", _extends$3T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3T);
}

function _extends$3U() { _extends$3U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }

var _ref$3U = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm-1.504 3c0 2.209-2.237 4-4.996 4v3.5L3.5 6 8 1.5v3.392c1.528.309 3.02-.042 3.987-1.092.45-.488.739-1.078.877-1.719.087.295.133.602.133.918z"
});

function SvgBubbleReply2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3U);
}

function _extends$3V() { _extends$3V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }

var _ref$3V = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM3 5h6V1.5L13.5 6 9 10.5V7H3V5z"
});

function SvgBubbleRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$3V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3V);
}

function _extends$3W() { _extends$3W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }

var _ref$3W = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM5 3a1 1 0 110 2 1 1 0 010-2zm3 7a4.002 4.002 0 01-3.874-3h7.748A4.002 4.002 0 018 10zm3-5a1 1 0 110-2 1 1 0 010 2z"
});

function SvgBubbleSmiley(props) {
  return /*#__PURE__*/createElement("svg", _extends$3W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3W);
}

function _extends$3X() { _extends$3X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }

var _ref$3X = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm-3.375 10.688L8 8.122l-3.125 2.566 1.137-3.666L3 4.997h3.771L8 1.09l1.229 3.907H13L9.988 7.022l1.137 3.666z"
});

function SvgBubbleStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$3X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3X);
}

function _extends$3Y() { _extends$3Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }

var _ref$3Y = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM8 2.005a1.995 1.995 0 110 3.99 1.995 1.995 0 010-3.99zM11 10H5V9a2 2 0 012-2h2a2 2 0 012 2v1z"
});

function SvgBubbleUser(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3Y);
}

function _extends$3Z() { _extends$3Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }

var _ref$3Z = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM13 8c0 .55-.36.73-.8.4L10 6v2c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v2l2.2-2.4c.44-.33.8-.15.8.4v4z"
});

function SvgBubbleVideo(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3Z);
}

function _extends$3_() { _extends$3_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }

var _ref$3_ = /*#__PURE__*/createElement("path", {
  d: "M8 1c4.418 0 8 2.91 8 6.5S12.418 14 8 14c-.424 0-.841-.027-1.247-.079-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.157 11.36 0 9.54 0 7.5 0 3.91 3.582 1 8 1z"
});

function SvgBubble(props) {
  return /*#__PURE__*/createElement("svg", _extends$3_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3_);
}

function _extends$3$() { _extends$3$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }

var _ref$3$ = /*#__PURE__*/createElement("path", {
  d: "M8 3c-.858 0-1.687.135-2.464.402-.73.251-1.38.605-1.932 1.054C2.569 5.297 2 6.378 2 7.5c0 .63.175 1.24.52 1.815.356.592.89 1.134 1.547 1.566.474.312.793.812.878 1.373.028.187.046.376.053.564.117-.097.23-.201.342-.312a2 2 0 011.666-.57c.328.042.662.063.995.063.858 0 1.687-.135 2.464-.402a6.278 6.278 0 001.932-1.054c1.035-.841 1.604-1.922 1.604-3.044s-.57-2.203-1.604-3.044a6.299 6.299 0 00-1.932-1.054 7.563 7.563 0 00-2.464-.402zm0-2c4.418 0 8 2.91 8 6.5S12.418 14 8 14c-.424 0-.841-.027-1.247-.079-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.157 11.36 0 9.54 0 7.5 0 3.91 3.582 1 8 1z"
});

function SvgBubble2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$3$);
}

function _extends$40() { _extends$40 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }

var _ref$40 = /*#__PURE__*/createElement("path", {
  d: "M13.063 1a2.947 2.947 0 012.938 2.938v5.125a2.947 2.947 0 01-2.938 2.938H3l-3 3V3.938A2.947 2.947 0 012.938 1h10.125z"
});

function SvgBubble3(props) {
  return /*#__PURE__*/createElement("svg", _extends$40({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$40);
}

function _extends$41() { _extends$41 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }

var _ref$41 = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM14 9.063a.95.95 0 01-.938.938H1.999V3.938A.95.95 0 012.937 3h10.125a.95.95 0 01.938.938v5.125z"
});

function SvgBubble4(props) {
  return /*#__PURE__*/createElement("svg", _extends$41({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$41);
}

function _extends$42() { _extends$42 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }

var _ref$42 = /*#__PURE__*/createElement("path", {
  d: "M13.063 1H2.938A2.947 2.947 0 000 3.938v11.063l3-3h10.063a2.947 2.947 0 002.938-2.938V3.938A2.947 2.947 0 0013.063 1zM14 3.938v.188H2v-.188l.002-.063h11.995l.002.063zm-.002 5.187H2v-.25h12v.188l-.002.063zM2 10v-.125h11.522a.919.919 0 01-.46.125H1.999zm0-.375v-.25h11.944a.954.954 0 01-.138.25H2zm0-1v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zm0-.5v-.25h12v.25H2zM13.063 3c.166 0 .323.046.46.125H2.479A.919.919 0 012.939 3h10.125zm.743.375c.058.076.105.16.138.25H2.056a.954.954 0 01.138-.25h11.613z"
});

function SvgBubble5(props) {
  return /*#__PURE__*/createElement("svg", _extends$42({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$42);
}

function _extends$43() { _extends$43 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }

var _ref$43 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0c.825 0 1.5.675 1.5 1.5v10c0 .825-.675 1.5-1.5 1.5h-4.429L7.5 16l-2.571-3H1.5C.675 13 0 12.325 0 11.5v-10C0 .675.675 0 1.5 0h13z"
});

function SvgBubble6(props) {
  return /*#__PURE__*/createElement("svg", _extends$43({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$43);
}

function _extends$44() { _extends$44 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }

var _ref$44 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v10c0 .825.675 1.5 1.5 1.5h3.429L7.5 16l2.571-3H14.5c.825 0 1.5-.675 1.5-1.5v-10c0-.825-.675-1.5-1.5-1.5zM14 11H9.652L7.5 13.427 5.348 11H2V2h12v9z"
});

function SvgBubble7(props) {
  return /*#__PURE__*/createElement("svg", _extends$44({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$44);
}

function _extends$45() { _extends$45 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }

var _ref$45 = /*#__PURE__*/createElement("path", {
  d: "M14.5 1c.825 0 1.5.675 1.5 1.5v8c0 .825-.675 1.5-1.5 1.5H8.8L4 16v-4H1.5C.675 12 0 11.325 0 10.5v-8C0 1.675.675 1 1.5 1h13z"
});

function SvgBubble8(props) {
  return /*#__PURE__*/createElement("svg", _extends$45({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$45);
}

function _extends$46() { _extends$46 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }

var _ref$46 = /*#__PURE__*/createElement("path", {
  d: "M14.5 1h-13C.675 1 0 1.675 0 2.5v8c0 .825.675 1.5 1.5 1.5H4v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zm-.5 9H8.076L5 12.73V10H2V3h12v7z"
});

function SvgBubble9(props) {
  return /*#__PURE__*/createElement("svg", _extends$46({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$46);
}

function _extends$47() { _extends$47 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }

var _ref$47 = /*#__PURE__*/createElement("path", {
  d: "M17 14.081c0 .711.407 1.327 1 1.628v.249a3.71 3.71 0 01-3.207-1.125 5.03 5.03 0 01-1.293.168c-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4 4.5 1.791 4.5 4c0 .865-.309 1.665-.834 2.32a1.81 1.81 0 00-.166.761zM8 0c4.351 0 7.89 2.822 7.997 6.336a6.123 6.123 0 00-2.497-.524c-1.493 0-2.903.523-3.971 1.472C8.422 8.268 7.812 9.588 7.812 11c0 .698.149 1.373.433 1.997a10.089 10.089 0 01-1.493-.076c-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.156 10.36-.001 8.54-.001 6.5c0-3.59 3.582-6.5 8-6.5z"
});

function SvgBubbles(props) {
  return /*#__PURE__*/createElement("svg", _extends$47({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$47);
}

function _extends$48() { _extends$48 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }

var _ref$48 = /*#__PURE__*/createElement("path", {
  d: "M12.5 0c.825 0 1.5.675 1.5 1.5v5c0 .825-.675 1.5-1.5 1.5H6.8L2 12V8h-.5C.675 8 0 7.325 0 6.5v-5C0 .675.675 0 1.5 0h11zm4 3c.825 0 1.5.675 1.5 1.5v6c0 .825-.675 1.5-1.5 1.5H14v4l-4.8-4H6v-2h3.924L13 12.73V10h3V5h-1V3h1.5z"
});

function SvgBubbles10(props) {
  return /*#__PURE__*/createElement("svg", _extends$48({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$48);
}

function _extends$49() { _extends$49 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }

var _ref$49 = /*#__PURE__*/createElement("path", {
  d: "M7.5 0C11.642 0 15 2.717 15 6.069s-3.358 6.069-7.5 6.069a9.16 9.16 0 01-1.169-.074C4.72 13.669 2.86 13.956 1 13.999v-.393c1.004-.49 1.813-1.382 1.813-2.402 0-.142-.011-.282-.032-.419C1.085 9.672 0 7.973 0 6.068 0 2.716 3.358-.001 7.5-.001zm8.063 13.604c0 .874.567 1.639 1.438 2.059V16c-1.611-.036-3.09-.283-4.487-1.658-.33.041-.669.063-1.013.063-1.492 0-2.866-.402-3.963-1.079 2.261-.008 4.395-.732 6.013-2.042a7.346 7.346 0 001.913-2.302 6.23 6.23 0 00.704-3.4C17.302 6.518 18 7.795 18 9.202c0 1.633-.94 3.089-2.41 4.043a2.361 2.361 0 00-.027.359z"
});

function SvgBubbles2(props) {
  return /*#__PURE__*/createElement("svg", _extends$49({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$49);
}

function _extends$4a() { _extends$4a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }

var _ref$4a = /*#__PURE__*/createElement("path", {
  d: "M17 14.081c0 .711.407 1.327 1 1.628v.249a3.71 3.71 0 01-3.207-1.125 5.03 5.03 0 01-1.293.168c-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4 4.5 1.791 4.5 4c0 .865-.309 1.665-.834 2.32a1.81 1.81 0 00-.166.761zM3.604 3.456C2.569 4.297 2 5.378 2 6.5c0 .63.175 1.24.52 1.815.356.592.89 1.134 1.547 1.566.474.312.793.812.878 1.373.028.187.046.376.053.564.117-.097.23-.201.342-.312a2 2 0 011.666-.57c.327.042.662.063.994.063v2c-.424 0-.84-.027-1.246-.079-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.158 10.359.001 8.539.001 6.499c0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336a6.083 6.083 0 00-2.067-.509c-.18-.876-.709-1.7-1.535-2.371a6.299 6.299 0 00-1.932-1.054C9.687 2.134 8.858 1.999 8 1.999s-1.687.135-2.464.402c-.73.251-1.38.605-1.932 1.054z"
});

function SvgBubbles3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$4a);
}

function _extends$4b() { _extends$4b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }

var _ref$4b = /*#__PURE__*/createElement("path", {
  d: "M7.5 2a7 7 0 00-2.272.369 5.79 5.79 0 00-1.773.963C2.517 4.091 2 5.063 2 6.069c0 .562.157 1.109.467 1.623.323.537.811 1.028 1.41 1.421a2 2 0 01.881 1.374c.014.094.025.188.034.282a3.62 3.62 0 00.127-.122 1.999 1.999 0 011.662-.567c.303.038.611.058.918.058a7 7 0 002.272-.369 5.807 5.807 0 001.774-.963C12.483 8.047 13 7.075 13 6.069s-.517-1.978-1.455-2.737a5.753 5.753 0 00-1.774-.963A7 7 0 007.499 2zm0-2C11.642 0 15 2.717 15 6.069s-3.358 6.069-7.5 6.069a9.16 9.16 0 01-1.169-.074C4.72 13.669 2.86 13.956 1 13.999v-.393c1.004-.49 1.813-1.382 1.813-2.402 0-.142-.011-.282-.032-.419C1.085 9.672 0 7.973 0 6.068 0 2.716 3.358-.001 7.5-.001zm8.063 13.604c0 .874.567 1.639 1.438 2.059V16c-1.611-.036-3.09-.283-4.487-1.658-.33.041-.669.063-1.013.063-1.492 0-2.866-.402-3.963-1.079 2.261-.008 4.395-.732 6.013-2.042a7.346 7.346 0 001.913-2.302 6.23 6.23 0 00.704-3.4C17.302 6.518 18 7.795 18 9.202c0 1.633-.94 3.089-2.41 4.043a2.361 2.361 0 00-.027.359z"
});

function SvgBubbles4(props) {
  return /*#__PURE__*/createElement("svg", _extends$4b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$4b);
}

function _extends$4c() { _extends$4c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }

var _ref$4c = /*#__PURE__*/createElement("path", {
  d: "M12 0c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2H3l-3 3V2C0 .9.9 0 2 0h10zm4 3c1.1 0 2 .9 2 2v11l-3-3H6c-1.1 0-2-.9-2-2v-1h2v.996l.004.004H16V5.004L15.996 5H15V3h1z"
});

function SvgBubbles5(props) {
  return /*#__PURE__*/createElement("svg", _extends$4c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$4c);
}

function _extends$4d() { _extends$4d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4d.apply(this, arguments); }

var _ref$4d = /*#__PURE__*/createElement("path", {
  d: "M16 3c1.1 0 2 .9 2 2v11l-3-3H6c-1.1 0-2-.9-2-2v-1h2v.996l.004.004H16V5.004L15.996 5H15V3h1zm-4-3H2C.9 0 0 .9 0 2v10l3-3h9c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 6.996L11.996 7H2V2.004L2.004 2h9.993l.004.004v4.993z"
});

function SvgBubbles6(props) {
  return /*#__PURE__*/createElement("svg", _extends$4d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$4d);
}

function _extends$4e() { _extends$4e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4e.apply(this, arguments); }

var _ref$4e = /*#__PURE__*/createElement("path", {
  d: "M14.5 3c.825 0 1.5.675 1.5 1.5v7c0 .825-.675 1.5-1.5 1.5h-2.429L9.5 16l-2.571-3H4.5c-.825 0-1.5-.675-1.5-1.5v-7C3 3.675 3.675 3 4.5 3h10zM2 2v8h-.5C.675 10 0 9.325 0 8.5v-7C0 .675.675 0 1.5 0h10c.825 0 1.5.675 1.5 1.5V2H2z"
});

function SvgBubbles7(props) {
  return /*#__PURE__*/createElement("svg", _extends$4e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4e);
}

function _extends$4f() { _extends$4f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4f.apply(this, arguments); }

var _ref$4f = /*#__PURE__*/createElement("path", {
  d: "M14.5 3h-10C3.675 3 3 3.675 3 4.5v7c0 .825.675 1.5 1.5 1.5h2.429L9.5 16l2.571-3H14.5c.825 0 1.5-.675 1.5-1.5v-7c0-.825-.675-1.5-1.5-1.5zm-.5 8h-2.348L9.5 13.427 7.348 11H5V5h9v6zM2 2v8h-.5C.675 10 0 9.325 0 8.5v-7C0 .675.675 0 1.5 0h10c.825 0 1.5.675 1.5 1.5V2H2z"
});

function SvgBubbles8(props) {
  return /*#__PURE__*/createElement("svg", _extends$4f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4f);
}

function _extends$4g() { _extends$4g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4g.apply(this, arguments); }

var _ref$4g = /*#__PURE__*/createElement("path", {
  d: "M12.5 0h-11C.675 0 0 .675 0 1.5v5C0 7.325.675 8 1.5 8H2v4l4.8-4h5.7c.825 0 1.5-.675 1.5-1.5v-5c0-.825-.675-1.5-1.5-1.5zM12 6H6.076L3 8.73V6H2V2h10v4zm4.5-3c.825 0 1.5.675 1.5 1.5v6c0 .825-.675 1.5-1.5 1.5H14v4l-4.8-4H6v-2h3.924L13 12.73V10h3V5h-1V3h1.5z"
});

function SvgBubbles9(props) {
  return /*#__PURE__*/createElement("svg", _extends$4g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$4g);
}

function _extends$4h() { _extends$4h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4h.apply(this, arguments); }

var _ref$4h = /*#__PURE__*/createElement("path", {
  d: "M13.265 5.651c-.312-.134-.745-.252-1.287-.35C10.911 5.107 9.498 5 7.999 5s-2.911.107-3.979.301c-.542.099-.975.216-1.287.35-.488.21-.735.495-.735.849 0 .047.005.092.013.136l.988 7.902c.034.703.988.997 1.709 1.157.885.197 2.053.305 3.29.305s2.406-.108 3.29-.305c.721-.16 1.675-.454 1.709-1.157l.988-7.902a.682.682 0 00.013-.136c0-.354-.247-.639-.735-.849zm-8.726.577C5.503 6.081 6.732 6 8 6s2.497.081 3.461.228c.601.092.984.191 1.223.272-.239.081-.622.18-1.223.272C10.497 6.919 9.268 7 8 7s-2.497-.081-3.461-.228c-.601-.092-.984-.191-1.223-.272.239-.081.622-.18 1.223-.272zm7.471 8.16c-.087.063-.387.235-1.227.39C10.007 14.921 9.019 15 8 15s-2.007-.079-2.783-.222c-.84-.155-1.14-.326-1.227-.39L3.128 7.49c.252.077.551.147.894.209.301.055.629.102.979.143V10a1 1 0 002 0V7.984c.327.011.661.016 1 .016v4.5a.5.5 0 001 0V7.984c.343-.011.677-.028 1-.051V9.5a.5.5 0 001 0V7.842c.35-.04.678-.088.979-.143.343-.062.642-.132.894-.209l-.862 6.898z"
});

var _ref2$A = /*#__PURE__*/createElement("path", {
  d: "M13.696 2.04c-.549-.656-1.284-1.16-2.184-1.498C10.553.182 9.371 0 8 0S5.448.182 4.489.542c-.9.338-1.635.842-2.184 1.498-.89 1.063-1.304 2.48-1.304 4.46a.5.5 0 001 0c0-1.732.34-2.945 1.071-3.818.443-.53 1.022-.923 1.769-1.203.847-.318 1.91-.478 3.16-.478s2.314.161 3.16.478c.747.28 1.325.674 1.769 1.203.731.873 1.071 2.086 1.071 3.818a.5.5 0 001 0c0-1.98-.414-3.397-1.304-4.46z"
});

function SvgBucket(props) {
  return /*#__PURE__*/createElement("svg", _extends$4h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4h, _ref2$A);
}

function _extends$4i() { _extends$4i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4i.apply(this, arguments); }

var _ref$4i = /*#__PURE__*/createElement("path", {
  d: "M13.696 2.04c-.549-.656-1.284-1.16-2.184-1.498C10.553.182 9.371 0 8 0S5.448.182 4.489.542c-.9.338-1.635.842-2.184 1.498-.89 1.063-1.304 2.48-1.304 4.46a.5.5 0 001 0c0-1.732.34-2.945 1.071-3.818.443-.53 1.022-.923 1.769-1.203.847-.318 1.91-.478 3.16-.478s2.314.161 3.16.478c.747.28 1.325.674 1.769 1.203.731.873 1.071 2.086 1.071 3.818a.5.5 0 001 0c0-1.98-.414-3.397-1.304-4.46z"
});

var _ref2$B = /*#__PURE__*/createElement("path", {
  d: "M13.265 5.651c-.312-.134-.745-.252-1.287-.35C10.911 5.107 9.498 5 7.999 5s-2.911.107-3.979.301c-.542.099-.975.216-1.287.35-.488.21-.735.495-.735.849 0 .047.005.092.013.136l.988 7.902c.034.703.988.997 1.709 1.157.885.197 2.053.305 3.29.305s2.406-.108 3.29-.305c.721-.16 1.675-.454 1.709-1.157l.988-7.902a.682.682 0 00.013-.136c0-.354-.247-.639-.735-.849zm-1.804 1.121C10.497 6.919 9.268 7 8 7s-2.497-.081-3.461-.228c-.601-.092-.984-.191-1.223-.272.239-.081.622-.18 1.223-.272C5.503 6.081 6.732 6 8 6s2.497.081 3.461.228c.601.092.984.191 1.223.272-.239.081-.622.18-1.223.272z"
});

function SvgBucket2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4i, _ref2$B);
}

function _extends$4j() { _extends$4j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4j.apply(this, arguments); }

var _ref$4j = /*#__PURE__*/createElement("path", {
  d: "M15 5l1-2V1l-1.5 3h-1.778c-.134-.147-.33-.287-.617-.447L9.894 2.447C9.402 2.201 8.55 2 8 2s-1.403.201-1.894.447L3.895 3.553c-.287.161-.483.301-.617.447H1.5L0 1v2l1 2h2v2L0 8v1l3-1v3H2l-2 5h1l1.6-4h.522c.139.39.383.771.659.992l3.438 2.751c.215.172.498.258.781.258s.566-.086.781-.258l3.438-2.751c.276-.221.52-.602.659-.992h.522l1.6 4h1l-2-5h-1V8l3 1V8l-3-1V5h2zm-6.5 9h-1V4h1v10zM10 1.944V1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v.944c.567-.253 1.415-.444 2-.444s1.433.191 2 .444z"
});

function SvgBug(props) {
  return /*#__PURE__*/createElement("svg", _extends$4j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4j);
}

function _extends$4k() { _extends$4k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4k.apply(this, arguments); }

var _ref$4k = /*#__PURE__*/createElement("path", {
  d: "M16 9V8h-3.02a5.785 5.785 0 00-1.12-3.004h2.53L15.485.617l-.97-.243-.905 3.621h-2.729l-.042-.032A2.996 2.996 0 008.001-.001a2.996 2.996 0 00-2.838 3.964l-.042.032H2.392L1.487.374l-.97.243 1.095 4.379h2.53A5.785 5.785 0 003.022 8H.002v1h3.021c.059.713.242 1.388.526 1.996H1.612L.517 15.375l.97.243.905-3.621h1.756c.917 1.219 2.303 1.996 3.854 1.996s2.937-.777 3.854-1.996h1.756l.905 3.621.97-.243-1.095-4.379h-1.937A5.903 5.903 0 0012.981 9h3.021z"
});

function SvgBug2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4k);
}

function _extends$4l() { _extends$4l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4l.apply(this, arguments); }

var _ref$4l = /*#__PURE__*/createElement("path", {
  d: "M16 6.707C16 3.568 15.081 1.02 13.946 1h.014-1.296S9.62 3.287 5.239 4.184c-.134.708-.219 1.551-.219 2.523s.085 1.816.219 2.523c4.382.897 7.425 3.184 7.425 3.184h1.296l-.014-.001C15.082 12.393 16 9.846 16 6.706zm-2.487 4.844c-.147 0-.305-.152-.387-.243-.197-.22-.387-.562-.55-.989-.363-.957-.564-2.239-.564-3.611s.2-2.655.564-3.611c.162-.428.353-.77.55-.99.081-.091.24-.243.387-.243s.305.152.387.243c.197.22.387.562.55.99.363.957.564 2.239.564 3.611s-.2 2.655-.564 3.611c-.162.428-.353.77-.55.989-.081.091-.24.243-.387.243zM3.935 6.707c0-.812.06-1.6.173-2.33-.74.102-1.39.161-2.193.161H.867L0 6.017v1.378l.867 1.479h1.048c.803 0 1.453.059 2.193.161a15.326 15.326 0 01-.173-2.33zm1.817 3.327l-2-.383 1.279 5.024c.066.26.324.391.573.291l1.852-.741a.427.427 0 00.222-.611l-1.926-3.581zm7.761-1.46c-.057 0-.118-.059-.149-.094a1.268 1.268 0 01-.212-.381c-.14-.369-.217-.863-.217-1.392s.077-1.023.217-1.392c.063-.165.136-.297.212-.381.031-.035.092-.094.149-.094s.118.059.149.094c.076.085.149.217.212.381.14.369.217.863.217 1.392s-.077 1.023-.217 1.392a1.243 1.243 0 01-.212.381c-.031.035-.092.094-.149.094z"
});

function SvgBullhorn(props) {
  return /*#__PURE__*/createElement("svg", _extends$4l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4l);
}

function _extends$4m() { _extends$4m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4m.apply(this, arguments); }

var _ref$4m = /*#__PURE__*/createElement("path", {
  d: "M14.985 7.379l-1.25-6A.5.5 0 0013.25 1H2.75a.5.5 0 00-.485.379l-1.25 6A.495.495 0 001 7.5v6a.5.5 0 00.5.5H3v1a1 1 0 002 0v-1h6v1a1 1 0 002 0v-1h1.5a.5.5 0 00.5-.5v-6a.49.49 0 00-.015-.121zM5.5 2h5a.5.5 0 010 1h-5a.5.5 0 010-1zM4 12a1 1 0 110-2 1 1 0 010 2zm-.5-4a.498.498 0 01-.493-.582l.5-3A.5.5 0 014 4h8a.5.5 0 01.493.418l.5 3a.5.5 0 01-.494.582h-9zm8.5 4a1 1 0 110-2 1 1 0 010 2z"
});

function SvgBus(props) {
  return /*#__PURE__*/createElement("svg", _extends$4m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4m);
}

function _extends$4n() { _extends$4n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4n.apply(this, arguments); }

var _ref$4n = /*#__PURE__*/createElement("path", {
  d: "M2 16h12v-4H2v4zm4-2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v1a.5.5 0 01-1 0V14H7v.5a.5.5 0 01-1 0v-1zM2 11h12V7H2v4zm4-2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v1a.5.5 0 01-1 0V9H7v.5a.5.5 0 01-1 0v-1zM11 0H5L2 2v4h12V2l-3-2zm-1 4.5a.5.5 0 01-1 0V4H7v.5a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v1z"
});

function SvgCabinet(props) {
  return /*#__PURE__*/createElement("svg", _extends$4n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4n);
}

function _extends$4o() { _extends$4o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4o.apply(this, arguments); }

var _ref$4o = /*#__PURE__*/createElement("path", {
  d: "M14.5 5H14V3.5a1.5 1.5 0 00-3 0v3c0 .271-.229.5-.5.5H9V1.5a1.5 1.5 0 00-3 0V3h-.5a.5.5 0 000 1H6v5H4.5a.507.507 0 01-.5-.5v-1a1.5 1.5 0 00-3 0v1C1 10.43 2.57 12 4.5 12H6v4h3v-3h.5a.5.5 0 000-1H9v-2h1.5c1.93 0 3.5-1.57 3.5-3.5V6h.5a.5.5 0 000-1z"
});

function SvgCactus(props) {
  return /*#__PURE__*/createElement("svg", _extends$4o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4o);
}

function _extends$4p() { _extends$4p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4p.apply(this, arguments); }

var _ref$4p = /*#__PURE__*/createElement("path", {
  d: "M9 5.019V3.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v1.519C3.054 5.173 0 6.225 0 7.5v6C0 14.881 3.582 16 8 16s8-1.119 8-2.5v-6c0-1.275-3.054-2.327-7-2.481zM1.672 7.275c.379-.199.898-.388 1.501-.545C4.258 6.447 5.59 6.267 7 6.208V7.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5V6.208c1.41.058 2.741.238 3.827.522.603.157 1.122.346 1.501.545.167.088.283.165.362.225a2.516 2.516 0 01-.362.225c-.379.199-.898.388-1.501.545-1.339.35-3.053.542-4.827.542s-3.488-.193-4.827-.542c-.603-.157-1.122-.346-1.501-.545A2.609 2.609 0 011.31 7.5c.079-.061.195-.137.362-.225zM15 11.93c-1.365.769-3.988 1.289-7 1.289s-5.635-.52-7-1.289v-1.406c1.365.769 3.988 1.289 7 1.289s5.635-.52 7-1.289v1.406zM8 2.5a1 1 0 01-1-1l.002-.058C7.04.481 8 0 8 0s.96.481.998 1.442L9 1.5a1 1 0 01-1 1z"
});

function SvgCake(props) {
  return /*#__PURE__*/createElement("svg", _extends$4p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4p);
}

function _extends$4q() { _extends$4q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4q.apply(this, arguments); }

var _ref$4q = /*#__PURE__*/createElement("path", {
  d: "M12 0H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM6 15H4v-2h2v2zm0-3H4v-2h2v2zm0-3H4V7h2v2zm3 6H7v-2h2v2zm0-3H7v-2h2v2zm0-3H7V7h2v2zm3 6h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3H4V1h8v5z"
});

function SvgCalculator(props) {
  return /*#__PURE__*/createElement("svg", _extends$4q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4q);
}

function _extends$4r() { _extends$4r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4r.apply(this, arguments); }

var _ref$4r = /*#__PURE__*/createElement("path", {
  d: "M14.5 16H.5a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h14a.5.5 0 01.5.5v15a.5.5 0 01-.5.5zM1 15h13V1H1v14z"
});

var _ref2$C = /*#__PURE__*/createElement("path", {
  d: "M2 2h11v3H2V2zM2 6h2v2H2V6zM5 6h2v2H5V6zM8 6h2v2H8V6zM2 9h2v2H2V9zM5 9h2v2H5V9zM8 9h2v2H8V9zM2 12h2v2H2v-2zM5 12h2v2H5v-2zM8 12h2v2H8v-2zM11 9h2v5h-2V9zM11 6h2v2h-2V6z"
});

function SvgCalculator2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4r, _ref2$C);
}

function _extends$4s() { _extends$4s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4s.apply(this, arguments); }

var _ref$4s = /*#__PURE__*/createElement("path", {
  d: "M6 1H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 4H1V4h5v1zm8-4H9c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 9H9V9h5v1zm0-3H9V6h5v1zM6 9H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm0 4H4v2H3v-2H1v-1h2v-2h1v2h2v1z"
});

function SvgCalculator3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4s);
}

function _extends$4t() { _extends$4t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4t.apply(this, arguments); }

var _ref$4t = /*#__PURE__*/createElement("path", {
  d: "M8 9a1 1 0 110-2 1 1 0 110 2z"
});

var _ref2$D = /*#__PURE__*/createElement("path", {
  d: "M14 2V0h-2v2H4V0H2v2H0v14h16V2h-2zM3 15H1v-2h2v2zm0-3H1v-2h2v2zm0-3H1V7h2v2zm0-3H1V4h2v2zm3 9H4v-2h2v2zm0-3H4v-2h2v2zm0-3H4V7h2v2zm0-3H4V4h2v2zm3 9H7v-2h2v2zm0-3H7v-2h2v2zm0-3H7V7h2v2zm0-3H7V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2z"
});

function SvgCalendarDay(props) {
  return /*#__PURE__*/createElement("svg", _extends$4t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4t, _ref2$D);
}

function _extends$4u() { _extends$4u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4u.apply(this, arguments); }

var _ref$4u = /*#__PURE__*/createElement("path", {
  d: "M14 2V0h-2v2H4V0H2v2H0v14h16V2h-2zM3 15H1v-2h2v2zm0-3H1v-2h2v2zm0-3H1V7h2v2zm0-3H1V4h2v2zm3 9H4v-2h2v2zm0-3H4v-2h2v2zm0-3H4V7h2v2zm0-3H4V4h2v2zm3 9H7v-2h2v2zm0-3H7v-2h2v2zm0-3H7V7h2v2zm0-3H7V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2z"
});

function SvgCalendarEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$4u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4u);
}

function _extends$4v() { _extends$4v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4v.apply(this, arguments); }

var _ref$4v = /*#__PURE__*/createElement("path", {
  d: "M8 9a1 1 0 110-2 1 1 0 110 2zm4-1a1 1 0 10-2 0 1 1 0 102 0zm3 0a1 1 0 10-2 0 1 1 0 102 0zM6 8a1 1 0 10-2 0 1 1 0 102 0zM3 8a1 1 0 10-2 0 1 1 0 102 0z"
});

var _ref2$E = /*#__PURE__*/createElement("path", {
  d: "M14 2V0h-2v2H4V0H2v2H0v14h16V2h-2zM3 15H1v-2h2v2zm0-3H1v-2h2v2zm0-3H1V7h2v2zm0-3H1V4h2v2zm3 9H4v-2h2v2zm0-3H4v-2h2v2zm0-3H4V7h2v2zm0-3H4V4h2v2zm3 9H7v-2h2v2zm0-3H7v-2h2v2zm0-3H7V7h2v2zm0-3H7V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2zm3 9h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V7h2v2zm0-3h-2V4h2v2z"
});

function SvgCalendarWeek(props) {
  return /*#__PURE__*/createElement("svg", _extends$4v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4v, _ref2$E);
}

function _extends$4w() { _extends$4w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4w.apply(this, arguments); }

var _ref$4w = /*#__PURE__*/createElement("path", {
  d: "M0 15a1 1 0 001 1h14a1 1 0 001-1V6H0v9zm11-8h4v2h-4V7zm0 3h4v2h-4v-2zm0 3h4v2h-4v-2zM6 7h4v2H6V7zm0 3h4v2H6v-2zm0 3h4v2H6v-2zM1 7h4v2H1V7zm0 3h4v2H1v-2zm0 3h4v2H1v-2zM15 2h-2V.571C13 .255 12.776 0 12.5 0s-.5.256-.5.571V2H4V.571C4 .255 3.776 0 3.5 0S3 .256 3 .571V2H1a1 1 0 00-1 1v2h16V3a1 1 0 00-1-1zM3.5 4.5A1 1 0 013 2.634V3.5a.5.5 0 001 0v-.866A1 1 0 013.5 4.5zm9 0a1 1 0 01-.5-1.866V3.5a.5.5 0 001 0v-.866a1 1 0 01-.5 1.866z"
});

function SvgCalendar(props) {
  return /*#__PURE__*/createElement("svg", _extends$4w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4w);
}

function _extends$4x() { _extends$4x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4x.apply(this, arguments); }

var _ref$4x = /*#__PURE__*/createElement("path", {
  d: "M5 6h2v2H5zm3 0h2v2H8zm3 0h2v2h-2zm-9 6h2v2H2zm3 0h2v2H5zm3 0h2v2H8zM5 9h2v2H5zm3 0h2v2H8zm3 0h2v2h-2zM2 9h2v2H2zm11-9v1h-2V0H4v1H2V0H0v16h15V0h-2zm1 15H1V4h13v11z"
});

function SvgCalendar2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4x);
}

function _extends$4y() { _extends$4y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4y.apply(this, arguments); }

var _ref$4y = /*#__PURE__*/createElement("path", {
  d: "M8 7h1v1H8V7zM10 9h1v1h-1V9zM10 11h1v1h-1v-1zM8 5h1v1H8V5zM8 9h1v1H8V9zM8 13h1v1H8v-1zM8 11h1v1H8v-1zM6 5h1v1H6V5zM12 9h1v1h-1V9zM12 7h1v1h-1V7zM12 5h1v1h-1V5zM12 11h1v1h-1v-1zM10 5h1v1h-1V5zM12 13h1v1h-1v-1zM10 7h1v1h-1V7zM10 13h1v1h-1v-1zM2 7h1v1H2V7zM2 9h1v1H2V9zM4 13h1v1H4v-1zM6 7h1v1H6V7zM2 13h1v1H2v-1zM2 11h1v1H2v-1zM2 5h1v1H2V5zM6 11h1v1H6v-1zM4 11h1v1H4v-1zM6 9h1v1H6V9zM6 13h1v1H6v-1zM4 5h1v1H4V5zM4 9h1v1H4V9zM4 7h1v1H4V7z"
});

var _ref2$F = /*#__PURE__*/createElement("path", {
  d: "M12 1V0h-2v1H5V0H3v1H0v15h15V1h-3zm-2 1h2v1h-2V2zM3 2h2v1H3V2zm11 13H1V4h13v11z"
});

function SvgCalendar3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4y, _ref2$F);
}

function _extends$4z() { _extends$4z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4z.apply(this, arguments); }

var _ref$4z = /*#__PURE__*/createElement("path", {
  d: "M13 3h-1v2H9V3H6v2H3V3H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM4 15H2.002L2 14.998V13h2v2zm0-3H2v-2h2v2zm0-3H2V7h2v2zm3 6H5v-2h2v2zm0-3H5v-2h2v2zm0-3H5V7h2v2zm3 6H8v-2h2v2zm0-3H8v-2h2v2zm0-3H8V7h2v2zm3 5.998l-.002.002H11v-2h2v1.998zM13 12h-2v-2h2v2zm0-3h-2V7h2v2zM5 2a.5.5 0 00-1 0v2h1V2zm6 0a.5.5 0 00-1 0v2h1V2z"
});

function SvgCalendar4(props) {
  return /*#__PURE__*/createElement("svg", _extends$4z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4z);
}

function _extends$4A() { _extends$4A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4A.apply(this, arguments); }

var _ref$4A = /*#__PURE__*/createElement("path", {
  d: "M14 2h-1.5v.5c0 .551-.449 1-1 1s-1-.449-1-1V2h-5v.5c0 .551-.449 1-1 1s-1-.449-1-1V2H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 11.998l-.002.002H2.002L2 13.998V5h12v8.998zM4.5 3a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v2a.5.5 0 00.5.5zm7 0a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v2a.5.5 0 00.5.5zM9 6H4v1h4v2H4v1h4v2H4v1h5zm2 7h1V6h-2v1h1zm2.625 2.375H2.375c-.55 0-1-.325-1-.875v.5c0 .55.45 1 1 1h11.25c.55 0 1-.45 1-1v-.5c0 .55-.45.875-1 .875z"
});

function SvgCalendar5(props) {
  return /*#__PURE__*/createElement("svg", _extends$4A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4A);
}

function _extends$4B() { _extends$4B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4B.apply(this, arguments); }

var _ref$4B = /*#__PURE__*/createElement("path", {
  d: "M4.75 9.5a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zM15 4h-3.5c-.25-1-.5-2-1.5-2H6C5 2 4.75 3 4.5 4H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-7 9.938a4.438 4.438 0 110-8.876 4.438 4.438 0 010 8.876zM15 7h-2V6h2v1z"
});

function SvgCamera(props) {
  return /*#__PURE__*/createElement("svg", _extends$4B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4B);
}

function _extends$4C() { _extends$4C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4C.apply(this, arguments); }

var _ref$4C = /*#__PURE__*/createElement("path", {
  d: "M15 5h-3a.404.404 0 01-.276-.171l-.553-1.106c-.206-.413-.71-.724-1.171-.724H6c-.461 0-.965.311-1.171.724l-.553 1.106A.406.406 0 014 5v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5V5c-.551 0-1 .449-1 1v9c0 .551.449 1 1 1h14c.551 0 1-.449 1-1V6c0-.551-.449-1-1-1zM1 15V6h3c.461 0 .965-.311 1.171-.724l.553-1.106A.406.406 0 016 3.999h4c.086 0 .238.094.276.171l.553 1.106c.206.412.71.724 1.171.724h3v9H1z"
});

var _ref2$G = /*#__PURE__*/createElement("path", {
  d: "M8 5.875c-2.275 0-4.125 1.85-4.125 4.125S5.725 14.125 8 14.125s4.125-1.85 4.125-4.125S10.275 5.875 8 5.875zm0 7.219c-1.706 0-3.094-1.388-3.094-3.094S6.294 6.906 8 6.906 11.094 8.294 11.094 10 9.706 13.094 8 13.094z"
});

var _ref3$4 = /*#__PURE__*/createElement("path", {
  d: "M10 10a2 2 0 11-3.999.001A2 2 0 0110 10zM13 7h1v1h-1V7z"
});

function SvgCamera2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4C, _ref2$G, _ref3$4);
}

function _extends$4D() { _extends$4D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4D.apply(this, arguments); }

var _ref$4D = /*#__PURE__*/createElement("path", {
  d: "M13 1H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-2.5 8c0 1.379-1.121 2.5-2.5 2.5S5.5 10.379 5.5 9c0-.817.394-1.544 1.002-2h2.997a2.497 2.497 0 011.002 2zM5 3h1v2H5V3zM3 3h1v2H3V3zm10 9.996l-.004.004H3.003l-.004-.004V7h1.535a4 4 0 106.93 0h1.535v5.996z"
});

function SvgCamera3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4D);
}

function _extends$4E() { _extends$4E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4E.apply(this, arguments); }

var _ref$4E = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$H = /*#__PURE__*/createElement("path", {
  d: "M10.5 4L8 6.5 5.5 4 4 5.5 6.5 8 4 10.5 5.5 12 8 9.5l2.5 2.5 1.5-1.5L9.5 8 12 5.5z"
});

function SvgCancelCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$4E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4E, _ref2$H);
}

function _extends$4F() { _extends$4F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4F.apply(this, arguments); }

var _ref$4F = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm4 10.5L10.5 12 8 9.5 5.5 12 4 10.5 6.5 8 4 5.5 5.5 4 8 6.5 10.5 4 12 5.5 9.5 8l2.5 2.5z"
});

function SvgCancelCircle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4F);
}

function _extends$4G() { _extends$4G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4G.apply(this, arguments); }

var _ref$4G = /*#__PURE__*/createElement("path", {
  d: "M13.996 2l.004.004v11.993l-.004.004H2.003l-.004-.004V2.004L2.003 2h11.993zM14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
});

var _ref2$I = /*#__PURE__*/createElement("path", {
  d: "M10.5 4L8 6.5 5.5 4 4 5.5 6.5 8 4 10.5 5.5 12 8 9.5l2.5 2.5 1.5-1.5L9.5 8 12 5.5z"
});

function SvgCancelSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$4G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4G, _ref2$I);
}

function _extends$4H() { _extends$4H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4H.apply(this, arguments); }

var _ref$4H = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-1.543 11.043l-1.414 1.414L8 9.414l-3.043 3.043-1.414-1.414L6.586 8 3.543 4.957l1.414-1.414L8 6.586l3.043-3.043 1.414 1.414L9.414 8l3.043 3.043z"
});

function SvgCancelSquare2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4H);
}

function _extends$4I() { _extends$4I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4I.apply(this, arguments); }

var _ref$4I = /*#__PURE__*/createElement("path", {
  d: "M11.5 0h-7L0 4.5v7L4.5 16h7l4.5-4.5v-7L11.5 0zm1 11L11 12.5l-3-3-3 3L3.5 11l3-3-3-3L5 3.5l3 3 3-3L12.5 5l-3 3 3 3z"
});

function SvgCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$4I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4I);
}

function _extends$4J() { _extends$4J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4J.apply(this, arguments); }

var _ref$4J = /*#__PURE__*/createElement("path", {
  d: "M15 8h-1a.998.998 0 00-.03-.243l-1-4A1 1 0 0012 3H4a1 1 0 00-.97.757l-1 4A.992.992 0 002 8H1a1 1 0 00-1 1v4a1 1 0 001 1h1v1a1 1 0 002 0v-1h8v1a1 1 0 002 0v-1h1a1 1 0 001-1V9a1 1 0 00-1-1zM3 12a1 1 0 110-2 1 1 0 010 2zm1.031-4l.75-3h6.438l.75 3H4.031zM13 12a1 1 0 110-2 1 1 0 010 2z"
});

function SvgCar(props) {
  return /*#__PURE__*/createElement("svg", _extends$4J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4J);
}

function _extends$4K() { _extends$4K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4K.apply(this, arguments); }

var _ref$4K = /*#__PURE__*/createElement("path", {
  d: "M15 8h-1a.998.998 0 00-.03-.243l-1-4A1 1 0 0012 3H4a1 1 0 00-.97.757l-1 4A.992.992 0 002 8H1a1 1 0 00-1 1v4a1 1 0 001 1h1v1a1 1 0 002 0v-1h8v1a1 1 0 002 0v-1h1a1 1 0 001-1V9a1 1 0 00-1-1zM3 12a1 1 0 110-2 1 1 0 010 2zm1.031-4l.75-3h6.438l.75 3H4.031zM13 12a1 1 0 110-2 1 1 0 010 2zM10.5 2L9.985.379A.5.5 0 009.5 0h-3a.5.5 0 00-.485.379L5.5 2h5z"
});

function SvgCar2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4K);
}

function _extends$4L() { _extends$4L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4L.apply(this, arguments); }

var _ref$4L = /*#__PURE__*/createElement("path", {
  d: "M13 12H4.5a1 1 0 01-.992-.876L2.618 4H1.001a1 1 0 010-2h2.5a1 1 0 01.992.876L5.384 10h6.863l1.793-6.275a1 1 0 011.923.549l-2 7a1 1 0 01-.962.725zm-9 2.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 14.5zm6 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 14.5zM12 7h-2v2H8V7H6V5h2V3h2v2h2z"
});

function SvgCartAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$4L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4L);
}

function _extends$4M() { _extends$4M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4M.apply(this, arguments); }

var _ref$4M = /*#__PURE__*/createElement("path", {
  d: "M15.275 3.038a1 1 0 01.687 1.236l-2 7a1 1 0 01-.962.725H4.5a1 1 0 01-.992-.876l-.89-7.124H1.001a1 1 0 010-2h2.5a1 1 0 01.992.876l.891 7.124h6.863l1.793-6.275a1 1 0 011.236-.687zM4 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 14.5zm6 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 14.5zM5.688 5h2.313V2h2v3h2.313L9.001 8.563z"
});

function SvgCartAdd2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4M);
}

function _extends$4N() { _extends$4N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4N.apply(this, arguments); }

var _ref$4N = /*#__PURE__*/createElement("path", {
  d: "M15.275 3.038a1 1 0 01.687 1.236l-2 7a1 1 0 01-.962.725H4.5a1 1 0 01-.992-.876l-.89-7.124H1.001a1 1 0 010-2h2.5a1 1 0 01.992.876l.891 7.124h6.863l1.793-6.275a1 1 0 011.236-.687zM4 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 14.5zm6 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 14.5zM12.313 6H10v3H8V6H5.687L9 2.437z"
});

function SvgCartRemove(props) {
  return /*#__PURE__*/createElement("svg", _extends$4N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4N);
}

function _extends$4O() { _extends$4O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4O.apply(this, arguments); }

var _ref$4O = /*#__PURE__*/createElement("path", {
  d: "M6 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 016 14.5zM16 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0116 14.5zM16 8V2H4a1 1 0 00-1-1H0v1h2l.751 6.438A2 2 0 004 12h12v-1H4a1 1 0 01-1-1v-.01L16 8z"
});

function SvgCart(props) {
  return /*#__PURE__*/createElement("svg", _extends$4O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4O);
}

function _extends$4P() { _extends$4P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4P.apply(this, arguments); }

var _ref$4P = /*#__PURE__*/createElement("path", {
  d: "M13.238 9c.55 0 1.124-.433 1.275-.962l1.451-5.077c.151-.529-.175-.962-.725-.962H5.001a2 2 0 00-2-2h-3v2h3v8.5a1.5 1.5 0 001.5 1.5h9.5a1 1 0 000-2h-9v-1h8.238zM5 4h9.044l-.857 3H5V4zM6 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 016 14.5zM15 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0115 14.5z"
});

function SvgCart2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4P);
}

function _extends$4Q() { _extends$4Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Q.apply(this, arguments); }

var _ref$4Q = /*#__PURE__*/createElement("path", {
  d: "M13.238 9c.55 0 1.124-.433 1.275-.962l1.451-5.077c.151-.529-.175-.962-.725-.962H5.001a2 2 0 00-2-2h-3v2h3v8.5a1.5 1.5 0 001.5 1.5h9.5a1 1 0 000-2h-9v-1h8.238zM5 7v-.125h8.222L13.186 7H4.999zm8.794-2.125l-.071.25H5.001v-.25h8.794zM5 4.625v-.25h8.937l-.071.25H5.001zm8.651.75l-.071.25H5v-.25h8.651zm-.143.5l-.071.25H5v-.25h8.508zm-.143.5l-.071.25H5v-.25h8.365zM14.044 4l-.036.125H5V4h9.044zM6 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 016 14.5zM15 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0115 14.5z"
});

function SvgCart3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4Q);
}

function _extends$4R() { _extends$4R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4R.apply(this, arguments); }

var _ref$4R = /*#__PURE__*/createElement("path", {
  d: "M15.275 3.038a1 1 0 01.687 1.236l-2 7a1 1 0 01-.962.725H4.5a1 1 0 01-.992-.876l-.89-7.124H1.001a1 1 0 010-2h2.5a1 1 0 01.992.876l.891 7.124h6.863l1.793-6.275a1 1 0 011.236-.687zM4 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 14.5zm6 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 14.5z"
});

function SvgCart4(props) {
  return /*#__PURE__*/createElement("svg", _extends$4R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4R);
}

function _extends$4S() { _extends$4S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4S.apply(this, arguments); }

var _ref$4S = /*#__PURE__*/createElement("path", {
  d: "M15.275 3.038a1 1 0 00-1.236.687L13.961 4H4.634l-.141-1.124A1 1 0 003.501 2h-2.5a1 1 0 000 2h1.617l.89 7.124A1 1 0 004.5 12H13c.446 0 .839-.296.962-.725l2-7a1 1 0 00-.687-1.236zM8 8V7h2v1H8zm2 1v1H8V9h2zM8 6V5h2v1H8zM4.758 5H7v1H4.883l-.125-1zm.25 2H7v1H5.133l-.125-1zm.25 2H7v1H5.383l-.125-1zm6.988 1H11V9h1.531l-.286 1zm.571-2H11V7h2.103l-.286 1zm.572-2H11V5h2.674l-.286 1zM4 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 014 14.5zm6 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 14.5z"
});

function SvgCart5(props) {
  return /*#__PURE__*/createElement("svg", _extends$4S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4S);
}

function _extends$4T() { _extends$4T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4T.apply(this, arguments); }

var _ref$4T = /*#__PURE__*/createElement("path", {
  d: "M7 7h1v1H7V7z"
});

var _ref2$J = /*#__PURE__*/createElement("path", {
  d: "M0 4v9h17V4H0zm3 8H1v-2h1v1h1v1zm0-6H2v1H1V5h2v1zm7.5 2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H9v.5a.5.5 0 01-1 0V11H6.5a.5.5 0 010-1H8V9H6.5a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5H8v-.5a.5.5 0 011 0V6h1.5a.5.5 0 010 1H9v1h1.5zm5.5 4h-2v-1h1v-1h1v2zm0-5h-1V6h-1V5h2v2z"
});

var _ref3$5 = /*#__PURE__*/createElement("path", {
  d: "M9 9h1v1H9V9z"
});

function SvgCash(props) {
  return /*#__PURE__*/createElement("svg", _extends$4T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$4T, _ref2$J, _ref3$5);
}

function _extends$4U() { _extends$4U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4U.apply(this, arguments); }

var _ref$4U = /*#__PURE__*/createElement("path", {
  d: "M0 4v9h17V4H0zm3 8H1v-2h1v1h1v1zm0-6H2v1H1V5h2v1zm5.5 6C6.57 12 5 10.43 5 8.5S6.57 5 8.5 5 12 6.57 12 8.5 10.43 12 8.5 12zm7.5 0h-2v-1h1v-1h1v2zm0-5h-1V6h-1V5h2v2z"
});

var _ref2$K = /*#__PURE__*/createElement("path", {
  d: "M8.5 6C7.122 6 6 7.122 6 8.5S7.122 11 8.5 11 11 9.879 11 8.5 9.879 6 8.5 6z"
});

function SvgCash2(props) {
  return /*#__PURE__*/createElement("svg", _extends$4U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$4U, _ref2$K);
}

function _extends$4V() { _extends$4V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4V.apply(this, arguments); }

var _ref$4V = /*#__PURE__*/createElement("path", {
  d: "M7 9h1v1H7V9z"
});

var _ref2$L = /*#__PURE__*/createElement("path", {
  d: "M0 6v9h17V6H0zm3 8H1v-2h1v1h1v1zm0-6H2v1H1V7h2v1zm7.5 2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H9v.5a.5.5 0 01-1 0V13H6.5a.5.5 0 010-1H8v-1H6.5a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5H8v-.5a.5.5 0 011 0V8h1.5a.5.5 0 010 1H9v1h1.5zm5.5 4h-2v-1h1v-1h1v2zm0-5h-1V8h-1V7h2v2z"
});

var _ref3$6 = /*#__PURE__*/createElement("path", {
  d: "M9 11h1v1H9v-1zM1 4h15v1.5H1V4zM2 2h13v1.5H2V2z"
});

function SvgCash3(props) {
  return /*#__PURE__*/createElement("svg", _extends$4V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$4V, _ref2$L, _ref3$6);
}

function _extends$4W() { _extends$4W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4W.apply(this, arguments); }

var _ref$4W = /*#__PURE__*/createElement("path", {
  d: "M1 4h15v1.5H1V4zM2 2h13v1.5H2V2zM0 6v9h17V6H0zm3 8H1v-2h1v1h1v1zm0-6H2v1H1V7h2v1zm5.5 6C6.57 14 5 12.43 5 10.5S6.57 7 8.5 7 12 8.57 12 10.5 10.43 14 8.5 14zm7.5 0h-2v-1h1v-1h1v2zm0-5h-1V8h-1V7h2v2z"
});

var _ref2$M = /*#__PURE__*/createElement("path", {
  d: "M8.5 8C7.122 8 6 9.121 6 10.5S7.122 13 8.5 13s2.5-1.121 2.5-2.5S9.879 8 8.5 8z"
});

function SvgCash4(props) {
  return /*#__PURE__*/createElement("svg", _extends$4W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$4W, _ref2$M);
}

function _extends$4X() { _extends$4X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4X.apply(this, arguments); }

var _ref$4X = /*#__PURE__*/createElement("path", {
  d: "M3.86 12l-.667 2h9.609l-.663-2z"
});

var _ref2$N = /*#__PURE__*/createElement("path", {
  d: "M15.5 3H.5a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h1.64l.886-2.658A.5.5 0 013.5 11h9a.5.5 0 01.475.343L13.856 14H15.5a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5zM4 10a2 2 0 11-.001-3.999A2 2 0 014 10zm8 0a2 2 0 11-.001-3.999A2 2 0 0112 10zm1.5-5h-11a.5.5 0 010-1h11a.5.5 0 010 1z"
});

var _ref3$7 = /*#__PURE__*/createElement("path", {
  d: "M5 8a1 1 0 11-2 0 1 1 0 012 0zM13 8a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgCassette(props) {
  return /*#__PURE__*/createElement("svg", _extends$4X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4X, _ref2$N, _ref3$7);
}

function _extends$4Y() { _extends$4Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Y.apply(this, arguments); }

var _ref$4Y = /*#__PURE__*/createElement("path", {
  d: "M7.989 0C5.797 0 3.868.811 2.378 2.323.844 3.879.011 5.896.011 8c0 2.126.811 4.098 2.345 5.633S5.885 16 7.989 16s4.143-.833 5.721-2.389c1.491-1.469 2.279-3.419 2.279-5.611 0-2.17-.789-4.143-2.301-5.655C12.154.811 10.181 0 7.989 0zm.022 1.447c1.797 0 3.397.679 4.647 1.929 1.227 1.228 1.885 2.849 1.885 4.625 0 1.797-.636 3.375-1.863 4.581-1.293 1.271-2.959 1.951-4.669 1.951-1.731 0-3.354-.679-4.603-1.929S1.457 9.711 1.457 8.001c0-1.732.702-3.375 1.951-4.647 1.227-1.249 2.806-1.907 4.603-1.907zm-.103 5.224c-.452-.824-1.223-1.152-2.118-1.152-1.303 0-2.34.922-2.34 2.481 0 1.586.975 2.481 2.384 2.481.904 0 1.675-.496 2.1-1.249l-.993-.505c-.222.532-.558.691-.984.691-.735 0-1.072-.611-1.072-1.418s.284-1.418 1.072-1.418c.213 0 .638.115.886.647l1.063-.558zm4.615 0c-.452-.824-1.223-1.152-2.118-1.152-1.303 0-2.34.922-2.34 2.481 0 1.586.975 2.481 2.384 2.481.904 0 1.675-.496 2.1-1.249l-.993-.505c-.221.532-.558.691-.984.691C9.837 9.418 9.5 8.807 9.5 8s.284-1.418 1.072-1.418c.213 0 .638.115.887.647l1.063-.558z"
});

function SvgCc(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4Y);
}

function _extends$4Z() { _extends$4Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Z.apply(this, arguments); }

var _ref$4Z = /*#__PURE__*/createElement("path", {
  d: "M1 0v16h14V0H1zm13 15H2V1h12v14zM3 3h5v1H3V3zm0 2h5v1H3V5zm0 2h5v1H3V7zm0 1.99h5v1H3v-1zM3 11h5v1H3v-1zm0 2h10v1H3v-1zm10-9.586L12.414 4l.586.586V5h-1v1h-.414L11 5.414 10.414 6H10V5H9v-.414L9.586 4 9 3.414V3h1V2h.414l.586.586.586-.586H12v1h1v.414z"
});

var _ref2$O = /*#__PURE__*/createElement("path", {
  d: "M12 7v4.5l-1-1-1 1V7z"
});

function SvgCertificate(props) {
  return /*#__PURE__*/createElement("svg", _extends$4Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4Z, _ref2$O);
}

function _extends$4_() { _extends$4_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4_.apply(this, arguments); }

var _ref$4_ = /*#__PURE__*/createElement("path", {
  d: "M14 9h-2V2a1 1 0 00-2 0v1H5V2a1 1 0 00-2 0v7H1v2h1v5h2v-2h7v2h2v-5h1V9zM5 6h5v1H5V6zm5-2v1H5V4h5zM5 8h5v1H5V8zm6 5H4v-2h7v2z"
});

function SvgChair(props) {
  return /*#__PURE__*/createElement("svg", _extends$4_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4_);
}

function _extends$4$() { _extends$4$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$.apply(this, arguments); }

var _ref$4$ = /*#__PURE__*/createElement("path", {
  d: "M15.5 15H12v-.5h-.5v.5h-5v-.5H6v.5H2.5v-.5H2v.5H1v-4.5h.5V10H1V6.5h.5V6H1V2.5h.5V2H1V0H0v16h16v-1.5h-.5zM6.875 6.125l-.25.25v3.939l.25-.25zm-.5.5l-.25.25v3.939l.25-.25zm-.5 4.439V6.937l-.25-.125v4.161l.227.113zm2.5-6.439l-.25.25v3.939l.25-.25zm-1 1l-.25.25v3.939l.25-.25zm-2 1.063l-.25-.125v4.161l.25.125zm2.5-1.563l-.25.25v3.939l.25-.25zm-4 .813l-.25-.125v4.161l.25.125zm-1-.5l-.25-.125v4.161l.25.125zm2 1l-.25-.125v4.161l.25.125zm-1.5-.75l-.25-.125v4.161l.25.125zm-1-.5l-.25-.125v4.161l.25.125zm6.5-1.063l-.25.25v3.939l.25-.25zm-4.5 2.063l-.25-.125v4.161l.25.125zm8.5-1.063l-.25.25v5.335l.25-.375zm.5-.5l-.25.25V9.96l.25-.375zm.5-.5l-.25.25V9.21l.25-.375zm1-1l-.25.25V7.71l.25-.375zm-.5.5l-.25.25V8.46l.25-.375zm1.5-1.5l-.25.25V6.21l.25-.375zm-.5.5l-.25.25V6.96l.25-.375zm-4.5 2.625l-.25-.167v4.833l.25.333zm-.5-.333l-.25-.167v4.5l.25.333zm-1-.667l-.25-.167v3.833l.25.333zm.5.333l-.25-.167v4.167l.25.333zm1.5 1l-.25-.167v5.167l.25.333zm1 .042l-.25.25v5.585l.25-.375zm-.5.292l-.25-.167v5.5l.25.333zM12 13L9 9l-3 3-4-2v4h14V7z"
});

function SvgChart(props) {
  return /*#__PURE__*/createElement("svg", _extends$4$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$4$);
}

function _extends$50() { _extends$50 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$50.apply(this, arguments); }

var _ref$50 = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 15H1V1h14v14z"
});

var _ref2$P = /*#__PURE__*/createElement("path", {
  d: "M2.5 8L4 6.5 6.5 9 12 3.5 13.5 5l-7 7z"
});

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/createElement("svg", _extends$50({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$50, _ref2$P);
}

function _extends$51() { _extends$51 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$51.apply(this, arguments); }

var _ref$51 = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 12.414L3.293 8.707l1.414-1.414L7 9.586l4.793-4.793 1.414 1.414L7 12.414z"
});

function SvgCheckboxChecked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$51({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$51);
}

function _extends$52() { _extends$52 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$52.apply(this, arguments); }

var _ref$52 = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 15H1V1h14v14zM4 4h8v8H4z"
});

function SvgCheckboxPartial(props) {
  return /*#__PURE__*/createElement("svg", _extends$52({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$52);
}

function _extends$53() { _extends$53 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$53.apply(this, arguments); }

var _ref$53 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM14 14H2V2h12v12zm-9-2h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm0-1.125h6v.123l-.002.002H5.002L5 10.998v-.123zM5.002 5h5.996l.002.002v.123H5v-.123L5.002 5zM11 5.375v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6zm0 .5v.25H5v-.25h6z"
});

function SvgCheckboxPartial2(props) {
  return /*#__PURE__*/createElement("svg", _extends$53({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$53);
}

function _extends$54() { _extends$54 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$54.apply(this, arguments); }

var _ref$54 = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 15H1V1h14v14z"
});

function SvgCheckboxUnchecked(props) {
  return /*#__PURE__*/createElement("svg", _extends$54({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$54);
}

function _extends$55() { _extends$55 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$55.apply(this, arguments); }

var _ref$55 = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 14H2V2h12v12z"
});

function SvgCheckboxUnchecked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$55({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$55);
}

function _extends$56() { _extends$56 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$56.apply(this, arguments); }

var _ref$56 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM6.5 12.031L3.687 8.687l1.031-1.031 1.781 1.75 5.156-4.5.719.719-5.875 6.406z"
});

function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$56({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$56);
}

function _extends$57() { _extends$57 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$57.apply(this, arguments); }

var _ref$57 = /*#__PURE__*/createElement("path", {
  d: "M13.5 2L6 9.5 2.5 6 0 8.5l6 6 10-10z"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/createElement("svg", _extends$57({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$57);
}

function _extends$58() { _extends$58 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$58.apply(this, arguments); }

var _ref$58 = /*#__PURE__*/createElement("path", {
  d: "M6.21 14.339L-.007 8.22l3.084-3.035L6.21 8.268l6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369L6.21 9.935 3.077 6.852 1.686 8.221z"
});

function SvgCheckmark2(props) {
  return /*#__PURE__*/createElement("svg", _extends$58({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$58);
}

function _extends$59() { _extends$59 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$59.apply(this, arguments); }

var _ref$59 = /*#__PURE__*/createElement("path", {
  d: "M14 2.5L5.5 11 2 7.5.5 9l5 5 10-10z"
});

function SvgCheckmark3(props) {
  return /*#__PURE__*/createElement("svg", _extends$59({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$59);
}

function _extends$5a() { _extends$5a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5a.apply(this, arguments); }

var _ref$5a = /*#__PURE__*/createElement("path", {
  d: "M15.36 1c-5.227 3.956-10.239 9.247-10.239 9.247L1.509 7 0 8.537C1.485 9.932 4.924 13.618 6.088 15 9.363 9.528 12.767 5.448 16 1.716L15.36 1z"
});

function SvgCheckmark4(props) {
  return /*#__PURE__*/createElement("svg", _extends$5a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5a);
}

function _extends$5b() { _extends$5b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5b.apply(this, arguments); }

var _ref$5b = /*#__PURE__*/createElement("path", {
  d: "M13.718 3.368l-7.594 6.55L2.326 7.11l-.679.67 4.442 4.744 8.252-8.541-.623-.614zm.054-1.614l2.24 2.208-9.937 10.284-6.087-6.5 2.227-2.195 3.852 2.848 7.704-6.645z"
});

function SvgCheckmark5(props) {
  return /*#__PURE__*/createElement("svg", _extends$5b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5b);
}

function _extends$5c() { _extends$5c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5c.apply(this, arguments); }

var _ref$5c = /*#__PURE__*/createElement("path", {
  d: "M15.743 7.063L4.668.908a.5.5 0 00-.469-.009C1.609 2.212 0 4.742 0 7.5v6a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V7.502a.5.5 0 00-.257-.439zM7.969 5.094c.518 0 .938.392.938.875s-.42.875-.938.875-.938-.392-.938-.875.42-.875.938-.875zM4 4.067c.552 0 1 .418 1 .933s-.448.933-1 .933S3 5.515 3 5c0-.515.448-.933 1-.933zM12 13a1 1 0 00-2 0H1V8h14v1h-.5a1.5 1.5 0 000 3h.5v1h-3z"
});

var _ref2$Q = /*#__PURE__*/createElement("path", {
  d: "M4 10a1 1 0 11-2 0 1 1 0 012 0zM8 10.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 018 10.5zM11 10a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgCheese(props) {
  return /*#__PURE__*/createElement("svg", _extends$5c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5c, _ref2$Q);
}

function _extends$5d() { _extends$5d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5d.apply(this, arguments); }

var _ref$5d = /*#__PURE__*/createElement("path", {
  d: "M13 6a3 3 0 00-2.599 1.501 17.264 17.264 0 01-2.939-1.149 14.468 14.468 0 01-3.264-2.238C2.986 3.001 2.259 1.895 2 1.386v-.385a1 1 0 10-1 1h.019c.117 1.618.765 3.819 1.719 5.781.587 1.208 1.248 2.255 1.965 3.11l.077.091a3 3 0 10.785-.617C4.876 9.57 4.223 8.55 3.637 7.345a18.757 18.757 0 01-1.359-3.797c.325.391.722.82 1.2 1.263a15.414 15.414 0 003.497 2.416c.958.486 1.987.892 3.077 1.215A3 3 0 1013 6.002z"
});

function SvgCherry(props) {
  return /*#__PURE__*/createElement("svg", _extends$5d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5d);
}

function _extends$5e() { _extends$5e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5e.apply(this, arguments); }

var _ref$5e = /*#__PURE__*/createElement("path", {
  d: "M12.4 12H2.6c.463 1.141 2.481 2 4.9 2s4.437-.859 4.9-2zM0 16h1.406c0-.04.044-.175.174-.314s.257-.186.295-.186h4.219c.835-.016 1.406-.984 1.406-1.5H1.875C.938 14 0 15 0 16zm13.125-2H7.5c0 .516.571 1.484 1.406 1.5h4.219c.038 0 .164.047.295.186s.174.274.174.314H15c0-1-.938-2-1.875-2zM7.5 11h4.9c-.203-.5-.705-.946-1.409-1.29.324-.438.509-1.001.509-1.71 0-2.515-1.827-4.15-3.105-4.746a1.75 1.75 0 10-1.79 0C5.327 3.851 3.5 5.486 3.5 8c0 .71.185 1.273.509 1.71-.704.343-1.206.789-1.409 1.29h4.9zM5 7V6h2V4h1v2h2v1H8v2H7V7H5z"
});

function SvgChessBishop(props) {
  return /*#__PURE__*/createElement("svg", _extends$5e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5e);
}

function _extends$5f() { _extends$5f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5f.apply(this, arguments); }

var _ref$5f = /*#__PURE__*/createElement("path", {
  d: "M15.22 4.148c-.527-.527-1.252-.78-2.055-.78-1.076 0-2.294.455-3.368 1.314-.254-.778-.726-1.367-1.297-1.588V1.999H10v-1H8.5v-1h-1v1H6v1h1.5v1.095c-.571.22-1.043.809-1.297 1.588-1.074-.859-2.291-1.314-3.368-1.314-.803 0-1.527.253-2.055.78-1.367 1.367-.892 4.058 1.061 6.01.365.365.756.678 1.159.937v1.465c1.37.275 3.108.439 5 .439s3.63-.164 5-.439v-1.465a6.981 6.981 0 001.159-.937c1.953-1.953 2.427-4.644 1.061-6.01zM2.548 5.916c.017-.011.107-.048.287-.048.498 0 1.369.29 2.188 1.109.54.54.927 1.193 1.061 1.791.096.427.024.648 0 .683-.017.011-.107.048-.287.048-.498 0-1.369-.29-2.188-1.109-.54-.54-.927-1.193-1.061-1.792-.096-.427-.024-.648 0-.683zm10.904.684c-.134.598-.521 1.251-1.061 1.791-.819.819-1.69 1.109-2.188 1.109-.18 0-.27-.037-.287-.048-.024-.035-.096-.256 0-.683.134-.598.521-1.251 1.061-1.792.819-.819 1.69-1.109 2.188-1.109.18 0 .27.037.287.048.024.035.096.256 0 .683zM3 14.088v1.473c1.37.275 3.108.439 5 .439s3.63-.164 5-.439v-1.473c-1.466.27-3.187.412-5 .412s-3.534-.142-5-.412z"
});

function SvgChessKing(props) {
  return /*#__PURE__*/createElement("svg", _extends$5f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5f);
}

function _extends$5g() { _extends$5g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5g.apply(this, arguments); }

var _ref$5g = /*#__PURE__*/createElement("path", {
  d: "M15.5 15H4l-.5 1H16zM8.867 8c.21 3.248-2.649 4.524-3.635 6.5H15V9c0-3.474-1.361-5.982-2.967-7.19a5.677 5.677 0 00-.311-.947l-.193-.438c-.222-.503-.692-.57-1.045-.148L9.88.999h-.013c-.257 0-.494.008-.714.023L7.832.141C7.374-.164 7 .036 7 .586v1.018c-.406.23-.746.508-1.133.803-1 .762-3.404 3.783-5 5.591-1.476 1.672-.679 3 .719 2.688-.07 1.313 1.024.891 1.781.313 1.747-1.333 5.649-.703 5.5-3zm3.241-5.296c.539.546 1.005 1.244 1.367 2.055.556 1.246.838 2.672.838 4.241v4.5l-1.5-1.5V9c0-1.357-.238-2.578-.707-3.63-.288-.645-.648-1.19-1.057-1.605l1.061-1.061zM2.5 9.207a.707.707 0 110-1.414.707.707 0 010 1.414zm5.03-4.708c-.586.586-1.298.823-1.591.53s-.055-1.005.53-1.591 1.298-.823 1.591-.53c.293.293.055 1.005-.53 1.591z"
});

function SvgChessKnight(props) {
  return /*#__PURE__*/createElement("svg", _extends$5g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5g);
}

function _extends$5h() { _extends$5h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5h.apply(this, arguments); }

var _ref$5h = /*#__PURE__*/createElement("path", {
  d: "M11.5 9.937a4 4 0 00-1.833-5.574 2.5 2.5 0 10-3.334 0A4 4 0 004.5 9.937 6.997 6.997 0 001 16h14a6.997 6.997 0 00-3.5-6.063z"
});

function SvgChessPawn(props) {
  return /*#__PURE__*/createElement("svg", _extends$5h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5h);
}

function _extends$5i() { _extends$5i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5i.apply(this, arguments); }

var _ref$5i = /*#__PURE__*/createElement("path", {
  d: "M8 15c-1.79 0-3.528-.155-4.891-.437L3 14.54v1.021c1.37.274 3.108.439 5 .439s3.63-.164 5-.439V14.54l-.109.023C11.527 14.845 9.79 15 8 15zm4-1.531V13l-.5-1h-7L4 13v.469c1.177.17 2.543.268 4 .268s2.823-.097 4-.268zm3.649-9.068a1.2 1.2 0 00-1.878 1.466l-3.052 1.831.602-2.839a1.2 1.2 0 10-.524-.255L8.95 6.802l-.659-2.638a1.2 1.2 0 10-.582 0L7.05 6.802 5.203 4.604a1.201 1.201 0 00-1.298-1.998 1.2 1.2 0 00.775 2.253l.602 2.839L2.23 5.867a1.2 1.2 0 10-.412.412l2.833 4.722h6.699l2.833-4.722a1.2 1.2 0 001.466-1.878z"
});

function SvgChessQueen(props) {
  return /*#__PURE__*/createElement("svg", _extends$5i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5i);
}

function _extends$5j() { _extends$5j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5j.apply(this, arguments); }

var _ref$5j = /*#__PURE__*/createElement("path", {
  d: "M3 4.5h9v8H3zm9-.5l2-2V0h-2v1H9V0H6v1H3V0H1v2l2 2h9zm0-1.5l-.5.5h-8L3 2.5h9zM2 13h11v1H2zm12 1.5H1S.234 15 0 16h15c-.234-1-1-1.5-1-1.5z"
});

function SvgChessRook(props) {
  return /*#__PURE__*/createElement("svg", _extends$5j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5j);
}

function _extends$5k() { _extends$5k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5k.apply(this, arguments); }

var _ref$5k = /*#__PURE__*/createElement("path", {
  d: "M14 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM12 2h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM10 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM8 2h2v2H8zm0 4h2v2H8zm0 4h2v2H8zm0 4h2v2H8zM6 0h2v2H6zm0 4h2v2H6zm0 4h2v2H6zm0 4h2v2H6zM4 2h2v2H4zm0 4h2v2H4zm0 4h2v2H4zm0 4h2v2H4zM2 0h2v2H2zm0 4h2v2H2zm0 4h2v2H2zm0 4h2v2H2zM0 2h2v2H0zm0 4h2v2H0zm0 4h2v2H0zm0 4h2v2H0z"
});

function SvgChess(props) {
  return /*#__PURE__*/createElement("svg", _extends$5k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5k);
}

function _extends$5l() { _extends$5l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5l.apply(this, arguments); }

var _ref$5l = /*#__PURE__*/createElement("path", {
  d: "M15 12c-2.5 0-3.75-2.25-3.75-2.25-1 0-1.5.5-1.5 1.5 0 0 2.25 1.25 2.25 3.75a1 1 0 002 0v-.5a.5.5 0 01.5-.5h.5a1 1 0 000-2z"
});

var _ref2$R = /*#__PURE__*/createElement("path", {
  d: "M9 10.5a1.5 1.5 0 011.988-1.419c.144-.498.151-1.047-.014-1.486l-.447-1.191a53.542 53.542 0 01-.958-2.841S8.5 0 4.5 0A4.5 4.5 0 000 4.5c0 4 3.563 5.069 3.563 5.069L5 10l1.404.527 1.191.447c.439.165.987.158 1.486.014A1.487 1.487 0 019 10.5z"
});

function SvgChicken(props) {
  return /*#__PURE__*/createElement("svg", _extends$5l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5l, _ref2$R);
}

function _extends$5m() { _extends$5m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5m.apply(this, arguments); }

var _ref$5m = /*#__PURE__*/createElement("path", {
  d: "M14.5 8a.5.5 0 000-1H13V6h1.5a.5.5 0 000-1H13V3.5l-.5-.5H11V1.5a.5.5 0 00-1 0V3H9V1.5a.5.5 0 00-1 0V3H7V1.5a.5.5 0 00-1 0V3H5V1.5a.5.5 0 00-1 0V3H2.5l-.5.5V5H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1.5l.5.5H4v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1.5l.5-.5V12h1.5a.5.5 0 000-1H13v-1h1.5a.5.5 0 000-1H13V8h1.5zM9 10H6V7h3v3z"
});

function SvgChip(props) {
  return /*#__PURE__*/createElement("svg", _extends$5m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5m);
}

function _extends$5n() { _extends$5n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5n.apply(this, arguments); }

var _ref$5n = /*#__PURE__*/createElement("path", {
  d: "M15.5 5a.5.5 0 00-.5.5v.764l-5 1.532V7c0-1.103-.897-2-2-2H6V4h5.5a.5.5 0 000-1H.5a.5.5 0 000 1H5v1c-1.058 0-2.086.58-2.896 1.633C1.423 7.518 1 8.617 1 9.5v.938c0 .074.016.144.045.207.18.775.876 1.355 1.705 1.355H3v1H1.5c-.276 0-.5-.224-.5-.5a.5.5 0 00-1 0c0 .827.673 1.5 1.5 1.5h8a.5.5 0 000-1H7v-1.111a4.274 4.274 0 001.255-.497l6.744-3.689V8.5a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zM2.058 9c.122-.571.429-1.225.838-1.758C3.253 6.778 4.001 6 5 6h1v2.5a.5.5 0 01-.5.5H2.058zM4 13v-1h2v1H4z"
});

function SvgChopper(props) {
  return /*#__PURE__*/createElement("svg", _extends$5n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5n);
}

function _extends$5o() { _extends$5o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5o.apply(this, arguments); }

var _ref$5o = /*#__PURE__*/createElement("path", {
  d: "M15.5 5a.5.5 0 00-.5.5v.875l-5 1.458V7c0-1.103-.897-2-2-2H6V4h5.5a.5.5 0 000-1H.5a.5.5 0 000 1H5v1c-1.058 0-2.086.58-2.896 1.633C1.423 7.518 1 8.617 1 9.5v.938c0 .074.016.144.045.207.18.775.876 1.355 1.705 1.355H3v1H1.5c-.276 0-.5-.224-.5-.5a.5.5 0 00-1 0c0 .827.673 1.5 1.5 1.5h8a.5.5 0 000-1H7v-1.11a4.274 4.274 0 001.244-.491l.001-.001L15 7.604V8.5a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zM2.896 7.242C3.253 6.778 4.001 6 5 6h1v2.5a.5.5 0 01-.5.5H2.058c.122-.571.429-1.225.838-1.758zM2 10.25V10h3.5C6.327 10 7 9.327 7 8.5V6h1c.551 0 1 .449 1 1V8.5c0 .803-.47 1.563-1.257 2.033A3.398 3.398 0 016 11H2.75a.75.75 0 01-.75-.75zM6 13H4v-1h2v1z"
});

function SvgChopper2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5o);
}

function _extends$5p() { _extends$5p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5p.apply(this, arguments); }

var _ref$5p = /*#__PURE__*/createElement("path", {
  d: "M4.036 6.977l-2.29-3.966A7.986 7.986 0 018-.001a7.994 7.994 0 016.883 3.922H8.355a4.1 4.1 0 00-4.32 3.055zm6.828-1.899h4.585a8 8 0 01-7.358 10.921l3.272-5.667a4.08 4.08 0 00-.499-5.254zM5.094 8c0-1.603 1.304-2.906 2.906-2.906S10.906 6.398 10.906 8 9.602 10.906 8 10.906 5.094 9.602 5.094 8zm4.003 3.944l-2.29 3.967a8.001 8.001 0 01-5.78-11.833l3.266 5.657a4.1 4.1 0 004.804 2.21z"
});

function SvgChrome(props) {
  return /*#__PURE__*/createElement("svg", _extends$5p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5p);
}

function _extends$5q() { _extends$5q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5q.apply(this, arguments); }

var _ref$5q = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM6.707 10.293a.999.999 0 11-1.414 1.414l-3-3a.999.999 0 010-1.414l3-3a.999.999 0 111.414 1.414L4.414 8l2.293 2.293zm4 1.414a.999.999 0 11-1.414-1.414L11.586 8 9.293 5.707a.999.999 0 111.414-1.414l3 3a.999.999 0 010 1.414l-3 3z"
});

function SvgCircleCode(props) {
  return /*#__PURE__*/createElement("svg", _extends$5q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5q);
}

function _extends$5r() { _extends$5r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5r.apply(this, arguments); }

var _ref$5r = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM7 4.111c-.552 0-1 .497-1 1.111v1.111C6 7.253 5.328 8 4.5 8 5.328 8 6 8.746 6 9.667v1.111c0 .614.448 1.111 1 1.111V13H6c-1.103 0-2-.997-2-2.222V9.667c0-.614-.448-1.111-1-1.111V7.445c.552 0 1-.497 1-1.111V5.223c0-1.225.897-2.222 2-2.222h1v1.111zm6 4.445c-.552 0-1 .498-1 1.111v1.111C12 12.003 11.103 13 10 13H9v-1.111c.552 0 1-.497 1-1.111V9.667C10 8.747 10.672 8 11.5 8c-.828 0-1.5-.746-1.5-1.667V5.222c0-.614-.448-1.111-1-1.111V3h1c1.103 0 2 .997 2 2.222v1.111c0 .614.448 1.111 1 1.111v1.111z"
});

function SvgCircleCss(props) {
  return /*#__PURE__*/createElement("svg", _extends$5r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5r);
}

function _extends$5s() { _extends$5s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5s.apply(this, arguments); }

var _ref$5s = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z"
});

var _ref2$S = /*#__PURE__*/createElement("path", {
  d: "M11 11V9H8.414l3.243-3.243-1.414-1.414L7 7.586V5H5v6z"
});

function SvgCircleDownLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$5s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5s, _ref2$S);
}

function _extends$5t() { _extends$5t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5t.apply(this, arguments); }

var _ref$5t = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM5 5h2v2.586l3.243-3.243 1.414 1.414L8.414 9H11v2H5V5z"
});

function SvgCircleDownLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5t);
}

function _extends$5u() { _extends$5u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5u.apply(this, arguments); }

var _ref$5u = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$T = /*#__PURE__*/createElement("path", {
  d: "M11 5H9v2.586L5.757 4.343 4.343 5.757 7.586 9H5v2h6z"
});

function SvgCircleDownRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$5u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5u, _ref2$T);
}

function _extends$5v() { _extends$5v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5v.apply(this, arguments); }

var _ref$5v = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM5 11V9h2.586L4.343 5.757l1.414-1.414L9 7.586V5h2v6H5z"
});

function SvgCircleDownRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5v);
}

function _extends$5w() { _extends$5w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5w.apply(this, arguments); }

var _ref$5w = /*#__PURE__*/createElement("path", {
  d: "M4.875.633a7.95 7.95 0 00-.25.112v1.699c.082-.05.166-.098.25-.144V.634zM4.375.867c-.084.043-.167.088-.25.133v1.781c.082-.061.165-.12.25-.177V.867zM3.875 1.144c-.084.051-.168.104-.25.157v1.891a6.45 6.45 0 01.25-.216V1.144zM1.375 3.515a8.42 8.42 0 00-.25.393v8.184c.08.134.163.265.25.393V3.514zM7.125 1.559c.083-.011.166-.021.25-.029V.037h.25v1.474c.083-.005.166-.008.25-.009V.038h.25v1.464c.084.002.167.005.25.009V.037h.25V1.53c.084.008.167.018.25.029V.048a8.146 8.146 0 00-1.75 0v1.511zM2.875 1.857a8.632 8.632 0 00-.25.217v2.27c.08-.117.163-.231.25-.343V1.857zM2.375 2.312a7.638 7.638 0 00-.25.259v2.645c.077-.162.16-.321.25-.475V2.312zM5.375.441c-.084.029-.167.06-.25.092V2.17c.082-.041.166-.08.25-.117V.442zM.375 10.426V5.574a8.054 8.054 0 00-.25 1.01v2.833c.062.345.146.682.25 1.01zM.875 4.358c-.09.175-.173.354-.25.537v6.21c.077.182.16.361.25.537V4.359zM6.875.079c-.084.012-.167.025-.25.039v1.528c.083-.018.166-.034.25-.049V.079zM5.875.286a7.155 7.155 0 00-.25.073v1.589c.082-.032.166-.063.25-.092V.286zM6.375.165a6.955 6.955 0 00-.25.056v1.553c.083-.025.166-.049.25-.07V.165zM1.875 5.82V2.854a7.613 7.613 0 00-.25.313v3.56c.062-.311.146-.613.25-.907zM9.875.222a6.955 6.955 0 00-.25-.056v1.54c.084.022.167.045.25.07V.222zM10.375.358a7.155 7.155 0 00-.25-.073v1.57c.084.029.168.06.25.092V.358zM9.375 1.646V.118a10.018 10.018 0 00-.25-.039v1.518c.084.015.167.031.25.049zM10.875.533a10.645 10.645 0 00-.25-.092v1.611c.084.037.168.076.25.117V.532zM13.625 11.259v2.429c.085-.084.169-.171.25-.259v-2.645c-.077.162-.16.321-.25.475zM2.375 11.259a6.309 6.309 0 01-.25-.475v2.645c.081.088.165.174.25.259v-2.429zM13.375 2.075a8.632 8.632 0 00-.25-.217v2.144c.087.111.17.226.25.343v-2.27zM14.375 3.167a8.355 8.355 0 00-.25-.313V5.82c.104.293.188.596.25.907v-3.56zM11.375.745a7.95 7.95 0 00-.25-.112v1.666c.084.046.168.094.25.144V.744zM13.875 2.571a8.707 8.707 0 00-.25-.259v2.429c.09.154.173.313.25.475V2.571zM12.875 1.657a7.685 7.685 0 00-.25-.185v1.962c.086.087.169.176.25.268V1.658zM11.875 1a8.573 8.573 0 00-.25-.133v1.737c.085.057.168.116.25.177V1zM12.375 1.302a6.527 6.527 0 00-.25-.157v1.832c.085.07.169.142.25.216V1.302zM3.375 1.472c-.085.06-.168.122-.25.185v2.044c.081-.092.164-.181.25-.268V1.471zM1.875 10.18a6.525 6.525 0 01-.25-.907v3.56c.081.106.164.211.25.313V10.18zM11.875 13.219c-.082.061-.165.12-.25.177v1.737c.084-.043.167-.088.25-.133v-1.781zM10.875 13.831c-.082.041-.166.08-.25.117v1.611c.084-.029.167-.06.25-.092V13.83zM11.375 13.556c-.082.05-.166.098-.25.144v1.666a7.95 7.95 0 00.25-.112v-1.699zM9.375 14.354a6.898 6.898 0 01-.25.049v1.518c.084-.012.167-.025.25-.039v-1.528zM10.375 14.052a6.747 6.747 0 01-.25.092v1.57c.084-.023.167-.047.25-.073v-1.589zM9.875 14.225a5.452 5.452 0 01-.25.07v1.539c.084-.017.167-.036.25-.056v-1.553zM15.375 4.895a8.171 8.171 0 00-.25-.537v7.283c.09-.175.173-.354.25-.537v-6.21zM12.875 12.299a6.337 6.337 0 01-.25.268v1.962c.085-.06.168-.122.25-.185V12.3zM14.875 3.908a7.925 7.925 0 00-.25-.393v8.971c.087-.128.17-.26.25-.393V3.909zM15.875 6.584a8.054 8.054 0 00-.25-1.01v4.852c.104-.328.188-.665.25-1.01V6.583zM14.375 9.273a6.525 6.525 0 01-.25.907v2.966c.086-.102.169-.206.25-.313v-3.56zM13.375 11.656a6.51 6.51 0 01-.25.342v2.144c.085-.071.168-.143.25-.217v-2.27zM12.375 12.807a6.45 6.45 0 01-.25.216v1.832c.084-.051.168-.104.25-.157v-1.891zM3.875 13.023a6.45 6.45 0 01-.25-.216v1.891c.082.054.166.107.25.157v-1.832zM4.375 13.396a6.259 6.259 0 01-.25-.177V15c.083.046.166.09.25.133v-1.737zM4.875 13.701a6.216 6.216 0 01-.25-.144v1.699c.083.039.166.076.25.112v-1.666zM3.375 12.567a6.337 6.337 0 01-.25-.268v2.044c.082.063.165.125.25.185v-1.962zM5.375 13.948a5.682 5.682 0 01-.25-.117v1.637c.083.032.166.062.25.092v-1.611zM8.875 14.441a6.822 6.822 0 01-.25.029v1.506c.084-.006.167-.015.25-.024v-1.511zM2.875 11.998a6.956 6.956 0 01-.25-.342v2.27c.082.074.165.146.25.217v-2.144zM7.375 14.47a6.822 6.822 0 01-.25-.029v1.511c.083.009.166.017.25.024V14.47zM7.875 14.498a10.253 10.253 0 01-.25-.009v1.502c.083.004.166.006.25.007v-1.5zM5.875 14.144a6.747 6.747 0 01-.25-.092v1.589c.083.026.166.05.25.073v-1.57zM8.375 14.489a5.173 5.173 0 01-.25.009v1.5c.084-.001.167-.004.25-.007v-1.502zM6.375 14.295a7.114 7.114 0 01-.25-.07v1.553c.083.02.166.039.25.056v-1.539zM6.875 14.403a6.898 6.898 0 01-.25-.049v1.528c.083.014.166.027.25.039v-1.518zM4.957 5.543L3.543 6.957 8 11.414l4.457-4.457-1.414-1.414L8 8.586z"
});

function SvgCircleDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$5w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5w);
}

function _extends$5x() { _extends$5x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5x.apply(this, arguments); }

var _ref$5x = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z"
});

var _ref2$U = /*#__PURE__*/createElement("path", {
  d: "M4.957 5.543L3.543 6.957 8 11.414l4.457-4.457-1.414-1.414L8 8.586z"
});

function SvgCircleDown2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5x, _ref2$U);
}

function _extends$5y() { _extends$5y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5y.apply(this, arguments); }

var _ref$5y = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z"
});

var _ref2$V = /*#__PURE__*/createElement("path", {
  d: "M4 8.5l4 4 4-4L10.5 7 9 8.5V4H7v4.5L5.5 7z"
});

function SvgCircleDown3(props) {
  return /*#__PURE__*/createElement("svg", _extends$5y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5y, _ref2$V);
}

function _extends$5z() { _extends$5z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5z.apply(this, arguments); }

var _ref$5z = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm9-5v5.5l2-2L12.5 8 8 12.5 3.5 8 5 6.5l2 2V3h2z"
});

function SvgCircleDown4(props) {
  return /*#__PURE__*/createElement("svg", _extends$5z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5z);
}

function _extends$5A() { _extends$5A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5A.apply(this, arguments); }

var _ref$5A = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm11.5 1H9V4H7v5H4.5L8 12.5 11.5 9z"
});

function SvgCircleDown5(props) {
  return /*#__PURE__*/createElement("svg", _extends$5A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5A);
}

function _extends$5B() { _extends$5B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5B.apply(this, arguments); }

var _ref$5B = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm14 0A6 6 0 102 8a6 6 0 0012 0zm-2.5 1H9V4H7v5H4.5L8 12.5z"
});

function SvgCircleDown6(props) {
  return /*#__PURE__*/createElement("svg", _extends$5B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5B);
}

function _extends$5C() { _extends$5C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5C.apply(this, arguments); }

var _ref$5C = /*#__PURE__*/createElement("path", {
  d: "M15.367 11.125a7.95 7.95 0 01-.112.25h-1.699c.05-.082.098-.166.144-.25h1.666zM15.133 11.625c-.043.084-.088.167-.133.25h-1.781c.061-.082.12-.165.177-.25h1.737zM14.856 12.125c-.051.084-.104.168-.157.25h-1.891a6.45 6.45 0 00.216-.25h1.832zM12.485 14.625a8.42 8.42 0 01-.393.25H3.908a7.925 7.925 0 01-.393-.25h8.971zM14.441 8.875c.011-.083.021-.166.029-.25h1.493v-.25h-1.474c.005-.083.008-.166.009-.25h1.464v-.25h-1.464a10.253 10.253 0 00-.009-.25h1.474v-.25H14.47a6.822 6.822 0 00-.029-.25h1.511a8.146 8.146 0 010 1.75h-1.511zM14.143 13.125a8.632 8.632 0 01-.217.25h-2.27a6.51 6.51 0 00.342-.25h2.144zM13.688 13.625a7.638 7.638 0 01-.259.25h-2.645c.162-.077.321-.16.475-.25h2.429zM15.559 10.625c-.029.084-.06.167-.092.25H13.83c.041-.082.08-.166.117-.25h1.611zM5.574 15.625h4.852a8.054 8.054 0 01-1.01.25H6.583a8.054 8.054 0 01-1.01-.25zM11.642 15.125c-.175.09-.354.173-.537.25h-6.21a8.171 8.171 0 01-.537-.25h7.283zM15.921 9.125c-.012.084-.025.167-.039.25h-1.528c.018-.083.034-.166.049-.25h1.518zM15.714 10.125a7.155 7.155 0 01-.073.25h-1.589c.032-.082.063-.166.092-.25h1.57zM15.835 9.625a6.955 6.955 0 01-.056.25h-1.553c.025-.083.049-.166.07-.25h1.539zM10.18 14.125h2.966a7.613 7.613 0 01-.313.25h-3.56c.311-.062.613-.146.907-.25zM15.778 6.125c.02.083.039.166.056.25h-1.54a7.114 7.114 0 00-.07-.25h1.553zM15.642 5.625c.026.083.05.166.073.25h-1.57a6.747 6.747 0 00-.092-.25h1.589zM14.354 6.625h1.528c.014.083.027.166.039.25h-1.518a6.898 6.898 0 00-.049-.25zM15.467 5.125c.032.083.062.166.092.25h-1.611a5.682 5.682 0 00-.117-.25h1.637zM4.741 2.375H2.312c.084-.085.171-.169.259-.25h2.645c-.162.077-.321.16-.475.25zM4.741 13.625c.154.09.313.173.475.25H2.571a8.707 8.707 0 01-.259-.25h2.429zM13.925 2.625c.074.082.146.165.217.25h-2.144a6.956 6.956 0 00-.342-.25h2.27zM12.833 1.625c.106.081.211.164.313.25H10.18a6.525 6.525 0 00-.907-.25h3.56zM15.255 4.625c.039.083.076.166.112.25h-1.666a6.216 6.216 0 00-.144-.25h1.699zM13.429 2.125c.088.081.174.165.259.25h-2.429a6.309 6.309 0 00-.475-.25h2.645zM14.343 3.125c.063.082.125.165.185.25h-1.962a6.337 6.337 0 00-.268-.25h2.044zM15 4.125c.046.083.09.166.133.25h-1.737a6.259 6.259 0 00-.177-.25H15zM14.698 3.625c.054.082.107.166.157.25h-1.832a6.45 6.45 0 00-.216-.25h1.891zM14.528 12.625c-.06.085-.122.168-.185.25h-2.044c.092-.081.181-.164.268-.25h1.962zM5.82 14.125c.293.104.596.188.907.25h-3.56a8.355 8.355 0 01-.313-.25H5.82zM2.781 4.125c-.061.082-.12.165-.177.25H.867c.043-.084.088-.167.133-.25h1.781zM2.169 5.125c-.041.082-.08.166-.117.25H.441c.029-.084.06-.167.092-.25H2.17zM2.444 4.625c-.05.082-.098.166-.144.25H.634a7.95 7.95 0 01.112-.25h1.699zM1.646 6.625a6.898 6.898 0 00-.049.25H.079c.012-.084.025-.167.039-.25h1.528zM1.948 5.625a6.747 6.747 0 00-.092.25H.286c.023-.084.047-.167.073-.25h1.589zM1.775 6.125a5.452 5.452 0 00-.07.25H.166c.017-.084.036-.167.056-.25h1.553zM11.105.625c.182.077.361.16.537.25H4.359c.175-.09.354-.173.537-.25h6.21zM3.701 3.125a6.337 6.337 0 00-.268.25H1.471c.06-.085.122-.168.185-.25H3.7zM12.092 1.125c.134.08.265.163.393.25H3.514c.128-.087.26-.17.393-.25h8.184zM9.416.125c.345.062.682.146 1.01.25H5.574a8.054 8.054 0 011.01-.25h2.833zM6.727 1.625a6.525 6.525 0 00-.907.25H2.854c.102-.086.206-.169.313-.25h3.56zM4.344 2.625c-.117.08-.231.163-.343.25H1.857c.071-.085.143-.168.217-.25h2.27zM3.193 3.625a6.45 6.45 0 00-.216.25H1.145c.051-.084.104-.168.157-.25h1.891zM2.977 12.125c.07.085.142.169.216.25H1.302a6.527 6.527 0 01-.157-.25h1.832zM2.604 11.625c.057.085.116.168.177.25H1a8.573 8.573 0 01-.133-.25h1.737zM2.299 11.125c.046.084.094.168.144.25H.744a11.197 11.197 0 01-.112-.25h1.666zM3.433 12.625c.087.086.176.169.268.25H1.657a7.685 7.685 0 01-.185-.25h1.962zM2.052 10.625c.037.084.076.168.117.25H.532a10.645 10.645 0 01-.092-.25h1.611zM1.559 7.125a6.822 6.822 0 00-.029.25H.024c.006-.084.015-.167.024-.25h1.511zM4.002 13.125c.111.087.226.17.343.25h-2.27a8.632 8.632 0 01-.217-.25h2.144zM1.53 8.625c.008.084.018.167.029.25H.048a10.078 10.078 0 01-.024-.25H1.53zM1.502 8.125c.002.084.005.167.009.25H.009a6.889 6.889 0 01-.007-.25h1.5zM1.856 10.125c.029.084.06.168.092.25H.359a7.155 7.155 0 01-.073-.25h1.57zM1.511 7.625a5.173 5.173 0 00-.009.25h-1.5c.001-.084.004-.167.007-.25h1.502zM1.705 9.625c.022.084.045.167.07.25H.222a6.955 6.955 0 01-.056-.25h1.539zM1.597 9.125c.015.084.031.167.049.25H.118a10.018 10.018 0 01-.039-.25h1.518zM10.457 11.043l-1.414 1.414L4.586 8l4.457-4.457 1.414 1.414L7.414 8z"
});

function SvgCircleLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$5C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5C);
}

function _extends$5D() { _extends$5D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5D.apply(this, arguments); }

var _ref$5D = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$W = /*#__PURE__*/createElement("path", {
  d: "M10.457 4.957L9.043 3.543 4.586 8l4.457 4.457 1.414-1.414L7.414 8z"
});

function SvgCircleLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5D, _ref2$W);
}

function _extends$5E() { _extends$5E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5E.apply(this, arguments); }

var _ref$5E = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$X = /*#__PURE__*/createElement("path", {
  d: "M7.5 4l-4 4 4 4L9 10.5 7.5 9H12V7H7.5L9 5.5z"
});

function SvgCircleLeft3(props) {
  return /*#__PURE__*/createElement("svg", _extends$5E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5E, _ref2$X);
}

function _extends$5F() { _extends$5F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5F.apply(this, arguments); }

var _ref$5F = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm5 9H7.5l2 2L8 12.5 3.5 8 8 3.5 9.5 5l-2 2H13v2z"
});

function SvgCircleLeft4(props) {
  return /*#__PURE__*/createElement("svg", _extends$5F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5F);
}

function _extends$5G() { _extends$5G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5G.apply(this, arguments); }

var _ref$5G = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zM7 11.5V9h5V7H7V4.5L3.5 8 7 11.5z"
});

function SvgCircleLeft5(props) {
  return /*#__PURE__*/createElement("svg", _extends$5G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5G);
}

function _extends$5H() { _extends$5H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5H.apply(this, arguments); }

var _ref$5H = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 14A6 6 0 108 2a6 6 0 000 12zm-1-2.5V9h5V7H7V4.5L3.5 8z"
});

function SvgCircleLeft6(props) {
  return /*#__PURE__*/createElement("svg", _extends$5H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5H);
}

function _extends$5I() { _extends$5I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5I.apply(this, arguments); }

var _ref$5I = /*#__PURE__*/createElement("path", {
  d: "M.633 11.125c.036.084.073.167.112.25h1.699a6.216 6.216 0 01-.144-.25H.634zM.867 11.625c.043.084.088.167.133.25h1.781a6.259 6.259 0 01-.177-.25H.867zM1.144 12.125c.051.084.104.168.157.25h1.891a6.45 6.45 0 01-.216-.25H1.144zM3.515 14.625c.128.087.26.17.393.25h8.184c.134-.08.265-.163.393-.25H3.514zM1.559 8.875a6.822 6.822 0 01-.029-.25H.037v-.25h1.474a5.173 5.173 0 01-.009-.25H.038v-.25h1.464c.002-.084.005-.167.009-.25H.037v-.25H1.53c.008-.084.018-.167.029-.25H.048a8.146 8.146 0 000 1.75h1.511zM1.857 13.125c.071.085.143.168.217.25h2.27a6.983 6.983 0 01-.343-.25H1.857zM2.312 13.625c.084.085.171.169.259.25h2.645a6.309 6.309 0 01-.475-.25H2.312zM.441 10.625c.029.084.06.167.092.25H2.17a5.682 5.682 0 01-.117-.25H.442zM10.426 15.625H5.574c.328.104.665.188 1.01.25h2.833a8.054 8.054 0 001.01-.25zM4.358 15.125c.175.09.354.173.537.25h6.21c.182-.077.361-.16.537-.25H4.359zM.079 9.125c.012.084.025.167.039.25h1.528a6.898 6.898 0 01-.049-.25H.079zM.286 10.125c.023.084.047.167.073.25h1.589a6.747 6.747 0 01-.092-.25H.286zM.165 9.625c.017.084.036.167.056.25h1.553a5.452 5.452 0 01-.07-.25H.165zM5.82 14.125H2.854c.102.086.206.169.313.25h3.56a6.564 6.564 0 01-.907-.25zM.222 6.125c-.02.083-.039.166-.056.25h1.54c.022-.084.045-.167.07-.25H.222zM.358 5.625c-.026.083-.05.166-.073.25h1.57c.029-.084.06-.168.092-.25H.358zM1.646 6.625H.118c-.014.083-.027.166-.039.25h1.518c.015-.084.031-.167.049-.25zM.533 5.125c-.032.083-.062.166-.092.25h1.611c.037-.084.076-.168.117-.25H.532zM11.259 2.375h2.429a7.638 7.638 0 00-.259-.25h-2.645c.162.077.321.16.475.25zM11.259 13.625c-.154.09-.313.173-.475.25h2.645c.088-.081.174-.165.259-.25h-2.429zM2.075 2.625a8.632 8.632 0 00-.217.25h2.144c.111-.087.226-.17.343-.25h-2.27zM3.167 1.625a8.355 8.355 0 00-.313.25H5.82c.293-.104.596-.188.907-.25h-3.56zM.745 4.625a7.95 7.95 0 00-.112.25h1.666c.046-.084.094-.168.144-.25H.744zM2.571 2.125a8.707 8.707 0 00-.259.25h2.429c.154-.09.313-.173.475-.25H2.571zM1.657 3.125a7.685 7.685 0 00-.185.25h1.962c.087-.086.176-.169.268-.25H1.658zM1 4.125c-.046.083-.09.166-.133.25h1.737c.057-.085.116-.168.177-.25H1zM1.302 3.625a6.527 6.527 0 00-.157.25h1.832a6.45 6.45 0 01.216-.25H1.302zM1.472 12.625c.06.085.122.168.185.25h2.044a6.337 6.337 0 01-.268-.25H1.471zM10.18 14.125a6.525 6.525 0 01-.907.25h3.56c.106-.081.211-.164.313-.25H10.18zM13.219 4.125c.061.082.12.165.177.25h1.737a11.958 11.958 0 00-.133-.25h-1.781zM13.831 5.125c.041.082.08.166.117.25h1.611a7.484 7.484 0 00-.092-.25H13.83zM13.556 4.625c.05.082.098.166.144.25h1.666a7.95 7.95 0 00-.112-.25h-1.699zM14.354 6.625c.018.083.034.166.049.25h1.518a10.018 10.018 0 00-.039-.25h-1.528zM14.052 5.625c.032.082.063.166.092.25h1.57a7.155 7.155 0 00-.073-.25h-1.589zM14.225 6.125c.025.083.049.166.07.25h1.539a6.955 6.955 0 00-.056-.25h-1.553zM4.895.625c-.182.077-.361.16-.537.25h7.283a7.717 7.717 0 00-.537-.25h-6.21zM12.299 3.125c.092.081.181.164.268.25h1.962a7.685 7.685 0 00-.185-.25H12.3zM3.908 1.125c-.134.08-.265.163-.393.25h8.971a8.42 8.42 0 00-.393-.25H3.909zM6.584.125a8.054 8.054 0 00-1.01.25h4.852a8.054 8.054 0 00-1.01-.25H6.583zM9.273 1.625c.311.062.614.146.907.25h2.966a7.613 7.613 0 00-.313-.25h-3.56zM11.656 2.625c.117.08.231.163.342.25h2.144a8.632 8.632 0 00-.217-.25h-2.27zM12.807 3.625c.074.081.146.165.216.25h1.832a10.536 10.536 0 00-.157-.25h-1.891zM13.023 12.125a6.45 6.45 0 01-.216.25h1.891c.054-.082.107-.166.157-.25h-1.832zM13.396 11.625a6.259 6.259 0 01-.177.25H15c.046-.083.09-.166.133-.25h-1.737zM13.701 11.125a6.216 6.216 0 01-.144.25h1.699a7.95 7.95 0 00.112-.25h-1.666zM12.567 12.625a6.337 6.337 0 01-.268.25h2.044c.063-.082.125-.165.185-.25h-1.962zM13.948 10.625a5.682 5.682 0 01-.117.25h1.637c.032-.083.062-.166.092-.25h-1.611zM14.441 7.125c.011.083.021.166.029.25h1.506a6.823 6.823 0 00-.024-.25h-1.511zM11.998 13.125c-.111.087-.226.17-.342.25h2.27c.074-.082.146-.165.217-.25h-2.144zM14.47 8.625a6.822 6.822 0 01-.029.25h1.511c.009-.083.017-.166.024-.25H14.47zM14.498 8.125c-.002.084-.005.167-.009.25h1.502c.004-.083.006-.166.007-.25h-1.5zM14.144 10.125c-.029.084-.06.168-.092.25h1.589c.026-.083.05-.166.073-.25h-1.57zM14.489 7.625c.005.083.008.166.009.25h1.5c-.001-.084-.004-.167-.007-.25h-1.502zM14.295 9.625a7.114 7.114 0 01-.07.25h1.553c.02-.083.039-.166.056-.25h-1.539zM14.403 9.125a6.898 6.898 0 01-.049.25h1.528c.014-.083.027-.166.039-.25h-1.518zM5.543 11.043l1.414 1.414L11.414 8 6.957 3.543 5.543 4.957 8.586 8z"
});

function SvgCircleRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$5I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5I);
}

function _extends$5J() { _extends$5J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5J.apply(this, arguments); }

var _ref$5J = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$Y = /*#__PURE__*/createElement("path", {
  d: "M5.543 11.043l1.414 1.414L11.414 8 6.957 3.543 5.543 4.957 8.586 8z"
});

function SvgCircleRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5J, _ref2$Y);
}

function _extends$5K() { _extends$5K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5K.apply(this, arguments); }

var _ref$5K = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$Z = /*#__PURE__*/createElement("path", {
  d: "M8.5 12l4-4-4-4L7 5.5 8.5 7H4v2h4.5L7 10.5z"
});

function SvgCircleRight3(props) {
  return /*#__PURE__*/createElement("svg", _extends$5K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5K, _ref2$Z);
}

function _extends$5L() { _extends$5L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5L.apply(this, arguments); }

var _ref$5L = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM3 7h5.5l-2-2L8 3.5 12.5 8 8 12.5 6.5 11l2-2H3V7z"
});

function SvgCircleRight4(props) {
  return /*#__PURE__*/createElement("svg", _extends$5L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5L);
}

function _extends$5M() { _extends$5M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5M.apply(this, arguments); }

var _ref$5M = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1 11.5V9H4V7h5V4.5L12.5 8 9 11.5z"
});

function SvgCircleRight5(props) {
  return /*#__PURE__*/createElement("svg", _extends$5M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5M);
}

function _extends$5N() { _extends$5N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5N.apply(this, arguments); }

var _ref$5N = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12zm1-2.5V9H4V7h5V4.5L12.5 8z"
});

function SvgCircleRight6(props) {
  return /*#__PURE__*/createElement("svg", _extends$5N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5N);
}

function _extends$5O() { _extends$5O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5O.apply(this, arguments); }

var _ref$5O = /*#__PURE__*/createElement("path", {
  d: "M5 8a3 3 0 116 0 3 3 0 01-6 0z"
});

function SvgCircleSmall(props) {
  return /*#__PURE__*/createElement("svg", _extends$5O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5O);
}

function _extends$5P() { _extends$5P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5P.apply(this, arguments); }

var _ref$5P = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$_ = /*#__PURE__*/createElement("path", {
  d: "M5 11h2V8.414l3.243 3.243 1.414-1.414L8.414 7H11V5H5z"
});

function SvgCircleUpLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$5P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5P, _ref2$_);
}

function _extends$5Q() { _extends$5Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Q.apply(this, arguments); }

var _ref$5Q = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm11-3v2H8.414l3.243 3.243-1.414 1.414L7 8.414V11H5V5h6z"
});

function SvgCircleUpLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5Q);
}

function _extends$5R() { _extends$5R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5R.apply(this, arguments); }

var _ref$5R = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm14.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
});

var _ref2$$ = /*#__PURE__*/createElement("path", {
  d: "M5 5v2h2.586l-3.243 3.243 1.414 1.414L9 8.414V11h2V5z"
});

function SvgCircleUpRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$5R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5R, _ref2$$);
}

function _extends$5S() { _extends$5S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5S.apply(this, arguments); }

var _ref$5S = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 11H9V8.414l-3.243 3.243-1.414-1.414L7.586 7H5V5h6v6z"
});

function SvgCircleUpRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5S);
}

function _extends$5T() { _extends$5T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5T.apply(this, arguments); }

var _ref$5T = /*#__PURE__*/createElement("path", {
  d: "M11.125 15.367a7.95 7.95 0 00.25-.112v-1.699c-.082.05-.166.098-.25.144v1.666zM11.625 15.133c.084-.043.167-.088.25-.133v-1.781c-.082.061-.165.12-.25.177v1.737zM12.125 14.856c.084-.051.168-.104.25-.157v-1.891a6.45 6.45 0 01-.25.216v1.832zM14.625 12.485c.087-.128.17-.26.25-.393V3.908a7.925 7.925 0 00-.25-.393v8.971zM8.875 14.441a6.822 6.822 0 01-.25.029v1.493h-.25v-1.474a5.173 5.173 0 01-.25.009v1.464h-.25v-1.464a10.253 10.253 0 01-.25-.009v1.474h-.25V14.47a6.822 6.822 0 01-.25-.029v1.511a8.146 8.146 0 001.75 0v-1.511zM13.125 14.143c.085-.071.168-.143.25-.217v-2.27a6.51 6.51 0 01-.25.342v2.144zM13.625 13.688c.085-.084.169-.171.25-.259v-2.645c-.077.162-.16.321-.25.475v2.429zM10.625 15.559c.084-.029.167-.06.25-.092V13.83c-.082.041-.166.08-.25.117v1.611zM15.625 5.574v4.852c.104-.328.188-.665.25-1.01V6.583a8.054 8.054 0 00-.25-1.01zM15.125 11.642c.09-.175.173-.354.25-.537v-6.21a8.171 8.171 0 00-.25-.537v7.283zM9.125 15.921c.084-.012.167-.025.25-.039v-1.528a6.898 6.898 0 01-.25.049v1.518zM10.125 15.714c.084-.023.167-.047.25-.073v-1.589a6.747 6.747 0 01-.25.092v1.57zM9.625 15.835c.084-.017.167-.036.25-.056v-1.553a5.452 5.452 0 01-.25.07v1.539zM14.125 10.18v2.966c.086-.102.169-.206.25-.313v-3.56a6.564 6.564 0 01-.25.907zM6.125 15.778c.083.02.166.039.25.056v-1.54a7.114 7.114 0 01-.25-.07v1.553zM5.625 15.642c.083.026.166.05.25.073v-1.57a6.747 6.747 0 01-.25-.092v1.589zM6.625 14.354v1.528c.083.014.166.027.25.039v-1.518a6.898 6.898 0 01-.25-.049zM5.125 15.467c.083.032.166.062.25.092v-1.611a5.682 5.682 0 01-.25-.117v1.637zM2.375 4.741V2.312a7.638 7.638 0 00-.25.259v2.645c.077-.162.16-.321.25-.475zM13.625 4.741c.09.154.173.313.25.475V2.571a8.707 8.707 0 00-.25-.259v2.429zM2.625 13.925c.082.074.165.146.25.217v-2.144a6.956 6.956 0 01-.25-.342v2.27zM1.625 12.833c.081.106.164.211.25.313V10.18a6.525 6.525 0 01-.25-.907v3.56zM4.625 15.255c.083.039.166.076.25.112v-1.666a6.216 6.216 0 01-.25-.144v1.699zM2.125 13.429c.081.088.165.174.25.259v-2.429a6.309 6.309 0 01-.25-.475v2.645zM3.125 14.343c.082.063.165.125.25.185v-1.962a6.337 6.337 0 01-.25-.268v2.044zM4.125 15c.083.046.166.09.25.133v-1.737a6.259 6.259 0 01-.25-.177V15zM3.625 14.698c.082.054.166.107.25.157v-1.832a6.45 6.45 0 01-.25-.216v1.891zM12.625 14.528c.085-.06.168-.122.25-.185v-2.044a6.337 6.337 0 01-.25.268v1.962zM14.125 5.82c.104.293.188.596.25.907v-3.56a8.355 8.355 0 00-.25-.313V5.82zM4.125 2.781c.082-.061.165-.12.25-.177V.867c-.084.043-.167.088-.25.133v1.781zM5.125 2.169c.082-.041.166-.08.25-.117V.441c-.084.029-.167.06-.25.092V2.17zM4.625 2.444c.082-.05.166-.098.25-.144V.634a7.95 7.95 0 00-.25.112v1.699zM6.625 1.646c.083-.018.166-.034.25-.049V.079c-.084.012-.167.025-.25.039v1.528zM5.625 1.948c.082-.032.166-.063.25-.092V.286a7.155 7.155 0 00-.25.073v1.589zM6.125 1.775c.083-.025.166-.049.25-.07V.166a6.955 6.955 0 00-.25.056v1.553zM.625 11.105c.077.182.16.361.25.537V4.359c-.09.175-.173.354-.25.537v6.21zM3.125 3.701c.081-.092.164-.181.25-.268V1.471c-.085.06-.168.122-.25.185V3.7zM1.125 12.092c.08.134.163.265.25.393V3.514a8.42 8.42 0 00-.25.393v8.184zM.125 9.416c.062.345.146.682.25 1.01V5.574a8.054 8.054 0 00-.25 1.01v2.833zM1.625 6.727c.062-.311.146-.614.25-.907V2.854a7.613 7.613 0 00-.25.313v3.56zM2.625 4.344c.08-.117.163-.231.25-.343V1.857a8.632 8.632 0 00-.25.217v2.27zM3.625 3.193a6.45 6.45 0 01.25-.216V1.145c-.084.051-.168.104-.25.157v1.891zM12.125 2.977c.085.07.169.142.25.216V1.302a6.527 6.527 0 00-.25-.157v1.832zM11.625 2.604c.085.057.168.116.25.177V1a8.573 8.573 0 00-.25-.133v1.737zM11.125 2.299c.084.046.168.094.25.144V.744a11.197 11.197 0 00-.25-.112v1.666zM12.625 3.433c.086.087.169.176.25.268V1.657a7.685 7.685 0 00-.25-.185v1.962zM10.625 2.052c.084.037.168.076.25.117V.532a10.645 10.645 0 00-.25-.092v1.611zM7.125 1.559c.083-.011.166-.021.25-.029V.024a6.823 6.823 0 00-.25.024v1.511zM13.125 4.002c.087.111.17.226.25.343v-2.27a8.632 8.632 0 00-.25-.217v2.144zM8.625 1.53c.084.008.167.018.25.029V.048a10.078 10.078 0 00-.25-.024V1.53zM8.125 1.502c.084.002.167.005.25.009V.009a6.889 6.889 0 00-.25-.007v1.5zM10.125 1.856c.084.029.168.06.25.092V.359a7.155 7.155 0 00-.25-.073v1.57zM7.625 1.511c.083-.005.166-.008.25-.009v-1.5c-.084.001-.167.004-.25.007v1.502zM9.625 1.705c.084.022.167.045.25.07V.222a6.955 6.955 0 00-.25-.056v1.539zM9.125 1.597c.084.015.167.031.25.049V.118a10.018 10.018 0 00-.25-.039v1.518zM11.043 10.457l1.414-1.414L8 4.586 3.543 9.043l1.414 1.414L8 7.414z"
});

function SvgCircleUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$5T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5T);
}

function _extends$5U() { _extends$5U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5U.apply(this, arguments); }

var _ref$5U = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm14.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
});

var _ref2$10 = /*#__PURE__*/createElement("path", {
  d: "M11.043 10.457l1.414-1.414L8 4.586 3.543 9.043l1.414 1.414L8 7.414z"
});

function SvgCircleUp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5U, _ref2$10);
}

function _extends$5V() { _extends$5V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5V.apply(this, arguments); }

var _ref$5V = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm14.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
});

var _ref2$11 = /*#__PURE__*/createElement("path", {
  d: "M12 7.5l-4-4-4 4L5.5 9 7 7.5V12h2V7.5L10.5 9z"
});

function SvgCircleUp3(props) {
  return /*#__PURE__*/createElement("svg", _extends$5V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5V, _ref2$11);
}

function _extends$5W() { _extends$5W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5W.apply(this, arguments); }

var _ref$5W = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zm-9 5V7.5l-2 2L3.5 8 8 3.5 12.5 8 11 9.5l-2-2V13H7z"
});

function SvgCircleUp4(props) {
  return /*#__PURE__*/createElement("svg", _extends$5W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5W);
}

function _extends$5X() { _extends$5X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5X.apply(this, arguments); }

var _ref$5X = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm11.5-1H9v5H7V7H4.5L8 3.5 11.5 7z"
});

function SvgCircleUp5(props) {
  return /*#__PURE__*/createElement("svg", _extends$5X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5X);
}

function _extends$5Y() { _extends$5Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Y.apply(this, arguments); }

var _ref$5Y = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm14 0A6 6 0 112 8a6 6 0 0112 0zm-2.5-1H9v5H7V7H4.5L8 3.5z"
});

function SvgCircleUp6(props) {
  return /*#__PURE__*/createElement("svg", _extends$5Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5Y);
}

function _extends$5Z() { _extends$5Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Z.apply(this, arguments); }

var _ref$5Z = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 15A7 7 0 118 1a7 7 0 010 14z"
});

function SvgCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$5Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5Z);
}

function _extends$5_() { _extends$5_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5_.apply(this, arguments); }

var _ref$5_ = /*#__PURE__*/createElement("path", {
  d: "M0 8a8 8 0 1116 0A8 8 0 010 8z"
});

function SvgCircle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$5_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5_);
}

function _extends$5$() { _extends$5$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5$.apply(this, arguments); }

var _ref$5$ = /*#__PURE__*/createElement("path", {
  d: "M8 1a7 7 0 100 14A7 7 0 008 1zm0 12a5 5 0 11.001-10.001A5 5 0 018 13z"
});

var _ref2$12 = /*#__PURE__*/createElement("path", {
  d: "M11.75 8a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
});

function SvgCircles(props) {
  return /*#__PURE__*/createElement("svg", _extends$5$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$5$, _ref2$12);
}

function _extends$60() { _extends$60 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$60.apply(this, arguments); }

var _ref$60 = /*#__PURE__*/createElement("path", {
  d: "M8 1a7 7 0 100 14A7 7 0 008 1zm0 12a5 5 0 11.001-10.001A5 5 0 018 13z"
});

var _ref2$13 = /*#__PURE__*/createElement("path", {
  d: "M8 5.25c1.516 0 2.75 1.234 2.75 2.75S9.516 10.75 8 10.75 5.25 9.516 5.25 8 6.484 5.25 8 5.25zm0-1a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
});

function SvgCircles2(props) {
  return /*#__PURE__*/createElement("svg", _extends$60({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$60, _ref2$13);
}

function _extends$61() { _extends$61 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$61.apply(this, arguments); }

var _ref$61 = /*#__PURE__*/createElement("path", {
  d: "M15.5 4H15V2.5a.5.5 0 00-.5-.5H13V.5a.5.5 0 00-1 0V2h-1.5a.5.5 0 00-.5.5V4h-.5a.5.5 0 00-.5.5V7h3a1 1 0 011 1v7h-1V8.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5V15H4V8a1 1 0 011-1h2V2.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zM11 6h-1V5h1v1zM5 3h1v1H5V3zm0 2h1v1H5V5zM3 3h1v1H3V3zm-1 9H1v-1h1v1zm0-2H1V9h1v1zm0-2H1V7h1v1zm0-2H1V5h1v1zm0-2H1V3h1v1zm1 1h1v1H3V5zm8 10H6V9h5v6zm2-9h-1V5h1v1zm2 6h-1v-2h1v2zm0-3h-1V7h1v2zm0-3h-1V5h1v1z"
});

var _ref2$14 = /*#__PURE__*/createElement("path", {
  d: "M7 10h1v1H7v-1zM9 10h1v1H9v-1zM7 12h1v1H7v-1zM9 12h1v1H9v-1z"
});

function SvgCity(props) {
  return /*#__PURE__*/createElement("svg", _extends$61({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$61, _ref2$14);
}

function _extends$62() { _extends$62 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$62.apply(this, arguments); }

var _ref$62 = /*#__PURE__*/createElement("path", {
  d: "M1.223 4.102L14.746.479l.776 2.898L1.999 7zM2 7v9h14V7H2zm5 7V9l4 2.5L7 14z"
});

function SvgClapboardPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$62({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$62);
}

function _extends$63() { _extends$63 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$63.apply(this, arguments); }

var _ref$63 = /*#__PURE__*/createElement("path", {
  d: "M1 2a1 1 0 00-1 1v4h16V2H1zm0 4v-.5L3.5 3h2l-3 3H1zm3.5 0l3-3h2l-3 3h-2zm4 0l3-3h2l-3 3h-2zm6.5-.5l-.5.5h-2L15 3.5v2zM0 8h16v8H0V8z"
});

function SvgClapboard(props) {
  return /*#__PURE__*/createElement("svg", _extends$63({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$63);
}

function _extends$64() { _extends$64 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$64.apply(this, arguments); }

var _ref$64 = /*#__PURE__*/createElement("path", {
  d: "M0 14h9v2H0zM14 2H9.273L6.402 13H4.335L7.206 2H3.001V0h11zm.528 14L12.5 13.972 10.472 16l-.972-.972L11.528 13 9.5 10.972l.972-.972 2.028 2.028L14.528 10l.972.972L13.472 13l2.028 2.028z"
});

function SvgClearFormatting(props) {
  return /*#__PURE__*/createElement("svg", _extends$64({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$64);
}

function _extends$65() { _extends$65 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$65.apply(this, arguments); }

var _ref$65 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H10a2 2 0 10-4 0H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM8 1a1 1 0 110 2 1 1 0 010-2zm6 14H2V3h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V3h2v12z"
});

function SvgClipboard(props) {
  return /*#__PURE__*/createElement("svg", _extends$65({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$65);
}

function _extends$66() { _extends$66 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$66.apply(this, arguments); }

var _ref$66 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H10a2 2 0 10-4 0H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM8 1a1 1 0 110 2 1 1 0 010-2zm6 14H2V3h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V3h2v12z"
});

var _ref2$15 = /*#__PURE__*/createElement("path", {
  d: "M7 13.414L3.793 9.707l.914-.914L7 10.586l4.293-3.793.914.914z"
});

function SvgClipboard2(props) {
  return /*#__PURE__*/createElement("svg", _extends$66({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$66, _ref2$15);
}

function _extends$67() { _extends$67 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$67.apply(this, arguments); }

var _ref$67 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H10a2 2 0 10-4 0H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM8 1a1 1 0 110 2 1 1 0 010-2zm6 14H2V3h2v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V3h2v12z"
});

var _ref2$16 = /*#__PURE__*/createElement("path", {
  d: "M11.5 9h-7a.5.5 0 010-1h7a.5.5 0 010 1zM11.5 11h-7a.5.5 0 010-1h7a.5.5 0 010 1zM11.5 13h-7a.5.5 0 010-1h7a.5.5 0 010 1z"
});

function SvgClipboard3(props) {
  return /*#__PURE__*/createElement("svg", _extends$67({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$67, _ref2$16);
}

function _extends$68() { _extends$68 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$68.apply(this, arguments); }

var _ref$68 = /*#__PURE__*/createElement("path", {
  d: "M4 4h8V2h-2a2 2 0 10-4 0H4v2zm4-3a1 1 0 110 2 1 1 0 010-2z"
});

var _ref2$17 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H13v2.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5V2H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5z"
});

function SvgClipboard4(props) {
  return /*#__PURE__*/createElement("svg", _extends$68({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$68, _ref2$17);
}

function _extends$69() { _extends$69 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$69.apply(this, arguments); }

var _ref$69 = /*#__PURE__*/createElement("path", {
  d: "M4 4h8V2h-2a2 2 0 10-4 0H4v2zm4-3a1 1 0 110 2 1 1 0 010-2z"
});

var _ref2$18 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H13v2.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5V2H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM7 14.414l-3.207-3.707.914-.914L7 11.586l4.293-3.793.914.914L7 14.414z"
});

function SvgClipboard5(props) {
  return /*#__PURE__*/createElement("svg", _extends$69({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$69, _ref2$18);
}

function _extends$6a() { _extends$6a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6a.apply(this, arguments); }

var _ref$6a = /*#__PURE__*/createElement("path", {
  d: "M4 4h8V2h-2a2 2 0 10-4 0H4v2zm4-3a1 1 0 110 2 1 1 0 010-2z"
});

var _ref2$19 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H13v2.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5V2H1.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zm-3 11h-7a.5.5 0 010-1h7a.5.5 0 010 1zm0-2h-7a.5.5 0 010-1h7a.5.5 0 010 1zm0-2h-7a.5.5 0 010-1h7a.5.5 0 010 1z"
});

function SvgClipboard6(props) {
  return /*#__PURE__*/createElement("svg", _extends$6a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6a, _ref2$19);
}

function _extends$6b() { _extends$6b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6b.apply(this, arguments); }

var _ref$6b = /*#__PURE__*/createElement("path", {
  d: "M10.293 11.707L7 8.414V4h2v3.586l2.707 2.707zM8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
});

function SvgClock(props) {
  return /*#__PURE__*/createElement("svg", _extends$6b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6b);
}

function _extends$6c() { _extends$6c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6c.apply(this, arguments); }

var _ref$6c = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2.293 11.707L7 8.414V4h2v3.586l2.707 2.707-1.414 1.414z"
});

function SvgClock2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6c);
}

function _extends$6d() { _extends$6d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6d.apply(this, arguments); }

var _ref$6d = /*#__PURE__*/createElement("path", {
  d: "M12 7v2H7V3h2v4zM8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
});

function SvgClock3(props) {
  return /*#__PURE__*/createElement("svg", _extends$6d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6d);
}

function _extends$6e() { _extends$6e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6e.apply(this, arguments); }

var _ref$6e = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm4 9H7V3h2v4h3v2z"
});

function SvgClock4(props) {
  return /*#__PURE__*/createElement("svg", _extends$6e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6e);
}

function _extends$6f() { _extends$6f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6f.apply(this, arguments); }

var _ref$6f = /*#__PURE__*/createElement("path", {
  d: "M10.5 9l-4 4-2-2L3 12.5 6.5 16l5.5-5.5z"
});

var _ref2$1a = /*#__PURE__*/createElement("path", {
  d: "M4 5C1.794 5 0 6.794 0 9c0 1.068.416 2.073 1.172 2.828a.498.498 0 00.708 0 .5.5 0 000-.707A2.98 2.98 0 011.001 9c0-1.654 1.346-3 3-3 .813 0 1.574.32 2.143.901a.5.5 0 00.714-.7 4.037 4.037 0 00-.809-.638 2.005 2.005 0 011.952-1.562A2.002 2.002 0 019.96 6.405a.5.5 0 10.98.2 2.99 2.99 0 00.06-.518 1.502 1.502 0 011.915 1.914h-.414a.5.5 0 000 1h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-1a.5.5 0 000 1h1c1.379 0 2.5-1.122 2.5-2.5 0-1.228-.89-2.251-2.059-2.46a2.503 2.503 0 00-3.084-2.956 3.005 3.005 0 00-2.857-2.084 3.008 3.008 0 00-2.88 2.158 4.02 4.02 0 00-1.12-.158z"
});

function SvgCloudCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$6f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6f, _ref2$1a);
}

function _extends$6g() { _extends$6g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6g.apply(this, arguments); }

var _ref$6g = /*#__PURE__*/createElement("path", {
  d: "M13.942 8.039a2.5 2.5 0 00-3.085-2.955 3 3 0 00-5.737.075A4 4 0 104 13h9.5a2.5 2.5 0 00.442-4.961zM6.5 12L4 9.5l1-1L6.5 10 10 6.5l1 1L6.5 12z"
});

function SvgCloudCheck2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6g);
}

function _extends$6h() { _extends$6h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6h.apply(this, arguments); }

var _ref$6h = /*#__PURE__*/createElement("path", {
  d: "M9 9H7v3H4.5L8 15.5l3.5-3.5H9z"
});

var _ref2$1b = /*#__PURE__*/createElement("path", {
  d: "M13.941 8.04a2.503 2.503 0 00-3.084-2.956A3.005 3.005 0 008 3a3.008 3.008 0 00-2.88 2.158A4.004 4.004 0 000 9a3.998 3.998 0 003.43 3.96.5.5 0 10.141-.99 2.997 2.997 0 01-2.57-2.969c0-1.654 1.346-3 3-3 .813 0 1.574.32 2.143.9a.5.5 0 00.714-.7 4.037 4.037 0 00-.809-.638 2.005 2.005 0 011.952-1.562A2.002 2.002 0 019.96 6.405a.5.5 0 10.98.2 2.99 2.99 0 00.06-.518 1.502 1.502 0 011.915 1.914h-.414a.5.5 0 000 1h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-1a.5.5 0 000 1h1c1.379 0 2.5-1.121 2.5-2.5 0-1.228-.89-2.251-2.059-2.46z"
});

function SvgCloudDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$6h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6h, _ref2$1b);
}

function _extends$6i() { _extends$6i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6i.apply(this, arguments); }

var _ref$6i = /*#__PURE__*/createElement("path", {
  d: "M13.922 5.626A3.72 3.72 0 0010.205 2a3.712 3.712 0 00-2.92 1.418 2.09 2.09 0 00-3.719 1.573 3.028 3.028 0 00-3.567 2.98A3.028 3.028 0 003.026 11H4.46l3.539 3.664L11.538 11h1.742a2.725 2.725 0 00.641-5.374zM8 13l-3-3h2V7h2v3h2l-3 3z"
});

function SvgCloudDownload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6i);
}

function _extends$6j() { _extends$6j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6j.apply(this, arguments); }

var _ref$6j = /*#__PURE__*/createElement("path", {
  d: "M8 8.5L4.5 12H7v3h2v-3h2.5L8 8.5z"
});

var _ref2$1c = /*#__PURE__*/createElement("path", {
  d: "M13.941 8.04a2.503 2.503 0 00-3.084-2.956A3.005 3.005 0 008 3a3.008 3.008 0 00-2.88 2.158A4.004 4.004 0 000 9a3.998 3.998 0 003.43 3.96.5.5 0 10.141-.99 2.997 2.997 0 01-2.57-2.969c0-1.654 1.346-3 3-3 .813 0 1.574.32 2.143.9a.5.5 0 00.714-.7 4.037 4.037 0 00-.809-.638 2.005 2.005 0 011.952-1.562A2.002 2.002 0 019.96 6.405a.5.5 0 10.98.2 2.99 2.99 0 00.06-.518 1.502 1.502 0 011.915 1.914h-.414a.5.5 0 000 1h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-1a.5.5 0 000 1h1c1.379 0 2.5-1.121 2.5-2.5 0-1.228-.89-2.251-2.059-2.46z"
});

function SvgCloudUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$6j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6j, _ref2$1c);
}

function _extends$6k() { _extends$6k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6k.apply(this, arguments); }

var _ref$6k = /*#__PURE__*/createElement("path", {
  d: "M13.942 6.039a2.5 2.5 0 00-3.085-2.955 3 3 0 00-5.737.075A4 4 0 104 11h2v3h4v-3h3.5a2.5 2.5 0 00.442-4.961zM9 10v3H7v-3H4.5L8 6.5l3.5 3.5H9z"
});

function SvgCloudUpload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6k);
}

function _extends$6l() { _extends$6l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6l.apply(this, arguments); }

var _ref$6l = /*#__PURE__*/createElement("path", {
  d: "M13.941 8.04a2.503 2.503 0 00-3.084-2.956A3.005 3.005 0 008 3a3.008 3.008 0 00-2.88 2.158A4.004 4.004 0 000 9c0 2.206 1.794 4 4 4h9.5c1.379 0 2.5-1.121 2.5-2.5 0-1.228-.89-2.251-2.059-2.46zM13.5 12H4c-1.654 0-3-1.346-3-3s1.346-3 3-3c.813 0 1.574.32 2.143.9a.5.5 0 00.714-.7 4.037 4.037 0 00-.809-.638A2.005 2.005 0 018 4a2.002 2.002 0 011.959 2.404.5.5 0 10.98.2 2.99 2.99 0 00.06-.518A1.502 1.502 0 0112.914 8H12.5a.5.5 0 000 1h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z"
});

function SvgCloud(props) {
  return /*#__PURE__*/createElement("svg", _extends$6l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6l);
}

function _extends$6m() { _extends$6m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6m.apply(this, arguments); }

var _ref$6m = /*#__PURE__*/createElement("path", {
  d: "M16 10.274a2.726 2.726 0 00-2.078-2.648A3.72 3.72 0 0010.205 4a3.712 3.712 0 00-2.92 1.418 2.09 2.09 0 00-3.719 1.573 3.028 3.028 0 00-3.567 2.98A3.028 3.028 0 003.026 13H13.28a2.725 2.725 0 002.719-2.726z"
});

function SvgCloud2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6m);
}

function _extends$6n() { _extends$6n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6n.apply(this, arguments); }

var _ref$6n = /*#__PURE__*/createElement("path", {
  d: "M12.294 6.137c-.922 0-1.751.384-2.341 1.011-.25.265-.684.58-1.153.856.22-.842.917-1.902 1.4-2.367a3.27 3.27 0 001-2.367C11.2 1.475 9.771.018 8-.001 6.229.018 4.8 1.474 4.8 3.27c0 .932.38 1.771 1 2.367.484.465 1.18 1.525 1.4 2.367-.469-.277-.903-.591-1.153-.856a3.197 3.197 0 00-2.341-1.011C1.919 6.137.47 7.6.47 9.408s1.448 3.271 3.236 3.271c.923 0 1.751-.396 2.341-1.023.263-.279.726-.627 1.223-.916-.047 2.308-1.149 4.003-2.271 4.67V16h6v-.59c-1.122-.668-2.224-2.363-2.271-4.67.498.289.961.637 1.223.916a3.21 3.21 0 002.341 1.023c1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"
});

function SvgClubs(props) {
  return /*#__PURE__*/createElement("svg", _extends$6n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6n);
}

function _extends$6o() { _extends$6o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6o.apply(this, arguments); }

var _ref$6o = /*#__PURE__*/createElement("path", {
  d: "M4 5.5v-2A1.5 1.5 0 015.5 2H6V0h-.5A3.5 3.5 0 002 3.5v2A1.5 1.5 0 01.5 7H0v2h.5A1.5 1.5 0 012 10.5v2A3.5 3.5 0 005.5 16H6v-2h-.5A1.5 1.5 0 014 12.5v-2c0-.979-.402-1.865-1.051-2.5A3.491 3.491 0 004 5.5zM16 5.5v-2A1.5 1.5 0 0014.5 2H14V0h.5A3.5 3.5 0 0118 3.5v2A1.5 1.5 0 0019.5 7h.5v2h-.5a1.5 1.5 0 00-1.5 1.5v2a3.5 3.5 0 01-3.5 3.5H14v-2h.5a1.5 1.5 0 001.5-1.5v-2c0-.979.402-1.865 1.051-2.5A3.491 3.491 0 0116 5.5zM12 5.014a2 2 0 11-3.999.001A2 2 0 0112 5.014zM10 7.986a2 2 0 00-2 2c0 1.074.5 1.925 2.034 1.998-.456.643-1.143.896-2.034.98v1.188s4 .349 4-4.165a2.002 2.002 0 00-2-2z"
});

function SvgCode(props) {
  return /*#__PURE__*/createElement("svg", _extends$6o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$6o);
}

function _extends$6p() { _extends$6p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6p.apply(this, arguments); }

var _ref$6p = /*#__PURE__*/createElement("path", {
  d: "M14.777 5.751l-7-4.667a.5.5 0 00-.555 0l-7 4.667a.501.501 0 00-.223.416v4.667c0 .167.084.323.223.416l7 4.667a.5.5 0 00.554 0l7-4.667a.501.501 0 00.223-.416V6.167a.501.501 0 00-.223-.416zM7.5 10.232L4.901 8.5 7.5 6.768 10.099 8.5 7.5 10.232zM8 5.899V2.434l5.599 3.732L11 7.898l-3-2zm-1 0l-3 2-2.599-1.732L7 2.435V5.9zM3.099 8.5L1 9.899V7.101L3.099 8.5zM4 9.101l3 2v3.465l-5.599-3.732L4 9.102zm4 2l3-2 2.599 1.732L8 14.565V11.1zM11.901 8.5L14 7.101v2.798L11.901 8.5z"
});

function SvgCodepen(props) {
  return /*#__PURE__*/createElement("svg", _extends$6p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6p);
}

function _extends$6q() { _extends$6q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6q.apply(this, arguments); }

var _ref$6q = /*#__PURE__*/createElement("path", {
  d: "M7.834 10.231C6.826 6.531 5.941 3.63 8.12.002L8 0C3.5 0 2 3.582 2 8c0 4.064 1.269 7.42 4.975 7.932.916-1.643 1.354-3.881.859-5.701z"
});

var _ref2$1d = /*#__PURE__*/createElement("path", {
  d: "M9.019.067c-.877 1.358-1.318 3.35-.89 4.902 1.109 4.017 1.814 7.013-.3 11.029L8 16c4.5 0 6-3.582 6-8C14 3.934 12.729.576 9.019.067z"
});

function SvgCoffeeBean(props) {
  return /*#__PURE__*/createElement("svg", _extends$6q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6q, _ref2$1d);
}

function _extends$6r() { _extends$6r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6r.apply(this, arguments); }

var _ref$6r = /*#__PURE__*/createElement("path", {
  d: "M13.5 2h-.691L11.947.276A.5.5 0 0011.5 0h-7a.5.5 0 00-.447.276L3.191 2H2.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H3c0 .017.001.035.003.052l1 9.5A.5.5 0 004.5 16h7a.5.5 0 00.497-.448l1-9.5A.467.467 0 0013 6h.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM4.809 1h6.382l.5 1H4.309l.5-1zm.141 14l-.316-3h6.731l-.316 3h-6.1zM7 10a1 1 0 112 0 1 1 0 01-2 0zm4.787-2H4.214l-.211-2h7.995l-.211 2zM13 5H3V3h10v2z"
});

function SvgCoffee(props) {
  return /*#__PURE__*/createElement("svg", _extends$6r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6r);
}

function _extends$6s() { _extends$6s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6s.apply(this, arguments); }

var _ref$6s = /*#__PURE__*/createElement("path", {
  d: "M14.59 9.535a3.053 3.053 0 011.127-4.164l-1.572-2.723a3.017 3.017 0 01-1.529.414A3.052 3.052 0 019.574 0H6.429a3.009 3.009 0 01-.406 1.535c-.839 1.454-2.706 1.948-4.17 1.106L.281 5.364a3 3 0 011.123 1.117 3.053 3.053 0 01-1.12 4.16l1.572 2.723c.448-.261.967-.41 1.522-.41A3.052 3.052 0 016.42 16h3.145a3.012 3.012 0 01.406-1.519 3.053 3.053 0 014.163-1.11l1.572-2.723a3.008 3.008 0 01-1.116-1.113zM8 11.24a3.24 3.24 0 110-6.48 3.24 3.24 0 010 6.48z"
});

function SvgCog(props) {
  return /*#__PURE__*/createElement("svg", _extends$6s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6s);
}

function _extends$6t() { _extends$6t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6t.apply(this, arguments); }

var _ref$6t = /*#__PURE__*/createElement("path", {
  d: "M16 9.501V6.498l-2.293-.382a6.016 6.016 0 00-.339-.82l1.351-1.891-2.123-2.123-1.888 1.349a5.917 5.917 0 00-.825-.342L9.502.001H6.499l-.381 2.288c-.285.094-.56.209-.824.342L3.406 1.282 1.283 3.405l1.351 1.891a6.016 6.016 0 00-.339.82l-2.293.382v3.003l2.299.383c.093.281.206.552.338.813l-1.355 1.898 2.123 2.123 1.901-1.358c.259.13.53.243.809.335l.384 2.304h3.003l.384-2.304a5.91 5.91 0 00.809-.335l1.901 1.358 2.123-2.123-1.355-1.898c.132-.261.245-.532.338-.813l2.299-.383zM8 10a2 2 0 11-.001-3.999A2 2 0 018 10z"
});

function SvgCog2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6t);
}

function _extends$6u() { _extends$6u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6u.apply(this, arguments); }

var _ref$6u = /*#__PURE__*/createElement("path", {
  d: "M9.893 16H6.107l-.381-2.288a10.417 10.417 0 01-.157-.065l-1.887 1.348-2.677-2.677 1.346-1.884-.067-.161-2.283-.381V6.106l2.277-.38a4.88 4.88 0 01.069-.167L1.005 3.681l2.677-2.677 1.875 1.339c.057-.025.114-.048.172-.071L6.108 0h3.786l.379 2.272.172.071 1.875-1.339 2.677 2.677-1.342 1.878c.024.055.047.111.069.167l2.277.38v3.786l-2.283.381-.067.161 1.346 1.884-2.677 2.677-1.887-1.348-.157.065L9.895 16zm-2.78-1.187h1.774l.332-1.991.34-.113c.228-.075.453-.169.668-.277l.32-.161 1.642 1.173 1.254-1.254-1.171-1.64.162-.321a4.93 4.93 0 00.279-.672l.113-.34 1.985-.331V7.112l-1.981-.33-.112-.341a4.885 4.885 0 00-.28-.678l-.161-.32 1.167-1.633-1.254-1.254-1.631 1.165-.321-.162a4.937 4.937 0 00-.681-.283l-.341-.112-.329-1.976H7.113l-.329 1.976-.341.112a4.937 4.937 0 00-.681.283l-.321.162L3.81 2.556 2.555 3.811l1.167 1.633-.161.32c-.11.218-.204.446-.28.678l-.112.341-1.981.33v1.774l1.985.331.113.34c.076.23.17.456.279.672l.162.321-1.171 1.64 1.255 1.254 1.642-1.173.32.161c.215.108.44.201.668.277l.34.113.332 1.991zM8.5 6h-1C6.675 6 6 6.675 6 7.5v1c0 .825.675 1.5 1.5 1.5h1c.825 0 1.5-.675 1.5-1.5v-1C10 6.675 9.325 6 8.5 6zM9 8.5c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1z"
});

function SvgCog3(props) {
  return /*#__PURE__*/createElement("svg", _extends$6u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6u);
}

function _extends$6v() { _extends$6v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6v.apply(this, arguments); }

var _ref$6v = /*#__PURE__*/createElement("path", {
  d: "M16 6.5l-3.527-.353 2.245-2.743-2.121-2.121-2.743 2.245L9.501.001h-3l-.353 3.527-2.743-2.245-2.121 2.121 2.245 2.743L.002 6.5v3l3.527.353-2.245 2.743 2.121 2.121 2.743-2.245.353 3.527h3l.353-3.527 2.743 2.245 2.121-2.121-2.245-2.743L16 9.5v-3zM8 11a3 3 0 110-6 3 3 0 010 6z"
});

function SvgCog4(props) {
  return /*#__PURE__*/createElement("svg", _extends$6v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6v);
}

function _extends$6w() { _extends$6w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6w.apply(this, arguments); }

var _ref$6w = /*#__PURE__*/createElement("path", {
  d: "M16 6.5l-3.527-.353 2.245-2.743-2.121-2.121-2.743 2.245L9.501.001h-3l-.353 3.527-2.743-2.245-2.121 2.121 2.245 2.743L.002 6.5v3l3.527.353-2.245 2.743 2.121 2.121 2.743-2.245.353 3.527h3l.353-3.527 2.743 2.245 2.121-2.121-2.245-2.743L16 9.5v-3zM8 11a3 3 0 110-6 3 3 0 010 6z"
});

var _ref2$1e = /*#__PURE__*/createElement("path", {
  d: "M9 8a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgCog5(props) {
  return /*#__PURE__*/createElement("svg", _extends$6w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6w, _ref2$1e);
}

function _extends$6x() { _extends$6x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6x.apply(this, arguments); }

var _ref$6x = /*#__PURE__*/createElement("path", {
  d: "M16 7l-3.767-.753 2.131-3.196-1.414-1.414-3.196 2.131L9.001.001h-2l-.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196L.002 7v2l3.767.753-2.131 3.196 1.414 1.414 3.196-2.131.753 3.767h2l.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196L16 9V7zm-8 4a3 3 0 110-6 3 3 0 010 6z"
});

function SvgCog6(props) {
  return /*#__PURE__*/createElement("svg", _extends$6x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6x);
}

function _extends$6y() { _extends$6y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6y.apply(this, arguments); }

var _ref$6y = /*#__PURE__*/createElement("path", {
  d: "M16 7l-3.767-.753 2.131-3.196-1.414-1.414-3.196 2.131L9.001.001h-2l-.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196L.002 7v2l3.767.753-2.131 3.196 1.414 1.414 3.196-2.131.753 3.767h2l.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196L16 9V7zm-8 4a3 3 0 110-6 3 3 0 010 6z"
});

var _ref2$1f = /*#__PURE__*/createElement("path", {
  d: "M9 8a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgCog7(props) {
  return /*#__PURE__*/createElement("svg", _extends$6y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6y, _ref2$1f);
}

function _extends$6z() { _extends$6z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6z.apply(this, arguments); }

var _ref$6z = /*#__PURE__*/createElement("path", {
  d: "M5.683 11.282l.645-.903-.707-.707-.903.645a2.515 2.515 0 00-.535-.222L4 9H3l-.183 1.095a2.444 2.444 0 00-.535.222l-.903-.645-.707.707.645.903a2.515 2.515 0 00-.222.535L0 12v1l1.095.183c.053.188.128.368.222.535l-.645.903.707.707.903-.645c.168.094.347.168.535.222L3 16h1l.183-1.095c.188-.053.368-.128.535-.222l.903.645.707-.707-.645-.903c.094-.168.168-.347.222-.535L7 13.001v-1l-1.095-.183a2.444 2.444 0 00-.222-.535zM3.5 13.5a1 1 0 110-2 1 1 0 010 2zM16 6V5l-1.053-.191a4.147 4.147 0 00-.074-.372l.899-.58-.383-.924-1.046.226a4.432 4.432 0 00-.211-.315l.609-.88-.707-.707-.88.609a4.8 4.8 0 00-.315-.211l.226-1.046-.924-.383-.58.899a4.53 4.53 0 00-.372-.074l-.191-1.053h-1l-.191 1.053c-.126.019-.25.044-.372.074l-.58-.899-.924.383.226 1.046a4.432 4.432 0 00-.315.211l-.88-.609-.707.707.609.88a4.8 4.8 0 00-.211.315l-1.046-.226-.383.924.899.58a4.53 4.53 0 00-.074.372L4.996 5v1l1.053.191c.019.126.044.25.074.372l-.899.58.383.924 1.046-.226c.066.108.136.213.211.315l-.609.88.707.707.88-.609a4.8 4.8 0 00.315.211l-.226 1.046.924.383.58-.899c.122.03.246.054.372.074l.191 1.053h1l.191-1.053c.126-.019.25-.044.372-.074l.58.899.924-.383-.226-1.046c.108-.066.213-.136.315-.211l.88.609.707-.707-.609-.88a4.8 4.8 0 00.211-.315l1.046.226.383-.924-.899-.58a4.53 4.53 0 00.074-.372L16 6zm-5.5 1.675a2.175 2.175 0 110-4.35 2.175 2.175 0 010 4.35z"
});

function SvgCogs(props) {
  return /*#__PURE__*/createElement("svg", _extends$6z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6z);
}

function _extends$6A() { _extends$6A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6A.apply(this, arguments); }

var _ref$6A = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12zM8 8V6h2V5H8V4H7v1H5v4h2v2H5v1h2v1h1v-1h2V8H8zM7 8H6V6h1v2zm2 3H8V9h1v2z"
});

function SvgCoinDollar(props) {
  return /*#__PURE__*/createElement("svg", _extends$6A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6A);
}

function _extends$6B() { _extends$6B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6B.apply(this, arguments); }

var _ref$6B = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"
});

var _ref2$1g = /*#__PURE__*/createElement("path", {
  d: "M10.482 10.068a.5.5 0 00-.684.181A1.51 1.51 0 018.5 11h-2a1.502 1.502 0 01-1.414-1H7.5a.5.5 0 000-1H5V8h2.5a.5.5 0 000-1H5.086c.206-.582.762-1 1.414-1h2a1.51 1.51 0 011.298.751.5.5 0 10.865-.503 2.513 2.513 0 00-2.162-1.249h-2c-1.207 0-2.217.86-2.45 2h-.55a.5.5 0 000 1h.5v1h-.5a.5.5 0 000 1h.55c.232 1.14 1.242 2 2.45 2h2a2.51 2.51 0 002.162-1.249.5.5 0 00-.181-.684z"
});

function SvgCoinEuro(props) {
  return /*#__PURE__*/createElement("svg", _extends$6B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6B, _ref2$1g);
}

function _extends$6C() { _extends$6C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6C.apply(this, arguments); }

var _ref$6C = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"
});

var _ref2$1h = /*#__PURE__*/createElement("path", {
  d: "M9.5 11H6V9h1.5a.5.5 0 000-1H6v-.5a1.502 1.502 0 012.8-.75.499.499 0 10.865-.501A2.51 2.51 0 007.5 4.999a2.503 2.503 0 00-2.5 2.5v.5h-.5a.5.5 0 000 1H5v3h4.5a.5.5 0 000-1z"
});

function SvgCoinPound(props) {
  return /*#__PURE__*/createElement("svg", _extends$6C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6C, _ref2$1h);
}

function _extends$6D() { _extends$6D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6D.apply(this, arguments); }

var _ref$6D = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"
});

var _ref2$1i = /*#__PURE__*/createElement("path", {
  d: "M9.5 9a.5.5 0 000-1H8.434l1.482-2.223a.5.5 0 10-.832-.554L7.5 7.599 5.916 5.223a.5.5 0 10-.832.554L6.566 8H5.5a.5.5 0 000 1H7v1H5.5a.5.5 0 000 1H7v1.5a.5.5 0 001 0V11h1.5a.5.5 0 000-1H8V9h1.5z"
});

function SvgCoinYen(props) {
  return /*#__PURE__*/createElement("svg", _extends$6D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6D, _ref2$1i);
}

function _extends$6E() { _extends$6E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6E.apply(this, arguments); }

var _ref$6E = /*#__PURE__*/createElement("path", {
  d: "M10.479 4.958c-.364 0-.72.036-1.064.103A1.81 1.81 0 009.331 5c.425-.294.669-.636.669-1V3c0-1.105-2.239-2-5-2s-5 .895-5 2v1c0 .364.244.706.669 1C.244 5.294 0 5.636 0 6v1c0 .364.244.706.669 1C.244 8.294 0 8.636 0 9v1c0 .364.244.706.669 1-.425.294-.669.636-.669 1v1c0 1.105 2.239 2 5 2 .738 0 1.438-.064 2.069-.179a5.521 5.521 0 103.41-9.863zM.5 3c0-.298.451-.671 1.15-.95.887-.355 2.076-.55 3.35-.55s2.463.195 3.35.55c.699.279 1.15.652 1.15.95s-.451.671-1.15.95a6.615 6.615 0 01-.954.294C6.68 4.411 5.86 4.5 5 4.5s-1.68-.089-2.396-.256a6.615 6.615 0 01-.954-.294C.951 3.671.5 3.298.5 3zm0 6c0-.221.249-.483.663-.718C2.08 8.721 3.459 9 5 9l.159-.001a5.521 5.521 0 00-.201 1.481v.021a10.625 10.625 0 01-2.354-.256 6.615 6.615 0 01-.954-.294C.951 9.672.5 9.299.5 9.001zM5 13.5c-1.273 0-2.463-.195-3.35-.55C.951 12.671.5 12.298.5 12c0-.221.249-.483.663-.718C2.08 11.721 3.459 12 5 12l.17-.002c.151.527.378 1.022.668 1.472-.274.019-.554.029-.839.029zm0-6c-.859 0-1.68-.089-2.396-.256a6.615 6.615 0 01-.954-.294C.951 6.671.5 6.298.5 6c0-.221.249-.483.663-.718C2.08 5.721 3.459 6 5 6c1.03 0 1.987-.125 2.782-.339A5.551 5.551 0 005.85 7.469c-.278.02-.562.03-.85.03zm5.479 7.496a4.517 4.517 0 110-9.033 4.517 4.517 0 010 9.033zM11 7h-1v1H8v3h2v1H8v1h2v1h1v-1h2v-3h-2V9h2V8h-2V7zm-1 3H9V9h1v1zm2 1v1h-1v-1h1z"
});

function SvgCoins(props) {
  return /*#__PURE__*/createElement("svg", _extends$6E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6E);
}

function _extends$6F() { _extends$6F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6F.apply(this, arguments); }

var _ref$6F = /*#__PURE__*/createElement("path", {
  d: "M4 3.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 3.5z"
});

var _ref2$1j = /*#__PURE__*/createElement("path", {
  d: "M2.5 5C1.119 5 0 5.448 0 6v1h5V6c0-.552-1.119-1-2.5-1zM14 3.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0114 3.5z"
});

var _ref3$8 = /*#__PURE__*/createElement("path", {
  d: "M12.5 5c-1.381 0-2.5.448-2.5 1v1h5V6c0-.552-1.119-1-2.5-1zM9 11.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 11.5z"
});

var _ref4$1 = /*#__PURE__*/createElement("path", {
  d: "M7.5 13c-1.381 0-2.5.448-2.5 1v1h5v-1c0-.552-1.119-1-2.5-1zM9.5 4h-4a.5.5 0 010-1h4a.5.5 0 010 1zM10.5 12a.5.5 0 01-.416-.777l2-3a.5.5 0 11.832.554l-2 3A.498.498 0 0110.5 12zM4.5 12a.5.5 0 01-.417-.223l-2-3a.5.5 0 11.832-.554l2 3a.5.5 0 01-.416.777z"
});

function SvgCollaboration(props) {
  return /*#__PURE__*/createElement("svg", _extends$6F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6F, _ref2$1j, _ref3$8, _ref4$1);
}

function _extends$6G() { _extends$6G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6G.apply(this, arguments); }

var _ref$6G = /*#__PURE__*/createElement("path", {
  d: "M15.707 14.293l-13-13-1.414 1.414 2.326 2.326a13.533 13.533 0 00-1.129 2.36c-.635 1.772-.698 3.696.197 5.397A6.053 6.053 0 008 16a6.057 6.057 0 004.523-2.063l1.77 1.77 1.414-1.414zM13.51 7.393C12.483 4.527 10.305 1.953 8 0a23.21 23.21 0 00-2.325 2.261l8.288 8.288c.09-1.054-.085-2.13-.453-3.155z"
});

function SvgColorClear(props) {
  return /*#__PURE__*/createElement("svg", _extends$6G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6G);
}

function _extends$6H() { _extends$6H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6H.apply(this, arguments); }

var _ref$6H = /*#__PURE__*/createElement("path", {
  d: "M11.5 11H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM10 14a1 1 0 110-2 1 1 0 010 2zM12 10.581V3.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v3.081l4 4zM15.698 4.646L13 3.344v8.042l2.931-6.072a.5.5 0 00-.233-.668zM9.828 10L4.696 4.868a.5.5 0 00-.707 0L1.868 6.989a.5.5 0 000 .707l2.303 2.303h5.657z"
});

function SvgColorSampler(props) {
  return /*#__PURE__*/createElement("svg", _extends$6H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6H);
}

function _extends$6I() { _extends$6I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6I.apply(this, arguments); }

var _ref$6I = /*#__PURE__*/createElement("path", {
  d: "M14 5H1a1 1 0 00-1 1v5.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V8h1v3.5a.5.5 0 001 0V6a1 1 0 00-1-1z"
});

function SvgComb(props) {
  return /*#__PURE__*/createElement("svg", _extends$6I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6I);
}

function _extends$6J() { _extends$6J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6J.apply(this, arguments); }

var _ref$6J = /*#__PURE__*/createElement("path", {
  d: "M11.5 14A2.502 2.502 0 019 11.5V10H7v1.5C7 12.879 5.878 14 4.5 14S2 12.879 2 11.5 3.122 9 4.5 9H6V7H4.5C3.122 7 2 5.878 2 4.5S3.122 2 4.5 2 7 3.122 7 4.5V6h2V4.5C9 3.122 10.121 2 11.5 2S14 3.122 14 4.5 12.879 7 11.5 7H10v2h1.5c1.379 0 2.5 1.121 2.5 2.5S12.879 14 11.5 14zM10 10v1.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5H10zm-5.5 0c-.827 0-1.5.673-1.5 1.5S3.673 13 4.5 13 6 12.327 6 11.5V10H4.5zM7 9h2V7H7v2zm3-3h1.5c.827 0 1.5-.673 1.5-1.5S12.327 3 11.5 3 10 3.673 10 4.5V6zM4.5 3C3.673 3 3 3.673 3 4.5S3.673 6 4.5 6H6V4.5C6 3.673 5.327 3 4.5 3z"
});

function SvgCommand(props) {
  return /*#__PURE__*/createElement("svg", _extends$6J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6J);
}

function _extends$6K() { _extends$6K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6K.apply(this, arguments); }

var _ref$6K = /*#__PURE__*/createElement("path", {
  d: "M8.5 16a.5.5 0 01-.5-.5V8H.5a.5.5 0 01-.211-.953l15-7a.5.5 0 01.665.665l-7 15a.5.5 0 01-.453.289zM2.754 7H8.5a.5.5 0 01.5.5v5.746l5.465-11.712L2.753 6.999z"
});

function SvgCompass(props) {
  return /*#__PURE__*/createElement("svg", _extends$6K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6K);
}

function _extends$6L() { _extends$6L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6L.apply(this, arguments); }

var _ref$6L = /*#__PURE__*/createElement("path", {
  d: "M15.854.146a.501.501 0 00-.565-.1l-15 7a.5.5 0 00.211.953H8v7.5a.5.5 0 00.953.211l7-15a.5.5 0 00-.1-.565zM9 13.246V7l5.465-5.465L9 13.247z"
});

function SvgCompass2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6L);
}

function _extends$6M() { _extends$6M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6M.apply(this, arguments); }

var _ref$6M = /*#__PURE__*/createElement("path", {
  d: "M8.5 16a.5.5 0 01-.5-.5V8H.5a.5.5 0 01-.211-.953l15-7a.5.5 0 01.665.665l-7 15a.5.5 0 01-.453.289z"
});

function SvgCompass3(props) {
  return /*#__PURE__*/createElement("svg", _extends$6M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6M);
}

function _extends$6N() { _extends$6N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6N.apply(this, arguments); }

var _ref$6N = /*#__PURE__*/createElement("path", {
  d: "M9.673 7.501L11 5.705v-.706h-.706L8.498 6.326 7.73 2.999h-.462L6.5 6.326 4.704 4.999h-.706v.706l1.327 1.796-3.327.768v.462l3.327.768-1.327 1.796v.706h.706L6.5 10.674l.768 3.327h.462l.768-3.327 1.796 1.327H11v-.706L9.673 9.499 13 8.731v-.462l-3.327-.768zM7.5 9a.5.5 0 110-1 .5.5 0 010 1z"
});

var _ref2$1k = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"
});

function SvgCompass4(props) {
  return /*#__PURE__*/createElement("svg", _extends$6N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6N, _ref2$1k);
}

function _extends$6O() { _extends$6O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6O.apply(this, arguments); }

var _ref$6O = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 0110.93-4.756L6 6l-2.756 6.43A6.476 6.476 0 011.5 8zm7.643 1.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5a6.476 6.476 0 01-4.43-1.744L10 10l2.756-6.43A6.5 6.5 0 018 14.5z"
});

function SvgCompass5(props) {
  return /*#__PURE__*/createElement("svg", _extends$6O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6O);
}

function _extends$6P() { _extends$6P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6P.apply(this, arguments); }

var _ref$6P = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 0110.93-4.756L6 6l-2.756 6.43A6.476 6.476 0 011.5 8zM9 8a1 1 0 11-2 0 1 1 0 012 0zm-1 6.5a6.476 6.476 0 01-4.43-1.744L10 10l2.756-6.43A6.5 6.5 0 018 14.5z"
});

function SvgCompass6(props) {
  return /*#__PURE__*/createElement("svg", _extends$6P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6P);
}

function _extends$6Q() { _extends$6Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Q.apply(this, arguments); }

var _ref$6Q = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm1.345 5h1.014a2.505 2.505 0 01-1.624 2.665 2.502 2.502 0 01-3.204-1.494 1.502 1.502 0 00-1.923-.896A1.502 1.502 0 004.655 12H3.642a2.505 2.505 0 011.624-2.665 2.502 2.502 0 013.204 1.494 1.502 1.502 0 001.923.896A1.502 1.502 0 0011.346 10z"
});

function SvgConfused(props) {
  return /*#__PURE__*/createElement("svg", _extends$6Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6Q);
}

function _extends$6R() { _extends$6R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6R.apply(this, arguments); }

var _ref$6R = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm5.735 8.665a2.502 2.502 0 01-3.204-1.494 1.502 1.502 0 00-1.923-.896A1.502 1.502 0 004.655 12H3.642a2.505 2.505 0 011.624-2.665 2.502 2.502 0 013.204 1.494 1.502 1.502 0 001.923.896A1.502 1.502 0 0011.346 10h1.014a2.505 2.505 0 01-1.624 2.665z"
});

function SvgConfused2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6R);
}

function _extends$6S() { _extends$6S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6S.apply(this, arguments); }

var _ref$6S = /*#__PURE__*/createElement("path", {
  d: "M10 9c1.654 0 3.154.673 4.241 1.759l-1.414 1.414C12.103 11.449 11.103 11 10 11s-2.103.449-2.827 1.173l-1.414-1.414A5.982 5.982 0 0110 9zM2.929 7.929C4.818 6.04 7.329 5 10 5s5.182 1.04 7.071 2.929l-1.414 1.414C14.146 7.832 12.137 7 10 7s-4.146.832-5.657 2.343L2.929 7.929zM15.45 2.101a13.966 13.966 0 014.45 3l-1.414 1.414C16.219 4.249 13.206 3 10.001 3S3.782 4.248 1.516 6.515L.102 5.101A13.955 13.955 0 0110.002 1c1.89 0 3.723.37 5.45 1.101zM9 14a1 1 0 112 0 1 1 0 01-2 0z"
});

function SvgConnection(props) {
  return /*#__PURE__*/createElement("svg", _extends$6S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$6S);
}

function _extends$6T() { _extends$6T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6T.apply(this, arguments); }

var _ref$6T = /*#__PURE__*/createElement("path", {
  d: "M10 9c1.654 0 3.154.673 4.241 1.759l-1.414 1.414C12.103 11.449 11.103 11 10 11s-2.103.449-2.827 1.173l-1.414-1.414A5.982 5.982 0 0110 9z"
});

var _ref2$1l = /*#__PURE__*/createElement("path", {
  d: "M2.929 7.929C4.818 6.04 7.329 5 10 5s5.182 1.04 7.071 2.929l-1.414 1.414C14.146 7.832 12.137 7 10 7s-4.146.832-5.657 2.343L2.929 7.929zM9 14a1 1 0 112 0 1 1 0 01-2 0zM13.125 3.409c.084.022.167.046.25.07v-2.07a10.116 10.116 0 00-.25-.06v2.06zM12.625 3.286l.25.058v-2.05a18.413 18.413 0 00-.25-.05v2.041zM14.625 3.92c.084.035.167.071.25.108V1.873a18.408 18.408 0 00-.25-.091V3.92zM13.625 3.554c.084.026.167.054.25.082V1.542a18.227 18.227 0 00-.25-.07v2.081zM14.125 3.725c.084.031.167.062.25.095V1.698a18.268 18.268 0 00-.25-.08v2.107zM11.125 3.052c.084.008.167.016.25.026V1.067l-.25-.022v2.007zM10.125 3.001l.25.005V1.005a10.421 10.421 0 00-.25-.004v2zM12.125 3.187c.084.015.167.03.25.047V1.2a10.018 10.018 0 00-.25-.04v2.027zM11.625 3.108c.084.011.167.023.25.036V1.123a10.658 10.658 0 00-.25-.031v2.015zM10.625 3.016c.084.004.167.009.25.015V1.026l-.25-.013v2.002zM19.125 5.875l.25-.25V4.602a17.177 17.177 0 00-.25-.221v1.493zM18.625 6.375l.25-.25V4.171a15.696 15.696 0 00-.25-.201v2.405zM18.125 6.169c.084.078.168.157.25.237V3.779a14.515 14.515 0 00-.25-.183v2.573zM19.625 4.834v.541l.25-.25v-.049a14.327 14.327 0 00-.25-.243zM15.125 1.968v2.175c.084.04.167.08.25.122V2.07a10.9 10.9 0 00-.25-.102zM15.625 4.394c.084.045.167.09.25.137V2.289a18.963 18.963 0 00-.25-.113v2.217zM16.125 4.675c.084.05.167.101.25.153V2.532c-.083-.042-.166-.084-.25-.124v2.268zM17.125 5.341c.084.062.167.126.25.19V3.096c-.083-.051-.166-.102-.25-.151v2.396zM17.625 5.733c.084.069.167.14.25.212V3.422c-.083-.056-.166-.112-.25-.166v2.477zM16.625 4.99c.084.056.167.113.25.171v-2.36a12.166 12.166 0 00-.25-.138V4.99zM3.125 5.161c.083-.058.166-.115.25-.171V2.663c-.084.045-.167.091-.25.138v2.36zM9.625 3.006c.083-.003.167-.004.25-.005v-2l-.25.004v2.001zM3.625 4.829c.083-.052.166-.103.25-.153V2.408a19.37 19.37 0 00-.25.124v2.296zM2.125 5.945c.083-.072.166-.143.25-.212V3.256l-.25.166v2.523zM4.125 2.289v2.242c.083-.047.166-.092.25-.137V2.177a11.23 11.23 0 00-.25.113zM.125 5.125l.25.25v-.542c-.084.08-.168.161-.25.243v.049zM1.625 6.406c.082-.08.166-.159.25-.237V3.596c-.084.06-.167.121-.25.183v2.627zM4.625 4.264c.083-.042.166-.082.25-.122V1.967a10.9 10.9 0 00-.25.102v2.195zM.625 5.625l.25.25V4.382c-.084.072-.167.146-.25.221v1.023zM1.125 6.125l.25.25V3.97c-.084.066-.167.133-.25.201v1.954zM2.625 5.532c.083-.065.166-.128.25-.19V2.946l-.25.151v2.435zM5.125 4.028c.083-.037.166-.073.25-.108V1.782c-.084.029-.167.06-.25.091v2.155zM8.625 3.078l.25-.026V1.045l-.25.022v2.011zM9.125 3.031c.083-.006.166-.011.25-.015V1.014l-.25.013v2.005zM7.625 3.234c.083-.017.166-.032.25-.047V1.16l-.25.04v2.034zM8.125 3.145c.083-.013.166-.025.25-.036V1.094l-.25.031v2.021zM6.125 3.637c.083-.028.166-.056.25-.082V1.474c-.084.022-.167.046-.25.07v2.093zM5.625 3.819l.25-.095V1.617l-.25.08v2.122zM7.125 3.345c.083-.02.166-.04.25-.058V1.246l-.25.05v2.05zM6.625 3.479l.25-.07v-2.06c-.084.019-.167.039-.25.06v2.07z"
});

function SvgConnection2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$6T, _ref2$1l);
}

function _extends$6U() { _extends$6U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6U.apply(this, arguments); }

var _ref$6U = /*#__PURE__*/createElement("path", {
  d: "M10 9c1.654 0 3.154.673 4.241 1.759l-1.414 1.414C12.103 11.449 11.103 11 10 11s-2.103.449-2.827 1.173l-1.414-1.414A5.982 5.982 0 0110 9zM9 14a1 1 0 112 0 1 1 0 01-2 0zM13.125 3.409c.084.022.167.046.25.07v-2.07a10.116 10.116 0 00-.25-.06v2.06zM12.625 3.286l.25.058v-2.05a18.413 18.413 0 00-.25-.05v2.041zM14.625 3.92c.084.035.167.071.25.108V1.873a18.408 18.408 0 00-.25-.091V3.92zM13.625 3.554c.084.026.167.054.25.082V1.542a18.227 18.227 0 00-.25-.07v2.081zM14.125 3.725c.084.031.167.062.25.095V1.698a18.268 18.268 0 00-.25-.08v2.107zM11.125 3.052c.084.008.167.016.25.026V1.067l-.25-.022v2.007zM10.125 3.001l.25.005V1.005a10.421 10.421 0 00-.25-.004v2zM12.125 3.187c.084.015.167.03.25.047V1.2a10.018 10.018 0 00-.25-.04v2.027zM11.625 3.108c.084.011.167.023.25.036V1.123a10.658 10.658 0 00-.25-.031v2.015zM10.625 3.016c.084.004.167.009.25.015V1.026l-.25-.013v2.002zM19.125 5.875l.25-.25V4.602a17.177 17.177 0 00-.25-.221v1.493zM18.625 6.375l.25-.25V4.171a15.696 15.696 0 00-.25-.201v2.405zM18.125 6.169c.084.078.168.157.25.237V3.779a14.515 14.515 0 00-.25-.183v2.573zM19.625 4.834v.541l.25-.25v-.049a14.327 14.327 0 00-.25-.243zM15.125 1.968v2.175c.084.04.167.08.25.122V2.07a10.9 10.9 0 00-.25-.102zM15.625 4.394c.084.045.167.09.25.137V2.289a18.963 18.963 0 00-.25-.113v2.217zM16.125 4.675c.084.05.167.101.25.153V2.532c-.083-.042-.166-.084-.25-.124v2.268zM17.125 5.341c.084.062.167.126.25.19V3.096c-.083-.051-.166-.102-.25-.151v2.396zM17.625 5.733c.084.069.167.14.25.212V3.422c-.083-.056-.166-.112-.25-.166v2.477zM16.625 4.99c.084.056.167.113.25.171v-2.36a12.166 12.166 0 00-.25-.138V4.99zM3.125 5.161c.083-.058.166-.115.25-.171V2.663c-.084.045-.167.091-.25.138v2.36zM9.625 3.006c.083-.003.167-.004.25-.005v-2l-.25.004v2.001zM3.625 4.829c.083-.052.166-.103.25-.153V2.408a19.37 19.37 0 00-.25.124v2.296zM2.125 5.945c.083-.072.166-.143.25-.212V3.256l-.25.166v2.523zM4.125 2.289v2.242c.083-.047.166-.092.25-.137V2.177a11.23 11.23 0 00-.25.113zM.125 5.125l.25.25v-.542c-.084.08-.168.161-.25.243v.049zM1.625 6.406c.082-.08.166-.159.25-.237V3.596c-.084.06-.167.121-.25.183v2.627zM4.625 4.264c.083-.042.166-.082.25-.122V1.967a10.9 10.9 0 00-.25.102v2.195zM.625 5.625l.25.25V4.382c-.084.072-.167.146-.25.221v1.023zM1.125 6.125l.25.25V3.97c-.084.066-.167.133-.25.201v1.954zM2.625 5.532c.083-.065.166-.128.25-.19V2.946l-.25.151v2.435zM5.125 4.028c.083-.037.166-.073.25-.108V1.782c-.084.029-.167.06-.25.091v2.155zM8.625 3.078l.25-.026V1.045l-.25.022v2.011zM9.125 3.031c.083-.006.166-.011.25-.015V1.014l-.25.013v2.005zM7.625 3.234c.083-.017.166-.032.25-.047V1.16l-.25.04v2.034zM8.125 3.145c.083-.013.166-.025.25-.036V1.094l-.25.031v2.021zM6.125 3.637c.083-.028.166-.056.25-.082V1.474c-.084.022-.167.046-.25.07v2.093zM5.625 3.819l.25-.095V1.617l-.25.08v2.122zM7.125 3.345c.083-.02.166-.04.25-.058V1.246l-.25.05v2.05zM6.625 3.479l.25-.07v-2.06c-.084.019-.167.039-.25.06v2.07zM12.125 7.284c.084.023.167.047.25.073V5.283a10.09 10.09 0 00-.25-.057v2.058zM12.625 7.439c.084.029.167.059.25.091V5.418a10.247 10.247 0 00-.25-.071v2.092zM11.125 7.079c.084.012.167.024.25.039V5.095c-.083-.011-.166-.022-.25-.031V7.08zM10.625 7.024c.084.006.167.014.25.023V5.038a10.133 10.133 0 00-.25-.018v2.004zM11.625 7.165c.084.017.167.036.25.056V5.176c-.083-.016-.166-.03-.25-.044v2.033zM13.125 7.631c.084.036.167.073.25.111V5.581a7.35 7.35 0 00-.25-.085v2.136zM13.625 7.864c.084.043.167.087.25.133V5.775a7.679 7.679 0 00-.25-.101v2.19zM16.125 8.875l.25-.25v-1.33a9.552 9.552 0 00-.25-.201v1.781zM16.625 7.51v.865l.25-.25v-.387a10.754 10.754 0 00-.25-.229zM15.625 9.312l.032.031.218-.218V6.906c-.083-.06-.166-.119-.25-.176v2.583zM14.125 8.142c.084.051.167.104.25.158V6.003c-.083-.04-.166-.08-.25-.118v2.257zM15.125 8.857c.085.071.168.143.25.218V6.564a9.375 9.375 0 00-.25-.155v2.448zM10.125 7.002c.084.001.167.003.25.007V5.008a10.302 10.302 0 00-.25-.006v2zM14.625 8.47c.084.06.168.122.25.185V6.263a12.04 12.04 0 00-.25-.135v2.341zM7.125 7.53c.083-.032.166-.062.25-.091V5.347c-.084.023-.167.046-.25.071V7.53zM4.625 9.075c.082-.075.165-.147.25-.218V6.409c-.084.05-.167.102-.25.155v2.511zM4.125 9.125l.218.218.032-.031V6.729c-.084.057-.167.116-.25.176v2.219zM5.125 8.656c.082-.063.166-.125.25-.185V6.13a12.04 12.04 0 00-.25.135v2.392zM5.625 8.3a8.09 8.09 0 01.25-.158V5.885a8.114 8.114 0 00-.25.118V8.3zM3.625 8.625l.25.25V7.094c-.084.066-.168.133-.25.201v1.33zM3.125 8.125l.25.25V7.51c-.084.075-.168.151-.25.229v.387zM9.125 7.048c.083-.009.166-.017.25-.023V5.021c-.084.005-.167.011-.25.018v2.009zM6.125 7.998c.083-.046.166-.09.25-.133v-2.19c-.084.033-.167.066-.25.101v2.222zM9.625 7.009c.083-.004.166-.006.25-.007v-2c-.084.001-.167.003-.25.006v2.001zM8.125 7.22c.083-.02.166-.038.25-.056V5.131c-.084.014-.167.028-.25.044V7.22zM8.625 7.117c.083-.014.166-.027.25-.039V5.062c-.084.009-.167.02-.25.031v2.023zM6.625 7.743c.083-.038.166-.075.25-.111V5.496c-.084.027-.167.056-.25.085v2.161zM7.625 7.357c.083-.026.166-.05.25-.073V5.226a10.09 10.09 0 00-.25.057v2.074z"
});

function SvgConnection3(props) {
  return /*#__PURE__*/createElement("svg", _extends$6U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$6U);
}

function _extends$6V() { _extends$6V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6V.apply(this, arguments); }

var _ref$6V = /*#__PURE__*/createElement("path", {
  d: "M9 14a1 1 0 112 0 1 1 0 01-2 0zM13.125 3.409c.084.022.167.046.25.07v-2.07a10.116 10.116 0 00-.25-.06v2.06zM12.625 3.286l.25.058v-2.05a18.413 18.413 0 00-.25-.05v2.041zM14.625 3.92c.084.035.167.071.25.108V1.873a18.408 18.408 0 00-.25-.091V3.92zM13.625 3.554c.084.026.167.054.25.082V1.542a18.227 18.227 0 00-.25-.07v2.081zM14.125 3.725c.084.031.167.062.25.095V1.698a18.268 18.268 0 00-.25-.08v2.107zM11.125 3.052c.084.008.167.016.25.026V1.067l-.25-.022v2.007zM10.125 3.001l.25.005V1.005a10.421 10.421 0 00-.25-.004v2zM12.125 3.187c.084.015.167.03.25.047V1.2a10.018 10.018 0 00-.25-.04v2.027zM11.625 3.108c.084.011.167.023.25.036V1.123a10.658 10.658 0 00-.25-.031v2.015zM10.625 3.016c.084.004.167.009.25.015V1.026l-.25-.013v2.002zM19.125 5.875l.25-.25V4.602a17.177 17.177 0 00-.25-.221v1.493zM18.625 6.375l.25-.25V4.171a15.696 15.696 0 00-.25-.201v2.405zM18.125 6.169c.084.078.168.157.25.237V3.779a14.515 14.515 0 00-.25-.183v2.573zM19.625 4.834v.541l.25-.25v-.049a14.327 14.327 0 00-.25-.243zM15.125 1.968v2.175c.084.04.167.08.25.122V2.07a10.9 10.9 0 00-.25-.102zM15.625 4.394c.084.045.167.09.25.137V2.289a18.963 18.963 0 00-.25-.113v2.217zM16.125 4.675c.084.05.167.101.25.153V2.532c-.083-.042-.166-.084-.25-.124v2.268zM17.125 5.341c.084.062.167.126.25.19V3.096c-.083-.051-.166-.102-.25-.151v2.396zM17.625 5.733c.084.069.167.14.25.212V3.422c-.083-.056-.166-.112-.25-.166v2.477zM16.625 4.99c.084.056.167.113.25.171v-2.36a12.166 12.166 0 00-.25-.138V4.99zM3.125 5.161c.083-.058.166-.115.25-.171V2.663c-.084.045-.167.091-.25.138v2.36zM9.625 3.006c.083-.003.167-.004.25-.005v-2l-.25.004v2.001zM3.625 4.829c.083-.052.166-.103.25-.153V2.408a19.37 19.37 0 00-.25.124v2.296zM2.125 5.945c.083-.072.166-.143.25-.212V3.256l-.25.166v2.523zM4.125 2.289v2.242c.083-.047.166-.092.25-.137V2.177a11.23 11.23 0 00-.25.113zM.125 5.125l.25.25v-.542c-.084.08-.168.161-.25.243v.049zM1.625 6.406c.082-.08.166-.159.25-.237V3.596c-.084.06-.167.121-.25.183v2.627zM4.625 4.264c.083-.042.166-.082.25-.122V1.967a10.9 10.9 0 00-.25.102v2.195zM.625 5.625l.25.25V4.382c-.084.072-.167.146-.25.221v1.023zM1.125 6.125l.25.25V3.97c-.084.066-.167.133-.25.201v1.954zM2.625 5.532c.083-.065.166-.128.25-.19V2.946l-.25.151v2.435zM5.125 4.028c.083-.037.166-.073.25-.108V1.782c-.084.029-.167.06-.25.091v2.155zM8.625 3.078l.25-.026V1.045l-.25.022v2.011zM9.125 3.031c.083-.006.166-.011.25-.015V1.014l-.25.013v2.005zM7.625 3.234c.083-.017.166-.032.25-.047V1.16l-.25.04v2.034zM8.125 3.145c.083-.013.166-.025.25-.036V1.094l-.25.031v2.021zM6.125 3.637c.083-.028.166-.056.25-.082V1.474c-.084.022-.167.046-.25.07v2.093zM5.625 3.819l.25-.095V1.617l-.25.08v2.122zM7.125 3.345c.083-.02.166-.04.25-.058V1.246l-.25.05v2.05zM6.625 3.479l.25-.07v-2.06c-.084.019-.167.039-.25.06v2.07zM12.125 7.284c.084.023.167.047.25.073V5.283a10.09 10.09 0 00-.25-.057v2.058zM12.625 7.439c.084.029.167.059.25.091V5.418a10.247 10.247 0 00-.25-.071v2.092zM11.125 7.079c.084.012.167.024.25.039V5.095c-.083-.011-.166-.022-.25-.031V7.08zM10.625 7.024c.084.006.167.014.25.023V5.038a10.133 10.133 0 00-.25-.018v2.004zM11.625 7.165c.084.017.167.036.25.056V5.176c-.083-.016-.166-.03-.25-.044v2.033zM13.125 7.631c.084.036.167.073.25.111V5.581a7.35 7.35 0 00-.25-.085v2.136zM13.625 7.864c.084.043.167.087.25.133V5.775a7.679 7.679 0 00-.25-.101v2.19zM16.125 8.875l.25-.25v-1.33a9.552 9.552 0 00-.25-.201v1.781zM16.625 7.51v.865l.25-.25v-.387a10.754 10.754 0 00-.25-.229zM15.625 9.312l.032.031.218-.218V6.906c-.083-.06-.166-.119-.25-.176v2.583zM14.125 8.142c.084.051.167.104.25.158V6.003c-.083-.04-.166-.08-.25-.118v2.257zM15.125 8.857c.085.071.168.143.25.218V6.564a9.375 9.375 0 00-.25-.155v2.448zM10.125 7.002c.084.001.167.003.25.007V5.008a10.302 10.302 0 00-.25-.006v2zM14.625 8.47c.084.06.168.122.25.185V6.263a12.04 12.04 0 00-.25-.135v2.341zM7.125 7.53c.083-.032.166-.062.25-.091V5.347c-.084.023-.167.046-.25.071V7.53zM4.625 9.075c.082-.075.165-.147.25-.218V6.409c-.084.05-.167.102-.25.155v2.511zM4.125 9.125l.218.218.032-.031V6.729c-.084.057-.167.116-.25.176v2.219zM5.125 8.656c.082-.063.166-.125.25-.185V6.13a12.04 12.04 0 00-.25.135v2.392zM5.625 8.3a8.09 8.09 0 01.25-.158V5.885a8.114 8.114 0 00-.25.118V8.3zM3.625 8.625l.25.25V7.094c-.084.066-.168.133-.25.201v1.33zM3.125 8.125l.25.25V7.51c-.084.075-.168.151-.25.229v.387zM9.125 7.048c.083-.009.166-.017.25-.023V5.021c-.084.005-.167.011-.25.018v2.009zM6.125 7.998c.083-.046.166-.09.25-.133v-2.19c-.084.033-.167.066-.25.101v2.222zM9.625 7.009c.083-.004.166-.006.25-.007v-2c-.084.001-.167.003-.25.006v2.001zM8.125 7.22c.083-.02.166-.038.25-.056V5.131c-.084.014-.167.028-.25.044V7.22zM8.625 7.117c.083-.014.166-.027.25-.039V5.062c-.084.009-.167.02-.25.031v2.023zM6.625 7.743c.083-.038.166-.075.25-.111V5.496c-.084.027-.167.056-.25.085v2.161zM7.625 7.357c.083-.026.166-.05.25-.073V5.226a10.09 10.09 0 00-.25.057v2.074zM10.125 11.002c.084.003.167.008.25.016V9.012a5.17 5.17 0 00-.25-.01v2.001zM11.125 11.161c.084.025.168.052.25.082V9.159a6.929 6.929 0 00-.25-.053v2.055zM10.625 11.049c.084.013.168.029.25.048V9.064a6.825 6.825 0 00-.25-.032v2.017zM12.125 11.613c.086.054.169.111.25.171V9.491a5.437 5.437 0 00-.25-.101v2.224zM11.625 11.345c.085.038.168.079.25.122V9.3a7.216 7.216 0 00-.25-.077v2.122zM12.625 11.984c.069.061.137.123.202.189l.048-.048v-2.39a5.9 5.9 0 00-.25-.129v2.379zM14.125 10.647v.228l.116-.116-.116-.112zM13.625 11.375l.25-.25v-.702a6.865 6.865 0 00-.25-.201v1.153zM13.125 11.875l.25-.25v-1.583a5.931 5.931 0 00-.25-.162v1.995zM9.625 11.018a4.14 4.14 0 01.25-.016V9.001a6.87 6.87 0 00-.25.01v2.006zM6.625 11.625l.25.25V9.88a5.931 5.931 0 00-.25.162v1.583zM9.125 11.097c.082-.018.166-.034.25-.048V9.033a5.172 5.172 0 00-.25.032v2.033zM5.875 10.875v-.228a6.13 6.13 0 00-.116.112l.116.116zM7.125 12.125l.048.048c.065-.065.133-.128.202-.189V9.605a5.9 5.9 0 00-.25.129v2.39zM6.125 11.125l.25.25v-1.153a6.865 6.865 0 00-.25.201v.702zM7.625 11.784c.081-.06.164-.117.25-.171V9.389a6.864 6.864 0 00-.25.101v2.293zM8.625 11.244a4.06 4.06 0 01.25-.082V9.107a6.929 6.929 0 00-.25.053v2.084zM8.125 11.468c.082-.044.165-.084.25-.122V9.224a5.54 5.54 0 00-.25.077v2.167z"
});

function SvgConnection4(props) {
  return /*#__PURE__*/createElement("svg", _extends$6V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$6V);
}

function _extends$6W() { _extends$6W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6W.apply(this, arguments); }

var _ref$6W = /*#__PURE__*/createElement("path", {
  d: "M16 6.5v-4c0-.275-.225-.5-.5-.5H.5c-.275 0-.5.225-.5.5v4c0 .275.225.5.5.5h1.88L0 14h3l1.02-3h7.96L13 14h3l-2.38-7h1.88c.275 0 .5-.225.5-.5zM13 3l-3 3H7l3-3h3zM4 3h3L4 6H1l3-3zm7.64 7H4.361l1.02-3h5.239l1.02 3zM15 6h-2l2-2v2z"
});

function SvgConstruction(props) {
  return /*#__PURE__*/createElement("svg", _extends$6W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6W);
}

function _extends$6X() { _extends$6X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6X.apply(this, arguments); }

var _ref$6X = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 016-6v12a6 6 0 01-6-6z"
});

function SvgContrast(props) {
  return /*#__PURE__*/createElement("svg", _extends$6X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6X);
}

function _extends$6Y() { _extends$6Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Y.apply(this, arguments); }

var _ref$6Y = /*#__PURE__*/createElement("path", {
  d: "M12 2c-.526 0-1.046.104-1.528.303A3 3 0 008 1a3 3 0 00-2.472 1.303A4.004 4.004 0 000 6c0 1.957.875 2.832 1.646 3.604C2.372 10.33 3 10.958 3 12.5v3a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-3c0-1.543.627-2.17 1.354-2.896C15.126 8.832 16 7.958 16 6c0-2.206-1.794-4-4-4zm0 13H4v-2h8v2zm1.646-6.104c-.703.703-1.491 1.491-1.626 3.104H3.979c-.135-1.613-.923-2.401-1.626-3.104C1.627 8.17.999 7.542.999 6c0-1.654 1.346-3 3-3 .039 0 .177.006.179.006.821.058.821.526.821.994v.5a.5.5 0 001 0V4c0-1.103.897-2 2-2s2 .897 2 2v.5a.5.5 0 001 0V4c0-.468 0-.936.821-.994.002 0 .14-.006.179-.006 1.654 0 3 1.346 3 3 0 1.543-.627 2.17-1.354 2.896z"
});

function SvgCook(props) {
  return /*#__PURE__*/createElement("svg", _extends$6Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6Y);
}

function _extends$6Z() { _extends$6Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Z.apply(this, arguments); }

var _ref$6Z = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM12.5 4c.275 0 .5.225.5.5V6c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1H7c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5V5h2v-.5c0-.275.225-.5.5-.5h3zM8 12a3.996 3.996 0 003.43-1.942l.857.515a4.996 4.996 0 01-6.406 1.957l.518-.864c.49.214 1.031.334 1.6.334z"
});

function SvgCool(props) {
  return /*#__PURE__*/createElement("svg", _extends$6Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6Z);
}

function _extends$6_() { _extends$6_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6_.apply(this, arguments); }

var _ref$6_ = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 13a4.984 4.984 0 01-2.118-.47l.518-.864a3.996 3.996 0 005.03-1.608l.858.515A4.996 4.996 0 018 13zm5-7c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1H7c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5V5h2v-.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5V6z"
});

function SvgCool2(props) {
  return /*#__PURE__*/createElement("svg", _extends$6_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6_);
}

function _extends$6$() { _extends$6$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6$.apply(this, arguments); }

var _ref$6$ = /*#__PURE__*/createElement("path", {
  d: "M13.5 2h-1v1h.5v8H9v4H3V3h.5V2h-1c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5h7.875L14 12.375V2.5c0-.275-.225-.5-.5-.5zM10 15v-3h3l-3 3zm2-13h-2V1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1H4v2h8V2zM9 2H7v-.998L7.002 1h1.996L9 1.002V2z"
});

function SvgCopy(props) {
  return /*#__PURE__*/createElement("svg", _extends$6$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$6$);
}

function _extends$70() { _extends$70 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$70.apply(this, arguments); }

var _ref$70 = /*#__PURE__*/createElement("path", {
  d: "M13.5 2c.275 0 .5.225.5.5V12l-4 4H2.5a.501.501 0 01-.5-.5v-13c0-.275.225-.5.5-.5h1v1H3v12h6v-4h4V3h-.5V2h1zM12 2h-2V1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1H4v2h8V2zM9 2H7v-.998L7.002 1h1.996L9 1.002V2z"
});

function SvgCopy2(props) {
  return /*#__PURE__*/createElement("svg", _extends$70({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$70);
}

function _extends$71() { _extends$71 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$71.apply(this, arguments); }

var _ref$71 = /*#__PURE__*/createElement("path", {
  d: "M10 4V0H3L0 3v9h6v4h10V4h-6zM3 1.414V3H1.414L3 1.414zM1 11V4h3V1h5v3L6 7v4H1zm8-5.586V7H7.414L9 5.414zM15 15H7V8h3V5h5v10z"
});

function SvgCopy3(props) {
  return /*#__PURE__*/createElement("svg", _extends$71({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$71);
}

function _extends$72() { _extends$72 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$72.apply(this, arguments); }

var _ref$72 = /*#__PURE__*/createElement("path", {
  d: "M13 4h-3V3L7 0H0v12h6v4h10V7l-3-3zm0 1.414L14.586 7H13V5.414zm-6-4L8.586 3H7V1.414zM1 1h5v3h3v7H1V1zm14 14H7v-3h3V5h2v3h3v7z"
});

function SvgCopy4(props) {
  return /*#__PURE__*/createElement("svg", _extends$72({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$72);
}

function _extends$73() { _extends$73 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$73.apply(this, arguments); }

var _ref$73 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2h-13C.675 2 0 2.675 0 3.5v9c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm-13 1h13c.271 0 .5.229.5.5V5H1V3.5c0-.271.229-.5.5-.5zm13 10h-13a.507.507 0 01-.5-.5V8h14v4.5c0 .271-.229.5-.5.5zM2 10h1v2H2zm2 0h1v2H4zm2 0h1v2H6z"
});

function SvgCreditCard(props) {
  return /*#__PURE__*/createElement("svg", _extends$73({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$73);
}

function _extends$74() { _extends$74 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$74.apply(this, arguments); }

var _ref$74 = /*#__PURE__*/createElement("path", {
  d: "M14.5 2h-13C.675 2 0 2.675 0 3.5v9c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM3 12H2v-2h1v2zm2 0H4v-2h1v2zm2 0H6v-2h1v2zm8.5-4H.5V5h15v3z"
});

function SvgCreditCard2(props) {
  return /*#__PURE__*/createElement("svg", _extends$74({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$74);
}

function _extends$75() { _extends$75 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$75.apply(this, arguments); }

var _ref$75 = /*#__PURE__*/createElement("path", {
  d: "M13 4l3-3-1-1-3 3H5V0H3v3H0v2h3v8h8v3h2v-3h3v-2h-3V4zM5 5h5l-5 5V5zm1 6l5-5v5H6z"
});

function SvgCrop(props) {
  return /*#__PURE__*/createElement("svg", _extends$75({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$75);
}

function _extends$76() { _extends$76 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$76.apply(this, arguments); }

var _ref$76 = /*#__PURE__*/createElement("path", {
  d: "M5 11V0H3v3H0v2h3v8h8v3h2v-3h3v-2z"
});

var _ref2$1m = /*#__PURE__*/createElement("path", {
  d: "M11 10h2V3H6v2h5z"
});

function SvgCrop2(props) {
  return /*#__PURE__*/createElement("svg", _extends$76({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$76, _ref2$1m);
}

function _extends$77() { _extends$77 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$77.apply(this, arguments); }

var _ref$77 = /*#__PURE__*/createElement("path", {
  d: "M15.854 12.854L11 8l4.854-4.854a.503.503 0 000-.707L13.561.146a.499.499 0 00-.707 0L8 5 3.146.146a.5.5 0 00-.707 0L.146 2.439a.499.499 0 000 .707L5 8 .146 12.854a.5.5 0 000 .707l2.293 2.293a.499.499 0 00.707 0L8 11l4.854 4.854a.5.5 0 00.707 0l2.293-2.293a.499.499 0 000-.707z"
});

function SvgCross(props) {
  return /*#__PURE__*/createElement("svg", _extends$77({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$77);
}

function _extends$78() { _extends$78 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$78.apply(this, arguments); }

var _ref$78 = /*#__PURE__*/createElement("path", {
  d: "M13.957 3.457l-1.414-1.414L8 6.586 3.457 2.043 2.043 3.457 6.586 8l-4.543 4.543 1.414 1.414L8 9.414l4.543 4.543 1.414-1.414L9.414 8z"
});

function SvgCross2(props) {
  return /*#__PURE__*/createElement("svg", _extends$78({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$78);
}

function _extends$79() { _extends$79 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$79.apply(this, arguments); }

var _ref$79 = /*#__PURE__*/createElement("path", {
  d: "M12.207 10.793l-1.414 1.414L8 9.414l-2.793 2.793-1.414-1.414L6.586 8 3.793 5.207l1.414-1.414L8 6.586l2.793-2.793 1.414 1.414L9.414 8l2.793 2.793z"
});

function SvgCross3(props) {
  return /*#__PURE__*/createElement("svg", _extends$79({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$79);
}

function _extends$7a() { _extends$7a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7a.apply(this, arguments); }

var _ref$7a = /*#__PURE__*/createElement("path", {
  d: "M4 12h8v2H4zm11-9a1 1 0 00-.832 1.555L10.5 7l-.376-3.008a1 1 0 10-.571-.098L8 7 6.447 3.894a1 1 0 10-.571.098L5.5 7 1.832 4.555a1 1 0 10-.438.364L4 11h8l2.606-6.081A1 1 0 1015 3z"
});

function SvgCrown(props) {
  return /*#__PURE__*/createElement("svg", _extends$7a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7a);
}

function _extends$7b() { _extends$7b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7b.apply(this, arguments); }

var _ref$7b = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$1n = /*#__PURE__*/createElement("path", {
  d: "M12.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zM5.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zM9.5 13.375a.502.502 0 01-.354-.146C9.074 13.157 8.686 13 8 13s-1.075.157-1.146.229a.5.5 0 01-.707-.707c.471-.471 1.453-.521 1.854-.521s1.383.051 1.854.521a.5.5 0 01-.354.853zM11.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM11.5 12a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM4.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM4.5 12a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z"
});

function SvgCrying(props) {
  return /*#__PURE__*/createElement("svg", _extends$7b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7b, _ref2$1n);
}

function _extends$7c() { _extends$7c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7c.apply(this, arguments); }

var _ref$7c = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM5 11.5a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm0-3a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zM5.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zm4.354 7.229a.498.498 0 01-.708 0C9.074 13.157 8.686 13 8 13s-1.075.157-1.146.229a.5.5 0 01-.707-.707c.471-.471 1.453-.521 1.854-.521s1.383.051 1.854.521a.5.5 0 010 .707zM12 11.5a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm0-3a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zm.5-2.5h-2a.5.5 0 010-1h2a.5.5 0 010 1z"
});

function SvgCrying2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7c);
}

function _extends$7d() { _extends$7d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7d.apply(this, arguments); }

var _ref$7d = /*#__PURE__*/createElement("path", {
  d: "M2.381.758l-.537 2.686h10.934l-.342 1.735H1.496l-.53 2.686h10.933l-.61 3.063-4.406 1.46-3.819-1.46.261-1.329H.639L0 12.823l6.316 2.417 7.281-2.417L16 .757z"
});

function SvgCss3(props) {
  return /*#__PURE__*/createElement("svg", _extends$7d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7d);
}

function _extends$7e() { _extends$7e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7e.apply(this, arguments); }

var _ref$7e = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a.5.5 0 01-.377-.171l-3.124-3.57-3.124 3.57a.5.5 0 11-.753-.659l3.5-4a.502.502 0 01.752 0l3.5 4a.5.5 0 01-.376.83z"
});

function SvgCtrl(props) {
  return /*#__PURE__*/createElement("svg", _extends$7e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7e);
}

function _extends$7f() { _extends$7f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7f.apply(this, arguments); }

var _ref$7f = /*#__PURE__*/createElement("path", {
  d: "M7.5 1L0 4v7l7.5 4 7.5-4V4L7.5 1zM7 13.6l-6-3.2V5.533l6 3.2V13.6zM1.297 4.558L7.5 2.077l6.203 2.481L7.5 7.866 1.297 4.558z"
});

function SvgCube(props) {
  return /*#__PURE__*/createElement("svg", _extends$7f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7f);
}

function _extends$7g() { _extends$7g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7g.apply(this, arguments); }

var _ref$7g = /*#__PURE__*/createElement("path", {
  d: "M7.5 1L0 4v7l7.5 4 7.5-4V4L7.5 1zM7 13.6l-6-3.2V5.533l6 3.2V13.6zM1.297 4.558L7.5 2.077l6.203 2.481L7.5 7.866 1.297 4.558zM14 10.4l-6 3.2V8.733l6-3.2V10.4z"
});

function SvgCube2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7g);
}

function _extends$7h() { _extends$7h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7h.apply(this, arguments); }

var _ref$7h = /*#__PURE__*/createElement("path", {
  d: "M7.625 0h-.251L-.001 3.951v7.129l7.348 4.921h.304l7.348-4.921V3.951L7.624 0zm5.816 4.25L11.05 5.531 8.393 4.108l2.391-1.281 2.657 1.423zM7.5 1.067l2.391 1.281L7.5 3.629 5.109 2.348 7.5 1.067zm-3.285 1.76l2.391 1.281-2.657 1.423L1.558 4.25l2.657-1.423zm-1.136 9.111L1 10.545V8.121l2.079 1.3v2.517zm0-3.512L1 7.126V5.084l2.079 1.114v2.227zM7 14.563l-3.077-2.06V9.949L7 11.872v2.692zm0-3.686L3.923 8.954V6.651L7 8.299v2.577zm.5-3.444L4.843 6.01 7.5 4.587l2.657 1.423L7.5 7.433zm3.577 5.07L8 14.563v-2.692l3.077-1.923v2.554zm0-3.549L8 10.877V8.3l3.077-1.648v2.303zM14 10.546l-2.079 1.392V9.421L14 8.121v2.424zm0-3.419l-2.079 1.3V6.2L14 5.086v2.042z"
});

function SvgCube3(props) {
  return /*#__PURE__*/createElement("svg", _extends$7h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7h);
}

function _extends$7i() { _extends$7i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7i.apply(this, arguments); }

var _ref$7i = /*#__PURE__*/createElement("path", {
  d: "M7.625 0h-.251L-.001 3.951v7.129l7.348 4.921h.304l7.348-4.921V3.951L7.624 0zm-1.28 14.125l-.373-.25H7v.25h-.655zm.655.25v.188l-.281-.188H7zm-1.401-.75l-.373-.25h1.775v.25H5.6zm-.747-.5l-.373-.25H7v.25H4.852zm-.747-.5l-.373-.25H7v.25H4.105zm-.746-.5l-.373-.25h4.015v.25H3.36zm-.747-.5l-.373-.25H7v.25H2.612zm-.747-.5l-.373-.25H7v.25H1.865zm-.746-.5L1 10.546v-.171h6v.25H1.119zm-.119-.5v-.25h6v.25H1zm0-.5v-.25h6v.25H1zm0-.5v-.25h6v.25H1zm0-.5v-.25h6v.25H1zm0-.5v-.25h5.208l.467.25H1zm0-.5v-.25h4.274l.467.25H1zm0-.5v-.25h3.341l.467.25H1zm0-.5v-.25h2.408l.467.25H1.001zm0-.5v-.25h1.474l.467.25H1zm0-.5v-.25h.541l.467.25H1zm0-.5v-.04l.074.04H1zm6.5 2.308L1.559 4.25 7.5 1.067l5.941 3.183L7.5 7.433z"
});

function SvgCube4(props) {
  return /*#__PURE__*/createElement("svg", _extends$7i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7i);
}

function _extends$7j() { _extends$7j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7j.apply(this, arguments); }

var _ref$7j = /*#__PURE__*/createElement("path", {
  d: "M14.063 7H.5a.5.5 0 00-.5.5c0 1.525.311 3.02.899 4.324.578 1.282 1.407 2.346 2.397 3.078.086.064.19.098.297.098H1.499a.5.5 0 000 1h10a.5.5 0 000-1H9.405a.497.497 0 00.297-.098c.911-.674 1.686-1.63 2.254-2.777h.105c1.584 0 2.539-.553 3.061-1.017.627-.557 1.001-1.322 1.001-2.045A2.065 2.065 0 0014.06 7zm-2.702 4H1.638a9.626 9.626 0 01-.627-3h10.976a9.598 9.598 0 01-.627 3zm3.015-.733c-.337.299-.939.65-1.945.72.309-.902.496-1.871.551-2.862h1.08a.94.94 0 01.938.938c0 .314-.164.796-.624 1.205zM4.5 6a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM6.5 6a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM8.5 6a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
});

function SvgCup(props) {
  return /*#__PURE__*/createElement("svg", _extends$7j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$7j);
}

function _extends$7k() { _extends$7k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7k.apply(this, arguments); }

var _ref$7k = /*#__PURE__*/createElement("path", {
  d: "M14.063 7H.5a.5.5 0 00-.5.5c0 1.525.311 3.02.899 4.324.578 1.282 1.407 2.346 2.397 3.078.086.064.19.098.297.098H1.499a.5.5 0 000 1h10a.5.5 0 000-1H9.405a.497.497 0 00.297-.098c.911-.674 1.686-1.63 2.254-2.777h.105c1.584 0 2.539-.553 3.061-1.017.627-.557 1.001-1.322 1.001-2.045A2.065 2.065 0 0014.06 7zm.313 3.267c-.337.299-.939.65-1.945.72.309-.902.496-1.871.551-2.862h1.08a.94.94 0 01.938.938c0 .314-.164.796-.624 1.205zM4.5 6a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM6.5 6a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM8.5 6a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
});

function SvgCup2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$7k);
}

function _extends$7l() { _extends$7l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7l.apply(this, arguments); }

var _ref$7l = /*#__PURE__*/createElement("path", {
  d: "M10.119 7.589L0 0v12.649l3.158-2.978L6.316 16l2.683-1.342-3.158-6.329z"
});

function SvgCursor(props) {
  return /*#__PURE__*/createElement("svg", _extends$7l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7l);
}

function _extends$7m() { _extends$7m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7m.apply(this, arguments); }

var _ref$7m = /*#__PURE__*/createElement("path", {
  d: "M5.819 16.018l-2.694-5.509-3.124 3.006V0l10.59 8.104-4.221.745 2.696 5.513-3.246 1.656zM3.42 8.837l2.85 5.828 1.464-.747-2.848-5.823 3.288-.58L1 2.025v9.141l2.42-2.328z"
});

function SvgCursor2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7m);
}

function _extends$7n() { _extends$7n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7n.apply(this, arguments); }

var _ref$7n = /*#__PURE__*/createElement("path", {
  d: "M16 9h-2V7h-2v2h-2v2h2v2h2v-2h2z"
});

var _ref2$1o = /*#__PURE__*/createElement("path", {
  d: "M10 12v.5c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51c-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062 1.33 0 2.549-.215 3.5-.572V9.085l-.158.06c-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062s3.505-.42 4.5-1.062v2.062h1v-3.5c0-1.381-2.462-2.5-5.5-2.5S0 3.118 0 4.499v8c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-.5h-1zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$7n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7n, _ref2$1o);
}

function _extends$7o() { _extends$7o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7o.apply(this, arguments); }

var _ref$7o = /*#__PURE__*/createElement("path", {
  d: "M10 1.5c2.123.449 3.5 2.853 3.5 5 0 2.406-1.993 4.246-4.5 4.369V8l-3.5 4L9 16v-2.891c3.356-.216 6-2.714 6-5.609 0-2.664-2.028-5.494-5-6z"
});

var _ref2$1p = /*#__PURE__*/createElement("path", {
  d: "M6 13.677c-.165.007-.332.01-.5.01-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.905.584 2.347.984 4 1.052V9.646c-1.058-.042-2.052-.216-2.842-.5-.762-.275-1.074-.562-1.158-.677V5.938C1.995 6.581 3.64 7 5.5 7s3.505-.42 4.5-1.062V9h1V4.5C11 3.119 8.538 2 5.5 2S0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.169 0 .335-.004.5-.01v-1.312zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$7o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7o, _ref2$1p);
}

function _extends$7p() { _extends$7p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7p.apply(this, arguments); }

var _ref$7p = /*#__PURE__*/createElement("path", {
  d: "M6 9l-1.5 1.5 4 4L16 6l-1-1-6.5 6z"
});

var _ref2$1q = /*#__PURE__*/createElement("path", {
  d: "M2.158 13.177c-.763-.275-1.074-.562-1.158-.677V9.906c.717.463 1.771.81 3 .968v-1.31a8.674 8.674 0 01-1.842-.419C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062s3.505-.42 4.5-1.062v2.062l1-.923V4.5C11 3.119 8.538 2 5.5 2S0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.169 0 .335-.004.5-.01v-1.312c-.165.007-.332.01-.5.01-1.242 0-2.429-.181-3.342-.51zm.244-9.354c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$7p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7p, _ref2$1q);
}

function _extends$7q() { _extends$7q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7q.apply(this, arguments); }

var _ref$7q = /*#__PURE__*/createElement("path", {
  d: "M9 14h6v2H9v-2zM15 9h-2V7h-2v2H9v2h2v2h2v-2h2z"
});

var _ref2$1r = /*#__PURE__*/createElement("path", {
  d: "M8 13.421c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.9 0 1.75-.098 2.5-.273V9.389c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062 3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5S0 3.118 0 4.499v8c0 1.381 2.462 2.5 5.5 2.5.9 0 1.75-.098 2.5-.273V13.42zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseDiff(props) {
  return /*#__PURE__*/createElement("svg", _extends$7q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7q, _ref2$1r);
}

function _extends$7r() { _extends$7r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7r.apply(this, arguments); }

var _ref$7r = /*#__PURE__*/createElement("path", {
  d: "M15.531 5.929l-1.696-1.06a1.004 1.004 0 00-1.378.318l-.48.769 3.392 2.12.48-.769a1.004 1.004 0 00-.318-1.378zM8.052 12.237L8.059 16l3.385-1.643 3.295-5.274-3.392-2.12z"
});

var _ref2$1s = /*#__PURE__*/createElement("path", {
  d: "M5.5 7C8.538 7 11 5.881 11 4.5S8.538 2 5.5 2 0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.52 0 1.023-.033 1.5-.094v-1.31c-.48.06-.985.091-1.5.091-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.9 0 1.75-.098 2.5-.273V9.389c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$7r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7r, _ref2$1s);
}

function _extends$7s() { _extends$7s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7s.apply(this, arguments); }

var _ref$7s = /*#__PURE__*/createElement("path", {
  d: "M15.531 5.929l-1.696-1.06a1.004 1.004 0 00-1.378.318l-4.405 7.049.007 3.763 3.385-1.643 4.405-7.049a1.004 1.004 0 00-.318-1.378zm-1.06 1.696l-3.444 5.512-1.696-1.06 3.444-5.512 1.696 1.06z"
});

var _ref2$1t = /*#__PURE__*/createElement("path", {
  d: "M5.5 7C8.538 7 11 5.881 11 4.5S8.538 2 5.5 2 0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.52 0 1.023-.033 1.5-.094v-1.31c-.48.06-.985.091-1.5.091-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.9 0 1.75-.099 2.5-.273V9.389c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseEdit2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7s, _ref2$1t);
}

function _extends$7t() { _extends$7t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7t.apply(this, arguments); }

var _ref$7t = /*#__PURE__*/createElement("path", {
  d: "M16 10l-3-3.5V9H9v2h4v2.5z"
});

var _ref2$1u = /*#__PURE__*/createElement("path", {
  d: "M10 12v.5c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51c-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.9 0 1.75-.099 2.5-.273V9.389c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062s3.505-.42 4.5-1.062v2.062h1v-3.5c0-1.381-2.462-2.5-5.5-2.5S0 3.118 0 4.499v8c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-.5h-1zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseExport(props) {
  return /*#__PURE__*/createElement("svg", _extends$7t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7t, _ref2$1u);
}

function _extends$7u() { _extends$7u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7u.apply(this, arguments); }

var _ref$7u = /*#__PURE__*/createElement("path", {
  d: "M7.5 10L4 6.5V9H0v2h4v2.5z"
});

var _ref2$1v = /*#__PURE__*/createElement("path", {
  d: "M10.5 2C7.462 2 5 3.119 5 4.5S7.462 7 10.5 7c1.86 0 3.505-.42 4.5-1.062v2.531c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51-.889 0-1.748-.093-2.5-.266v1.306c.75.174 1.6.273 2.5.273 1.86 0 3.505-.42 4.5-1.062v2.594c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51a5.362 5.362 0 01-.158-.06v1.311c.951.357 2.17.571 3.5.571 3.038 0 5.5-1.119 5.5-2.5v-8C16 3.119 13.538 2 10.5 2zm3.098 3.177c-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.995-.562-1.074-.677.078-.115.367-.402 1.074-.677.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677z"
});

function SvgDatabaseInsert(props) {
  return /*#__PURE__*/createElement("svg", _extends$7u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7u, _ref2$1v);
}

function _extends$7v() { _extends$7v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7v.apply(this, arguments); }

var _ref$7v = /*#__PURE__*/createElement("path", {
  d: "M5 2C2.239 2 0 3.119 0 4.5v8C0 13.881 2.239 15 5 15s5-1.119 5-2.5v-8C10 3.119 7.761 2 5 2zm4 6.576c-.141.142-.431.36-.962.57-.83.329-1.909.51-3.038.51s-2.208-.181-3.038-.51c-.53-.21-.821-.428-.962-.57V6c.912.607 2.364 1 4 1s3.088-.393 4-1v2.576zM2.184 3.823c.769-.329 1.77-.51 2.816-.51s2.047.181 2.816.51c.643.275.905.562.976.677-.071.115-.333.402-.976.677-.769.329-1.77.51-2.816.51s-2.047-.181-2.816-.51c-.643-.275-.905-.562-.976-.677.071-.115.333-.402.976-.677zm5.854 9.354c-.83.329-1.909.51-3.038.51s-2.208-.181-3.038-.51c-.53-.21-.821-.428-.962-.57V9.969c.912.607 2.364 1 4 1s3.088-.393 4-1v2.638c-.141.142-.431.36-.962.57zM11 5h5v2h-5V5zM11 8h5v2h-5V8zM11 11h5v2h-5v-2z"
});

function SvgDatabaseMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$7v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7v);
}

function _extends$7w() { _extends$7w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7w.apply(this, arguments); }

var _ref$7w = /*#__PURE__*/createElement("path", {
  d: "M14.422 7.078a4.502 4.502 0 00-7.346 2.594h1.54A3.005 3.005 0 0111.5 7.5c.7 0 1.344.241 1.855.645L11.5 10H16V5.5l-1.578 1.578zM11.5 13.5a2.98 2.98 0 01-1.855-.645L11.5 11H7v4.5l1.578-1.578a4.502 4.502 0 007.346-2.594h-1.54A3.005 3.005 0 0111.5 13.5z"
});

var _ref2$1w = /*#__PURE__*/createElement("path", {
  d: "M2.158 9.146C1.396 8.871 1.084 8.584 1 8.469V5.938C1.995 6.581 3.64 7 5.5 7c.169 0 .335-.004.5-.01V5.676c-.165.008-.332.012-.5.012-1.152 0-2.252-.181-3.098-.51-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.061.09-.252.287-.674.5h1.892c.072-.162.11-.329.11-.5 0-1.381-2.462-2.5-5.5-2.5S0 3.12 0 4.501v8c0 1.381 2.462 2.5 5.5 2.5.169 0 .335-.004.5-.01v-1.312c-.165.007-.332.01-.5.01-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.908c.995.643 2.64 1.062 4.5 1.062.169 0 .335-.004.5-.01V9.648c-.165.007-.332.01-.5.01-1.242 0-2.429-.181-3.342-.51z"
});

function SvgDatabaseRefresh(props) {
  return /*#__PURE__*/createElement("svg", _extends$7w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7w, _ref2$1w);
}

function _extends$7x() { _extends$7x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7x.apply(this, arguments); }

var _ref$7x = /*#__PURE__*/createElement("path", {
  d: "M16 8.414L14.586 7 12.5 9.086 10.414 7 9 8.414l2.086 2.086L9 12.586 10.414 14l2.086-2.086L14.586 14 16 12.586 13.914 10.5z"
});

var _ref2$1x = /*#__PURE__*/createElement("path", {
  d: "M8 13.421c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.9 0 1.75-.098 2.5-.273V9.389c-.752.173-1.611.266-2.5.266-1.242 0-2.429-.181-3.342-.51C1.396 8.87 1.084 8.583 1 8.468V5.937c.995.643 2.64 1.062 4.5 1.062 3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5S0 3.118 0 4.499v8c0 1.381 2.462 2.5 5.5 2.5.9 0 1.75-.098 2.5-.273V13.42zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseRemove(props) {
  return /*#__PURE__*/createElement("svg", _extends$7x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7x, _ref2$1x);
}

function _extends$7y() { _extends$7y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7y.apply(this, arguments); }

var _ref$7y = /*#__PURE__*/createElement("path", {
  d: "M5.5 7C8.538 7 11 5.881 11 4.5S8.538 2 5.5 2 0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.503 0 .99-.031 1.452-.088a5.701 5.701 0 01-.711-1.246c-.244.014-.491.022-.741.022-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.907c.995.643 2.64 1.062 4.5 1.062.114 0 .226-.002.338-.005.043-.459.141-.902.287-1.324-.206.01-.415.016-.625.016-1.242 0-2.429-.181-3.342-.51-.762-.275-1.074-.562-1.158-.677V5.938C1.995 6.581 3.64 7 5.5 7zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

var _ref2$1y = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.5 5h-3V9h1v2h2v1z"
});

function SvgDatabaseTime(props) {
  return /*#__PURE__*/createElement("svg", _extends$7y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7y, _ref2$1y);
}

function _extends$7z() { _extends$7z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7z.apply(this, arguments); }

var _ref$7z = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.688c-1.758 0-3.188-1.43-3.188-3.188s1.43-3.188 3.188-3.188 3.188 1.43 3.188 3.188-1.43 3.188-3.188 3.188z"
});

var _ref2$1z = /*#__PURE__*/createElement("path", {
  d: "M12 11V9h-1v3h3v-1zM5.5 7C8.538 7 11 5.881 11 4.5S8.538 2 5.5 2 0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c.503 0 .99-.031 1.452-.088a5.701 5.701 0 01-.711-1.246c-.244.014-.491.022-.741.022-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.907c.995.643 2.64 1.062 4.5 1.062.114 0 .226-.002.338-.005.043-.459.141-.902.287-1.324-.206.01-.415.016-.625.016-1.242 0-2.429-.181-3.342-.51-.762-.275-1.074-.562-1.158-.677V5.938C1.995 6.581 3.64 7 5.5 7zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

function SvgDatabaseTime2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7z, _ref2$1z);
}

function _extends$7A() { _extends$7A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7A.apply(this, arguments); }

var _ref$7A = /*#__PURE__*/createElement("path", {
  d: "M8.813 13.187c-.909.323-2.083.5-3.313.5-1.242 0-2.429-.181-3.342-.51-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062.12 0 .239-.002.357-.005l1.439-1.439c-.567.087-1.175.132-1.796.132-1.242 0-2.429-.181-3.342-.51-.762-.275-1.074-.562-1.158-.677V5.938C1.995 6.581 3.64 7 5.5 7s3.505-.42 4.5-1.062v.883l1-1V4.5C11 3.119 8.538 2 5.5 2S0 3.119 0 4.5v8C0 13.881 2.462 15 5.5 15c1.244 0 2.391-.188 3.313-.504v-1.309zM2.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.996-.562-1.074-.677.078-.115.367-.402 1.074-.677z"
});

var _ref2$1A = /*#__PURE__*/createElement("path", {
  d: "M11 7.5L7.5 11H10v4h2v-4h2.5z"
});

function SvgDatabaseUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$7A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7A, _ref2$1A);
}

function _extends$7B() { _extends$7B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7B.apply(this, arguments); }

var _ref$7B = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.582 0 0 1.119 0 2.5v2C0 5.881 3.582 7 8 7s8-1.119 8-2.5v-2C16 1.119 12.418 0 8 0z"
});

var _ref2$1B = /*#__PURE__*/createElement("path", {
  d: "M8 8.5C3.582 8.5 0 7.381 0 6v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5V6c0 1.381-3.582 2.5-8 2.5z"
});

var _ref3$9 = /*#__PURE__*/createElement("path", {
  d: "M8 13c-4.418 0-8-1.119-8-2.5v3C0 14.881 3.582 16 8 16s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
});

function SvgDatabase(props) {
  return /*#__PURE__*/createElement("svg", _extends$7B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7B, _ref2$1B, _ref3$9);
}

function _extends$7C() { _extends$7C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7C.apply(this, arguments); }

var _ref$7C = /*#__PURE__*/createElement("path", {
  d: "M16 3.5c0-.444-.157-1.106-.905-1.737-.444-.375-1.053-.702-1.809-.972C11.859.281 9.981.001 8 .001s-3.859.281-5.286.79c-.756.27-1.365.597-1.809.972C.157 2.395 0 3.056 0 3.5h-.003v9H0c0 .444.157 1.106.905 1.737.444.375 1.053.702 1.809.972 1.427.51 3.305.79 5.286.79s3.859-.281 5.286-.79c.756-.27 1.365-.597 1.809-.972.748-.632.905-1.293.905-1.737v-9zM3.612 2.597C4.804 2.212 6.362 2 8 2s3.196.212 4.388.597c1.165.377 1.546.781 1.607.903-.061.121-.442.526-1.607.903C11.196 4.788 9.638 5 8 5s-3.196-.212-4.388-.597c-1.165-.377-1.546-.781-1.607-.903.061-.121.442-.526 1.607-.903zm8.776 10.806C11.196 13.788 9.638 14 8 14s-3.196-.212-4.388-.597c-1.165-.376-1.546-.781-1.607-.903h-.003v-2.082c.22.103.457.201.711.291 1.427.51 3.305.79 5.286.79s3.859-.281 5.286-.79c.253-.09.489-.187.709-.29V12.5c-.061.121-.442.526-1.607.903zm0-4.5C11.196 9.288 9.638 9.5 8 9.5s-3.196-.212-4.388-.597C2.447 8.526 2.066 8.122 2.005 8h-.003V5.918c.22.103.457.201.711.291 1.427.51 3.305.79 5.286.79s3.859-.281 5.286-.79c.253-.09.489-.187.709-.29V8c-.061.121-.442.526-1.607.903z"
});

function SvgDatabase2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7C);
}

function _extends$7D() { _extends$7D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7D.apply(this, arguments); }

var _ref$7D = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.582 0 0 1.343 0 3v10c0 1.657 3.582 3 8 3s8-1.343 8-3V3c0-1.657-3.582-3-8-3zm7 13c0 .143-.311.666-1.694 1.185-.672.252-1.462.451-2.348.592-.935.148-1.93.223-2.957.223s-2.023-.075-2.957-.223c-.886-.141-1.676-.34-2.348-.592-1.383-.519-1.694-1.042-1.694-1.185V9.453c1.365.922 3.988 1.547 7 1.547s5.635-.624 7-1.547V13zm0-5c0 .143-.311.666-1.694 1.185-.672.252-1.462.451-2.348.592-.935.148-1.93.223-2.957.223s-2.023-.075-2.957-.223c-.886-.141-1.676-.34-2.348-.592C1.313 8.666 1.002 8.143 1.002 8V4.453C2.367 5.375 4.99 6 8.002 6s5.635-.624 7-1.547V8zm-1.245-4a7.8 7.8 0 01-.45.185c-.672.252-1.462.451-2.348.592C10.022 4.925 9.027 5 8 5s-2.023-.075-2.957-.223c-.886-.141-1.676-.34-2.348-.592A7.8 7.8 0 012.245 4C1.242 3.547 1 3.126 1 3c0-.143.311-.666 1.694-1.185.672-.252 1.462-.451 2.348-.592C5.977 1.075 6.972 1 7.999 1s2.023.075 2.957.223c.886.141 1.677.34 2.348.592 1.383.519 1.694 1.042 1.694 1.185 0 .126-.242.547-1.245 1z"
});

function SvgDatabase3(props) {
  return /*#__PURE__*/createElement("svg", _extends$7D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7D);
}

function _extends$7E() { _extends$7E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7E.apply(this, arguments); }

var _ref$7E = /*#__PURE__*/createElement("path", {
  d: "M7.5 2C4.462 2 2 3.119 2 4.5v8C2 13.881 4.462 15 7.5 15s5.5-1.119 5.5-2.5v-8C13 3.119 10.538 2 7.5 2zM4.402 3.823c.846-.329 1.946-.51 3.098-.51s2.252.181 3.098.51c.707.275.995.562 1.074.677-.078.115-.367.402-1.074.677-.846.329-1.946.51-3.098.51s-2.252-.181-3.098-.51c-.707-.275-.995-.562-1.074-.677.078-.115.367-.402 1.074-.677zM12 12.5c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51c-.763-.275-1.074-.562-1.158-.677V9.906c.995.643 2.64 1.062 4.5 1.062s3.505-.42 4.5-1.062V12.5zm0-4.031c-.084.115-.396.402-1.158.677-.913.329-2.1.51-3.342.51s-2.429-.181-3.342-.51C3.395 8.871 3.084 8.584 3 8.469V5.938C3.995 6.581 5.64 7 7.5 7s3.505-.42 4.5-1.062v2.531z"
});

function SvgDatabase4(props) {
  return /*#__PURE__*/createElement("svg", _extends$7E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7E);
}

function _extends$7F() { _extends$7F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7F.apply(this, arguments); }

var _ref$7F = /*#__PURE__*/createElement("path", {
  d: "M6.5 7C7.878 7 9 8.121 9 9.5S7.878 12 6.5 12 4 10.879 4 9.5 5.122 7 6.5 7zm0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM6.5 5a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM6.5 16a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM2 9.5a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1a.5.5 0 01.5.5zM13 9.5a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1a.5.5 0 01.5.5zM3.318 6.318a.5.5 0 01-.707 0l-.707-.707a.5.5 0 01.707-.707l.707.707a.5.5 0 010 .707zM11.096 14.096a.5.5 0 01-.707 0l-.707-.707a.5.5 0 01.707-.707l.707.707a.5.5 0 010 .707zM3.318 12.682a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707-.707l.707-.707a.5.5 0 01.707 0zM12.702 4.798c-.997-.997-1.308-2.402-.912-3.583a3.5 3.5 0 104.495 4.495c-1.181.396-2.586.084-3.583-.912z"
});

function SvgDayNight(props) {
  return /*#__PURE__*/createElement("svg", _extends$7F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7F);
}

function _extends$7G() { _extends$7G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7G.apply(this, arguments); }

var _ref$7G = /*#__PURE__*/createElement("path", {
  d: "M11.5 4c-.278 0-.55.025-.815.074 1.374.99 2.268 2.604 2.268 4.426s-.894 3.436-2.268 4.426A4.5 4.5 0 1011.5 4zM7.5 16a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM7.5 3a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM2.5 14a.5.5 0 01-.354-.853l1-1a.5.5 0 01.707.707l-1 1a.498.498 0 01-.354.146zM3.5 5a.502.502 0 01-.354-.146l-1-1a.5.5 0 01.707-.707l1 1A.5.5 0 013.499 5zM1.5 9h-1a.5.5 0 010-1h1a.5.5 0 010 1z"
});

var _ref2$1C = /*#__PURE__*/createElement("path", {
  d: "M7.5 13C5.019 13 3 10.981 3 8.5S5.019 4 7.5 4 12 6.019 12 8.5 9.981 13 7.5 13zm0-8C5.57 5 4 6.57 4 8.5S5.57 12 7.5 12 11 10.43 11 8.5 9.43 5 7.5 5z"
});

function SvgDayNight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7G, _ref2$1C);
}

function _extends$7H() { _extends$7H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7H.apply(this, arguments); }

var _ref$7H = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm8 15V8H1V1h7v7h7v7H8z"
});

function SvgDelicious(props) {
  return /*#__PURE__*/createElement("svg", _extends$7H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7H);
}

function _extends$7I() { _extends$7I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7I.apply(this, arguments); }

var _ref$7I = /*#__PURE__*/createElement("path", {
  d: "M16 4.5v-4L.5 16h4v-1H5v1h1.5v-2H7v2h1.5v-1H9v1h1.5v-2h.5v2h1.5v-1h.5v1h3v-3h-1v-.5h1V11h-2v-.5h2V9h-1v-.5h1V7h-2v-.5h2V5h-1v-.5h1zM13 13H7.5L13 7.5V13zM9.5 0l-8 8L0 12l4-1.5 8-8C12 1 11 0 9.5 0zm-6 9l-1-1 7-7 1 1-7 7z"
});

function SvgDesign(props) {
  return /*#__PURE__*/createElement("svg", _extends$7I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7I);
}

function _extends$7J() { _extends$7J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7J.apply(this, arguments); }

var _ref$7J = /*#__PURE__*/createElement("path", {
  d: "M12.953 2.909V0h-2.909l-.291.294L8.378 2.91l-.431.291h-4.9v3.994h2.694l.241.291-2.934 5.606v2.909h2.909l.291-.294 1.375-2.616.431-.291h4.9V8.806H10.26l-.241-.294z"
});

function SvgDeviantart(props) {
  return /*#__PURE__*/createElement("svg", _extends$7J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7J);
}

function _extends$7K() { _extends$7K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7K.apply(this, arguments); }

var _ref$7K = /*#__PURE__*/createElement("path", {
  d: "M11.172 4l2.081 2.081-5.252 5.909-5.252-5.909L4.83 4h6.343zM12 2H4L0 6l8 9 8-9-4-4z"
});

function SvgDiamond(props) {
  return /*#__PURE__*/createElement("svg", _extends$7K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7K);
}

function _extends$7L() { _extends$7L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7L.apply(this, arguments); }

var _ref$7L = /*#__PURE__*/createElement("path", {
  d: "M12 2H4L0 6l8 9 8-9-4-4zM8 12.167v-.042h-.037l-.222-.25H8v-.25h-.481l-.222-.25h.704v-.25h-.926l-.222-.25h1.148v-.25h-1.37l-.222-.25h1.593v-.25H6.187l-.222-.25h2.037v-.25H5.743l-.222-.25h2.481v-.25H5.298l-.222-.25h2.926v-.25H4.854l-.222-.25h3.37v-.25H4.409l-.222-.25h3.815v-.25H3.965l-.222-.25h4.259v-.25H3.521l-.222-.25h4.704v-.25H3.077l-.222-.25h5.148v-.25h-5.37l-.115-.129 2.173-2.173h3.312v.052h3.364l.25.25H8.003v.25h3.864l.25.25H8.003v.25h4.364l.25.25H8.003v.25h4.864l.25.25H8.003v.25h5.364l.121.121-5.485 6.171z"
});

function SvgDiamond2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7L);
}

function _extends$7M() { _extends$7M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7M.apply(this, arguments); }

var _ref$7M = /*#__PURE__*/createElement("path", {
  d: "M8 .5L.5 8 8 15.5 15.5 8 8 .5zM2.5 8L8 2.5 13.5 8 8 13.5 2.5 8z"
});

function SvgDiamond3(props) {
  return /*#__PURE__*/createElement("svg", _extends$7M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7M);
}

function _extends$7N() { _extends$7N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7N.apply(this, arguments); }

var _ref$7N = /*#__PURE__*/createElement("path", {
  d: "M.5 8L8 .5 15.5 8 8 15.5.5 8z"
});

function SvgDiamond4(props) {
  return /*#__PURE__*/createElement("svg", _extends$7N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7N);
}

function _extends$7O() { _extends$7O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7O.apply(this, arguments); }

var _ref$7O = /*#__PURE__*/createElement("path", {
  d: "M8 0L3 8l5 8 5-8z"
});

function SvgDiamonds(props) {
  return /*#__PURE__*/createElement("svg", _extends$7O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7O);
}

function _extends$7P() { _extends$7P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7P.apply(this, arguments); }

var _ref$7P = /*#__PURE__*/createElement("path", {
  d: "M13.5 3h-8A2.507 2.507 0 003 5.5v8C3 14.875 4.125 16 5.5 16h8c1.375 0 2.5-1.125 2.5-2.5v-8C16 4.125 14.875 3 13.5 3zm-7 11a1.5 1.5 0 11.001-3.001A1.5 1.5 0 016.5 14zm0-6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 016.5 8zm3 3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 019.5 11zm3 3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 14zm0-6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 8zm.449-6A2.509 2.509 0 0010.5 0h-8A2.507 2.507 0 000 2.5v8c0 1.204.862 2.216 2 2.449V3c0-.55.45-1 1-1h9.949z"
});

function SvgDice(props) {
  return /*#__PURE__*/createElement("svg", _extends$7P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7P);
}

function _extends$7Q() { _extends$7Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Q.apply(this, arguments); }

var _ref$7Q = /*#__PURE__*/createElement("path", {
  d: "M13.5 6l2-2-2-2H9V.75A.753.753 0 008.25 0h-.5A.753.753 0 007 .75V2H2v4h5v1H1.5L0 8.5 1.5 10H7v6h2v-6h4V7H9V6h4.5z"
});

function SvgDirection(props) {
  return /*#__PURE__*/createElement("svg", _extends$7Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7Q);
}

function _extends$7R() { _extends$7R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7R.apply(this, arguments); }

var _ref$7R = /*#__PURE__*/createElement("path", {
  d: "M8 6.508c-.823 0-1.492.669-1.492 1.492S7.177 9.492 8 9.492 9.492 8.823 9.492 8 8.823 6.508 8 6.508z"
});

var _ref2$1D = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2.609 8c0 1.439-1.171 2.609-2.609 2.609S5.391 9.438 5.391 8 6.562 5.391 8 5.391 10.609 6.562 10.609 8zm-8.545 3.71l3.3-2.063c.25.399.589.738.988.988l-2.063 3.3a7.041 7.041 0 01-2.226-2.226zm8.572-5.357a3.138 3.138 0 00-.988-.988l2.063-3.3a7.041 7.041 0 012.226 2.226l-3.3 2.063z"
});

function SvgDisk(props) {
  return /*#__PURE__*/createElement("svg", _extends$7R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7R, _ref2$1D);
}

function _extends$7S() { _extends$7S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7S.apply(this, arguments); }

var _ref$7S = /*#__PURE__*/createElement("path", {
  d: "M8 6.508c-.823 0-1.492.669-1.492 1.492S7.177 9.492 8 9.492 9.492 8.823 9.492 8 8.823 6.508 8 6.508zM8 0a8 8 0 100 16A8 8 0 008 0zm5.733 3.874zm-.397-.5l-.108-.122c.037.04.073.081.108.122zm-.119-.134l-.107-.115.107.115zM3.141 13.125l.132.122a7.621 7.621 0 01-.132-.122zm.138.127l.139.122a5.272 5.272 0 01-.139-.122zm.977.738a5.368 5.368 0 01-.177-.115h.249l-.072.115zm.228-.365h-.755a6.778 6.778 0 00-.31-.25h1.222l-.156.25zm-.406.25a7.699 7.699 0 01-.175-.121c.058.041.116.082.175.121zm.719-.75H3.141l-.135-.131a8.212 8.212 0 01-.116-.119h2.063l-.156.25zm-2.134-.5l.109.123a4.34 4.34 0 01-.109-.123zm2.446 0H2.663a7.218 7.218 0 01-.208-.25h2.81l-.156.25zm.313-.5H2.267a6.51 6.51 0 01-.257-.381l.085.131h3.483l-.156.25zm.312-.5H2.2l.4-.25h3.291l-.156.25zm.313-.5H3l.4-.25h2.803l-.156.25zm7.202-6.405l.151-.095h-3.291l-.156.25H13l-.4.25H9.797l-.156.25H12.2l-.4.25H9.564c.115.076.223.159.325.25h1.51l-.4.25h-.862c.07.08.135.163.196.25h.266l-.188.118a2.844 2.844 0 01-3.919 3.919l-.133.213H3.8l.4-.25h2.236a2.832 2.832 0 01-.325-.25h-1.51l.988-.618a2.844 2.844 0 013.919-3.919l2.236-3.578a6.82 6.82 0 01.178.115l-.406.25h.755a7.232 7.232 0 01.31.25h-1.222l-.156.25h1.656a3.783 3.783 0 00.134.132l.116.119h-2.063l-.156.25h2.446c.071.082.141.165.208.25h-2.81l-.156.25h3.155c.09.124.176.251.257.381l-.741.463zm-.667-2.094l.139.121c-.046-.041-.092-.082-.139-.121zm-2.16 1.499l-.156.25H13.8l.19-.119-.085-.131h-3.483zM5.4 9.625l-.4.25h.862a2.952 2.952 0 01-.196-.25H5.4z"
});

function SvgDisk2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7S);
}

function _extends$7T() { _extends$7T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7T.apply(this, arguments); }

var _ref$7T = /*#__PURE__*/createElement("path", {
  d: "M0 1v10h16V1H0zm15 9H1V2h14v8zm-4.5 2h-5L5 14l-1 1h8l-1-1z"
});

function SvgDisplay(props) {
  return /*#__PURE__*/createElement("svg", _extends$7T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7T);
}

function _extends$7U() { _extends$7U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7U.apply(this, arguments); }

var _ref$7U = /*#__PURE__*/createElement("path", {
  d: "M0 1v10h16V1H0zm15 9H1V2h14v8zm-4.5 2h-5L5 14l-1 1h8l-1-1zm-9-4.875h13v.25h-13zm0-.5h13v.25h-13zm0 1h13v.25h-13zm0-1.5h13v.25h-13zm0 2h13v.25h-13zm0 1h13v.25h-13zm0-.5h13v.25h-13zm0-5.5h13v.25h-13zm0 2.5h13v.25h-13zm0-2h13v.25h-13zm0-1h13v.25h-13zm0 2.5h13v.25h-13zm0-.5h13v.25h-13zm0-.5h13v.25h-13z"
});

function SvgDisplay2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7U);
}

function _extends$7V() { _extends$7V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7V.apply(this, arguments); }

var _ref$7V = /*#__PURE__*/createElement("path", {
  d: "M1.5 7.375h8.906l-.438-.25H1.499zm0-.5h8.031l-.438-.25H1.499zm0-.5h7.156l-.438-.25H1.499zm0-.5h6.281l-.438-.25H1.499zm0 2h9.781l-.438-.25H1.499zm0 .5h10.656l-.438-.25H1.499zm0 .5h11.531l-.438-.25H1.499zm0-6h1.031l-.438-.25h-.594zm0 6.25v.25h12.406l-.438-.25zm0-5.75h1.906l-.438-.25H1.499zm0 .5h2.781l-.438-.25H1.499zm0 1h4.531l-.438-.25H1.499zm0-.5h3.656l-.438-.25H1.499zm0 1h5.406l-.438-.25H1.499zM0 1v10h16V1H0zm15 9H1V2h14v8zm-4.5 2h-5L5 14l-1 1h8l-1-1z"
});

function SvgDisplay3(props) {
  return /*#__PURE__*/createElement("svg", _extends$7V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7V);
}

function _extends$7W() { _extends$7W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7W.apply(this, arguments); }

var _ref$7W = /*#__PURE__*/createElement("path", {
  d: "M16 13V1H0v12h7v1H4v1h8v-1H9v-1h7zM2 3h12v8H2V3z"
});

function SvgDisplay4(props) {
  return /*#__PURE__*/createElement("svg", _extends$7W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7W);
}

function _extends$7X() { _extends$7X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7X.apply(this, arguments); }

var _ref$7X = /*#__PURE__*/createElement("path", {
  d: "M13 1h2v2h-2zm0 4h2v2h-2zM9 5h2v2H9zm4 4h2v2h-2zM9 9h2v2H9zM5 9h2v2H5zm4 4h2v2H9zm-4 0h2v2H5zm-4 0h2v2H1zm12 0h2v2h-2z"
});

function SvgDots(props) {
  return /*#__PURE__*/createElement("svg", _extends$7X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7X);
}

function _extends$7Y() { _extends$7Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Y.apply(this, arguments); }

var _ref$7Y = /*#__PURE__*/createElement("path", {
  d: "M8 9l4-4H9V1H7v4H4zm3.636-1.636l-1.121 1.121L14.579 10 8 12.453 1.421 10l4.064-1.515-1.121-1.121L0 9v4l8 3 8-3V9z"
});

function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$7Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7Y);
}

function _extends$7Z() { _extends$7Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7Z.apply(this, arguments); }

var _ref$7Z = /*#__PURE__*/createElement("path", {
  d: "M17.964 10.985l-5.43 6.21a.797.797 0 01-1.183.058l-.056-.059-5.43-6.21 1.237-1.413 3.938 4.501V-.013h1.75v14.086l3.936-4.5 1.238 1.412z"
});

var _ref2$1E = /*#__PURE__*/createElement("path", {
  d: "M21 12.75h2V18c0 1.45-1.343 2.625-3 2.625H4c-1.657 0-3-1.176-3-2.625v-5.25h2v4.812c0 .725.672 1.313 1.5 1.313h15c.828 0 1.5-.588 1.5-1.313V12.75z"
});

function SvgDownload11(props) {
  return /*#__PURE__*/createElement("svg", _extends$7Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22"
  }, props), _ref$7Z, _ref2$1E);
}

function _extends$7_() { _extends$7_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7_.apply(this, arguments); }

var _ref$7_ = /*#__PURE__*/createElement("path", {
  d: "M8 5V0H7v5H4.5l3 3 3-3z"
});

var _ref2$1F = /*#__PURE__*/createElement("path", {
  d: "M11 5.4v1.077l2.703 1.081L7.5 10.866 1.297 7.558 4 6.477V5.4L0 7v5l7.5 4 7.5-4V7l-4-1.6zm-4 9.2l-6-3.2V8.533l6 3.2V14.6zm7-3.2l-6 3.2v-2.867l6-3.2V11.4z"
});

function SvgDownload10(props) {
  return /*#__PURE__*/createElement("svg", _extends$7_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7_, _ref2$1F);
}

function _extends$7$() { _extends$7$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7$.apply(this, arguments); }

var _ref$7$ = /*#__PURE__*/createElement("path", {
  d: "M2.5 7L8 12.5 13.5 7H10V1H6v6z"
});

var _ref2$1G = /*#__PURE__*/createElement("path", {
  d: "M14 8v6H2V8H0v6.5c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5V8h-2z"
});

function SvgDownload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$7$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$7$, _ref2$1G);
}

function _extends$80() { _extends$80 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$80.apply(this, arguments); }

var _ref$80 = /*#__PURE__*/createElement("path", {
  d: "M2.5 7L8 12.5 13.5 7H10V1H6v6zM.284 15.375h15.432c.056-.078.106-.162.146-.25H.137c.041.088.09.172.146.25zM.903 15.875h14.194c.144-.063.276-.148.392-.25H.511c.116.102.248.187.392.25zM.048 14.875h15.904c.021-.081.035-.165.042-.25H.005c.007.085.021.169.042.25z"
});

var _ref2$1H = /*#__PURE__*/createElement("path", {
  d: "M15.875 14.125V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H1.875V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H0v.25h16v-.25z"
});

function SvgDownload3(props) {
  return /*#__PURE__*/createElement("svg", _extends$80({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$80, _ref2$1H);
}

function _extends$81() { _extends$81 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$81.apply(this, arguments); }

var _ref$81 = /*#__PURE__*/createElement("path", {
  d: "M14 11v2H2v-2H0v4h16v-4zm-2-5H9V1H7v5H4l4 6z"
});

function SvgDownload4(props) {
  return /*#__PURE__*/createElement("svg", _extends$81({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$81);
}

function _extends$82() { _extends$82 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$82.apply(this, arguments); }

var _ref$82 = /*#__PURE__*/createElement("path", {
  d: "M2 12h12v3H2v-3zM10 6V1H6v5H2.5L8 11.5 13.5 6z"
});

function SvgDownload5(props) {
  return /*#__PURE__*/createElement("svg", _extends$82({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$82);
}

function _extends$83() { _extends$83 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$83.apply(this, arguments); }

var _ref$83 = /*#__PURE__*/createElement("path", {
  d: "M3 16h10a3 3 0 003-3H0a3 3 0 003 3zm10-2h1v1h-1v-1zm-.5-10L8 8.5 3.5 4H7V0h2v4zm3.481 7.519c.077.264-.089.481-.368.481H.387c-.279 0-.445-.216-.368-.481L1.77 6.481A.714.714 0 012.417 6H3.5l4 4h1l4-4h1.083c.279 0 .57.216.647.481l1.751 5.038z"
});

function SvgDownload6(props) {
  return /*#__PURE__*/createElement("svg", _extends$83({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$83);
}

function _extends$84() { _extends$84 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$84.apply(this, arguments); }

var _ref$84 = /*#__PURE__*/createElement("path", {
  d: "M14 8h-2.5L8 11.5 4.5 8H2l-2 4v1h16v-1l-2-4zM0 14h16v1H0v-1zm9-9V1H7v4H3.5L8 9.5 12.5 5H9z"
});

function SvgDownload7(props) {
  return /*#__PURE__*/createElement("svg", _extends$84({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$84);
}

function _extends$85() { _extends$85 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$85.apply(this, arguments); }

var _ref$85 = /*#__PURE__*/createElement("path", {
  d: "M11.5 7l-4 4-4-4H6V1h3v6zm-4 4H0v4h15v-4H7.5zm6.5 2h-2v-1h2v1z"
});

function SvgDownload8(props) {
  return /*#__PURE__*/createElement("svg", _extends$85({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$85);
}

function _extends$86() { _extends$86 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$86.apply(this, arguments); }

var _ref$86 = /*#__PURE__*/createElement("path", {
  d: "M12.5 6H9V2H7v4H3.5L8 10zm-.889 2.322l-.525.462C12.832 9.134 14 9.771 14 10.5c0 1.105-2.686 2-6 2s-6-.895-6-2c0-.728 1.168-1.366 2.914-1.716l-.525-.462C1.785 8.817 0 9.83 0 11c0 1.657 3.582 3 8 3s8-1.343 8-3c0-1.17-1.785-2.183-4.389-2.678z"
});

function SvgDownload9(props) {
  return /*#__PURE__*/createElement("svg", _extends$86({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$86);
}

function _extends$87() { _extends$87 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$87.apply(this, arguments); }

var _ref$87 = /*#__PURE__*/createElement("path", {
  d: "M4 3V.5L.5 4 4 7.5V5h4V3zM17 3V.5L20.5 4 17 7.5V5h-4V3zM17.5 16H8a.5.5 0 01-.424-.235l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L9 12.119V4.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3.11l5.621 1.405A.5.5 0 0118 9.5v6a.5.5 0 01-.5.5zm-9.223-1H17V9.89l-1-.25v2.86a.5.5 0 01-1 0V9.39l-1-.25v2.36a.5.5 0 01-1 0V8.89l-1-.25v3.86a.5.5 0 01-1 0V5h-1v8.5a.5.5 0 01-.884.32l-2.212-2.655-.722.481 2.096 3.353z"
});

function SvgDragLeftRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$87({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16"
  }, props), _ref$87);
}

function _extends$88() { _extends$88 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$88.apply(this, arguments); }

var _ref$88 = /*#__PURE__*/createElement("path", {
  d: "M8.5 16H18a.5.5 0 00.424-.235l2.5-4a.5.5 0 00-.147-.681l-1.5-1a.5.5 0 00-.661.096L17 12.119V4.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v3.11L8.379 9.015A.5.5 0 008 9.5v6a.5.5 0 00.5.5zm9.223-1H9V9.89l1-.25v2.86a.5.5 0 001 0V9.39l1-.25v2.36a.5.5 0 001 0V8.89l1-.25v3.86a.5.5 0 001 0V5h1v8.5a.5.5 0 00.884.32l2.212-2.655.722.481-2.096 3.353z"
});

var _ref2$1I = /*#__PURE__*/createElement("path", {
  d: "M12 6.938a.5.5 0 00.437-.743A3.501 3.501 0 0115.5 1a3.504 3.504 0 013.063 5.195.5.5 0 10.875.485 4.503 4.503 0 00.563-2.18c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5c0 .763.195 1.517.563 2.181a.5.5 0 00.438.258zM.5 4L4 .5V3h6v2H4v2.5z"
});

function SvgDragLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$88({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16"
  }, props), _ref$88, _ref2$1I);
}

function _extends$89() { _extends$89 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$89.apply(this, arguments); }

var _ref$89 = /*#__PURE__*/createElement("path", {
  d: "M12.5 16H3a.5.5 0 01-.424-.235l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L4 12.119V4.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3.11l5.621 1.405A.5.5 0 0113 9.5v6a.5.5 0 01-.5.5zm-9.223-1H12V9.89l-1-.25v2.86a.5.5 0 01-1 0V9.39l-1-.25v2.36a.5.5 0 01-1 0V8.89l-1-.25v3.86a.5.5 0 01-1 0V5H5v8.5a.5.5 0 01-.884.32l-2.212-2.655-.722.481 2.096 3.353z"
});

var _ref2$1J = /*#__PURE__*/createElement("path", {
  d: "M9 6.938a.5.5 0 01-.437-.743A3.501 3.501 0 005.5 1a3.504 3.504 0 00-3.063 5.195.5.5 0 11-.875.485A4.503 4.503 0 01.999 4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5a4.51 4.51 0 01-.563 2.181.5.5 0 01-.438.258zM20.5 4L17 .5V3h-6v2h6v2.5z"
});

function SvgDragRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$89({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16"
  }, props), _ref$89, _ref2$1J);
}

function _extends$8a() { _extends$8a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8a.apply(this, arguments); }

var _ref$8a = /*#__PURE__*/createElement("path", {
  d: "M15.89 10.188l-4-5a.5.5 0 10-.781.625l3.89 4.863v.325h-3.5l-2 2h-3l-2-2h-3.5v-.325l3.89-4.863a.5.5 0 10-.781-.625l-4 5a.5.5 0 00-.11.312V15a1 1 0 001 1h14a1 1 0 001-1v-4.5a.497.497 0 00-.11-.312z"
});

var _ref2$1K = /*#__PURE__*/createElement("path", {
  d: "M8 11.5L11.5 8H9V3H7v5H4.5z"
});

function SvgDrawerIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$8a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8a, _ref2$1K);
}

function _extends$8b() { _extends$8b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8b.apply(this, arguments); }

var _ref$8b = /*#__PURE__*/createElement("path", {
  d: "M15.89 10.188l-4-5a.5.5 0 10-.781.625l3.89 4.863v.325h-3.5l-2 2h-3l-2-2h-3.5v-.325l3.89-4.863a.5.5 0 10-.781-.625l-4 5a.5.5 0 00-.11.312V15a1 1 0 001 1h14a1 1 0 001-1v-4.5a.497.497 0 00-.11-.312z"
});

var _ref2$1L = /*#__PURE__*/createElement("path", {
  d: "M8 .5L4.5 4H7v5h2V4h2.5z"
});

function SvgDrawerOut(props) {
  return /*#__PURE__*/createElement("svg", _extends$8b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8b, _ref2$1L);
}

function _extends$8c() { _extends$8c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8c.apply(this, arguments); }

var _ref$8c = /*#__PURE__*/createElement("path", {
  d: "M15.89 10.188l-4-5A.5.5 0 0011.5 5h-7a.497.497 0 00-.39.188l-4 5A.5.5 0 000 10.5V15a1 1 0 001 1h14a1 1 0 001-1v-4.5a.497.497 0 00-.11-.312zM15 11h-3.5l-2 2h-3l-2-2H1v-.325L4.74 6h6.519l3.74 4.675V11z"
});

var _ref2$1M = /*#__PURE__*/createElement("path", {
  d: "M11.5 8h-7a.5.5 0 010-1h7a.5.5 0 010 1zM12.5 10h-9a.5.5 0 010-1h9a.5.5 0 010 1z"
});

function SvgDrawer(props) {
  return /*#__PURE__*/createElement("svg", _extends$8c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8c, _ref2$1M);
}

function _extends$8d() { _extends$8d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8d.apply(this, arguments); }

var _ref$8d = /*#__PURE__*/createElement("path", {
  d: "M15.89 10.188l-4-5A.5.5 0 0011.5 5h-7a.497.497 0 00-.39.188l-4 5A.5.5 0 000 10.5V15a1 1 0 001 1h14a1 1 0 001-1v-4.5a.497.497 0 00-.11-.312zM15 11h-3.5l-2 2h-3l-2-2H1v-.325L4.74 6h6.519l3.74 4.675V11z"
});

function SvgDrawer2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8d);
}

function _extends$8e() { _extends$8e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8e.apply(this, arguments); }

var _ref$8e = /*#__PURE__*/createElement("path", {
  d: "M14.039 0l1.051 8.931-1.179.139-.938-7.976H3.029L2.091 9.07.912 8.931 1.963 0zM4 2h8v1H4zm0 2h8v1H4zm0 2h8v1H4zm0 2h8v1H4zm11.5 2H.5c-.275 0-.429.213-.342.474l1.684 5.051a.742.742 0 00.658.474h11a.742.742 0 00.658-.474l1.684-5.051c.087-.261-.067-.474-.342-.474zM10 12H6v-1h4v1z"
});

function SvgDrawer3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8e);
}

function _extends$8f() { _extends$8f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8f.apply(this, arguments); }

var _ref$8f = /*#__PURE__*/createElement("path", {
  d: "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8zm6.747-6.906c-.234-.075-2.116-.634-4.256-.291a29.7 29.7 0 011.328 4.872 6.845 6.845 0 002.928-4.581zM10.669 14.3c-.103-.6-.497-2.688-1.456-5.181-.016.006-.031.009-.044.016-3.856 1.344-5.241 4.016-5.362 4.266a6.807 6.807 0 006.863.9zm-7.747-1.722c.156-.266 2.031-3.369 5.553-4.509a7.04 7.04 0 01.269-.081 24.04 24.04 0 00-.553-1.159c-3.409 1.022-6.722.978-7.022.975-.003.069-.003.138-.003.209 0 1.753.666 3.356 1.756 4.566zM1.313 6.609c.306.003 3.122.016 6.319-.831a43.092 43.092 0 00-2.534-3.953 6.854 6.854 0 00-3.784 4.784zM6.4 1.366a36.612 36.612 0 012.55 4c2.431-.909 3.459-2.294 3.581-2.469A6.799 6.799 0 006.4 1.366zm6.891 2.325c-.144.194-1.291 1.663-3.816 2.694.159.325.313.656.453.991.05.119.1.234.147.353 2.275-.284 4.534.172 4.759.219a6.816 6.816 0 00-1.544-4.256z"
});

function SvgDribbble(props) {
  return /*#__PURE__*/createElement("svg", _extends$8f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8f);
}

function _extends$8g() { _extends$8g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8g.apply(this, arguments); }

var _ref$8g = /*#__PURE__*/createElement("path", {
  d: "M3 14h10a3 3 0 003-3H0a3 3 0 003 3zm10-2h1v1h-1v-1zm2-10H1l-1 8h16z"
});

function SvgDrive(props) {
  return /*#__PURE__*/createElement("svg", _extends$8g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8g);
}

function _extends$8h() { _extends$8h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8h.apply(this, arguments); }

var _ref$8h = /*#__PURE__*/createElement("path", {
  d: "M11.5.5L8 3.5l4.5 3 3.5-3zM8 3.5L4.5.5 0 3.5l3.5 3zM12.5 6.5l3.5 3-4.5 2.5L8 9zM8 9L3.5 6.5 0 9.5 4.5 12z"
});

var _ref2$1N = /*#__PURE__*/createElement("path", {
  d: "M11.377 13.212L8 10.317l-3.377 2.895L2.5 12.033V13.5L8 16l5.5-2.5v-1.467z"
});

function SvgDropbox(props) {
  return /*#__PURE__*/createElement("svg", _extends$8h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8h, _ref2$1N);
}

function _extends$8i() { _extends$8i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8i.apply(this, arguments); }

var _ref$8i = /*#__PURE__*/createElement("path", {
  d: "M13.51 7.393C12.483 4.527 10.305 1.953 8 0 5.695 1.953 3.518 4.527 2.49 7.393c-.635 1.772-.698 3.696.197 5.397C3.716 14.745 5.791 16 8 16s4.284-1.255 5.313-3.21c.895-1.701.832-3.624.197-5.397zm-9.496 4.699c-.794-1.509-.499-3.113-.112-4.192.431-1.201 1.121-2.422 2.052-3.629A19.875 19.875 0 018 2.015v12.486a4.553 4.553 0 01-3.986-2.408z"
});

function SvgDropletContrast(props) {
  return /*#__PURE__*/createElement("svg", _extends$8i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8i);
}

function _extends$8j() { _extends$8j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8j.apply(this, arguments); }

var _ref$8j = /*#__PURE__*/createElement("path", {
  d: "M13.51 7.393C12.483 4.527 10.305 1.953 8 0 5.695 1.953 3.518 4.527 2.49 7.393c-.635 1.772-.698 3.696.197 5.397C3.716 14.745 5.791 16 8 16s4.284-1.255 5.313-3.21c.895-1.701.832-3.624.197-5.397zm-1.967 4.466A4.045 4.045 0 018 14a4.03 4.03 0 01-2.377-.791c.207.027.416.041.627.041a5.056 5.056 0 004.428-2.676c.701-1.333.64-2.716.373-3.818.227.44.42.878.576 1.311.353.985.625 2.443-.084 3.791z"
});

function SvgDroplet(props) {
  return /*#__PURE__*/createElement("svg", _extends$8j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8j);
}

function _extends$8k() { _extends$8k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8k.apply(this, arguments); }

var _ref$8k = /*#__PURE__*/createElement("path", {
  d: "M8 2.014c.762.725 1.448 1.48 2.046 2.256.931 1.207 1.621 2.428 2.052 3.629.387 1.08.682 2.683-.112 4.192-.77 1.463-2.334 2.408-3.986 2.408s-3.216-.945-3.986-2.408c-.794-1.509-.499-3.113-.112-4.192.431-1.201 1.121-2.422 2.052-3.629A19.875 19.875 0 018 2.014zM8 0C5.695 1.953 3.518 4.527 2.49 7.393c-.635 1.772-.698 3.696.197 5.397C3.716 14.745 5.791 16 8 16s4.284-1.255 5.313-3.21c.895-1.701.832-3.624.197-5.397C12.483 4.527 10.305 1.953 8 0z"
});

function SvgDroplet2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8k);
}

function _extends$8l() { _extends$8l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8l.apply(this, arguments); }

var _ref$8l = /*#__PURE__*/createElement("path", {
  d: "M2.25 4h-.5a.25.25 0 00-.25.25v7.5c0 .137.113.25.25.25h.5a.25.25 0 00.25-.25v-7.5A.25.25 0 002.25 4zM.75 6h-.5C.112 6 0 6.075 0 6.167v3.667c0 .092.113.167.25.167h.5c.137 0 .25-.075.25-.167V6.167C1 6.075.887 6 .75 6zM12.5 3h-1c-.275 0-.5.225-.5.5V7H5V3.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5V9h6v3.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm1.75 1h-.5a.25.25 0 00-.25.25v7.5c0 .137.113.25.25.25h.5c.137 0 .25-.113.25-.25v-7.5a.25.25 0 00-.25-.25zm1.5 2h-.5c-.137 0-.25.075-.25.167v3.667c0 .092.113.167.25.167h.5c.137 0 .25-.075.25-.167V6.167c0-.092-.113-.167-.25-.167z"
});

function SvgDumbbell(props) {
  return /*#__PURE__*/createElement("svg", _extends$8l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8l);
}

function _extends$8m() { _extends$8m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8m.apply(this, arguments); }

var _ref$8m = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 15a6.96 6.96 0 01-2.769-.57l3.643-4.098A.503.503 0 009 10V8.5a.5.5 0 00-.5-.5C6.735 8 4.872 6.165 4.854 6.146A.5.5 0 004.5 6h-2a.5.5 0 00-.5.5v3a.5.5 0 00.276.447L4 10.809v2.936A6.992 6.992 0 011 8a6.97 6.97 0 01.674-3H3.5c.133 0 .26-.053.354-.146l2-2A.5.5 0 006 2.5V1.29A6.989 6.989 0 018 1c1.1 0 2.141.254 3.067.706A2.98 2.98 0 0010 3.999c0 .801.312 1.555.879 2.121a2.994 2.994 0 002.268.875c.216.809.605 2.917-.131 5.818a.466.466 0 00-.013.082 6.979 6.979 0 01-5.002 2.104z"
});

function SvgEarth(props) {
  return /*#__PURE__*/createElement("svg", _extends$8m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8m);
}

function _extends$8n() { _extends$8n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8n.apply(this, arguments); }

var _ref$8n = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM5.5 1.46V2L3 4.5H1.937A7.027 7.027 0 015.5 1.46zM8 10l-3.573 4.02A7.052 7.052 0 014 13.745V10.5L2 9V6.5a.5.5 0 01.5-.5H4s1.5 2 4 2.5V10zm6.049-2.332c-.247-.832-.461-.913-1.549-1.283a2.501 2.501 0 01-.813-4.336 6.997 6.997 0 012.346 9.502c.257-1.664.162-2.997.016-3.883z"
});

function SvgEarth2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8n);
}

function _extends$8o() { _extends$8o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8o.apply(this, arguments); }

var _ref$8o = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm7 8a6.975 6.975 0 01-.628 2.901c.291-2.803-.372-4.545-.407-4.634a.5.5 0 00-.565-.307A1.999 1.999 0 0110.999 4a2.004 2.004 0 011.01-1.738A6.992 6.992 0 0114.999 8zM5 1.674v.619L3.293 4H2.255A7.03 7.03 0 015 1.674zm-.276 8.379L3 9.191V7h1.301C4.784 7.444 6.318 8.737 8 8.965v.844l-3 3.375v-2.685a.5.5 0 00-.276-.447zM8 15a6.96 6.96 0 01-2.769-.57l3.643-4.098A.503.503 0 009 10V8.5a.5.5 0 00-.5-.5C6.735 8 4.872 6.165 4.854 6.146A.5.5 0 004.5 6h-2a.5.5 0 00-.5.5v3a.5.5 0 00.276.447L4 10.809v2.936A6.992 6.992 0 011 8a6.97 6.97 0 01.674-3H3.5c.133 0 .26-.053.354-.146l2-2A.5.5 0 006 2.5V1.29A6.989 6.989 0 018 1c1.1 0 2.141.254 3.067.706A2.98 2.98 0 0010 3.999c0 .801.312 1.555.879 2.121a2.994 2.994 0 002.268.875c.216.809.605 2.917-.131 5.818a.466.466 0 00-.013.082 6.979 6.979 0 01-5.002 2.104z"
});

function SvgEarth3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8o);
}

function _extends$8p() { _extends$8p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8p.apply(this, arguments); }

var _ref$8p = /*#__PURE__*/createElement("path", {
  d: "M.241 7.103C.71 3.403 3.235.047 7.76 0c2.731.053 4.978 1.291 6.316 3.65.672 1.231.881 2.525.925 3.953v1.678H4.96c.047 4.141 6.094 4 8.697 2.175v3.372c-1.525.916-4.984 1.734-7.662.681-2.281-.856-3.906-3.244-3.897-5.541-.075-2.978 1.481-4.95 3.897-6.072-.513.634-.903 1.334-1.106 2.547h5.669s.331-3.388-3.209-3.388C4.011 3.171 1.605 5.111.243 7.102z"
});

function SvgEdge(props) {
  return /*#__PURE__*/createElement("svg", _extends$8p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8p);
}

function _extends$8q() { _extends$8q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8q.apply(this, arguments); }

var _ref$8q = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 11.5a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$1O = /*#__PURE__*/createElement("path", {
  d: "M9.502 7.5c.311-.264.498-.612.498-1C10 5.659 9.121 5 8 5s-2 .659-2 1.5c0 .388.187.736.498 1-.311.264-.498.612-.498 1 0 .841.878 1.5 2 1.5s2-.659 2-1.5c0-.388-.187-.736-.498-1zM7 6.5c0-.204.39-.5 1-.5s1 .296 1 .5c0 .204-.389.5-1 .5-.61 0-1-.296-1-.5zM8 9c-.61 0-1-.296-1-.5S7.389 8 8 8c.61 0 1 .296 1 .5S8.61 9 8 9z"
});

function SvgEightBall(props) {
  return /*#__PURE__*/createElement("svg", _extends$8q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8q, _ref2$1O);
}

function _extends$8r() { _extends$8r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8r.apply(this, arguments); }

var _ref$8r = /*#__PURE__*/createElement("path", {
  d: "M0 12h16v2H0zM8 2l8 8H0z"
});

function SvgEject(props) {
  return /*#__PURE__*/createElement("svg", _extends$8r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8r);
}

function _extends$8s() { _extends$8s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8s.apply(this, arguments); }

var _ref$8s = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm4.885 9.212C12.31 11.442 10.301 13 8 13s-4.31-1.558-4.885-3.788a.708.708 0 01.685-.884c.322 0 .604.218.684.531a3.631 3.631 0 007.032 0 .707.707 0 111.369.354z"
});

function SvgEllo(props) {
  return /*#__PURE__*/createElement("svg", _extends$8s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8s);
}

function _extends$8t() { _extends$8t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8t.apply(this, arguments); }

var _ref$8t = /*#__PURE__*/createElement("path", {
  d: "M9 11.5l1.5 1.5 5-5-5-5L9 4.5 12.5 8zM7 4.5L5.5 3l-5 5 5 5L7 11.5 3.5 8z"
});

function SvgEmbed(props) {
  return /*#__PURE__*/createElement("svg", _extends$8t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8t);
}

function _extends$8u() { _extends$8u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8u.apply(this, arguments); }

var _ref$8u = /*#__PURE__*/createElement("path", {
  d: "M13 11.5l1.5 1.5 5-5-5-5L13 4.5 16.5 8zM7 4.5L5.5 3l-5 5 5 5L7 11.5 3.5 8zM10.958 2.352l1.085.296-3 11-1.085-.296 3-11z"
});

function SvgEmbed2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$8u);
}

function _extends$8v() { _extends$8v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8v.apply(this, arguments); }

var _ref$8v = /*#__PURE__*/createElement("path", {
  d: "M2 5H0V1a1 1 0 011-1h4v2H2v3zM16 5h-2V2h-3V0h4a1 1 0 011 1v4zM15 16h-4v-2h3v-3h2v4a1 1 0 01-1 1zM5 16H1a1 1 0 01-1-1v-4h2v3h3v2z"
});

function SvgEnlarge(props) {
  return /*#__PURE__*/createElement("svg", _extends$8v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8v);
}

function _extends$8w() { _extends$8w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8w.apply(this, arguments); }

var _ref$8w = /*#__PURE__*/createElement("path", {
  d: "M16 0H9.5L12 2.5l-3 3L10.5 7l3-3L16 6.5zM16 16V9.5L13.5 12l-3-3L9 10.5l3 3L9.5 16zM0 16h6.5L4 13.5l3-3L5.5 9l-3 3L0 9.5zM0 0v6.5L2.5 4l3 3L7 5.5l-3-3L6.5 0z"
});

function SvgEnlarge2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8w);
}

function _extends$8x() { _extends$8x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8x.apply(this, arguments); }

var _ref$8x = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 15H1V1h14v14zM10.5 2.5L15 1l-1.5 4.5zM5.25 4h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm-5 7h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zM4 10.25h1v.5H4zm0-1h1v.5H4zm0-1h1v.5H4zm0-1h1v.5H4zm0-1h1v.5H4zm0-1h1v.5H4zm7 5h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm-8.5.25L1 1l4.5 1.5zm3 8L1 15l1.5-4.5zm8-3L15 15l-4.5-1.5z"
});

function SvgEnlarge3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8x);
}

function _extends$8y() { _extends$8y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8y.apply(this, arguments); }

var _ref$8y = /*#__PURE__*/createElement("path", {
  d: "M16 5.5V0h-5.5zM5.5 0H0v5.5zM16 16v-5.5L10.5 16zM0 16h5.5L0 10.5z"
});

function SvgEnlarge4(props) {
  return /*#__PURE__*/createElement("svg", _extends$8y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8y);
}

function _extends$8z() { _extends$8z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8z.apply(this, arguments); }

var _ref$8z = /*#__PURE__*/createElement("path", {
  d: "M0 1v15h15V1H0zm14 14H1V2h13v13zM12.75 3.25H2.25v10.5h10.5V3.25zm-.5 10h-9.5v-9.5h9.5v9.5zM7 9H5V8h2V6h1v2h2v1H8v2H7z"
});

function SvgEnlarge5(props) {
  return /*#__PURE__*/createElement("svg", _extends$8z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8z);
}

function _extends$8A() { _extends$8A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8A.apply(this, arguments); }

var _ref$8A = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 8v7H1V1h14v7z"
});

var _ref2$1P = /*#__PURE__*/createElement("path", {
  d: "M14 2H9.5L14 6.5zM2 14V9.5L6.5 14z"
});

function SvgEnlarge6(props) {
  return /*#__PURE__*/createElement("svg", _extends$8A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8A, _ref2$1P);
}

function _extends$8B() { _extends$8B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8B.apply(this, arguments); }

var _ref$8B = /*#__PURE__*/createElement("path", {
  d: "M16 0v6.5L13.5 4l-3 3L9 5.5l3-3L9.5 0zM7 10.5l-3 3L6.5 16H0V9.5L2.5 12l3-3z"
});

function SvgEnlarge7(props) {
  return /*#__PURE__*/createElement("svg", _extends$8B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8B);
}

function _extends$8C() { _extends$8C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8C.apply(this, arguments); }

var _ref$8C = /*#__PURE__*/createElement("path", {
  d: "M7 13l4.5-4.5L7 4v3H0v3h7v3z"
});

var _ref2$1Q = /*#__PURE__*/createElement("path", {
  d: "M15 16H4v-2h10V3H4V1h11a1 1 0 011 1v13a1 1 0 01-1 1z"
});

function SvgEnter(props) {
  return /*#__PURE__*/createElement("svg", _extends$8C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8C, _ref2$1Q);
}

function _extends$8D() { _extends$8D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8D.apply(this, arguments); }

var _ref$8D = /*#__PURE__*/createElement("path", {
  d: "M15 0v16H3v-5h1v3h7V2H4v3H3V0zM6 9H0V7h6V4l4 4-4 4z"
});

function SvgEnter2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8D);
}

function _extends$8E() { _extends$8E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8E.apply(this, arguments); }

var _ref$8E = /*#__PURE__*/createElement("path", {
  d: "M6 8H1V6h5V4l3 3-3 3zm10-8v13l-6 3v-3H4V9h1v3h5V3l4-2H5v4H4V0z"
});

function SvgEnter3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8E);
}

function _extends$8F() { _extends$8F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8F.apply(this, arguments); }

var _ref$8F = /*#__PURE__*/createElement("path", {
  d: "M16 1h-3v7H5.5L8 5.5l-2-2-6 6 6 6 2-2L5.5 11H16z"
});

function SvgEnter4(props) {
  return /*#__PURE__*/createElement("svg", _extends$8F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8F);
}

function _extends$8G() { _extends$8G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8G.apply(this, arguments); }

var _ref$8G = /*#__PURE__*/createElement("path", {
  d: "M13 1v7H7V3.5l-6 6 6 6V11h9V1z"
});

function SvgEnter5(props) {
  return /*#__PURE__*/createElement("svg", _extends$8G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8G);
}

function _extends$8H() { _extends$8H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8H.apply(this, arguments); }

var _ref$8H = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 11-8 8h2a6 6 0 106-6V0z"
});

var _ref2$1R = /*#__PURE__*/createElement("path", {
  d: "M2.468 1.032l5.25 5.25L10 4v6H4l2.282-2.282-5.25-5.25z"
});

function SvgEnter6(props) {
  return /*#__PURE__*/createElement("svg", _extends$8H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8H, _ref2$1R);
}

function _extends$8I() { _extends$8I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8I.apply(this, arguments); }

var _ref$8I = /*#__PURE__*/createElement("path", {
  d: "M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM5.831 9.773l-3 2.182a.559.559 0 01-.785-.124.563.563 0 01.124-.786l3-2.182a.563.563 0 01.662.91zm8.124 2.058a.563.563 0 01-.785.124l-3-2.182a.563.563 0 01.662-.91l3 2.182a.563.563 0 01.124.786zm-.124-6.876l-5.5 4a.562.562 0 01-.662 0l-5.5-4a.563.563 0 01.662-.91L8 7.804l5.169-3.759a.563.563 0 01.662.91z"
});

function SvgEnvelop(props) {
  return /*#__PURE__*/createElement("svg", _extends$8I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8I);
}

function _extends$8J() { _extends$8J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8J.apply(this, arguments); }

var _ref$8J = /*#__PURE__*/createElement("path", {
  d: "M14.998 3l.002.002v9.996l-.002.002H1.002L1 12.998V3.002L1.002 3h13.996zM15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"
});

var _ref2$1S = /*#__PURE__*/createElement("path", {
  d: "M5.831 9.773l-3 2.182a.559.559 0 01-.785-.124.563.563 0 01.124-.786l3-2.182a.563.563 0 01.662.91zM13.955 11.831a.563.563 0 01-.785.124l-3-2.182a.563.563 0 01.662-.91l3 2.182a.563.563 0 01.124.786zM13.831 4.955l-5.5 4a.562.562 0 01-.662 0l-5.5-4a.563.563 0 01.662-.91L8 7.804l5.169-3.759a.563.563 0 01.662.91z"
});

function SvgEnvelop2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8J, _ref2$1S);
}

function _extends$8K() { _extends$8K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8K.apply(this, arguments); }

var _ref$8K = /*#__PURE__*/createElement("path", {
  d: "M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 2v.719L8 8.255 2 4.719V4h12zM2 12V6.46l6 3.536 6-3.536V12H2z"
});

function SvgEnvelop3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8K);
}

function _extends$8L() { _extends$8L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8L.apply(this, arguments); }

var _ref$8L = /*#__PURE__*/createElement("path", {
  d: "M14.5 2h-13C.675 2 0 2.675 0 3.5v10c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-10c0-.825-.675-1.5-1.5-1.5zM6.23 8.6L2 11.895V4.057L6.23 8.6zM2.756 4h10.488L8 7.938 2.756 4zm3.639 4.777L8 10.5l1.605-1.723L12.895 13h-9.79l3.29-4.223zM9.77 8.6L14 4.057v7.838L9.77 8.6z"
});

function SvgEnvelop4(props) {
  return /*#__PURE__*/createElement("svg", _extends$8L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8L);
}

function _extends$8M() { _extends$8M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8M.apply(this, arguments); }

var _ref$8M = /*#__PURE__*/createElement("path", {
  d: "M14.5 2h-13C.675 2 0 2.675 0 3.5v9c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zM14 5L8 9.5 2 5V4l6 3 6-3v1z"
});

function SvgEnvelop5(props) {
  return /*#__PURE__*/createElement("svg", _extends$8M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8M);
}

function _extends$8N() { _extends$8N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8N.apply(this, arguments); }

var _ref$8N = /*#__PURE__*/createElement("path", {
  d: "M7 2v-.25A.752.752 0 006.25 1h-2.5a.752.752 0 00-.75.75V2H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V4h9V2H7zM4 4V2h2v2H4zm9 2.75a.753.753 0 00-.75-.75h-2.5a.753.753 0 00-.75.75V7H0v2h9v.25c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75V9h3V7h-3v-.25zM10 9V7h2v2h-2zm-3 2.75a.753.753 0 00-.75-.75h-2.5a.752.752 0 00-.75.75V12H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V14h9v-2H7v-.25zM4 14v-2h2v2H4z"
});

function SvgEqualizer(props) {
  return /*#__PURE__*/createElement("svg", _extends$8N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8N);
}

function _extends$8O() { _extends$8O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8O.apply(this, arguments); }

var _ref$8O = /*#__PURE__*/createElement("path", {
  d: "M14 7h.25c.412 0 .75-.338.75-.75v-2.5a.752.752 0 00-.75-.75H14V0h-2v3h-.25a.752.752 0 00-.75.75v2.5c0 .412.338.75.75.75H12v9h2V7zm-2-3h2v2h-2V4zm-2.75 9c.412 0 .75-.338.75-.75v-2.5A.753.753 0 009.25 9H9V0H7v9h-.25a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75H7v3h2v-3h.25zM7 10h2v2H7v-2zM4.25 7c.412 0 .75-.338.75-.75v-2.5A.752.752 0 004.25 3H4V0H2v3h-.25a.752.752 0 00-.75.75v2.5c0 .412.337.75.75.75H2v9h2V7h.25zM2 4h2v2H2V4z"
});

function SvgEqualizer2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8O);
}

function _extends$8P() { _extends$8P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8P.apply(this, arguments); }

var _ref$8P = /*#__PURE__*/createElement("path", {
  d: "M4.5 5h-2c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zM3 2h1v2.5H3zm0 5.5h1V14H3zM8.5 9h-2c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zM7 2h1v6.5H7zm0 9.5h1V14H7zM12.5 6h-2c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zM11 2h1v3.5h-1zm0 6.5h1V14h-1zM13.75 0H1.25C.561 0 0 .561 0 1.25v13.5C0 15.439.561 16 1.25 16h12.5c.689 0 1.25-.561 1.25-1.25V1.25C15 .561 14.439 0 13.75 0zM14 14.75c0 .137-.113.25-.25.25H1.25a.251.251 0 01-.25-.25V1.25c0-.137.113-.25.25-.25h12.5c.137 0 .25.113.25.25v13.5z"
});

function SvgEqualizer3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8P);
}

function _extends$8Q() { _extends$8Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Q.apply(this, arguments); }

var _ref$8Q = /*#__PURE__*/createElement("path", {
  d: "M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 12.998l-.002.002H1.002L1 13.998V2.002L1.002 2h13.996l.002.002v11.996zM6.75 11H6V3H4v8h-.75a.25.25 0 00-.25.25v1.5c0 .137.112.25.25.25h3.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25zm2.5-6H10v8h2V5h.75a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25v1.5c0 .138.113.25.25.25z"
});

function SvgEqualizer4(props) {
  return /*#__PURE__*/createElement("svg", _extends$8Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8Q);
}

function _extends$8R() { _extends$8R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8R.apply(this, arguments); }

var _ref$8R = /*#__PURE__*/createElement("path", {
  d: "M14.995 4.366c-.058-.875-.668-1.441-1.161-1.668l-.077-.033-3.143-1.257a1.787 1.787 0 00-.665-.122c-.572 0-1.141.242-1.487.631 0 0-6.715 7.556-6.735 7.582l-.002.002c-.44.5-.725 1-.725 2v1c0 .751.546 1.557 1.243 1.836l2.954 1.182c.456.178 1.216.584 2.144-.243.067-.054.133-.117.197-.19l.075-.084 6.596-7.42c.443-.499.791-1.412.791-2.08v-1c0-.027-.005-.133-.005-.134zM2.538 10.085L9.209 2.58c.157-.176.454-.295.74-.295.109 0 .21.018.294.051l3.143 1.257c.087.035.149.086.16.132s-.021.119-.084.19L6.791 11.42c-.157.176-.454.295-.74.295a.812.812 0 01-.294-.051l-3.143-1.257c-.087-.035-.149-.086-.16-.133s.021-.12.084-.19zM2 12.5v-1c0-.195.075-.195.107-.195.027 0 .072.005.135.031l3.143 1.257c.321.129.614.561.614.907v1c0 .195-.075.195-.107.195a.355.355 0 01-.135-.031l-3.143-1.257C2.293 13.278 2 12.846 2 12.5zm12-7c0 .424-.256 1.098-.538 1.415L7 14.185V13.5c0-.424.256-1.098.538-1.415L14 4.815V5.5z"
});

function SvgEraser(props) {
  return /*#__PURE__*/createElement("svg", _extends$8R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8R);
}

function _extends$8S() { _extends$8S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8S.apply(this, arguments); }

var _ref$8S = /*#__PURE__*/createElement("path", {
  d: "M14.998 4.422a6.582 6.582 0 01-.003-.057c-.058-.875-.668-1.441-1.161-1.668l-.077-.033-3.143-1.257a1.787 1.787 0 00-.665-.122c-.572 0-1.141.242-1.487.631L1.791 9.421l-.064.077-.002.002c-.44.5-.725 1-.725 2v1c0 .751.546 1.557 1.243 1.836l2.954 1.182c.456.178 1.216.584 2.144-.243.067-.054.133-.117.197-.19l.075-.084 6.596-7.42c.443-.499.791-1.412.791-2.08v-1l-.002-.078zM9.209 2.58c.157-.176.454-.295.74-.295.109 0 .21.018.294.051l3.143 1.257c.087.035.149.086.16.132s-.021.119-.084.19L9.548 8.319 5.535 6.714 9.21 2.58zM14 5.5c0 .424-.256 1.098-.538 1.415L10 10.81V9.315l4-4.5V5.5z"
});

function SvgEraser2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8S);
}

function _extends$8T() { _extends$8T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8T.apply(this, arguments); }

var _ref$8T = /*#__PURE__*/createElement("path", {
  d: "M14.995 4.366c-.058-.875-.668-1.441-1.161-1.668l-.077-.033-3.143-1.257a1.787 1.787 0 00-.665-.122c-.572 0-1.141.242-1.487.631 0 0-6.715 7.556-6.735 7.582l-.002.002c-.44.5-.725 1-.725 2v1c0 .751.546 1.557 1.243 1.836l2.954 1.182c.456.178 1.216.584 2.144-.243.067-.054.133-.117.197-.19l.075-.084 6.596-7.42c.443-.499.791-1.412.791-2.08v-1c0-.027-.005-.133-.005-.134zM2.538 10.085L9.209 2.58c.157-.176.454-.295.74-.295.109 0 .21.018.294.051l3.143 1.257c.087.035.149.086.16.132s-.021.119-.084.19L6.791 11.42c-.157.176-.454.295-.74.295a.812.812 0 01-.294-.051l-3.143-1.257c-.087-.035-.149-.086-.16-.133s.021-.12.084-.19z"
});

function SvgEraser3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8T);
}

function _extends$8U() { _extends$8U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8U.apply(this, arguments); }

var _ref$8U = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 11-8 8h2a6 6 0 106-6V0z"
});

var _ref2$1T = /*#__PURE__*/createElement("path", {
  d: "M7.532 8.968l-5.25-5.25L0 6V0h6L3.718 2.282l5.25 5.25z"
});

function SvgEsc(props) {
  return /*#__PURE__*/createElement("svg", _extends$8U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8U, _ref2$1T);
}

function _extends$8V() { _extends$8V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8V.apply(this, arguments); }

var _ref$8V = /*#__PURE__*/createElement("path", {
  d: "M10 7a1 1 0 01-1-1l.002-.054c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.999 7zM4.379 4.985a.5.5 0 11.242-.97c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334zM8 11.5a3.5 3.5 0 003.002-1.699l1.286.772C11.414 12.027 9.821 13 8 13s-3.413-.973-4.288-2.427l1.286-.772A3.498 3.498 0 008 11.5zM16 1c0-.711-.149-1.387-.416-2a5.016 5.016 0 01-2.726 2.643C11.511.612 9.828 0 8.001 0s-3.51.613-4.857 1.643A5.013 5.013 0 01.418-1a4.979 4.979 0 00-.416 2c0 1.15.388 2.208 1.04 3.053a8 8 0 1013.92 0A4.979 4.979 0 0016.002 1zM8 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

function SvgEvil(props) {
  return /*#__PURE__*/createElement("svg", _extends$8V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8V);
}

function _extends$8W() { _extends$8W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8W.apply(this, arguments); }

var _ref$8W = /*#__PURE__*/createElement("path", {
  d: "M16 1c0-.711-.149-1.387-.416-2a5.016 5.016 0 01-2.726 2.643C11.511.612 9.828 0 8.001 0s-3.51.613-4.857 1.643A5.013 5.013 0 01.418-1a4.979 4.979 0 00-.416 2c0 1.15.388 2.208 1.04 3.053a8 8 0 1013.92 0A4.979 4.979 0 0016.002 1zM9.001 5.946c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.998 7a1 1 0 01-1-1L9 5.946zM4.015 4.379a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606zM8 13a4.999 4.999 0 01-4.288-2.427l1.286-.772C5.61 10.819 6.725 11.5 8 11.5s2.389-.681 3.002-1.699l1.286.772A4.996 4.996 0 018 13z"
});

function SvgEvil2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8W);
}

function _extends$8X() { _extends$8X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8X.apply(this, arguments); }

var _ref$8X = /*#__PURE__*/createElement("path", {
  d: "M11 4V0H0v11h4v5h12V4h-5zm3 2.125h-3V6h3v.125zM6 14v-.125h8V14H6zm0-.375v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5V11h5v-.125h3v.25H6zm5-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zM9 4H4v.125H2v-.25h7V4zM2 9v-.125h2V9H2zm0-.375v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm7-1H2v-.25h7v.25zm0-.5H2v-.25h7v.25zm0-.5H2v-.25h7v.25zm0-.5H2V2h7v.125zM5 5h5v5H5V5z"
});

function SvgExclude(props) {
  return /*#__PURE__*/createElement("svg", _extends$8X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8X);
}

function _extends$8Y() { _extends$8Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Y.apply(this, arguments); }

var _ref$8Y = /*#__PURE__*/createElement("path", {
  d: "M11 13l4.5-4.5L11 4v3H4v3h7v3z"
});

var _ref2$1U = /*#__PURE__*/createElement("path", {
  d: "M1 1h11v2H2v11h10v2H1a1 1 0 01-1-1V2a1 1 0 011-1z"
});

function SvgExit(props) {
  return /*#__PURE__*/createElement("svg", _extends$8Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8Y, _ref2$1U);
}

function _extends$8Z() { _extends$8Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8Z.apply(this, arguments); }

var _ref$8Z = /*#__PURE__*/createElement("path", {
  d: "M12 9H5V7h7V4l4 4-4 4zm-2 1v6H0V0h10v6H9V2H4v12h5v-4z"
});

function SvgExit2(props) {
  return /*#__PURE__*/createElement("svg", _extends$8Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8Z);
}

function _extends$8_() { _extends$8_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8_.apply(this, arguments); }

var _ref$8_ = /*#__PURE__*/createElement("path", {
  d: "M12 10V8H7V6h5V4l3 3zm-1-1v4H6v3l-6-3V0h11v5h-1V1H2l4 2v9h4V9z"
});

function SvgExit3(props) {
  return /*#__PURE__*/createElement("svg", _extends$8_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$8_);
}

function _extends$8$() { _extends$8$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8$.apply(this, arguments); }

var _ref$8$ = /*#__PURE__*/createElement("path", {
  d: "M24 4v7.932H11.932v40.14h40.14V40H60v20H4.24V4H24zm32.1 0C58.252 4 60 5.744 60 7.896v.459l.16.161-.16.156V28h-7.8V16.302L32.18 35.888l-4.516-4.516 20.009-19.577L36 11.796V4h20.1z"
});

function SvgExternalLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$8$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref$8$);
}

function _extends$90() { _extends$90 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$90.apply(this, arguments); }

var _ref$90 = /*#__PURE__*/createElement("path", {
  d: "M14.78.22a.75.75 0 00-1.061 0L10.56 3.379a8.815 8.815 0 00-2.561-.378c-3.489 0-6.514 2.032-8 5a9.176 9.176 0 002.703 3.236L.218 13.721a.75.75 0 001.06 1.061l13.5-13.5a.75.75 0 000-1.061zM6.5 5a1.5 1.5 0 011.421 1.019L6.019 7.921A1.5 1.5 0 016.5 5zM1.721 8a7.594 7.594 0 012.52-2.462A3.981 3.981 0 004 6.907c0 .858.27 1.652.73 2.303l-.952.952A7.625 7.625 0 011.721 8zM12 6.906c0-.424-.066-.833-.189-1.217l-5.028 5.028A4 4 0 0012 6.906z"
});

var _ref2$1V = /*#__PURE__*/createElement("path", {
  d: "M12.969 4.531l-1.084 1.084.059.037c.94.6 1.737 1.403 2.335 2.348a7.594 7.594 0 01-2.335 2.348 7.326 7.326 0 01-5.725.933l-1.201 1.201A8.808 8.808 0 008 13c3.489 0 6.514-2.032 8-5a9.142 9.142 0 00-3.031-3.469z"
});

function SvgEyeBlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$90({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$90, _ref2$1V);
}

function _extends$91() { _extends$91 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$91.apply(this, arguments); }

var _ref$91 = /*#__PURE__*/createElement("path", {
  d: "M8 10a2 2 0 001.64-3.145l4.74-5.53-.759-.651-4.74 5.53A2 2 0 006.36 9.145l-4.74 5.53.759.651 4.74-5.53c.266.131.565.204.881.204zM5.17 8.997a3 3 0 013.382-3.946l1.159-1.352A7.779 7.779 0 008 3.5C4 3.5 0 7 0 8c0 .588 1.383 2.04 3.336 3.137l1.834-2.14zm7.494-4.134l-1.834 2.14a3 3 0 01-3.382 3.946l-1.159 1.352A7.779 7.779 0 008 12.5c4 0 8-3.5 8-4.5 0-.588-1.383-2.04-3.336-3.137z"
});

function SvgEyeBlocked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$91({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$91);
}

function _extends$92() { _extends$92 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$92.apply(this, arguments); }

var _ref$92 = /*#__PURE__*/createElement("path", {
  d: "M2.905 11.18a13.171 13.171 0 01-.303-.194c-.685-.453-1.315-.972-1.775-1.461C.271 8.934 0 8.435 0 7.999s.27-.934.827-1.526c.46-.489 1.09-1.007 1.775-1.461C3.624 4.336 5.685 3.201 8 3.201c.197 0 .392.009.586.024L7.517 4.721c-1.642.137-3.122.928-3.897 1.418-1.212.766-1.922 1.542-2.095 1.858.172.317.883 1.093 2.095 1.858.05.032.103.065.159.098l-.874 1.223zm12.268-4.706c-.46-.489-1.09-1.007-1.775-1.461a12.125 12.125 0 00-2.209-1.156l1.794-2.512-.966-.69-10 14 .966.69 2.19-3.066c.85.301 1.814.518 2.827.518 2.315 0 4.376-1.134 5.398-1.811.685-.453 1.315-.972 1.775-1.461.556-.591.827-1.09.827-1.526s-.27-.934-.827-1.526zM12.38 9.858c-.85.537-2.549 1.438-4.38 1.438-.667 0-1.316-.12-1.913-.298l.907-1.27a2 2 0 002.314-3.24l.977-1.367c.88.307 1.619.72 2.094 1.02 1.212.766 1.922 1.541 2.095 1.858-.172.317-.883 1.093-2.095 1.858z"
});

function SvgEyeBlocked3(props) {
  return /*#__PURE__*/createElement("svg", _extends$92({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$92);
}

function _extends$93() { _extends$93 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$93.apply(this, arguments); }

var _ref$93 = /*#__PURE__*/createElement("path", {
  d: "M10 2h6v2h-6V2z"
});

var _ref2$1W = /*#__PURE__*/createElement("path", {
  d: "M13.599 5H9V3.056A8.923 8.923 0 008 3C4.511 3 1.486 5.032 0 8c1.486 2.968 4.511 5 8 5s6.514-2.032 8-5a9.173 9.173 0 00-2.401-3zM6.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 016.5 5zm5.444 5.348a7.326 7.326 0 01-7.889 0A7.626 7.626 0 011.72 8a7.594 7.594 0 012.52-2.462 4 4 0 107.518 0A7.615 7.615 0 0114.278 8a7.594 7.594 0 01-2.335 2.348z"
});

function SvgEyeMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$93({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$93, _ref2$1W);
}

function _extends$94() { _extends$94 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$94.apply(this, arguments); }

var _ref$94 = /*#__PURE__*/createElement("path", {
  d: "M16 2h-2V0h-2v2h-2v2h2v2h2V4h2z"
});

var _ref2$1X = /*#__PURE__*/createElement("path", {
  d: "M13.498 6.969c.288.32.55.665.782 1.031a7.594 7.594 0 01-2.335 2.348 7.326 7.326 0 01-7.889 0A7.626 7.626 0 011.721 8a7.594 7.594 0 012.52-2.462A4 4 0 1012 6.907v-.032a4.002 4.002 0 01-2.999-3.817A8.94 8.94 0 008 3.001c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5a9.217 9.217 0 00-.979-1.548 3.973 3.973 0 01-1.523.517zM6.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 016.5 5z"
});

function SvgEyePlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$94({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$94, _ref2$1X);
}

function _extends$95() { _extends$95 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$95.apply(this, arguments); }

var _ref$95 = /*#__PURE__*/createElement("path", {
  d: "M8 3C4.511 3 1.486 5.032 0 8c1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zm3.945 2.652c.94.6 1.737 1.403 2.335 2.348a7.594 7.594 0 01-2.335 2.348 7.326 7.326 0 01-7.889 0A7.615 7.615 0 011.721 8a7.594 7.594 0 012.52-2.462 4 4 0 107.518 0c.062.037.124.075.185.114zM8 6.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 018 6.5z"
});

function SvgEye(props) {
  return /*#__PURE__*/createElement("svg", _extends$95({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$95);
}

function _extends$96() { _extends$96 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$96.apply(this, arguments); }

var _ref$96 = /*#__PURE__*/createElement("path", {
  d: "M8 3.5C4 3.5 0 7 0 8s4 4.5 8 4.5S16 9 16 8s-4-4.5-8-4.5zM8 11a3 3 0 110-6 3 3 0 010 6zM6 8a2 2 0 113.999-.001A2 2 0 016 8z"
});

function SvgEye2(props) {
  return /*#__PURE__*/createElement("svg", _extends$96({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$96);
}

function _extends$97() { _extends$97 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$97.apply(this, arguments); }

var _ref$97 = /*#__PURE__*/createElement("path", {
  d: "M8 12.797c-2.315 0-4.376-1.134-5.398-1.811-.685-.453-1.315-.972-1.775-1.461C.271 8.934 0 8.435 0 7.999s.27-.934.827-1.526c.46-.489 1.09-1.007 1.775-1.461C3.624 4.336 5.685 3.201 8 3.201s4.376 1.134 5.398 1.811c.685.453 1.315.972 1.775 1.461.556.591.827 1.09.827 1.525s-.27.934-.827 1.526c-.46.489-1.09 1.007-1.775 1.461-1.022.676-3.083 1.811-5.398 1.811zM1.526 8c.172.317.883 1.093 2.095 1.858.85.537 2.549 1.438 4.38 1.438s3.53-.901 4.38-1.438c1.212-.766 1.922-1.541 2.095-1.858-.172-.317-.883-1.093-2.095-1.858-.85-.537-2.549-1.438-4.38-1.438s-3.53.901-4.38 1.438C2.409 6.908 1.699 7.683 1.526 8zM6 8a2 2 0 113.999-.001A2 2 0 016 8z"
});

function SvgEye3(props) {
  return /*#__PURE__*/createElement("svg", _extends$97({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$97);
}

function _extends$98() { _extends$98 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$98.apply(this, arguments); }

var _ref$98 = /*#__PURE__*/createElement("path", {
  d: "M8 5a9.983 9.983 0 00-8 4c1.824 2.429 4.729 4 8 4s6.176-1.571 8-4a9.983 9.983 0 00-8-4zM7 7a1 1 0 110 2 1 1 0 010-2zm5.088 4.02A8.964 8.964 0 018 12a8.913 8.913 0 01-4.088-.98A9.084 9.084 0 011.293 9a8.98 8.98 0 014.198-2.646 3 3 0 105.016 0 8.903 8.903 0 011.579.626A9.084 9.084 0 0114.705 9a9.098 9.098 0 01-2.619 2.02zm1.364-7.212C11.753 2.94 9.919 2.5 8 2.5s-3.753.44-5.452 1.308A12.055 12.055 0 000 5.559v1.706A11.105 11.105 0 013.003 5.01C4.56 4.215 6.241 3.811 8 3.811s3.44.403 4.997 1.199A11.084 11.084 0 0116 7.265V5.559a12.055 12.055 0 00-2.548-1.751z"
});

function SvgEye4(props) {
  return /*#__PURE__*/createElement("svg", _extends$98({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$98);
}

function _extends$99() { _extends$99 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$99.apply(this, arguments); }

var _ref$99 = /*#__PURE__*/createElement("path", {
  d: "M15.414.586a2 2 0 00-2.828 0L9.897 3.275 8.001 1.379 5.88 3.5l1.663 1.663L.166 12.54a.56.56 0 00-.161.46H.001v2.5a.5.5 0 00.5.5h2.563a.561.561 0 00.398-.165l7.377-7.377 1.663 1.663L14.623 8l-1.896-1.896 2.689-2.689a2 2 0 000-2.828zM2.705 15H1v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z"
});

function SvgEyedropper(props) {
  return /*#__PURE__*/createElement("svg", _extends$99({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$99);
}

function _extends$9a() { _extends$9a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9a.apply(this, arguments); }

var _ref$9a = /*#__PURE__*/createElement("path", {
  d: "M15.414.586a2 2 0 00-2.828 0L9.897 3.275 8.001 1.379 5.88 3.5l1.663 1.663L.166 12.54a.56.56 0 00-.161.46H.001v2.5a.5.5 0 00.5.5h2.563a.561.561 0 00.398-.165l7.377-7.377 1.663 1.663L14.623 8l-1.896-1.896 2.689-2.689a2 2 0 000-2.828zM7.705 10H4.296l4.042-4.042 1.704 1.705L7.705 10z"
});

function SvgEyedropper2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9a);
}

function _extends$9b() { _extends$9b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9b.apply(this, arguments); }

var _ref$9b = /*#__PURE__*/createElement("path", {
  d: "M12 5h-1.75c-1 0-.25-1-.25-3 0-.236-.028-.416-.077-.55a2 2 0 00-3.846 0A1.626 1.626 0 006 2c0 2 .75 3-.25 3H4v2h2v7.75c0 .137.112.25.25.25h.5a.25.25 0 01.25.25v.5c0 .137.112.25.25.25h1.5c.137 0 .25-.113.25-.25v-.5c0-.137.113-.25.25-.25h.5c.137 0 .25-.113.25-.25V7h2V5zm-3 9.025c-.489.1-.875.486-.975.975h-.05A1.255 1.255 0 007 14.025V7h2v7.025z"
});

function SvgEyedropper3(props) {
  return /*#__PURE__*/createElement("svg", _extends$9b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9b);
}

function _extends$9c() { _extends$9c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9c.apply(this, arguments); }

var _ref$9c = /*#__PURE__*/createElement("path", {
  d: "M9.5 3H12V0H9.5C7.57 0 6 1.57 6 3.5V5H4v3h2v8h3V8h2.5l.5-3H9V3.5c0-.271.229-.5.5-.5z"
});

function SvgFacebook(props) {
  return /*#__PURE__*/createElement("svg", _extends$9c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9c);
}

function _extends$9d() { _extends$9d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9d.apply(this, arguments); }

var _ref$9d = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5H8V9H6V7h2V6c0-1.653 1.347-3 3-3h2v2h-2c-.55 0-1 .45-1 1v1h3l-.5 2H10v7h4.5c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5z"
});

function SvgFacebook2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9d);
}

function _extends$9e() { _extends$9e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9e.apply(this, arguments); }

var _ref$9e = /*#__PURE__*/createElement("path", {
  d: "M15 14V5l-4 3V5L7 8V4L3 7V1H1v13H0v1h16v-1z"
});

function SvgFactory(props) {
  return /*#__PURE__*/createElement("svg", _extends$9e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9e);
}

function _extends$9f() { _extends$9f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9f.apply(this, arguments); }

var _ref$9f = /*#__PURE__*/createElement("path", {
  d: "M14.389 7.884a5.482 5.482 0 00-2.792-1.501l3.205-3.205c.681-.681 1.06-1.55-.223-2.411a5.502 5.502 0 00-8.195 3.635L3.179 1.197C2.498.516 1.629.137.768 1.42a5.502 5.502 0 003.635 8.195L1.198 12.82c-.681.681-1.06 1.55.223 2.411a5.502 5.502 0 008.195-3.635l3.205 3.205c.681.681 1.55 1.06 2.411-.223a5.502 5.502 0 00-.843-6.694zM8 10a2 2 0 11-.001-3.999A2 2 0 018 10z"
});

function SvgFan(props) {
  return /*#__PURE__*/createElement("svg", _extends$9f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9f);
}

function _extends$9g() { _extends$9g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9g.apply(this, arguments); }

var _ref$9g = /*#__PURE__*/createElement("path", {
  d: "M6 8a2 2 0 113.999-.001A2 2 0 016 8zm4.38-4.398a4.999 4.999 0 010 8.796c.689-1.096 1.12-2.66 1.12-4.398s-.431-3.302-1.12-4.398zM4.5 8c0 1.738.431 3.302 1.12 4.398a4.999 4.999 0 010-8.796C4.931 4.698 4.5 6.262 4.5 8zm-3 0c0 2.686.85 5.097 2.198 6.746C1.475 13.325 0 10.835 0 8s1.474-5.325 3.698-6.746C2.35 2.903 1.5 5.314 1.5 8zm10.802-6.746C14.525 2.675 16 5.165 16 8s-1.474 5.325-3.698 6.746C13.65 13.097 14.5 10.686 14.5 8s-.85-5.097-2.198-6.746z"
});

function SvgFeed(props) {
  return /*#__PURE__*/createElement("svg", _extends$9g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9g);
}

function _extends$9h() { _extends$9h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9h.apply(this, arguments); }

var _ref$9h = /*#__PURE__*/createElement("path", {
  d: "M9 9.9A5.002 5.002 0 008 0a5 5 0 00-1 9.9V12H4v2h3v2h2v-2h3v-2H9V9.9zM4.7 5a3.3 3.3 0 116.599-.001A3.3 3.3 0 014.7 5z"
});

function SvgFemale(props) {
  return /*#__PURE__*/createElement("svg", _extends$9h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9h);
}

function _extends$9i() { _extends$9i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9i.apply(this, arguments); }

var _ref$9i = /*#__PURE__*/createElement("path", {
  d: "M12.5 1L11 2.5V5H9V2.5L7.5 1 6 2.5V5H4V2.5L2.5 1 1 2.5V16h3v-3h2v3h3v-3h2v3h3V2.5L12.5 1zM4 12V6h2v6H4zm5 0V6h2v6H9z"
});

function SvgFence(props) {
  return /*#__PURE__*/createElement("svg", _extends$9i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9i);
}

function _extends$9j() { _extends$9j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9j.apply(this, arguments); }

var _ref$9j = /*#__PURE__*/createElement("path", {
  d: "M11 16l-3-3.5 1.273-1.273L11 12.965 15 9l1 1-5 6z"
});

var _ref2$1Y = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25H8.5a.5.5 0 000-1H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v2.5a.5.5 0 001 0V5c0-.224-.068-.615-.659-1.421zM11 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271h-2.406z"
});

function SvgFileCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$9j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9j, _ref2$1Y);
}

function _extends$9k() { _extends$9k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9k.apply(this, arguments); }

var _ref$9k = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$1Z = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm-3.781 9.352l-3.207-3.707.914-.914 2.293 1.793 4.293-3.793.914.914-5.207 5.707z"
});

function SvgFileCheck2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9k, _ref2$1Z);
}

function _extends$9l() { _extends$9l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9l.apply(this, arguments); }

var _ref$9l = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$1_ = /*#__PURE__*/createElement("path", {
  d: "M6.5 13a.5.5 0 01-.5-.5v-1.25a1.24 1.24 0 00-.251-.75c.157-.209.251-.469.251-.75V8.5c0-.276.224-.5.5-.5a.5.5 0 000-1C5.673 7 5 7.673 5 8.5v1.25a.25.25 0 01-.25.25H4.5a.5.5 0 000 1h.25a.25.25 0 01.25.25v1.25c0 .827.673 1.5 1.5 1.5a.5.5 0 000-1zM9.5 13a.5.5 0 00.5-.5v-1.25c0-.281.093-.541.251-.75A1.246 1.246 0 0110 9.75V8.5c0-.276-.224-.5-.5-.5a.5.5 0 010-1c.827 0 1.5.673 1.5 1.5v1.25c0 .138.112.25.25.25h.25a.5.5 0 010 1h-.25a.25.25 0 00-.25.25v1.25c0 .827-.673 1.5-1.5 1.5a.5.5 0 010-1z"
});

function SvgFileCss(props) {
  return /*#__PURE__*/createElement("svg", _extends$9l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9l, _ref2$1_);
}

function _extends$9m() { _extends$9m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9m.apply(this, arguments); }

var _ref$9m = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$1$ = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM6 11.25v1.25c0 .276.224.5.5.5a.5.5 0 010 1c-.827 0-1.5-.673-1.5-1.5v-1.25a.25.25 0 00-.25-.25H4.5a.5.5 0 010-1h.25A.25.25 0 005 9.75V8.5C5 7.673 5.673 7 6.5 7a.5.5 0 010 1 .5.5 0 00-.5.5v1.25c0 .281-.093.541-.251.75.157.209.251.469.251.75zm5.5-.25h-.25a.25.25 0 00-.25.25v1.25c0 .827-.673 1.5-1.5 1.5a.5.5 0 010-1 .5.5 0 00.5-.5v-1.25c0-.281.093-.541.251-.75A1.246 1.246 0 0110 9.75V8.5c0-.276-.224-.5-.5-.5a.5.5 0 010-1c.827 0 1.5.673 1.5 1.5v1.25c0 .138.112.25.25.25h.25a.5.5 0 010 1z"
});

function SvgFileCss2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9m, _ref2$1$);
}

function _extends$9n() { _extends$9n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9n.apply(this, arguments); }

var _ref$9n = /*#__PURE__*/createElement("path", {
  d: "M13.341 3.579c-.347-.473-.831-1.027-1.362-1.558S10.894 1.006 10.421.659C9.615.068 9.224 0 9 0H2.25C1.561 0 1 .561 1 1.25V5l.5 11L2 5V1.25c0-.135.115-.25.25-.25H9v3.5a.5.5 0 00.5.5H13l.5 11L14 5c0-.224-.068-.615-.659-1.421zM10 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271H9.999z"
});

var _ref2$20 = /*#__PURE__*/createElement("path", {
  d: "M9 7H6v5H3.5l4 4 4-4H9z"
});

function SvgFileDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$9n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9n, _ref2$20);
}

function _extends$9o() { _extends$9o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9o.apply(this, arguments); }

var _ref$9o = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$21 = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM8 15.5L4.5 12H7V7h2v5h2.5L8 15.5z"
});

function SvgFileDownload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9o, _ref2$21);
}

function _extends$9p() { _extends$9p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9p.apply(this, arguments); }

var _ref$9p = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFileEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$9p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9p);
}

function _extends$9q() { _extends$9q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9q.apply(this, arguments); }

var _ref$9q = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$22 = /*#__PURE__*/createElement("path", {
  d: "M10 4.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5a.5.5 0 01-.5-.5z"
});

function SvgFileEmpty2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9q, _ref2$22);
}

function _extends$9r() { _extends$9r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9r.apply(this, arguments); }

var _ref$9r = /*#__PURE__*/createElement("path", {
  d: "M11.61 6H9.496L8 8.204 6.504 6H4.39l2.534 3.788L4.065 14H8v-1.431h-.784L8 11.397 9.741 14h2.194L9.076 9.788 11.61 6z"
});

var _ref2$23 = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFileExcel(props) {
  return /*#__PURE__*/createElement("svg", _extends$9r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9r, _ref2$23);
}

function _extends$9s() { _extends$9s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9s.apply(this, arguments); }

var _ref$9s = /*#__PURE__*/createElement("path", {
  d: "M15.95 10.807a6.075 6.075 0 00-2.318-2.745C12.562 7.367 11.306 7 10 7s-2.562.367-3.632 1.062a6.069 6.069 0 00-2.318 2.745.497.497 0 000 .386 6.069 6.069 0 002.318 2.745C7.438 14.633 8.694 15 10 15s2.562-.367 3.632-1.062a6.069 6.069 0 002.318-2.745.497.497 0 000-.386zM10 10a1 1 0 11-2 0 1 1 0 012 0zm3.087 3.099c-.908.589-1.975.901-3.087.901s-2.18-.312-3.087-.901A5.1 5.1 0 015.058 11a5.1 5.1 0 011.855-2.099c.102-.066.206-.128.311-.188a3.044 3.044 0 105.433-.065c.147.078.292.162.432.253A5.106 5.106 0 0114.944 11a5.1 5.1 0 01-1.855 2.099z"
});

var _ref2$24 = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25H7.5a.5.5 0 000-1H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v2.5a.5.5 0 001 0V5c0-.224-.068-.615-.659-1.421zM11 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271h-2.406z"
});

function SvgFileEye(props) {
  return /*#__PURE__*/createElement("svg", _extends$9s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9s, _ref2$24);
}

function _extends$9t() { _extends$9t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9t.apply(this, arguments); }

var _ref$9t = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$25 = /*#__PURE__*/createElement("path", {
  d: "M5.755 15.881a7.192 7.192 0 01-2.743-3.254 1.632 1.632 0 010-1.254 7.192 7.192 0 012.743-3.254C7.008 7.305 8.476 6.875 10 6.875s2.992.43 4.245 1.244c.266.172.518.36.755.56V5h-4.5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h3.695a7.527 7.527 0 01-.19-.119z"
});

var _ref3$a = /*#__PURE__*/createElement("path", {
  d: "M15.95 11.807a6.075 6.075 0 00-2.318-2.745C12.562 8.367 11.306 8 10 8s-2.562.367-3.632 1.062a6.069 6.069 0 00-2.318 2.745.497.497 0 000 .386 6.075 6.075 0 002.318 2.745C7.438 15.633 8.694 16 10 16s2.562-.367 3.632-1.062a6.069 6.069 0 002.318-2.745.497.497 0 000-.386zM10 11a1 1 0 11-2 0 1 1 0 012 0zm3.087 3.099c-.908.589-1.975.901-3.087.901s-2.18-.312-3.087-.901A5.1 5.1 0 015.058 12a5.1 5.1 0 011.855-2.099c.102-.066.206-.128.311-.188a3.044 3.044 0 105.433-.065c.147.078.292.162.432.253A5.106 5.106 0 0114.944 12a5.1 5.1 0 01-1.855 2.099z"
});

function SvgFileEye2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9t, _ref2$25, _ref3$a);
}

function _extends$9u() { _extends$9u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9u.apply(this, arguments); }

var _ref$9u = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$26 = /*#__PURE__*/createElement("path", {
  d: "M10.5 9H10V6.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V9h-.5c-.275 0-.5.225-.5.5v4c0 .275.225.5.5.5h5c.275 0 .5-.225.5-.5v-4c0-.275-.225-.5-.5-.5zM7 7h2v2H7V7z"
});

function SvgFileLocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$9u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9u, _ref2$26);
}

function _extends$9v() { _extends$9v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9v.apply(this, arguments); }

var _ref$9v = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4zM7 7h2v2H7V7z"
});

var _ref2$27 = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm.5 8.5c0 .275-.225.5-.5.5h-5a.501.501 0 01-.5-.5v-4c0-.275.225-.5.5-.5H6V6.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V9h.5c.275 0 .5.225.5.5v4z"
});

function SvgFileLocked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9v, _ref2$27);
}

function _extends$9w() { _extends$9w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9w.apply(this, arguments); }

var _ref$9w = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25H8.5a.5.5 0 000-1H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v3.5a.5.5 0 001 0V5c0-.224-.068-.615-.659-1.421zM11 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271h-2.406z"
});

var _ref2$28 = /*#__PURE__*/createElement("path", {
  d: "M10 12h6v2h-6v-2z"
});

function SvgFileMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$9w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9w, _ref2$28);
}

function _extends$9x() { _extends$9x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9x.apply(this, arguments); }

var _ref$9x = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$29 = /*#__PURE__*/createElement("path", {
  d: "M7.875 12.5A4.63 4.63 0 0112.5 7.875c.92 0 1.779.27 2.5.736V5h-4.5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h7.23a4.617 4.617 0 01-1.605-3.5z"
});

var _ref3$b = /*#__PURE__*/createElement("path", {
  d: "M12.5 9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM10 13v-1h5v1h-5z"
});

function SvgFileMinus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9x, _ref2$29, _ref3$b);
}

function _extends$9y() { _extends$9y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9y.apply(this, arguments); }

var _ref$9y = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2a = /*#__PURE__*/createElement("path", {
  d: "M11.817 6.113a.501.501 0 00-.415-.104l-5 1a.5.5 0 00-.402.49V11.2a2.514 2.514 0 00-1-.201c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5v-3.59l4-.8V10.2a2.514 2.514 0 00-1-.201c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5v-5a.5.5 0 00-.183-.387z"
});

function SvgFileMusic(props) {
  return /*#__PURE__*/createElement("svg", _extends$9y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9y, _ref2$2a);
}

function _extends$9z() { _extends$9z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9z.apply(this, arguments); }

var _ref$9z = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2b = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm1.5 7.5c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V9.11l-4 .8v3.59c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V8.5a.5.5 0 01.402-.49l5-1a.501.501 0 01.598.491v5z"
});

function SvgFileMusic2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9z, _ref2$2b);
}

function _extends$9A() { _extends$9A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9A.apply(this, arguments); }

var _ref$9A = /*#__PURE__*/createElement("path", {
  d: "M10.785 7.37c-.948-.448-2.156-.538-3.044.095 1.08-.103 2.265.076 3.049.893.75-.861 1.939-1.022 3.015-.933-.898-.596-2.082-.516-3.019-.054zm-.384 2.095c-1.068-.025-2.101.362-2.986.939-1.675-.712-3.793-.58-5.219.609.411-.015.813-.116 1.22-.169 1.487-.148 3.072.221 4.196 1.247a4.52 4.52 0 011.87-1.561c.986-.477 2.096-.526 3.169-.539-.651-.448-1.478-.531-2.249-.526z"
});

var _ref2$2c = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFileOpenoffice(props) {
  return /*#__PURE__*/createElement("svg", _extends$9A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9A, _ref2$2c);
}

function _extends$9B() { _extends$9B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9B.apply(this, arguments); }

var _ref$9B = /*#__PURE__*/createElement("path", {
  d: "M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 00-1.69.124c-.276-.159-.561-.333-.784-.542-.601-.561-1.103-1.34-1.415-2.197.02-.08.038-.15.054-.222 0 0 .339-1.923.249-2.573a.73.73 0 00-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323-.926.553-1.539 1.18-1.641 1.678-.032.159-.008.362.156.456l.263.132a.792.792 0 00.357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 013.819-.908c.926.521 2.065.883 2.783.883.128 0 .238-.012.327-.036a.558.558 0 00.325-.222c.139-.21.168-.499.13-.795a.531.531 0 00-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556.044-.036.153-.138.253-.233-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389 0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839.383-.724.624-1.29.804-1.755a5.813 5.813 0 001.328 1.649c.065.055.135.111.207.166-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064-.386 0-.864-.176-1.533-.464.257-.019.493-.029.705-.029.387 0 .502-.002.88.095s.383.293.318.333z"
});

var _ref2$2d = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFilePdf(props) {
  return /*#__PURE__*/createElement("svg", _extends$9B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9B, _ref2$2d);
}

function _extends$9C() { _extends$9C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9C.apply(this, arguments); }

var _ref$9C = /*#__PURE__*/createElement("path", {
  d: "M13 14H3v-2l3-5 4.109 5L13 10v4zM13 7.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 7.5z"
});

var _ref2$2e = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFilePicture(props) {
  return /*#__PURE__*/createElement("svg", _extends$9C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9C, _ref2$2e);
}

function _extends$9D() { _extends$9D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9D.apply(this, arguments); }

var _ref$9D = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2f = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm2.5 9H3v-2l3-5 4.109 5L13 10v4zm-1.5-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
});

function SvgFilePicture2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9D, _ref2$2f);
}

function _extends$9E() { _extends$9E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9E.apply(this, arguments); }

var _ref$9E = /*#__PURE__*/createElement("path", {
  d: "M6 6l5 3.5L6 13V6z"
});

var _ref2$2g = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFilePlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$9E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9E, _ref2$2g);
}

function _extends$9F() { _extends$9F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9F.apply(this, arguments); }

var _ref$9F = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2h = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM6 13V6l5 3.5L6 13z"
});

function SvgFilePlay2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9F, _ref2$2h);
}

function _extends$9G() { _extends$9G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9G.apply(this, arguments); }

var _ref$9G = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25H8.5a.5.5 0 000-1H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v3.5a.5.5 0 001 0V5c0-.224-.068-.615-.659-1.421zM11 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271h-2.406z"
});

var _ref2$2i = /*#__PURE__*/createElement("path", {
  d: "M16 12h-2v-2h-2v2h-2v2h2v2h2v-2h2z"
});

function SvgFilePlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$9G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9G, _ref2$2i);
}

function _extends$9H() { _extends$9H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9H.apply(this, arguments); }

var _ref$9H = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2j = /*#__PURE__*/createElement("path", {
  d: "M7.875 12.5A4.63 4.63 0 0112.5 7.875c.92 0 1.779.27 2.5.736V5h-4.5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h7.23a4.617 4.617 0 01-1.605-3.5z"
});

var _ref3$c = /*#__PURE__*/createElement("path", {
  d: "M12.5 9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm.5 4v2h-1v-2h-2v-1h2v-2h1v2h2v1h-2z"
});

function SvgFilePlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9H, _ref2$2j, _ref3$c);
}

function _extends$9I() { _extends$9I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9I.apply(this, arguments); }

var _ref$9I = /*#__PURE__*/createElement("path", {
  d: "M3 8h3v1H3V8zm0 2h3v1H3v-1zm0 2h3v1H3v-1zm6-1h2.95A2.5 2.5 0 119 8.05V11zm1.5-4a2.5 2.5 0 012.45 3H10V7.05c.162-.033.329-.05.5-.05z"
});

var _ref2$2k = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFilePresentation(props) {
  return /*#__PURE__*/createElement("svg", _extends$9I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9I, _ref2$2k);
}

function _extends$9J() { _extends$9J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9J.apply(this, arguments); }

var _ref$9J = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2l = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM6 14H3v-1h3v1zm0-2H3v-1h3v1zm0-2H3V9h3v1zm3.5 4A2.5 2.5 0 019 9.05V12h2.95a2.5 2.5 0 01-2.45 2zm3.45-3H10V8.05A2.501 2.501 0 0112.95 11z"
});

function SvgFilePresentation2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9J, _ref2$2l);
}

function _extends$9K() { _extends$9K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9K.apply(this, arguments); }

var _ref$9K = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2m = /*#__PURE__*/createElement("path", {
  d: "M3 7v7h10V7H3zm3 6H4v-2h2v2zm0-3H4V8h2v2zm3 3H7v-2h2v2zm0-3H7V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
});

function SvgFileSpreadsheet(props) {
  return /*#__PURE__*/createElement("svg", _extends$9K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9K, _ref2$2m);
}

function _extends$9L() { _extends$9L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9L.apply(this, arguments); }

var _ref$9L = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4zM7 11h2v2H7v-2zM10 11h2v2h-2v-2zM10 8h2v2h-2V8zM7 8h2v2H7V8z"
});

var _ref2$2n = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm2.5 9H3V7h10v7z"
});

var _ref3$d = /*#__PURE__*/createElement("path", {
  d: "M4 8h2v2H4V8zM4 11h2v2H4v-2z"
});

function SvgFileSpreadsheet2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9L, _ref2$2n, _ref3$d);
}

function _extends$9M() { _extends$9M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9M.apply(this, arguments); }

var _ref$9M = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2o = /*#__PURE__*/createElement("path", {
  d: "M4 5h2v9H4V5zM7 9h2v5H7V9zM10 11h2v3h-2v-3z"
});

function SvgFileStats(props) {
  return /*#__PURE__*/createElement("svg", _extends$9M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9M, _ref2$2o);
}

function _extends$9N() { _extends$9N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9N.apply(this, arguments); }

var _ref$9N = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2p = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM6 14H4V5h2v9zm3 0H7V9h2v5zm3 0h-2v-3h2v3z"
});

function SvgFileStats2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9N, _ref2$2p);
}

function _extends$9O() { _extends$9O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9O.apply(this, arguments); }

var _ref$9O = /*#__PURE__*/createElement("path", {
  d: "M13.5 0h-12C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM13 14H2V2h11v12zM4 7h7v1H4zm0 2h7v1H4zm0 2h7v1H4zm0-6h7v1H4z"
});

function SvgFileText(props) {
  return /*#__PURE__*/createElement("svg", _extends$9O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9O);
}

function _extends$9P() { _extends$9P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9P.apply(this, arguments); }

var _ref$9P = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2q = /*#__PURE__*/createElement("path", {
  d: "M11.5 13h-7a.5.5 0 010-1h7a.5.5 0 010 1zM11.5 11h-7a.5.5 0 010-1h7a.5.5 0 010 1zM11.5 9h-7a.5.5 0 010-1h7a.5.5 0 010 1z"
});

function SvgFileText2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9P, _ref2$2q);
}

function _extends$9Q() { _extends$9Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Q.apply(this, arguments); }

var _ref$9Q = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2r = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm1 8h-7a.5.5 0 010-1h7a.5.5 0 010 1zm0-2h-7a.5.5 0 010-1h7a.5.5 0 010 1zm0-2h-7a.5.5 0 010-1h7a.5.5 0 010 1z"
});

function SvgFileText3(props) {
  return /*#__PURE__*/createElement("svg", _extends$9Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9Q, _ref2$2r);
}

function _extends$9R() { _extends$9R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9R.apply(this, arguments); }

var _ref$9R = /*#__PURE__*/createElement("path", {
  d: "M13.341 3.579c-.347-.473-.831-1.027-1.362-1.558S10.894 1.006 10.421.659C9.615.068 9.224 0 9 0H2.25C1.561 0 1 .561 1 1.25V5l.5 11L2 5V1.25c0-.135.115-.25.25-.25H9v3.5a.5.5 0 00.5.5H13l.5 11L14 5c0-.224-.068-.615-.659-1.421zM10 4V1.595c.359.278.792.654 1.271 1.134s.856.912 1.134 1.271H9.999z"
});

var _ref2$2s = /*#__PURE__*/createElement("path", {
  d: "M6 16h3v-5h2.5l-4-4-4 4H6z"
});

function SvgFileUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$9R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9R, _ref2$2s);
}

function _extends$9S() { _extends$9S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9S.apply(this, arguments); }

var _ref$9S = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2t = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM8 6.5l3.5 3.5H9v5H7v-5H4.5L8 6.5z"
});

function SvgFileUpload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9S, _ref2$2t);
}

function _extends$9T() { _extends$9T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9T.apply(this, arguments); }

var _ref$9T = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2u = /*#__PURE__*/createElement("path", {
  d: "M4 8h5v5H4V8zM9 10l3-2v5l-3-2z"
});

function SvgFileVideo(props) {
  return /*#__PURE__*/createElement("svg", _extends$9T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9T, _ref2$2u);
}

function _extends$9U() { _extends$9U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9U.apply(this, arguments); }

var _ref$9U = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2v = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm1.5 9l-3-2v2H4V9h5v2l3-2v5z"
});

function SvgFileVideo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9U, _ref2$2v);
}

function _extends$9V() { _extends$9V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9V.apply(this, arguments); }

var _ref$9V = /*#__PURE__*/createElement("path", {
  d: "M9.997 7.436h.691l-.797 3.534-1.036-4.969H7.19L5.985 10.97l-.903-4.969H3.341l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998H9.997v1.435z"
});

var _ref2$2w = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFileWord(props) {
  return /*#__PURE__*/createElement("svg", _extends$9V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9V, _ref2$2w);
}

function _extends$9W() { _extends$9W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9W.apply(this, arguments); }

var _ref$9W = /*#__PURE__*/createElement("path", {
  d: "M7.5 9l-1-1-3 3 3 3 1-1-2-2 2-2zM8.5 13l1 1 3-3-3-3-1 1 2 2-2 2z"
});

var _ref2$2x = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

function SvgFileXml(props) {
  return /*#__PURE__*/createElement("svg", _extends$9W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9W, _ref2$2x);
}

function _extends$9X() { _extends$9X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9X.apply(this, arguments); }

var _ref$9X = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2y = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zm-3 8l-1 1-3-3 3-3 1 1-2 2 2 2zm2 1l-1-1 2-2-2-2 1-1 3 3-3 3z"
});

function SvgFileXml2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9X, _ref2$2y);
}

function _extends$9Y() { _extends$9Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Y.apply(this, arguments); }

var _ref$9Y = /*#__PURE__*/createElement("path", {
  d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
});

var _ref2$2z = /*#__PURE__*/createElement("path", {
  d: "M4 1h2v1H4V1zM6 2h2v1H6V2zM4 3h2v1H4V3zM6 4h2v1H6V4zM4 5h2v1H4V5zM6 6h2v1H6V6zM4 7h2v1H4V7zM6 8h2v1H6V8zM4 13.25c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75H6V9H4v4.25zM7 12v1H5v-1h2z"
});

function SvgFileZip(props) {
  return /*#__PURE__*/createElement("svg", _extends$9Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9Y, _ref2$2z);
}

function _extends$9Z() { _extends$9Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9Z.apply(this, arguments); }

var _ref$9Z = /*#__PURE__*/createElement("path", {
  d: "M11 4h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659A6.38 6.38 0 0011 .373V4z"
});

var _ref2$2A = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a.5.5 0 01-.5-.5V0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5h-4.5zM7 3H5v1h2v1H5v1h2v1H5v1h2v1H5v1h1.25c.412 0 .75.338.75.75v2.5c0 .412-.338.75-.75.75h-2.5a.752.752 0 01-.75-.75V9h2V8H3V7h2V6H3V5h2V4H3V3h2V2H3V1h2v1h2v1z"
});

var _ref3$e = /*#__PURE__*/createElement("path", {
  d: "M4 12h2v1H4v-1z"
});

function SvgFileZip2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9Z, _ref2$2A, _ref3$e);
}

function _extends$9_() { _extends$9_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9_.apply(this, arguments); }

var _ref$9_ = /*#__PURE__*/createElement("path", {
  d: "M14.341 5.579c-.347-.473-.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362C10.615 2.068 10.224 2 10 2H4.25C3.561 2 3 2.561 3 3.25v11.5c0 .689.561 1.25 1.25 1.25h9.5c.689 0 1.25-.561 1.25-1.25V7c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V3.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25h-9.5a.253.253 0 01-.25-.25V3.25c0-.135.114-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v7.75z"
});

var _ref2$2B = /*#__PURE__*/createElement("path", {
  d: "M9.421.659C8.615.068 8.224 0 8 0H2.25C1.561 0 1 .561 1 1.25v11.5c0 .604.43 1.109 1 1.225V1.25c0-.135.115-.25.25-.25h7.607A10.455 10.455 0 009.42.659z"
});

function SvgFilesEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$9_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9_, _ref2$2B);
}

function _extends$9$() { _extends$9$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9$.apply(this, arguments); }

var _ref$9$ = /*#__PURE__*/createElement("path", {
  d: "M9.421.659C8.615.068 8.224 0 8 0H2.25C1.561 0 1 .561 1 1.25v11.5c0 .604.43 1.109 1 1.225V1.25c0-.135.115-.25.25-.25h7.607A10.455 10.455 0 009.42.659zM11 6h3.627a6.38 6.38 0 00-.286-.421c-.347-.473-.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362A6.38 6.38 0 0011 2.373V6z"
});

var _ref2$2C = /*#__PURE__*/createElement("path", {
  d: "M10 6.5V2H4.25C3.561 2 3 2.561 3 3.25v11.5c0 .689.561 1.25 1.25 1.25h9.5c.689 0 1.25-.561 1.25-1.25V7h-4.5a.5.5 0 01-.5-.5z"
});

function SvgFilesEmpty2(props) {
  return /*#__PURE__*/createElement("svg", _extends$9$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$9$, _ref2$2C);
}

function _extends$a0() { _extends$a0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a0.apply(this, arguments); }

var _ref$a0 = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm10 1h2v2h-2V1zM7 1h2v2H7V1zM4 1h2v2H4V1zM1 1h2v2H1V1zm0 3h6v8H1V4zm2 11H1v-2h2v2zm3 0H4v-2h2v2zm3 0H7v-2h2v2zm3 0h-2v-2h2v2zm3 0h-2v-2h2v2zm0-3H8V4h7v8zm0-9h-2V1h2v2z"
});

function SvgFilm(props) {
  return /*#__PURE__*/createElement("svg", _extends$a0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a0);
}

function _extends$a1() { _extends$a1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a1.apply(this, arguments); }

var _ref$a1 = /*#__PURE__*/createElement("path", {
  d: "M0 1v14h16V1H0zm3 13H1v-2h2v2zm0-3H1V9h2v2zm0-4H1V5h2v2zm0-3H1V2h2v2zm9 10H4V9h8v5zm0-7H4V2h8v5zm3 7h-2v-2h2v2zm0-3h-2V9h2v2zm0-4h-2V5h2v2zm0-3h-2V2h2v2z"
});

function SvgFilm2(props) {
  return /*#__PURE__*/createElement("svg", _extends$a1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a1);
}

function _extends$a2() { _extends$a2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a2.apply(this, arguments); }

var _ref$a2 = /*#__PURE__*/createElement("path", {
  d: "M0 2v12h16V2H0zm3 11H1v-2h2v2zm0-4H1V7h2v2zm0-4H1V3h2v2zm9 8H4V3h8v10zm3 0h-2v-2h2v2zm0-4h-2V7h2v2zm0-4h-2V3h2v2z"
});

function SvgFilm3(props) {
  return /*#__PURE__*/createElement("svg", _extends$a2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a2);
}

function _extends$a3() { _extends$a3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a3.apply(this, arguments); }

var _ref$a3 = /*#__PURE__*/createElement("path", {
  d: "M0 2v12h16V2H0zm3 11H1v-2h2v2zm0-4H1V7h2v2zm0-4H1V3h2v2zm9 8H4V3h8v10zm3 0h-2v-2h2v2zm0-4h-2V7h2v2zm0-4h-2V3h2v2zM6 5v6l4-3z"
});

function SvgFilm4(props) {
  return /*#__PURE__*/createElement("svg", _extends$a3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a3);
}

function _extends$a4() { _extends$a4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a4.apply(this, arguments); }

var _ref$a4 = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.582 0 0 1.119 0 2.5V4l6 6v5c0 .552.895 1 2 1s2-.448 2-1v-5l6-6V2.5C16 1.119 12.418 0 8 0zM1.475 2.169c.374-.213.9-.416 1.52-.586C4.369 1.207 6.147 1 8 1s3.631.207 5.005.583c.62.17 1.146.372 1.52.586.247.141.38.26.442.331-.062.071-.195.19-.442.331-.374.213-.9.416-1.52.586C11.631 3.793 9.853 4 8 4s-3.631-.207-5.005-.583c-.62-.17-1.146-.372-1.52-.586a1.741 1.741 0 01-.442-.331c.062-.071.195-.19.442-.331z"
});

function SvgFilter(props) {
  return /*#__PURE__*/createElement("svg", _extends$a4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a4);
}

function _extends$a5() { _extends$a5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a5.apply(this, arguments); }

var _ref$a5 = /*#__PURE__*/createElement("path", {
  d: "M16 3.5C16 1.567 12.418 0 8 0S0 1.567 0 3.5c0 .615.363 1.193 1 1.696l5 4.57V15c0 .552.895 1 2 1s2-.448 2-1V9.766l5-4.57c.637-.502 1-1.08 1-1.696zm-1.62.942L9 9.325v5.472c-.159.088-.505.203-1 .203s-.841-.115-1-.203V9.325L1.62 4.442C1.389 4.26 1 3.867 1 3.5c0-.204.117-.429.348-.667.307-.318.79-.626 1.396-.891a10.625 10.625 0 012.324-.714C5.994 1.057 6.981.938 8 .938s2.006.118 2.932.29c.877.162 1.659.423 2.324.714.606.265 1.089.573 1.396.891.231.239.348.463.348.667 0 .367-.388.759-.62.942zM3 3.633c0-.755 2.239-1.367 5-1.367s5 .612 5 1.367S10.761 5 8 5s-5-.612-5-1.367z"
});

function SvgFilter2(props) {
  return /*#__PURE__*/createElement("svg", _extends$a5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a5);
}

function _extends$a6() { _extends$a6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a6.apply(this, arguments); }

var _ref$a6 = /*#__PURE__*/createElement("path", {
  d: "M0 2l6 6v6l4-1V8l6-6z"
});

function SvgFilter3(props) {
  return /*#__PURE__*/createElement("svg", _extends$a6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a6);
}

function _extends$a7() { _extends$a7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a7.apply(this, arguments); }

var _ref$a7 = /*#__PURE__*/createElement("path", {
  d: "M13.586 3L9 7.586v4.633l-2 .5V7.586L2.414 3h11.172zM16 2H0l6 6v6l4-1V8l6-6z"
});

function SvgFilter4(props) {
  return /*#__PURE__*/createElement("svg", _extends$a7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a7);
}

function _extends$a8() { _extends$a8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a8.apply(this, arguments); }

var _ref$a8 = /*#__PURE__*/createElement("path", {
  d: "M8.894 12.16v-.002.002zM8.916 12.727l-.001-.011.001.011zM8.903 12.442v-.008.008zM15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM3 3.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zM15 15H9.14a20.425 20.425 0 01-.209-1.994v.005a8.551 8.551 0 01-6.595-2.09.563.563 0 01.744-.844 7.426 7.426 0 005.807 1.806 31.808 31.808 0 01.11-3.334A.499.499 0 008.499 8H7.012c.022-.541.079-1.466.234-2.503.295-1.981.812-3.528 1.502-4.497h6.251v14z"
});

var _ref2$2D = /*#__PURE__*/createElement("path", {
  d: "M12.5 5a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM8.445 13.05zM8 13.063zM8.423 11.925l.037-.002-.037.002zM8.204 11.934a.803.803 0 00.05-.002l-.05.002zM13.713 10.128a.563.563 0 00-.794-.05 7.428 7.428 0 01-4.032 1.806c.007.364.02.742.043 1.127a8.552 8.552 0 004.733-2.09.563.563 0 00.05-.794zM8.93 13.012zM8.68 13.035l-.183.013.183-.013z"
});

function SvgFinder(props) {
  return /*#__PURE__*/createElement("svg", _extends$a8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a8, _ref2$2D);
}

function _extends$a9() { _extends$a9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a9.apply(this, arguments); }

var _ref$a9 = /*#__PURE__*/createElement("path", {
  d: "M5 6h2v2H5V6zM9 6h2v2H9V6z"
});

var _ref2$2E = /*#__PURE__*/createElement("path", {
  d: "M15 1a1 1 0 00-1 1v1H2V2a1 1 0 00-2 0v13a1 1 0 002 0v-4h12v4a1 1 0 002 0V2a1 1 0 00-1-1zm-2 9V8h-2v2H9V8H7v2H5V8H3v2H2V8h1V6H2V4h1v2h2V4h2v2h2V4h2v2h2V4h1v2h-1v2h1v2h-1z"
});

function SvgFinish(props) {
  return /*#__PURE__*/createElement("svg", _extends$a9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a9, _ref2$2E);
}

function _extends$aa() { _extends$aa = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aa.apply(this, arguments); }

var _ref$aa = /*#__PURE__*/createElement("path", {
  d: "M5.016 16c-1.066-2.219-.498-3.49.321-4.688.897-1.312 1.129-2.61 1.129-2.61s.706.917.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013.376.823.448 2.216-.313 2.893C9.999 1.002 6.818.002 6.818.002c.376 2.516-1.364 5.268-3.042 7.324-.059-1.003-.122-1.696-.649-2.656-.118 1.823-1.511 3.309-1.889 5.135-.511 2.473.383 4.284 3.777 6.197z"
});

function SvgFire(props) {
  return /*#__PURE__*/createElement("svg", _extends$aa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aa);
}

function _extends$ab() { _extends$ab = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ab.apply(this, arguments); }

var _ref$ab = /*#__PURE__*/createElement("path", {
  d: "M8 0S2 6 2 10a6 6 0 1012 0C14 6 8 0 8 0zm0 14a2.5 2.5 0 01-2.5-2.5C5.5 9.833 8 7.333 8 7.333s2.5 2.5 2.5 4.167A2.5 2.5 0 018 14z"
});

function SvgFire2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ab({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ab);
}

function _extends$ac() { _extends$ac = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ac.apply(this, arguments); }

var _ref$ac = /*#__PURE__*/createElement("path", {
  d: "M15.977 5.221l-.185 1.189s-.265-2.201-.59-3.024c-.498-1.261-.719-1.251-.72-1.249.333.847.273 1.302.273 1.302s-.591-1.609-2.152-2.121C10.874.751 9.938.906 9.83.935h-.047l.038.003-.001.001c.007.009 1.911.333 2.249.797 0 0-.809 0-1.614.232-.036.01 2.961.374 3.574 3.37 0 0-.329-.686-.735-.802.267.813.199 2.356-.056 3.123-.033.099-.066-.426-.568-.652.161 1.151-.01 2.976-.808 3.479-.062.039.5-1.802.113-1.09-2.23 3.419-4.866 1.578-6.051.767.607.132 1.76-.021 2.271-.4l.002-.001c.554-.379.882-.656 1.177-.59s.491-.23.262-.493a1.527 1.527 0 00-1.539-.428c-.531.139-1.19.727-2.194.132-.771-.457-.844-.837-.851-1.1.019-.093.043-.18.072-.26.089-.248.358-.323.508-.382.254.044.473.123.703.241a4.049 4.049 0 000-.293c.022-.044.008-.176-.027-.337a2.364 2.364 0 00-.106-.48l.002-.001.003-.003.001-.001.003-.007c.016-.072.188-.211.402-.361.192-.134.417-.277.595-.387.157-.098.277-.17.302-.189l.034-.026.007-.006.004-.004a.623.623 0 00.237-.462v-.002l.002-.024.001-.017.001-.013.001-.032v-.002c0-.026 0-.053-.002-.081a.268.268 0 00-.005-.043v-.002l-.001-.004a.025.025 0 00-.002-.007v-.001a.049.049 0 00-.003-.007c-.027-.064-.13-.088-.554-.096h-.001a36.33 36.33 0 00-.695-.002c-.52.002-.807-.508-.898-.705.126-.695.489-1.19 1.085-1.525.011-.006.009-.012-.004-.015.117-.071-1.41-.002-2.112.891-.623-.155-1.166-.144-1.635-.035a2.024 2.024 0 01-.335-.041c-.311-.282-.757-.803-.781-1.425l-.004.003-.001-.018s-.949.729-.807 2.717l-.002.092c-.257.348-.384.641-.394.706C.418 5.1.188 5.797 0 6.855c0 0 .131-.417.395-.889C.201 6.56.049 7.484.138 8.87c0 0 .024-.307.107-.75.065.86.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791a8.06 8.06 0 001.272.003l.118-.009a8.877 8.877 0 001.457-.224c6.643-1.606 5.921-9.628 5.921-9.628z"
});

function SvgFirefox(props) {
  return /*#__PURE__*/createElement("svg", _extends$ac({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ac);
}

function _extends$ad() { _extends$ad = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ad.apply(this, arguments); }

var _ref$ad = /*#__PURE__*/createElement("path", {
  d: "M2 14V2h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5V14z"
});

function SvgFirst(props) {
  return /*#__PURE__*/createElement("svg", _extends$ad({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ad);
}

function _extends$ae() { _extends$ae = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ae.apply(this, arguments); }

var _ref$ae = /*#__PURE__*/createElement("path", {
  d: "M13 3l-3-3-8 8 8 8 3-3-5-5zM0 0v16h2V0z"
});

function SvgFirst2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ae({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ae);
}

function _extends$af() { _extends$af = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$af.apply(this, arguments); }

var _ref$af = /*#__PURE__*/createElement("path", {
  d: "M15.927 7.24c-.781-1.28-1.808-2.343-2.97-3.074A7.437 7.437 0 009 3c-1.973 0-3.869.814-5.395 2.304-.867-1.024-1.862-1.8-2.903-2.261a.5.5 0 00-.649.681L1.942 7.5.053 11.276A.502.502 0 00.5 12a.496.496 0 00.202-.043c1.042-.461 2.037-1.238 2.903-2.261C5.131 11.186 7.027 12 9 12a7.437 7.437 0 003.957-1.166c1.161-.73 2.188-1.793 2.97-3.074a.498.498 0 000-.521zM13 8a1 1 0 110-2 1 1 0 010 2z"
});

function SvgFish(props) {
  return /*#__PURE__*/createElement("svg", _extends$af({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$af);
}

function _extends$ag() { _extends$ag = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ag.apply(this, arguments); }

var _ref$ag = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM13 10.047c1.291 0 2.415-.312 3-.773v-8c-.585.461-1.709.773-3 .773s-2.415-.312-3-.773v8c.585.461 1.709.773 3 .773zM9.5.508C8.767.196 7.695 0 6.5 0 4.994 0 3.682.312 3 .773v8C3.682 8.312 4.994 8 6.5 8c1.195 0 2.267.197 3 .508v-8z"
});

function SvgFlag(props) {
  return /*#__PURE__*/createElement("svg", _extends$ag({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ag);
}

function _extends$ah() { _extends$ah = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ah.apply(this, arguments); }

var _ref$ah = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM12.5 2.047c-.946 0-1.815-.123-2.5-.329V.774C9.318.313 8.006.001 6.5.001S3.682.313 3 .774v8c.682-.461 1.994-.773 3.5-.773.946 0 1.815.123 2.5.329v.944c.682.461 1.994.773 3.5.773s2.818-.312 3.5-.773v-8c-.682.461-1.994.773-3.5.773zm-3 4.312v1.076l-.212-.064c-.808-.243-1.772-.372-2.788-.372-.903 0-1.763.104-2.5.293V1.328c.685-.206 1.554-.329 2.5-.329 1.195 0 2.267.197 3 .508v4.851zM15 8.663c-.557.213-1.434.384-2.5.384s-1.943-.172-2.5-.384V2.756c.745.191 1.602.292 2.5.292.903 0 1.763-.104 2.5-.293v5.909z"
});

function SvgFlag2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ah({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ah);
}

function _extends$ai() { _extends$ai = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ai.apply(this, arguments); }

var _ref$ai = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM10 1c-.5 0-.75-.25-1-.5S8.5 0 8 0H3v10h5c.5 0 .75.25 1 .5s.5.5 1 .5h5V1h-5z"
});

function SvgFlag3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ai({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ai);
}

function _extends$aj() { _extends$aj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aj.apply(this, arguments); }

var _ref$aj = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM10 1c-.5 0-.75-.25-1-.5S8.5 0 8 0H3v10h5c.5 0 .75.25 1 .5s.5.5 1 .5h5V1h-5zM4 9V1h4c.078 0 .086 0 .293.207.056.056.12.119.191.185V9.05A2.268 2.268 0 008 8.999H4zm10 1h-4c-.078 0-.086 0-.293-.207A2.905 2.905 0 009 9.238V1.762C9.262 1.9 9.589 2 10 2h4v8z"
});

function SvgFlag4(props) {
  return /*#__PURE__*/createElement("svg", _extends$aj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aj);
}

function _extends$ak() { _extends$ak = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ak.apply(this, arguments); }

var _ref$ak = /*#__PURE__*/createElement("path", {
  d: "M7.939 1.907C6.433.118 5.292 0 3 0v8c4.008-2 4.457.26 6.985.032C12.477 7.806 14.595 5.889 16 4c-3.98.92-5.983.376-8.061-2.093zM0 0h2v16H0z"
});

function SvgFlag5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ak({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ak);
}

function _extends$al() { _extends$al = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$al.apply(this, arguments); }

var _ref$al = /*#__PURE__*/createElement("path", {
  d: "M4 1.016c.606.025 1.053.084 1.449.216.599.199 1.115.594 1.725 1.319 1.693 2.011 3.404 2.87 5.722 2.87.242 0 .493-.01.755-.029a14.34 14.34 0 01-.992 1.064c-.483.464-.953.829-1.398 1.084-.468.269-.923.425-1.352.464-.057.005-.11.008-.165.008-.526 0-.93-.244-1.545-.643-.705-.457-1.583-1.025-2.861-1.025-.428 0-.872.064-1.339.193v-5.52zM3 0v8c.956-.477 1.711-.657 2.339-.657 1.917 0 2.668 1.668 4.406 1.668.083 0 .167-.004.255-.012 2.492-.226 4.595-3.111 6-5-1.194.276-2.21.42-3.104.42-2.085 0-3.503-.785-4.957-2.513C6.433.117 5.292-.001 3-.001zM0 0h2v16H0z"
});

function SvgFlag6(props) {
  return /*#__PURE__*/createElement("svg", _extends$al({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$al);
}

function _extends$am() { _extends$am = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$am.apply(this, arguments); }

var _ref$am = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM3 1v8h12.5l-4-4 4-4z"
});

function SvgFlag7(props) {
  return /*#__PURE__*/createElement("svg", _extends$am({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$am);
}

function _extends$an() { _extends$an = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$an.apply(this, arguments); }

var _ref$an = /*#__PURE__*/createElement("path", {
  d: "M0 0h2v16H0V0zM14.512 9H3.499a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h11.012a.5.5 0 01.354.854L11.719 5l3.132 3.132a.5.5 0 01-.338.868zM4 8h9.305l-2.646-2.646a.5.5 0 010-.707l2.646-2.646H4v6z"
});

function SvgFlag8(props) {
  return /*#__PURE__*/createElement("svg", _extends$an({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$an);
}

function _extends$ao() { _extends$ao = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ao.apply(this, arguments); }

var _ref$ao = /*#__PURE__*/createElement("path", {
  d: "M5.743 0C1.941 0 0 2.19 0 6.279v8.579l3.725-3.729V6.771c0-1.694.449-2.772 1.955-3.014.526-.103 1.621-.067 2.317-.067v2.587a.247.247 0 00.245.269c.063 0 .123-.033.184-.093L14.881 0 5.742-.001zm6.532 4.871v4.358c0 1.694-.449 2.772-1.955 3.014-.526.103-1.621.067-2.317.067V9.723a.414.414 0 00-.009-.087.246.246 0 00-.236-.182c-.064 0-.123.033-.184.093L1.119 16l9.139.001c3.802 0 5.743-2.19 5.743-6.279V1.143l-3.725 3.729z"
});

function SvgFlattr(props) {
  return /*#__PURE__*/createElement("svg", _extends$ao({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ao);
}

function _extends$ap() { _extends$ap = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ap.apply(this, arguments); }

var _ref$ap = /*#__PURE__*/createElement("path", {
  d: "M0 8.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm9 0a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
});

function SvgFlickr(props) {
  return /*#__PURE__*/createElement("svg", _extends$ap({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ap);
}

function _extends$aq() { _extends$aq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aq.apply(this, arguments); }

var _ref$aq = /*#__PURE__*/createElement("path", {
  d: "M12.5 6.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0-1.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM0 8.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
});

function SvgFlickr2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aq);
}

function _extends$ar() { _extends$ar = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ar.apply(this, arguments); }

var _ref$ar = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-10 10.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm7 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgFlickr3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ar({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ar);
}

function _extends$as() { _extends$as = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$as.apply(this, arguments); }

var _ref$as = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.582 0 0 3.606 0 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055S12.418 0 8 0zM4.5 10.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm7 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgFlickr4(props) {
  return /*#__PURE__*/createElement("svg", _extends$as({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$as);
}

function _extends$at() { _extends$at = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$at.apply(this, arguments); }

var _ref$at = /*#__PURE__*/createElement("path", {
  d: "M9 0v16h6zM0 16h6V0z"
});

function SvgFlipHorizontal(props) {
  return /*#__PURE__*/createElement("svg", _extends$at({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$at);
}

function _extends$au() { _extends$au = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$au.apply(this, arguments); }

var _ref$au = /*#__PURE__*/createElement("path", {
  d: "M0 16L7 0v16zM9 12.125v.25h5.414l-.109-.25zM9 11.625v.25h5.195l-.109-.25zM9 8.125v.25h3.664l-.109-.25zM9 10.625v.25h4.758l-.109-.25zM9 8.625v.25h3.883l-.109-.25zM9 9.125v.25h4.102l-.109-.25zM9 9.625v.25h4.32l-.109-.25zM9 10.125v.25h4.539l-.109-.25zM9 15.125v.25h6.727l-.109-.25zM15.836 15.625H9v.25h6.945zM9 12.625v.25h5.633l-.109-.25zM9 14.625v.25h6.508l-.109-.25zM9 13.125v.25h5.852l-.109-.25zM9 13.625v.25h6.07l-.109-.25zM9 14.125v.25h6.289l-.109-.25zM9 11.125v.25h4.977l-.109-.25zM9 1.625v.25h.82l-.109-.25zM9 2.625v.25h1.258l-.109-.25zM9 2.125v.25h1.039l-.109-.25zM9 3.125v.25h1.477l-.109-.25zM9 1.125v.25h.602l-.109-.25zM9 7.625v.25h3.445l-.109-.25zM9 .625v.25h.383l-.109-.25zM9 3.625v.25h1.695l-.109-.25zM9 .125v.25h.164l-.109-.25zM9 6.125v.25h2.789l-.109-.25zM9 4.125v.25h1.914l-.109-.25zM9 7.125v.25h3.227l-.109-.25zM9 6.625v.25h3.008l-.109-.25zM9 4.625v.25h2.133l-.109-.25zM9 5.625v.25h2.57l-.109-.25zM9 5.125v.25h2.352l-.109-.25z"
});

function SvgFlipHorizontal2(props) {
  return /*#__PURE__*/createElement("svg", _extends$au({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$au);
}

function _extends$av() { _extends$av = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$av.apply(this, arguments); }

var _ref$av = /*#__PURE__*/createElement("path", {
  d: "M0 6h16V0zm16 9V9H0z"
});

function SvgFlipVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends$av({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$av);
}

function _extends$aw() { _extends$aw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aw.apply(this, arguments); }

var _ref$aw = /*#__PURE__*/createElement("path", {
  d: "M16 16L0 9h16zM16 2.875v-.25h-6l-.571.25zM16 1.875v-.25h-3.714l-.571.25zM16 .875v-.25h-1.429L14 .875zM15.143.375H16v-.25h-.286zM16 1.375v-.25h-2.571l-.571.25zM16 3.375v-.25H8.857l-.571.25zM16 2.375v-.25h-4.857l-.571.25zM16 6.375v-.25H2l-.571.25zM16 6.875v-.25H.857l-.571.25zM16 5.875v-.25H3.143l-.571.25zM16 4.875v-.25H5.429l-.571.25zM16 4.375v-.25H6.571L6 4.375zM16 5.375v-.25H4.286l-.571.25zM16 3.875v-.25H7.714l-.571.25z"
});

function SvgFlipVertical2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aw);
}

function _extends$ax() { _extends$ax = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ax.apply(this, arguments); }

var _ref$ax = /*#__PURE__*/createElement("path", {
  d: "M10.854 1.854A.499.499 0 0010.5 1H.5a.5.5 0 00-.354.854l5 5a.5.5 0 00.707 0l5-5zM9 8.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM6 8.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM3 8.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM0 8.5A.5.5 0 01.5 8h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM10.962 15.691a.504.504 0 00-.108-.545l-5-5a.5.5 0 00-.707 0l-5 5A.499.499 0 00.501 16h10a.5.5 0 00.462-.309zm-8.953-.816L5.5 11.384l3.491 3.491H2.009zM13 12.5a4.994 4.994 0 002-4 4.998 4.998 0 00-2.222-4.158.5.5 0 00-.557.831A3.998 3.998 0 0113.999 8.5c0 1.313-.64 2.534-1.716 3.284L10.999 10.5V14h3.5l-1.5-1.5z"
});

function SvgFlipVertical3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ax({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ax);
}

function _extends$ay() { _extends$ay = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ay.apply(this, arguments); }

var _ref$ay = /*#__PURE__*/createElement("path", {
  d: "M.854 5.146A.499.499 0 000 5.5v10a.5.5 0 00.854.354l5-5a.5.5 0 000-.707l-5-5zM7.5 7a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM7.5 10a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM7.5 13a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM7.5 16a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM14.691 5.038a.504.504 0 00-.545.108l-5 5a.5.5 0 000 .707l5 5a.499.499 0 00.854-.354v-10a.5.5 0 00-.309-.462zm-.816 8.953L10.384 10.5l3.491-3.491v6.982zM11.5 3a4.994 4.994 0 00-4-2 4.998 4.998 0 00-4.158 2.222.5.5 0 00.831.557A3.998 3.998 0 017.5 2.001c1.313 0 2.534.64 3.284 1.716L9.5 5.001H13v-3.5l-1.5 1.5z"
});

function SvgFlipVertical4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ay({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ay);
}

function _extends$az() { _extends$az = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$az.apply(this, arguments); }

var _ref$az = /*#__PURE__*/createElement("path", {
  d: "M13.5 0H.5C.225 0 0 .225 0 .5v15c0 .275.225.5.5.5h15c.275 0 .5-.225.5-.5v-13L13.5 0zM4 .5h8v4c0 .275-.225.5-.5.5h-7a.501.501 0 01-.5-.5v-4zm10 15H2V9a1 1 0 011-1h10a1 1 0 011 1v6.5z"
});

var _ref2$2F = /*#__PURE__*/createElement("path", {
  d: "M9 1h2v3H9V1zM4 9h8v1H4V9zM4 11h8v1H4v-1zM4 13h8v1H4v-1z"
});

function SvgFloppyDisk(props) {
  return /*#__PURE__*/createElement("svg", _extends$az({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$az, _ref2$2F);
}

function _extends$aA() { _extends$aA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aA.apply(this, arguments); }

var _ref$aA = /*#__PURE__*/createElement("path", {
  d: "M14 0H0v16h16V2l-2-2zM8 2h2v4H8V2zm6 12H2V2h1v5h9V2h1.172l.828.828V14z"
});

function SvgFloppyDisk2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aA);
}

function _extends$aB() { _extends$aB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aB.apply(this, arguments); }

var _ref$aB = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$2G = /*#__PURE__*/createElement("path", {
  d: "M8 5.5h1v2H8v-2z"
});

var _ref3$f = /*#__PURE__*/createElement("path", {
  d: "M10.5 4h-6c-.275 0-.5.225-.5.5v7c0 .275.225.5.5.5h7c.275 0 .5-.225.5-.5v-6L10.5 4zM6 5h4v3H6V5zm5 6H5v-1h6v1z"
});

function SvgFloppyDisk3(props) {
  return /*#__PURE__*/createElement("svg", _extends$aB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aB, _ref2$2G, _ref3$f);
}

function _extends$aC() { _extends$aC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aC.apply(this, arguments); }

var _ref$aC = /*#__PURE__*/createElement("path", {
  d: "M11 6h1v2h-1V6z"
});

var _ref2$2H = /*#__PURE__*/createElement("path", {
  d: "M13.5 5H11V2.5L8.5 0h-8C.225 0 0 .225 0 .5v10c0 .275.225.5.5.5H5v4.5c0 .275.225.5.5.5h10c.275 0 .5-.225.5-.5v-8L13.5 5zm-.5.5v3c0 .275-.225.5-.5.5h-4a.501.501 0 01-.5-.5v-3h5zM5 10H2V7.5a.5.5 0 01.5-.5H5v3zM3.5 4a.501.501 0 01-.5-.5v-3h5v3c0 .275-.225.5-.5.5h-4zM14 15H7v-2.5a.5.5 0 01.5-.5h6a.5.5 0 01.5.5V15z"
});

var _ref3$g = /*#__PURE__*/createElement("path", {
  d: "M6 1h1v2H6V1z"
});

function SvgFloppyDisks(props) {
  return /*#__PURE__*/createElement("svg", _extends$aC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aC, _ref2$2H, _ref3$g);
}

function _extends$aD() { _extends$aD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aD.apply(this, arguments); }

var _ref$aD = /*#__PURE__*/createElement("path", {
  d: "M11 6h1v2h-1V6z"
});

var _ref2$2I = /*#__PURE__*/createElement("path", {
  d: "M13.5 5H11V2.5L8.5 0h-8C.225 0 0 .225 0 .5v10c0 .275.225.5.5.5H5v4.5c0 .275.225.5.5.5h10c.275 0 .5-.225.5-.5v-8L13.5 5zm-6 7h6c.127 0 .242.047.33.125H7.17A.495.495 0 017.5 12zM7 15v-.125h7V15H7zm0-.375v-.25h7v.25H7zm0-.5v-.25h7v.25H7zm0-.5v-.25h7v.25H7zm0-.5v-.25h7v.25H7zm0-.5V12.5c0-.043.006-.085.016-.125h6.967c.01.04.016.082.016.125v.125h-7zM13 5.5v3c0 .275-.225.5-.5.5h-4a.501.501 0 01-.5-.5v-3h5zM5 7.125H2.17A.495.495 0 012.5 7H5v.125zM2 10v-.125h3V10H2zm0-.375v-.25h3v.25H2zm0-.5v-.25h3v.25H2zm0-.5v-.25h3v.25H2zm0-.5v-.25h3v.25H2zm0-.5V7.5c0-.043.006-.085.016-.125H5v.25H2zM3.5 4a.501.501 0 01-.5-.5v-3h5v3c0 .275-.225.5-.5.5h-4z"
});

var _ref3$h = /*#__PURE__*/createElement("path", {
  d: "M6 1h1v2H6V1z"
});

function SvgFloppyDisks2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aD, _ref2$2I, _ref3$h);
}

function _extends$aE() { _extends$aE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aE.apply(this, arguments); }

var _ref$aE = /*#__PURE__*/createElement("path", {
  d: "M15.801 5.902c-.835-2.568-3.368-2.828-5.323-.876C11.73 2.563 10.7.234 8 .234S4.27 2.563 5.522 5.026C3.567 3.075 1.034 3.334.199 5.902S1.261 10.169 3.99 9.74c-2.46 1.257-2.996 3.746-.811 5.333s4.386.308 4.821-2.42c.435 2.728 2.637 4.007 4.822 2.42s1.648-4.077-.812-5.333c2.729.429 4.626-1.27 3.792-3.838zM8 10.717a2.313 2.313 0 110-4.626 2.313 2.313 0 010 4.626z"
});

function SvgFlower(props) {
  return /*#__PURE__*/createElement("svg", _extends$aE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aE);
}

function _extends$aF() { _extends$aF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aF.apply(this, arguments); }

var _ref$aF = /*#__PURE__*/createElement("path", {
  d: "M10.723 15.749c-.791 0-1.544-.334-2.119-.939a3.818 3.818 0 01-.605-.854c-.168.321-.37.608-.605.854-.575.606-1.328.939-2.119.939-.696 0-1.419-.256-2.09-.742-.977-.707-1.47-1.677-1.388-2.73.064-.82.466-1.61 1.128-2.265-1.026-.15-1.873-.614-2.388-1.323-.553-.762-.67-1.758-.329-2.804.457-1.4 1.422-2.204 2.648-2.204.555 0 1.136.166 1.708.481-.103-.847.056-1.671.477-2.359C5.646.815 6.724.248 7.997.248s2.351.567 2.956 1.555c.421.687.58 1.511.477 2.358.572-.315 1.153-.481 1.708-.481 1.226 0 2.191.803 2.649 2.204.341 1.046.225 2.042-.329 2.804-.514.709-1.362 1.172-2.388 1.322.662.655 1.064 1.444 1.128 2.264.082 1.054-.411 2.023-1.388 2.73-.671.485-1.393.742-2.09.742zM8 11.844a.5.5 0 01.494.421c.242 1.509 1.117 2.485 2.23 2.485.492 0 .997-.186 1.504-.552.694-.502 1.032-1.139.977-1.842-.072-.917-.811-1.84-1.931-2.409a.5.5 0 01.304-.94c.253.04.506.06.75.06 1.033 0 1.88-.351 2.324-.963.365-.503.43-1.163.187-1.906-.225-.691-.703-1.514-1.698-1.514-.705 0-1.539.427-2.288 1.172a.5.5 0 01-.798-.582c.527-1.033.545-2.133.049-2.945C9.679 1.634 8.932 1.252 8 1.252s-1.678.383-2.103 1.077c-.497.811-.479 1.912.049 2.945a.499.499 0 01-.798.582c-.749-.745-1.583-1.172-2.288-1.172-.995 0-1.472.823-1.698 1.514-.243.744-.178 1.403.187 1.906.444.612 1.291.963 2.324.963.244 0 .496-.02.75-.06a.5.5 0 01.304.94c-1.12.569-1.859 1.493-1.931 2.41-.055.703.283 1.34.977 1.842.499.361 1.019.552 1.503.552 1.113 0 1.988-.975 2.23-2.485A.5.5 0 018 11.845z"
});

var _ref2$2J = /*#__PURE__*/createElement("path", {
  d: "M8 10.717c-1.275 0-2.313-1.037-2.313-2.313S6.724 6.091 8 6.091c1.275 0 2.313 1.038 2.313 2.313S9.275 10.717 8 10.717zm0-3.625c-.724 0-1.313.589-1.313 1.313S7.276 9.718 8 9.718s1.313-.589 1.313-1.313S8.724 7.092 8 7.092z"
});

function SvgFlower2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aF, _ref2$2J);
}

function _extends$aG() { _extends$aG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aG.apply(this, arguments); }

var _ref$aG = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zM0 5l1 10h14l1-10H0zm6.719 8.352L3.512 9.645l.914-.914 2.293 1.793 4.293-3.793.914.914-5.207 5.707z"
});

function SvgFolderCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$aG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aG);
}

function _extends$aH() { _extends$aH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aH.apply(this, arguments); }

var _ref$aH = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zM0 5l1 10h14l1-10H0zm8 9.5L3.5 10H7V7.015h2V10h3.5L8 14.5z"
});

function SvgFolderDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$aH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aH);
}

function _extends$aI() { _extends$aI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aI.apply(this, arguments); }

var _ref$aI = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm-1 9.5L4.5 10H7V6h2v4h2.5L8 13.5z"
});

function SvgFolderDownload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aI);
}

function _extends$aJ() { _extends$aJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aJ.apply(this, arguments); }

var _ref$aJ = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm6 10H1V3h5.586l2 2H15v9zm-6-4V7H7v3H4l4 4 4-4z"
});

function SvgFolderDownload3(props) {
  return /*#__PURE__*/createElement("svg", _extends$aJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aJ);
}

function _extends$aK() { _extends$aK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aK.apply(this, arguments); }

var _ref$aK = /*#__PURE__*/createElement("path", {
  d: "M14.5 3H8l-.5-1H2L1 4h14zM0 5l1 10h14l1-10H0zm11.5 5.494l-.004.004C11.421 10.586 8 14 8 14s-3.418-3.411-3.488-3.492l-.006-.006h.001A2.124 2.124 0 118 8.125a2.125 2.125 0 113.5 2.369z"
});

function SvgFolderHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$aK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aK);
}

function _extends$aL() { _extends$aL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aL.apply(this, arguments); }

var _ref$aL = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zm-7.187 8.5c0 .918.266 1.776.724 2.5H1L0 5h16l-.399 3.988A4.669 4.669 0 0012.5 7.812a4.693 4.693 0 00-4.688 4.687zM12.5 9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM10 13v-1h5v1h-5z"
});

function SvgFolderMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$aL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aL);
}

function _extends$aM() { _extends$aM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aM.apply(this, arguments); }

var _ref$aM = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zM0 5l1 10h14l1-10H0zm11 6H5V9h6v2z"
});

function SvgFolderMinus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aM);
}

function _extends$aN() { _extends$aN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aN.apply(this, arguments); }

var _ref$aN = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm2 7H5V9h6v2z"
});

function SvgFolderMinus3(props) {
  return /*#__PURE__*/createElement("svg", _extends$aN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aN);
}

function _extends$aO() { _extends$aO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aO.apply(this, arguments); }

var _ref$aO = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm6 10H1V3h5.586l2 2H15v9zM5 9h6v2H5z"
});

function SvgFolderMinus4(props) {
  return /*#__PURE__*/createElement("svg", _extends$aO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aO);
}

function _extends$aP() { _extends$aP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aP.apply(this, arguments); }

var _ref$aP = /*#__PURE__*/createElement("path", {
  d: "M13 15l3-8H3l-3 8zM2 6l-2 9V2h4.5l2 2H13v2z"
});

function SvgFolderOpen(props) {
  return /*#__PURE__*/createElement("svg", _extends$aP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aP);
}

function _extends$aQ() { _extends$aQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aQ.apply(this, arguments); }

var _ref$aQ = /*#__PURE__*/createElement("path", {
  d: "M15.383 6c.412 0 .684.331.603.735l-1.839 6.529a.955.955 0 01-.897.735H2.75a.955.955 0 01-.897-.735L.014 6.735C-.067 6.331.204 6 .617 6h14.766zM14 2.75V5H2V1.75A.75.75 0 012.75 1H6l.5 1h6.75a.75.75 0 01.75.75z"
});

function SvgFolderOpen2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aQ);
}

function _extends$aR() { _extends$aR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aR.apply(this, arguments); }

var _ref$aR = /*#__PURE__*/createElement("path", {
  d: "M15.383 6H14V2.75a.75.75 0 00-.75-.75H6.5L6 1H2.75a.75.75 0 00-.75.75V6H.617c-.412 0-.684.331-.603.735l1.839 6.529a.955.955 0 00.897.735h10.5a.956.956 0 00.897-.735l1.839-6.529c.081-.404-.19-.735-.603-.735zM3 2h2.382l.5 1H13v3H3V2zm10.181 11H2.819L1.094 7h13.811l-1.725 6z"
});

function SvgFolderOpen3(props) {
  return /*#__PURE__*/createElement("svg", _extends$aR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aR);
}

function _extends$aS() { _extends$aS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aS.apply(this, arguments); }

var _ref$aS = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zm-7.187 8.5c0 .918.266 1.776.724 2.5H1L0 5h16l-.399 3.988A4.669 4.669 0 0012.5 7.812a4.693 4.693 0 00-4.688 4.687zM12.5 9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm.5 4v2h-1v-2h-2v-1h2v-2h1v2h2v1h-2z"
});

function SvgFolderPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$aS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aS);
}

function _extends$aT() { _extends$aT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aT.apply(this, arguments); }

var _ref$aT = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zM0 5l1 10h14l1-10H0zm11 6H9v2H7v-2H5V9h2V7h2v2h2v2z"
});

function SvgFolderPlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aT);
}

function _extends$aU() { _extends$aU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aU.apply(this, arguments); }

var _ref$aU = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm2 7H9v2H7v-2H5V9h2V7h2v2h2v2z"
});

function SvgFolderPlus3(props) {
  return /*#__PURE__*/createElement("svg", _extends$aU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aU);
}

function _extends$aV() { _extends$aV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aV.apply(this, arguments); }

var _ref$aV = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm6 10H1V3h5.586l2 2H15v9zM9 7H7v2H5v2h2v2h2v-2h2V9H9z"
});

function SvgFolderPlus4(props) {
  return /*#__PURE__*/createElement("svg", _extends$aV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aV);
}

function _extends$aW() { _extends$aW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aW.apply(this, arguments); }

var _ref$aW = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5l.5 1zM0 5l1 10h14l1-10H0zm11.25 2.811L9.061 10l2.189 2.189-1.061 1.061L8 11.061 5.811 13.25 4.75 12.189 6.939 10 4.75 7.811 5.811 6.75 8 8.939l2.189-2.189 1.061 1.061z"
});

function SvgFolderRemove(props) {
  return /*#__PURE__*/createElement("svg", _extends$aW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aW);
}

function _extends$aX() { _extends$aX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aX.apply(this, arguments); }

var _ref$aX = /*#__PURE__*/createElement("path", {
  d: "M14.5 2H8l-.5-1H2L1 3h14zM14.13 11h1.17l.7-7H0l1 10h7.564a4.257 4.257 0 01-2.814-4c0-2.343 1.907-4.25 4.25-4.25A4.255 4.255 0 0114.13 11z"
});

var _ref2$2K = /*#__PURE__*/createElement("path", {
  d: "M15.672 14.277l-3.101-2.73a3 3 0 10-1.022 1.022l2.73 3.101a.916.916 0 001.359.051l.086-.086a.916.916 0 00-.051-1.359zM10 11.938a1.938 1.938 0 110-3.876 1.938 1.938 0 010 3.876z"
});

function SvgFolderSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$aX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aX, _ref2$2K);
}

function _extends$aY() { _extends$aY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aY.apply(this, arguments); }

var _ref$aY = /*#__PURE__*/createElement("path", {
  d: "M15 4H1l1-2h5.5L8 3h6.5zM0 5l1 10h14l1-10H0zm9 6v2.985H7V11H3.5L8 6.5l4.5 4.5H9z"
});

function SvgFolderUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$aY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aY);
}

function _extends$aZ() { _extends$aZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$aZ.apply(this, arguments); }

var _ref$aZ = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zM8 7.5l3.5 3.5H9v4H7v-4H4.5L8 7.5z"
});

function SvgFolderUpload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$aZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$aZ);
}

function _extends$a_() { _extends$a_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a_.apply(this, arguments); }

var _ref$a_ = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm6 10H9v-3h3L8 7l-4 4h3v3H1V3h5.586l2 2H15v9z"
});

function SvgFolderUpload3(props) {
  return /*#__PURE__*/createElement("svg", _extends$a_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a_);
}

function _extends$a$() { _extends$a$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a$.apply(this, arguments); }

var _ref$a$ = /*#__PURE__*/createElement("path", {
  d: "M0 5h16l-1 10H1L0 5zm14.5-2l.5 1H1l1-2h5.5L8 3h6.5z"
});

function SvgFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends$a$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$a$);
}

function _extends$b0() { _extends$b0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b0.apply(this, arguments); }

var _ref$b0 = /*#__PURE__*/createElement("path", {
  d: "M7 2l2 2h7v11H0V2z"
});

function SvgFolder2(props) {
  return /*#__PURE__*/createElement("svg", _extends$b0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b0);
}

function _extends$b1() { _extends$b1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b1.apply(this, arguments); }

var _ref$b1 = /*#__PURE__*/createElement("path", {
  d: "M9 4L7 2H0v13h16V4H9zm-.414 1H15v.125H1v-.25h7.461L8.586 5zM1 14v-.125h14V14H1zm0-.375v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zm0-.5v-.25h14v.25H1zM6.586 3l.125.125H1V3h5.586zm.375.375l.25.25H1v-.25h5.961zm.5.5l.25.25H1v-.25h6.461zm.5.5l.25.25H1v-.25h6.961z"
});

function SvgFolder3(props) {
  return /*#__PURE__*/createElement("svg", _extends$b1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b1);
}

function _extends$b2() { _extends$b2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b2.apply(this, arguments); }

var _ref$b2 = /*#__PURE__*/createElement("path", {
  d: "M6.586 3l2 2H15v9H1V3h5.586zM7 2H0v13h16V4H9L7 2z"
});

function SvgFolder4(props) {
  return /*#__PURE__*/createElement("svg", _extends$b2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b2);
}

function _extends$b3() { _extends$b3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b3.apply(this, arguments); }

var _ref$b3 = /*#__PURE__*/createElement("path", {
  d: "M15.383 4H.617c-.412 0-.684.331-.603.735l1.839 8.529a.955.955 0 00.897.735h10.5a.956.956 0 00.897-.735l1.839-8.529c.081-.404-.19-.735-.603-.735zM14 2.75a.75.75 0 00-.75-.75H6.5L6 1H2.75a.75.75 0 00-.75.75V3h12v-.25z"
});

function SvgFolder5(props) {
  return /*#__PURE__*/createElement("svg", _extends$b3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b3);
}

function _extends$b4() { _extends$b4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b4.apply(this, arguments); }

var _ref$b4 = /*#__PURE__*/createElement("path", {
  d: "M15.383 4H14V2.75a.75.75 0 00-.75-.75H6.5L6 1H2.75a.75.75 0 00-.75.75V4H.617c-.412 0-.684.331-.603.735l1.839 8.529a.955.955 0 00.897.735h10.5a.956.956 0 00.897-.735l1.839-8.529c.081-.404-.19-.735-.603-.735zM3 2h2.382l.5 1H13v1H3V2zm10.181 11H2.819L1.094 5h13.811l-1.725 8z"
});

function SvgFolder6(props) {
  return /*#__PURE__*/createElement("svg", _extends$b4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b4);
}

function _extends$b5() { _extends$b5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b5.apply(this, arguments); }

var _ref$b5 = /*#__PURE__*/createElement("path", {
  d: "M2 0v5l2-3h4v13H6v1h6v-1h-2V2h4l2 3V0zm2 9h2l1 1.5V8H0v2.5L1 9h2v6H2v1h3v-1H4z"
});

function SvgFontSize(props) {
  return /*#__PURE__*/createElement("svg", _extends$b5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b5);
}

function _extends$b6() { _extends$b6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b6.apply(this, arguments); }

var _ref$b6 = /*#__PURE__*/createElement("path", {
  d: "M1 8h6v2H5v6H3v-6H1zm14-4h-3.934v12H8.933V4H4.999V2h10z"
});

function SvgFontSize2(props) {
  return /*#__PURE__*/createElement("svg", _extends$b6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b6);
}

function _extends$b7() { _extends$b7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b7.apply(this, arguments); }

var _ref$b7 = /*#__PURE__*/createElement("path", {
  d: "M12.494.253C11.08.253 10.172 0 8.715 0 4.007 0 1.812 2.681 1.812 5.404c0 1.604.76 2.132 2.259 2.132-.106-.232-.296-.486-.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v.385h4.947l1.688-8h3.091l.689-2H8.642l.812-3.847c.929.19 1.837.38 2.618.38.971 0 1.858-.296 2.343-2.533-.591.19-1.224.253-1.921.253z"
});

function SvgFont(props) {
  return /*#__PURE__*/createElement("svg", _extends$b7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b7);
}

function _extends$b8() { _extends$b8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b8.apply(this, arguments); }

var _ref$b8 = /*#__PURE__*/createElement("path", {
  d: "M15.908 2.485c-.131-1.19-1.202-2.261-2.393-2.393-3.233-.356-7.424.246-10.301 3.122s-3.479 7.068-3.123 10.3c.131 1.19 1.202 2.261 2.393 2.393 3.233.356 7.424-.246 10.3-3.122s3.479-7.068 3.123-10.301zM5.08 9.08a.594.594 0 01.84 0l1 1a.594.594 0 11-.84.84l-1-1a.594.594 0 010-.84zm.261 5.871c-.907-.461-1.745-1.067-2.485-1.807s-1.347-1.58-1.808-2.488c.056-.685.168-1.419.362-2.176.066-.258.14-.51.221-.756.295 1.642 1.081 3.154 2.285 4.359s2.714 1.989 4.355 2.285a12.839 12.839 0 01-2.931.583zM8.92 8.92a.592.592 0 01-.84 0l-1-1a.594.594 0 11.84-.84l1 1a.594.594 0 010 .84zm2-2a.592.592 0 01-.84 0l-1-1a.594.594 0 11.84-.84l1 1a.594.594 0 010 .84zm3.67.6c-.066.258-.14.51-.221.756-.295-1.642-1.081-3.154-2.285-4.359S9.37 1.928 7.729 1.632a12.839 12.839 0 012.931-.583c.907.461 1.745 1.067 2.485 1.807s1.347 1.58 1.808 2.488a13.075 13.075 0 01-.362 2.176z"
});

function SvgFootball(props) {
  return /*#__PURE__*/createElement("svg", _extends$b8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b8);
}

function _extends$b9() { _extends$b9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b9.apply(this, arguments); }

var _ref$b9 = /*#__PURE__*/createElement("path", {
  d: "M12.531 3.654c1.923 1.387 2.112 5.737 2.49 7.061l-3.58 1.419c-.365-2.396-3.45-4.193-3.576-6.841s2.743-3.026 4.666-1.639zm2.176 12.168c-2.858 1.039-3.026-2.806-3.026-2.806l3.72-1.513s1.734 3.436-.694 4.319zM.034 2.985C.413.644 2.709-1.116 4.492.845S5.364 6.259 6.8 8.21L3.266 9.738C2.597 8.534-.345 5.325.034 2.984zM7.1 13.127c-2.34 1.092-3.544-2.564-3.544-2.564l3.7-1.56s2.599 2.838-.156 4.124z"
});

function SvgFootprint(props) {
  return /*#__PURE__*/createElement("svg", _extends$b9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b9);
}

function _extends$ba() { _extends$ba = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ba.apply(this, arguments); }

var _ref$ba = /*#__PURE__*/createElement("path", {
  d: "M6.5 0a.5.5 0 00-.5.5V5c0 .296-.051.493-.15.585-.094.086-.277.132-.471.18a3.62 3.62 0 00-.379.11V.5a.5.5 0 00-1 0v5.375c-.134-.049-.265-.081-.379-.11-.194-.048-.377-.094-.471-.18C3.05 5.494 3 5.297 3 5V.5a.5.5 0 00-1 0V5c0 1.39.863 1.606 1.379 1.735.194.048.377.094.471.18.1.091.15.288.15.585v2.586A1.5 1.5 0 003 11.5v3a1.5 1.5 0 003 0v-3a1.5 1.5 0 00-1-1.414V7.5c0-.296.051-.493.15-.585.094-.086.277-.132.471-.18C6.137 6.606 7 6.39 7 5V.5a.5.5 0 00-.5-.5zM13 10.086V.5a.5.5 0 00-.5-.5c-1.078 0-1.767.72-2.155 1.323-.406.631-.729 1.497-.959 2.572A19.308 19.308 0 009 7.5a.5.5 0 00.5.5H12v2.086a1.5 1.5 0 00-1 1.414v3a1.5 1.5 0 003 0v-3a1.5 1.5 0 00-1-1.414zm-2.633-5.994c.259-1.202.745-2.6 1.633-2.988V7h-1.986c.028-.633.109-1.778.353-2.908z"
});

function SvgForkKnife(props) {
  return /*#__PURE__*/createElement("svg", _extends$ba({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ba);
}

function _extends$bb() { _extends$bb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bb.apply(this, arguments); }

var _ref$bb = /*#__PURE__*/createElement("path", {
  d: "M4.096 0C2.319 3.219 2.02 8.13 9 7.966V4l6 6-6 6v-3.881C.641 12.337-.29 4.741 4.096 0z"
});

function SvgForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$bb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bb);
}

function _extends$bc() { _extends$bc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bc.apply(this, arguments); }

var _ref$bc = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm-3-9L8.5 8 5 10.5zm4 0L12.5 8 9 10.5z"
});

function SvgForward2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bc);
}

function _extends$bd() { _extends$bd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bd.apply(this, arguments); }

var _ref$bd = /*#__PURE__*/createElement("path", {
  d: "M8 13.5v-5l-5 5v-11l5 5v-5L13.5 8z"
});

function SvgForward3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bd);
}

function _extends$be() { _extends$be = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$be.apply(this, arguments); }

var _ref$be = /*#__PURE__*/createElement("path", {
  d: "M13.306 1.408A1.001 1.001 0 0012.5 1H3a1 1 0 00-1 1v12a1.002 1.002 0 00.999 1 1 1 0 00.707-.293L7.413 11h2.586a.999.999 0 00.954-.702l2.5-8a.999.999 0 00-.149-.891zM10.515 5H7a1 1 0 000 2h2.89l-.625 2H7a.997.997 0 00-.707.293L4 11.586V3h7.14l-.625 2z"
});

function SvgFoursquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$be({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$be);
}

function _extends$bf() { _extends$bf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bf.apply(this, arguments); }

var _ref$bf = /*#__PURE__*/createElement("path", {
  d: "M5.724 4.428c-.543-.271-1.08-.407-1.102-.413a.5.5 0 10-.242.97c.275.07.602.189.89.334A.998.998 0 006.002 7a1 1 0 001-1L7 5.946c-.032-.741-.706-1.234-1.275-1.518z"
});

var _ref2$2L = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM3.695 12.87c.167.083.356.13.555.13h7.5c.199 0 .387-.047.555-.13C11.158 13.884 9.651 14.5 8 14.5s-3.158-.616-4.305-1.63zM4 11.75v-1.5c0-.136.114-.25.25-.25H6v2H4.25a.253.253 0 01-.25-.25zM7 12v-2h2v2H7zm3 0v-2h1.75c.136 0 .25.114.25.25v1.5c0 .136-.114.25-.25.25H10zm2.87.305c.083-.167.13-.356.13-.555v-1.5C13 9.561 12.439 9 11.75 9h-7.5C3.561 9 3 9.561 3 10.25v1.5c0 .199.047.387.13.555a6.5 6.5 0 119.74 0z"
});

var _ref3$i = /*#__PURE__*/createElement("path", {
  d: "M11.379 4.015c-.023.006-.559.141-1.102.413-.568.284-1.243.776-1.275 1.518L9 6a1 1 0 101.732-.681c.288-.144.614-.264.89-.334a.5.5 0 10-.242-.97z"
});

function SvgFrustrated(props) {
  return /*#__PURE__*/createElement("svg", _extends$bf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bf, _ref2$2L, _ref3$i);
}

function _extends$bg() { _extends$bg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bg.apply(this, arguments); }

var _ref$bg = /*#__PURE__*/createElement("path", {
  d: "M4 10.25v1.5c0 .136.114.25.25.25H6v-2H4.25a.253.253 0 00-.25.25zM7 10h2v2H7v-2zM11.75 10H10v2h1.75c.136 0 .25-.114.25-.25v-1.5a.253.253 0 00-.25-.25z"
});

var _ref2$2M = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1.002 5.946c.032-.741.706-1.234 1.275-1.518.543-.271 1.08-.407 1.102-.413a.5.5 0 11.242.97c-.275.07-.602.189-.89.334A.998.998 0 019.999 7a1 1 0 01-1-1l.002-.054zM4.015 4.379a.5.5 0 01.606-.364c.023.006.559.141 1.102.413.568.284 1.243.776 1.275 1.518L7 6a1 1 0 11-1.732-.681 4.638 4.638 0 00-.89-.334.5.5 0 01-.364-.606zM13 11.75c0 .689-.561 1.25-1.25 1.25h-7.5C3.561 13 3 12.439 3 11.75v-1.5C3 9.561 3.561 9 4.25 9h7.5c.689 0 1.25.561 1.25 1.25v1.5z"
});

function SvgFrustrated2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bg, _ref2$2M);
}

function _extends$bh() { _extends$bh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bh.apply(this, arguments); }

var _ref$bh = /*#__PURE__*/createElement("path", {
  d: "M14 6a2 2 0 00-2 2v2H4V8a2 2 0 10-4 0v4a2 2 0 002 2v2h1l.5-2h9l.5 2h1v-2a2 2 0 002-2V8a2 2 0 00-2-2z"
});

var _ref2$2N = /*#__PURE__*/createElement("path", {
  d: "M5 7.688v1.313h6V7.688C11 6.046 12 5 13.964 5.001a3.505 3.505 0 00-3.464-3h-5a3.505 3.505 0 00-3.464 3C4 5.001 5 6.046 5 7.688z"
});

function SvgFurniture(props) {
  return /*#__PURE__*/createElement("svg", _extends$bh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bh, _ref2$2N);
}

function _extends$bi() { _extends$bi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bi.apply(this, arguments); }

var _ref$bi = /*#__PURE__*/createElement("path", {
  d: "M5 5H4v1H3v1h1v1h1V7h1V6H5zm5 .75a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm1.5 1.5a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm.054-4.565C9.738 2.685 9.455 3.761 8 3.761S6.262 2.685 4.446 2.685C1.517 2.685 0 6.271 0 8.835c0 2.427.228 4.192 1.136 4.44s2.065-.731 3.193-1.793c1.128-1.062 1.318-.993 2.226-.993L8 10.521l1.445-.032c.908 0 1.098-.069 2.226.993s2.285 2.041 3.193 1.793c.908-.248 1.136-2.014 1.136-4.44 0-2.565-1.517-6.15-4.446-6.15zM4.5 9a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm7 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgGamepad(props) {
  return /*#__PURE__*/createElement("svg", _extends$bi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bi);
}

function _extends$bj() { _extends$bj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bj.apply(this, arguments); }

var _ref$bj = /*#__PURE__*/createElement("path", {
  d: "M14.873 4.935c-.406-.663-.89-1.188-1.439-1.561a3.616 3.616 0 00-2.063-.641c-1.017 0-1.588.322-2.092.606-.411.231-.735.414-1.278.414s-.867-.183-1.278-.414c-.504-.284-1.075-.606-2.092-.606-.743 0-1.437.216-2.063.641-.549.373-1.034.898-1.44 1.561C.422 6.087.001 7.599.001 8.979c0 1.326.072 2.269.225 2.969.209.949.587 1.486 1.157 1.641.125.034.258.052.393.052.982 0 2.035-.914 3.029-1.849.881-.829 1.037-.829 1.553-.829h.268l1.375.03 1.375-.03h.268c.517 0 .673 0 1.553.829.994.936 2.046 1.849 3.029 1.849.135 0 .267-.017.392-.052.57-.156.949-.693 1.157-1.641.154-.7.225-1.643.225-2.969 0-1.38-.421-2.892-1.127-4.044zm-.075 6.799c-.111.505-.281.847-.444.892a.472.472 0 01-.128.016c-.668 0-1.799-1.065-2.343-1.577-.532-.502-.847-.745-1.162-.897-.42-.204-.769-.204-1.077-.204h-.279l-1.364.03-1.375-.03h-.268c-.308 0-.656 0-1.077.204-.315.153-.63.396-1.162.897-.544.512-1.675 1.577-2.343 1.577a.485.485 0 01-.129-.016c-.162-.044-.332-.386-.443-.891-.138-.627-.202-1.502-.202-2.754 0-.588.091-1.223.262-1.839a6.686 6.686 0 01.718-1.683c.331-.541.718-.964 1.149-1.256a2.628 2.628 0 011.502-.468c.755 0 1.147.221 1.602.477.452.254.963.543 1.769.543s1.317-.288 1.768-.543c.454-.256.846-.477 1.601-.477.539 0 1.044.158 1.502.468.431.293.817.715 1.149 1.256.299.488.547 1.07.718 1.683.171.615.262 1.251.262 1.839 0 1.251-.064 2.127-.202 2.754zM10 6a1 1 0 112 0 1 1 0 01-2 0zm2 2a1 1 0 112 0 1 1 0 01-2 0zM4 5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
});

function SvgGamepad2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bj);
}

function _extends$bk() { _extends$bk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bk.apply(this, arguments); }

var _ref$bk = /*#__PURE__*/createElement("path", {
  d: "M15.5 3.025V3H5a5 5 0 104 8h2a5 5 0 104.5-7.975zM8 9H6v2H4V9H2V7h2V5h2v2h2v2zm6 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z"
});

function SvgGamepad3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$bk);
}

function _extends$bl() { _extends$bl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bl.apply(this, arguments); }

var _ref$bl = /*#__PURE__*/createElement("path", {
  d: "M14.854 4.146l-2-2A.5.5 0 0012.5 2h-1a.5.5 0 000 1h.543l1 1H12.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H14v4c0 .551-.449 1-1 1s-1-.449-1-1V8.5a.5.5 0 00-.5-.5H10V2.5C10 1.675 9.325 1 8.5 1h-6C1.675 1 1 1.675 1 2.5V15H0v1h11v-1h-1V9h1v2c0 1.103.897 2 2 2s2-.897 2-2V4.5a.504.504 0 00-.146-.354zM2 5.5v-3c0-.275.225-.5.5-.5h6c.275 0 .5.225.5.5v3c0 .275-.225.5-.5.5h-6a.501.501 0 01-.5-.5zM13 6V5h1v1h-1z"
});

function SvgGas(props) {
  return /*#__PURE__*/createElement("svg", _extends$bl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bl);
}

function _extends$bm() { _extends$bm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bm.apply(this, arguments); }

var _ref$bm = /*#__PURE__*/createElement("path", {
  d: "M56.347 39.04c0-1.348-1.203-2.442-2.68-2.442l-24.963-.011c-.718 0-1.3-.53-1.3-1.182 0-.656.582-1.183 1.3-1.183h20.851c1.475 0 2.677-1.096 2.677-2.437 0-1.348-1.202-2.444-2.677-2.444H23.85c-.988 0-1.822-.437-2.23-1.168-.463-.825-.302-1.87.431-2.793.85-1.064 7.321-8.61 7.597-8.932.41-.502.587-1.15.482-1.797-.106-.647-.48-1.216-1.056-1.604-1.525-1.036-3.11-.032-3.919.661-.753.638-3.61 3.006-7.032 5.84-4.389 3.635-9.708 8.042-12.69 10.549C3.402 31.803 0 35.535 0 41.332 0 50.088 7.733 55.97 19.245 55.97l24.031.03c1.476 0 2.677-1.094 2.677-2.44 0-1.345-1.201-2.441-2.677-2.441H28.704c-.718 0-1.3-.53-1.3-1.184 0-.002.002-.004.002-.01l-.001-.006c0-.655.58-1.184 1.299-1.184h20.85c1.476 0 2.678-1.094 2.678-2.44 0-1.345-1.202-2.441-2.677-2.441H28.704c-.718 0-1.3-.53-1.3-1.184 0-.654.582-1.183 1.3-1.183l24.964-.01c1.476 0 2.68-1.094 2.68-2.437m-33.41-27.496c.271-.231.551-.44.837-.628-.41-2.976-.852-6.258-.882-6.494-.102-.617-.478-1.188-1.053-1.581a2.878 2.878 0 00-1.992-.453c-1.883.251-2.225 1.983-2.261 2.992-.035.938-.218 4.453-.44 8.661l-.125 2.422c2.956-2.452 5.254-4.355 5.916-4.92m40.28 8.616c-1.046-.95-2.745-.95-3.786-.003l-7.383 6.728c1.692.72 2.951 2.145 3.32 3.86l7.849-7.135c1.04-.95 1.045-2.497 0-3.45M33.116 13.34L46.975.711c1.04-.95 2.737-.948 3.785.005 1.04.95 1.04 2.495 0 3.447L36.015 17.597a1.11 1.11 0 000 1.676 1.39 1.39 0 001.837-.002L55.51 3.197c1.045-.953 2.745-.955 3.79 0 1.04.948 1.04 2.497-.004 3.45l-17.643 16.09a1.108 1.108 0 000 1.674 1.39 1.39 0 001.837 0l14.745-13.436c1.04-.95 2.74-.948 3.786.002 1.045.95 1.045 2.5 0 3.448L48.903 26.38l-23.608-.005c1.872-2.226 6.875-8.062 6.941-8.14.946-1.161 1.34-2.586 1.106-4.02a5.12 5.12 0 00-.226-.876",
  mask: "url(#gebaerdensprache_svg__hclad4avsb)",
  transform: "translate(0 .667)",
  fillRule: "evenodd"
});

function SvgGebaerdensprache(props) {
  return /*#__PURE__*/createElement("svg", _extends$bm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 57,
    viewBox: "0 0 64 57"
  }, props), _ref$bm);
}

function _extends$bn() { _extends$bn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bn.apply(this, arguments); }

var _ref$bn = /*#__PURE__*/createElement("path", {
  d: "M12.055 5a6.27 6.27 0 00.804-.674c.522-.522.871-1.164.983-1.808.123-.706-.057-1.362-.494-1.798-.348-.348-.82-.533-1.365-.533-.775 0-1.593.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-.241-1.028-.722-2.416-1.657-3.351C5.613.852 4.972.594 4.366.594c-.495 0-.965.172-1.317.523-.781.781-.675 2.153.236 3.064.325.325.705.595 1.105.819H.999v4h1v7h12V9h1V5h-2.945zm-1.519-2.997c.433-.433.974-.692 1.446-.692.167 0 .402.035.57.203.407.407.178 1.349-.489 2.016-.687.687-1.61 1.159-2.413 1.47h-.792c.29-.899.813-2.132 1.678-2.997zm-6.881.511c-.011-.143-.001-.41.191-.601a.727.727 0 01.521-.194c.332 0 .679.157.952.429.529.529.965 1.371 1.26 2.436l.023.086-.086-.023c-1.064-.295-1.906-.731-2.436-1.26a1.42 1.42 0 01-.426-.872zM7 15H3V8.5h4V15zm0-7H2V6h5v2zm6 7H9V8.5h4V15zm1-7H9V6h5v2z"
});

function SvgGift(props) {
  return /*#__PURE__*/createElement("svg", _extends$bn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bn);
}

function _extends$bo() { _extends$bo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bo.apply(this, arguments); }

var _ref$bo = /*#__PURE__*/createElement("path", {
  d: "M12.055 5a6.27 6.27 0 00.804-.674c.522-.522.871-1.164.983-1.808.123-.706-.057-1.362-.494-1.798-.348-.348-.82-.533-1.365-.533-.775 0-1.593.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-.241-1.028-.722-2.416-1.657-3.351C5.613.852 4.972.594 4.366.594c-.495 0-.965.172-1.317.523-.781.781-.675 2.153.236 3.064.325.325.705.595 1.105.819H.999v4h1v7h12V9h1V5h-2.945zm-1.519-2.997c.433-.433.974-.692 1.446-.692.167 0 .402.035.57.203.407.407.178 1.349-.489 2.016-.687.687-1.61 1.159-2.413 1.47h-.792c.29-.899.813-2.132 1.678-2.997zM4.081 3.386a1.42 1.42 0 01-.426-.872c-.011-.143-.001-.41.191-.601a.727.727 0 01.521-.194c.332 0 .679.157.952.429.529.529.965 1.371 1.26 2.436l.023.086-.086-.023c-1.064-.295-1.906-.731-2.436-1.26zM14 8.5H9V15H7V8.5H2V8h5V6h2v2h5v.5z"
});

function SvgGift2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bo);
}

function _extends$bp() { _extends$bp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bp.apply(this, arguments); }

var _ref$bp = /*#__PURE__*/createElement("path", {
  d: "M15.698 7.287L8.712.301a1.03 1.03 0 00-1.457 0L5.632 1.924l1.221 1.221a1.5 1.5 0 012.001 2.001l2 2a1.5 1.5 0 11-.707.707l-2-2A1.569 1.569 0 018 5.914v4.171a1.5 1.5 0 11-1 0V5.914a1.5 1.5 0 01-.854-2.061L4.925 2.632.302 7.255a1.032 1.032 0 000 1.458l6.986 6.986a1.03 1.03 0 001.457 0l6.953-6.953a1.032 1.032 0 000-1.458z"
});

function SvgGit(props) {
  return /*#__PURE__*/createElement("svg", _extends$bp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bp);
}

function _extends$bq() { _extends$bq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bq.apply(this, arguments); }

var _ref$bq = /*#__PURE__*/createElement("path", {
  d: "M8 .198a8 8 0 00-2.529 15.591c.4.074.547-.174.547-.385 0-.191-.008-.821-.011-1.489-2.226.484-2.695-.944-2.695-.944-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.869 2.328.665.072-.517.279-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.954 0-.873.313-1.587.824-2.147-.083-.202-.357-1.015.077-2.117 0 0 .672-.215 2.201.82A7.672 7.672 0 018 4.066c.68.003 1.365.092 2.004.269 1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.079 2.117.513.56.823 1.274.823 2.147 0 3.073-1.872 3.749-3.653 3.947.287.248.543.735.543 1.481 0 1.07-.009 1.932-.009 2.195 0 .213.144.462.55.384A8 8 0 008.001.196z"
});

function SvgGithub(props) {
  return /*#__PURE__*/createElement("svg", _extends$bq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bq);
}

function _extends$br() { _extends$br = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$br.apply(this, arguments); }

var _ref$br = /*#__PURE__*/createElement("path", {
  d: "M12.153.263a.5.5 0 00-.44-.263H4.288a.5.5 0 00-.44.263C3.294 1.295 3.001 2.5 3.001 3.75c0 1.647.506 3.2 1.424 4.374.71.907 1.601 1.508 2.576 1.753V15h-1.5a.5.5 0 000 1h5a.5.5 0 000-1h-1.5V9.877c.975-.244 1.866-.846 2.576-1.753.918-1.174 1.424-2.727 1.424-4.374 0-1.249-.293-2.455-.847-3.487zM4.595 1h6.809a6.46 6.46 0 01.59 3H4.003a6.46 6.46 0 01.59-3z"
});

function SvgGlass(props) {
  return /*#__PURE__*/createElement("svg", _extends$br({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$br);
}

function _extends$bs() { _extends$bs = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bs.apply(this, arguments); }

var _ref$bs = /*#__PURE__*/createElement("path", {
  d: "M12.153.263a.5.5 0 00-.44-.263H4.288a.5.5 0 00-.44.263C3.294 1.295 3.001 2.5 3.001 3.75c0 1.647.506 3.2 1.424 4.374.71.907 1.601 1.508 2.576 1.753V15h-1.5a.5.5 0 000 1h5a.5.5 0 000-1h-1.5V9.877c.975-.244 1.866-.846 2.576-1.753.918-1.174 1.424-2.727 1.424-4.374 0-1.249-.293-2.455-.847-3.487zM8 9C5.794 9 4 6.645 4 3.75c0-.979.205-1.923.595-2.75h6.809a6.46 6.46 0 01.595 2.75c0 2.895-1.794 5.25-4 5.25z"
});

function SvgGlass2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bs);
}

function _extends$bt() { _extends$bt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bt.apply(this, arguments); }

var _ref$bt = /*#__PURE__*/createElement("path", {
  d: "M13.893 2.809a.499.499 0 00-.393-.808h-11a.501.501 0 00-.393.808L7 9.037V15H5.5a.5.5 0 000 1h5a.5.5 0 000-1H9V9.037l4.893-6.228zM12.471 3L10.9 5H5.1L3.529 3h8.943z"
});

function SvgGlass3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bt);
}

function _extends$bu() { _extends$bu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bu.apply(this, arguments); }

var _ref$bu = /*#__PURE__*/createElement("path", {
  d: "M13.893 2.809a.499.499 0 00-.393-.808h-11a.501.501 0 00-.393.808L7 9.037V15H5.5a.5.5 0 000 1h5a.5.5 0 000-1H9V9.037l4.893-6.228zM12.471 3L8 8.691 3.529 3h8.943z"
});

function SvgGlass4(props) {
  return /*#__PURE__*/createElement("svg", _extends$bu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bu);
}

function _extends$bv() { _extends$bv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bv.apply(this, arguments); }

var _ref$bv = /*#__PURE__*/createElement("path", {
  d: "M17 5v6h-5.086L9.707 8.793a.997.997 0 00-1.414 0L6.086 11H1V5h16zm1-1H0v8h6.5L9 9.5l2.5 2.5H18V4z"
});

var _ref2$2O = /*#__PURE__*/createElement("path", {
  d: "M2 6v4h3.5L8 7.5V6H2zm3 3H3V7h4L5 9zM10 6v1.5l2.5 2.5H16V6z"
});

function SvgGlasses3D(props) {
  return /*#__PURE__*/createElement("svg", _extends$bv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$bv, _ref2$2O);
}

function _extends$bw() { _extends$bw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bw.apply(this, arguments); }

var _ref$bw = /*#__PURE__*/createElement("path", {
  d: "M8 10.5V9H2v4h3.5L8 10.5zM3 12v-2h4l-2 2H3zM16 13V9h-6v1.5l2.5 2.5z"
});

var _ref2$2P = /*#__PURE__*/createElement("path", {
  d: "M10.376.098C10.169-.083 10-.006 10 .269v1.125c0 .275.016.426.187.64L14 7H4l3.813-4.966c.172-.215.187-.365.187-.64V.269c0-.275-.169-.352-.376-.171L0 7v8h6.5L9 12.5l2.5 2.5H18V7L10.376.098zM17 14h-5.086l-2.207-2.207a.997.997 0 00-1.414 0L6.086 14H1V8h16v6z"
});

function SvgGlasses3D2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$bw, _ref2$2P);
}

function _extends$bx() { _extends$bx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bx.apply(this, arguments); }

var _ref$bx = /*#__PURE__*/createElement("path", {
  d: "M11.392 10.927c-.517 0-1.257-.036-1.705-.345-.561-.387-1.008-1.943-1.224-2.837a.338.338 0 00-.262-.26L8 7.468l-.204.018a.337.337 0 00-.259.26c-.217.893-.664 2.45-1.224 2.837-.448.309-1.187.345-1.705.345-.116 0-.222-.002-.317-.003l-.19-.002c-2.155 0-2.871-.73-3.092-1.342C.838 9.109.73 8.608.634 8.167.508 7.587.379 6.988.168 6.864l-.071-.042-.031-.076C-.065 6.421.03 5.619.05 5.462l.024-.188.188-.022c.94-.11 2.347-.177 2.943-.177.023 0 2.328.015 3.005.343.093.045.187.094.277.141.426.222.867.452 1.512.456.642-.004 1.083-.234 1.509-.456.091-.047.184-.096.277-.141.677-.328 2.982-.343 3.005-.343.596 0 2.004.067 2.943.177l.188.022.024.188c.02.157.115.96-.015 1.284l-.031.076-.071.042c-.21.124-.34.724-.466 1.303-.096.441-.204.942-.375 1.414-.221.612-.937 1.342-3.092 1.342l-.19.002c-.094.002-.201.003-.316.003zm1.543-4.818c-1.578 0-2.664.211-3.006.408-.396.228-.471.459-.471.805 0 .278.31 1.505.543 1.971.205.411.465.608.843.64.146.012.365.02.599.02.923 0 1.716-.094 2.02-.238.396-.189.806-.385.939-2.18.006-.08.014-.161.021-.239.037-.38.068-.708-.105-.903-.154-.173-.49-.267-.998-.278a16.558 16.558 0 00-.386-.004zm-9.87 0c-.127 0-.257.001-.386.004-.508.011-.844.105-.998.278-.173.195-.142.524-.105.904.008.078.015.158.021.238.133 1.796.542 1.991.939 2.18.304.145 1.096.238 2.02.238.235 0 .453-.007.599-.02.378-.032.638-.23.843-.64.17-.341.543-1.591.543-1.971 0-.347-.075-.578-.471-.805-.341-.196-1.428-.407-3.006-.407z"
});

function SvgGlasses(props) {
  return /*#__PURE__*/createElement("svg", _extends$bx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bx);
}

function _extends$by() { _extends$by = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$by.apply(this, arguments); }

var _ref$by = /*#__PURE__*/createElement("path", {
  d: "M15.948 5.412c-.986-.115-2.431-.181-3.006-.181s-2.447.066-2.99.328c-.538.261-1.077.635-1.952.64-.876-.005-1.414-.379-1.953-.64-.542-.263-2.415-.328-2.989-.328s-2.02.066-3.006.181c0 0-.117.908 0 1.199.506.3.534 1.714.974 2.933s2.496 1.218 2.953 1.218c.457 0 1.587.075 2.138-.305s1.03-2.236 1.162-2.778c.112-.461.568-.482.702-.478v.002L8 7.202l.019.001v-.002c.134-.004.59.017.702.478.131.542.61 2.398 1.162 2.778s1.681.305 2.138.305c.457 0 2.513 0 2.953-1.218s.468-2.633.974-2.933c.117-.291 0-1.199 0-1.199z"
});

function SvgGlasses2(props) {
  return /*#__PURE__*/createElement("svg", _extends$by({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$by);
}

function _extends$bz() { _extends$bz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bz.apply(this, arguments); }

var _ref$bz = /*#__PURE__*/createElement("path", {
  d: "M6.527 12.106l.848 2.394V16h1.25v-1.5l.848-2.394a6.279 6.279 0 01-2.946 0zM3 6a5 5 0 1110.001.001A5 5 0 013 6z"
});

function SvgGolf(props) {
  return /*#__PURE__*/createElement("svg", _extends$bz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bz);
}

function _extends$bA() { _extends$bA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bA.apply(this, arguments); }

var _ref$bA = /*#__PURE__*/createElement("path", {
  d: "M16 8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0116 8.5zM4 1v6l7-3-7-3z"
});

var _ref2$2Q = /*#__PURE__*/createElement("path", {
  d: "M6 9c-.701 0-1.374.07-2 .199V13H3V.5a.5.5 0 00-1 0v9.392c-1.227.641-2 1.572-2 2.608C0 14.433 2.686 16 6 16s6-1.567 6-3.5S9.314 9 6 9zm1 5c-1.105 0-2-.672-2-1.5S5.895 11 7 11s2 .672 2 1.5S8.105 14 7 14z"
});

function SvgGolf2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bA, _ref2$2Q);
}

function _extends$bB() { _extends$bB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bB.apply(this, arguments); }

var _ref$bB = /*#__PURE__*/createElement("path", {
  d: "M6.844 10L3.96 15h9.072l2.884-5zM15.506 9l-4.619-8H5.112l4.619 8zM4.534 2L0 9.856l2.888 5L7.422 7z"
});

function SvgGoogleDrive(props) {
  return /*#__PURE__*/createElement("svg", _extends$bB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bB);
}

function _extends$bC() { _extends$bC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bC.apply(this, arguments); }

var _ref$bC = /*#__PURE__*/createElement("path", {
  d: "M5.091 7.147v1.747h2.888c-.116.75-.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c.991 0 1.65.422 2.028.784L8.5 4.112c-.888-.828-2.037-1.331-3.409-1.331C2.275 2.784 0 5.059 0 7.875s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-.334-.037-.591-.081-.844H5.092zM16 7h-1.5V5.5H13V7h-1.5v1.5H13V10h1.5V8.5H16z"
});

function SvgGooglePlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$bC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bC);
}

function _extends$bD() { _extends$bD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bD.apply(this, arguments); }

var _ref$bD = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984.394 2.681 1.047L7.593 6.091c-.297-.284-.816-.616-1.594-.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725H5.999V7.428h3.778c.034.2.063.4.063.663C9.84 10.378 8.309 12 5.999 12zm8-4h-1v1h-1V8h-1V7h1V6h1v1h1v1z"
});

function SvgGooglePlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bD);
}

function _extends$bE() { _extends$bE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bE.apply(this, arguments); }

var _ref$bE = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984.394 2.681 1.047L7.593 6.091c-.297-.284-.816-.616-1.594-.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725H5.999V7.428h3.778c.034.2.063.4.063.663C9.84 10.378 8.309 12 5.999 12zm7-4v1h-1V8h-1V7h1V6h1v1h1v1h-1z"
});

function SvgGooglePlus3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bE);
}

function _extends$bF() { _extends$bF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bF.apply(this, arguments); }

var _ref$bF = /*#__PURE__*/createElement("path", {
  d: "M8.159 6.856V9.6h4.537c-.184 1.178-1.372 3.45-4.537 3.45C5.428 13.05 3.2 10.788 3.2 8s2.228-5.05 4.959-5.05c1.553 0 2.594.663 3.188 1.234l2.172-2.091C12.125.787 10.319-.001 8.16-.001c-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-.525-.056-.925-.125-1.325L8.16 6.855z"
});

function SvgGoogle(props) {
  return /*#__PURE__*/createElement("svg", _extends$bF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bF);
}

function _extends$bG() { _extends$bG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bG.apply(this, arguments); }

var _ref$bG = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975.591 4.019 1.569L10.51 5.138c-.447-.428-1.225-.925-2.391-.925C6.069 4.213 4.4 5.91 4.4 8s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588H8.119V7.143h5.666c.05.3.094.6.094.994C13.882 11.565 11.585 14 8.12 14z"
});

function SvgGoogle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bG);
}

function _extends$bH() { _extends$bH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bH.apply(this, arguments); }

var _ref$bH = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zm.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975.591 4.019 1.569L10.51 5.138c-.447-.428-1.225-.925-2.391-.925C6.069 4.213 4.4 5.91 4.4 8s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588H8.119V7.143h5.666c.05.3.094.6.094.994C13.882 11.565 11.585 14 8.12 14z"
});

function SvgGoogle3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bH);
}

function _extends$bI() { _extends$bI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bI.apply(this, arguments); }

var _ref$bI = /*#__PURE__*/createElement("path", {
  d: "M12 16H7a.502.502 0 01-.325-.12l-3.5-3A.5.5 0 013 12.5v-4a.5.5 0 01.5-.5H5V5.5a.5.5 0 01.5-.5h6a.5.5 0 01.5.5V6h1.5a.5.5 0 01.5.5v6a.499.499 0 01-.053.224l-1.5 3A.5.5 0 0112 16zm-4.815-1h4.506L13 12.382V7h-1v1.5a.5.5 0 01-1 0V6h-1v2.5a.5.5 0 01-1 0V6H8v2.5a.5.5 0 01-1 0V6H6v4.5a.5.5 0 01-1 0V9H4v3.27L7.185 15z"
});

function SvgGrab(props) {
  return /*#__PURE__*/createElement("svg", _extends$bI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bI);
}

function _extends$bJ() { _extends$bJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bJ.apply(this, arguments); }

var _ref$bJ = /*#__PURE__*/createElement("path", {
  d: "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 1v.5h-.5V1H5zm-.5 11.5V12H5v.5h-.5zm.5.5v.5h-.5V13H5zm-.5-1.5V11H5v.5h-.5zm0-1V10H5v.5h-.5zm0-1V9H5v.5h-.5zm0-1V8H5v.5h-.5zm0-1V7H5v.5h-.5zm0-1V6H5v.5h-.5zm0-1V5H5v.5h-.5zm0-1V4H5v.5h-.5zm0-1V3H5v.5h-.5zm0-1V2H5v.5h-.5zm0 11.5H5v.5h-.5V14zM4 1v.5h-.5V1H4zm-.5 11.5V12H4v.5h-.5zm.5.5v.5h-.5V13H4zm-.5-1.5V11H4v.5h-.5zm0-1V10H4v.5h-.5zm0-1V9H4v.5h-.5zm0-1V8H4v.5h-.5zm0-1V7H4v.5h-.5zm0-1V6H4v.5h-.5zm0-1V5H4v.5h-.5zm0-1V4H4v.5h-.5zm0-1V3H4v.5h-.5zm0-1V2H4v.5h-.5zm0 11.5H4v.5h-.5V14zM3 1v.5h-.5V1H3zm-.5 11.5V12H3v.5h-.5zm.5.5v.5h-.5V13H3zm-.5-1.5V11H3v.5h-.5zm0-1V10H3v.5h-.5zm0-1V9H3v.5h-.5zm0-1V8H3v.5h-.5zm0-1V7H3v.5h-.5zm0-1V6H3v.5h-.5zm0-1V5H3v.5h-.5zm0-1V4H3v.5h-.5zm0-1V3H3v.5h-.5zm0-1V2H3v.5h-.5zm0 11.5H3v.5h-.5V14zM15 15h-2v-.5h-.5v.5H12v-.5h-.5v.5H11v-.5h-.5v.5H10v-.5h-.5v.5H9v-.5h-.5v.5H8v-.5h-.5v.5H7v-.5h-.5v.5H6v-.5h-.5V14H6v-.5h-.5V13H6v-.5h-.5V12H6v-.5h-.5V11H6v-.5h-.5V10H6v-.5h-.5V9H6v-.5h-.5V8H6v-.5h-.5V7H6v-.5h-.5V6H6v-.5h-.5V5H6v-.5h-.5V4H6v-.5h-.5V3H6v-.5h-.5V2H6v-.5h-.5V1H6v.5h.5V1H7v.5h.5V1H8v.5h.5V1H9v.5h.5V1H15v14z"
});

var _ref2$2R = /*#__PURE__*/createElement("path", {
  d: "M7.5 1.5H8V2h-.5v-.5zM8.5 1.5H9V2h-.5v-.5zM9.5 1.5h.5V2h-.5v-.5zM10.5 1.5h.5V2h-.5v-.5zM8 2h.5v.5H8V2zM7.5 2.5H8V3h-.5v-.5zM9 2h.5v.5H9V2zM8.5 2.5H9V3h-.5v-.5zM6.5 1.5H7V2h-.5v-.5zM6 2h.5v.5H6V2zM7 2h.5v.5H7V2zM6.5 2.5H7V3h-.5v-.5zM9.5 2.5h.5V3h-.5v-.5zM10.5 2.5h.5V3h-.5v-.5zM11.5 1.5h.5V2h-.5v-.5zM12.5 1.5h.5V2h-.5v-.5zM11.5 2.5h.5V3h-.5v-.5zM12.5 2.5h.5V3h-.5v-.5zM8 3h.5v.5H8V3zM7.5 3.5H8V4h-.5v-.5zM9 3h.5v.5H9V3zM8.5 3.5H9V4h-.5v-.5zM9.5 3.5h.5V4h-.5v-.5zM10.5 3.5h.5V4h-.5v-.5zM8 4h.5v.5H8V4zM7.5 4.5H8V5h-.5v-.5zM9 4h.5v.5H9V4zM8.5 4.5H9V5h-.5v-.5zM6 3h.5v.5H6V3zM7 3h.5v.5H7V3zM6.5 3.5H7V4h-.5v-.5zM6 4h.5v.5H6V4zM7 4h.5v.5H7V4zM6.5 4.5H7V5h-.5v-.5zM9.5 4.5h.5V5h-.5v-.5zM10.5 4.5h.5V5h-.5v-.5zM11.5 3.5h.5V4h-.5v-.5zM12.5 3.5h.5V4h-.5v-.5zM11.5 4.5h.5V5h-.5v-.5zM12.5 4.5h.5V5h-.5v-.5zM8 5h.5v.5H8V5zM7.5 5.5H8V6h-.5v-.5zM9 5h.5v.5H9V5zM8.5 5.5H9V6h-.5v-.5zM9.5 5.5h.5V6h-.5v-.5zM10.5 5.5h.5V6h-.5v-.5zM8 6h.5v.5H8V6zM7.5 6.5H8V7h-.5v-.5zM9 6h.5v.5H9V6zM8.5 6.5H9V7h-.5v-.5zM6 5h.5v.5H6V5zM7 5h.5v.5H7V5zM6.5 5.5H7V6h-.5v-.5zM6 6h.5v.5H6V6zM7 6h.5v.5H7V6zM6.5 6.5H7V7h-.5v-.5zM9.5 6.5h.5V7h-.5v-.5zM10.5 6.5h.5V7h-.5v-.5zM11.5 5.5h.5V6h-.5v-.5zM12.5 5.5h.5V6h-.5v-.5zM11.5 6.5h.5V7h-.5v-.5zM12.5 6.5h.5V7h-.5v-.5zM8 7h.5v.5H8V7zM7.5 7.5H8V8h-.5v-.5zM9 7h.5v.5H9V7zM8.5 7.5H9V8h-.5v-.5zM9.5 7.5h.5V8h-.5v-.5zM10.5 7.5h.5V8h-.5v-.5zM8 8h.5v.5H8V8zM7.5 8.5H8V9h-.5v-.5zM9 8h.5v.5H9V8zM8.5 8.5H9V9h-.5v-.5zM6 7h.5v.5H6V7zM7 7h.5v.5H7V7zM6.5 7.5H7V8h-.5v-.5zM6 8h.5v.5H6V8zM7 8h.5v.5H7V8zM6.5 8.5H7V9h-.5v-.5zM9.5 8.5h.5V9h-.5v-.5zM10.5 8.5h.5V9h-.5v-.5zM11.5 7.5h.5V8h-.5v-.5zM12.5 7.5h.5V8h-.5v-.5zM11.5 8.5h.5V9h-.5v-.5zM12.5 8.5h.5V9h-.5v-.5zM8 9h.5v.5H8V9zM7.5 9.5H8v.5h-.5v-.5zM9 9h.5v.5H9V9zM8.5 9.5H9v.5h-.5v-.5zM9.5 9.5h.5v.5h-.5v-.5zM10.5 9.5h.5v.5h-.5v-.5zM8 10h.5v.5H8V10zM7.5 10.5H8v.5h-.5v-.5zM9 10h.5v.5H9V10zM8.5 10.5H9v.5h-.5v-.5zM6 9h.5v.5H6V9zM7 9h.5v.5H7V9zM6.5 9.5H7v.5h-.5v-.5zM6 10h.5v.5H6V10zM7 10h.5v.5H7V10zM6.5 10.5H7v.5h-.5v-.5zM9.5 10.5h.5v.5h-.5v-.5zM10.5 10.5h.5v.5h-.5v-.5zM11.5 9.5h.5v.5h-.5v-.5zM12.5 9.5h.5v.5h-.5v-.5zM11.5 10.5h.5v.5h-.5v-.5zM12.5 10.5h.5v.5h-.5v-.5zM8 11h.5v.5H8V11zM7.5 11.5H8v.5h-.5v-.5zM9 11h.5v.5H9V11zM8.5 11.5H9v.5h-.5v-.5zM9.5 11.5h.5v.5h-.5v-.5zM10.5 11.5h.5v.5h-.5v-.5zM8 12h.5v.5H8V12zM7.5 12.5H8v.5h-.5v-.5zM9 12h.5v.5H9V12zM8.5 12.5H9v.5h-.5v-.5zM6 11h.5v.5H6V11zM7 11h.5v.5H7V11zM6.5 11.5H7v.5h-.5v-.5zM6 12h.5v.5H6V12zM7 12h.5v.5H7V12zM6.5 12.5H7v.5h-.5v-.5zM9.5 12.5h.5v.5h-.5v-.5zM10.5 12.5h.5v.5h-.5v-.5zM11.5 11.5h.5v.5h-.5v-.5zM12.5 11.5h.5v.5h-.5v-.5zM11.5 12.5h.5v.5h-.5v-.5zM12.5 12.5h.5v.5h-.5v-.5zM8 13h.5v.5H8V13zM7.5 13.5H8v.5h-.5v-.5zM9 13h.5v.5H9V13zM8.5 13.5H9v.5h-.5v-.5zM9.5 13.5h.5v.5h-.5v-.5zM10.5 13.5h.5v.5h-.5v-.5zM8 14h.5v.5H8V14zM9 14h.5v.5H9V14zM6 13h.5v.5H6V13zM7 13h.5v.5H7V13zM6.5 13.5H7v.5h-.5v-.5zM6 14h.5v.5H6V14zM7 14h.5v.5H7V14zM11.5 13.5h.5v.5h-.5v-.5zM12.5 13.5h.5v.5h-.5v-.5z"
});

function SvgGradient(props) {
  return /*#__PURE__*/createElement("svg", _extends$bJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bJ, _ref2$2R);
}

function _extends$bK() { _extends$bK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bK.apply(this, arguments); }

var _ref$bK = /*#__PURE__*/createElement("path", {
  d: "M3 9.177V11.5c0 1 2.239 2.5 5 2.5s5-1.5 5-2.5V9.177l-5 2.5-5-2.5zM8 2L0 6l8 4 6.491-3.246L14 11h1V6.5l1-.5-8-4zm.5 4.225a.726.726 0 11.001-1.451.726.726 0 01-.001 1.451z"
});

function SvgGraduation(props) {
  return /*#__PURE__*/createElement("svg", _extends$bK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bK);
}

function _extends$bL() { _extends$bL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bL.apply(this, arguments); }

var _ref$bL = /*#__PURE__*/createElement("path", {
  d: "M3 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 013 14.5zM7 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 017 14.5zM11 14.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0111 14.5zM5 11.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 015 11.5zM9 11.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 11.5zM13 11.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 11.5zM7 8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 017 8.5zM11 8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0111 8.5z"
});

var _ref2$2S = /*#__PURE__*/createElement("path", {
  d: "M15.5 7h-.128c-.586-.003-1.417-.007-2.411.495C12.991 7.209 13 7 13 7c0-3.5-1.5-5-5-5 0 3.142 1.209 4.672 3.988 4.952-.034.718-.161 1.201-.602 1.71a9.556 9.556 0 00-.449.476.501.501 0 00.727.686l.003-.002c.166-.166.316-.324.45-.477C13.5 7.99 14.568 7.996 15.367 8h.133a.5.5 0 000-1z"
});

function SvgGrapes(props) {
  return /*#__PURE__*/createElement("svg", _extends$bL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bL, _ref2$2S);
}

function _extends$bM() { _extends$bM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bM.apply(this, arguments); }

var _ref$bM = /*#__PURE__*/createElement("path", {
  d: "M0 0h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 6h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 12h4v4H0zm6 0h4v4H6zm6 0h4v4h-4z"
});

function SvgGrid(props) {
  return /*#__PURE__*/createElement("svg", _extends$bM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bM);
}

function _extends$bN() { _extends$bN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bN.apply(this, arguments); }

var _ref$bN = /*#__PURE__*/createElement("path", {
  d: "M0 2a2 2 0 113.999-.001A2 2 0 010 2zm6 0a2 2 0 113.999-.001A2 2 0 016 2zm6 0a2 2 0 113.999-.001A2 2 0 0112 2zM0 8a2 2 0 113.999-.001A2 2 0 010 8zm6 0a2 2 0 113.999-.001A2 2 0 016 8zm6 0a2 2 0 113.999-.001A2 2 0 0112 8zM0 14a2 2 0 113.999-.001A2 2 0 010 14zm6 0a2 2 0 113.999-.001A2 2 0 016 14zm6 0a2 2 0 113.999-.001A2 2 0 0112 14z"
});

function SvgGrid2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bN);
}

function _extends$bO() { _extends$bO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bO.apply(this, arguments); }

var _ref$bO = /*#__PURE__*/createElement("path", {
  d: "M1 1h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 6h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 11h4v4H1zm5 0h4v4H6zm5 0h4v4h-4z"
});

function SvgGrid3(props) {
  return /*#__PURE__*/createElement("svg", _extends$bO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bO);
}

function _extends$bP() { _extends$bP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bP.apply(this, arguments); }

var _ref$bP = /*#__PURE__*/createElement("path", {
  d: "M3 1a2 2 0 11.001 3.999A2 2 0 013 1zm5 0a2 2 0 11.001 3.999A2 2 0 018 1zm5 0a2 2 0 11.001 3.999A2 2 0 0113 1zM3 6a2 2 0 11.001 3.999A2 2 0 013 6zm5 0a2 2 0 11.001 3.999A2 2 0 018 6zm5 0a2 2 0 11.001 3.999A2 2 0 0113 6zM3 11a2 2 0 11.001 3.999A2 2 0 013 11zm5 0a2 2 0 11.001 3.999A2 2 0 018 11zm5 0a2 2 0 11.001 3.999A2 2 0 0113 11z"
});

function SvgGrid4(props) {
  return /*#__PURE__*/createElement("svg", _extends$bP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bP);
}

function _extends$bQ() { _extends$bQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bQ.apply(this, arguments); }

var _ref$bQ = /*#__PURE__*/createElement("path", {
  d: "M14 6h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm0 3h-2V7h2v2zM9 6H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm0 3H7V7h2v2zM4 6H2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm0 3H2V7h2v2zM14 1h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 3h-2V2h2v2zM9 1H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 3H7V2h2v2zM4 1H2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 3H2V2h2v2zM14 11h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-2v-2h2v2zM9 11H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3H7v-2h2v2zM4 11H2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3H2v-2h2v2z"
});

function SvgGrid5(props) {
  return /*#__PURE__*/createElement("svg", _extends$bQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bQ);
}

function _extends$bR() { _extends$bR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bR.apply(this, arguments); }

var _ref$bR = /*#__PURE__*/createElement("path", {
  d: "M0 0h7v7H0zm9 0h7v7H9zM0 9h7v7H0zm9 0h7v7H9z"
});

function SvgGrid6(props) {
  return /*#__PURE__*/createElement("svg", _extends$bR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bR);
}

function _extends$bS() { _extends$bS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bS.apply(this, arguments); }

var _ref$bS = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 5h-4V1h4v4zm-9 5V6h4v4H6zm4 1v4H6v-4h4zm-5-1H1V6h4v4zm1-5V1h4v4H6zm5 1h4v4h-4V6zM5 1v4H1V1h4zM1 11h4v4H1v-4zm10 4v-4h4v4h-4z"
});

function SvgGrid7(props) {
  return /*#__PURE__*/createElement("svg", _extends$bS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bS);
}

function _extends$bT() { _extends$bT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bT.apply(this, arguments); }

var _ref$bT = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4V8H3zm3 3.828a3.008 3.008 0 01-1.118-.71A2.978 2.978 0 014 9h2v2.828zM9 12H7V9h2v3zm2.118-.882a3.008 3.008 0 01-1.118.71V9h2c0 .797-.313 1.549-.882 2.118zM3.521 6c.153 0 .283-.11.308-.261.096-.573.589-.989 1.171-.989s1.074.416 1.171.989a.312.312 0 00.616 0 1.815 1.815 0 00-1.788-2.115 1.815 1.815 0 00-1.788 2.115.312.312 0 00.308.261zm6 0c.153 0 .283-.11.308-.261.096-.573.589-.989 1.171-.989s1.074.416 1.171.989a.312.312 0 00.616 0 1.815 1.815 0 00-1.788-2.115 1.815 1.815 0 00-1.788 2.115.312.312 0 00.308.261z"
});

function SvgGrin(props) {
  return /*#__PURE__*/createElement("svg", _extends$bT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bT);
}

function _extends$bU() { _extends$bU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bU.apply(this, arguments); }

var _ref$bU = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 3.688a1.815 1.815 0 011.788 2.115.312.312 0 01-.616 0c-.096-.573-.589-.833-1.171-.833s-1.074.26-1.171.833a.312.312 0 01-.616 0 1.815 1.815 0 011.788-2.115zm-6 0a1.815 1.815 0 011.788 2.115.312.312 0 01-.616 0c-.096-.573-.589-.833-1.171-.833s-1.074.26-1.171.833a.312.312 0 01-.616 0 1.815 1.815 0 011.788-2.115zM3 9h3v3.873A4.017 4.017 0 013 9zm4 4V9h2v4H7zm3-.127V9h3a4.017 4.017 0 01-3 3.873z"
});

function SvgGrin2(props) {
  return /*#__PURE__*/createElement("svg", _extends$bU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bU);
}

function _extends$bV() { _extends$bV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bV.apply(this, arguments); }

var _ref$bV = /*#__PURE__*/createElement("path", {
  d: "M13.75 4L16 2a2.514 2.514 0 00-2-2l-2 2.25v.535L9.165 5.62c-1.47-1.201-2.486-1.037-3.146-.494-.64.527-.88 1.571-1.234 1.883-.716.63-2.476-.002-3.975 1.629-1.734 1.887-.366 3.9 1.143 5.409s3.522 2.878 5.409 1.143c1.631-1.499.999-3.26 1.628-3.975.312-.354 1.356-.593 1.883-1.233.543-.66.707-1.676-.494-3.146l2.835-2.835h.535zm-9.17 9.42l-2-2 .84-.84 2 2-.84.84zM7.5 10a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 10z"
});

function SvgGuitar(props) {
  return /*#__PURE__*/createElement("svg", _extends$bV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bV);
}

function _extends$bW() { _extends$bW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bW.apply(this, arguments); }

var _ref$bW = /*#__PURE__*/createElement("path", {
  d: "M6.219 7H1.125l-.25-2H0V3h9.219zM16 6V4c0-.55-.45-1-1-1h-2.313l2.25-3h-1.875l-10.5 14h1.875l3.001-4.001.061.001h2.857l.921 3.222-.071.071c-.389.389-.257.707.293.707h4.5v-2l-1.6-4c-.53-1.325 1.1-2 1.6-2zM8.188 9l.75-1h.848l.286 1H8.188z"
});

function SvgGunForbidden(props) {
  return /*#__PURE__*/createElement("svg", _extends$bW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bW);
}

function _extends$bX() { _extends$bX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bX.apply(this, arguments); }

var _ref$bX = /*#__PURE__*/createElement("path", {
  d: "M0 3v2h.875l.25 2H6v1.5c0 .825.675 1.5 1.5 1.5h2.857l.921 3.222-.071.071c-.389.389-.257.707.293.707H16v-2l-1.6-4c-.53-1.325 1.1-2 1.6-2V4c0-.55-.45-1-1-1zm7.5 6a.507.507 0 01-.5-.5V7h1v1h1.786l.286 1H7.501z"
});

function SvgGun(props) {
  return /*#__PURE__*/createElement("svg", _extends$bX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bX);
}

function _extends$bY() { _extends$bY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bY.apply(this, arguments); }

var _ref$bY = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm8.5 9.125V12.5h-1V9.125L4.766 4H5.9L8 7.938 10.1 4h1.134L8.5 9.125z"
});

function SvgHackernews(props) {
  return /*#__PURE__*/createElement("svg", _extends$bY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bY);
}

function _extends$bZ() { _extends$bZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$bZ.apply(this, arguments); }

var _ref$bZ = /*#__PURE__*/createElement("path", {
  d: "M7 10c-.364 0-.706.098-1 .269V7.5a.565.565 0 00-.005-.071l-1-7a.5.5 0 00-.99 0l-1 7A.552.552 0 003 7.5v2.769A2.002 2.002 0 000 12c0 1.103.897 2 2 2s2-.897 2-2V8a.5.5 0 011 0v4c0 .801.474 1.494 1.156 1.813-.1.214-.156.449-.156.687 0 .827.673 1.5 1.5 1.5a.5.5 0 000-1 .5.5 0 01-.5-.5c0-.197.115-.41.277-.52A2.003 2.003 0 009 12c0-1.103-.897-2-2-2zm-5 3c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zm5 0c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zM15 0h-3.5a.5.5 0 000 1H14v1h-2.5a.5.5 0 000 1H14v1h-2.5a.5.5 0 000 1H14v1h-2.5a.5.5 0 000 1H14v1h-2.5a.5.5 0 000 1H14v5a1 1 0 002 0V1a1 1 0 00-1-1z"
});

function SvgHaircut(props) {
  return /*#__PURE__*/createElement("svg", _extends$bZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$bZ);
}

function _extends$b_() { _extends$b_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b_.apply(this, arguments); }

var _ref$b_ = /*#__PURE__*/createElement("path", {
  d: "M8 15c4.418 0 8-1.343 8-3H0c0 1.657 3.582 3 8 3zm6.5-9h-13C.675 6 0 6.675 0 7.5S.675 9 1.5 9h13c.825 0 1.5-.675 1.5-1.5S15.325 6 14.5 6zM8 1C3.582 1 0 2.656 0 4.313v.688h16v-.688C16 2.656 12.418 1 8 1zM2.5 4a.5.5 0 110-1 .5.5 0 010 1zm2-1a.5.5 0 110-1 .5.5 0 010 1zm2 1a.5.5 0 110-1 .5.5 0 010 1zm3 0a.5.5 0 110-1 .5.5 0 010 1zm2-1a.5.5 0 110-1 .5.5 0 010 1zm2 1a.5.5 0 110-1 .5.5 0 010 1zM0 10h16v1H0z"
});

function SvgHamburger(props) {
  return /*#__PURE__*/createElement("svg", _extends$b_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$b_);
}

function _extends$b$() { _extends$b$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b$.apply(this, arguments); }

var _ref$b$ = /*#__PURE__*/createElement("path", {
  d: "M7.696 11.009l2.295 2.295-1.823 2.341a.855.855 0 01-1.315.087l-1.586-1.586a.855.855 0 01.087-1.315l2.341-1.823zm12.203-6.908L17.5 6.5l-3-3 2.399-2.399a4 4 0 00-4.264 6.062l-2.233 1.739L7 5.5 11.5 1h-5L4.28 3.22 4.06 3H2.999v1.061l.22.22-3.22 3.22 2.5 2.5 3-3 9 9 1.5-1.5-3.902-3.902 1.739-2.233a4 4 0 006.062-4.264z"
});

function SvgHammerWrench(props) {
  return /*#__PURE__*/createElement("svg", _extends$b$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$b$);
}

function _extends$c0() { _extends$c0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c0.apply(this, arguments); }

var _ref$c0 = /*#__PURE__*/createElement("path", {
  d: "M15.781 12.953l-4.712-4.712a.752.752 0 00-1.061 0l-.354.354L6.779 5.72 11.499 1h-5l-2.22 2.22-.22-.22H2.998v1.061l.22.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-.354.354a.752.752 0 000 1.061l4.712 4.712a.752.752 0 001.061 0l1.768-1.768a.752.752 0 000-1.061z"
});

function SvgHammer(props) {
  return /*#__PURE__*/createElement("svg", _extends$c0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c0);
}

function _extends$c1() { _extends$c1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c1.apply(this, arguments); }

var _ref$c1 = /*#__PURE__*/createElement("path", {
  d: "M15.784 14.309L7.212 6.505l.399-.4a1.83 1.83 0 00.53-1.181.395.395 0 00.046-.023l1.609-1.006a.676.676 0 00-.036-.898L6.961.191a.673.673 0 00-.896-.036L5.061 1.769l-.022.046c-.43.027-.852.204-1.178.531L2.339 3.873c-.327.327-.503.75-.53 1.181a.395.395 0 00-.046.023L.154 6.083a.676.676 0 00.036.898l2.799 2.806a.673.673 0 00.896.036l1.004-1.614.023-.046c.43-.027.852-.204 1.178-.531l.442-.443 7.783 8.596c.226.249.573.289.773.089l.787-.789c.199-.2.159-.549-.089-.775z"
});

function SvgHammer2(props) {
  return /*#__PURE__*/createElement("svg", _extends$c1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c1);
}

function _extends$c2() { _extends$c2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c2.apply(this, arguments); }

var _ref$c2 = /*#__PURE__*/createElement("path", {
  d: "M12 16H7a.504.504 0 01-.354-.146l-3-3a.466.466 0 01-.07-.089l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L5 9.119V1.5a.5.5 0 01.5-.5H7V.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5V1h1.5a.5.5 0 01.5.5V3h1.5a.5.5 0 01.5.5v9a.499.499 0 01-.053.224l-1.5 3A.5.5 0 0112 16zm-4.793-1h4.484L13 12.382V4h-1v4.5a.5.5 0 01-1 0V2h-1v6.5a.5.5 0 01-1 0V1H8v7.5a.5.5 0 01-1 0V2H6v8.5a.5.5 0 01-.884.32L2.904 8.165l-.722.481 2.213 3.54 2.813 2.813z"
});

function SvgHand(props) {
  return /*#__PURE__*/createElement("svg", _extends$c2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c2);
}

function _extends$c3() { _extends$c3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c3.apply(this, arguments); }

var _ref$c3 = /*#__PURE__*/createElement("path", {
  d: "M14.77 13.579L8 9.227v-.495C8.61 8.379 9 7.722 9 7c0-1.103-.897-2-2-2-.846 0-1.604.536-1.886 1.333a.5.5 0 10.943.333c.141-.399.52-.667.943-.667.551 0 1 .449 1 1 0 .423-.268.802-.667.943A.5.5 0 007 8.413v.812L.23 13.577a.5.5 0 00-.23.421v.5c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-.5a.5.5 0 00-.23-.421zM14 14.5a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-.227l6.5-4.179 6.5 4.179v.227z"
});

function SvgHanger(props) {
  return /*#__PURE__*/createElement("svg", _extends$c3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c3);
}

function _extends$c4() { _extends$c4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c4.apply(this, arguments); }

var _ref$c4 = /*#__PURE__*/createElement("path", {
  d: "M7.997 0a6.91 6.91 0 00-6.909 6.909c0 3.616 3.294 6.547 6.909 6.547V16c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 .828-.447 1.5-1 1.5V8H4V5h3v3zm5 0c0 .828-.447 1.5-1 1.5V8H9V5h3v3z"
});

function SvgHangouts(props) {
  return /*#__PURE__*/createElement("svg", _extends$c4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c4);
}

function _extends$c5() { _extends$c5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c5.apply(this, arguments); }

var _ref$c5 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm0 7.856c1.812 0 3.535-.481 5-1.327C12.772 10.817 10.607 13 8 13s-4.772-2.186-5-4.973a10.017 10.017 0 005 1.329zM4 5.5C4 4.672 4.448 4 5 4s1 .672 1 1.5S5.552 7 5 7s-1-.672-1-1.5zm6 0c0-.828.448-1.5 1-1.5s1 .672 1 1.5S11.552 7 11 7s-1-.672-1-1.5z"
});

function SvgHappy(props) {
  return /*#__PURE__*/createElement("svg", _extends$c5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c5);
}

function _extends$c6() { _extends$c6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c6.apply(this, arguments); }

var _ref$c6 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4c.552 0 1 .672 1 1.5S11.552 7 11 7s-1-.672-1-1.5.448-1.5 1-1.5zM5 4c.552 0 1 .672 1 1.5S5.552 7 5 7s-1-.672-1-1.5S4.448 4 5 4zm3 10c-2.607 0-4.772-2.186-5-4.973 1.465.846 3.188 1.329 5 1.329s3.535-.481 5-1.327C12.772 11.817 10.607 14 8 14z"
});

function SvgHappy2(props) {
  return /*#__PURE__*/createElement("svg", _extends$c6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c6);
}

function _extends$c7() { _extends$c7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c7.apply(this, arguments); }

var _ref$c7 = /*#__PURE__*/createElement("path", {
  d: "M13 7.768V4.5C13 3.672 10.761 3 8 3s-5 .672-5 1.5v3.268c-1.829.641-3 1.627-3 2.732C0 12.433 3.582 14 8 14s8-1.567 8-3.5c0-1.105-1.171-2.091-3-2.732zm0 2.732c0 .828-2.239 1.5-5 1.5s-5-.672-5-1.5v-2C3 9.328 5.239 10 8 10s5-.672 5-1.5v2z"
});

function SvgHat(props) {
  return /*#__PURE__*/createElement("svg", _extends$c7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c7);
}

function _extends$c8() { _extends$c8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c8.apply(this, arguments); }

var _ref$c8 = /*#__PURE__*/createElement("path", {
  d: "M4.5 9h-1v7h1c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM11.5 9c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h1V9h-1z"
});

var _ref2$2T = /*#__PURE__*/createElement("path", {
  d: "M16 8A8 8 0 10.479 10.732 3.5 3.5 0 003 15.964V9.036a3.478 3.478 0 00-1.371.506 6.5 6.5 0 1112.743 0A3.484 3.484 0 0013 9.035v6.929a3.5 3.5 0 002.521-5.232C15.831 9.879 16 8.959 16 8z"
});

function SvgHeadphones(props) {
  return /*#__PURE__*/createElement("svg", _extends$c8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c8, _ref2$2T);
}

function _extends$c9() { _extends$c9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c9.apply(this, arguments); }

var _ref$c9 = /*#__PURE__*/createElement("path", {
  d: "M12.95 2.05C11.628.728 9.87 0 8 0S4.372.728 3.05 2.05 1 5.13 1 7v3.5a1.5 1.5 0 003 0v-2a1.5 1.5 0 00-1.979-1.421V7C2.276 3.925 4.86 1.5 8 1.5s5.724 2.425 5.979 5.5v.079A1.5 1.5 0 0012 8.5v2a1.5 1.5 0 002 1.414V13.5a.5.5 0 01-.5.5h-2.586a1.5 1.5 0 100 1H13.5c.827 0 1.5-.673 1.5-1.5V7c0-1.87-.728-3.628-2.05-4.95z"
});

function SvgHeadset(props) {
  return /*#__PURE__*/createElement("svg", _extends$c9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c9);
}

function _extends$ca() { _extends$ca = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ca.apply(this, arguments); }

var _ref$ca = /*#__PURE__*/createElement("path", {
  d: "M16 5.596A4.586 4.586 0 0114.492 9h.008l-5 5c-.5.5-1 1-1.5 1s-1-.5-1.5-1L1.508 9a4.596 4.596 0 015.456-7.343L5.499 4l3.5 2-2 5 5.5-6-3.5-2 1.233-1.849a4.596 4.596 0 015.767 4.445z"
});

function SvgHeartBroken(props) {
  return /*#__PURE__*/createElement("svg", _extends$ca({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ca);
}

function _extends$cb() { _extends$cb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cb.apply(this, arguments); }

var _ref$cb = /*#__PURE__*/createElement("path", {
  d: "M11.8 1C14.118 1 16 2.882 16 5.2c0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616C0 2.881 1.882 1 4.2 1c.943 0 1.812.43 2.512 1.06L5.499 4l3.5 2-2 5 5.5-6-3.5-2 .967-1.451c.553-.34 1.175-.549 1.833-.549z"
});

function SvgHeartBroken2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cb);
}

function _extends$cc() { _extends$cc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cc.apply(this, arguments); }

var _ref$cc = /*#__PURE__*/createElement("path", {
  d: "M11.75 1A4.25 4.25 0 0116 5.25C16 11 8 15 8 15s-8-4-8-9.75a4.25 4.25 0 016.83-3.377L5.5 4 9 6l-2 5 5.5-6L9 3l1.116-1.674A4.231 4.231 0 0111.75 1z"
});

function SvgHeartBroken3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cc);
}

function _extends$cd() { _extends$cd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cd.apply(this, arguments); }

var _ref$cd = /*#__PURE__*/createElement("path", {
  d: "M11 2.5l5 5-8 8-8-8 5-5 3 3 3-3z"
});

function SvgHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$cd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cd);
}

function _extends$ce() { _extends$ce = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ce.apply(this, arguments); }

var _ref$ce = /*#__PURE__*/createElement("path", {
  d: "M11 2.5l-3 3-3-3-5 5 8 8 8-8-5-5zm-8.172 5L5 5.328l3 3 3-3L13.172 7.5 8 12.672 2.828 7.5z"
});

function SvgHeart2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ce({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ce);
}

function _extends$cf() { _extends$cf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cf.apply(this, arguments); }

var _ref$cf = /*#__PURE__*/createElement("path", {
  d: "M16 5.596A4.586 4.586 0 0114.492 9h.008l-5 5c-.5.5-1 1-1.5 1s-1-.5-1.5-1L1.508 9A4.596 4.596 0 118 2.508a4.596 4.596 0 018 3.088z"
});

function SvgHeart3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cf);
}

function _extends$cg() { _extends$cg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cg.apply(this, arguments); }

var _ref$cg = /*#__PURE__*/createElement("path", {
  d: "M16 5.596a4.596 4.596 0 00-8-3.088A4.596 4.596 0 101.508 9H1.5l5 5c.5.5 1 1 1.5 1s1-.5 1.5-1l4.992-5A4.585 4.585 0 0016 5.596zm-2.852 1.923l-5.062 5.067-.086.086a3.483 3.483 0 01-.086-.086L2.852 7.52A2.57 2.57 0 012 5.597a2.599 2.599 0 012.596-2.596 2.57 2.57 0 011.923.852L8 5.484l1.481-1.631a2.567 2.567 0 011.923-.852A2.599 2.599 0 0114 5.597a2.57 2.57 0 01-.852 1.923z"
});

function SvgHeart4(props) {
  return /*#__PURE__*/createElement("svg", _extends$cg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cg);
}

function _extends$ch() { _extends$ch = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ch.apply(this, arguments); }

var _ref$ch = /*#__PURE__*/createElement("path", {
  d: "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797C7.33 2.368 5.883 1 4.201 1a4.202 4.202 0 00-4.2 4.2c0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.05 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"
});

function SvgHeart5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ch({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ch);
}

function _extends$ci() { _extends$ci = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ci.apply(this, arguments); }

var _ref$ci = /*#__PURE__*/createElement("path", {
  d: "M8.021 16l-.827-1.126c-1.015-1.382-2.212-2.376-3.37-3.338-.973-.808-1.892-1.571-2.592-2.485C.403 7.967 0 6.799 0 5.482 0 3.011 2.097 1 4.675 1c.901 0 1.798.317 2.595.916.26.195.505.418.73.662.225-.244.47-.467.73-.662C9.527 1.317 10.424 1 11.325 1 13.903 1 16 3.011 16 5.482c0 1.266-.404 2.405-1.234 3.482-.695.901-1.602 1.662-2.562 2.469-1.182.993-2.405 2.019-3.383 3.421l-.8 1.145zM4.675 3C3.2 3 2 4.113 2 5.482c0 1.941 1.301 3.021 3.101 4.515.92.764 1.935 1.606 2.883 2.677.946-1.104 1.988-1.979 2.933-2.772.875-.735 1.702-1.429 2.265-2.159.566-.733.818-1.431.818-2.261C14 4.113 12.8 3 11.325 3c-.749 0-1.829.551-2.428 1.762l-.896 1.809-.896-1.808C6.505 3.552 5.425 3 4.676 3z"
});

function SvgHeart6(props) {
  return /*#__PURE__*/createElement("svg", _extends$ci({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ci);
}

function _extends$cj() { _extends$cj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cj.apply(this, arguments); }

var _ref$cj = /*#__PURE__*/createElement("path", {
  d: "M11.75 1A4.25 4.25 0 008 3.249 4.25 4.25 0 000 5.25C0 11 8 15 8 15s8-4 8-9.75A4.25 4.25 0 0011.75 1z"
});

function SvgHeart7(props) {
  return /*#__PURE__*/createElement("svg", _extends$cj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cj);
}

function _extends$ck() { _extends$ck = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ck.apply(this, arguments); }

var _ref$ck = /*#__PURE__*/createElement("path", {
  d: "M8 15l-.437-.212C7.254 14.638 0 11.055 0 5.609 0 3.068 2.117 1 4.719 1A4.77 4.77 0 018 2.296 4.772 4.772 0 0111.281 1C13.883 1 16 3.068 16 5.609c0 5.446-7.255 9.029-7.563 9.179L8 15zM4.719 3C3.22 3 2 4.17 2 5.609c0 2.124 1.691 3.988 3.11 5.178A18.768 18.768 0 008 12.758a18.842 18.842 0 002.89-1.971C12.309 9.598 14 7.734 14 5.609 14 4.17 12.78 3 11.281 3c-1.011 0-1.932.533-2.405 1.392L8 5.981l-.876-1.589C6.651 3.533 5.729 3 4.719 3z"
});

function SvgHeart8(props) {
  return /*#__PURE__*/createElement("svg", _extends$ck({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ck);
}

function _extends$cl() { _extends$cl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cl.apply(this, arguments); }

var _ref$cl = /*#__PURE__*/createElement("path", {
  d: "M12 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0112 1.5zM12 4H9a1 1 0 00-1 1v5h1v6h1.25v-6h.5v6H12v-6h1V5a1 1 0 00-1-1zM6 1V0H1v16h5v-1H2v-2h2v-1H2v-2h2V9H2V7h2V6H2V4h2V3H2V1z"
});

function SvgHeight(props) {
  return /*#__PURE__*/createElement("svg", _extends$cl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cl);
}

function _extends$cm() { _extends$cm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cm.apply(this, arguments); }

var _ref$cm = /*#__PURE__*/createElement("path", {
  d: "M14 12h2l-2.5 3-2.5-3h2V4h-2l2.5-3L16 4h-2zM8 3H2v10h6V3zm2-2v14H0V1h10z"
});

function SvgHeight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cm);
}

function _extends$cn() { _extends$cn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cn.apply(this, arguments); }

var _ref$cn = /*#__PURE__*/createElement("path", {
  d: "M10.5 1.503l3.747 3.247.003-.003L11 1.002l3.749 3.246.751.751-5.256 5.256a1.412 1.412 0 01-1.714.214l.719-.722-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003L6.999 5l3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745 3.747 3.247.003-.003-3.25-3.745zm.751-.752L5.03 6.969a1.41 1.41 0 01.214-1.713L10.5 0l.751.751zm-6.22 6.218l3.5 3.5L6 13H0v-1z"
});

function SvgHighlight(props) {
  return /*#__PURE__*/createElement("svg", _extends$cn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cn);
}

function _extends$co() { _extends$co = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$co.apply(this, arguments); }

var _ref$co = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0z"
});

var _ref2$2U = /*#__PURE__*/createElement("path", {
  d: "M10.561 8.439a1.5 1.5 0 10-2.063 2.176c1.352 1.227 4.503-.029 4.503-1.615-.969.625-1.726.153-2.439-.561z"
});

var _ref3$j = /*#__PURE__*/createElement("path", {
  d: "M5.439 8.439a1.5 1.5 0 112.063 2.176C6.15 11.842 2.999 10.586 2.999 9c.969.625 1.726.153 2.439-.561z"
});

function SvgHipster(props) {
  return /*#__PURE__*/createElement("svg", _extends$co({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$co, _ref2$2U, _ref3$j);
}

function _extends$cp() { _extends$cp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cp.apply(this, arguments); }

var _ref$cp = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm3.497 6.615A1.507 1.507 0 018 9.5a1.491 1.491 0 01-.497 1.115C6.151 11.842 3 10.586 3 9c.969.625 1.726.153 2.439-.561a1.5 1.5 0 012.56 1.06 1.5 1.5 0 012.56-1.06c.713.714 1.471 1.186 2.439.561 0 1.586-3.151 2.842-4.503 1.615z"
});

function SvgHipster2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cp);
}

function _extends$cq() { _extends$cq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cq.apply(this, arguments); }

var _ref$cq = /*#__PURE__*/createElement("path", {
  d: "M10 1a7 7 0 110 14v-1.5c1.469 0 2.85-.572 3.889-1.611S15.5 9.469 15.5 8c0-1.469-.572-2.85-1.611-3.889S11.469 2.5 10 2.5c-1.469 0-2.85.572-3.889 1.611A5.455 5.455 0 004.591 7H7.5L4 11 .5 7h2.571A7.001 7.001 0 0110 1zm3 6v2H9V4h2v3z"
});

function SvgHistory(props) {
  return /*#__PURE__*/createElement("svg", _extends$cq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$cq);
}

function _extends$cr() { _extends$cr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cr.apply(this, arguments); }

var _ref$cr = /*#__PURE__*/createElement("path", {
  d: "M10 13.201v.486c0 .552 1.343 1 3 1s3-.448 3-1v-.486c-.518.485-1.765.736-3 .736s-2.482-.251-3-.736zm0-.576c0-.552 1.343-1 3-1s3 .448 3 1-1.343 1-3 1-3-.448-3-1zM14.2 3l-7.184 9.031c-.49.563-3.949.403-5.78.122h-.001c-.833-.092-1.055-.428-1.19.318a6.084 6.084 0 00.135 2.198c.611.64 6.238.263 6.836-.358L16 3h-1.8z"
});

function SvgHockey(props) {
  return /*#__PURE__*/createElement("svg", _extends$cr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cr);
}

function _extends$cs() { _extends$cs = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cs.apply(this, arguments); }

var _ref$cs = /*#__PURE__*/createElement("path", {
  d: "M16 9.226l-8-6.21-8 6.21V6.694l8-6.21 8 6.21zM14 9v6H2V9l6-4.5z"
});

function SvgHome(props) {
  return /*#__PURE__*/createElement("svg", _extends$cs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cs);
}

function _extends$ct() { _extends$ct = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ct.apply(this, arguments); }

var _ref$ct = /*#__PURE__*/createElement("path", {
  d: "M16 9.226l-8-6.21-8 6.21V6.694l8-6.21 8 6.21zM14 9v6h-4v-4H6v4H2V9l6-4.5z"
});

function SvgHome2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ct({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ct);
}

function _extends$cu() { _extends$cu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cu.apply(this, arguments); }

var _ref$cu = /*#__PURE__*/createElement("path", {
  d: "M8 .5l-8 8L1.5 10 3 8.5V15h4v-3h2v3h4V8.5l1.5 1.5L16 8.5l-8-8zM8 7a1 1 0 110-2 1 1 0 010 2z"
});

function SvgHome3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cu);
}

function _extends$cv() { _extends$cv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cv.apply(this, arguments); }

var _ref$cv = /*#__PURE__*/createElement("path", {
  d: "M8 .5l-8 8L1.5 10 3 8.5V15h10V8.5l1.5 1.5L16 8.5l-8-8zM8 7a1 1 0 110-2 1 1 0 010 2z"
});

function SvgHome4(props) {
  return /*#__PURE__*/createElement("svg", _extends$cv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cv);
}

function _extends$cw() { _extends$cw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cw.apply(this, arguments); }

var _ref$cw = /*#__PURE__*/createElement("path", {
  d: "M16 9.5l-3-3V2h-2v2.5l-3-3-8 8v.5h2v5h5v-3h2v3h5v-5h2z"
});

function SvgHome5(props) {
  return /*#__PURE__*/createElement("svg", _extends$cw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cw);
}

function _extends$cx() { _extends$cx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cx.apply(this, arguments); }

var _ref$cx = /*#__PURE__*/createElement("path", {
  d: "M8 0L0 6v3l2-1.5V15c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V7.5L16 9V6L8 0zm5 14.998l-.002.002H8v-5H5v5H3.002L3 14.998V6.75L8 3l5 3.75v8.248zM9 7h2v2H9z"
});

function SvgHome6(props) {
  return /*#__PURE__*/createElement("svg", _extends$cx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cx);
}

function _extends$cy() { _extends$cy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cy.apply(this, arguments); }

var _ref$cy = /*#__PURE__*/createElement("path", {
  d: "M4.6 6L9 2H4.5L.1 6zM0 7h4v8H0V7zM10.5 2L5 7v8h4v-4h3v4h4V7z"
});

function SvgHome7(props) {
  return /*#__PURE__*/createElement("svg", _extends$cy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cy);
}

function _extends$cz() { _extends$cz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cz.apply(this, arguments); }

var _ref$cz = /*#__PURE__*/createElement("path", {
  d: "M16 8.5l-8-8-8 8L1.5 10 3 8.5V16h4v-3h2v3h4V8.5l1.5 1.5L16 8.5zM12 15h-2v-3H6v3H4V7.5l4-4 4 4V15z"
});

function SvgHome8(props) {
  return /*#__PURE__*/createElement("svg", _extends$cz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cz);
}

function _extends$cA() { _extends$cA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cA.apply(this, arguments); }

var _ref$cA = /*#__PURE__*/createElement("path", {
  d: "M8 .5l-8 8L1.5 10 3 8.5V16h4v-3h2v3h4V8.5l1.5 1.5L16 8.5l-8-8zM4.125 15H4V7.5l.125-.125V15zm.5 0h-.25V7.125l.25-.25V15zm.5 0h-.25V6.625l.25-.25V15zm.5 0h-.25V6.125l.25-.25V15zm.5-3H6v3h-.125V5.625l.25-.25V12zm.5 0h-.25V5.125l.25-.25V12zm.5 0h-.25V4.625l.25-.25V12zm.5 0h-.25V4.125l.25-.25V12zm.5 0h-.25V3.625L8 3.5l.125.125V12zm.5 0h-.25V3.875l.25.25V12zm.5 0h-.25V4.375l.25.25V12zm.5 0h-.25V4.875l.25.25V12zm.5 3H10v-3h-.125V5.375l.25.25V15zm.5 0h-.25V5.875l.25.25V15zm.5 0h-.25V6.375l.25.25V15zm.5 0h-.25V6.875l.25.25V15zM12 15h-.125V7.375L12 7.5V15z"
});

function SvgHome9(props) {
  return /*#__PURE__*/createElement("svg", _extends$cA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cA);
}

function _extends$cB() { _extends$cB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cB.apply(this, arguments); }

var _ref$cB = /*#__PURE__*/createElement("path", {
  d: "M11.39 8C13.542 6.635 15 4.012 15 1c0-.339-.019-.672-.054-1H1.055a9.155 9.155 0 00-.054 1c0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 .339.019.672.054 1h13.891c.036-.328.054-.661.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214V7.214C3.753 6.397 2.5 3.92 2.5 1h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247.817 3.5 3.294 3.5 6.214h-11zm7.182-4.538C8.562 9.827 8.501 9.003 8.5 8.503V7.499c0-.5.059-1.327 1.184-1.963.602-.349 1.122-.88 1.516-1.537H4.8c.395.657.916 1.188 1.518 1.538 1.12.635 1.181 1.459 1.182 1.959V8.5c0 .5-.059 1.327-1.184 1.963-1.135.659-1.98 1.964-2.236 3.537h7.839c-.256-1.574-1.102-2.879-2.238-3.538z"
});

function SvgHourGlass(props) {
  return /*#__PURE__*/createElement("svg", _extends$cB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cB);
}

function _extends$cC() { _extends$cC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cC.apply(this, arguments); }

var _ref$cC = /*#__PURE__*/createElement("path", {
  d: "M10.838 9.824C9.669 9.063 9 8.636 9 8s.67-1.064 1.838-1.824C12.72 4.993 14 2.671 14 0H2c0 2.671 1.28 4.993 3.162 6.176C6.331 6.937 7 7.364 7 8s-.67 1.064-1.838 1.824C3.28 11.007 2 13.329 2 16h12c0-2.671-1.279-4.993-3.162-6.176zM4.057 3.028a6.34 6.34 0 01-.593-1.695h9.072a6.305 6.305 0 01-.593 1.695 5.693 5.693 0 01-.64.972H4.696a5.713 5.713 0 01-.64-.972zm3.693 8.935c0 .681-2.75 1.704-2.75 2.704H3.464c.119-.598.318-1.17.593-1.695.447-.855 1.074-1.553 1.814-2.018l.009-.006.009-.006.048-.031c.73-.475 1.376-.896 1.813-1.399v2.451zm4.786 2.704H11c0-1-2.75-2.023-2.75-2.704V9.512c.437.503 1.083.924 1.813 1.399l.057.037.009.006c.74.465 1.367 1.163 1.814 2.018a6.34 6.34 0 01.593 1.695z"
});

function SvgHourGlass2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cC);
}

function _extends$cD() { _extends$cD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cD.apply(this, arguments); }

var _ref$cD = /*#__PURE__*/createElement("path", {
  d: "M5.939 9.532c-1.49.81-2.591 2.472-2.87 4.468h9.862c-.279-1.996-1.379-3.658-2.87-4.468C9 8.778 9 8.416 9 8s0-.778 1.061-1.532c1.49-.81 2.591-2.472 2.87-4.468H3.069c.279 1.996 1.379 3.658 2.87 4.468C7 7.222 7 7.584 7 8s0 .778-1.061 1.532zM2 15h12v1H2zM2 0h12v1H2z"
});

function SvgHourGlass3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cD);
}

function _extends$cE() { _extends$cE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cE.apply(this, arguments); }

var _ref$cE = /*#__PURE__*/createElement("path", {
  d: "M.946 0L2.23 14.4 7.992 16l5.777-1.602L15.055 0H.947zM12.26 4.71H5.502l.161 1.809H12.1l-.485 5.422-3.623 1.004-3.618-1.004-.247-2.774H5.9l.126 1.41 1.967.53.004-.001 1.968-.531.204-2.29H4.048l-.476-5.341h8.847l-.158 1.766z"
});

function SvgHtmlFive(props) {
  return /*#__PURE__*/createElement("svg", _extends$cE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cE);
}

function _extends$cF() { _extends$cF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cF.apply(this, arguments); }

var _ref$cF = /*#__PURE__*/createElement("path", {
  d: "M.946 0L2.23 14.4 7.992 16l5.777-1.602L15.055 0H.947zm11.722 13.482l-4.644 1.287v.007l-.012-.004-.012.004v-.007l-4.644-1.287L2.258 1.178h11.508l-1.098 12.304zm-2.5-5.198l-.204 2.29-1.972.532-1.967-.53-.126-1.41H4.126l.247 2.774 3.626 1.003 3.615-1.003.485-5.422H5.662l-.161-1.809h6.758l.158-1.766H3.57l.477 5.341z"
});

function SvgHtmlFive2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cF);
}

function _extends$cG() { _extends$cG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cG.apply(this, arguments); }

var _ref$cG = /*#__PURE__*/createElement("path", {
  d: "M13 6.5a3.506 3.506 0 00-2.004-3.164C10.91 1.482 9.375 0 7.5 0S4.09 1.482 4.004 3.336A3.504 3.504 0 002 6.5c0 1.446.882 2.69 2.136 3.223l2.915 5.996a.5.5 0 00.9 0l2.915-5.996A3.506 3.506 0 0013.002 6.5zM9.5 9h-4C4.122 9 3 7.878 3 6.5a2.503 2.503 0 013.333-2.358.5.5 0 10.333-.943 3.499 3.499 0 00-1.622-.169A2.504 2.504 0 017.499 1a2.502 2.502 0 011.863 4.167.5.5 0 10.745.666c.367-.41.629-.897.77-1.419A2.506 2.506 0 0111.998 6.5c0 1.378-1.121 2.5-2.5 2.5z"
});

function SvgIcecream(props) {
  return /*#__PURE__*/createElement("svg", _extends$cG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cG);
}

function _extends$cH() { _extends$cH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cH.apply(this, arguments); }

var _ref$cH = /*#__PURE__*/createElement("path", {
  d: "M4.055 8a1.851 1.851 0 113.703 0 1.851 1.851 0 01-3.703 0zM8 0a8 8 0 100 16A8 8 0 008 0zM5.928 14.989C3.522 13.589 1.905 10.984 1.905 8s1.617-5.589 4.023-6.989C8.334 2.41 9.953 5.016 9.953 8s-1.618 5.589-4.025 6.989z"
});

function SvgIcoMoon(props) {
  return /*#__PURE__*/createElement("svg", _extends$cH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cH);
}

function _extends$cI() { _extends$cI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cI.apply(this, arguments); }

var _ref$cI = /*#__PURE__*/createElement("path", {
  d: "M11.472 9.825h3.688c.028-.256.04-.517.04-.784a6.835 6.835 0 00-.924-3.442c.607-1.614.586-2.984-.227-3.803-.773-.77-2.848-.645-5.194.394a6.876 6.876 0 00-7.193 5.181c1.01-1.293 2.072-2.231 3.492-2.913-.129.121-.882.87-1.009.996-3.743 3.742-4.923 8.63-3.653 9.9.965.965 2.715.802 4.725-.182a6.836 6.836 0 003.113.744 6.869 6.869 0 006.501-4.648h-3.717a3.026 3.026 0 01-5.32 0 3.042 3.042 0 01-.358-1.432v-.011h6.035zm-6.03-1.812c.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728H5.442zm8.573-5.454c.524.529.511 1.503.063 2.719a6.895 6.895 0 00-3.2-2.619c1.408-.604 2.553-.684 3.137-.1zM1.461 15.113c-.668-.669-.467-2.072.394-3.763a6.902 6.902 0 002.927 3.581c-1.491.677-2.712.792-3.321.182z"
});

function SvgIe(props) {
  return /*#__PURE__*/createElement("svg", _extends$cI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cI);
}

function _extends$cJ() { _extends$cJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cJ.apply(this, arguments); }

var _ref$cJ = /*#__PURE__*/createElement("path", {
  d: "M13 5.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 5.5zM0 3v10c0 .55.45 1 1 1h6v-1H1.002L1 12.998V3.002L1.002 3H7V2H1c-.55 0-1 .45-1 1z"
});

var _ref2$2V = /*#__PURE__*/createElement("path", {
  d: "M15 2H9V0H8v16h1v-2h6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 10.998l-.002.002H9v-1h5V7l-3.5 3h-1L9 9.375V3h5.998l.002.002v9.996zM2 11v1h5V6.875L5.5 5z"
});

function SvgImageCompare(props) {
  return /*#__PURE__*/createElement("svg", _extends$cJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cJ, _ref2$2V);
}

function _extends$cK() { _extends$cK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cK.apply(this, arguments); }

var _ref$cK = /*#__PURE__*/createElement("path", {
  d: "M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-3.5 2a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0111.5 3zM14 13H2v-2l3.5-6 4 5h1L14 7v6z"
});

function SvgImage(props) {
  return /*#__PURE__*/createElement("svg", _extends$cK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cK);
}

function _extends$cL() { _extends$cL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cL.apply(this, arguments); }

var _ref$cL = /*#__PURE__*/createElement("path", {
  d: "M14.998 2l.002.002v11.996l-.002.002H1.002L1 13.998V2.002L1.002 2h13.996zM15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z"
});

var _ref2$2W = /*#__PURE__*/createElement("path", {
  d: "M13 4.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 4.5zM14 13H2v-2l3.5-6 4 5h1L14 7z"
});

function SvgImage2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cL, _ref2$2W);
}

function _extends$cM() { _extends$cM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cM.apply(this, arguments); }

var _ref$cM = /*#__PURE__*/createElement("path", {
  d: "M0 1v15h16V1H0zm14 11H2V3h12v9zm-1-3l-1-2-2 2-3-5-4 6v1h10z"
});

function SvgImage3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cM);
}

function _extends$cN() { _extends$cN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cN.apply(this, arguments); }

var _ref$cN = /*#__PURE__*/createElement("path", {
  d: "M13.5 6L10 9.5l-3-3-5 5V13h12V6z"
});

var _ref2$2X = /*#__PURE__*/createElement("path", {
  d: "M14.5 2c.271 0 .5.229.5.5v11c0 .271-.229.5-.5.5h-13a.507.507 0 01-.5-.5v-11c0-.271.229-.5.5-.5h13zm0-1h-13C.675 1 0 1.675 0 2.5v11c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-11c0-.825-.675-1.5-1.5-1.5z"
});

function SvgImage4(props) {
  return /*#__PURE__*/createElement("svg", _extends$cN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cN, _ref2$2X);
}

function _extends$cO() { _extends$cO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cO.apply(this, arguments); }

var _ref$cO = /*#__PURE__*/createElement("path", {
  d: "M14 3v10H2V3h12zm.5-2h-13C.675 1 0 1.675 0 2.5v11c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-11c0-.825-.675-1.5-1.5-1.5z"
});

var _ref2$2Y = /*#__PURE__*/createElement("path", {
  d: "M10 9.5l-3-3-4 4V12h10V6.5z"
});

function SvgImage5(props) {
  return /*#__PURE__*/createElement("svg", _extends$cO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cO, _ref2$2Y);
}

function _extends$cP() { _extends$cP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cP.apply(this, arguments); }

var _ref$cP = /*#__PURE__*/createElement("path", {
  d: "M15.952 2.125H.048a1.483 1.483 0 00-.042.25h15.989a1.483 1.483 0 00-.042-.25zM15.097 1.125H.903a1.512 1.512 0 00-.392.25h14.978a1.512 1.512 0 00-.392-.25zM15.716 1.625H.284a1.485 1.485 0 00-.146.25h15.725a1.556 1.556 0 00-.146-.25zM.903 14.875h14.194c.144-.063.276-.148.392-.25H.511c.116.102.248.187.392.25zM.284 14.375h15.432c.056-.078.106-.162.146-.25H.137c.041.088.09.172.146.25zM16 2.875v-.25H0v.25h.125v10.25H0v.25h16v-.25h-.125V2.875H16zm-14.625 0h.25v10.25h-.25V2.875zm-.25 10.25h-.25V2.875h.25v10.25zm.75-10.25h12.25v10.25H1.875V2.875zm12.5 0h.25v10.25h-.25V2.875zm.5 0h.25v10.25h-.25V2.875zm-14.5 0h.25v10.25h-.25V2.875zm15.25 10.25h-.25V2.875h.25v10.25zM.048 13.875h15.904c.021-.081.035-.165.042-.25H.005c.007.085.021.169.042.25z"
});

var _ref2$2Z = /*#__PURE__*/createElement("path", {
  d: "M13.5 6L10 9.5l-3-3-5 5V13h12V6z"
});

function SvgImage6(props) {
  return /*#__PURE__*/createElement("svg", _extends$cP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cP, _ref2$2Z);
}

function _extends$cQ() { _extends$cQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cQ.apply(this, arguments); }

var _ref$cQ = /*#__PURE__*/createElement("path", {
  d: "M17 2h-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v12c0 .55.45 1 1 1h1v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM2 3v10H1V1h14v1H3c-.55 0-1 .45-1 1zm13 2.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0115 5.5zm1 8.5H4v-2l3.5-6 4 5h1L16 8v6z"
});

function SvgImages(props) {
  return /*#__PURE__*/createElement("svg", _extends$cQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$cQ);
}

function _extends$cR() { _extends$cR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cR.apply(this, arguments); }

var _ref$cR = /*#__PURE__*/createElement("path", {
  d: "M17 2h-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v12c0 .55.45 1 1 1h1v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM2 3v10h-.998L1 12.998V1.002L1.002 1h13.996l.002.002V2H3c-.55 0-1 .45-1 1zm15 11.998l-.002.002H3.002L3 14.998V3.002L3.002 3h13.996l.002.002v11.996z"
});

var _ref2$2_ = /*#__PURE__*/createElement("path", {
  d: "M15 5.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0115 5.5zM16 14H4v-2l3.5-6 4 5h1L16 8z"
});

function SvgImages2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$cR, _ref2$2_);
}

function _extends$cS() { _extends$cS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cS.apply(this, arguments); }

var _ref$cS = /*#__PURE__*/createElement("path", {
  d: "M12 1H0v12h12V1zm-1 9H1V2h10v8zM8 5l-.714 1.429L5 3 2 9h8zm5-1.144V14H1.89l-.078.746L13.746 16 15 4.066z"
});

function SvgImages3(props) {
  return /*#__PURE__*/createElement("svg", _extends$cS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cS);
}

function _extends$cT() { _extends$cT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cT.apply(this, arguments); }

var _ref$cT = /*#__PURE__*/createElement("path", {
  d: "M7 11h2V8h3V6H9V3H7v3H4v2h3v3z"
});

var _ref2$2$ = /*#__PURE__*/createElement("path", {
  d: "M14 8v6H2V8H0v6.5c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5V8h-2z"
});

function SvgImport(props) {
  return /*#__PURE__*/createElement("svg", _extends$cT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cT, _ref2$2$);
}

function _extends$cU() { _extends$cU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cU.apply(this, arguments); }

var _ref$cU = /*#__PURE__*/createElement("path", {
  d: "M7 11h2V8h3V6H9V3H7v3H4v2h3zM.284 15.375h15.432c.056-.078.106-.162.146-.25H.137c.041.088.09.172.146.25zM.903 15.875h14.194c.144-.063.276-.148.392-.25H.511c.116.102.248.187.392.25zM.048 14.875h15.904c.021-.081.035-.165.042-.25H.005c.007.085.021.169.042.25z"
});

var _ref2$30 = /*#__PURE__*/createElement("path", {
  d: "M15.875 14.125V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H1.875V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H0v.25h16v-.25z"
});

function SvgImport2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cU, _ref2$30);
}

function _extends$cV() { _extends$cV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cV.apply(this, arguments); }

var _ref$cV = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 3h10v2H6zm0 3h10v2H6zm0 3h10v2H6zm-6 3h16v2H0zm4-8v6L0 8z"
});

function SvgIndentDecrease(props) {
  return /*#__PURE__*/createElement("svg", _extends$cV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cV);
}

function _extends$cW() { _extends$cW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cW.apply(this, arguments); }

var _ref$cW = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 8h10v2H6zm0-4h10v2H6zm-6 8h16v2H0zm4-8v6L0 8z"
});

function SvgIndentDecrease2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cW);
}

function _extends$cX() { _extends$cX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cX.apply(this, arguments); }

var _ref$cX = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 3h10v2H6zm0 3h10v2H6zm0 3h10v2H6zm-6 3h16v2H0zm0-2V5l4 3z"
});

function SvgIndentIncrease(props) {
  return /*#__PURE__*/createElement("svg", _extends$cX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cX);
}

function _extends$cY() { _extends$cY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cY.apply(this, arguments); }

var _ref$cY = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 8h10v2H6zm0-4h10v2H6zm-6 8h16v2H0zm0-2V5l4 3z"
});

function SvgIndentIncrease2(props) {
  return /*#__PURE__*/createElement("svg", _extends$cY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cY);
}

function _extends$cZ() { _extends$cZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$cZ.apply(this, arguments); }

var _ref$cZ = /*#__PURE__*/createElement("path", {
  d: "M4.281 6.023c-.528 0-1.025.206-1.398.579s-.579.87-.579 1.398.206 1.025.579 1.398.87.579 1.398.579 1.025-.206 1.398-.579L7.077 8 5.679 6.602a1.965 1.965 0 00-1.398-.579zM11.719 6.023c-.528 0-1.025.206-1.398.579L8.923 8l1.398 1.398c.374.373.87.579 1.398.579s1.025-.206 1.398-.579c.373-.374.579-.87.579-1.398s-.206-1.025-.579-1.398a1.965 1.965 0 00-1.398-.579z"
});

var _ref2$31 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-.461 10.32c-.62.62-1.444.961-2.32.961s-1.7-.341-2.32-.961L8 8.922 6.602 10.32c-.62.62-1.444.961-2.32.961s-1.701-.341-2.32-.961c-.62-.62-.961-1.444-.961-2.32s.341-1.7.961-2.32c.62-.62 1.444-.961 2.32-.961s1.701.341 2.32.961L8 7.078 9.398 5.68c.62-.62 1.444-.961 2.32-.961s1.701.341 2.32.961c.62.62.961 1.444.961 2.32s-.341 1.701-.961 2.32z"
});

function SvgInfiniteSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$cZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$cZ, _ref2$31);
}

function _extends$c_() { _extends$c_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c_.apply(this, arguments); }

var _ref$c_ = /*#__PURE__*/createElement("path", {
  d: "M12.25 11.75a3.728 3.728 0 01-2.652-1.098L8 9.054l-1.598 1.598c-.708.708-1.65 1.098-2.652 1.098s-1.944-.39-2.652-1.098C.39 9.944 0 9.002 0 8s.39-1.943 1.098-2.652C1.806 4.64 2.748 4.25 3.75 4.25s1.943.39 2.652 1.098L8 6.946l1.598-1.598c.708-.708 1.65-1.098 2.652-1.098s1.944.39 2.652 1.098C15.61 6.056 16 6.998 16 8s-.39 1.943-1.098 2.652a3.726 3.726 0 01-2.652 1.098zm-1.598-2.152c.427.427.994.662 1.598.662s1.171-.235 1.598-.662c.427-.427.662-.994.662-1.598s-.235-1.171-.662-1.598c-.427-.427-.994-.662-1.598-.662s-1.171.235-1.598.662L9.054 8l1.598 1.598zM3.75 5.74c-.604 0-1.171.235-1.598.662S1.49 7.396 1.49 8c0 .604.235 1.171.662 1.598s.994.662 1.598.662c.604 0 1.171-.235 1.598-.662L6.946 8 5.348 6.402A2.244 2.244 0 003.75 5.74z"
});

function SvgInfinite(props) {
  return /*#__PURE__*/createElement("svg", _extends$c_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c_);
}

function _extends$c$() { _extends$c$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c$.apply(this, arguments); }

var _ref$c$ = /*#__PURE__*/createElement("path", {
  d: "M11.5 0A4.5 4.5 0 007 4.5V7H4.5A4.5 4.5 0 109 11.5V9h2.5a4.5 4.5 0 000-9zM7 11.5A2.5 2.5 0 114.5 9H7v2.5zM11.5 7H9V4.5A2.5 2.5 0 1111.5 7z"
});

function SvgInfinite2(props) {
  return /*#__PURE__*/createElement("svg", _extends$c$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$c$);
}

function _extends$d0() { _extends$d0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d0.apply(this, arguments); }

var _ref$d0 = /*#__PURE__*/createElement("path", {
  d: "M7 4.75c0-.412.338-.75.75-.75h.5c.412 0 .75.338.75.75v.5c0 .412-.338.75-.75.75h-.5A.753.753 0 017 5.25v-.5zM10 12H6v-1h1V8H6V7h3v4h1z"
});

var _ref2$32 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

function SvgInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$d0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d0, _ref2$32);
}

function _extends$d1() { _extends$d1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d1.apply(this, arguments); }

var _ref$d1 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM7 3.75c0-.413.338-.75.75-.75h.5c.412 0 .75.337.75.75v.5c0 .412-.338.75-.75.75h-.5A.753.753 0 017 4.25v-.5zM10 13H6v-1h1V8H6V7h3v5h1v1z"
});

function SvgInfo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$d1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d1);
}

function _extends$d2() { _extends$d2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d2.apply(this, arguments); }

var _ref$d2 = /*#__PURE__*/createElement("path", {
  d: "M6 3h2v1H6zm3 0h2v1H9zm5 0v4h-3V6h2V4h-1V3zM5 6h2v1H5zm3 0h2v1H8zM3 4v2h1v1H2V3h3v1zm3 5h2v1H6zm3 0h2v1H9zm5 0v4h-3v-1h2v-2h-1V9zm-9 3h2v1H5zm3 0h2v1H8zm-5-2v2h1v1H2V9h3v1zm12-9H1v14h14V1zm1-1v16H0V0h16z"
});

function SvgInsertTemplate(props) {
  return /*#__PURE__*/createElement("svg", _extends$d2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d2);
}

function _extends$d3() { _extends$d3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d3.apply(this, arguments); }

var _ref$d3 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM11 2.5c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5v2c0 .275-.225.5-.5.5h-2a.501.501 0 01-.5-.5v-2zM8 5a3.001 3.001 0 010 6 3.001 3.001 0 010-6zm6 8.5c0 .275-.225.5-.5.5h-11a.501.501 0 01-.5-.5V7h1.1A4.999 4.999 0 008 13a4.999 4.999 0 004.9-6H14v6.5z"
});

function SvgInstagram(props) {
  return /*#__PURE__*/createElement("svg", _extends$d3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d3);
}

function _extends$d4() { _extends$d4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d4.apply(this, arguments); }

var _ref$d4 = /*#__PURE__*/createElement("path", {
  d: "M11 4V0H0v11h4v5h12V4h-5zm-1 2.125H6V6h4v.125zM10 10H6v-.125h4V10zm0-.375H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zm0-.5H6v-.25h4v.25zM4 10H1V1h9v3H4v6zm11 5H5v-3h7V5h3v10z"
});

function SvgInterset(props) {
  return /*#__PURE__*/createElement("svg", _extends$d4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d4);
}

function _extends$d5() { _extends$d5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d5.apply(this, arguments); }

var _ref$d5 = /*#__PURE__*/createElement("path", {
  d: "M14 0v1h-2.04L6.71 15H9v1H2v-1h2.04L9.29 1H7V0z"
});

function SvgItalic(props) {
  return /*#__PURE__*/createElement("svg", _extends$d5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d5);
}

function _extends$d6() { _extends$d6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d6.apply(this, arguments); }

var _ref$d6 = /*#__PURE__*/createElement("path", {
  d: "M14 1v1h-2L7 14h2v1H2v-1h2L9 2H7V1z"
});

function SvgItalic2(props) {
  return /*#__PURE__*/createElement("svg", _extends$d6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d6);
}

function _extends$d7() { _extends$d7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d7.apply(this, arguments); }

var _ref$d7 = /*#__PURE__*/createElement("path", {
  d: "M4.156 4.323a1.312 1.312 0 011.856 0l.122.123 1.58-1.581-.123-.123a3.538 3.538 0 00-3.319-.946A2.142 2.142 0 002.16 0a2.143 2.143 0 00-.473 4.234 3.552 3.552 0 00.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561a1.318 1.318 0 01.003-1.861zm11.824-2.18a2.141 2.141 0 00-4.26-.296 3.543 3.543 0 00-3.51.897L4.65 6.305l1.58 1.581 3.559-3.56a1.31 1.31 0 011.854-.003 1.316 1.316 0 01-.001 1.859l-.122.122 1.578 1.582.123-.124a3.55 3.55 0 00.9-3.494 2.142 2.142 0 001.858-2.125zm-1.82 9.592a3.55 3.55 0 00-.939-3.352L9.666 4.821l-1.58 1.58 3.555 3.563a1.313 1.313 0 11-1.854 1.857l-.121-.122-1.578 1.582.121.121a3.544 3.544 0 003.553.883A2.14 2.14 0 0016 13.858c0-1.081-.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562a1.316 1.316 0 01-1.86-1.861l.122-.121-1.579-1.58-.121.12a3.55 3.55 0 00-.929 3.39A2.142 2.142 0 000 13.857a2.141 2.141 0 004.227.481 3.539 3.539 0 003.365-.934l3.555-3.562L9.569 8.26z"
});

function SvgJoomla(props) {
  return /*#__PURE__*/createElement("svg", _extends$d7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d7);
}

function _extends$d8() { _extends$d8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d8.apply(this, arguments); }

var _ref$d8 = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058zM10.786 12h1.512L8.625 3.984h-1.25L3.702 12h1.512l.916-2h3.738l.916 2zM6.589 9L8 5.921 9.411 9H6.589z"
});

function SvgKeyA(props) {
  return /*#__PURE__*/createElement("svg", _extends$d8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d8);
}

function _extends$d9() { _extends$d9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d9.apply(this, arguments); }

var _ref$d9 = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058zM5 8l3 3 3-3H9V5H7v3z"
});

function SvgKeyDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$d9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d9);
}

function _extends$da() { _extends$da = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$da.apply(this, arguments); }

var _ref$da = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058z"
});

function SvgKeyKeyboard(props) {
  return /*#__PURE__*/createElement("svg", _extends$da({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$da);
}

function _extends$db() { _extends$db = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$db.apply(this, arguments); }

var _ref$db = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058zM8 5L5 8l3 3V9h3V7H8z"
});

function SvgKeyLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$db({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$db);
}

function _extends$dc() { _extends$dc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dc.apply(this, arguments); }

var _ref$dc = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058zM8 11l3-3-3-3v2H5v2h3z"
});

function SvgKeyRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$dc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dc);
}

function _extends$dd() { _extends$dd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dd.apply(this, arguments); }

var _ref$dd = /*#__PURE__*/createElement("path", {
  d: "M14 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm1.25 13.625h-2.438c.119-.074.231-.158.336-.25h2.102v.25zm-2.515-.89a1.738 1.738 0 01-1.235.515h-7c-.465 0-.903-.183-1.235-.515s-.515-.771-.515-1.235v-7c0-.465.183-.903.515-1.235S4.036 2.75 4.5 2.75h7c.465 0 .903.183 1.235.515s.515.771.515 1.235v7c0 .465-.183.903-.515 1.235zm2.515.39h-1.855a2.57 2.57 0 00.19-.25h1.665v.25zm0-.5h-1.52c.041-.081.078-.164.111-.25h1.409v.25zm0-.5h-1.33l-.001.003c.022-.083.039-.167.052-.253h1.278v.25zm0-.5h-1.253c.002-.042.003-.083.003-.125v-.125h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14v-.25h1.25v.25zm0-.5H14V4.5c0-.042-.001-.084-.003-.125h1.253v.25zm0-.5h-1.278a2.636 2.636 0 00-.052-.253l.001.003h1.33v.25zm0-.5h-1.409a2.235 2.235 0 00-.111-.25h1.52v.25zm0-.5h-1.665a2.42 2.42 0 00-.19-.25h1.855v.25zm0-1h-1.375l-.25.25h1.625v.25h-1.875l-.109.109A2.492 2.492 0 0011.5 2h-7A2.507 2.507 0 002 4.5v7c0 .688.281 1.313.734 1.766l-.109.109h.227c.105.092.217.176.336.25h-.813l-.25.25h1.598c.245.081.506.125.777.125h7c.271 0 .532-.044.777-.125h2.973V14c0 .063-.005.126-.014.188l.008-.063H1.875l-.25.25h13.567a1.238 1.238 0 01-.111.25H1.375l-.25.25h13.764l-.007.007a1.266 1.266 0 01-.365.255H1.482A1.266 1.266 0 01.749 14V2c0-.332.131-.645.368-.882s.55-.368.882-.368h12c.332 0 .645.131.882.368l.007.007h-.014l-.25.25h.456a1.214 1.214 0 00.111.25h-.817l-.25.25h1.119l-.008-.063c.009.062.014.125.014.188v.125zm-.058 12.25zm.032-.124zm-.335.624zm.058-.063l.045-.055a.772.772 0 01-.045.055zm-.058-13.687zm.058.063l.045.055a.772.772 0 00-.045-.055zm.245.437zm.032.124a1 1 0 01.01.058l-.01-.058zM11 8L8 5 5 8h2v3h2V8z"
});

function SvgKeyUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$dd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dd);
}

function _extends$de() { _extends$de = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$de.apply(this, arguments); }

var _ref$de = /*#__PURE__*/createElement("path", {
  d: "M11 0a5 5 0 00-4.916 5.916L0 12v3a1 1 0 001 1h1v-1h2v-2h2v-2h2l1.298-1.298A5 5 0 1011 0zm1.498 5.002a1.5 1.5 0 11.001-3.001 1.5 1.5 0 01-.001 3.001z"
});

function SvgKey(props) {
  return /*#__PURE__*/createElement("svg", _extends$de({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$de);
}

function _extends$df() { _extends$df = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$df.apply(this, arguments); }

var _ref$df = /*#__PURE__*/createElement("path", {
  d: "M15.658 4.91l-1.58-1.58-1.409-1.409-1.58-1.58c-.387-.387-1.077-.456-1.533-.152l-4.319 2.88a1.162 1.162 0 00-.383 1.444l1.101 2.203c.034.067.073.139.115.213L.499 12.5l-.5 3.5h3v-1h2v-2h2v-2h2V9.888c.1.06.196.113.284.157l2.203 1.101c.49.245 1.14.072 1.444-.383l2.88-4.319c.304-.456.236-1.146-.152-1.533zM2.354 13.354l-.707-.707 4.868-4.868.707.707-4.868 4.868zm11.974-6.733l-.707.707a.502.502 0 01-.707 0L8.671 3.085a.502.502 0 010-.707l.707-.707a.502.502 0 01.707 0l4.243 4.243a.502.502 0 010 .707z"
});

function SvgKey2(props) {
  return /*#__PURE__*/createElement("svg", _extends$df({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$df);
}

function _extends$dg() { _extends$dg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dg.apply(this, arguments); }

var _ref$dg = /*#__PURE__*/createElement("path", {
  d: "M11.438 0a4.568 4.568 0 00-4.563 4.563c0 1.056.36 2.029.965 2.802L1.165 14.04a.561.561 0 10.796.795l2.04-2.04 1.205 1.204-1.04 1.04a.561.561 0 10.796.795l2.875-2.875a.561.561 0 10-.795-.795l-1.04 1.04-1.204-1.205 3.84-3.84a4.541 4.541 0 002.802.965c2.516 0 4.563-2.047 4.563-4.563S13.956-.002 11.44-.002zm0 8C9.543 8 8 6.458 8 4.562s1.542-3.438 3.438-3.438c1.895 0 3.438 1.542 3.438 3.438S13.334 8 11.438 8z"
});

function SvgKey3(props) {
  return /*#__PURE__*/createElement("svg", _extends$dg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dg);
}

function _extends$dh() { _extends$dh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dh.apply(this, arguments); }

var _ref$dh = /*#__PURE__*/createElement("path", {
  d: "M11.438 0a4.568 4.568 0 00-4.563 4.563c0 1.056.36 2.029.965 2.802L1.165 14.04a.561.561 0 10.796.795l.54-.54 1.54 1.54a.561.561 0 00.796 0 .561.561 0 000-.795l-1.54-1.54 1.204-1.204 1.54 1.54a.561.561 0 00.796 0 .561.561 0 000-.795l-1.54-1.54 3.34-3.34a4.541 4.541 0 002.802.965c2.516 0 4.562-2.047 4.562-4.563S13.954 0 11.438 0zm0 8C9.543 8 8 6.458 8 4.562s1.542-3.438 3.438-3.438 3.438 1.542 3.438 3.438S13.334 8 11.438 8z"
});

function SvgKey4(props) {
  return /*#__PURE__*/createElement("svg", _extends$dh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dh);
}

function _extends$di() { _extends$di = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$di.apply(this, arguments); }

var _ref$di = /*#__PURE__*/createElement("path", {
  d: "M15 6H7.465a4 4 0 100 4H8l1-1h1v1h1l1-1h1v1h1l2-2-1-2zM3 9.414a1.414 1.414 0 110-2.828 1.414 1.414 0 010 2.828zM8 7.5V7h6l.25.5H8z"
});

function SvgKey5(props) {
  return /*#__PURE__*/createElement("svg", _extends$di({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$di);
}

function _extends$dj() { _extends$dj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dj.apply(this, arguments); }

var _ref$dj = /*#__PURE__*/createElement("path", {
  d: "M17 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-7 2h2v2h-2V4zm3 3v2h-2V7h2zM7 4h2v2H7V4zm3 3v2H8V7h2zM4 4h2v2H4V4zm3 3v2H5V7h2zM2 4h1v2H2V4zm0 3h2v2H2V7zm1 5H2v-2h1v2zm9 0H4v-2h8v2zm4 0h-3v-2h3v2zm0-3h-2V7h2v2zm0-3h-3V4h3v2z"
});

function SvgKeyboard(props) {
  return /*#__PURE__*/createElement("svg", _extends$dj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$dj);
}

function _extends$dk() { _extends$dk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dk.apply(this, arguments); }

var _ref$dk = /*#__PURE__*/createElement("path", {
  d: "M14 4H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 7.998l-.002.002H1.002L1 11.998V5.002L1.002 5h12.996l.002.002v6.996zM4 10h7v1H4zm7-2h1v1h-1zM9 8h1v1H9zM7 8h1v1H7zM5 8h1v1H5zM3 8h1v1H3zm7-2h1v1h-1zm2 0h1v1h-1zM8 6h1v1H8zM6 6h1v1H6zM4 6h1v1H4zM2 6h1v1H2z"
});

function SvgKeyboard2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dk);
}

function _extends$dl() { _extends$dl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dl.apply(this, arguments); }

var _ref$dl = /*#__PURE__*/createElement("path", {
  d: "M12 4a4 4 0 10-5.883 3.53L3.999 16h8L9.882 7.53A3.998 3.998 0 0011.999 4z"
});

function SvgKeyhole(props) {
  return /*#__PURE__*/createElement("svg", _extends$dl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dl);
}

function _extends$dm() { _extends$dm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dm.apply(this, arguments); }

var _ref$dm = /*#__PURE__*/createElement("path", {
  d: "M13 10H3a3 3 0 100 6h10a3 3 0 100-6zM3 14a1 1 0 110-2 1 1 0 010 2zM3 9h2.78l2.927-4.212A3 3 0 007.955.612L2.046 9.115A4 4 0 013 9zM13 8H7.692L7 8.996V9h6c1.144 0 2.177.483 2.907 1.255A3.001 3.001 0 0013 8z"
});

function SvgKnife(props) {
  return /*#__PURE__*/createElement("svg", _extends$dm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dm);
}

function _extends$dn() { _extends$dn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dn.apply(this, arguments); }

var _ref$dn = /*#__PURE__*/createElement("path", {
  d: "M14.942 12.57L10 4.335V1h.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-5c-.275 0-.5.225-.5.5s.225.5.5.5H6v3.335L1.058 12.57C-.074 14.456.8 16 3 16h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10L7 4.61V1h2v3.61L12.234 10H3.766z"
});

function SvgLab(props) {
  return /*#__PURE__*/createElement("svg", _extends$dn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dn);
}

function _extends$do() { _extends$do = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$do.apply(this, arguments); }

var _ref$do = /*#__PURE__*/createElement("path", {
  d: "M12 0a1 1 0 00-1 1v2H5V1a1 1 0 00-2 0v14a1 1 0 002 0v-2h6v2a1 1 0 002 0V1a1 1 0 00-1-1zm-1 11H5V9h6v2zm0-4H5V5h6v2z"
});

function SvgLadder(props) {
  return /*#__PURE__*/createElement("svg", _extends$do({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$do);
}

function _extends$dp() { _extends$dp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dp.apply(this, arguments); }

var _ref$dp = /*#__PURE__*/createElement("path", {
  d: "M14.907 7.209l-5-7A.5.5 0 009.5 0h-4a.502.502 0 00-.407.209l-5 7a.5.5 0 00.407.79H6v1.5c0 .388-.414.646-1.089 1.036-.429.248-.872.504-1.234.867-.449.45-.677.988-.677 1.597 0 .875.07 1.856.91 2.416.729.486 1.914.584 3.59.584s2.86-.098 3.59-.584c.84-.56.91-1.541.91-2.416 0-.61-.228-1.147-.677-1.597-.362-.363-.806-.619-1.234-.867C9.414 10.145 9 9.887 9 9.499v-1.5h5.5a.498.498 0 00.407-.79zM1.472 7l.714-1h10.628l.714 1H1.471z"
});

function SvgLamp(props) {
  return /*#__PURE__*/createElement("svg", _extends$dp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dp);
}

function _extends$dq() { _extends$dq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dq.apply(this, arguments); }

var _ref$dq = /*#__PURE__*/createElement("path", {
  d: "M14.907 7.209l-5-7A.5.5 0 009.5 0h-4a.502.502 0 00-.407.209l-5 7a.5.5 0 00.407.79H6v1.5c0 .388-.414.646-1.089 1.036-.429.248-.872.504-1.234.867-.449.45-.677.988-.677 1.597 0 .875.07 1.856.91 2.416.729.486 1.914.584 3.59.584s2.86-.098 3.59-.584c.84-.56.91-1.541.91-2.416 0-.61-.228-1.147-.677-1.597-.362-.363-.806-.619-1.234-.867C9.414 10.145 9 9.887 9 9.499v-1.5h5.5a.498.498 0 00.407-.79zM5.757 1h3.485l2.857 4h-9.2l2.857-4zm3.832 10.402C10.467 11.909 11 12.269 11 13c0 .953-.117 1.352-.465 1.584-.437.292-1.345.416-3.035.416s-2.598-.124-3.035-.416C4.117 14.352 4 13.953 4 13c0-.73.533-1.091 1.411-1.598C6.156 10.972 7 10.485 7 9.5V8h1v1.5c0 .985.844 1.472 1.589 1.902zM1.472 7l.714-1h10.628l.714 1H1.471z"
});

function SvgLamp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dq);
}

function _extends$dr() { _extends$dr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dr.apply(this, arguments); }

var _ref$dr = /*#__PURE__*/createElement("path", {
  d: "M14 9V3a1 1 0 00-1-1H2a1 1 0 00-1 1v6h5v5h-.5a.5.5 0 000 1h-1a.5.5 0 000 1h6a.5.5 0 000-1h-1a.5.5 0 000-1H9V9h2v3a1 1 0 101-1V9h2zm-2-6h1v5h-1V3zM3 8H2V3h1v5zm2 0H4V3h1v5zm2 0H6V3h1v5zm2 0H8V3h1v5zm2 0h-1V3h1v5z"
});

function SvgLamp3(props) {
  return /*#__PURE__*/createElement("svg", _extends$dr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dr);
}

function _extends$ds() { _extends$ds = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ds.apply(this, arguments); }

var _ref$ds = /*#__PURE__*/createElement("path", {
  d: "M8 0a6 6 0 00-3 11.197V15l1 1h4l1-1v-3.803A6 6 0 008 0zM5 5a1 1 0 012 0v4.5a.5.5 0 01-1 0V6a1 1 0 01-1-1zm4.5 8h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5zm.5-7v3.5a.5.5 0 01-1 0V5a1 1 0 111 1zm-.5 9h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5z"
});

function SvgLamp4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ds({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ds);
}

function _extends$dt() { _extends$dt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dt.apply(this, arguments); }

var _ref$dt = /*#__PURE__*/createElement("path", {
  d: "M14 6a6 6 0 10-9 5.197V15l1 1h4l1-1v-3.803A5.997 5.997 0 0014 6zm-4.5 7h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5zm.5-2.415V6a1 1 0 10-1-1v5.9a5.032 5.032 0 01-2 0V5a1 1 0 10-1 1v4.585a4.995 4.995 0 01-1.536-1.05C3.52 8.591 3 7.335 3 5.999s.52-2.591 1.464-3.536S6.664.999 8 .999c1.335 0 2.591.52 3.536 1.464S13 4.663 13 5.999s-.52 2.591-1.464 3.536c-.45.45-.97.803-1.536 1.05zM9.5 15h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5z"
});

function SvgLamp5(props) {
  return /*#__PURE__*/createElement("svg", _extends$dt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dt);
}

function _extends$du() { _extends$du = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$du.apply(this, arguments); }

var _ref$du = /*#__PURE__*/createElement("path", {
  d: "M8 0a6 6 0 00-3 11.197V15l1 1h4l1-1v-3.803A6 6 0 008 0zM7 10.625v-.25h2v.25H7zm2 .25v.025a5.032 5.032 0 01-2 0v-.025h2zm-2-.75v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5v-.25h2v.25H7zm0-.5V5c0-.042-.003-.084-.008-.125h2.016A1.036 1.036 0 009 5v.125H7zm2.073-.5H6.927a.979.979 0 00-.147-.25h2.439c-.06.075-.11.159-.147.25zm-.022.059v0zm-2.102.002v-.001.001zm-.465-.561a.993.993 0 00-.968 0H3.362a4.843 4.843 0 01.109-.25h9.057c.039.082.075.166.109.25h-2.154a.994.994 0 00-.97 0H6.481zm2.99.025l-.001.001.001-.001zm-.041.026l-.001.001.001-.001zm-.039.029l-.001.001.001-.001zm-.039.031l-.001.001.001-.001zm-.036.032zm-2.57.07zm-.033-.036zm-.035-.034zm-.036-.032l-.001-.001.001.001zm-.037-.03l-.002-.001.002.001zm-.04-.029l-.002-.001.002.001zm-.041-.027l-.001-.001.001.001zm-1.519.975H3.076a4.587 4.587 0 00.051-.25h1.881a1.036 1.036 0 000 .25zm-1.817-.5a5.042 5.042 0 01.123-.375l-.045.125H5.22c-.06.075-.11.159-.147.25H3.191zm1.86.059v0zm-1.924.19l.03-.124a2.49 2.49 0 00-.03.124zm2.347-.724l-.001.001.001-.001zm-.041.026l-.002.001.002-.001zm-.039.029l-.002.001.002-.001zm-.038.031l-.001.001.001-.001zm-.037.032zm-.035.034zm-.033.036zm-1.937-.09zm7.635 1.067v0zm0-.631v0zm-.022.691h2.034a5.19 5.19 0 00.025.25H10.78c.06-.075.11-.159.147-.25zm.065-.25a1.036 1.036 0 000-.25h1.882c.019.083.036.166.051.25h-1.932zm-.065-.5a.979.979 0 00-.147-.25h1.951c.028.083.054.166.078.25h-1.882zm1.882 0c.012.041.023.082.033.124l-.033-.124zm.034.125c.011.042.021.083.03.125l-.03-.125zm-.205-.625l.048.123a3.12 3.12 0 00-.048-.123zm.049.126l.044.123-.044-.123zm-2.006.017zm-.036-.032l-.001-.001.001.001zm-.037-.03l-.001-.001.001.001zm-.04-.029l-.002-.001.002.001zm-.041-.027l-.001-.001.001.001zM10 8.875h2.092c-.06.085-.123.168-.189.25H10v-.25zm0-.5h2.402a4.494 4.494 0 00-.145.25H10v-.25zm0-.25v-.25h2.638c-.034.084-.07.168-.109.25H10zm0-.5v-.25h2.809c-.024.084-.05.167-.078.25H10zm2.731.001l-.044.123.044-.123zm-.046.126a3.12 3.12 0 01-.048.123l.048-.123zM10 7.125v-.25h2.924a4.716 4.716 0 01-.051.25H10zm2.843.126l-.033.124c.012-.041.023-.082.033-.124zM10 6.625v-.25h2.986a4.911 4.911 0 01-.025.25H10zm0-.5V6c.176 0 .341-.046.485-.125h2.514a5.02 5.02 0 00-.005.375l.005-.125h-2.998zm2.994.129l-.007.121.007-.121zm-2.313-.522zm-.036.032l-.001.001.001-.001zm-.037.03l-.001.001.001-.001zm-.04.029l-.002.001.002-.001zm-.041.027l-.001.001.001-.001zm2.459-.224l.007.121-.007-.121zm-.729-2.252l-.077-.121.077.121zm-1.43-1.499a5.188 5.188 0 00.333.25H4.839c.108-.088.219-.172.333-.25h5.655zm-5.654 0l.099-.066-.099.066zm.098-.066c.033-.022.066-.043.1-.063l-.1.063zm.101-.064l.1-.061-.1.061zm.102-.062c.202-.118.411-.222.626-.311l-.007.003h3.813c.213.088.42.191.62.308l-.102-.058H5.575l-.102.058zm5.054.001l.1.061-.1-.061zm.915.69l-.125-.115.125.115zM9.81 1.336l-.056-.021.056.021zm-.105-.039l-.059-.021.059.021zM9.6 1.261a1.446 1.446 0 00-.061-.02l.061.02zm-.105-.034l-.064-.02.064.02zm-.104-.031l-.069-.02.069.02zm-.092-.026zm-.181-.045H6.881a5.068 5.068 0 012.236 0zm-2.928.211l.057-.021-.057.021zm.105-.039l.059-.021-.059.021zm.105-.036l.062-.02-.062.02zm.105-.034l.064-.02a1.196 1.196 0 00-.064.02zm.103-.031l.069-.02a1.791 1.791 0 00-.069.02zm.093-.026zM4.683 2.259a3.46 3.46 0 00-.126.116h6.888a3.863 3.863 0 01.245.25H4.312a5.065 5.065 0 00-.215.25h7.807a5.547 5.547 0 00.189.25H3.908l-.083.122a4.95 4.95 0 01.858-.987zm.156-.134c-.044.036-.088.074-.132.112.043-.038.087-.076.132-.112zM3.82 3.254l-.077.121h8.515a4.828 4.828 0 01.145.25H3.598c.068-.127.143-.25.222-.371zM3.056 5.25a4.713 4.713 0 00-.017.125l.017-.125zm-.018.125h2.034a.979.979 0 00.147.25H3.013c-.006.083-.01.166-.012.25h2.514c.144.08.309.125.484.125v.125H3.001c.002.084.006.167.012.25h2.986v.25H3.037c.01.084.023.167.037.25h2.924v.25H3.125a5.072 5.072 0 01-.089-1.75zm2.013-.061v0zm.2.348zm.033.036zm.035.034zm.036.032l.001.001-.001-.001zm.037.03l.002.001-.002-.001zm.04.029l.002.001-.002-.001zm.041.027l.001.001-.001-.001zM6 7.375v.25H3.269a5.555 5.555 0 01-.078-.25H6zm-2.809 0a2.799 2.799 0 01-.033-.123l.033.123zm-.034-.125zm.157.501c.015.041.031.083.048.124H6v.25H3.471c.04.084.082.168.126.25h2.402v.25H3.742a4.967 4.967 0 00-.428-.873zm-.045-.126c.014.042.029.083.045.125l-.045-.125zM6 8.875v.25H4.096a4.916 4.916 0 01-.272-.372l.083.122h2.092zm-1.903.25c.069.085.14.169.214.25H6v.25H4.556a3.786 3.786 0 00-.092-.09 5.258 5.258 0 01-.368-.41zm.603.631c.046.041.093.08.14.119H6v.25h-.828a4.703 4.703 0 00-.472-.369zm1.3.619v.21a4.927 4.927 0 01-.527-.269l.103.059h.425zM9.5 13h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5zm.5-2.625h.425l.102-.059c-.171.1-.346.19-.527.269v-.21zm.529-.06c.101-.06.201-.123.298-.19h-.828v-.25h1.16a4.92 4.92 0 01-.631.44zm.631-.44zm.15-.127zm.134-.123H10v-.25h1.689a7.689 7.689 0 01-.245.25zm.459-.5zm.277-.38zm-.087.13zM9.5 15h-3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h3c.275 0 .5.225.5.5s-.225.5-.5.5z"
});

function SvgLamp6(props) {
  return /*#__PURE__*/createElement("svg", _extends$du({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$du);
}

function _extends$dv() { _extends$dv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dv.apply(this, arguments); }

var _ref$dv = /*#__PURE__*/createElement("path", {
  d: "M5 10c-.004 1.657 1.343 2 3 2s2.996-.343 3-2 1.996-2.239 2-5-2.239-5-5-5-4.996 2.239-5 5 2.004 3.343 2 5z"
});

var _ref2$33 = /*#__PURE__*/createElement("path", {
  d: "M8 13c-1.234 0-2.259-.274-2.463-1.516-.024.168-.037.34-.037.516 0 1.657 1.119 2 2.5 2s2.5-.343 2.5-2c0-.176-.013-.348-.037-.516C10.259 12.725 9.234 13 8 13z"
});

var _ref3$k = /*#__PURE__*/createElement("path", {
  d: "M8 15c-.987 0-1.807-.274-1.97-1.516-.019.168-.03.34-.03.516 0 1.657.895 2 2 2s2-.343 2-2c0-.176-.01-.348-.03-.516C9.807 14.725 8.987 15 8 15z"
});

function SvgLamp7(props) {
  return /*#__PURE__*/createElement("svg", _extends$dv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dv, _ref2$33, _ref3$k);
}

function _extends$dw() { _extends$dw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dw.apply(this, arguments); }

var _ref$dw = /*#__PURE__*/createElement("path", {
  d: "M8 1c1.07 0 2.076.417 2.833 1.175A3.96 3.96 0 0112 4.999c-.002 1.23-.485 1.888-.996 2.585-.47.64-1.002 1.365-1.004 2.414-.001.51-.176.647-.355.744-.318.172-.871.259-1.645.259-1.189 0-1.645-.208-1.819-.382-.045-.045-.182-.182-.181-.616.003-1.053-.533-1.78-1.005-2.422-.512-.696-.996-1.353-.995-2.579.002-1.07.418-2.075 1.173-2.83S6.932 1.001 8 1.001zm0-1C5.239 0 3.004 2.239 3 5s2.004 3.343 2 5 1.343 2 3 2 2.996-.343 3-2 1.996-2.239 2-5-2.239-5-5-5z"
});

var _ref2$34 = /*#__PURE__*/createElement("path", {
  d: "M8 13c-1.234 0-2.259-.274-2.463-1.516-.024.168-.037.34-.037.516 0 1.657 1.119 2 2.5 2s2.5-.343 2.5-2c0-.176-.013-.348-.037-.516C10.259 12.725 9.234 13 8 13z"
});

var _ref3$l = /*#__PURE__*/createElement("path", {
  d: "M8 15c-.987 0-1.807-.274-1.97-1.516-.019.168-.03.34-.03.516 0 1.657.895 2 2 2s2-.343 2-2c0-.176-.01-.348-.03-.516C9.807 14.725 8.987 15 8 15z"
});

function SvgLamp8(props) {
  return /*#__PURE__*/createElement("svg", _extends$dw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dw, _ref2$34, _ref3$l);
}

function _extends$dx() { _extends$dx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dx.apply(this, arguments); }

var _ref$dx = /*#__PURE__*/createElement("path", {
  d: "M16 14V8h-4V4H8V1H0v6h3v1H2v1h4V8H5V7h3V5h3v3H8v6h3v1h-1v1h4v-1h-1v-1h3zM7 6H1V2h6v4zm2 7V9h6v4H9z"
});

function SvgLan(props) {
  return /*#__PURE__*/createElement("svg", _extends$dx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dx);
}

function _extends$dy() { _extends$dy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dy.apply(this, arguments); }

var _ref$dy = /*#__PURE__*/createElement("path", {
  d: "M14.5 8H8V6h1.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v4a.5.5 0 00.5.5H7v2H.5a.5.5 0 000 1H3v2H1.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5H4V9h7v2H9.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5H12V9h2.5a.5.5 0 000-1zM6 2h3v3H6V2zM5 15H2v-3h3v3zm8 0h-3v-3h3v3z"
});

function SvgLan2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dy);
}

function _extends$dz() { _extends$dz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dz.apply(this, arguments); }

var _ref$dz = /*#__PURE__*/createElement("path", {
  d: "M13 11.5l1.5 1.5 5-5-5-5L13 4.5 16.5 8 13 11.5zM7 4.5L5.5 3l-5 5 5 5L7 11.5 3.5 8 7 4.5z"
});

var _ref2$35 = /*#__PURE__*/createElement("path", {
  d: "M8 8a1 1 0 11-2 0 1 1 0 012 0zM11 8a1 1 0 11-2 0 1 1 0 012 0zM14 8a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgLan3(props) {
  return /*#__PURE__*/createElement("svg", _extends$dz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$dz, _ref2$35);
}

function _extends$dA() { _extends$dA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dA.apply(this, arguments); }

var _ref$dA = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-1.65 12.012l-5.444 1.781c-1.244.406-1.369.341-1.931-1.4L4.1 8.134c-.328-1.009-1.328-3.728-1.497-4.25-.313-.969-.313-1.022 1.516-1.616 1.431-.469 1.491-.453 2.009 1.163.419 1.3.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c.738-.244.984-.231 1.194.678l.15.688c.175.797-.228 1-.656 1.137z"
});

function SvgLanyrd(props) {
  return /*#__PURE__*/createElement("svg", _extends$dA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dA);
}

function _extends$dB() { _extends$dB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dB.apply(this, arguments); }

var _ref$dB = /*#__PURE__*/createElement("path", {
  d: "M14 11V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v8H0v3h16v-3h-2zm-4 2H6v-1h4v1zm3-2H3V3.002L3.002 3h9.996l.002.002V11z"
});

function SvgLaptop(props) {
  return /*#__PURE__*/createElement("svg", _extends$dB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dB);
}

function _extends$dC() { _extends$dC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dC.apply(this, arguments); }

var _ref$dC = /*#__PURE__*/createElement("path", {
  d: "M14.894 5.157c-.676-2.524-3.276-4.22-6.469-4.22a9.3 9.3 0 00-2.405.321c-1.927.516-3.585 1.597-4.669 3.043C.237 5.788-.142 7.482.284 9.071c.278 1.037.881 1.934 1.716 2.632V15.5a.5.5 0 001 0v-2.586a1.505 1.505 0 001.112-.044 8.205 8.205 0 002.641.422 9.3 9.3 0 002.405-.321c1.927-.516 3.585-1.597 4.669-3.043 1.114-1.487 1.493-3.181 1.067-4.77zM3.5 12a.5.5 0 110-1 .5.5 0 010 1zm5.367-.116a8.16 8.16 0 01-2.114.283 7.251 7.251 0 01-1.819-.225 1.5 1.5 0 00-2.564-1.427 3.956 3.956 0 01-.999-1.734c-.335-1.249-.022-2.6.881-3.804.933-1.245 2.375-2.18 4.06-2.631a8.155 8.155 0 012.114-.283c2.677 0 4.84 1.361 5.382 3.386.705 2.63-1.512 5.517-4.94 6.435z"
});

function SvgLasso(props) {
  return /*#__PURE__*/createElement("svg", _extends$dC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dC);
}

function _extends$dD() { _extends$dD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dD.apply(this, arguments); }

var _ref$dD = /*#__PURE__*/createElement("path", {
  d: "M7 12.163a7.251 7.251 0 01-2.066-.221 1.5 1.5 0 00-2.564-1.427 3.956 3.956 0 01-.999-1.734c-.335-1.249-.022-2.6.881-3.804.933-1.245 2.375-2.18 4.06-2.631a8.16 8.16 0 012.114-.283c2.677 0 4.84 1.361 5.382 3.386.226.845.151 1.716-.169 2.54l.927.697c.52-1.151.639-2.367.328-3.528-.676-2.524-3.276-4.22-6.469-4.22a9.3 9.3 0 00-2.405.321c-1.927.516-3.585 1.597-4.669 3.043C.237 5.789-.142 7.483.284 9.072c.278 1.037.881 1.934 1.716 2.632v3.797a.5.5 0 001 0v-2.586a1.505 1.505 0 001.112-.044A8.205 8.205 0 007 13.289v-1.125zM3.5 12a.5.5 0 110-1 .5.5 0 010 1z"
});

var _ref2$36 = /*#__PURE__*/createElement("path", {
  d: "M8 5v9.978l3.554-2.871L15.981 11z"
});

var _ref3$m = /*#__PURE__*/createElement("path", {
  d: "M12.453 11.659l-1.79.893 1.719 3.447.001-.002 1.788-.892z"
});

function SvgLasso2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dD, _ref2$36, _ref3$m);
}

function _extends$dE() { _extends$dE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dE.apply(this, arguments); }

var _ref$dE = /*#__PURE__*/createElement("path", {
  d: "M14 2v12h-2V8.5l-5 5v-5l-5 5v-11l5 5v-5l5 5V2z"
});

function SvgLast(props) {
  return /*#__PURE__*/createElement("svg", _extends$dE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dE);
}

function _extends$dF() { _extends$dF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dF.apply(this, arguments); }

var _ref$dF = /*#__PURE__*/createElement("path", {
  d: "M3 13l3 3 8-8-8-8-3 3 5 5zm13 3V0h-2v16z"
});

function SvgLast2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dF);
}

function _extends$dG() { _extends$dG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dG.apply(this, arguments); }

var _ref$dG = /*#__PURE__*/createElement("path", {
  d: "M7.056 11.972l-.588-1.594s-.953 1.063-2.381 1.063c-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l.588 1.831c.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-.697 3.813-2.528 0-1.484-.844-2.253-2.419-2.622l-1.172-.256c-.806-.184-1.044-.513-1.044-1.063 0-.622.494-.991 1.3-.991.881 0 1.356.331 1.428 1.119l1.831-.219c-.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262.622-3.262 2.622 0 1.247.606 2.034 2.125 2.4l1.247.294c.934.219 1.247.606 1.247 1.137 0 .678-.659.953-1.906.953-1.85 0-2.622-.972-3.059-2.309l-.606-1.831c-.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-.972 3.059-.972z"
});

function SvgLastfm(props) {
  return /*#__PURE__*/createElement("svg", _extends$dG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dG);
}

function _extends$dH() { _extends$dH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dH.apply(this, arguments); }

var _ref$dH = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-2.834 11.887c-2.775 0-3.737-1.25-4.25-2.806l-.513-1.603c-.384-1.172-.834-2.084-2.244-2.084-.978 0-1.972.706-1.972 2.678 0 1.541.784 2.503 1.894 2.503 1.25 0 2.084-.931 2.084-.931l.513 1.394s-.866.85-2.678.85c-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206.769 3.881 2.853l.528 1.603c.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-.241 1.669-.834 0-.466-.272-.803-1.091-.994l-1.091-.256c-1.331-.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631.594 2.759 2.038l-1.603.194c-.066-.691-.481-.978-1.25-.978-.706 0-1.137.322-1.137.866 0 .481.209.769.912.931l1.025.225c1.378.322 2.116.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"
});

function SvgLastfm2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dH);
}

function _extends$dI() { _extends$dI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dI.apply(this, arguments); }

var _ref$dI = /*#__PURE__*/createElement("path", {
  d: "M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 1a1 1 0 110 2 1 1 0 010-2zm-8 .5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM8 14a4 4 0 110-8 4 4 0 010 8zm5-11a1 1 0 110-2 1 1 0 010 2z"
});

var _ref2$37 = /*#__PURE__*/createElement("path", {
  d: "M8 10c-.5-1.5-2.5-1.5-3 0a3 3 0 106 0c-.5 1.5-2.5 1.5-3 0z"
});

function SvgLaundry(props) {
  return /*#__PURE__*/createElement("svg", _extends$dI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dI, _ref2$37);
}

function _extends$dJ() { _extends$dJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dJ.apply(this, arguments); }

var _ref$dJ = /*#__PURE__*/createElement("path", {
  d: "M15.802 2.102C14.072.791 11.409.008 8.678.008c-3.377 0-6.129 1.179-7.549 3.235C.462 4.208.093 5.352.032 6.641c-.054 1.148.139 2.418.573 3.784C2.087 5.981 6.227 2.502 11 2.502c0 0-4.466 1.175-7.274 4.816A10.535 10.535 0 002.2 10.037 15.387 15.387 0 001 16.002h2s-.304-1.91.224-4.106a17.71 17.71 0 002.357.177c1.839 0 3.146-.398 4.115-1.252.868-.765 1.347-1.794 1.854-2.882.774-1.663 1.651-3.547 4.198-5.002a.5.5 0 00.054-.833z"
});

function SvgLeaf(props) {
  return /*#__PURE__*/createElement("svg", _extends$dJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dJ);
}

function _extends$dK() { _extends$dK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dK.apply(this, arguments); }

var _ref$dK = /*#__PURE__*/createElement("path", {
  d: "M15.802 2.102C14.072.791 11.409.008 8.678.008c-3.377 0-6.129 1.179-7.549 3.235C.462 4.208.093 5.352.032 6.641c-.065 1.375.225 2.925.859 4.606-.586 1.428-.904 2.898-.904 4.254a.5.5 0 001 0c0-1.198.293-2.535.818-3.835 1.472.272 2.712.405 3.776.405 1.839 0 3.146-.398 4.115-1.252.868-.765 1.347-1.794 1.854-2.882.774-1.663 1.651-3.547 4.198-5.002a.5.5 0 00.054-.833zm-5.158 5.413c-.481 1.034-.897 1.927-1.608 2.554-.776.684-1.873 1.002-3.454 1.002-.945 0-2.047-.113-3.351-.345.238-.476.507-.941.804-1.386a11.753 11.753 0 012.417-2.661 9.446 9.446 0 013.193-1.7.5.5 0 10-.288-.958 10.44 10.44 0 00-3.53 1.878 12.777 12.777 0 00-2.623 2.886 14.37 14.37 0 00-.698 1.163c-.36-1.185-.52-2.279-.474-3.261.052-1.099.361-2.067.921-2.876.636-.92 1.583-1.633 2.816-2.119 1.134-.447 2.487-.684 3.911-.684 2.172 0 4.357.555 5.9 1.475-2.314 1.551-3.206 3.467-3.935 5.032z"
});

function SvgLeaf2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dK);
}

function _extends$dL() { _extends$dL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dL.apply(this, arguments); }

var _ref$dL = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  id: "leichte-sprache_svg__a",
  d: "M.169.2h21.118v21.055H.169z"
}));

var _ref2$38 = /*#__PURE__*/createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M.784 52.368L30.059 64l29.275-11.632v-36l-29.275 11.51L.667 16l.117 36.368zm33.907-21.614l18.206-7.03.104 5.083-18.31 7.14v-5.193zm-.005 6.667l18.206-7.031.104 5.084-18.31 7.139V37.42zm.039 6.761l11.301-4.143.104 4.843-11.405 4.492v-5.192z"
}), /*#__PURE__*/createElement("path", {
  d: "M10.581.2C7.652.2 5.114 1.352 2.986 3.648c-3.622 3.91-3.768 9.875-.339 13.813 4.683 5.376 12.431 4.993 16.57-.864 1.97-2.79 2.658-5.894 1.52-9.248C19.281 3.052 15.172.2 10.581.2",
  mask: "url(#leichte-sprache_svg__x7cy11vgkb)",
  transform: "translate(19.334)"
}), /*#__PURE__*/createElement("g", {
  transform: "translate(19.334)"
}, /*#__PURE__*/createElement("mask", {
  id: "leichte-sprache_svg__b"
}, /*#__PURE__*/createElement("use", {
  xlinkHref: "#leichte-sprache_svg__a"
})), /*#__PURE__*/createElement("path", {
  d: "M10.581.2c4.591 0 8.7 2.852 10.156 7.15 1.138 3.353.45 6.457-1.52 9.247-4.139 5.857-11.887 6.24-16.57.864-3.43-3.938-3.283-9.902.34-13.813C5.113 1.352 7.651.2 10.58.2",
  mask: "url(#leichte-sprache_svg__b)"
})));

function SvgLeichteSprache(props) {
  return /*#__PURE__*/createElement("svg", _extends$dL({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 64,
    viewBox: "0 0 60 64"
  }, props), _ref$dL, _ref2$38);
}

function _extends$dM() { _extends$dM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dM.apply(this, arguments); }

var _ref$dM = /*#__PURE__*/createElement("path", {
  d: "M16 15v-1h-1V8h1V7h-3v1h1v6h-3V8h1V7H9v1h1v6H7V8h1V7H5v1h1v6H3V8h1V7H1v1h1v6H1v1H0v1h17v-1h-1zM8 0h1l8 5v1H0V5l8-5z"
});

function SvgLibrary(props) {
  return /*#__PURE__*/createElement("svg", _extends$dM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$dM);
}

function _extends$dN() { _extends$dN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dN.apply(this, arguments); }

var _ref$dN = /*#__PURE__*/createElement("path", {
  d: "M15 7h-2v7h-2V7H9v7H7V7H5v7H3V7H1v8H0v1h16v-1h-1V7zM8.5 0h-1L0 5v1h16V5L8.5 0zM8 4a1 1 0 110-2 1 1 0 010 2z"
});

function SvgLibrary2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dN);
}

function _extends$dO() { _extends$dO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dO.apply(this, arguments); }

var _ref$dO = /*#__PURE__*/createElement("path", {
  d: "M8.354.354A1.394 1.394 0 007.5 0h-6c-.275 0-.5.225-.5.5v15c0 .275.225.5.5.5h12c.275 0 .5-.225.5-.5v-9c0-.275-.159-.659-.354-.854L8.353.353zM13 15H2V1h5.487a.545.545 0 01.169.07l5.274 5.274a.545.545 0 01.07.169V15zm.5-15h-3c-.275 0-.341.159-.146.354l3.293 3.293c.194.194.354.129.354-.146v-3c0-.275-.225-.5-.5-.5z"
});

function SvgLibreoffice(props) {
  return /*#__PURE__*/createElement("svg", _extends$dO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dO);
}

function _extends$dP() { _extends$dP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dP.apply(this, arguments); }

var _ref$dP = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM5 8a3 3 0 116 0 3 3 0 01-6 0zm9.468 2.679l-2.772-1.148C11.892 9.059 12 8.542 12 8s-.108-1.059-.304-1.531l2.772-1.148C14.81 6.146 15 7.051 15 8s-.189 1.854-.532 2.679zm-3.789-9.147L9.531 4.304C9.059 4.108 8.542 4 8 4s-1.059.108-1.531.304L5.321 1.532C6.146 1.19 7.051 1 8 1s1.854.189 2.679.532zM1.532 5.321l2.772 1.148C4.108 6.941 4 7.458 4 8s.108 1.059.304 1.531l-2.772 1.148C1.19 9.854 1 8.949 1 8s.189-1.854.532-2.679zm3.789 9.147l1.148-2.772c.472.196.989.304 1.531.304s1.059-.108 1.531-.304l1.148 2.772C9.854 14.81 8.949 15 8 15s-1.854-.189-2.679-.532z"
});

function SvgLifebuoy(props) {
  return /*#__PURE__*/createElement("svg", _extends$dP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dP);
}

function _extends$dQ() { _extends$dQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dQ.apply(this, arguments); }

var _ref$dQ = /*#__PURE__*/createElement("path", {
  d: "M12 13.622v-.002l-.005-6.821-1.992.097H6.067V6.56c0-1.274.091-2.546.269-3.042.123-.343.353-.652.683-.919.322-.261.643-.393.955-.393.262 0 .48.045.647.134.235.134.464.359.682.669.577.82.812 1.038.939 1.131.216.158.477.238.776.238.292 0 .546-.109.757-.324a1.09 1.09 0 00.315-.792c0-.335-.139-.691-.414-1.057-.268-.358-.683-.652-1.232-.875a4.743 4.743 0 00-1.793-.329c-.949 0-1.813.228-2.568.678a4.405 4.405 0 00-1.725 1.863c-.359.728-.333 2.105-.355 3.355H2.038v1.116H4v5.073c0 1.12-.342 1.422-.472 1.583a1.225 1.225 0 01-.944.455H1.98v.878h6.021v-.878h-.105c-1.424 0-1.828-.154-1.828-1.888v-.001l-.001-5.222h2.191c1.163 0 1.43.054 1.491.077.074.028.169.075.204.143.014.026.081.391.081 1.296v3.917c0 .913-.111 1.217-.179 1.319-.145.222-.319.345-.854.358v.879h4.588v-.873c-1.431 0-1.588-.153-1.588-1.505z"
});

function SvgLigature(props) {
  return /*#__PURE__*/createElement("svg", _extends$dQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dQ);
}

function _extends$dR() { _extends$dR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dR.apply(this, arguments); }

var _ref$dR = /*#__PURE__*/createElement("path", {
  d: "M13.364 14.335c-.183 0-1.307-.206-1.375-.458-.161-.619-.183-1.284-.183-2.04V3.384c0-1.261.252-1.994.252-1.994-.023-.115-.138-.367-.275-.367h-.069c-.069 0-.871.504-1.605.504-.596 0-.967-.527-1.655-.527-2.892 0-4.249 2.349-4.249 5.672v.173c0 .069-.046.138-.115.138h-.94c-.115 0-.344.642-.344.94 0 .092.023.137.069.137H4.09c.069 0 .115.092.115.16 0 2.04-.023 4.052-.023 4.052 0 .321-.023 1.031-.16 1.605-.069.252-1.123.458-1.398.458-.115 0-.115.55 0 .665.94-.046 1.559-.115 2.499-.115.871 0 1.536.069 2.453.115.046-.138.046-.665-.069-.665-.183 0-1.307-.206-1.375-.458-.16-.619-.16-1.284-.183-2.04V8.198c0-.069.069-.138.138-.138h2.361c.16-.321.275-.711.275-.917 0-.138 0-.16-.115-.16H6.064c-.046 0-.115-.069-.115-.115v-.825c0-2.04.836-3.837 2.234-3.837.99 0 1.854.642 1.854 3.093.003.063.005.114.005.148v6.825c0 .321-.023 1.031-.16 1.605-.069.252-1.123.458-1.398.458-.115 0-.115.55 0 .665.94-.046 1.559-.115 2.499-.115.871 0 1.536.069 2.453.115.046-.137.046-.665-.069-.665z"
});

function SvgLigature2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dR);
}

function _extends$dS() { _extends$dS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dS.apply(this, arguments); }

var _ref$dS = /*#__PURE__*/createElement("path", {
  d: "M6.879 9.934a.81.81 0 01-.575-.238 3.818 3.818 0 010-5.392l3-3C10.024.584 10.982.187 12 .187s1.976.397 2.696 1.117a3.818 3.818 0 010 5.392l-1.371 1.371a.813.813 0 01-1.149-1.149l1.371-1.371A2.19 2.19 0 0012 1.812c-.584 0-1.134.228-1.547.641l-3 3a2.19 2.19 0 000 3.094.813.813 0 01-.575 1.387z"
});

var _ref2$39 = /*#__PURE__*/createElement("path", {
  d: "M4 15.813a3.789 3.789 0 01-2.696-1.117 3.818 3.818 0 010-5.392l1.371-1.371a.813.813 0 011.149 1.149l-1.371 1.371A2.19 2.19 0 004 14.188c.585 0 1.134-.228 1.547-.641l3-3a2.19 2.19 0 000-3.094.813.813 0 011.149-1.149 3.818 3.818 0 010 5.392l-3 3A3.789 3.789 0 014 15.813z"
});

function SvgLink(props) {
  return /*#__PURE__*/createElement("svg", _extends$dS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dS, _ref2$39);
}

function _extends$dT() { _extends$dT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dT.apply(this, arguments); }

var _ref$dT = /*#__PURE__*/createElement("path", {
  d: "M5 11c.275.275.739.261 1.03-.03l4.939-4.939c.292-.292.305-.755.03-1.03s-.739-.261-1.03.03L5.03 9.97c-.292.292-.305.755-.03 1.03zm2.451-.451c.071.141.109.299.109.464 0 .275-.105.532-.297.724L4.71 14.29c-.191.191-.448.297-.724.297s-.532-.105-.724-.297l-1.553-1.553c-.191-.191-.297-.448-.297-.724s.105-.532.297-.724l2.553-2.553c.191-.191.448-.297.724-.297.165 0 .323.038.464.109l1.021-1.021a2.43 2.43 0 00-1.485-.502 2.43 2.43 0 00-1.724.711L.709 10.289a2.444 2.444 0 000 3.447l1.553 1.553c.474.474 1.099.711 1.724.711s1.25-.237 1.724-.711l2.553-2.553a2.448 2.448 0 00.209-3.209l-1.021 1.021zm7.838-8.285L13.736.711C13.262.237 12.637 0 12.012 0s-1.25.237-1.724.711L7.735 3.264a2.445 2.445 0 00-.208 3.208l1.021-1.021a1.029 1.029 0 01-.109-.464c0-.275.105-.532.297-.724l2.553-2.553c.191-.191.448-.297.724-.297s.532.105.724.297l1.553 1.553c.191.191.297.448.297.724s-.105.532-.297.724l-2.553 2.553a1.016 1.016 0 01-.724.297c-.165 0-.323-.038-.464-.109L9.528 8.473c.435.335.96.502 1.485.502a2.43 2.43 0 001.724-.711l2.553-2.553a2.444 2.444 0 000-3.447z"
});

function SvgLink2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dT);
}

function _extends$dU() { _extends$dU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dU.apply(this, arguments); }

var _ref$dU = /*#__PURE__*/createElement("path", {
  d: "M4.5 16C2.019 16 0 13.981 0 11.5S2.019 7 4.5 7a1 1 0 010 2C3.122 9 2 10.121 2 11.5S3.122 14 4.5 14 7 12.879 7 11.5a1 1 0 012 0C9 13.981 6.981 16 4.5 16zM11.5 9a1 1 0 010-2C12.879 7 14 5.878 14 4.5S12.879 2 11.5 2 9 3.122 9 4.5a1 1 0 01-2 0C7 2.019 9.019 0 11.5 0S16 2.019 16 4.5 13.981 9 11.5 9z"
});

var _ref2$3a = /*#__PURE__*/createElement("path", {
  d: "M6 11a.999.999 0 01-.707-1.707l4-4a.999.999 0 111.414 1.414l-4 4A.997.997 0 016 11z"
});

function SvgLink3(props) {
  return /*#__PURE__*/createElement("svg", _extends$dU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dU, _ref2$3a);
}

function _extends$dV() { _extends$dV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dV.apply(this, arguments); }

var _ref$dV = /*#__PURE__*/createElement("path", {
  d: "M8.586 10.086l-3.365 3.365c-.354.354-.829.549-1.337.549a1.873 1.873 0 01-1.883-1.884c0-.508.195-.983.549-1.337l3.365-3.365L4.501 6 1.136 9.365a3.9 3.9 0 00-.001 5.501C1.891 15.622 2.888 16 3.885 16s1.995-.378 2.752-1.135l3.365-3.365-1.414-1.414zM10.086 8.586l3.365-3.365c.354-.354.549-.829.549-1.337a1.873 1.873 0 00-1.884-1.883c-.508 0-.983.195-1.337.549L7.414 5.915 6 4.501l3.365-3.365a3.9 3.9 0 015.501-.001C15.622 1.891 16 2.888 16 3.885s-.378 1.995-1.135 2.752L11.5 10.002l-1.414-1.414z"
});

var _ref2$3b = /*#__PURE__*/createElement("path", {
  d: "M6.5 10.5l-1-1 4-4 1 1-4 4z"
});

function SvgLink4(props) {
  return /*#__PURE__*/createElement("svg", _extends$dV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dV, _ref2$3b);
}

function _extends$dW() { _extends$dW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dW.apply(this, arguments); }

var _ref$dW = /*#__PURE__*/createElement("path", {
  d: "M7 12H4c-2.206 0-4-1.794-4-4s1.794-4 4-4h3a1 1 0 010 2H4c-1.103 0-2 .897-2 2s.897 2 2 2h3a1 1 0 010 2zM13 12h-3a1 1 0 010-2h3c1.103 0 2-.897 2-2s-.897-2-2-2h-3a1 1 0 010-2h3c2.206 0 4 1.794 4 4s-1.794 4-4 4z"
});

var _ref2$3c = /*#__PURE__*/createElement("path", {
  d: "M11 9H6a1 1 0 010-2h5a1 1 0 010 2z"
});

function SvgLink5(props) {
  return /*#__PURE__*/createElement("svg", _extends$dW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$dW, _ref2$3c);
}

function _extends$dX() { _extends$dX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dX.apply(this, arguments); }

var _ref$dX = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM6 13H4V6h2v7zM5 5a1 1 0 110-2 1 1 0 110 2zm8 8h-2V9a1 1 0 10-2 0v4H7V6h2v1.241C9.412 6.675 10.044 6 10.75 6 11.994 6 13 7.119 13 8.5V13z"
});

function SvgLinkedin(props) {
  return /*#__PURE__*/createElement("svg", _extends$dX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dX);
}

function _extends$dY() { _extends$dY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dY.apply(this, arguments); }

var _ref$dY = /*#__PURE__*/createElement("path", {
  d: "M6 6h2.767v1.418h.04C9.192 6.727 10.134 6 11.539 6 14.46 6 15 7.818 15 10.183V15h-2.885v-4.27c0-1.018-.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255V15H6V6zM1 6h3v9H1V6zM4 3.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 3.5z"
});

function SvgLinkedin2(props) {
  return /*#__PURE__*/createElement("svg", _extends$dY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dY);
}

function _extends$dZ() { _extends$dZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$dZ.apply(this, arguments); }

var _ref$dZ = /*#__PURE__*/createElement("path", {
  d: "M16 6.877l-.157-.005c-1.935-.112-3.646-2.091-5.593-2.091-2 0-2.25.75-2.25.75s-.25-.75-2.25-.75c-1.948 0-3.658 1.979-5.593 2.091L0 6.877s5 .904 8 .904 8-.904 8-.904zM8 9.219c-2.637 0-7-1.531-7.793-2.138C2.457 8.803 4.101 11.875 8 11.875s5.543-3.073 7.793-4.794C15 7.688 10.637 9.219 8 9.219z"
});

function SvgLips(props) {
  return /*#__PURE__*/createElement("svg", _extends$dZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$dZ);
}

function _extends$d_() { _extends$d_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d_.apply(this, arguments); }

var _ref$d_ = /*#__PURE__*/createElement("path", {
  d: "M15.071 5.799c-.456 0-2.015-.834-2.015-.834-.888-.495-1.895-1.057-3.031-1.057-.84 0-1.52.133-2.025.396-.505-.263-1.185-.396-2.025-.396-1.136 0-2.143.562-3.031 1.057 0 0-1.558.834-2.015.834-.697 0-1.416.927-.49 1.793.497.38.972.855 1.475 1.357.734.733 1.494 1.492 2.445 2.09 1.126.708 2.317 1.053 3.64 1.053s2.514-.344 3.64-1.053c.952-.599 1.711-1.357 2.445-2.09.503-.502.978-.977 1.475-1.357.926-.867.206-1.793-.49-1.793zM8 11.192c-3.509 0-4.989-2.765-7.014-4.315C1.7 7.423 5.626 8.958 8 8.958s6.3-1.534 7.014-2.081c-2.025 1.55-3.505 4.315-7.014 4.315zm0-3.684c-2.7 0-7.2-.813-7.2-.813l.141-.004c1.742-.101 3.281-1.882 5.034-1.882 1.8 0 2.025.675 2.025.675s.225-.675 2.025-.675c1.753 0 3.292 1.782 5.034 1.882l.141.004s-4.5.813-7.2.813z"
});

function SvgLips2(props) {
  return /*#__PURE__*/createElement("svg", _extends$d_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d_);
}

function _extends$d$() { _extends$d$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d$.apply(this, arguments); }

var _ref$d$ = /*#__PURE__*/createElement("path", {
  d: "M6 13h10v2H6zm0-6h10v2H6zm0-6h10v2H6zM3 0v4H2V1H1V0zM2 8.219V9h2v1H1V7.719l2-.938V6H1V5h3v2.281zM4 11v5H1v-1h2v-1H1v-1h2v-1H1v-1z"
});

function SvgListNumbered(props) {
  return /*#__PURE__*/createElement("svg", _extends$d$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$d$);
}

function _extends$e0() { _extends$e0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e0.apply(this, arguments); }

var _ref$e0 = /*#__PURE__*/createElement("path", {
  d: "M0 0h4v4H0zm6 1h10v2H6zM0 6h4v4H0zm6 1h10v2H6zm-6 5h4v4H0zm6 1h10v2H6z"
});

function SvgList(props) {
  return /*#__PURE__*/createElement("svg", _extends$e0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e0);
}

function _extends$e1() { _extends$e1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e1.apply(this, arguments); }

var _ref$e1 = /*#__PURE__*/createElement("path", {
  d: "M6 1h10v2H6V1zm0 6h10v2H6V7zm0 6h10v2H6v-2zM0 2a2 2 0 113.999-.001A2 2 0 010 2zm0 6a2 2 0 113.999-.001A2 2 0 010 8zm0 6a2 2 0 113.999-.001A2 2 0 010 14z"
});

function SvgList2(props) {
  return /*#__PURE__*/createElement("svg", _extends$e1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e1);
}

function _extends$e2() { _extends$e2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e2.apply(this, arguments); }

var _ref$e2 = /*#__PURE__*/createElement("path", {
  d: "M15.979 4.021c-6.604 0-11.957 5.354-11.957 11.957h2.604a9.355 9.355 0 019.354-9.354V4.02z"
});

function SvgLoad(props) {
  return /*#__PURE__*/createElement("svg", _extends$e2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref$e2);
}

function _extends$e3() { _extends$e3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e3.apply(this, arguments); }

var _ref$e3 = /*#__PURE__*/createElement("path", {
  d: "M18.75 8.75A1.25 1.25 0 0017.5 10 7.5 7.5 0 1110 2.5 1.25 1.25 0 0010 0a10 10 0 1010 10 1.25 1.25 0 00-1.25-1.25z"
});

function SvgLoadingCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$e3({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref$e3);
}

function _extends$e4() { _extends$e4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e4.apply(this, arguments); }

var _ref$e4 = /*#__PURE__*/createElement("path", {
  d: "M8 0a5 5 0 00-5 5c0 5 5 11 5 11s5-6 5-11a5 5 0 00-5-5zm0 8a3 3 0 110-6 3 3 0 010 6z"
});

function SvgLocation(props) {
  return /*#__PURE__*/createElement("svg", _extends$e4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e4);
}

function _extends$e5() { _extends$e5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e5.apply(this, arguments); }

var _ref$e5 = /*#__PURE__*/createElement("path", {
  d: "M8 0a5 5 0 00-5 5c0 5 5 9 5 9s5-4 5-9a5 5 0 00-5-5zm0 8a3 3 0 110-6 3 3 0 010 6zm4.285 2.9a16.57 16.57 0 01-.682.988l.108.052c.76.38 1.101.806 1.101 1.059s-.34.679-1.101 1.059c-.957.479-2.31.753-3.712.753s-2.754-.275-3.712-.753c-.76-.38-1.101-.806-1.101-1.059s.34-.679 1.101-1.059l.108-.052c-.231-.31-.461-.64-.682-.988-1.061.541-1.715 1.282-1.715 2.1 0 1.657 2.686 3 6 3s6-1.343 6-3c0-.817-.654-1.558-1.715-2.1z"
});

function SvgLocation2(props) {
  return /*#__PURE__*/createElement("svg", _extends$e5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e5);
}

function _extends$e6() { _extends$e6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e6.apply(this, arguments); }

var _ref$e6 = /*#__PURE__*/createElement("path", {
  d: "M8 0a5 5 0 00-5 5c0 5 5 11 5 11s5-6 5-11a5 5 0 00-5-5zm0 8.063a3.063 3.063 0 110-6.126 3.063 3.063 0 010 6.126zM6.063 5a1.938 1.938 0 113.876 0 1.938 1.938 0 01-3.876 0z"
});

function SvgLocation3(props) {
  return /*#__PURE__*/createElement("svg", _extends$e6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e6);
}

function _extends$e7() { _extends$e7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e7.apply(this, arguments); }

var _ref$e7 = /*#__PURE__*/createElement("path", {
  d: "M8 0a5 5 0 00-5 5c0 5 5 9 5 9s5-4 5-9a5 5 0 00-5-5zm0 8.063a3.063 3.063 0 110-6.126 3.063 3.063 0 010 6.126zM6.063 5a1.938 1.938 0 103.876 0 1.938 1.938 0 00-3.876 0zm6.222 5.9a16.57 16.57 0 01-.682.988l.108.052c.76.38 1.101.806 1.101 1.059s-.34.679-1.101 1.059c-.957.479-2.31.753-3.712.753s-2.754-.275-3.712-.753c-.76-.38-1.101-.806-1.101-1.059s.34-.679 1.101-1.059l.108-.052c-.231-.31-.461-.64-.682-.988-1.061.541-1.715 1.282-1.715 2.1 0 1.657 2.686 3 6 3s6-1.343 6-3c0-.817-.654-1.558-1.715-2.1z"
});

function SvgLocation4(props) {
  return /*#__PURE__*/createElement("svg", _extends$e7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e7);
}

function _extends$e8() { _extends$e8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e8.apply(this, arguments); }

var _ref$e8 = /*#__PURE__*/createElement("path", {
  d: "M8 0a6 6 0 00-6 6c0 6 6 10 6 10s6-4 6-10a6 6 0 00-6-6zm0 7a2 2 0 11-.001-3.999A2 2 0 018 7z"
});

function SvgLocation5(props) {
  return /*#__PURE__*/createElement("svg", _extends$e8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e8);
}

function _extends$e9() { _extends$e9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e9.apply(this, arguments); }

var _ref$e9 = /*#__PURE__*/createElement("path", {
  d: "M8 0a6 6 0 00-6 6c0 6 6 10 6 10s6-4 6-10a6 6 0 00-6-6zm2.093 12.387A16.25 16.25 0 018 14.433a16.254 16.254 0 01-2.093-2.046c-.785-.924-1.407-1.883-1.849-2.85C3.522 8.366 3.251 7.176 3.251 6c0-1.269.494-2.462 1.391-3.359S6.732 1.25 8.001 1.25c1.269 0 2.462.494 3.359 1.391S12.751 4.731 12.751 6c0 1.175-.272 2.365-.807 3.537-.442.967-1.064 1.926-1.849 2.85zM8 3a2 2 0 10-.001 3.999A2 2 0 008 3zm0 3a1 1 0 110-2 1 1 0 010 2z"
});

function SvgLocation6(props) {
  return /*#__PURE__*/createElement("svg", _extends$e9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e9);
}

function _extends$ea() { _extends$ea = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ea.apply(this, arguments); }

var _ref$ea = /*#__PURE__*/createElement("path", {
  d: "M8 0C5.239 0 3 2.099 3 4.688c0 3.75 4 5.023 4 10.313v.5c0 .264.205.48.464.499v.001H8.5a.5.5 0 00.5-.5v-.5c0-5.29 4-6.563 4-10.313C13 2.099 10.761 0 8 0z"
});

function SvgLocation7(props) {
  return /*#__PURE__*/createElement("svg", _extends$ea({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ea);
}

function _extends$eb() { _extends$eb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eb.apply(this, arguments); }

var _ref$eb = /*#__PURE__*/createElement("path", {
  d: "M14 6h-1V1c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v5H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm-5 7H7l.435-2.175a1 1 0 111.13 0L9 13zm2-7H5V2h6v4z"
});

function SvgLock(props) {
  return /*#__PURE__*/createElement("svg", _extends$eb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eb);
}

function _extends$ec() { _extends$ec = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ec.apply(this, arguments); }

var _ref$ec = /*#__PURE__*/createElement("path", {
  d: "M13 7h-1V4a4 4 0 00-8 0v3H3c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-5 6a1 1 0 110-2 1 1 0 010 2zm2-6H6V4c0-1.103.897-2 2-2s2 .897 2 2v3z"
});

function SvgLock2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ec({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ec);
}

function _extends$ed() { _extends$ed = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ed.apply(this, arguments); }

var _ref$ed = /*#__PURE__*/createElement("path", {
  d: "M13 7h-1V4a4 4 0 00-8 0v3H3c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM6 4c0-1.103.897-2 2-2s2 .897 2 2v3H6V4zm7 6l-5 .5 5 .5-5 .5 5 .5-5 .5 5 .5-5 .5 5 .5-5 .5 4.998.5H3.002L8 14.5 3 14l5-.5-5-.5 5-.5-5-.5 5-.5-5-.5 5-.5-5-.5 5-.5L3 9l5-.5L3.002 8h9.996L8 8.5l5 .5-5 .5 5 .5z"
});

function SvgLock3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ed({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ed);
}

function _extends$ee() { _extends$ee = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ee.apply(this, arguments); }

var _ref$ee = /*#__PURE__*/createElement("path", {
  d: "M9.25 7H9V4c0-1.654-1.346-3-3-3H4C2.346 1 1 2.346 1 4v3H.75a.753.753 0 00-.75.75v7.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-7.5A.753.753 0 009.25 7zM3 4c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v3H3V4z"
});

function SvgLock4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ee({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ee);
}

function _extends$ef() { _extends$ef = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ef.apply(this, arguments); }

var _ref$ef = /*#__PURE__*/createElement("path", {
  d: "M9.25 7H9V4c0-1.654-1.346-3-3-3H4C2.346 1 1 2.346 1 4v3H.75a.753.753 0 00-.75.75v7.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-7.5A.753.753 0 009.25 7zM6 14H4l.435-2.175a1 1 0 111.13 0L6 14zm1-7H3V4c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v3z"
});

function SvgLock5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ef({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ef);
}

function _extends$eg() { _extends$eg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eg.apply(this, arguments); }

var _ref$eg = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.391a6.608 6.608 0 00-4.615 11.34c.391-1.152 1.49-2.51 4.058-2.72V9.54C6.813 9.185 6.3 8.3 6.3 7.415v-.241c.006-1.308.098-2.333 1.716-2.333 1.618 0 1.71 1.025 1.715 2.333v.24c0 .886-.513 1.77-1.143 2.126v.471c2.54.104 3.708 1.427 4.16 2.587A6.608 6.608 0 008 1.391z"
});

function SvgLogin(props) {
  return /*#__PURE__*/createElement("svg", _extends$eg({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$eg);
}

function _extends$eh() { _extends$eh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eh.apply(this, arguments); }

var _ref$eh = /*#__PURE__*/createElement("path", {
  d: "M2 5h10v3l4-4-4-4v3H0v6h2zm12 6H4V8l-4 4 4 4v-3h12V7h-2z"
});

function SvgLoop(props) {
  return /*#__PURE__*/createElement("svg", _extends$eh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eh);
}

function _extends$ei() { _extends$ei = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ei.apply(this, arguments); }

var _ref$ei = /*#__PURE__*/createElement("path", {
  d: "M8 3.25a4.88 4.88 0 00-3.849 1.863l-1.2-.9a6.379 6.379 0 015.048-2.464v-1.75l2.5 2.5-2.5 2.5v-1.75zm0 9.5a4.88 4.88 0 003.849-1.863l1.2.9a6.379 6.379 0 01-5.048 2.464v1.75l-2.5-2.5 2.5-2.5v1.75zM3.15 8c0 1.568.78 2.961 1.98 3.827l-.9 1.2c-1.564-1.139-2.58-2.968-2.58-5.026H0l2.5-2.5 2.5 2.5H3.15zm11.2 0H16l-2.5 2.5L11 8h1.85c0-1.568-.78-2.961-1.98-3.827l.9-1.2c1.564 1.139 2.58 2.968 2.58 5.026z"
});

function SvgLoop2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ei({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ei);
}

function _extends$ej() { _extends$ej = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ej.apply(this, arguments); }

var _ref$ej = /*#__PURE__*/createElement("path", {
  d: "M13.901 2.599A8 8 0 000 8h1.5a6.5 6.5 0 0111.339-4.339L10.5 6H16V.5l-2.099 2.099zM14.5 8a6.5 6.5 0 01-11.339 4.339L5.5 10H0v5.5l2.099-2.099A8 8 0 0016 8h-1.5z"
});

function SvgLoop3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ej({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ej);
}

function _extends$ek() { _extends$ek = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ek.apply(this, arguments); }

var _ref$ek = /*#__PURE__*/createElement("path", {
  d: "M5 10V7h3L4 3 0 7h3v5h6l-2-2zm8-1V4H7l2 2h2v3H8l4 4 4-4z"
});

function SvgLoop4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ek({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ek);
}

function _extends$el() { _extends$el = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$el.apply(this, arguments); }

var _ref$el = /*#__PURE__*/createElement("path", {
  d: "M8 0a4 4 0 000 8v8h2V2h2v14h2V2h2V0H8zM0 11l4-4-4-4z"
});

function SvgLtr(props) {
  return /*#__PURE__*/createElement("svg", _extends$el({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$el);
}

function _extends$em() { _extends$em = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$em.apply(this, arguments); }

var _ref$em = /*#__PURE__*/createElement("path", {
  d: "M7 0a3 3 0 100 6v5h1V1h1v10h1V1h2V0H7z"
});

var _ref2$3d = /*#__PURE__*/createElement("path", {
  d: "M12 13v2.5l3-3-3-3V12H4v1z"
});

function SvgLtr2(props) {
  return /*#__PURE__*/createElement("svg", _extends$em({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$em, _ref2$3d);
}

function _extends$en() { _extends$en = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$en.apply(this, arguments); }

var _ref$en = /*#__PURE__*/createElement("path", {
  d: "M10.5 6h2a.5.5 0 000-1h-2a.5.5 0 000 1zM10.5 4h2a.5.5 0 000-1h-2a.5.5 0 000 1zM10.5 8h2a.5.5 0 000-1h-2a.5.5 0 000 1zM3.5 12h9a.5.5 0 000-1h-9a.5.5 0 000 1zM3.5 10h9a.5.5 0 000-1h-9a.5.5 0 000 1z"
});

var _ref2$3e = /*#__PURE__*/createElement("path", {
  d: "M14.5 0H3c-.638 0-1.138.177-1.485.525C1.17.872.996 1.369 1 2v13.5a.5.5 0 00.5.5h11a.5.5 0 00.5-.5V15h1.5a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM14 14H2V1.997c-.002-.357.074-.615.224-.767.152-.153.413-.231.776-.231h11v13z"
});

var _ref3$n = /*#__PURE__*/createElement("path", {
  d: "M8.5 2h-5c-.275 0-.5.225-.5.5v5c0 .275.225.5.5.5h5c.275 0 .5-.225.5-.5v-5c0-.275-.225-.5-.5-.5zM8 7H4V6a1 1 0 011-1h1a1 1 0 110-2 1 1 0 010 2h1a1 1 0 011 1v1z"
});

function SvgMagazine(props) {
  return /*#__PURE__*/createElement("svg", _extends$en({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$en, _ref2$3e, _ref3$n);
}

function _extends$eo() { _extends$eo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eo.apply(this, arguments); }

var _ref$eo = /*#__PURE__*/createElement("path", {
  d: "M4 3L2 1H1v1l2 2zm1-3h1v2H5zm4 5h2v1H9zm1-3V1H9L7 3l1 1zM0 5h2v1H0zm5 4h1v2H5zM1 9v1h1l2-2-1-1zm14.781 4.781L5.842 3.842a.752.752 0 00-1.061 0l-.939.939a.752.752 0 000 1.061l9.939 9.939a.752.752 0 001.061 0l.939-.939a.752.752 0 000-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z"
});

function SvgMagicWand(props) {
  return /*#__PURE__*/createElement("svg", _extends$eo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eo);
}

function _extends$ep() { _extends$ep = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ep.apply(this, arguments); }

var _ref$ep = /*#__PURE__*/createElement("path", {
  d: "M8.068 7.06l2.95-.917L8 4.009V0L4.767 2.329 1 1l1.329 3.767L0 8h4l2.143 3.018.917-2.95L14 16l2-2-7.932-6.94zm-1.745-.737l-.612 1.968-1.19-1.657H2.46l1.233-1.652-.662-1.952 1.952.662 1.652-1.233V4.52l1.657 1.19-1.968.612z"
});

function SvgMagicWand2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ep({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ep);
}

function _extends$eq() { _extends$eq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eq.apply(this, arguments); }

var _ref$eq = /*#__PURE__*/createElement("path", {
  d: "M6 6v4c0 1.103.897 2 2 2s2-.897 2-2V6h4v4a6 6 0 11-12 0V6h4zM14 2.75V5h-4V2.75c0-.413.338-.75.75-.75h2.5c.412 0 .75.337.75.75zM6 2.75V5H2V2.75c0-.413.337-.75.75-.75h2.5c.412 0 .75.337.75.75z"
});

function SvgMagnet(props) {
  return /*#__PURE__*/createElement("svg", _extends$eq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eq);
}

function _extends$er() { _extends$er = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$er.apply(this, arguments); }

var _ref$er = /*#__PURE__*/createElement("path", {
  d: "M14 0h-4l1 9a3 3 0 11-6 0l1-9H2L1 9a7 7 0 1014 0l-1-9zm-1.846 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-.611-4.154-1.721a5.834 5.834 0 01-1.72-4.095l.564-5.075h1.736l-.55 4.953v.062c0 1.102.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-.429 2.917-1.208a4.098 4.098 0 001.208-2.917v-.062l-.007-.062-.543-4.891h1.736l.564 5.075a5.838 5.838 0 01-1.72 4.095z"
});

function SvgMagnet2(props) {
  return /*#__PURE__*/createElement("svg", _extends$er({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$er);
}

function _extends$es() { _extends$es = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$es.apply(this, arguments); }

var _ref$es = /*#__PURE__*/createElement("path", {
  d: "M9.2 0c5.1 0 9.2 4.1 9.2 9.3 0 2.1-.7 4-1.9 5.6l5.4 5.3-1.7 1.8-5.4-5.4c-1.6 1.2-3.5 1.9-5.6 1.9-5.1 0-9.2-4.1-9.2-9.2S4.1 0 9.2 0zm0 2.5a6.7 6.7 0 100 13.4 6.7 6.7 0 000-13.4zM18 1.2c.7.8 1.4 1.7 1.9 2.7H37V1.2H18zm4.4 16l2.7 2.6H37v-2.6zm-1.2-8c0 1-.1 1.8-.3 2.7H37V9.2H21.2z"
});

function SvgMagnifierMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$es({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 22,
    viewBox: "0 0 37 22"
  }, props), _ref$es);
}

function _extends$et() { _extends$et = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$et.apply(this, arguments); }

var _ref$et = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  d: "M27.312 2.667c13.662 0 24.645 10.933 24.645 24.8 0 5.6-1.875 10.666-5.09 14.933l14.466 14.133-4.554 4.8-14.465-14.4C38.027 50.133 32.938 52 27.312 52 13.65 52 2.667 41.067 2.667 27.467c0-13.6 10.983-24.8 24.645-24.8zm0 6.666c-9.912 0-17.948 8-17.948 17.867S17.4 45.067 27.312 45.067s17.948-8 17.948-17.867S37.224 9.333 27.312 9.333z"
});

function SvgMagnifier(props) {
  return /*#__PURE__*/createElement("svg", _extends$et({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref$et);
}

function _extends$eu() { _extends$eu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eu.apply(this, arguments); }

var _ref$eu = /*#__PURE__*/createElement("path", {
  d: "M13.333 0H2.667A2.675 2.675 0 000 2.667v10.666C0 14.8 1.2 16 2.667 16h10.666C14.801 16 16 14.8 16 13.333V2.667A2.674 2.674 0 0013.333 0zM4 4h8c.143 0 .281.031.409.088L8 9.231 3.591 4.088A.982.982 0 014 4zm-1 7V5l.002-.063 2.932 3.421-2.9 2.9A.967.967 0 013 11zm9 1H4c-.088 0-.175-.012-.258-.034L6.588 9.12l1.413 1.648L9.414 9.12l2.846 2.846a.967.967 0 01-.258.034zm1-1c0 .088-.012.175-.034.258l-2.9-2.9 2.932-3.421L13 5v6z"
});

function SvgMail(props) {
  return /*#__PURE__*/createElement("svg", _extends$eu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eu);
}

function _extends$ev() { _extends$ev = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ev.apply(this, arguments); }

var _ref$ev = /*#__PURE__*/createElement("path", {
  d: "M13.333 0H2.667A2.675 2.675 0 000 2.667v10.666C0 14.801 1.2 16 2.667 16h10.666A2.674 2.674 0 0016 13.333V2.667C16 1.2 14.8 0 13.333 0zm0 2c.125 0 .243.036.344.099L7.999 6.793 2.322 2.099A.648.648 0 012.666 2h10.666zM2.667 14a.654.654 0 01-.089-.006l3.525-4.89-.457-.457L2 12.293V2.744L8 10l6-7.256v9.549l-3.646-3.646-.457.457 3.525 4.89a.65.65 0 01-.088.006H2.668z"
});

function SvgMail2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ev({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ev);
}

function _extends$ew() { _extends$ew = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ew.apply(this, arguments); }

var _ref$ew = /*#__PURE__*/createElement("path", {
  d: "M13.333 0H2.667A2.675 2.675 0 000 2.667v10.666C0 14.801 1.2 16 2.667 16h10.666A2.674 2.674 0 0016 13.333V2.667C16 1.2 14.8 0 13.333 0zM2.854 13.854l-1.207-1.207 4-4 .457.457-3.25 4.75zm-.458-10.75l.457-.457 5.146 4.146 5.146-4.146.457.457-5.604 6.604-5.604-6.604zm10.75 10.75l-3.25-4.75.457-.457 4 4-1.207 1.207z"
});

function SvgMail3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ew({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ew);
}

function _extends$ex() { _extends$ex = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ex.apply(this, arguments); }

var _ref$ex = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4 4h8c.143 0 .281.031.409.088L8 9.231 3.591 4.088A.982.982 0 014 4zm-1 7V5l.002-.063 2.932 3.421-2.9 2.9A.967.967 0 013 11zm9 1H4c-.088 0-.175-.012-.258-.034L6.588 9.12l1.413 1.648L9.414 9.12l2.846 2.846a.967.967 0 01-.258.034zm1-1c0 .088-.012.175-.034.258l-2.9-2.9 2.932-3.421L13 5v6z"
});

function SvgMail4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ex({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ex);
}

function _extends$ey() { _extends$ey = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ey.apply(this, arguments); }

var _ref$ey = /*#__PURE__*/createElement("path", {
  d: "M15.5 3h-6a.5.5 0 000 1H15v7H3V4h1.5a.5.5 0 000-1h-4a.5.5 0 00-.5.5v8a.5.5 0 00.5.5H5v3.5a.5.5 0 00.5.5h4a.5.5 0 00.5-.5V12h5.5a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5zM1 4h1v7H1V4zm8 11H6v-3h3v3z"
});

var _ref2$3f = /*#__PURE__*/createElement("path", {
  d: "M7.5 8A1.5 1.5 0 008 5.086V2h2V0H6v6.5A1.5 1.5 0 007.5 8z"
});

function SvgMailbox(props) {
  return /*#__PURE__*/createElement("svg", _extends$ey({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ey, _ref2$3f);
}

function _extends$ez() { _extends$ez = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ez.apply(this, arguments); }

var _ref$ez = /*#__PURE__*/createElement("path", {
  d: "M5 2H3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM11 6h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0-3h2v2h-2V3zM5 10H3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3H3v-2h2v2zM13 10h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
});

var _ref2$3g = /*#__PURE__*/createElement("path", {
  d: "M14 8h-1c-1.336 0-2.591-.52-3.536-1.464S8 4.336 8 3V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v4c0 1.1.9 2 2 2h1c1.336 0 2.591.52 3.536 1.464S8 11.664 8 13v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm1 6c0 .265-.105.515-.295.705S14.265 15 14 15h-4c-.265 0-.515-.105-.705-.295S9 14.265 9 14v-1a6 6 0 00-6-6H2c-.265 0-.515-.105-.705-.295S1 6.264 1 6V2c0-.265.105-.515.295-.705S1.735 1 2 1h4c.265 0 .515.105.705.295S7 1.735 7 2v1a6 6 0 006 6h1c.265 0 .515.105.705.295S15 9.735 15 10v4z"
});

function SvgMakeGroup(props) {
  return /*#__PURE__*/createElement("svg", _extends$ez({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ez, _ref2$3g);
}

function _extends$eA() { _extends$eA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eA.apply(this, arguments); }

var _ref$eA = /*#__PURE__*/createElement("path", {
  d: "M10 0v2h2.586L8.757 5.829a5 5 0 101.414 1.414L14 3.414V6h2V0h-6zM6 13.3a3.3 3.3 0 11-.001-6.599A3.3 3.3 0 016 13.3z"
});

function SvgMale(props) {
  return /*#__PURE__*/createElement("svg", _extends$eA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eA);
}

function _extends$eB() { _extends$eB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eB.apply(this, arguments); }

var _ref$eB = /*#__PURE__*/createElement("path", {
  d: "M4 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 1.5zM13 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 1.5zM4 4H1a1 1 0 00-1 1v5h1v6h1.25v-6h.5v6H4v-6h1V5a1 1 0 00-1-1zM15.234 8L16 7.445l-2.083-3.221a.5.5 0 00-.417-.225h-4a.497.497 0 00-.417.225L7 7.445 7.766 8l1.729-2.244.601 1.402-2.095 3.841h1.917l.333 5h1v-5h.5v5h1l.333-5h1.917l-2.095-3.842.601-1.402 1.729 2.244z"
});

function SvgManWoman(props) {
  return /*#__PURE__*/createElement("svg", _extends$eB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eB);
}

function _extends$eC() { _extends$eC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eC.apply(this, arguments); }

var _ref$eC = /*#__PURE__*/createElement("path", {
  d: "M9 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 1.5zM9 4H6a1 1 0 00-1 1v5h1v6h1.25v-6h.5v6H9v-6h1V5a1 1 0 00-1-1z"
});

function SvgMan(props) {
  return /*#__PURE__*/createElement("svg", _extends$eC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eC);
}

function _extends$eD() { _extends$eD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eD.apply(this, arguments); }

var _ref$eD = /*#__PURE__*/createElement("path", {
  d: "M5.5 2a3.5 3.5 0 00-2.872 5.5L5.5 11l2.872-3.5A3.5 3.5 0 005.5 2zm0 5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 015.5 7z"
});

var _ref2$3h = /*#__PURE__*/createElement("path", {
  d: "M15.5 0H.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM1 15v-1h8v-2H1V1h9v14H1zm14 0h-3v-1h3v1zm0-3h-3V1h3v11z"
});

function SvgMap(props) {
  return /*#__PURE__*/createElement("svg", _extends$eD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eD, _ref2$3h);
}

function _extends$eE() { _extends$eE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eE.apply(this, arguments); }

var _ref$eE = /*#__PURE__*/createElement("path", {
  d: "M12 2.5l-8-2L0 3v13l4-2.5 8 2 4-2.5V0l-4 2.5zm-1 11.719l-6-1.5V1.781l6 1.5v10.938z"
});

function SvgMap2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eE);
}

function _extends$eF() { _extends$eF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eF.apply(this, arguments); }

var _ref$eF = /*#__PURE__*/createElement("path", {
  d: "M12 2.5l-8-2L0 3v13l4-2.5 8 2 4-2.5V0l-4 2.5zM5 12.719V1.781l.125.031V12.75L5 12.719zm.375.094V1.875l.25.063v10.938l-.25-.063zm.5.125V2l.25.063v10.938l-.25-.063zm.5.125V2.125l.25.063v10.938l-.25-.063zm.5.125V2.25l.25.063v10.938l-.25-.063zm.5.125V2.375l.25.063v10.938l-.25-.063zm.5.125V2.5l.25.063v10.938l-.25-.063zm.5.125V2.625l.25.063v10.938l-.25-.063zm.5.125V2.75l.25.063v10.938l-.25-.063zm.5.125V2.875l.25.063v10.938l-.25-.063zm.5.125V3l.25.063v10.938l-.25-.063zm.5.125V3.125l.25.063v10.938l-.25-.063zm.625.156l-.125-.031V3.25l.125.031v10.938z"
});

function SvgMap3(props) {
  return /*#__PURE__*/createElement("svg", _extends$eF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eF);
}

function _extends$eG() { _extends$eG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eG.apply(this, arguments); }

var _ref$eG = /*#__PURE__*/createElement("path", {
  d: "M0 3l5-2v12l-5 2zM6 .5l5 3V15l-5-2.5zM12 3.5l4-3v12l-4 3z"
});

function SvgMap4(props) {
  return /*#__PURE__*/createElement("svg", _extends$eG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eG);
}

function _extends$eH() { _extends$eH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eH.apply(this, arguments); }

var _ref$eH = /*#__PURE__*/createElement("path", {
  d: "M10.5 3l-5-2L0 3v12l5.5-2 5 2 5.5-2V1l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6V2.277zM1 3.7l4-1.455v9.872l-4 1.454V3.699zm14 8.6l-4 1.455V3.883l4-1.455V12.3z"
});

function SvgMap5(props) {
  return /*#__PURE__*/createElement("svg", _extends$eH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eH);
}

function _extends$eI() { _extends$eI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eI.apply(this, arguments); }

var _ref$eI = /*#__PURE__*/createElement("path", {
  d: "M15.726 3.301c-.343-.829-.995-1.663-1.789-2.288C13.108.36 12.221 0 11.438 0c-.607 0-1.128.213-1.548.632L2.719 7.803a.7.7 0 00-.163.256L.043 14.703a.703.703 0 00.163.738l.352.352a.704.704 0 00.738.163l6.644-2.513a.704.704 0 00.256-.163l7.171-7.171c.694-.694.821-1.691.358-2.809zm-8.231 8.694L4.006 8.506l6-6 3.489 3.489-6 6z"
});

function SvgMarker(props) {
  return /*#__PURE__*/createElement("svg", _extends$eI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eI);
}

function _extends$eJ() { _extends$eJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eJ.apply(this, arguments); }

var _ref$eJ = /*#__PURE__*/createElement("path", {
  d: "M15.726 3.301c-.343-.829-.995-1.663-1.789-2.288C13.108.36 12.221 0 11.438 0c-.607 0-1.128.213-1.548.632L2.719 7.803a.7.7 0 00-.163.256L.043 14.703a.703.703 0 00.163.738l.352.352a.704.704 0 00.738.163l6.644-2.513a.704.704 0 00.256-.163l7.171-7.171c.694-.694.821-1.691.358-2.809zm-8.231 8.694L4.006 8.506l6-6 3.489 3.489-6 6zM8.625 14.875H16v-.25H8.875zM8.125 15.375H16v-.25H8.375zM7.625 15.875H16v-.25H7.875zM9.625 13.875H16v-.25H9.875zM9.125 14.375H16v-.25H9.375zM10.125 13.375H16v-.25h-5.625z"
});

function SvgMarker2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eJ);
}

function _extends$eK() { _extends$eK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eK.apply(this, arguments); }

var _ref$eK = /*#__PURE__*/createElement("path", {
  d: "M17 7V5h-2V3h-2v2h-2V3H9v2H7v2h2v2H7v2h2v2h2v-2h2v2h2v-2h2V9h-2V7h2zm-4 2h-2V7h2v2z"
});

var _ref2$3i = /*#__PURE__*/createElement("path", {
  d: "M8.707 1.707L7.293.293 0 7.586v.828l7.293 7.293 1.414-1.414L2.414 8zM15.293 1.707L16.707.293 24 7.586v.828l-7.293 7.293-1.414-1.414L21.586 8z"
});

function SvgMarkup(props) {
  return /*#__PURE__*/createElement("svg", _extends$eK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _ref$eK, _ref2$3i);
}

function _extends$eL() { _extends$eL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eL.apply(this, arguments); }

var _ref$eL = /*#__PURE__*/createElement("path", {
  d: "M11.321 6.116L14.14 0h-3.461L8.368 5.013a5.636 5.636 0 00-.738 0L5.319 0H1.858l2.819 6.116a5.5 5.5 0 108.821 4.384 5.49 5.49 0 00-2.179-4.384zM11.319 1h1.258l-2.111 4.581-.016-.005a5.41 5.41 0 00-1.057-.397l1.925-4.178zM3.422 1h1.259l1.925 4.178a5.41 5.41 0 00-1.057.397l-.016.005L3.422.999zM8 14.5a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$3j = /*#__PURE__*/createElement("path", {
  d: "M9.5 12H9V8.5a.5.5 0 00-.5-.5h-1a.5.5 0 000 1H8v3h-.5a.5.5 0 000 1h2a.5.5 0 000-1z"
});

function SvgMedalFirst(props) {
  return /*#__PURE__*/createElement("svg", _extends$eL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eL, _ref2$3j);
}

function _extends$eM() { _extends$eM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eM.apply(this, arguments); }

var _ref$eM = /*#__PURE__*/createElement("path", {
  d: "M11.321 6.116L14.14 0h-3.461L8.368 5.013a5.636 5.636 0 00-.738 0L5.319 0H1.858l2.819 6.116a5.5 5.5 0 108.821 4.384 5.49 5.49 0 00-2.179-4.384zM11.319 1h1.258l-2.111 4.581-.016-.005a5.41 5.41 0 00-1.057-.397l1.925-4.178zM3.422 1h1.259l1.925 4.178a5.41 5.41 0 00-1.057.397l-.016.005L3.422.999zM8 14.5a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$3k = /*#__PURE__*/createElement("path", {
  d: "M9.5 13h-3a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5H9V9H6.5a.5.5 0 010-1h3a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H7v1h2.5a.5.5 0 010 1z"
});

function SvgMedalSecond(props) {
  return /*#__PURE__*/createElement("svg", _extends$eM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eM, _ref2$3k);
}

function _extends$eN() { _extends$eN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eN.apply(this, arguments); }

var _ref$eN = /*#__PURE__*/createElement("path", {
  d: "M7.5 4.839l1.352 4.162h4.376l-3.541 2.572 1.352 4.162-3.541-2.572-3.541 2.572 1.352-4.162-3.541-2.572h4.377zM7 0h1v4H7V0z"
});

var _ref2$3l = /*#__PURE__*/createElement("path", {
  d: "M9 0v6.214L11 4.5V0zM6 0v6.214L4 4.5V0z"
});

function SvgMedalStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$eN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eN, _ref2$3l);
}

function _extends$eO() { _extends$eO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eO.apply(this, arguments); }

var _ref$eO = /*#__PURE__*/createElement("path", {
  d: "M11.321 6.116L14.14 0h-3.461L8.368 5.013a5.636 5.636 0 00-.738 0L5.319 0H1.858l2.819 6.116a5.5 5.5 0 108.821 4.384 5.49 5.49 0 00-2.179-4.384zM11.319 1h1.258l-2.111 4.581-.016-.005a5.41 5.41 0 00-1.057-.397l1.925-4.178zM3.422 1h1.259l1.925 4.178a5.41 5.41 0 00-1.057.397l-.016.005L3.422.999zM8 14.5a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$3m = /*#__PURE__*/createElement("path", {
  d: "M9.5 8h-3a.5.5 0 000 1H9v1H6.5a.5.5 0 000 1H9v1H6.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z"
});

function SvgMedalThird(props) {
  return /*#__PURE__*/createElement("svg", _extends$eO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eO, _ref2$3m);
}

function _extends$eP() { _extends$eP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eP.apply(this, arguments); }

var _ref$eP = /*#__PURE__*/createElement("path", {
  d: "M13 5a1.5 1.5 0 00-1.39-1.495A1.5 1.5 0 009.495 1.39a1.5 1.5 0 00-2.991 0 1.5 1.5 0 00-2.115 2.115 1.5 1.5 0 000 2.99A1.5 1.5 0 006 8.897V15.5l2-2 2 2V8.897a1.499 1.499 0 001.611-2.402 1.5 1.5 0 001.39-1.496zM8 8a3 3 0 110-6 3 3 0 010 6z"
});

function SvgMedal(props) {
  return /*#__PURE__*/createElement("svg", _extends$eP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eP);
}

function _extends$eQ() { _extends$eQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eQ.apply(this, arguments); }

var _ref$eQ = /*#__PURE__*/createElement("path", {
  d: "M11.321 6.116L14.14 0h-3.461L8.368 5.013a5.636 5.636 0 00-.738 0L5.319 0H1.858l2.819 6.116a5.5 5.5 0 108.821 4.384 5.49 5.49 0 00-2.179-4.384zM11.319 1h1.258l-2.111 4.581-.016-.005a5.41 5.41 0 00-1.057-.397l1.925-4.178zM3.422 1h1.259l1.925 4.178a5.41 5.41 0 00-1.057.397l-.016.005L3.422.999zM8 14.5a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$3n = /*#__PURE__*/createElement("path", {
  d: "M8 9.125c.758 0 1.375.617 1.375 1.375S8.758 11.875 8 11.875s-1.375-.617-1.375-1.375S7.242 9.125 8 9.125zM8 8a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
});

function SvgMedal2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eQ, _ref2$3n);
}

function _extends$eR() { _extends$eR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eR.apply(this, arguments); }

var _ref$eR = /*#__PURE__*/createElement("path", {
  d: "M16 13.5c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V9.286l-4 1.429v3.786c0 .828-.895 1.5-2 1.5s-2-.672-2-1.5.895-1.5 2-1.5c.364 0 .706.073 1 .201V9.001l6-2v6.5zM4.5 3C3.673 3 3 3.673 3 4.5S3.673 6 4.5 6 6 5.327 6 4.5 5.327 3 4.5 3z"
});

var _ref2$3o = /*#__PURE__*/createElement("path", {
  d: "M8.5 1H6.309L5.947.276A.5.5 0 005.5 0h-2a.5.5 0 00-.447.276L2.691 1H.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zm-4 6C3.122 7 2 5.878 2 4.5S3.122 2 4.5 2 7 3.122 7 4.5 5.879 7 4.5 7z"
});

function SvgMedia(props) {
  return /*#__PURE__*/createElement("svg", _extends$eR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eR, _ref2$3o);
}

function _extends$eS() { _extends$eS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eS.apply(this, arguments); }

var _ref$eS = /*#__PURE__*/createElement("path", {
  d: "M2 6H0v5h2v-1l2 .572V12.001c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-.286l5 1.429V3.858L2 7.001v-1zm3 4.857l1.998.571V12H5v-1.143zm9-7.286v9.857l2 .571v-11z"
});

function SvgMegaphone(props) {
  return /*#__PURE__*/createElement("svg", _extends$eS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eS);
}

function _extends$eT() { _extends$eT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eT.apply(this, arguments); }

var _ref$eT = /*#__PURE__*/createElement("path", {
  d: "M4 3l4 4 4-4zm8 11l-4-4-4 4z"
});

function SvgMenuClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$eT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eT);
}

function _extends$eU() { _extends$eU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eU.apply(this, arguments); }

var _ref$eU = /*#__PURE__*/createElement("path", {
  d: "M4 4l4 4 4-4zm8 9L8 9l-4 4z"
});

function SvgMenuClose2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eU);
}

function _extends$eV() { _extends$eV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eV.apply(this, arguments); }

var _ref$eV = /*#__PURE__*/createElement("path", {
  d: "M12 7L8 3 4 7zm-8 3l4 4 4-4z"
});

function SvgMenuOpen(props) {
  return /*#__PURE__*/createElement("svg", _extends$eV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eV);
}

function _extends$eW() { _extends$eW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eW.apply(this, arguments); }

var _ref$eW = /*#__PURE__*/createElement("path", {
  d: "M4 4l4 4 4-4zm0 5l4 4 4-4z"
});

function SvgMenuOpen2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eW);
}

function _extends$eX() { _extends$eX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eX.apply(this, arguments); }

var _ref$eX = /*#__PURE__*/createElement("path", {
  d: "M13 7a2 2 0 11.001 3.999A2 2 0 0113 7zM8 7a2 2 0 11.001 3.999A2 2 0 018 7zM3 7a2 2 0 11.001 3.999A2 2 0 013 7z"
});

function SvgMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$eX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$eX);
}

function _extends$eY() { _extends$eY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eY.apply(this, arguments); }

var _ref$eY = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v2H0V3zM0 7h14v2H0V7zM0 11h14v2H0v-2zM21.5 9l-3-3-3 3h6z"
});

function SvgMenu10(props) {
  return /*#__PURE__*/createElement("svg", _extends$eY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$eY);
}

function _extends$eZ() { _extends$eZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$eZ.apply(this, arguments); }

var _ref$eZ = /*#__PURE__*/createElement("path", {
  d: "M16 0H1C.45 0 0 .45 0 1v3c0 .55.45 1 1 1h2v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H5v-2h10v2zm0-3H5V9h10v2zm0-3H5V6h10v2zm-2-3l-2.5-3h5L13 5z"
});

function SvgMenu2(props) {
  return /*#__PURE__*/createElement("svg", _extends$eZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$eZ);
}

function _extends$e_() { _extends$e_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e_.apply(this, arguments); }

var _ref$e_ = /*#__PURE__*/createElement("path", {
  d: "M1 3h14v3H1zm0 4h14v3H1zm0 4h14v3H1z"
});

function SvgMenu3(props) {
  return /*#__PURE__*/createElement("svg", _extends$e_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$e_);
}

function _extends$e$() { _extends$e$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e$.apply(this, arguments); }

var _ref$e$ = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v3H0V3zm0 4h14v3H0V7zm0 4h14v3H0v-3zM15.5 9l3 3 3-3zM21.5 8l-3-3-3 3z"
});

function SvgMenu4(props) {
  return /*#__PURE__*/createElement("svg", _extends$e$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$e$);
}

function _extends$f0() { _extends$f0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f0.apply(this, arguments); }

var _ref$f0 = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v3H0V3zm0 4h14v3H0V7zm0 4h14v3H0v-3zM15.5 7l3 3 3-3z"
});

function SvgMenu5(props) {
  return /*#__PURE__*/createElement("svg", _extends$f0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$f0);
}

function _extends$f1() { _extends$f1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f1.apply(this, arguments); }

var _ref$f1 = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v3H0V3zm0 4h14v3H0V7zm0 4h14v3H0v-3zM15.5 10l3-3 3 3z"
});

function SvgMenu6(props) {
  return /*#__PURE__*/createElement("svg", _extends$f1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$f1);
}

function _extends$f2() { _extends$f2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f2.apply(this, arguments); }

var _ref$f2 = /*#__PURE__*/createElement("path", {
  d: "M1 3h14v2H1V3zM1 7h14v2H1V7zM1 11h14v2H1v-2z"
});

function SvgMenu7(props) {
  return /*#__PURE__*/createElement("svg", _extends$f2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f2);
}

function _extends$f3() { _extends$f3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f3.apply(this, arguments); }

var _ref$f3 = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v2H0V3zM0 7h14v2H0V7zM0 11h14v2H0v-2zM15.5 9l3 3 3-3h-6zM21.5 7l-3-3-3 3h6z"
});

function SvgMenu8(props) {
  return /*#__PURE__*/createElement("svg", _extends$f3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$f3);
}

function _extends$f4() { _extends$f4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f4.apply(this, arguments); }

var _ref$f4 = /*#__PURE__*/createElement("path", {
  d: "M0 3h14v2H0V3zM0 7h14v2H0V7zM0 11h14v2H0v-2zM15.5 7l3 3 3-3h-6z"
});

function SvgMenu9(props) {
  return /*#__PURE__*/createElement("svg", _extends$f4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$f4);
}

function _extends$f5() { _extends$f5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f5.apply(this, arguments); }

var _ref$f5 = /*#__PURE__*/createElement("path", {
  d: "M9 5h3.5L8 .5 3.5 5H7v3.586l-5.957 5.957 1.414 1.414L9 9.414zM8.543 11.957l1.414-1.414 4 4-1.414 1.414-4-4z"
});

function SvgMerge(props) {
  return /*#__PURE__*/createElement("svg", _extends$f5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f5);
}

function _extends$f6() { _extends$f6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f6.apply(this, arguments); }

var _ref$f6 = /*#__PURE__*/createElement("path", {
  d: "M8 4a8 8 0 00-8 8h1a6 6 0 0110.446-4.029L8.735 10.14a2 2 0 101.126 1.126l2.106-2.633A5.972 5.972 0 0113 12h3a8 8 0 00-8-8z"
});

function SvgMeterFast(props) {
  return /*#__PURE__*/createElement("svg", _extends$f6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f6);
}

function _extends$f7() { _extends$f7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f7.apply(this, arguments); }

var _ref$f7 = /*#__PURE__*/createElement("path", {
  d: "M8 4a8 8 0 00-8 8h1a6 6 0 016.446-5.983L7 10.268h.001a2 2 0 101.998 0H9l-.426-4.059A6.003 6.003 0 0113 12h3a8 8 0 00-8-8z"
});

function SvgMeterMedium(props) {
  return /*#__PURE__*/createElement("svg", _extends$f7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f7);
}

function _extends$f8() { _extends$f8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f8.apply(this, arguments); }

var _ref$f8 = /*#__PURE__*/createElement("path", {
  d: "M8 4a8 8 0 00-8 8h1c0-1.819.809-3.449 2.088-4.549l3.052 3.815a2 2 0 101.126-1.126L3.5 7.127A6 6 0 0113.001 12h3a8 8 0 00-8-8z"
});

function SvgMeterSlow(props) {
  return /*#__PURE__*/createElement("svg", _extends$f8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f8);
}

function _extends$f9() { _extends$f9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f9.apply(this, arguments); }

var _ref$f9 = /*#__PURE__*/createElement("path", {
  d: "M8 1a8 8 0 013.875 15h-7.75A8 8 0 018 1zm4.53 12.53A6.364 6.364 0 0014.406 9H13V8h1.329a6.346 6.346 0 00-.665-2H12V5h1.004a6.372 6.372 0 00-3.005-2.089V4h-1V2.671a6.506 6.506 0 00-2 0V4h-1V2.911A6.384 6.384 0 002.994 5h1.004v1H2.334a6.346 6.346 0 00-.665 2h1.329v1H1.592c0 1.711.666 3.32 1.876 4.53.167.167.343.324.524.47h3.006l.571-8h.857l.571 8h3.006c.182-.146.357-.303.524-.47z"
});

function SvgMeter(props) {
  return /*#__PURE__*/createElement("svg", _extends$f9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f9);
}

function _extends$fa() { _extends$fa = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fa.apply(this, arguments); }

var _ref$fa = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4.732 13.034a4.501 4.501 0 00-2.688-5.762 5.953 5.953 0 011.714-3.514c1.133-1.133 2.64-1.757 4.243-1.757s3.109.624 4.243 1.757a5.958 5.958 0 011.714 3.514 4.501 4.501 0 00-2.688 5.762c-.964.629-2.09.966-3.268.966s-2.304-.338-3.268-.966zm3.889-3.018A.502.502 0 019 10.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1a.5.5 0 01.379-.484L7.75 3h.5l.371 7.016z"
});

function SvgMeter2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fa);
}

function _extends$fb() { _extends$fb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fb.apply(this, arguments); }

var _ref$fb = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12zM7 4a1 1 0 112 0 1 1 0 01-2 0zm3 1a1 1 0 112 0 1 1 0 01-2 0zM4 5a1 1 0 112 0 1 1 0 01-2 0z"
});

var _ref2$3p = /*#__PURE__*/createElement("path", {
  d: "M8.25 6h-.5L7 11v1a1 1 0 002 0v-1l-.75-5z"
});

function SvgMeter3(props) {
  return /*#__PURE__*/createElement("svg", _extends$fb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fb, _ref2$3p);
}

function _extends$fc() { _extends$fc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fc.apply(this, arguments); }

var _ref$fc = /*#__PURE__*/createElement("path", {
  d: "M10 2.5a2.5 2.5 0 10-5 0v5.379l5-5V2.5zM4.018 8.86A3.571 3.571 0 014 8.5V7H3v1.5c0 .42.058.827.166 1.213l.853-.853zM11 8.5a3.5 3.5 0 01-6.117 2.324l.709-.709A2.5 2.5 0 009.999 8.5V5.707l4.01-4.01-.707-.707-3.303 3.303L.03 14.303l.707.707 3.437-3.478a4.492 4.492 0 002.825 1.441v2.028h-2v1h5v-1h-2v-2.028a4.5 4.5 0 004-4.472v-1.5h-1v1.5z"
});

function SvgMicOff(props) {
  return /*#__PURE__*/createElement("svg", _extends$fc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fc);
}

function _extends$fd() { _extends$fd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fd.apply(this, arguments); }

var _ref$fd = /*#__PURE__*/createElement("path", {
  d: "M10.735 1.765A3 3 0 005 3v4c0 .158.012.313.036.464l5.699-5.699zM3.824 8.676a4.47 4.47 0 01-.319-1.896.75.75 0 10-1.498-.072 5.968 5.968 0 00.689 3.096l1.128-1.128zM13.208 5.993a.75.75 0 00-.713.785A4.507 4.507 0 018 11.503c-.858 0-1.66-.241-2.343-.66l1.108-1.108A3 3 0 0011 7V5.5L15.5 1l-1-1L0 14.5l1 1 3.575-3.575A5.964 5.964 0 007 12.919V15a1 1 0 002 0v-2.081a6.012 6.012 0 004.993-6.213.75.75 0 00-.785-.713z"
});

function SvgMicOff2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fd);
}

function _extends$fe() { _extends$fe = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fe.apply(this, arguments); }

var _ref$fe = /*#__PURE__*/createElement("path", {
  d: "M7.5 11A2.5 2.5 0 0010 8.5v-6a2.5 2.5 0 10-5 0v6A2.5 2.5 0 007.5 11zM11 7v1.5a3.5 3.5 0 11-7 0V7H3v1.5a4.5 4.5 0 004 4.472V15H5v1h5v-1H8v-2.028A4.5 4.5 0 0012 8.5V7h-1z"
});

function SvgMic(props) {
  return /*#__PURE__*/createElement("svg", _extends$fe({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fe);
}

function _extends$ff() { _extends$ff = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ff.apply(this, arguments); }

var _ref$ff = /*#__PURE__*/createElement("path", {
  d: "M14 7a5.74 5.74 0 00-.007-.294.75.75 0 10-1.498.072A4.507 4.507 0 018 11.503 4.507 4.507 0 013.505 6.78a.75.75 0 10-1.498-.072A6.012 6.012 0 007 12.919V15a1 1 0 002 0v-2.081c2.834-.478 5-2.95 5-5.919z"
});

var _ref2$3q = /*#__PURE__*/createElement("path", {
  d: "M8 0a3 3 0 00-3 3v4a3 3 0 106 0V3a3 3 0 00-3-3z"
});

function SvgMic2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ff({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ff, _ref2$3q);
}

function _extends$fg() { _extends$fg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fg.apply(this, arguments); }

var _ref$fg = /*#__PURE__*/createElement("path", {
  d: "M14 7a5.74 5.74 0 00-.007-.294.75.75 0 10-1.498.072A4.507 4.507 0 018 11.503 4.507 4.507 0 013.505 6.78a.75.75 0 10-1.498-.072A6.012 6.012 0 007 12.919V15a1 1 0 002 0v-2.081c2.834-.478 5-2.95 5-5.919z"
});

var _ref2$3r = /*#__PURE__*/createElement("path", {
  d: "M8 1.5c.827 0 1.5.673 1.5 1.5v4c0 .827-.673 1.5-1.5 1.5S6.5 7.827 6.5 7V3c0-.827.673-1.5 1.5-1.5zM8 0a3 3 0 00-3 3v4a3 3 0 106 0V3a3 3 0 00-3-3z"
});

function SvgMic3(props) {
  return /*#__PURE__*/createElement("svg", _extends$fg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fg, _ref2$3r);
}

function _extends$fh() { _extends$fh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fh.apply(this, arguments); }

var _ref$fh = /*#__PURE__*/createElement("path", {
  d: "M4 9c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V6H4v3z"
});

var _ref2$3s = /*#__PURE__*/createElement("path", {
  d: "M14.5 5h-2a.5.5 0 000 1h.5v3c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V6h.5a.5.5 0 000-1h-2a.5.5 0 000 1H2v3c0 2.206 1.794 4 4 4h1v2H5.5a.5.5 0 000 1h5a.5.5 0 000-1H9v-2h1c2.206 0 4-1.794 4-4V6h.5a.5.5 0 000-1zM10 0H6C4.9 0 4 .9 4 2v3h8V2c0-1.1-.9-2-2-2zM5.5 3.75a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm1 2a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm1 2a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm1 2a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm1 2a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm1 2a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5z"
});

function SvgMic4(props) {
  return /*#__PURE__*/createElement("svg", _extends$fh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fh, _ref2$3s);
}

function _extends$fi() { _extends$fi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fi.apply(this, arguments); }

var _ref$fi = /*#__PURE__*/createElement("path", {
  d: "M7.158 5.251L0 14c0 1 1 2 2 2l8.749-7.158a5.01 5.01 0 01-3.591-3.591zM9.109 1.236a4 4 0 005.655 5.655 7.006 7.006 0 01-5.655-5.655z"
});

var _ref2$3t = /*#__PURE__*/createElement("path", {
  d: "M12 0c-.719 0-1.394.19-1.977.522a6.001 6.001 0 005.455 5.455A4 4 0 0012 0zm1.5 1a.5.5 0 110 1 .5.5 0 010-1zm-2 1a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm0-2a.5.5 0 110-1 .5.5 0 010 1z"
});

function SvgMic5(props) {
  return /*#__PURE__*/createElement("svg", _extends$fi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fi, _ref2$3t);
}

function _extends$fj() { _extends$fj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fj.apply(this, arguments); }

var _ref$fj = /*#__PURE__*/createElement("path", {
  d: "M8 14.5c-.811 0-1.587-.15-2.303-.422A2.989 2.989 0 005 16h6c0-.731-.262-1.401-.697-1.922A6.475 6.475 0 018 14.5zM10 9v2h1.354A4.47 4.47 0 018 12.5a4.47 4.47 0 01-3.182-1.318A4.47 4.47 0 013.5 8c0-1.135.448-2.236 1.212-3.069l3.674 2.858L9.614 6.21 1.629-.001 0 1.266l3.525 2.742A6.083 6.083 0 002 8a6 6 0 0011.197 3H16V9h-6z"
});

function SvgMicroscope(props) {
  return /*#__PURE__*/createElement("svg", _extends$fj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fj);
}

function _extends$fk() { _extends$fk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fk.apply(this, arguments); }

var _ref$fk = /*#__PURE__*/createElement("path", {
  d: "M14 6.502V6.5a.497.497 0 00-.084-.277L12 3.349V.5a.5.5 0 00-.5-.5h-8a.5.5 0 00-.5.5v2.849L1.086 6.22l-.001.001-.001.001A.497.497 0 001 6.499v9a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V6.502 6.5zM4 1h7v2H4V1zm-.232 3h6.798L9.233 6H2.435l1.333-2zM2 7h7v8H2V7zm8 8V6.651l1.5-2.25 1.5 2.25V15h-3z"
});

var _ref2$3u = /*#__PURE__*/createElement("path", {
  d: "M4 9h3v4H4V9z"
});

function SvgMilk(props) {
  return /*#__PURE__*/createElement("svg", _extends$fk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fk, _ref2$3u);
}

function _extends$fl() { _extends$fl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fl.apply(this, arguments); }

var _ref$fl = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12zM4 7h8v2H4z"
});

function SvgMinusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$fl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fl);
}

function _extends$fm() { _extends$fm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fm.apply(this, arguments); }

var _ref$fm = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm5 9H3V7h10v2z"
});

function SvgMinusCircle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fm);
}

function _extends$fn() { _extends$fn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fn.apply(this, arguments); }

var _ref$fn = /*#__PURE__*/createElement("path", {
  d: "M0 5h16v6H0z"
});

function SvgMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$fn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fn);
}

function _extends$fo() { _extends$fo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fo.apply(this, arguments); }

var _ref$fo = /*#__PURE__*/createElement("path", {
  d: "M0 6.5v3a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5z"
});

function SvgMinus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fo);
}

function _extends$fp() { _extends$fp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fp.apply(this, arguments); }

var _ref$fp = /*#__PURE__*/createElement("path", {
  d: "M1 7h14v2H1V7z"
});

function SvgMinus3(props) {
  return /*#__PURE__*/createElement("svg", _extends$fp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fp);
}

function _extends$fq() { _extends$fq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fq.apply(this, arguments); }

var _ref$fq = /*#__PURE__*/createElement("path", {
  d: "M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM6 .75h4v.5H6v-.5zM8 15a1 1 0 110-2 1 1 0 010 2zm4-3H4V2h8v10z"
});

function SvgMobile(props) {
  return /*#__PURE__*/createElement("svg", _extends$fq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fq);
}

function _extends$fr() { _extends$fr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fr.apply(this, arguments); }

var _ref$fr = /*#__PURE__*/createElement("path", {
  d: "M12 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7.5 15.278a.778.778 0 110-1.555.778.778 0 010 1.555zM12 13H3V2h9v11z"
});

function SvgMobile2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fr);
}

function _extends$fs() { _extends$fs = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fs.apply(this, arguments); }

var _ref$fs = /*#__PURE__*/createElement("path", {
  d: "M10.5 0a.5.5 0 00-.5.5V2H4.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h6a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM6 15H5v-1h1v1zm0-2H5v-1h1v1zm0-2H5v-1h1v1zm2 4H7v-1h1v1zm0-2H7v-1h1v1zm0-2H7v-1h1v1zm2 4H9v-1h1v1zm0-2H9v-1h1v1zm0-2H9v-1h1v1zm0-2H5V3h5v6z"
});

function SvgMobile3(props) {
  return /*#__PURE__*/createElement("svg", _extends$fs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fs);
}

function _extends$ft() { _extends$ft = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ft.apply(this, arguments); }

var _ref$ft = /*#__PURE__*/createElement("path", {
  d: "M11.185 1.008A8.014 8.014 0 008.223 0 8.035 8.035 0 01.798 12.861a8.033 8.033 0 0013.328-.88 8.034 8.034 0 00-2.94-10.974z"
});

function SvgMoon(props) {
  return /*#__PURE__*/createElement("svg", _extends$ft({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ft);
}

function _extends$fu() { _extends$fu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fu.apply(this, arguments); }

var _ref$fu = /*#__PURE__*/createElement("path", {
  d: "M6 1h4v4H6zm0 5h4v4H6zm0 5h4v4H6z"
});

function SvgMore(props) {
  return /*#__PURE__*/createElement("svg", _extends$fu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fu);
}

function _extends$fv() { _extends$fv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fv.apply(this, arguments); }

var _ref$fv = /*#__PURE__*/createElement("path", {
  d: "M6 3a2 2 0 113.999-.001A2 2 0 016 3zm0 5a2 2 0 113.999-.001A2 2 0 016 8zm0 5a2 2 0 113.999-.001A2 2 0 016 13z"
});

function SvgMore2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fv);
}

function _extends$fw() { _extends$fw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fw.apply(this, arguments); }

var _ref$fw = /*#__PURE__*/createElement("path", {
  d: "M17.81 15.213l-4.9-7a.499.499 0 00-.82 0l-1.04 1.486-3.14-4.486a.499.499 0 00-.82 0l-7 10A.5.5 0 00.5 16h16.9a.5.5 0 00.409-.787zM7.5 6.372L10.04 10H8.707l-.854-.854a.5.5 0 00-.707 0L6.292 10H4.959l2.54-3.628zM14.76 15l-3.128-4.468.037.026.83-1.186L16.439 15H14.76z"
});

function SvgMountains(props) {
  return /*#__PURE__*/createElement("svg", _extends$fw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$fw);
}

function _extends$fx() { _extends$fx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fx.apply(this, arguments); }

var _ref$fx = /*#__PURE__*/createElement("path", {
  d: "M7.5 1C6 1 3 1.584 3 4v6.625C3 13.041 5.015 15 7.5 15s4.5-1.959 4.5-4.375V4c0-2.416-3-3-4.5-3zm3.5 9.625c0 .896-.361 1.74-1.015 2.377a3.488 3.488 0 01-1.114.73c-.434.178-.895.269-1.371.269s-.938-.09-1.371-.269a3.51 3.51 0 01-1.114-.73A3.291 3.291 0 014 10.625V7h7v3.625zM11 6H8V2c.59.051 1.294.216 1.881.496.369.176.65.387.835.627.191.247.284.534.284.877v2z"
});

function SvgMouseLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$fx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fx);
}

function _extends$fy() { _extends$fy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fy.apply(this, arguments); }

var _ref$fy = /*#__PURE__*/createElement("path", {
  d: "M7.5 1C6 1 3 1.584 3 4v6.625C3 13.041 5.015 15 7.5 15s4.5-1.959 4.5-4.375V4c0-2.416-3-3-4.5-3zM4 4c0-.343.093-.63.284-.877.185-.24.466-.451.835-.627A5.722 5.722 0 017 2v4H4V4zm7 6.625c0 .896-.361 1.74-1.015 2.377a3.488 3.488 0 01-1.114.73c-.434.178-.895.269-1.371.269s-.938-.09-1.371-.269a3.51 3.51 0 01-1.114-.73A3.291 3.291 0 014 10.625V7h7v3.625z"
});

function SvgMouseRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$fy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fy);
}

function _extends$fz() { _extends$fz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fz.apply(this, arguments); }

var _ref$fz = /*#__PURE__*/createElement("path", {
  d: "M10 1.232V6H6V1.232C4.506 1.579 3 2.376 3 4v6.625C3 13.041 5.239 15 8 15s5-1.959 5-4.375V4c0-1.624-1.506-2.42-3-2.768zM9 1.06C8.634 1.018 8.291 1 8 1s-.634.018-1 .06V5h2V1.06z"
});

function SvgMouse(props) {
  return /*#__PURE__*/createElement("svg", _extends$fz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fz);
}

function _extends$fA() { _extends$fA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fA.apply(this, arguments); }

var _ref$fA = /*#__PURE__*/createElement("path", {
  d: "M12.43 9.942l-2.4-4a4 4 0 00-5.356-1.447C4.27 3.769 4 3.082 4 2.5c0-.546.118-1.255.683-1.526.043-.021.107-.052.171-.115a.5.5 0 00-.607-.785C3.443.462 3 1.323 3 2.5c0 .812.345 1.688.858 2.587a4.001 4.001 0 00-.688 4.971l2.4 4a3.998 3.998 0 005.488 1.372 4 4 0 001.372-5.488zm-5.053-.635a.86.86 0 01-1.187-.264L5.041 7.237a.858.858 0 111.45-.922L7.64 8.121c.255.4.137.932-.264 1.186z"
});

function SvgMouse2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fA);
}

function _extends$fB() { _extends$fB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fB.apply(this, arguments); }

var _ref$fB = /*#__PURE__*/createElement("path", {
  d: "M12 11V5h-1v6H8.5l3 3 3-3zM5 4v3H2V4h3zm1-1H1v5h5V3zM1 10h1.5v1H1v-1zM3 10h1.5v1H3v-1zM5 10h1v1.5H5V10zM1 13.5h1V15H1v-1.5zM2.5 14H4v1H2.5v-1zM4.5 14H6v1H4.5v-1zM1 11.5h1V13H1v-1.5zM5 12h1v1.5H5V12z"
});

function SvgMoveDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$fB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fB);
}

function _extends$fC() { _extends$fC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fC.apply(this, arguments); }

var _ref$fC = /*#__PURE__*/createElement("path", {
  d: "M11 8v6h1V8h2.5l-3-3-3 3zM1 3h1.5v1H1V3zM3 3h1.5v1H3V3zM5 3h1v1.5H5V3zM1 6.5h1V8H1V6.5zM2.5 7H4v1H2.5V7zM4.5 7H6v1H4.5V7zM1 4.5h1V6H1V4.5zM5 5h1v1.5H5V5zM5 11v3H2v-3h3zm1-1H1v5h5v-5z"
});

function SvgMoveUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$fC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fC);
}

function _extends$fD() { _extends$fD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fD.apply(this, arguments); }

var _ref$fD = /*#__PURE__*/createElement("path", {
  d: "M16 8l-4-3v2H9V4h2L8 0 5 4h2v3H4V5L0 8l4 3V9h3v3H5l3 4 3-4H9V9h3v2z"
});

function SvgMove(props) {
  return /*#__PURE__*/createElement("svg", _extends$fD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fD);
}

function _extends$fE() { _extends$fE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fE.apply(this, arguments); }

var _ref$fE = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 1.775a1.708 1.708 0 110 3.417 1.708 1.708 0 010-3.417zM1.806 6.48a1.708 1.708 0 113.417 0 1.708 1.708 0 01-3.417 0zm3.482 6.728a1.708 1.708 0 110-3.417 1.708 1.708 0 010 3.417zM8 9a1 1 0 110-2 1 1 0 010 2zm2.712 4.218a1.708 1.708 0 110-3.417 1.708 1.708 0 010 3.417zm1.774-5.02a1.708 1.708 0 110-3.417 1.708 1.708 0 010 3.417z"
});

function SvgMovie(props) {
  return /*#__PURE__*/createElement("svg", _extends$fE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fE);
}

function _extends$fF() { _extends$fF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fF.apply(this, arguments); }

var _ref$fF = /*#__PURE__*/createElement("path", {
  d: "M15 5h-3V3.5C12 2.119 9.314 1 6 1S0 2.119 0 3.5v10C0 14.881 2.686 16 6 16s6-1.119 6-2.5V12h3a1 1 0 001-1V6a1 1 0 00-1-1zM2.751 4.037c-.578-.19-.928-.394-1.116-.537.188-.143.538-.347 1.116-.537C3.656 2.665 4.81 2.5 6 2.5s2.344.164 3.249.463c.578.19.928.394 1.116.537-.188.143-.538.347-1.116.537C8.344 4.335 7.19 4.5 6 4.5s-2.344-.164-3.249-.463zM14 10h-2V7h2v3z"
});

function SvgMug(props) {
  return /*#__PURE__*/createElement("svg", _extends$fF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fF);
}

function _extends$fG() { _extends$fG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fG.apply(this, arguments); }

var _ref$fG = /*#__PURE__*/createElement("path", {
  d: "M15.5 16H6a.5.5 0 01-.424-.235l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L7 12.119V4.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3.11l5.621 1.405A.5.5 0 0116 9.5v6a.5.5 0 01-.5.5zm-9.223-1H15V9.89l-1-.25v2.86a.5.5 0 01-1 0V9.39l-1-.25v2.36a.5.5 0 01-1 0V8.89l-1-.25v3.86a.5.5 0 01-1 0V5H8v8.5a.5.5 0 01-.884.32l-2.212-2.655-.722.481 2.096 3.353z"
});

var _ref2$3v = /*#__PURE__*/createElement("path", {
  d: "M11.5 5a.5.5 0 01-.5-.5C11 3.122 9.878 2 8.5 2S6 3.122 6 4.5a.5.5 0 01-1 0C5 2.57 6.57 1 8.5 1S12 2.57 12 4.5a.5.5 0 01-.5.5zM2.5 14.663a.495.495 0 01-.214-.049A4.005 4.005 0 01.001 11a4.004 4.004 0 015.715-3.615.5.5 0 01-.429.903A3.004 3.004 0 001.002 11c0 1.152.673 2.217 1.715 2.712a.5.5 0 01-.215.952z"
});

function SvgMultitouch(props) {
  return /*#__PURE__*/createElement("svg", _extends$fG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fG, _ref2$3v);
}

function _extends$fH() { _extends$fH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fH.apply(this, arguments); }

var _ref$fH = /*#__PURE__*/createElement("path", {
  d: "M12.69 4.6c-1.36-1.91-1.232-.561-2.55-4.37L8.747 0l-1.55 11.452c-3.494-1.999-5.698.054-5.14 2.639.296 1.37 2.522 2.661 4.716 1.387 1.037-.623 1.37-1.628 1.502-2.341l1.107-8.498c3.951 3.484 2.69 5.592 1.873 8.019 1.68-.693 4.311-3.748 1.436-8.059z"
});

function SvgMusic(props) {
  return /*#__PURE__*/createElement("svg", _extends$fH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fH);
}

function _extends$fI() { _extends$fI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fI.apply(this, arguments); }

var _ref$fI = /*#__PURE__*/createElement("path", {
  d: "M5 3v8.241A4.689 4.689 0 003.5 11C1.567 11 0 12.119 0 13.5S1.567 16 3.5 16 7 14.881 7 13.5V8.763l7-1.909v2.387A4.689 4.689 0 0012.5 9C10.567 9 9 10.119 9 11.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5V0L5 3zm2 4.208V5.687l7-1.909v1.521L7 7.208z"
});

function SvgMusic2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fI);
}

function _extends$fJ() { _extends$fJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fJ.apply(this, arguments); }

var _ref$fJ = /*#__PURE__*/createElement("path", {
  d: "M5 3l11-3v11.5c0 1.381-1.567 2.5-3.5 2.5S9 12.881 9 11.5 10.567 9 12.5 9c.537 0 1.045.086 1.5.241v-5.15L7 6v7.5C7 14.881 5.433 16 3.5 16S0 14.881 0 13.5 1.567 11 3.5 11c.537 0 1.045.086 1.5.241V3z"
});

function SvgMusic3(props) {
  return /*#__PURE__*/createElement("svg", _extends$fJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fJ);
}

function _extends$fK() { _extends$fK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fK.apply(this, arguments); }

var _ref$fK = /*#__PURE__*/createElement("path", {
  d: "M15 0L6 2v9.751C5.365 11.288 4.479 11 3.5 11 1.567 11 0 12.119 0 13.5S1.567 16 3.5 16 7 14.881 7 13.5V7.04l8-1.778V9.75c-.635-.463-1.521-.751-2.5-.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-11.5h-1zm0 3.982L7 5.76V3.778L15 2v1.982z"
});

function SvgMusic4(props) {
  return /*#__PURE__*/createElement("svg", _extends$fK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fK);
}

function _extends$fL() { _extends$fL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fL.apply(this, arguments); }

var _ref$fL = /*#__PURE__*/createElement("path", {
  d: "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5S9 12.881 9 11.5 10.567 9 12.5 9c.979 0 1.865.287 2.5.751V4L7 5.778V13.5C7 14.881 5.433 16 3.5 16S0 14.881 0 13.5 1.567 11 3.5 11c.979 0 1.865.287 2.5.751V2l9-2z"
});

function SvgMusic5(props) {
  return /*#__PURE__*/createElement("svg", _extends$fL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fL);
}

function _extends$fM() { _extends$fM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fM.apply(this, arguments); }

var _ref$fM = /*#__PURE__*/createElement("path", {
  d: "M15 0L6 2v9.751C5.365 11.288 4.479 11 3.5 11 1.567 11 0 12.119 0 13.5S1.567 16 3.5 16 7 14.881 7 13.5V7.04l8-1.778V9.75c-.635-.463-1.521-.751-2.5-.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-11.5h-1zM3.5 14.813c-1.324 0-2.313-.693-2.313-1.313s.989-1.313 2.313-1.313 2.313.693 2.313 1.313-.989 1.313-2.313 1.313zm9-2c-1.324 0-2.313-.693-2.313-1.313s.989-1.313 2.313-1.313 2.313.693 2.313 1.313-.989 1.313-2.313 1.313zM15 3.982L7 5.76V3.778L15 2v1.982z"
});

function SvgMusic6(props) {
  return /*#__PURE__*/createElement("svg", _extends$fM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fM);
}

function _extends$fN() { _extends$fN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fN.apply(this, arguments); }

var _ref$fN = /*#__PURE__*/createElement("path", {
  d: "M14.645 8.021a.5.5 0 00-.561.201c-.327.491-.734.761-1.146.761-.408 0-.793-.271-.982-.689l-.007-.015c-.229-.509-.466-1.035-.815-1.462C10.692 6.275 10.142 6 9.5 6c-.817 0-1.544.394-2 1.002A2.497 2.497 0 005.5 6c-.642 0-1.192.275-1.634.817-.348.427-.586.953-.815 1.462l-.007.015c-.189.419-.574.689-.982.689-.412 0-.819-.27-1.146-.761A.5.5 0 000 8.5c0 1.074.419 1.978 1.212 2.615C1.923 11.686 2.913 12 4 12a4.22 4.22 0 002.807-1.064c.276-.245.508-.518.693-.809.185.291.417.564.693.809A4.22 4.22 0 0011 12c1.087 0 2.077-.314 2.788-.885C14.581 10.479 15 9.574 15 8.5a.5.5 0 00-.355-.479z"
});

function SvgMustache(props) {
  return /*#__PURE__*/createElement("svg", _extends$fN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fN);
}

function _extends$fO() { _extends$fO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fO.apply(this, arguments); }

var _ref$fO = /*#__PURE__*/createElement("path", {
  d: "M14.645 8.021a.5.5 0 00-.561.201c-.327.491-.734.761-1.146.761-.408 0-.793-.271-.982-.689l-.007-.015c-.229-.509-.466-1.035-.815-1.462C10.692 6.275 10.142 6 9.5 6c-.817 0-1.544.394-2 1.002A2.497 2.497 0 005.5 6c-.642 0-1.192.275-1.634.817-.348.427-.586.953-.815 1.462l-.007.015c-.189.419-.574.689-.982.689-.412 0-.819-.27-1.146-.761A.5.5 0 000 8.5c0 1.074.419 1.978 1.212 2.615C1.923 11.686 2.913 12 4 12a4.22 4.22 0 002.807-1.064c.276-.245.508-.518.693-.809.185.291.417.564.693.809A4.22 4.22 0 0011 12c1.087 0 2.077-.314 2.788-.885C14.581 10.479 15 9.574 15 8.5a.5.5 0 00-.355-.479zm-8.502 2.168A3.223 3.223 0 014 11c-1.331 0-2.146-.486-2.584-1.125.254.086.479.109.646.109.8 0 1.543-.502 1.894-1.278l.007-.015c.474-1.051.814-1.69 1.537-1.69.827 0 1.5.673 1.5 1.5 0 .589-.312 1.205-.857 1.689zM11 11a3.223 3.223 0 01-2.143-.811C8.312 9.705 8 9.09 8 8.5 8 7.673 8.673 7 9.5 7c.723 0 1.063.638 1.537 1.69l.007.015c.35.777 1.093 1.278 1.894 1.278.171 0 .404-.024.666-.116-.565.815-1.641 1.132-2.604 1.132z"
});

function SvgMustache2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fO);
}

function _extends$fP() { _extends$fP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fP.apply(this, arguments); }

var _ref$fP = /*#__PURE__*/createElement("path", {
  d: "M7 9H4V7h3V4h2v3h3v2H9v3H7zm9 1v6H0v-6h2v4h12v-4z"
});

function SvgNbsp(props) {
  return /*#__PURE__*/createElement("svg", _extends$fP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fP);
}

function _extends$fQ() { _extends$fQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fQ.apply(this, arguments); }

var _ref$fQ = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 102 0 1 1 0 00-2 0zm6 0a1 1 0 102 0 1 1 0 00-2 0zm-4 6h4v1H6v-1z"
});

function SvgNeutral(props) {
  return /*#__PURE__*/createElement("svg", _extends$fQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fQ);
}

function _extends$fR() { _extends$fR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fR.apply(this, arguments); }

var _ref$fR = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2 12H6v-1h4v1zm1-8a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2z"
});

function SvgNeutral2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fR);
}

function _extends$fS() { _extends$fS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fS.apply(this, arguments); }

var _ref$fS = /*#__PURE__*/createElement("path", {
  d: "M11 13H3V5h4.5l2-2H1v12h12V6.5l-2 2V13z"
});

var _ref2$3w = /*#__PURE__*/createElement("path", {
  d: "M16 0H9.5L12 2.5 4.5 10 6 11.5 13.5 4 16 6.5V0z"
});

function SvgNewTab(props) {
  return /*#__PURE__*/createElement("svg", _extends$fS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fS, _ref2$3w);
}

function _extends$fT() { _extends$fT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fT.apply(this, arguments); }

var _ref$fT = /*#__PURE__*/createElement("path", {
  d: "M3 1v12h12V1H3zm11 11H4V2h10v10zM2 14V3.5l-1-1V15h12.5l-1-1H2z"
});

var _ref2$3x = /*#__PURE__*/createElement("path", {
  d: "M5.5 4L8 6.5l-3 3L6.5 11l3-3 2.5 2.5V4z"
});

function SvgNewTab2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fT, _ref2$3x);
}

function _extends$fU() { _extends$fU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fU.apply(this, arguments); }

var _ref$fU = /*#__PURE__*/createElement("path", {
  d: "M14 3H2C.9 3 0 3.9 0 5v7c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H4L2 7.667V11H1V6h1l2 3.333V6h1v5zm4-4H7v1h2v1H7v1h2v1H6V6h3v1zm6 4h-1.5l-1-2-1 2H10V6h1v4l1-2h1l1 2V6h1v5z"
});

function SvgNew(props) {
  return /*#__PURE__*/createElement("svg", _extends$fU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fU);
}

function _extends$fV() { _extends$fV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fV.apply(this, arguments); }

var _ref$fV = /*#__PURE__*/createElement("path", {
  d: "M14 4V2H0v11a1 1 0 001 1h13.5a1.5 1.5 0 001.5-1.5V4h-2zm-1 9H1V3h12v10zM2 5h10v1H2zm6 2h4v1H8zm0 2h4v1H8zm0 2h3v1H8zM2 7h5v5H2z"
});

function SvgNewspaper(props) {
  return /*#__PURE__*/createElement("svg", _extends$fV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fV);
}

function _extends$fW() { _extends$fW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fW.apply(this, arguments); }

var _ref$fW = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
});

var _ref2$3y = /*#__PURE__*/createElement("path", {
  d: "M9 8L5 5v6zM11 5H9v6h2V5z"
});

function SvgNext(props) {
  return /*#__PURE__*/createElement("svg", _extends$fW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fW, _ref2$3y);
}

function _extends$fX() { _extends$fX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fX.apply(this, arguments); }

var _ref$fX = /*#__PURE__*/createElement("path", {
  d: "M12 2v12h-2V8.5l-5 5v-11l5 5V2z"
});

function SvgNext2(props) {
  return /*#__PURE__*/createElement("svg", _extends$fX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fX);
}

function _extends$fY() { _extends$fY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fY.apply(this, arguments); }

var _ref$fY = /*#__PURE__*/createElement("path", {
  d: "M13.5 1h-11a.5.5 0 00-.5.5V3H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1H1a1 1 0 000 2h1v1.5a.5.5 0 00.5.5h11c.827 0 1.5-.673 1.5-1.5v-12c0-.827-.673-1.5-1.5-1.5zM3 14a1 1 0 000-2v-1a1 1 0 000-2V8a1 1 0 000-2V5a1 1 0 000-2V2h2v13H3v-1z"
});

function SvgNotebook(props) {
  return /*#__PURE__*/createElement("svg", _extends$fY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fY);
}

function _extends$fZ() { _extends$fZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$fZ.apply(this, arguments); }

var _ref$fZ = /*#__PURE__*/createElement("path", {
  d: "M8 1.5c-1.736 0-3.369.676-4.596 1.904S1.5 6.264 1.5 8c0 1.736.676 3.369 1.904 4.596S6.264 14.5 8 14.5c1.736 0 3.369-.676 4.596-1.904S14.5 9.736 14.5 8c0-1.736-.676-3.369-1.904-4.596S9.736 1.5 8 1.5zM8 0a8 8 0 110 16A8 8 0 018 0zM7 11h2v2H7zm0-8h2v6H7z"
});

function SvgNotification(props) {
  return /*#__PURE__*/createElement("svg", _extends$fZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$fZ);
}

function _extends$f_() { _extends$f_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f_.apply(this, arguments); }

var _ref$f_ = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1 13H7v-2h2v2zm0-4H7V3h2v6z"
});

function SvgNotification2(props) {
  return /*#__PURE__*/createElement("svg", _extends$f_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f_);
}

function _extends$f$() { _extends$f$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f$.apply(this, arguments); }

var _ref$f$ = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm13 13h-2V5H8v8H3V3h10v10z"
});

function SvgNpm(props) {
  return /*#__PURE__*/createElement("svg", _extends$f$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$f$);
}

function _extends$g0() { _extends$g0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g0.apply(this, arguments); }

var _ref$g0 = /*#__PURE__*/createElement("path", {
  d: "M0 16h8V0H0v16zM5 2h2v2H5V2zm0 4h2v2H5V6zm0 4h2v2H5v-2zM1 2h2v2H1V2zm0 4h2v2H1V6zm0 4h2v2H1v-2zm8-5h7v1H9zm0 11h2v-4h3v4h2V7H9z"
});

function SvgOffice(props) {
  return /*#__PURE__*/createElement("svg", _extends$g0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g0);
}

function _extends$g1() { _extends$g1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g1.apply(this, arguments); }

var _ref$g1 = /*#__PURE__*/createElement("path", {
  d: "M11 14h4l1-2v4h-6v-3.347c2.049-.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973S2.5 3.649 2.5 7c0 2.572 1.451 4.77 3.5 5.653V16H0v-4l1 2h4v-.509C2.068 12.453 0 9.938 0 7c0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491V14z"
});

function SvgOmega(props) {
  return /*#__PURE__*/createElement("svg", _extends$g1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g1);
}

function _extends$g2() { _extends$g2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g2.apply(this, arguments); }

var _ref$g2 = /*#__PURE__*/createElement("path", {
  d: "M5.482 12.944c-.942-.235-1.466-.984-1.468-2.095 0-.355.025-.525.114-.754.217-.56.793-.982 1.55-1.138.377-.077.493-.16.493-.353 0-.06.045-.24.1-.399.249-.724.71-1.327 1.202-1.573.515-.258.776-.316 1.399-.313.886.005 1.327.197 1.945.846l.34.357.304-.105c1.473-.51 2.942.358 3.061 1.809l.032.397.29.104c.829.297 1.218.92 1.148 1.837-.046.599-.326 1.078-.77 1.315l-.209.112-4.638.009c-3.564.007-4.697-.006-4.893-.055zm-3.869-.663c-.565-.142-1.164-.67-1.445-1.273C.009 10.666 0 10.615 0 10.01c0-.576.014-.668.14-.954a2.141 2.141 0 011.422-1.21c.136-.036.263-.094.283-.128s.043-.221.05-.415c.045-1.206.794-2.269 1.839-2.61.565-.184 1.306-.202 1.92.058.195.082.173.1.585-.471.244-.338.705-.695 1.108-.909.435-.231.887-.337 1.428-.336 1.512.004 2.815 1.003 3.297 2.529.154.487.146.624-.035.628a3.144 3.144 0 00-.505.102l-.361.099-.329-.348c-.928-.98-2.441-1.192-3.728-.522a3.156 3.156 0 00-1.239 1.153c-.222.357-.506 1.024-.506 1.189 0 .117-.09.176-.474.309-1.189.412-1.883 1.364-1.882 2.582 0 .443.108.986.258 1.296.057.117.088.228.07.247-.046.049-1.525.032-1.73-.019z"
});

function SvgOnedrive(props) {
  return /*#__PURE__*/createElement("svg", _extends$g2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g2);
}

function _extends$g3() { _extends$g3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g3.apply(this, arguments); }

var _ref$g3 = /*#__PURE__*/createElement("path", {
  d: "M16 8c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966.3-4.597-.137 2.016-.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c.634-.438 2.547-1.137 4.597-.138A7.99 7.99 0 0116 8.001z"
});

var _ref2$3z = /*#__PURE__*/createElement("path", {
  d: "M5.366 3.491C4.482 4.535 3.91 6.078 3.872 7.813v.378c.038 1.731.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434a5.768 5.768 0 003.206-.978 7.984 7.984 0 01-5.715 2.025A8 8 0 018 0h.031a7.952 7.952 0 015.303 2.038 5.773 5.773 0 00-3.206-.981c-1.906 0-3.612.944-4.763 2.434z"
});

function SvgOpera(props) {
  return /*#__PURE__*/createElement("svg", _extends$g3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g3, _ref2$3z);
}

function _extends$g4() { _extends$g4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g4.apply(this, arguments); }

var _ref$g4 = /*#__PURE__*/createElement("path", {
  d: "M14.5 13h-4a.499.499 0 01-.457-.297L6.175 4H1.5a.5.5 0 010-1h5c.198 0 .377.116.457.297L10.825 12H14.5a.5.5 0 010 1zM14.5 4h-5a.5.5 0 010-1h5a.5.5 0 010 1z"
});

function SvgOpt(props) {
  return /*#__PURE__*/createElement("svg", _extends$g4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g4);
}

function _extends$g5() { _extends$g5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g5.apply(this, arguments); }

var _ref$g5 = /*#__PURE__*/createElement("path", {
  d: "M4 5h1v4H4zm7 0h1v3h-1zm.875-4h-7.75C1.665 2.365 0 4.988 0 8s1.665 5.635 4.125 7h7.75C14.335 13.635 16 11.012 16 8s-1.665-5.635-4.125-7zm-.268 13H4.393A6.99 6.99 0 011 8a6.99 6.99 0 013.393-6h7.214A6.99 6.99 0 0115 8a6.99 6.99 0 01-3.393 6zM8 10c-1.105 0-2 .448-2 1v2h4v-2c0-.552-.895-1-2-1z"
});

function SvgOutlet(props) {
  return /*#__PURE__*/createElement("svg", _extends$g5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g5);
}

function _extends$g6() { _extends$g6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g6.apply(this, arguments); }

var _ref$g6 = /*#__PURE__*/createElement("path", {
  d: "M11 0L1 2v11l3 3 10-2V3l-3-3zm-.247.814l2.363 2.363-8.232 1.646L2.521 2.46 10.753.814zM5 5.565l.125-.025v9.47L5 15.035v-9.47zm.375-.075l.25-.05v9.47l-.25.05V5.49zm.5-.1l.25-.05v9.47l-.25.05V5.39zm.5-.1l.25-.05v9.47l-.25.05V5.29zm.5-.1l.25-.05v9.47l-.25.05V5.19zm.5-.1l.25-.05v9.47l-.25.05V5.09zm.5-.1l.25-.05v9.47l-.25.05V4.99zm.5-.1l.25-.05v9.47l-.25.05V4.89zm.5-.1l.25-.05v9.47l-.25.05V4.79zm.5-.1l.25-.05v9.47l-.25.05V4.69zm.5-.1l.25-.05v9.47l-.25.05V4.59zm.5-.1l.25-.05v9.47l-.25.05V4.49zm.5-.1l.25-.05v9.47l-.25.05V4.39zm.5-.1l.25-.05v9.47l-.25.05V4.29zm.5-.1l.25-.05v9.47l-.25.05V4.19zm.5-.1l.25-.05v9.47l-.25.05V4.09zm.5-.1L13 3.965v9.47l-.125.025V3.99z"
});

function SvgPackage(props) {
  return /*#__PURE__*/createElement("svg", _extends$g6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g6);
}

function _extends$g7() { _extends$g7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g7.apply(this, arguments); }

var _ref$g7 = /*#__PURE__*/createElement("path", {
  d: "M15.074 2.794a8 8 0 100 10.412L10 8l5.074-5.206zM11 1.884a1.116 1.116 0 110 2.232 1.116 1.116 0 010-2.232z"
});

function SvgPacman(props) {
  return /*#__PURE__*/createElement("svg", _extends$g7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g7);
}

function _extends$g8() { _extends$g8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g8.apply(this, arguments); }

var _ref$g8 = /*#__PURE__*/createElement("path", {
  d: "M0 8h2v1H0zm3 0h3v1H3zm4 0h2v1H7zm3 0h3v1h-3zm4 0h2v1h-2zm-.25-8L14 7H2l.25-7h1.5L4 6h8l.25-6zM2.25 16L2 10h12l-.25 6h-1.5L12 12H4l-.25 4z"
});

function SvgPageBreak(props) {
  return /*#__PURE__*/createElement("svg", _extends$g8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g8);
}

function _extends$g9() { _extends$g9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g9.apply(this, arguments); }

var _ref$g9 = /*#__PURE__*/createElement("path", {
  d: "M0 8h2v1H0zm3 0h3v1H3zm4 0h2v1H7zm3 0h3v1h-3zm4 0h2v1h-2zm-.25-8L14 7H2l.25-7h.5L3 6h10l.25-6zM2.25 16L2 10h12l-.25 6h-.5L13 11H3l-.25 5z"
});

function SvgPageBreak2(props) {
  return /*#__PURE__*/createElement("svg", _extends$g9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g9);
}

function _extends$ga() { _extends$ga = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ga.apply(this, arguments); }

var _ref$ga = /*#__PURE__*/createElement("path", {
  d: "M4 6V0h12v6h-1V1H5v5zm12 3v7H4V9h1v6h10V9zM8 7h2v1H8zM5 7h2v1H5zm6 0h2v1h-2zm3 0h2v1h-2zM0 4.5l3 3-3 3z"
});

function SvgPagebreak(props) {
  return /*#__PURE__*/createElement("svg", _extends$ga({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ga);
}

function _extends$gb() { _extends$gb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gb.apply(this, arguments); }

var _ref$gb = /*#__PURE__*/createElement("path", {
  d: "M16 9V3h-3V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V4h2v4H6v2h-.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5H7V9h9zm-4-6H1V2h11v1z"
});

function SvgPaintFormat(props) {
  return /*#__PURE__*/createElement("svg", _extends$gb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gb);
}

function _extends$gc() { _extends$gc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gc.apply(this, arguments); }

var _ref$gc = /*#__PURE__*/createElement("path", {
  d: "M8.048 2C2.906 2 0 5.417 0 7.917c0 3.809 3.417 5.952 6.26 6.655s3.912-.586 3.866-2.072c-.055-1.805.846-1.828 1.485-1.764S16 11.666 16 8.792c0-3.557-2.81-6.791-7.952-6.791zM7 3a1 1 0 110 2 1 1 0 010-2zM2.5 9.008a.508.508 0 110-1.016.508.508 0 010 1.016zM4 7a1 1 0 110-2 1 1 0 010 2zm4 4c-1.105 0-2-.672-2-1.5S6.895 8 8 8s2 .672 2 1.5S9.105 11 8 11zm3.5-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0111.5 7z"
});

function SvgPalette(props) {
  return /*#__PURE__*/createElement("svg", _extends$gc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gc);
}

function _extends$gd() { _extends$gd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gd.apply(this, arguments); }

var _ref$gd = /*#__PURE__*/createElement("path", {
  d: "M8 2C3.582 2 0 5.134 0 9c0 2.592 1.61 4.855 4.003 6.065 1.35.667 2.504.182 1.692-.965-.434-.434-.695-.992-.695-1.6C5 11.119 6.343 10 8 10s3 1.119 3 2.5c0 .609-.261 1.167-.695 1.6-.812 1.146.342 1.632 1.692.965C14.39 13.855 16 11.592 16 9c0-3.866-3.582-7-8-7zm-6 8a1 1 0 110-2 1 1 0 010 2zm2-3.134c-.717.414-1.523.362-1.799-.116S2.283 5.548 3 5.134s1.523-.362 1.799.116S4.717 6.452 4 6.866zM8 6c-1.105 0-2-.672-2-1.5S6.895 3 8 3s2 .672 2 1.5S9.105 6 8 6zm4 .866c-.717-.414-1.075-1.138-.799-1.616s1.082-.53 1.799-.116 1.075 1.138.799 1.616-1.082.53-1.799.116zM14 10a1 1 0 110-2 1 1 0 010 2z"
});

function SvgPalette2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gd);
}

function _extends$ge() { _extends$ge = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ge.apply(this, arguments); }

var _ref$ge = /*#__PURE__*/createElement("path", {
  d: "M14.902 1.098a3.75 3.75 0 00-5.303 0l-8.5 8.5a3.75 3.75 0 005.303 5.303l8.5-8.5a3.75 3.75 0 000-5.303zM14.5 2a.5.5 0 110 1 .5.5 0 010-1zm-1-1a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM12.5 2a.5.5 0 110 1 .5.5 0 010-1zm-1-1a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM10.5 2a.5.5 0 110 1 .5.5 0 010-1zm-7 9a.5.5 0 110 1 .5.5 0 010-1zm1 1a.5.5 0 110 1 .5.5 0 010-1zm-2-2a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM1.5 11a.5.5 0 110 1 .5.5 0 010-1zm0 3a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1zm2.354-2.146a.498.498 0 01-.708 0l-3-3a.5.5 0 01.707-.707l3 3a.5.5 0 010 .707zm4-4a.498.498 0 01-.708 0l-3-3a.5.5 0 01.707-.707l3 3a.5.5 0 010 .707zM12.5 5a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1z"
});

function SvgPandage(props) {
  return /*#__PURE__*/createElement("svg", _extends$ge({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ge);
}

function _extends$gf() { _extends$gf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gf.apply(this, arguments); }

var _ref$gf = /*#__PURE__*/createElement("path", {
  d: "M14.902 1.098a3.75 3.75 0 00-5.303 0l-8.5 8.5a3.75 3.75 0 005.303 5.303l8.5-8.5a3.75 3.75 0 000-5.303zM14.5 2a.5.5 0 110 1 .5.5 0 010-1zm-1-1a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM12.5 2a.5.5 0 110 1 .5.5 0 010-1zm-1-1a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM10.5 2a.5.5 0 110 1 .5.5 0 010-1zm-7 9a.5.5 0 110 1 .5.5 0 010-1zm1 1a.5.5 0 110 1 .5.5 0 010-1zm-2-2a.5.5 0 110 1 .5.5 0 010-1zm.5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM1.5 11a.5.5 0 110 1 .5.5 0 010-1zm0 3a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1zm2.354-2.146a.498.498 0 01-.708 0l-3-3a.5.5 0 01.707-.707l3 3a.5.5 0 010 .707zm4-4a.498.498 0 01-.708 0l-3-3a.5.5 0 01.707-.707l3 3a.5.5 0 010 .707zM12.5 5a.5.5 0 110-1 .5.5 0 010 1zm1 1a.5.5 0 110-1 .5.5 0 010 1zm1-1a.5.5 0 110-1 .5.5 0 010 1zM1.99 7.293L7.293 1.99l-.891-.891C5.67.367 4.71.001 3.75.001S1.831.367 1.098 1.099a3.75 3.75 0 000 5.303l.891.891zM14.01 8.707L8.707 14.01l.891.891c.732.732 1.692 1.098 2.652 1.098s1.919-.366 2.652-1.098a3.75 3.75 0 000-5.303l-.891-.891z"
});

function SvgPandage2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gf);
}

function _extends$gg() { _extends$gg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gg.apply(this, arguments); }

var _ref$gg = /*#__PURE__*/createElement("path", {
  d: "M12.968 0H2.032L.965 16h4.966L7.499 5.383 9.067 16h4.966L12.966 0zM4 2H3V1h1v1zm3 0H5V1h2v1zm3 0H8V1h2v1zm2 0h-1V1h1v1z"
});

function SvgPants(props) {
  return /*#__PURE__*/createElement("svg", _extends$gg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gg);
}

function _extends$gh() { _extends$gh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gh.apply(this, arguments); }

var _ref$gh = /*#__PURE__*/createElement("path", {
  d: "M7 11l6.151 2.195L16 .736zm-2-.689L16 .736 0 8.649zm2 1.751V16l2.902-2.902z"
});

function SvgPaperplane(props) {
  return /*#__PURE__*/createElement("svg", _extends$gh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gh);
}

function _extends$gi() { _extends$gi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gi.apply(this, arguments); }

var _ref$gi = /*#__PURE__*/createElement("path", {
  d: "M0 3h16v1H0zm3 2h10v1H3zm0 4h10v1H3zm0 4h10v1H3zM0 7h16v1H0zm0 4h16v1H0z"
});

function SvgParagraphCenter(props) {
  return /*#__PURE__*/createElement("svg", _extends$gi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gi);
}

function _extends$gj() { _extends$gj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gj.apply(this, arguments); }

var _ref$gj = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm3 3h10v2H3zm0 6h10v2H3zM0 7h16v2H0zm0 6h16v2H0z"
});

function SvgParagraphCenter2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gj);
}

function _extends$gk() { _extends$gk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gk.apply(this, arguments); }

var _ref$gk = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm3 4h10v2H3zm0 8h10v2H3zM0 9h16v2H0z"
});

function SvgParagraphCenter3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gk);
}

function _extends$gl() { _extends$gl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gl.apply(this, arguments); }

var _ref$gl = /*#__PURE__*/createElement("path", {
  d: "M0 5h16v1H0zm0 4h16v1H0zm0 4h16v1H0zM0 3h16v1H0zm0 4h16v1H0zm0 4h16v1H0z"
});

function SvgParagraphJustify(props) {
  return /*#__PURE__*/createElement("svg", _extends$gl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gl);
}

function _extends$gm() { _extends$gm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gm.apply(this, arguments); }

var _ref$gm = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm0 3h16v2H0zm0 3h16v2H0zm0 3h16v2H0zm0 3h16v2H0z"
});

function SvgParagraphJustify2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gm);
}

function _extends$gn() { _extends$gn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gn.apply(this, arguments); }

var _ref$gn = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm0 8h16v2H0zm0-4h16v2H0zm0 8h16v2H0z"
});

function SvgParagraphJustify3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gn);
}

function _extends$go() { _extends$go = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$go.apply(this, arguments); }

var _ref$go = /*#__PURE__*/createElement("path", {
  d: "M0 3h16v1H0zm0 2h11v1H0zm0 2h16v1H0zm0 2h11v1H0zm0 2h16v1H0zm0 2h11v1H0z"
});

function SvgParagraphLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$go({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$go);
}

function _extends$gp() { _extends$gp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gp.apply(this, arguments); }

var _ref$gp = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm0 3h10v2H0zm0 6h10v2H0zm0-3h16v2H0zm0 6h16v2H0z"
});

function SvgParagraphLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gp);
}

function _extends$gq() { _extends$gq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gq.apply(this, arguments); }

var _ref$gq = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm0 4h10v2H0zm0 8h10v2H0zm0-4h16v2H0z"
});

function SvgParagraphLeft3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gq);
}

function _extends$gr() { _extends$gr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gr.apply(this, arguments); }

var _ref$gr = /*#__PURE__*/createElement("path", {
  d: "M0 3h16v1H0zm5 2h11v1H5zM0 7h16v1H0zm5 2h11v1H5zm-5 2h16v1H0zm5 2h11v1H5z"
});

function SvgParagraphRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$gr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gr);
}

function _extends$gs() { _extends$gs = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gs.apply(this, arguments); }

var _ref$gs = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 3h10v2H6zm0 6h10v2H6zM0 7h16v2H0zm0 6h16v2H0z"
});

function SvgParagraphRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gs);
}

function _extends$gt() { _extends$gt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gt.apply(this, arguments); }

var _ref$gt = /*#__PURE__*/createElement("path", {
  d: "M0 1h16v2H0zm6 4h10v2H6zm0 8h10v2H6zM0 9h16v2H0z"
});

function SvgParagraphRight3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gt);
}

function _extends$gu() { _extends$gu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gu.apply(this, arguments); }

var _ref$gu = /*#__PURE__*/createElement("path", {
  d: "M11 2H9V1c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H3v2h8V2zM8 2H6v-.998L6.002 1h1.996L8 1.002V2zm5 3V2.5c0-.275-.225-.5-.5-.5h-1v1h.5v2H6v7H2V3h.5V2h-1c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5H6v3h7l3-3V5h-3zm0 9.586V13h1.586L13 14.586zM15 12h-3v3H7V6h8v6z"
});

function SvgPaste(props) {
  return /*#__PURE__*/createElement("svg", _extends$gu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gu);
}

function _extends$gv() { _extends$gv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gv.apply(this, arguments); }

var _ref$gv = /*#__PURE__*/createElement("path", {
  d: "M13 5V2.5c0-.275-.225-.5-.5-.5H9V1c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H1.5c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5H6v3h7l3-3V5h-3zM6 1.002L6.002 1h1.996L8 1.002V2H6v-.998zM3 4V3h8v1H3zm10 10.586V13h1.586L13 14.586zM15 12h-3v3H7V6h8v6z"
});

function SvgPaste2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gv);
}

function _extends$gw() { _extends$gw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gw.apply(this, arguments); }

var _ref$gw = /*#__PURE__*/createElement("path", {
  d: "M8 8v2h.5L9 9h1v4h-.75v1h3.5v-1H12V9h1l.5 1h.5V8z"
});

var _ref2$3A = /*#__PURE__*/createElement("path", {
  d: "M13 5V2.5c0-.275-.225-.5-.5-.5H9V1c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H1.5c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5H6v3h10V5h-3zM6 1.002L6.002 1h1.996L8 1.002V2H6v-.998zM3 4V3h8v1H3zm12 11H7V6h8v9z"
});

function SvgPaste3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gw, _ref2$3A);
}

function _extends$gx() { _extends$gx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gx.apply(this, arguments); }

var _ref$gx = /*#__PURE__*/createElement("path", {
  d: "M11 2H9V1c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H3v2h8V2zM8 2H6v-.998L6.002 1h1.996L8 1.002V2zm5 3V2.5c0-.275-.225-.5-.5-.5h-1v1h.5v2H9L6 8v4H2V3h.5V2h-1c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5H6v3h10V5h-3zM9 6.414V8H7.414L9 6.414zM15 15H7V9h3V6h5v9z"
});

function SvgPaste4(props) {
  return /*#__PURE__*/createElement("svg", _extends$gx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gx);
}

function _extends$gy() { _extends$gy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gy.apply(this, arguments); }

var _ref$gy = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zM5 5h2v6H5zm4 0h2v6H9z"
});

function SvgPause(props) {
  return /*#__PURE__*/createElement("svg", _extends$gy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gy);
}

function _extends$gz() { _extends$gz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gz.apply(this, arguments); }

var _ref$gz = /*#__PURE__*/createElement("path", {
  d: "M2 2h5v12H2zm7 0h5v12H9z"
});

function SvgPause2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gz);
}

function _extends$gA() { _extends$gA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gA.apply(this, arguments); }

var _ref$gA = /*#__PURE__*/createElement("path", {
  d: "M8.349 8.625c-1.958 0-3.833.876-5.043 4.402s1.46 3.245 3.145 2.516c1.631-.705 2.252-.813 4.217.121 1.85.879 3.431-.038 2.771-1.965s-2.882-5.075-5.09-5.075zM4.645.681C3.529.948 2.939 2.465 3.327 4.069s1.608 2.689 2.724 2.422l.015-.004c1.116-.267 1.706-1.784 1.318-3.388-.167-.691-.488-1.285-.889-1.716C5.965.812 5.296.526 4.66.677l-.015.004zm6.466-.056C9.988.39 8.806 1.51 8.471 3.127c-.192.929-.063 1.82.296 2.454.265.469.655.798 1.133.898l.012.003c1.123.235 2.305-.885 2.64-2.502S12.247.862 11.123.627a.05.05 0 00-.012-.002zM.322 8.964c.617 1.427 1.918 2.239 2.905 1.812.565-.244.905-.841.977-1.574.054-.548-.043-1.173-.307-1.783l-.001-.002C3.279 5.99 1.978 5.178.991 5.605S-.296 7.534.321 8.962l.001.002zm12.452 1.561c.562.247 1.227.09 1.81-.354.439-.335.831-.832 1.098-1.445.621-1.426.326-2.932-.658-3.364l-.013-.006c-.985-.432-2.287.373-2.908 1.799s-.326 2.932.658 3.364l.013.006z"
});

function SvgPaw(props) {
  return /*#__PURE__*/createElement("svg", _extends$gA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gA);
}

function _extends$gB() { _extends$gB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gB.apply(this, arguments); }

var _ref$gB = /*#__PURE__*/createElement("path", {
  d: "M14.531 4.822c-.747 3.316-3.053 5.066-6.688 5.066H6.634l-.841 5.338H4.78l-.053.344a.374.374 0 00.369.431h2.588a.625.625 0 00.616-.525l.025-.131.488-3.091.031-.169a.622.622 0 01.616-.525h.384c2.506 0 4.469-1.019 5.044-3.963.216-1.119.134-2.069-.356-2.775z"
});

var _ref2$3B = /*#__PURE__*/createElement("path", {
  d: "M12.984 1.206C12.243.362 10.903 0 9.19 0H4.218c-.35 0-.65.253-.703.6L1.443 13.731a.427.427 0 00.422.494h3.072l.772-4.891-.025.153c.053-.347.35-.6.7-.6h1.459c2.866 0 5.109-1.162 5.766-4.531.019-.1.037-.197.05-.291.194-1.244 0-2.094-.675-2.859z"
});

function SvgPaypal(props) {
  return /*#__PURE__*/createElement("svg", _extends$gB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gB, _ref2$3B);
}

function _extends$gC() { _extends$gC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gC.apply(this, arguments); }

var _ref$gC = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm6.5 8a6.447 6.447 0 01-1.404 4.035L8.75 7.689V1.543a6.453 6.453 0 013.846 1.861A6.457 6.457 0 0114.5 8zm-7.25 6.457a6.434 6.434 0 01-3.285-1.361L7.25 9.811v4.646zm1.5-4.646l3.285 3.285a6.438 6.438 0 01-3.285 1.361V9.811zM3.404 3.404A6.453 6.453 0 017.25 1.543v6.146l-4.346 4.346A6.449 6.449 0 011.5 8c0-1.736.676-3.369 1.904-4.596z"
});

function SvgPeace(props) {
  return /*#__PURE__*/createElement("svg", _extends$gC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gC);
}

function _extends$gD() { _extends$gD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gD.apply(this, arguments); }

var _ref$gD = /*#__PURE__*/createElement("path", {
  d: "M17.5 6L13 1.5 14.5 0 19 4.5 17.5 6zm-4.75-3.25l3.5 3.5L14 12l-9 4-.646-.646 5.388-5.388a1 1 0 10-.707-.707l-5.388 5.388-.646-.646 4-9 5.75-2.25zM0 2h6v2H0V2z"
});

function SvgPenMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$gD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16"
  }, props), _ref$gD);
}

function _extends$gE() { _extends$gE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gE.apply(this, arguments); }

var _ref$gE = /*#__PURE__*/createElement("path", {
  d: "M17.5 6L13 1.5 14.5 0 19 4.5 17.5 6zm-4.75-3.25l3.5 3.5L14 12l-9 4-.646-.646 5.388-5.388a1 1 0 10-.707-.707l-5.388 5.388-.646-.646 4-9 5.75-2.25zM6 2H4V0H2v2H0v2h2v2h2V4h2z"
});

function SvgPenPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$gE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16"
  }, props), _ref$gE);
}

function _extends$gF() { _extends$gF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gF.apply(this, arguments); }

var _ref$gF = /*#__PURE__*/createElement("path", {
  d: "M14.5 6L10 1.5 11.5 0 16 4.5 14.5 6zM9.75 2.75l3.5 3.5L11 12l-9 4-.646-.646 5.388-5.388a1 1 0 10-.707-.707L.647 14.647l-.646-.646 4-9 5.75-2.25z"
});

function SvgPen(props) {
  return /*#__PURE__*/createElement("svg", _extends$gF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gF);
}

function _extends$gG() { _extends$gG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gG.apply(this, arguments); }

var _ref$gG = /*#__PURE__*/createElement("path", {
  d: "M15.909 4.561l-4.47-4.47c-.146-.146-.338-.113-.427.073l-.599 1.248 4.175 4.175 1.248-.599c.186-.089.219-.282.073-.427zM9.615 2.115L5.5 2.458c-.273.034-.501.092-.58.449v.001C3.804 8.268 0 13.499 0 13.499l.896.896 4.25-4.25a1.5 1.5 0 11.707.707l-4.25 4.25.896.896s5.231-3.804 10.591-4.92h.001c.357-.078.415-.306.449-.58l.343-4.115-4.269-4.269z"
});

function SvgPen2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gG);
}

function _extends$gH() { _extends$gH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gH.apply(this, arguments); }

var _ref$gH = /*#__PURE__*/createElement("path", {
  d: "M12 2H5l-.5-2h8zM12 3H5L3 7.5 7 16h1V7.914a1.5 1.5 0 111 0V16h1l4-8.5L12 3z"
});

function SvgPen3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gH);
}

function _extends$gI() { _extends$gI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gI.apply(this, arguments); }

var _ref$gI = /*#__PURE__*/createElement("path", {
  d: "M10.185 2.444L11 0H4l.815 2.444L2.5 8l4 8h2l4-8-2.315-5.556zM9.613 1L9.28 2H5.721l-.333-1h4.225zM8 14.764v-5.85a1.5 1.5 0 10-1 0v5.85L3.599 7.962 5.667 3h3.667l2.068 4.962-3.401 6.802z"
});

function SvgPen4(props) {
  return /*#__PURE__*/createElement("svg", _extends$gI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gI);
}

function _extends$gJ() { _extends$gJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gJ.apply(this, arguments); }

var _ref$gJ = /*#__PURE__*/createElement("path", {
  d: "M8.313 3.813a318.01 318.01 0 00-2.239 2.209C4.236 7.86-.079 12.979 0 15.999c3.02.08 8.139-4.236 9.977-6.074a318.01 318.01 0 002.209-2.239L8.313 3.813zm6.448-.623l-.282-.281L16 1.652 14.348 0l-1.257 1.521-.282-.282c-.872-.051-2.278.793-3.663 1.907l3.707 3.707c.419-.521.798-1.045 1.107-1.542.93.767.243 3.017-3.682 5.967L11 12c3.5-2.5 5.766-5.5 3.571-7.882.131-.346.205-.663.19-.928z"
});

function SvgPen5(props) {
  return /*#__PURE__*/createElement("svg", _extends$gJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gJ);
}

function _extends$gK() { _extends$gK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gK.apply(this, arguments); }

var _ref$gK = /*#__PURE__*/createElement("path", {
  d: "M16 2.5A2.5 2.5 0 0011.5 1l-9 9L6 13.5l9-9c.607-.456 1-1.182 1-2zM0 16l1.5-5L5 14.5z"
});

function SvgPen6(props) {
  return /*#__PURE__*/createElement("svg", _extends$gK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gK);
}

function _extends$gL() { _extends$gL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gL.apply(this, arguments); }

var _ref$gL = /*#__PURE__*/createElement("path", {
  d: "M3.899.221a.499.499 0 00-.832.003l-1.984 3A.502.502 0 001 3.5V15c0 .551.449 1 1 1h3c.551 0 1-.449 1-1V3.5a.506.506 0 00-.085-.279l-2.016-3zM3.092 2h.798L5 3.652V14H2V3.65L3.092 2z"
});

var _ref2$3C = /*#__PURE__*/createElement("path", {
  d: "M3.5 13a.5.5 0 00.5-.5v-8a.5.5 0 00-1 0v8a.5.5 0 00.5.5zM8 0v16h6V0H8zm5 2h-1v1h1v1h-2v1h2v1h-1v1h1v1h-2v1h2v1h-1v1h1v1h-2v1h2v2H9V1h4v1z"
});

function SvgPencilRuler(props) {
  return /*#__PURE__*/createElement("svg", _extends$gL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gL, _ref2$3C);
}

function _extends$gM() { _extends$gM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gM.apply(this, arguments); }

var _ref$gM = /*#__PURE__*/createElement("path", {
  d: "M13.5 0a2.5 2.5 0 012 4l-1 1L11 1.5l1-1c.418-.314.937-.5 1.5-.5zM1 11.5L0 16l4.5-1 9.25-9.25-3.5-3.5L1 11.5zm10.181-5.819l-7 7-.862-.862 7-7 .862.862z"
});

function SvgPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends$gM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gM);
}

function _extends$gN() { _extends$gN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gN.apply(this, arguments); }

var _ref$gN = /*#__PURE__*/createElement("path", {
  d: "M11.445.055L2.5 9 0 16l6.995-2.5 8.95-8.945c.5-2-2.5-5-4.5-4.5zM4.5 11l-1-1L12 1.5l1 1L4.5 11z"
});

function SvgPencil2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gN);
}

function _extends$gO() { _extends$gO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gO.apply(this, arguments); }

var _ref$gO = /*#__PURE__*/createElement("path", {
  d: "M11.91 0a1.94 1.94 0 00-.465.055L2.5 9 0 16l6.995-2.5 8.95-8.945C16.407 2.705 13.876 0 11.91 0zM6.525 12.025L3.972 9.472l7.5-7.5 2.555 2.555-7.502 7.498z"
});

function SvgPencil3(props) {
  return /*#__PURE__*/createElement("svg", _extends$gO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gO);
}

function _extends$gP() { _extends$gP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gP.apply(this, arguments); }

var _ref$gP = /*#__PURE__*/createElement("path", {
  d: "M11.445.055L2.5 9H4v1h1v1h1v1h1v1.495l8.945-8.939c.5-2-2.5-5-4.5-4.5zM6 13H5v-1H4v-1H3v-1h-.857L0 16l6-2.144z"
});

function SvgPencil4(props) {
  return /*#__PURE__*/createElement("svg", _extends$gP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gP);
}

function _extends$gQ() { _extends$gQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gQ.apply(this, arguments); }

var _ref$gQ = /*#__PURE__*/createElement("path", {
  d: "M12 8.5V14H2V4h5.5l2-2h-8C.675 2 0 2.675 0 3.5v11c0 .825.675 1.5 1.5 1.5h11c.825 0 1.5-.675 1.5-1.5v-8l-2 2z"
});

var _ref2$3D = /*#__PURE__*/createElement("path", {
  d: "M13.5 0L4 9.5V12h2.5L16 2.5C16 1 15 0 13.5 0z"
});

function SvgPencil5(props) {
  return /*#__PURE__*/createElement("svg", _extends$gQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gQ, _ref2$3D);
}

function _extends$gR() { _extends$gR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gR.apply(this, arguments); }

var _ref$gR = /*#__PURE__*/createElement("path", {
  d: "M6 10l2-1 7-7-1-1-7 7-1 2zm-1.48 3.548c-.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6V4l-6 6-1.217 2z"
});

function SvgPencil6(props) {
  return /*#__PURE__*/createElement("svg", _extends$gR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gR);
}

function _extends$gS() { _extends$gS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gS.apply(this, arguments); }

var _ref$gS = /*#__PURE__*/createElement("path", {
  d: "M12 8.5V14H2V4h5.5l2-2h-8C.675 2 0 2.675 0 3.5v11c0 .825.675 1.5 1.5 1.5h11c.825 0 1.5-.675 1.5-1.5v-8l-2 2z"
});

var _ref2$3E = /*#__PURE__*/createElement("path", {
  d: "M13.5 0L4 9.5V12h2.5L16 2.5C16 1 15 0 13.5 0zm-7 10l-.75-.75 7.5-7.5.75.75L6.5 10z"
});

function SvgPencil7(props) {
  return /*#__PURE__*/createElement("svg", _extends$gS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gS, _ref2$3E);
}

function _extends$gT() { _extends$gT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gT.apply(this, arguments); }

var _ref$gT = /*#__PURE__*/createElement("path", {
  d: "M10 10h1v2h-1v-2zM5 4h1v2H5V4z"
});

var _ref2$3F = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4 3.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-3zm8 9a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3zm-.056-8.655l-7 9a.56.56 0 01-.789.098.563.563 0 01-.099-.789l7-9a.563.563 0 01.888.69z"
});

function SvgPercent(props) {
  return /*#__PURE__*/createElement("svg", _extends$gT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gT, _ref2$3F);
}

function _extends$gU() { _extends$gU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gU.apply(this, arguments); }

var _ref$gU = /*#__PURE__*/createElement("path", {
  d: "M15.897 9c.125.867.207 2.053-.182 2.507-.643.751-4.714.751-4.714-.751 0-.756.67-1.252.027-2.003-.632-.738-1.766-.75-3.027-.751s-2.394.012-3.027.751c-.643.751.027 1.247.027 2.003 0 1.501-4.071 1.501-4.714.751C-.102 11.053-.02 9.867.105 9c.096-.579.339-1.203 1.118-2 1.168-1.09 2.935-1.98 6.716-2h.126c3.781.019 5.548.91 6.716 2 .778.797 1.022 1.421 1.118 2z"
});

function SvgPhoneHangUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$gU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gU);
}

function _extends$gV() { _extends$gV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gV.apply(this, arguments); }

var _ref$gV = /*#__PURE__*/createElement("path", {
  d: "M13.262 12.15c.529 0 1.814-.064 2.327-.652.258-.295.391-.744.409-1.372a8.173 8.173 0 00-.1-1.383l-.002-.013c-.132-.777-.502-1.436-1.2-2.137l-.02-.019c-.941-.862-2.473-1.847-6.025-1.962v-.011H7.348v.011c-3.552.115-5.084 1.1-6.025 1.962l-.02.019C.605 7.294.235 7.954.103 8.73l-.002.013a8.173 8.173 0 00-.1 1.383c.018.628.151 1.077.409 1.372.513.588 1.799.652 2.327.652.718 0 1.394-.108 1.903-.305 1.022-.396 1.175-1.059 1.175-1.419 0-.346-.103-.631-.186-.86-.127-.353-.136-.397.015-.57.417-.478 1.358-.479 2.355-.479s1.937 0 2.355.479c.151.173.142.218.015.57-.083.229-.186.514-.186.86 0 .36.153 1.023 1.175 1.419.509.197 1.185.305 1.903.306zM8 7.329c-1.218 0-2.477 0-3.249.886-.615.706-.378 1.362-.237 1.754.062.171.115.319.115.457 0 .182-.667.537-1.891.537-.799 0-1.324-.161-1.437-.25-.071-.095-.202-.581-.025-1.79.063-.369.217-.833.86-1.482.836-.762 2.254-1.634 5.809-1.652h.11c3.556.018 4.974.89 5.809 1.652.643.649.797 1.114.86 1.482.177 1.209.045 1.695-.025 1.79-.113.089-.638.25-1.437.25-1.223 0-1.891-.355-1.891-.537 0-.138.053-.286.115-.457.142-.392.379-1.049-.237-1.754-.772-.885-2.032-.886-3.25-.886z"
});

function SvgPhoneHangUp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gV);
}

function _extends$gW() { _extends$gW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gW.apply(this, arguments); }

var _ref$gW = /*#__PURE__*/createElement("path", {
  d: "M11.457 5.957L15 2.414 13.586 1l-3.543 3.543L8 2.5V8h5.5z"
});

var _ref2$3G = /*#__PURE__*/createElement("path", {
  d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
});

function SvgPhoneIncoming(props) {
  return /*#__PURE__*/createElement("svg", _extends$gW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gW, _ref2$3G);
}

function _extends$gX() { _extends$gX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gX.apply(this, arguments); }

var _ref$gX = /*#__PURE__*/createElement("path", {
  d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4S0 6 0 4c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zm.5-10a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.496 5H9.004V4h4.992v1z"
});

function SvgPhoneMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$gX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gX);
}

function _extends$gY() { _extends$gY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gY.apply(this, arguments); }

var _ref$gY = /*#__PURE__*/createElement("path", {
  d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4S0 6 0 4c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM9 3h6v2H9zm0 0h6v2H9z"
});

function SvgPhoneMinus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$gY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gY);
}

function _extends$gZ() { _extends$gZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$gZ.apply(this, arguments); }

var _ref$gZ = /*#__PURE__*/createElement("path", {
  d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
});

var _ref2$3H = /*#__PURE__*/createElement("path", {
  d: "M9.414 8l3.543-3.543L15 6.5V1H9.5l2.043 2.043L8 6.586z"
});

function SvgPhoneOutgoing(props) {
  return /*#__PURE__*/createElement("svg", _extends$gZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$gZ, _ref2$3H);
}

function _extends$g_() { _extends$g_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g_.apply(this, arguments); }

var _ref$g_ = /*#__PURE__*/createElement("path", {
  d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4S0 6 0 4c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zm.5-10a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm.5 5v1.996h-1V5H9.004V4H11V2.004h1V4h1.996v1H12z"
});

function SvgPhonePlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$g_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g_);
}

function _extends$g$() { _extends$g$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g$.apply(this, arguments); }

var _ref$g$ = /*#__PURE__*/createElement("path", {
  d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4S0 6 0 4c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zm4-5h-2v2h-2V5H9V3h2V1h2v2h2z"
});

function SvgPhonePlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$g$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$g$);
}

function _extends$h0() { _extends$h0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h0.apply(this, arguments); }

var _ref$h0 = /*#__PURE__*/createElement("path", {
  d: "M5.02 8.98C4.436 8.32 4 7.66 4 7c0-1 1-1 2-2S4 1 3 1 0 4 0 4c0 1.682 1.453 4.816 3.072 6.928L5.02 8.98zM11 10c-1 1-1 2-2 2-.649 0-1.299-.422-1.948-.991l6.728-6.728a.75.75 0 10-1.061-1.061l-11.5 11.5a.75.75 0 001.06 1.061l2.826-2.826c2.111 1.608 5.221 3.046 6.893 3.046 0 0 3-2 3-3s-3-4-4-3z"
});

function SvgPhoneSlash(props) {
  return /*#__PURE__*/createElement("svg", _extends$h0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h0);
}

function _extends$h1() { _extends$h1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h1.apply(this, arguments); }

var _ref$h1 = /*#__PURE__*/createElement("path", {
  d: "M12.614 16h-.189c-1.026 0-2.569-.48-4.234-1.316-1.627-.817-3.112-1.838-4.075-2.801S2.132 9.435 1.315 7.808C.479 6.143-.001 4.6-.001 3.574v-.189l.105-.157C.125 3.197.621 2.454 1.25 1.7 1.91.909 2.77 0 3.574 0c.694 0 1.555.696 2.006 1.111.346.319 1.194 1.161 1.58 2.092.408.986.054 1.549-.194 1.797-.427.427-.848.687-1.185.896-.531.328-.598.399-.598.629 0 .724.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c.23 0 .301-.067.629-.598.209-.338.469-.758.896-1.185a1.32 1.32 0 01.955-.381c.407 0 .871.156 1.379.463.402.243.827.579 1.23.971.337.328 1.436 1.464 1.436 2.339 0 .804-.908 1.664-1.7 2.324-.755.629-1.497 1.125-1.528 1.146l-.157.105zM1.257 3.759c.058.837.488 2.119 1.176 3.489C3.181 8.738 4.141 10.14 5 11s2.262 1.819 3.752 2.567c1.37.688 2.652 1.119 3.489 1.176.243-.169.725-.514 1.209-.913 1.139-.94 1.284-1.351 1.299-1.409-.028-.182-.368-.781-1.095-1.478-.747-.716-1.404-1.042-1.698-1.042-.038 0-.062.005-.072.015-.324.324-.524.647-.716.959-.345.558-.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-.956.633-1.347 1.191-1.692.312-.193.635-.392.959-.716.019-.019.033-.134-.046-.355-.165-.461-.631-1.093-1.215-1.648-.632-.602-1.107-.839-1.244-.862-.059.016-.471.162-1.415 1.306-.398.483-.739.96-.907 1.201z"
});

var _ref2$3I = /*#__PURE__*/createElement("path", {
  d: "M.75 16a.75.75 0 01-.53-1.281l11.5-11.5a.75.75 0 111.061 1.061l-11.5 11.5a.748.748 0 01-.53.22z"
});

function SvgPhoneSlash2(props) {
  return /*#__PURE__*/createElement("svg", _extends$h1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h1, _ref2$3I);
}

function _extends$h2() { _extends$h2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h2.apply(this, arguments); }

var _ref$h2 = /*#__PURE__*/createElement("path", {
  d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4S0 6 0 4c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM11.5 8a.5.5 0 01-.5-.5C11 6.122 9.879 5 8.5 5a.5.5 0 010-1C10.43 4 12 5.57 12 7.5a.5.5 0 01-.5.5z"
});

var _ref2$3J = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a.5.5 0 01-.5-.5C13 5.019 10.981 3 8.5 3a.5.5 0 010-1C11.533 2 14 4.467 14 7.5a.5.5 0 01-.5.5z"
});

var _ref3$o = /*#__PURE__*/createElement("path", {
  d: "M15.5 8a.5.5 0 01-.5-.5C15 3.916 12.084 1 8.5 1a.5.5 0 010-1c2.003 0 3.887.78 5.303 2.197S16 5.497 16 7.5a.5.5 0 01-.5.5z"
});

function SvgPhoneWave(props) {
  return /*#__PURE__*/createElement("svg", _extends$h2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h2, _ref2$3J, _ref3$o);
}

function _extends$h3() { _extends$h3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h3.apply(this, arguments); }

var _ref$h3 = /*#__PURE__*/createElement("path", {
  d: "M12.614 16h-.189c-1.026 0-2.569-.48-4.234-1.316-1.627-.817-3.112-1.838-4.075-2.801S2.132 9.435 1.315 7.808C.479 6.143-.001 4.6-.001 3.574v-.189l.105-.157C.125 3.197.621 2.454 1.25 1.7 1.91.909 2.77 0 3.574 0c.694 0 1.555.696 2.006 1.111.346.319 1.194 1.161 1.58 2.092.408.986.054 1.549-.194 1.797-.427.427-.848.687-1.185.896-.531.328-.598.399-.598.629 0 .724.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c.23 0 .301-.067.629-.598.209-.338.469-.758.896-1.185a1.32 1.32 0 01.955-.381c.407 0 .871.156 1.379.463.402.243.827.579 1.23.971.337.328 1.436 1.464 1.436 2.339 0 .804-.908 1.664-1.7 2.324-.755.629-1.497 1.125-1.528 1.146l-.157.105zM1.257 3.759c.058.837.488 2.119 1.176 3.489C3.181 8.738 4.141 10.14 5 11s2.262 1.819 3.752 2.567c1.37.688 2.652 1.119 3.489 1.176.243-.169.725-.514 1.209-.913 1.139-.94 1.284-1.351 1.299-1.409-.028-.182-.368-.781-1.095-1.478-.747-.716-1.404-1.042-1.698-1.042-.038 0-.062.005-.072.015-.324.324-.524.647-.716.959-.345.558-.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-.956.633-1.347 1.191-1.692.312-.193.635-.392.959-.716.019-.019.033-.134-.046-.355-.165-.461-.631-1.093-1.215-1.648-.632-.602-1.107-.839-1.244-.862-.059.016-.471.162-1.415 1.306-.398.483-.739.96-.907 1.201z"
});

var _ref2$3K = /*#__PURE__*/createElement("path", {
  d: "M11.5 8a.5.5 0 01-.5-.5C11 6.122 9.879 5 8.5 5a.5.5 0 010-1C10.43 4 12 5.57 12 7.5a.5.5 0 01-.5.5z"
});

var _ref3$p = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a.5.5 0 01-.5-.5C13 5.019 10.981 3 8.5 3a.5.5 0 010-1C11.533 2 14 4.467 14 7.5a.5.5 0 01-.5.5z"
});

var _ref4$2 = /*#__PURE__*/createElement("path", {
  d: "M15.5 8a.5.5 0 01-.5-.5C15 3.916 12.084 1 8.5 1a.5.5 0 010-1c2.003 0 3.887.78 5.303 2.197S16 5.497 16 7.5a.5.5 0 01-.5.5z"
});

function SvgPhoneWave2(props) {
  return /*#__PURE__*/createElement("svg", _extends$h3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h3, _ref2$3K, _ref3$p, _ref4$2);
}

function _extends$h4() { _extends$h4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h4.apply(this, arguments); }

var _ref$h4 = /*#__PURE__*/createElement("path", {
  d: "M15.095 2.763c-.444-.375-1.053-.702-1.809-.972-1.427-.51-3.305-.79-5.286-.79-1.981 0-3.859.281-5.286.79-.756.27-1.365.597-1.809.972C.157 3.395 0 4.056 0 4.5v1c0 .265.105.52.293.707l.5.5a1 1 0 001.078.221l2.5-1A1 1 0 005 5V3.256A16.932 16.932 0 018 3c1.059 0 2.085.089 3 .256V5c0 .409.249.777.629.928l2.5 1a1 1 0 001.078-.221l.5-.5A1 1 0 0016 5.5v-1c0-.444-.157-1.106-.905-1.737z"
});

var _ref2$3L = /*#__PURE__*/createElement("path", {
  d: "M14.931 12.44a18.358 18.358 0 00-1.006-2.618c-.904-1.872-2.426-2.821-4.426-2.821h-3c-2 0-3.522.949-4.426 2.821-.624 1.293-.99 2.565-1.006 2.618-.188.656-.085 1.311.281 1.797s.968.764 1.65.764h10c.683 0 1.284-.278 1.65-.764s.469-1.14.281-1.797zM8 13a2 2 0 11-.001-3.999A2 2 0 018 13z"
});

function SvgPhone(props) {
  return /*#__PURE__*/createElement("svg", _extends$h4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h4, _ref2$3L);
}

function _extends$h5() { _extends$h5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h5.apply(this, arguments); }

var _ref$h5 = /*#__PURE__*/createElement("path", {
  d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
});

function SvgPhone2(props) {
  return /*#__PURE__*/createElement("svg", _extends$h5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h5);
}

function _extends$h6() { _extends$h6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h6.apply(this, arguments); }

var _ref$h6 = /*#__PURE__*/createElement("path", {
  d: "M12.614 16h-.189c-1.026 0-2.569-.48-4.234-1.316-1.627-.817-3.112-1.838-4.075-2.801S2.132 9.435 1.315 7.808C.479 6.143-.001 4.6-.001 3.574v-.189l.105-.157C.125 3.197.621 2.454 1.25 1.7 1.91.909 2.77 0 3.574 0c.694 0 1.555.696 2.006 1.111.346.319 1.194 1.161 1.58 2.092.408.986.054 1.549-.194 1.797-.427.427-.848.687-1.185.896-.531.328-.598.399-.598.629 0 .724.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c.23 0 .301-.067.629-.598.209-.338.469-.758.896-1.185a1.32 1.32 0 01.955-.381c.407 0 .871.156 1.379.463.402.243.827.579 1.23.97.337.328 1.436 1.464 1.436 2.339 0 .804-.908 1.664-1.7 2.324-.755.629-1.497 1.125-1.528 1.146l-.157.105zM1.257 3.759c.058.837.488 2.119 1.176 3.489C3.181 8.738 4.141 10.14 5 11s2.262 1.819 3.752 2.567c1.37.688 2.652 1.119 3.489 1.176.243-.169.725-.514 1.209-.913 1.139-.94 1.284-1.351 1.299-1.409-.028-.182-.368-.781-1.095-1.477-.747-.716-1.404-1.042-1.698-1.042-.038 0-.062.005-.072.015-.324.324-.524.647-.716.959-.345.558-.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-.956.633-1.347 1.191-1.692.312-.193.635-.392.959-.716.019-.019.033-.134-.046-.355-.165-.461-.631-1.093-1.215-1.648-.632-.602-1.107-.839-1.244-.862-.059.016-.471.162-1.415 1.306-.398.483-.739.96-.907 1.201z"
});

function SvgPhone3(props) {
  return /*#__PURE__*/createElement("svg", _extends$h6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h6);
}

function _extends$h7() { _extends$h7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h7.apply(this, arguments); }

var _ref$h7 = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h15V0H0zm3 15H1V1h1v10h1v4zm4 0H4v-4h1V1h1v10h1v4zm4 0H8v-4h1V1h1v10h1v4zm3 0h-2v-4h1V1h1v14z"
});

function SvgPiano(props) {
  return /*#__PURE__*/createElement("svg", _extends$h7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h7);
}

function _extends$h8() { _extends$h8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h8.apply(this, arguments); }

var _ref$h8 = /*#__PURE__*/createElement("path", {
  d: "M7 9V2a7 7 0 106.262 3.869L7 9zm7.262-5.131A6.999 6.999 0 008 0v7l6.262-3.131z"
});

function SvgPieChart(props) {
  return /*#__PURE__*/createElement("svg", _extends$h8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h8);
}

function _extends$h9() { _extends$h9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h9.apply(this, arguments); }

var _ref$h9 = /*#__PURE__*/createElement("path", {
  d: "M7 2a7 7 0 107 7H7V2zm2-2v7h7a7 7 0 00-7-7z"
});

function SvgPieChart2(props) {
  return /*#__PURE__*/createElement("svg", _extends$h9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$h9);
}

function _extends$ha() { _extends$ha = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ha.apply(this, arguments); }

var _ref$ha = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4.609 14.125a7.27 7.27 0 01-.416-.25h7.613a7.27 7.27 0 01-.416.25H4.609zm6.286.25a6.878 6.878 0 01-.63.25h-4.53a6.878 6.878 0 01-.63-.25h5.789zm-7.061-.75a6.988 6.988 0 01-.318-.25h8.968c-.103.086-.209.17-.318.25H3.833zm-.857-.75h9.191l.25.25H3.233a7.516 7.516 0 01-.255-.25zm6.191-3l.25.25H1.329a7.17 7.17 0 01-.074-.25h7.913zm-7.978-.25a6.937 6.937 0 01-.054-.25h7.532l.25.25H1.19zm8.478.75l.25.25H1.51c-.033-.083-.066-.166-.096-.25h8.254zm.5.5l.25.25H1.735a7.162 7.162 0 01-.119-.25h8.551zm.5.5l.25.25H2.011a7.738 7.738 0 01-.145-.25h8.801zm.5.5l.25.25H2.345a6.19 6.19 0 01-.174-.25h8.998zm.5.5l.25.25H2.746a7.118 7.118 0 01-.21-.25h9.132zM8.293 9l.125.125H1.091A5.39 5.39 0 011.072 9h7.221zM8 1v7H1a7 7 0 017-7zM6.678 14.875h2.644a7.021 7.021 0 01-2.644 0z"
});

function SvgPieChart3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ha({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ha);
}

function _extends$hb() { _extends$hb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hb.apply(this, arguments); }

var _ref$hb = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 018 8H8V0zM7 .062A8.001 8.001 0 1015.938 9H7V.062zM5.735 1.375H6v.25h-.894c.206-.093.416-.177.63-.25zm-1.125.5H6v.25H4.194c.136-.088.275-.172.416-.25zm-.777.5H6v.25H3.516a7.56 7.56 0 01.317-.25zm-.601.5H6v.25H2.977c.083-.086.168-.169.255-.25zm-.486.5H6v.25H2.536c.068-.085.138-.168.21-.25zm-.401.5H6v.25H2.17a6.19 6.19 0 01.174-.25zm-.334.5H6v.25H1.867c.046-.084.094-.168.144-.25zm-.275.5H6v.25H1.617c.038-.084.077-.167.119-.25zm-.226.5H6v.25H1.415c.03-.084.062-.167.095-.25zm-.18.5H6v.25H1.255c.023-.084.048-.167.075-.25zm-.139.5H6v.25H1.136c.017-.084.035-.167.055-.25zm-.1.5H6v.25H1.055c.01-.084.022-.167.036-.25zm-.063.5H6v.25H1.01c.004-.084.01-.167.018-.25zM1 8l.001-.125H6v.25H1.002L1 8zm.01.375H6v.25H1.028a10.133 10.133 0 01-.018-.25zm.044.5H6v.25H1.09a6.834 6.834 0 01-.036-.25zm.081.5H6v.25H1.189a6.946 6.946 0 01-.055-.25zM8 15c-.449 0-.891-.042-1.324-.125h2.641A7.048 7.048 0 018 15zm2.261-.375H5.733a7.064 7.064 0 01-.458-.175c-.058-.024-.115-.05-.171-.075h5.788a6.838 6.838 0 01-.631.25zm1.129-.5H4.609a6.938 6.938 0 01-.416-.25h7.614a7.046 7.046 0 01-.416.25zm.777-.5H3.832a7.56 7.56 0 01-.317-.25h8.968c-.104.087-.209.17-.317.25zm.601-.5H3.233a6.036 6.036 0 01-.255-.25h10.046a7.516 7.516 0 01-.255.25zm.487-.5H2.746a7.118 7.118 0 01-.21-.25h10.929a7.118 7.118 0 01-.21.25zm.401-.5H2.344a7.43 7.43 0 01-.175-.25H13.83a6.19 6.19 0 01-.174.25zm.333-.5H2.01a6.216 6.216 0 01-.144-.25h12.268a6.238 6.238 0 01-.145.25zm.276-.5H1.735a7.162 7.162 0 01-.119-.25h12.768a6.324 6.324 0 01-.119.25zm.226-.5H1.51a5.842 5.842 0 01-.096-.25h13.173c-.03.084-.062.167-.096.25zM14.71 10a2.994 2.994 0 01-.039.125H1.328a10.308 10.308 0 01-.075-.25h4.746V10h8.71z"
});

function SvgPieChart4(props) {
  return /*#__PURE__*/createElement("svg", _extends$hb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hb);
}

function _extends$hc() { _extends$hc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hc.apply(this, arguments); }

var _ref$hc = /*#__PURE__*/createElement("path", {
  d: "M7 9V.062A8.001 8.001 0 1015.938 9H7zm5.65 4.233A6.987 6.987 0 018 15a6.959 6.959 0 01-4.949-2.051 7.003 7.003 0 01-1.501-2.225A6.95 6.95 0 011 8a6.998 6.998 0 015-6.71V10h8.71a7.01 7.01 0 01-2.06 3.233zM8 0a8 8 0 018 8H8V0z"
});

function SvgPieChart5(props) {
  return /*#__PURE__*/createElement("svg", _extends$hc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hc);
}

function _extends$hd() { _extends$hd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hd.apply(this, arguments); }

var _ref$hd = /*#__PURE__*/createElement("path", {
  d: "M7 .062V9h8.938A8.001 8.001 0 117 .062zM8 0v8h8a8 8 0 00-8-8zm1 6.875h5.91l.019.125h-5.93v-.125zm1.267-5.5c.154.053.307.111.457.175.058.024.115.05.171.075H8.999v-.25h1.267zM9 1.125V1.07c.109.016.218.034.327.055H9zm2.392.75c.142.079.281.162.416.25H9v-.25h2.392zm.776.5c.108.08.213.164.317.25H9v-.25h3.168zm.599.5a5.01 5.01 0 01.255.25H8.999v-.25h3.767zm.487.5c.072.082.142.165.21.25H8.999v-.25h4.254zm.402.5c.06.082.118.165.175.25H9v-.25h4.656zm.334.5c.05.082.098.166.144.25H9v-.25h4.99zm.275.5c.041.082.081.166.119.25H8.999v-.25h5.265zm.226.5c.034.083.065.166.096.25H9v-.25h5.491zm.181.5c.026.083.051.166.075.25H9v-.25h5.672zm.139.5c.02.083.038.166.055.25H9.001v-.25h5.811z"
});

function SvgPieChart6(props) {
  return /*#__PURE__*/createElement("svg", _extends$hd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hd);
}

function _extends$he() { _extends$he = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$he.apply(this, arguments); }

var _ref$he = /*#__PURE__*/createElement("path", {
  d: "M7 9V.062A8.001 8.001 0 1015.938 9H7z"
});

var _ref2$3M = /*#__PURE__*/createElement("path", {
  d: "M8 8h8a8 8 0 00-8-8v8z"
});

function SvgPieChart7(props) {
  return /*#__PURE__*/createElement("svg", _extends$he({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$he, _ref2$3M);
}

function _extends$hf() { _extends$hf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hf.apply(this, arguments); }

var _ref$hf = /*#__PURE__*/createElement("path", {
  d: "M15.25 3c.412 0 .75-.337.75-.75V.75a.753.753 0 00-.75-.75h-1.5a.753.753 0 00-.75.75V1H3V.75A.752.752 0 002.25 0H.75A.753.753 0 000 .75v1.5c0 .413.338.75.75.75H1v10H.75a.753.753 0 00-.75.75v1.5c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75V15h10v.25c0 .412.338.75.75.75h1.5c.412 0 .75-.338.75-.75v-1.5a.753.753 0 00-.75-.75H15V3h.25zM14 1h1v1h-1V1zM1 1h1v1H1V1zm1 14H1v-1h1v1zm13 0h-1v-1h1v1zm-1-2h-.25a.753.753 0 00-.75.75V14H3v-.25a.752.752 0 00-.75-.75H2V3h.25c.413 0 .75-.337.75-.75V2h10v.25c0 .413.338.75.75.75H14v10zM8 4v4h4a4 4 0 00-4-4zM7 9V4.126A4.002 4.002 0 008 12a4.002 4.002 0 003.874-3H7z"
});

function SvgPieChart8(props) {
  return /*#__PURE__*/createElement("svg", _extends$hf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hf);
}

function _extends$hg() { _extends$hg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hg.apply(this, arguments); }

var _ref$hg = /*#__PURE__*/createElement("path", {
  d: "M15.023 6H13.5a5.188 5.188 0 00-1.562-1.772 1.74 1.74 0 01.648-1.337.5.5 0 00-.288-.887 2.003 2.003 0 00-2.011 1.374A7.018 7.018 0 008 3.001c-3.243 0-5.885 2.145-5.996 4.825-.059-.002-.118-.002-.179-.002-.682.011-.782-.792-.815-1.328-.065-.597-.967-.606-1 .01-.116.385.01.983.122 1.346.262.851.998 1.255 1.834 1.328a.72.72 0 00.198-.013 4.668 4.668 0 001.035 1.834c.041.045.083.09.126.134.225.265.674.912.674 1.866v1c0 .552.672 1 1.5 1s1.5-.448 1.5-1v-1.07a7.289 7.289 0 002 0v1.07c0 .552.672 1 1.5 1s1.5-.448 1.5-1v-1c0-.954.449-1.601.674-1.866a4.896 4.896 0 00.826-1.134h1.523c.552 0 1-.895 1-2s-.448-2-1-2zM9.5 5h-3a.5.5 0 010-1h3a.5.5 0 010 1zM12 8a1 1 0 110-2 1 1 0 010 2z"
});

function SvgPiggyBank(props) {
  return /*#__PURE__*/createElement("svg", _extends$hg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hg);
}

function _extends$hh() { _extends$hh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hh.apply(this, arguments); }

var _ref$hh = /*#__PURE__*/createElement("path", {
  d: "M6 0h8v2h-2v14h-2V2H8v14H6V8a4 4 0 010-8z"
});

function SvgPilcrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$hh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hh);
}

function _extends$hi() { _extends$hi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hi.apply(this, arguments); }

var _ref$hi = /*#__PURE__*/createElement("path", {
  d: "M14.682 1.318C13.803.439 12.652 0 11.5 0S9.197.439 8.318 1.318l-7 7a4.5 4.5 0 006.364 6.364l7-7a4.5 4.5 0 000-6.364zM7.146 4.146l2-2a.5.5 0 01.707.707l-2 2a.498.498 0 01-.708 0 .5.5 0 010-.707zm-.392 9.608c-.602.602-1.402.934-2.254.934s-1.652-.332-2.254-.934c-.602-.602-.934-1.402-.934-2.254s.332-1.652.934-2.254l3.25-3.25 4.508 4.508-3.25 3.25z"
});

function SvgPill(props) {
  return /*#__PURE__*/createElement("svg", _extends$hi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hi);
}

function _extends$hj() { _extends$hj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hj.apply(this, arguments); }

var _ref$hj = /*#__PURE__*/createElement("path", {
  d: "M15 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0115 1.5zM15.16 13.287L12.181 10.5c-.496-.39-.343-.5-.146-1l.001-.003c.95-2.098.466-4.772-1.392-6.63-1.238-1.238-2.839-1.866-4.39-1.866-1.384 0-2.729.5-3.742 1.513-2.148 2.148-1.99 5.789.354 8.132 1.238 1.238 2.839 1.866 4.39 1.866.776 0 1.54-.157 2.239-.474l.005-.002c.249-.098.404-.181.543-.181.141 0 .266.085.457.327l2.787 2.979a.66.66 0 00.521.262.67.67 0 00.473-.202l.939-.939a.651.651 0 00-.059-.994zM5.114 10.886l5.771-5.771c.172.356.301.729.386 1.114l-5.045 5.045a5.025 5.025 0 01-1.113-.387z"
});

function SvgPingpong(props) {
  return /*#__PURE__*/createElement("svg", _extends$hj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hj);
}

function _extends$hk() { _extends$hk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hk.apply(this, arguments); }

var _ref$hk = /*#__PURE__*/createElement("path", {
  d: "M8 1.069a6.93 6.93 0 00-2.525 13.384c-.059-.547-.116-1.391.025-1.988.125-.541.813-3.444.813-3.444s-.206-.416-.206-1.028c0-.963.559-1.684 1.253-1.684.591 0 .878.444.878.975 0 .594-.378 1.484-.575 2.306-.166.691.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 .597.228 1.234.516 1.581.056.069.066.128.047.2a95.89 95.89 0 01-.194.787c-.031.128-.1.153-.231.094-.866-.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-.703 0-1.362-.366-1.588-.797 0 0-.347 1.322-.431 1.647-.156.603-.578 1.356-.862 1.816a6.93 6.93 0 008.984-6.622 6.931 6.931 0 00-6.931-6.934z"
});

function SvgPinterest(props) {
  return /*#__PURE__*/createElement("svg", _extends$hk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hk);
}

function _extends$hl() { _extends$hl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hl.apply(this, arguments); }

var _ref$hl = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.588 0 0 3.587 0 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.931a6.959 6.959 0 01-2.053-.309c.281-.459.706-1.216.862-1.816.084-.325.431-1.647.431-1.647.225.431.888.797 1.587.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016.541 2.281 1.406 2.684.131.063.2.034.231-.094.022-.097.141-.566.194-.787a.213.213 0 00-.047-.2c-.287-.347-.516-.988-.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-.947 3.175-2.178 3.175-.681 0-1.191-.563-1.025-1.253.197-.825.575-1.713.575-2.306 0-.531-.284-.975-.878-.975-.697 0-1.253.719-1.253 1.684 0 .612.206 1.028.206 1.028s-.688 2.903-.813 3.444c-.141.6-.084 1.441-.025 1.988a6.922 6.922 0 01-4.406-6.45 6.93 6.93 0 116.931 6.931z"
});

function SvgPinterest2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hl);
}

function _extends$hm() { _extends$hm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hm.apply(this, arguments); }

var _ref$hm = /*#__PURE__*/createElement("path", {
  d: "M15 7c-2.367 0-3.76 1.56-4.989 2.936C9.022 11.044 8.168 12 7 12c-.928 0-1-1.148-1-1.5v-2a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v2c0 2.304.617 3.912 1.834 4.782C2.839 16 3.961 16 4.5 16c1.49 0 2.837-.534 4.116-1.633 1.083-.931 1.948-2.106 2.785-3.243C12.635 9.448 13.7 8 15 8h1V7h-1zM1.344 7a.25.25 0 01-.178-.426c.53-.536.821-1.108.89-1.75.061-.572-.055-1.122-.167-1.653-.158-.747-.307-1.453.111-2.042C2.404.558 3.298.2 4.811.002a.25.25 0 01.222.411c-1.075 1.253-1.07 2.298-1.065 3.221.003.634.006 1.233-.324 1.805-.357.618-1.06 1.109-2.212 1.546a.248.248 0 01-.088.016z"
});

function SvgPipe(props) {
  return /*#__PURE__*/createElement("svg", _extends$hm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hm);
}

function _extends$hn() { _extends$hn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hn.apply(this, arguments); }

var _ref$hn = /*#__PURE__*/createElement("path", {
  d: "M15.626 5.604L.78.037A.578.578 0 00.037.78l5.567 14.846a.577.577 0 00.54.374l.023-.001c2.579-.103 5.006-1.168 6.835-2.997s2.894-4.257 2.997-6.835a.578.578 0 00-.374-.564zM3.951 7.93a1.5 1.5 0 10-1.052-2.804L1.563 1.564 13.92 6.198a9.003 9.003 0 01-7.723 7.723l-2.246-5.99z"
});

var _ref2$3N = /*#__PURE__*/createElement("path", {
  d: "M10 10a2 2 0 11-3.999.001A2 2 0 0110 10zM9 6a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgPizza(props) {
  return /*#__PURE__*/createElement("svg", _extends$hn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hn, _ref2$3N);
}

function _extends$ho() { _extends$ho = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ho.apply(this, arguments); }

var _ref$ho = /*#__PURE__*/createElement("path", {
  d: "M15.779 3.509c-.312-.541-.943-.815-1.876-.815-.672 0-1.501.146-2.425.417a6 6 0 00-9.451 5.452c-.17.162-.331.323-.482.483-.597.63-1.023 1.217-1.268 1.743-.213.458-.396 1.127-.062 1.706.312.541.943.815 1.876.815.674 0 1.506-.147 2.433-.419a6 6 0 009.449-5.455c.167-.16.326-.319.476-.477.597-.63 1.024-1.217 1.268-1.743.213-.458.396-1.126.062-1.705zm-2.17 2.654c-1.102 1.163-2.754 2.408-4.652 3.503-2.617 1.511-5.312 2.487-6.866 2.487-.544 0-.809-.122-.875-.237-.119-.206.081-.904 1.097-1.999.123.366.281.715.469 1.046 1.269-.21 3.301-.935 5.614-2.271 1.806-1.043 3.368-2.216 4.397-3.303.148-.157.274-.3.38-.43a6.038 6.038 0 00-.67-.923 6.424 6.424 0 011.399-.185c.544 0 .809.122.875.237.121.21-.089.937-1.168 2.076z"
});

function SvgPlanet(props) {
  return /*#__PURE__*/createElement("svg", _extends$ho({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ho);
}

function _extends$hp() { _extends$hp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hp.apply(this, arguments); }

var _ref$hp = /*#__PURE__*/createElement("path", {
  d: "M15.793 3.501c-.31-.537-.938-.809-1.867-.809-.677 0-1.513.148-2.446.423A5.97 5.97 0 008 2a6.007 6.007 0 00-5.973 6.571c-.172.164-.335.327-.488.489C.941 9.691.514 10.278.27 10.804c-.212.456-.394 1.121-.063 1.695.31.537.938.809 1.867.809.677 0 1.513-.149 2.445-.423A5.965 5.965 0 007.999 14a6.007 6.007 0 005.973-6.571c.172-.164.335-.327.488-.489.598-.631 1.025-1.218 1.269-1.744.212-.456.394-1.121.063-1.695zM8 3a5.009 5.009 0 014.88 3.909c-1.047.943-2.4 1.906-3.907 2.776-1.502.867-3.031 1.559-4.356 1.993A4.989 4.989 0 013 8c0-2.757 2.243-5 5-5zm-6.818 8.937c-.106-.183-.002-.844 1.123-2.049.26.784.679 1.496 1.216 2.1-.546.127-1.036.195-1.446.195-.554 0-.824-.127-.893-.246zM8 13a4.968 4.968 0 01-2.242-.532 26.048 26.048 0 003.778-1.809 26.009 26.009 0 003.456-2.365 5.006 5.006 0 01-4.991 4.705zm5.695-6.888a5.996 5.996 0 00-1.216-2.1c.546-.127 1.036-.195 1.446-.195.554 0 .824.127.893.246.106.183.002.844-1.123 2.049z"
});

function SvgPlanet2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hp);
}

function _extends$hq() { _extends$hq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hq.apply(this, arguments); }

var _ref$hq = /*#__PURE__*/createElement("path", {
  d: "M.517 13h14.966a.5.5 0 00.5-.5v-1l-.001-.033a7.967 7.967 0 00-2.504-5.297A7.956 7.956 0 009 4.063V3h.5a.5.5 0 000-1h-3a.5.5 0 000 1H7v1.063A7.972 7.972 0 002.522 6.17a7.965 7.965 0 00-2.504 5.297l-.001.033v1a.5.5 0 00.5.5zM15.5 14H.5a.5.5 0 000 1h15a.5.5 0 000-1z"
});

function SvgPlate(props) {
  return /*#__PURE__*/createElement("svg", _extends$hq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hq);
}

function _extends$hr() { _extends$hr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hr.apply(this, arguments); }

var _ref$hr = /*#__PURE__*/createElement("path", {
  d: "M15.331 2.502C13.087 2.179 10.607 2 8 2s-5.087.179-7.331.502C.239 4.185 0 6.045 0 8s.239 3.815.669 5.498C2.913 13.821 5.393 14 8 14s5.087-.179 7.331-.502C15.761 11.815 16 9.955 16 8s-.239-3.815-.669-5.498zM6 11V5l5 3-5 3z"
});

function SvgPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$hr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hr);
}

function _extends$hs() { _extends$hs = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hs.apply(this, arguments); }

var _ref$hs = /*#__PURE__*/createElement("path", {
  d: "M6 5.654v4.692L10.064 8zM0 4v10h16V4H0zm15 9H1v-1h14v1zm0-2H1V5h14v6z"
});

function SvgPlay2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hs);
}

function _extends$ht() { _extends$ht = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ht.apply(this, arguments); }

var _ref$ht = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm-2-10L12 8l-6 3.5z"
});

function SvgPlay3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ht({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ht);
}

function _extends$hu() { _extends$hu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hu.apply(this, arguments); }

var _ref$hu = /*#__PURE__*/createElement("path", {
  d: "M3 2l10 6-10 6z"
});

function SvgPlay4(props) {
  return /*#__PURE__*/createElement("svg", _extends$hu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hu);
}

function _extends$hv() { _extends$hv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hv.apply(this, arguments); }

var _ref$hv = /*#__PURE__*/createElement("path", {
  d: "M13 0h-2v11.142A3.543 3.543 0 0010 11c-1.657 0-3 1.119-3 2.5S8.343 16 10 16s3-1.119 3-2.5V3l3 1V2l-3-2zM5.031 14H0v2h5.839a4.25 4.25 0 01-.807-2zM5.839 11H0v2h5.031a4.261 4.261 0 01.807-2z"
});

var _ref2$3O = /*#__PURE__*/createElement("path", {
  d: "M9 9.09V8H0v2h6.85A5.226 5.226 0 019 9.09zM7.031 3H5V1H3v2H.969v2H3v2h2V5h2.031z"
});

function SvgPlaylistAdd(props) {
  return /*#__PURE__*/createElement("svg", _extends$hv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hv, _ref2$3O);
}

function _extends$hw() { _extends$hw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hw.apply(this, arguments); }

var _ref$hw = /*#__PURE__*/createElement("path", {
  d: "M13 0h-2v11.142A3.543 3.543 0 0010 11c-1.657 0-3 1.119-3 2.5S8.343 16 10 16s3-1.119 3-2.5V3l3 1V2l-3-2zM5.031 14H0v2h5.839a4.25 4.25 0 01-.807-2zM5.839 11H0v2h5.031a4.261 4.261 0 01.807-2z"
});

var _ref2$3P = /*#__PURE__*/createElement("path", {
  d: "M9 9.09V8H0v2h6.85A5.226 5.226 0 019 9.09zM0 5h9v2H0V5zM0 2h9v2H0V2z"
});

function SvgPlaylist(props) {
  return /*#__PURE__*/createElement("svg", _extends$hw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hw, _ref2$3P);
}

function _extends$hx() { _extends$hx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hx.apply(this, arguments); }

var _ref$hx = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12zm4-5H9v3H7V9H4V7h3V4h2v3h3z"
});

function SvgPlusCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$hx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hx);
}

function _extends$hy() { _extends$hy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hy.apply(this, arguments); }

var _ref$hy = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1 9v4H7V9H3V7h4V3h2v4h4v2H9z"
});

function SvgPlusCircle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hy);
}

function _extends$hz() { _extends$hz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hz.apply(this, arguments); }

var _ref$hz = /*#__PURE__*/createElement("path", {
  d: "M16 5h-5V0H5v5H0v6h5v5h6v-5h5z"
});

function SvgPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$hz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hz);
}

function _extends$hA() { _extends$hA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hA.apply(this, arguments); }

var _ref$hA = /*#__PURE__*/createElement("path", {
  d: "M15.5 6H10V.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V6H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H6v5.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V10h5.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5z"
});

function SvgPlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hA);
}

function _extends$hB() { _extends$hB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hB.apply(this, arguments); }

var _ref$hB = /*#__PURE__*/createElement("path", {
  d: "M15 7H9V1H7v6H1v2h6v6h2V9h6z"
});

function SvgPlus3(props) {
  return /*#__PURE__*/createElement("svg", _extends$hB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hB);
}

function _extends$hC() { _extends$hC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hC.apply(this, arguments); }

var _ref$hC = /*#__PURE__*/createElement("path", {
  d: "M16 8a8 8 0 10-10.786 7.501L5 16h6l-.214-.499A8.002 8.002 0 0016 8zM7.606 9.919a1 1 0 11.788 0L8 9l-.394.919zm.804.039a2 2 0 10-.82-.001l-1.166 2.721A4.002 4.002 0 014 9.001c0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188a4 4 0 01-2.424 3.677L8.41 9.958zm2.347 5.475l-1.155-2.695A5.002 5.002 0 008 3a5 5 0 00-1.602 9.738l-1.155 2.695A6.997 6.997 0 011.003 9c0-3.865 3.133-7.185 6.997-7.185S14.997 5.135 14.997 9a7 7 0 01-4.24 6.433z"
});

function SvgPodcast(props) {
  return /*#__PURE__*/createElement("svg", _extends$hC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hC);
}

function _extends$hD() { _extends$hD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hD.apply(this, arguments); }

var _ref$hD = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 00-5.657 13.657l.707-.707a7 7 0 119.9 0l.707.707A8 8 0 008 0zm0 3a5 5 0 00-3.536 8.536l.707-.707a4 4 0 115.657 0l.707.707A5 5 0 007.999 3zm1.414 6.414a2 2 0 10-2.828 0l.707-.707a1 1 0 111.414 0l.707.707zM7.625 9L5 16h6L8.375 9h-.75z"
});

function SvgPodcast2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hD);
}

function _extends$hE() { _extends$hE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hE.apply(this, arguments); }

var _ref$hE = /*#__PURE__*/createElement("path", {
  d: "M11 7V3H5v3H0v8h16V7h-5zm-7 4H2v1h2v1H1v-3h2V9H1V8h3v3zm5-1H8V6H7V5h2v5zm6 3h-3v-1h2v-1h-2v-1h2V9h-2V8h3v5z"
});

function SvgPodium(props) {
  return /*#__PURE__*/createElement("svg", _extends$hE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hE);
}

function _extends$hF() { _extends$hF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hF.apply(this, arguments); }

var _ref$hF = /*#__PURE__*/createElement("path", {
  d: "M15 6.5V9a1.502 1.502 0 01-2.236 1.307 1.5 1.5 0 01-2.264.31 1.494 1.494 0 01-1.5.297V14.5c0 .827-.673 1.5-1.5 1.5S6 15.327 6 14.5V8.333L3.25 9.799a1.502 1.502 0 01-1.789-2.381l.012-.011L5.21 4H4.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-.691l1.138 2.276A.496.496 0 0115 6.5zm-1-4a.5.5 0 10-1 0 .5.5 0 001 0zm0 4.118L12.691 4H6.694L2.15 8.143a.5.5 0 00.614.782l3.5-1.866a.502.502 0 01.735.442v7a.5.5 0 001 0v-5a.5.5 0 011 0 .5.5 0 001 0 .5.5 0 011 0 .5.5 0 001 0v-.5a.5.5 0 011 0 .5.5 0 001 0V6.619z"
});

function SvgPointDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$hF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hF);
}

function _extends$hG() { _extends$hG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hG.apply(this, arguments); }

var _ref$hG = /*#__PURE__*/createElement("path", {
  d: "M9.5 15H7a1.502 1.502 0 01-1.307-2.236 1.5 1.5 0 01-.31-2.264A1.494 1.494 0 015.086 9H1.5C.673 9 0 8.327 0 7.5S.673 6 1.5 6h6.167L6.201 3.25a1.502 1.502 0 012.381-1.789l.011.012L12 5.21V4.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-.691l-2.276 1.138A.496.496 0 019.5 15zm4-1a.5.5 0 100-1 .5.5 0 000 1zm-4.118 0L12 12.691V6.694L7.857 2.15a.5.5 0 00-.782.614l1.866 3.5a.499.499 0 01-.441.735h-7a.5.5 0 000 1h5a.5.5 0 010 1 .5.5 0 000 1 .5.5 0 010 1 .5.5 0 000 1H7a.5.5 0 010 1 .5.5 0 000 1h2.382z"
});

function SvgPointLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$hG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hG);
}

function _extends$hH() { _extends$hH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hH.apply(this, arguments); }

var _ref$hH = /*#__PURE__*/createElement("path", {
  d: "M6.5 15H9a1.502 1.502 0 001.307-2.236 1.5 1.5 0 00.31-2.264 1.494 1.494 0 00.297-1.5H14.5c.827 0 1.5-.673 1.5-1.5S15.327 6 14.5 6H8.333l1.466-2.75a1.502 1.502 0 00-2.381-1.789l-.011.012L4 5.21V4.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-.691l2.276 1.138A.496.496 0 006.5 15zm-4-1a.5.5 0 110-1 .5.5 0 010 1zm4.118 0L4 12.691V6.694L8.143 2.15a.5.5 0 01.782.614l-1.866 3.5a.502.502 0 00.442.735h7a.5.5 0 010 1h-5a.5.5 0 000 1 .5.5 0 010 1 .5.5 0 000 1 .5.5 0 010 1h-.5a.5.5 0 000 1 .5.5 0 010 1H6.619z"
});

function SvgPointRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$hH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hH);
}

function _extends$hI() { _extends$hI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hI.apply(this, arguments); }

var _ref$hI = /*#__PURE__*/createElement("path", {
  d: "M15 9.5V7a1.502 1.502 0 00-2.236-1.307 1.5 1.5 0 00-2.264-.31A1.494 1.494 0 009 5.086V1.5C9 .673 8.327 0 7.5 0S6 .673 6 1.5v6.167L3.25 6.201a1.502 1.502 0 00-1.789 2.381l.012.011L5.21 12H4.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-.691l1.138-2.276A.496.496 0 0015 9.5zm-1 4a.5.5 0 11-1 0 .5.5 0 011 0zm0-4.118L12.691 12H6.694L2.15 7.857a.5.5 0 01.614-.782l3.5 1.866a.499.499 0 00.735-.441v-7a.5.5 0 011 0v5a.5.5 0 001 0 .5.5 0 011 0 .5.5 0 001 0 .5.5 0 011 0V7a.5.5 0 001 0 .5.5 0 011 0v2.382z"
});

function SvgPointUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$hI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hI);
}

function _extends$hJ() { _extends$hJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hJ.apply(this, arguments); }

var _ref$hJ = /*#__PURE__*/createElement("path", {
  d: "M12 16H7a.504.504 0 01-.354-.146l-3-3a.466.466 0 01-.07-.089l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L5 9.119V1.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3.11l5.621 1.405A.5.5 0 0114 6.5v6a.499.499 0 01-.053.224l-1.5 3A.5.5 0 0112 16zm-4.793-1h4.484L13 12.382V6.89l-1-.25V9.5a.5.5 0 01-1 0V6.39l-1-.25V8.5a.5.5 0 01-1 0V5.89l-1-.25V9.5a.5.5 0 01-1 0V2H6v8.5a.5.5 0 01-.884.32L2.904 8.165l-.722.481 2.213 3.54 2.813 2.813z"
});

function SvgPointer(props) {
  return /*#__PURE__*/createElement("svg", _extends$hJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hJ);
}

function _extends$hK() { _extends$hK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hK.apply(this, arguments); }

var _ref$hK = /*#__PURE__*/createElement("path", {
  d: "M14.5 2h-9C4.675 2 4 2.675 4 3.5V5H1.5C.675 5 0 5.675 0 6.5v6c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5V11h2.5c.825 0 1.5-.675 1.5-1.5v-6c0-.825-.675-1.5-1.5-1.5zM11 12.5c0 .271-.229.5-.5.5h-9a.507.507 0 01-.5-.5v-6c0-.271.229-.5.5-.5H4v3.5c0 .825.675 1.5 1.5 1.5H11v1.5zm4-3c0 .271-.229.5-.5.5h-9a.507.507 0 01-.5-.5v-6c0-.271.229-.5.5-.5h9c.271 0 .5.229.5.5v6z"
});

function SvgPopout(props) {
  return /*#__PURE__*/createElement("svg", _extends$hK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hK);
}

function _extends$hL() { _extends$hL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hL.apply(this, arguments); }

var _ref$hL = /*#__PURE__*/createElement("path", {
  d: "M16 4.414L14.586 3l-2.793 2.793-1.586-1.586L13 1.414 11.586 0 8.793 2.793 7 1 5.646 2.353l8 8L15 9l-1.793-1.793L16 4.414zM12.407 10.528L5.472 3.593C3.975 5.388 2.276 8.163 3.45 10.55l-2.066 2.066a1.254 1.254 0 000 1.768l.232.232a1.254 1.254 0 001.768 0L5.45 12.55c2.387 1.174 5.161-.524 6.957-2.022z"
});

function SvgPowerCord(props) {
  return /*#__PURE__*/createElement("svg", _extends$hL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hL);
}

function _extends$hM() { _extends$hM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hM.apply(this, arguments); }

var _ref$hM = /*#__PURE__*/createElement("path", {
  d: "M11.25 9.25L14 6.5l-1-1-2.75 2.75-2.5-2.5L10.5 3l-1-1-2.75 2.75-1.72-1.72C4.738 2.738 4.275 2.725 4 3s-.261.739.03 1.03l1.141 1.141-2 2a4.002 4.002 0 00-.618 4.861L.292 14.293a.999.999 0 101.414 1.414l2.261-2.261c1.534.906 3.543.7 4.861-.618l2-2 1.141 1.141c.292.292.755.305 1.03.03s.261-.739-.03-1.03l-1.72-1.72z"
});

function SvgPowerCord2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hM);
}

function _extends$hN() { _extends$hN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hN.apply(this, arguments); }

var _ref$hN = /*#__PURE__*/createElement("path", {
  d: "M6 0L0 8h6l-4 8L16 6H8l6-6z"
});

function SvgPower(props) {
  return /*#__PURE__*/createElement("svg", _extends$hN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hN);
}

function _extends$hO() { _extends$hO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hO.apply(this, arguments); }

var _ref$hO = /*#__PURE__*/createElement("path", {
  d: "M11 0L2 9h5.5L5 16l9-9H8.5z"
});

function SvgPower2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hO);
}

function _extends$hP() { _extends$hP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hP.apply(this, arguments); }

var _ref$hP = /*#__PURE__*/createElement("path", {
  d: "M0 11l5-8 5 5 6-4-5 9-5-5z"
});

function SvgPower3(props) {
  return /*#__PURE__*/createElement("svg", _extends$hP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hP);
}

function _extends$hQ() { _extends$hQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hQ.apply(this, arguments); }

var _ref$hQ = /*#__PURE__*/createElement("path", {
  d: "M14.25 0H.75A.753.753 0 000 .75v11.5c0 .412.338.75.75.75h4.455l-2.04 2.04a.561.561 0 10.796.795L6.796 13h.205v2.5a.5.5 0 001 0V13h.205l2.835 2.835a.561.561 0 00.796 0 .561.561 0 000-.795L9.797 13h4.455c.412 0 .75-.338.75-.75V.75a.753.753 0 00-.75-.75zM6 3l4 2.5L6 8V3zm6.5 8h-10a.5.5 0 010-1h10a.5.5 0 010 1z"
});

function SvgPresentation(props) {
  return /*#__PURE__*/createElement("svg", _extends$hQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hQ);
}

function _extends$hR() { _extends$hR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hR.apply(this, arguments); }

var _ref$hR = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref2$3Q = /*#__PURE__*/createElement("path", {
  d: "M7 8l4-3v6zM5 5h2v6H5V5z"
});

function SvgPrevious(props) {
  return /*#__PURE__*/createElement("svg", _extends$hR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hR, _ref2$3Q);
}

function _extends$hS() { _extends$hS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hS.apply(this, arguments); }

var _ref$hS = /*#__PURE__*/createElement("path", {
  d: "M4 14V2h2v5.5l5-5v11l-5-5V14z"
});

function SvgPrevious2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hS);
}

function _extends$hT() { _extends$hT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hT.apply(this, arguments); }

var _ref$hT = /*#__PURE__*/createElement("path", {
  d: "M6 8h1v2H6zm2 3h1v2H8zm4.514-6.53L8.903.531c-.267-.292-.796-.53-1.174-.53h-.458c-.378 0-.906.239-1.174.53L2.486 4.47C2.219 4.762 2 5.338 2 5.75v9.5c0 .412.309.75.688.75h9.625c.378 0 .688-.338.688-.75v-9.5c0-.412-.219-.989-.486-1.28zM10 8H8v2h2v4H8v1H7v-1H5v-1h2v-2H5V7h2V6h1v1h2v1zM8.281 2.5a.781.781 0 11-1.563 0 .781.781 0 011.563 0z"
});

function SvgPriceTag(props) {
  return /*#__PURE__*/createElement("svg", _extends$hT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hT);
}

function _extends$hU() { _extends$hU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hU.apply(this, arguments); }

var _ref$hU = /*#__PURE__*/createElement("path", {
  d: "M15.25 0h-6c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l6.439 6.439a.752.752 0 001.061 0L15.47 8.03c.292-.292.53-.868.53-1.28v-6a.753.753 0 00-.75-.75zM11.5 6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0111.5 6z"
});

function SvgPriceTag2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hU);
}

function _extends$hV() { _extends$hV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hV.apply(this, arguments); }

var _ref$hV = /*#__PURE__*/createElement("path", {
  d: "M15 1v5.75c0 .147-.133.469-.237.573L7.5 14.586 1.414 8.5l7.263-7.263C8.781 1.133 9.103 1 9.25 1H15zm.25-1h-6c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l6.439 6.439a.747.747 0 001.06 0l7.439-7.439c.292-.292.53-.868.53-1.28v-6a.753.753 0 00-.75-.75z"
});

var _ref2$3R = /*#__PURE__*/createElement("path", {
  d: "M13 4.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 4.5z"
});

function SvgPriceTag3(props) {
  return /*#__PURE__*/createElement("svg", _extends$hV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hV, _ref2$3R);
}

function _extends$hW() { _extends$hW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hW.apply(this, arguments); }

var _ref$hW = /*#__PURE__*/createElement("path", {
  d: "M15.47 7.97l-4.439-4.439c-.292-.292-.868-.53-1.28-.53h-9a.752.752 0 00-.75.75v9.5c0 .412.338.75.75.75h9c.412 0 .989-.239 1.28-.53l4.439-4.439a.752.752 0 000-1.061zM10.5 10a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0110.5 10z"
});

function SvgPriceTag4(props) {
  return /*#__PURE__*/createElement("svg", _extends$hW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hW);
}

function _extends$hX() { _extends$hX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hX.apply(this, arguments); }

var _ref$hX = /*#__PURE__*/createElement("path", {
  d: "M9.75 4c.148 0 .469.133.573.237L14.586 8.5l-4.263 4.263c-.104.104-.426.237-.573.237H1V4h8.75zm0-1h-9a.752.752 0 00-.75.75v9.5c0 .412.338.75.75.75h9c.412 0 .989-.239 1.28-.53l4.439-4.439a.752.752 0 000-1.061L11.03 3.531c-.292-.292-.868-.53-1.28-.53z"
});

var _ref2$3S = /*#__PURE__*/createElement("path", {
  d: "M12 8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0112 8.5z"
});

function SvgPriceTag5(props) {
  return /*#__PURE__*/createElement("svg", _extends$hX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$hX, _ref2$3S);
}

function _extends$hY() { _extends$hY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hY.apply(this, arguments); }

var _ref$hY = /*#__PURE__*/createElement("path", {
  d: "M19.25 0h-6c-.412 0-.989.239-1.28.53L4.531 7.969a.752.752 0 000 1.061l6.439 6.439a.752.752 0 001.061 0L19.47 8.03c.292-.292.53-.868.53-1.28v-6a.752.752 0 00-.75-.75zM15.5 6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0115.5 6z"
});

var _ref2$3T = /*#__PURE__*/createElement("path", {
  d: "M2 8.5L10.5 0H9.25c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l6.439 6.439a.752.752 0 001.061 0l.47-.47-6.5-6.5z"
});

function SvgPriceTags(props) {
  return /*#__PURE__*/createElement("svg", _extends$hY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$hY, _ref2$3T);
}

function _extends$hZ() { _extends$hZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$hZ.apply(this, arguments); }

var _ref$hZ = /*#__PURE__*/createElement("path", {
  d: "M19 1v5.75c0 .147-.133.469-.237.573L11.5 14.586 5.414 8.5l7.263-7.263c.104-.104.426-.237.573-.237H19zm.25-1h-6c-.412 0-.989.239-1.28.53L4.531 7.969a.752.752 0 000 1.061l6.439 6.439a.747.747 0 001.06 0l7.439-7.439c.292-.292.53-.868.53-1.28v-6a.752.752 0 00-.75-.75z"
});

var _ref2$3U = /*#__PURE__*/createElement("path", {
  d: "M17 4.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0117 4.5zM9.914 0H9.25c-.412 0-.989.239-1.28.53L.531 7.969a.752.752 0 000 1.061l6.439 6.439a.747.747 0 001.06 0l.177-.177-6.793-6.793 8.5-8.5z"
});

function SvgPriceTags2(props) {
  return /*#__PURE__*/createElement("svg", _extends$hZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref$hZ, _ref2$3U);
}

function _extends$h_() { _extends$h_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h_.apply(this, arguments); }

var _ref$h_ = /*#__PURE__*/createElement("path", {
  d: "M17.47 9.97l-4.439-4.439c-.292-.292-.868-.53-1.28-.53h-9a.752.752 0 00-.75.75v9.5c0 .412.337.75.75.75h9c.412 0 .989-.239 1.28-.53l4.439-4.439a.752.752 0 000-1.061zM12.5 12a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 12z"
});

var _ref2$3V = /*#__PURE__*/createElement("path", {
  d: "M1 4h10.5l-.47-.47c-.292-.292-.868-.53-1.28-.53h-9a.752.752 0 00-.75.75v9.5c0 .412.338.75.75.75H1V4z"
});

function SvgPriceTags3(props) {
  return /*#__PURE__*/createElement("svg", _extends$h_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$h_, _ref2$3V);
}

function _extends$h$() { _extends$h$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h$.apply(this, arguments); }

var _ref$h$ = /*#__PURE__*/createElement("path", {
  d: "M11.75 6c.148 0 .469.133.573.237l4.263 4.263-4.263 4.263c-.104.104-.426.237-.573.237H3V6h8.75zm0-1h-9a.752.752 0 00-.75.75v9.5c0 .412.337.75.75.75h9c.412 0 .989-.239 1.28-.53l4.439-4.439a.752.752 0 000-1.061L13.03 5.531c-.292-.292-.868-.53-1.28-.53z"
});

var _ref2$3W = /*#__PURE__*/createElement("path", {
  d: "M14 10.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0114 10.5zM1 13V4h10.5l-.47-.47c-.292-.292-.868-.53-1.28-.53h-9a.752.752 0 00-.75.75v9.5c0 .412.338.75.75.75H1v-1z"
});

function SvgPriceTags4(props) {
  return /*#__PURE__*/createElement("svg", _extends$h$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$h$, _ref2$3W);
}

function _extends$i0() { _extends$i0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i0.apply(this, arguments); }

var _ref$i0 = /*#__PURE__*/createElement("path", {
  d: "M15.916 7.223l-2-3A.501.501 0 0013.5 4H12V.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V4H2.5a.501.501 0 00-.416.223l-2 3A.498.498 0 000 7.5v5a.5.5 0 00.5.5h2.306l-.781 2.342A.499.499 0 002.5 16h11a.499.499 0 00.475-.658L13.194 13H15.5a.5.5 0 00.5-.5v-5a.496.496 0 00-.084-.277zM5 1h6v4H5V1zM3.194 15l1.667-5h6.279l1.667 5H3.194zM15 12h-2.14l-.886-2.658A.5.5 0 0011.5 9h-7a.5.5 0 00-.474.342L3.14 12H1V7.651L2.768 5H4v.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V5h1.232L15 7.651V12z"
});

var _ref2$3X = /*#__PURE__*/createElement("path", {
  d: "M9.5 11h-3a.5.5 0 000 1h3a.5.5 0 000-1zM10.5 13h-5a.5.5 0 000 1h5a.5.5 0 000-1z"
});

function SvgPrinter(props) {
  return /*#__PURE__*/createElement("svg", _extends$i0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i0, _ref2$3X);
}

function _extends$i1() { _extends$i1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i1.apply(this, arguments); }

var _ref$i1 = /*#__PURE__*/createElement("path", {
  d: "M9.5 11h-3a.5.5 0 000 1h3a.5.5 0 000-1zM10.5 13h-5a.5.5 0 000 1h5a.5.5 0 000-1z"
});

var _ref2$3Y = /*#__PURE__*/createElement("path", {
  d: "M15.916 7.223l-2-3A.501.501 0 0013.5 4H12V.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V4H2.5a.501.501 0 00-.416.223l-2 3A.498.498 0 000 7.5v5a.5.5 0 00.5.5h2.306l-.781 2.342A.499.499 0 002.5 16h11a.499.499 0 00.475-.658L13.194 13H15.5a.5.5 0 00.5-.5v-5a.496.496 0 00-.084-.277zM5 1h6v4H5V1zM3.194 15l1.667-5h6.279l1.667 5H3.194z"
});

function SvgPrinter2(props) {
  return /*#__PURE__*/createElement("svg", _extends$i1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i1, _ref2$3Y);
}

function _extends$i2() { _extends$i2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i2.apply(this, arguments); }

var _ref$i2 = /*#__PURE__*/createElement("path", {
  d: "M4 1h8v2H4V1zM15 4H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h3v4h8v-4h3c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM2 7a1 1 0 110-2 1 1 0 010 2zm9 7H5V9h6v5z"
});

function SvgPrinter3(props) {
  return /*#__PURE__*/createElement("svg", _extends$i2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i2);
}

function _extends$i3() { _extends$i3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i3.apply(this, arguments); }

var _ref$i3 = /*#__PURE__*/createElement("path", {
  d: "M14 9v4H2V9H0v6h16V9zm-1-8H3v11h10V1zm-2 9H5V9h6v1zm0-3H5V6h6v1zm0-3H5V3h6v1z"
});

function SvgPrinter4(props) {
  return /*#__PURE__*/createElement("svg", _extends$i3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i3);
}

function _extends$i4() { _extends$i4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i4.apply(this, arguments); }

var _ref$i4 = /*#__PURE__*/createElement("path", {
  d: "M13.5 0h-12C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM13 14H2V2h11v12zM4 9h7v1H4zm0 2h7v1H4zm1-6.5a1.5 1.5 0 113.001.001A1.5 1.5 0 015 4.5zM7.5 6h-2C4.675 6 4 6.45 4 7v1h5V7c0-.55-.675-1-1.5-1z"
});

function SvgProfile(props) {
  return /*#__PURE__*/createElement("svg", _extends$i4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i4);
}

function _extends$i5() { _extends$i5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i5.apply(this, arguments); }

var _ref$i5 = /*#__PURE__*/createElement("path", {
  d: "M3.293 9l3.854-3.854a.499.499 0 01.854.354v3.793l2.146-2.146a.499.499 0 01.854.354v1.5h3.873c.681-1.133 1.127-2.393 1.127-3.75a4.25 4.25 0 00-8-2.001 4.25 4.25 0 00-8 2.001c0 1.357.446 2.617 1.127 3.75h2.166z"
});

var _ref2$3Z = /*#__PURE__*/createElement("path", {
  d: "M10.5 10a.5.5 0 01-.5-.5v-.793l-2.146 2.146A.5.5 0 017 10.499V6.706L3.854 9.852a.5.5 0 01-.354.146H1.81c2.36 3.085 6.19 5 6.19 5s3.83-1.915 6.19-5H10.5z"
});

function SvgPulse(props) {
  return /*#__PURE__*/createElement("svg", _extends$i5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i5, _ref2$3Z);
}

function _extends$i6() { _extends$i6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i6.apply(this, arguments); }

var _ref$i6 = /*#__PURE__*/createElement("path", {
  d: "M7.5 15a.501.501 0 01-.495-.424L5.41 4.207l-1.423 6.401a.5.5 0 01-.488.392h-3a.5.5 0 010-1h2.599l1.913-8.608a.5.5 0 01.983.033l1.709 11.11 2.328-6.209a.5.5 0 01.942.018l1.526 4.577.526-1.577a.5.5 0 01.474-.342h2a.5.5 0 010 1h-1.64l-.886 2.658a.5.5 0 01-.948 0L10.472 8l-2.504 6.678a.499.499 0 01-.468.324z"
});

function SvgPulse2(props) {
  return /*#__PURE__*/createElement("svg", _extends$i6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i6);
}

function _extends$i7() { _extends$i7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i7.apply(this, arguments); }

var _ref$i7 = /*#__PURE__*/createElement("path", {
  d: "M8.5 0L7 1.5 8.5 3 5 7H1.5l2.75 2.75L0 15.385V16h.615l5.635-4.25L9 14.5V11l4-3.5L14.5 9 16 7.5 8.5 0zM7 8.5l-1-1L9.5 4l1 1L7 8.5z"
});

function SvgPushpin(props) {
  return /*#__PURE__*/createElement("svg", _extends$i7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i7);
}

function _extends$i8() { _extends$i8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i8.apply(this, arguments); }

var _ref$i8 = /*#__PURE__*/createElement("path", {
  d: "M8 0a4 4 0 00-1 7.874V15.5l2-2V7.874A4.002 4.002 0 008 0zM7 4a1 1 0 110-2 1 1 0 010 2z"
});

function SvgPushpin2(props) {
  return /*#__PURE__*/createElement("svg", _extends$i8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i8);
}

function _extends$i9() { _extends$i9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i9.apply(this, arguments); }

var _ref$i9 = /*#__PURE__*/createElement("path", {
  d: "M14.974 4.004h-2.632c-.679-.001-1.355-.047-.695-1.21.661-1.166 1.127-2.798-1.525-2.798S7.937 1.628 8.597 2.794c.659 1.163-.017 1.209-.695 1.21H5.029A1.03 1.03 0 004.003 5.03v3.193c0 .68.184 1.36-.981.699S.001 7.795.001 10.447s1.855 2.185 3.021 1.525.981.019.981.699v2.306a1.03 1.03 0 001.026 1.026h2.869c.68 0 1.36-.272.699-1.438s-1.127-2.797 1.525-2.797 2.186 1.632 1.525 2.797c-.66 1.166.019 1.438.699 1.438h2.628A1.03 1.03 0 0016 14.977V5.029a1.03 1.03 0 00-1.026-1.026z"
});

function SvgPuzzle(props) {
  return /*#__PURE__*/createElement("svg", _extends$i9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i9);
}

function _extends$ia() { _extends$ia = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ia.apply(this, arguments); }

var _ref$ia = /*#__PURE__*/createElement("path", {
  d: "M14.543 16h-2.452c-.772 0-1.115-.309-1.267-.569-.23-.394-.17-.906.178-1.524.379-.672.506-1.212.348-1.483-.148-.253-.622-.393-1.335-.393s-1.188.139-1.335.393c-.158.271-.031.811.348 1.483.348.617.408 1.13.178 1.524-.152.26-.494.569-1.267.569H5.462a1.46 1.46 0 01-1.457-1.462v-2.161c0-.087.003-.171.005-.251l.002-.063a3.077 3.077 0 00-.176.094c-.438.249-1.369.546-2.029.546-.544 0-.997-.206-1.31-.595C.162 11.693 0 11.099 0 10.293s.163-1.4.497-1.815c.313-.389.766-.595 1.31-.595.66 0 1.591.297 2.029.546.068.039.126.069.176.094l-.002-.064a6.69 6.69 0 01-.005-.251l-.013-2.74c0-.808.654-1.464 1.457-1.464H7.93c.073 0 .261 0 .383-.018a1.832 1.832 0 00-.169-.37c-.583-1.033-.698-2.117-.341-2.729.344-.59 1.084-.889 2.199-.889s1.855.299 2.199.889c.357.611.242 1.695-.341 2.729-.102.18-.148.299-.169.37.122.018.31.018.383.018h2.455a1.46 1.46 0 011.457 1.461l.012 9.071a1.46 1.46 0 01-1.457 1.462zm-2.855-1.074c.029.023.147.074.402.074h2.452a.46.46 0 00.457-.462l-.012-9.071a.46.46 0 00-.457-.462h-2.456c-.401-.001-1.005-.002-1.284-.481-.268-.46-.014-1.019.2-1.399.379-.672.506-1.462.348-1.733-.148-.253-.622-.393-1.336-.393s-1.188.139-1.335.393c-.158.271-.031 1.061.348 1.733.214.38.468.938.2 1.399-.279.479-.884.48-1.284.481H5.449a.46.46 0 00-.457.461l.013 2.74c0 .073.003.148.005.22.012.35.024.712-.229.974a.715.715 0 01-.531.216c-.241 0-.521-.098-.907-.318-.464-.264-1.195-.415-1.534-.415-.221 0-.807 0-.807 1.41s.587 1.41.807 1.41c.34 0 1.071-.151 1.534-.415.386-.22.666-.318.907-.318.266 0 .436.118.531.216.253.261.241.623.229.974-.002.072-.005.147-.005.218v2.161a.46.46 0 00.457.462h2.477c.255 0 .373-.051.402-.074.004-.028.014-.176-.185-.527-.583-1.033-.698-1.867-.341-2.479.344-.59 1.084-.889 2.199-.889s1.855.299 2.199.889c.357.611.242 1.445-.341 2.479-.198.351-.189.499-.185.527z"
});

function SvgPuzzle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ia({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ia);
}

function _extends$ib() { _extends$ib = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ib.apply(this, arguments); }

var _ref$ib = /*#__PURE__*/createElement("path", {
  d: "M15.692 7.254L13.998 5.56c-1.304-1.305.365-1.201 1.335-2.07l.014-.013c.022-.021.045-.041.066-.063A2 2 0 1012.522.652l-.013.014c-.87.969-.765 2.639-2.071 1.334L8.745.307a1.059 1.059 0 00-1.492 0L5.561 1.999C4.255 3.305 4.359 1.635 3.49.666L3.477.652C3.456.63 3.436.607 3.414.586A2 2 0 10.652 3.477l.014.013c.97.87 2.64.765 1.333 2.071L.307 7.253c-.41.41-.41 1.081 0 1.492l1.692 1.692c1.306 1.306-.364 1.202-1.333 2.071l-.014.013c-.022.021-.045.041-.066.063a2 2 0 102.891 2.762l.013-.014c.87-.969.765-2.639 2.071-1.334l1.693 1.693c.41.41 1.081.41 1.492 0l1.966-1.966c.783-1.007-.701-.983-1.592-1.783l-.014-.013c-.023-.021-.045-.041-.066-.063a2 2 0 112.891-2.762l.013.014c.8.892.776 2.376 1.783 1.592l1.966-1.966c.41-.41.41-1.081 0-1.492z"
});

function SvgPuzzle3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ib({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ib);
}

function _extends$ic() { _extends$ic = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ic.apply(this, arguments); }

var _ref$ic = /*#__PURE__*/createElement("path", {
  d: "M8 16c.42 0 .815-.163 1.11-.459l1.846-1.846.023-.029c.104-.134.422-.543.304-1.037-.123-.513-.596-.736-1.054-.952-.283-.133-.576-.271-.795-.467l-.011-.01-.042-.04a1.26 1.26 0 010-1.779c.238-.238.553-.368.889-.368s.652.131.889.368l.043.045.006.007c.197.22.335.513.469.797.226.481.508 1.079 1.17 1.079.265 0 .533-.108.818-.33l.029-.023L15.54 9.11a1.573 1.573 0 000-2.221l-1.568-1.568c-.1-.1-.164-.176-.205-.23.095-.053.227-.115.333-.165.327-.154.735-.346 1.082-.658l.018-.017.081-.077c.462-.462.716-1.076.716-1.729s-.254-1.267-.716-1.729C14.819.254 14.205 0 13.552 0s-1.267.254-1.729.716l-.074.078-.018.02c-.313.349-.505.756-.659 1.084-.05.106-.112.238-.165.333a2.088 2.088 0 01-.231-.206L9.109.458c-.296-.296-.69-.459-1.11-.459s-.814.163-1.11.459L5.322 2.025c-.1.1-.177.165-.231.206-.053-.095-.115-.227-.165-.333-.154-.327-.346-.735-.659-1.084L4.251.797A2.429 2.429 0 002.445 0C1.792 0 1.178.254.716.716A2.449 2.449 0 00.795 4.25l.019.018c.349.313.756.505 1.084.659.106.05.238.112.333.165a2.2 2.2 0 01-.206.231L.458 6.89c-.296.296-.459.69-.459 1.11s.163.815.459 1.11l1.567 1.567c.1.1.165.177.206.231-.095.053-.227.115-.333.165-.327.154-.735.346-1.084.659l-.018.016a2.449 2.449 0 00-.08 3.535c.462.462 1.076.716 1.729.716a2.429 2.429 0 001.804-.795l.016-.017.002-.002c.313-.349.505-.756.659-1.084.05-.106.112-.238.165-.333.055.041.131.105.231.206l1.567 1.567c.296.296.69.459 1.11.459zm-2.978-3.483c-.662 0-.944.599-1.17 1.079-.133.283-.271.576-.468.796l-.009.01a1.247 1.247 0 01-.929.41 1.25 1.25 0 01-.889-.368 1.26 1.26 0 01.041-1.818l.012-.011c.219-.196.512-.334.795-.467.454-.214.969-.456 1.065-1.008.092-.527-.275-.973-.604-1.303L1.299 8.27a.38.38 0 01-.111-.271.38.38 0 01.111-.271l1.526-1.526.026-.017.037-.046c.324-.327.672-.765.582-1.281-.096-.552-.611-.794-1.065-1.008-.284-.134-.577-.272-.796-.468l-.01-.009-.042-.04a1.26 1.26 0 010-1.779c.238-.238.553-.368.889-.368a1.246 1.246 0 01.93.413l.007.008c.197.22.335.513.469.797.226.481.508 1.079 1.17 1.079.359 0 .708-.188 1.131-.609l1.576-1.576c.072-.072.168-.111.271-.111s.199.039.271.111l1.567 1.567c.427.427.779.618 1.14.618.662 0 .944-.599 1.17-1.079.134-.284.272-.577.467-.795l.01-.011.04-.042c.238-.238.553-.368.889-.368s.652.131.889.368c.238.238.368.553.368.889s-.131.652-.369.89c-.013.014-.027.026-.041.039l-.01.009c-.22.197-.513.335-.797.469-.454.214-.969.456-1.065 1.008-.092.527.274.972.603 1.302L14.7 7.73a.387.387 0 010 .541l-1.785 1.785a6.042 6.042 0 01-.165-.332c-.154-.327-.346-.734-.661-1.085l-.014-.016a2.429 2.429 0 00-1.806-.797c-.653 0-1.267.254-1.729.716a2.448 2.448 0 00.081 3.535l.017.016c.349.313.756.505 1.084.659.106.05.237.112.332.165l-1.785 1.785c-.072.072-.168.111-.271.111s-.199-.039-.271-.111L6.16 13.135c-.427-.427-.779-.618-1.14-.618z"
});

function SvgPuzzle4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ic({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ic);
}

function _extends$id() { _extends$id = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$id.apply(this, arguments); }

var _ref$id = /*#__PURE__*/createElement("path", {
  d: "M7.5 1.001L.261 11.657 7.5 16l7.239-4.343L7.5 1.001zM1.683 11.343L7 3.516v11.017l-5.317-3.19zM8 3.516l5.317 7.827L8 14.533V3.516z"
});

function SvgPyramid(props) {
  return /*#__PURE__*/createElement("svg", _extends$id({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$id);
}

function _extends$ie() { _extends$ie = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ie.apply(this, arguments); }

var _ref$ie = /*#__PURE__*/createElement("path", {
  d: "M7.5 1.001L.261 11.657 7.5 16l7.239-4.343L7.5 1.001zM1.683 11.343L7 3.516v11.017l-5.317-3.19zM8 14.375h.265L8 14.534v-.159zm0-.25v-.25h1.098l-.417.25H8zm0-.5v-.25h1.931l-.417.25H7.999zm0-.5v-.25h2.765l-.417.25H8zm0-.5v-.25h3.598l-.417.25H8zm0-.5v-.25h4.431l-.417.25H7.999zm0-.5v-.25h5.265l-.417.25H8zm.244-7.75l.17.25h-.413v-.25h.244zm.339.5l.17.25H8v-.25h.583zm.34.5l.17.25H8v-.25h.923zm.34.5l.17.25H8v-.25h1.263zm.339.5l.17.25H8v-.25h1.602zm.34.5l.17.25H8v-.25h1.942zm.34.5l.17.25H8v-.25h2.282zm.339.5l.17.25H8v-.25h2.621zm.34.5l.17.25H8v-.25h2.961zm.34.5l.17.25H8v-.25h3.301zm.339.5l.17.25H8v-.25h3.64zm.34.5l.17.25H8v-.25h3.98zm.34.5l.17.25H8v-.25h4.32zm.339.5l.17.25H8v-.25h4.659zm.34.5l.17.25H8v-.25h4.999z"
});

function SvgPyramid2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ie({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ie);
}

function _extends$if() { _extends$if = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$if.apply(this, arguments); }

var _ref$if = /*#__PURE__*/createElement("path", {
  d: "M5 1H1v4h4V1zm1-1v6H0V0h6zM2 2h2v2H2zm13-1h-4v4h4V1zm1-1v6h-6V0h6zm-4 2h2v2h-2zm-7 9H1v4h4v-4zm1-1v6H0v-6h6zm-4 2h2v2H2zM7 0h1v1H7zm1 1h1v1H8zM7 2h1v1H7zm1 1h1v1H8zM7 4h1v1H7zm1 1h1v1H8zM7 6h1v1H7zm0 2h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm-1 1h1v1H7zm1 1h1v1H8zm7-7h1v1h-1zM1 8h1v1H1zm1-1h1v1H2zM0 7h1v1H0zm4 0h1v1H4zm1 1h1v1H5zm1-1h1v1H6zm3 1h1v1H9zm1-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-6 0h1v1H9zm1-1h1v1h-1zm1 1h1v1h-1zm2 0h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-6 0h1v1H9zm1-1h1v1h-1zm2 0h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 3h1v1h-1zm-5-1h1v1h-1zm1 1h1v1h-1zm1-1h1v1h-1zm1 1h1v1h-1zm-3 1h1v1h-1zm2 0h1v1h-1zm2 0h1v1h-1z"
});

function SvgQrcode(props) {
  return /*#__PURE__*/createElement("svg", _extends$if({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$if);
}

function _extends$ig() { _extends$ig = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ig.apply(this, arguments); }

var _ref$ig = /*#__PURE__*/createElement("path", {
  d: "M7 11h2v2H7zm4-7a1 1 0 011 1v3l-3 2H7V9l3-2V6H5V4h6zM8 1.5c-1.736 0-3.369.676-4.596 1.904S1.5 6.264 1.5 8c0 1.736.676 3.369 1.904 4.596S6.264 14.5 8 14.5c1.736 0 3.369-.676 4.596-1.904S14.5 9.736 14.5 8c0-1.736-.676-3.369-1.904-4.596S9.736 1.5 8 1.5zM8 0a8 8 0 110 16A8 8 0 018 0z"
});

function SvgQuestion(props) {
  return /*#__PURE__*/createElement("svg", _extends$ig({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ig);
}

function _extends$ih() { _extends$ih = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ih.apply(this, arguments); }

var _ref$ih = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1 13H7v-2h2v2zm3-5l-3 2H7V9l3-2V6H5V4h6a1 1 0 011 1v3z"
});

function SvgQuestion2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ih({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ih);
}

function _extends$ii() { _extends$ii = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ii.apply(this, arguments); }

var _ref$ii = /*#__PURE__*/createElement("path", {
  d: "M9 12a1 1 0 11-2 0 1 1 0 012 0z"
});

var _ref2$3_ = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z"
});

var _ref3$q = /*#__PURE__*/createElement("path", {
  d: "M8 10.004a.75.75 0 01-.75-.75v-.5c0-.525.203-.998.602-1.404.295-.3.653-.525.999-.742.712-.447 1.024-.687 1.024-1.107 0-.457-.264-.762-.485-.938-.355-.282-.849-.437-1.39-.437-.821 0-1.559.548-1.796 1.333a.75.75 0 01-1.436-.432 3.406 3.406 0 011.2-1.721 3.344 3.344 0 012.031-.68c.878 0 1.703.271 2.322.762.679.539 1.053 1.289 1.053 2.113 0 1.293-.998 1.92-1.726 2.377-.611.384-.899.596-.899.876v.5a.75.75 0 01-.75.75z"
});

function SvgQuestion3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ii({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ii, _ref2$3_, _ref3$q);
}

function _extends$ij() { _extends$ij = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ij.apply(this, arguments); }

var _ref$ij = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 13a1 1 0 110-2 1 1 0 010 2zm1.649-5.123c-.611.384-.899.596-.899.876v.5a.75.75 0 01-1.5 0v-.5c0-.525.203-.998.602-1.404.295-.3.653-.525.999-.742.712-.447 1.024-.687 1.024-1.107 0-.457-.264-.762-.485-.938-.355-.282-.849-.437-1.39-.437-.821 0-1.559.548-1.796 1.333a.75.75 0 01-1.436-.432 3.406 3.406 0 011.2-1.721 3.344 3.344 0 012.031-.68c.878 0 1.703.271 2.322.762.679.539 1.053 1.289 1.053 2.113 0 1.293-.998 1.92-1.726 2.377z"
});

function SvgQuestion4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ij({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ij);
}

function _extends$ik() { _extends$ik = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ik.apply(this, arguments); }

var _ref$ik = /*#__PURE__*/createElement("path", {
  d: "M6 13h3v3H6zm6.5-12A1.5 1.5 0 0114 2.5V7l-5 3v2H6V9l5-3V4H3V1h9.5z"
});

function SvgQuestion5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ik({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ik);
}

function _extends$il() { _extends$il = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$il.apply(this, arguments); }

var _ref$il = /*#__PURE__*/createElement("path", {
  d: "M8 13a1 1 0 01-1-1v-1.027c0-1.41 1.124-2.477 2.212-3.509C10.091 6.63 11 5.767 11 5c0-1.493-1.082-3-3.5-3a3.494 3.494 0 00-3.479 3.11 1 1 0 11-1.988-.22 5.493 5.493 0 011.785-3.477A5.491 5.491 0 017.499 0c1.475 0 2.834.463 3.828 1.305 1.078.913 1.672 2.225 1.672 3.695 0 1.626-1.281 2.842-2.411 3.915-.745.707-1.589 1.508-1.589 2.058V12a1 1 0 01-1 1zM9 15a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgQuestion6(props) {
  return /*#__PURE__*/createElement("svg", _extends$il({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$il);
}

function _extends$im() { _extends$im = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$im.apply(this, arguments); }

var _ref$im = /*#__PURE__*/createElement("path", {
  d: "M0 16C2 10 7.234 0 16 0c-4.109 3.297-6 11-9 11H4l-3 5H0z"
});

function SvgQuill(props) {
  return /*#__PURE__*/createElement("svg", _extends$im({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$im);
}

function _extends$in() { _extends$in = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$in.apply(this, arguments); }

var _ref$in = /*#__PURE__*/createElement("path", {
  d: "M0 16h1l3-5h3c3 0 4.891-7.703 9-11C7.234 0 2 10 0 16zm6.125-7H5s2.766-5 7-7c0 0-3.797 3.359-5.875 7z"
});

function SvgQuill2(props) {
  return /*#__PURE__*/createElement("svg", _extends$in({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$in);
}

function _extends$io() { _extends$io = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$io.apply(this, arguments); }

var _ref$io = /*#__PURE__*/createElement("path", {
  d: "M15.914.22A.501.501 0 0015.5 0c-2.176 0-4.229.349-6.102 1.039-1.886.694-3.544 1.716-4.93 3.037C1.545 6.863.001 11 .001 16h1.5c0-.924.732-4 2-4 .777 0 2.31-.076 3.846-.588 1.651-.55 2.856-1.443 3.583-2.655a.5.5 0 00-.271-.732 5.095 5.095 0 00-.902-.181c1.602-.718 3.377-1.761 4.173-3.087a.498.498 0 00-.308-.743 8.731 8.731 0 00-1.163-.186c1.874-.954 3.053-2.012 3.506-3.144a.499.499 0 00-.05-.466zm-4 2.764a17.93 17.93 0 01-2.558 1.037.5.5 0 00.265.964 7.44 7.44 0 011.805-.207 9.6 9.6 0 011.173.074c-.692.729-1.832 1.453-3.351 2.123-1.512.666-2.866 1.039-2.88 1.043a.5.5 0 00.23.972 10.502 10.502 0 012.05-.213c.395 0 .727.026.991.06-1.734 1.996-5.082 2.162-6.139 2.162-1.186 0-1.912 1.021-2.336 1.997.448-3.31 1.806-6.112 3.994-8.198 1.286-1.226 2.829-2.176 4.585-2.822 1.506-.554 3.14-.875 4.868-.956-.538.672-1.452 1.34-2.696 1.963z"
});

function SvgQuill3(props) {
  return /*#__PURE__*/createElement("svg", _extends$io({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$io);
}

function _extends$ip() { _extends$ip = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ip.apply(this, arguments); }

var _ref$ip = /*#__PURE__*/createElement("path", {
  d: "M0 16c0-2.291.377-4.698 1.122-6.663.719-1.899 1.764-3.574 3.104-4.979A13.77 13.77 0 018.908 1.14C10.717.383 12.683 0 14.751 0c.085 0 .164.043.21.115s.053.161.017.239c-.522 1.148-1.851 2.212-3.952 3.162-.298.135-.594.259-.879.372.195-.007.393-.01.594-.01 1.176 0 2.01.12 2.045.125.084.012.156.066.191.143s.029.167-.016.238c-.755 1.186-2.404 2.281-4.901 3.255-.206.08-.409.156-.608.228.146-.004.292-.006.438-.006 1.163 0 1.878.138 1.908.144a.25.25 0 01.145.404c-2.28 2.786-3.837 3.592-6.944 3.592-.707 0-1.258.614-1.636 1.825-.3.96-.364 2.175-.364 2.175z"
});

function SvgQuill4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ip({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ip);
}

function _extends$iq() { _extends$iq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iq.apply(this, arguments); }

var _ref$iq = /*#__PURE__*/createElement("path", {
  d: "M3.516 7a3.5 3.5 0 11-3.5 3.5L0 10a7 7 0 017-7v2a4.97 4.97 0 00-3.536 1.464 5.01 5.01 0 00-.497.578c.179-.028.362-.043.548-.043zm9 0a3.5 3.5 0 11-3.5 3.5L9 10a7 7 0 017-7v2a4.97 4.97 0 00-3.536 1.464 5.01 5.01 0 00-.497.578c.179-.028.362-.043.549-.043z"
});

function SvgQuotesLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$iq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iq);
}

function _extends$ir() { _extends$ir = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ir.apply(this, arguments); }

var _ref$ir = /*#__PURE__*/createElement("path", {
  d: "M6 1v14H0V8zm9 0v14H9V8z"
});

function SvgQuotesLeft2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ir({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ir);
}

function _extends$is() { _extends$is = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$is.apply(this, arguments); }

var _ref$is = /*#__PURE__*/createElement("path", {
  d: "M12.5 10A3.5 3.5 0 1116 6.5l.016.5a7 7 0 01-7 7v-2a4.97 4.97 0 003.536-1.464 5.01 5.01 0 00.497-.578 3.547 3.547 0 01-.549.043zm-9 0A3.5 3.5 0 117 6.5l.016.5a7 7 0 01-7 7v-2a4.97 4.97 0 003.536-1.464 5.01 5.01 0 00.497-.578 3.547 3.547 0 01-.549.043z"
});

function SvgQuotesRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$is({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$is);
}

function _extends$it() { _extends$it = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$it.apply(this, arguments); }

var _ref$it = /*#__PURE__*/createElement("path", {
  d: "M9 15V1h6v7zm-9 0V1h6v7z"
});

function SvgQuotesRight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$it({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$it);
}

function _extends$iu() { _extends$iu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iu.apply(this, arguments); }

var _ref$iu = /*#__PURE__*/createElement("path", {
  d: "M25.714 0h-.83c-6.53 3.774-11.507 7.455-14.93 11.042C3.318 17.894 0 25.51 0 33.888c0 5.54 1.448 9.944 4.345 13.21 3.002 3.372 6.807 5.059 11.415 5.059 3.74 0 6.78-1.245 9.124-3.734 2.344-2.41 3.516-5.621 3.516-9.637 0-3.694-1.172-6.625-3.516-8.793-2.133-2.195-4.753-3.292-7.86-3.292-.527 0-1.066.053-1.62.16l-1.737.161c-1.08 0-1.883-.268-2.41-.803l-.79-2.61c0-3.8 2.08-7.816 6.241-12.045 2.344-2.41 5.872-5.247 10.586-8.512L25.714 0m34.933 0h-.83c-6.53 3.774-11.507 7.455-14.93 11.042-6.636 6.852-9.954 14.468-9.954 22.846 0 5.54 1.448 9.944 4.345 13.21 3.001 3.372 6.793 5.059 11.375 5.059 3.766 0 6.82-1.245 9.164-3.734 2.344-2.41 3.516-5.621 3.516-9.637 0-3.694-1.172-6.625-3.516-8.793-2.133-2.195-4.753-3.292-7.86-3.292-.527 0-1.067.053-1.62.16l-1.738.161c-1.08 0-1.882-.268-2.41-.803l-.829-2.61c0-3.8 2.094-7.816 6.28-12.045 2.344-2.41 5.873-5.247 10.587-8.512L60.647 0"
});

function SvgQuotes(props) {
  return /*#__PURE__*/createElement("svg", _extends$iu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 53,
    viewBox: "0 0 64 53"
  }, props), _ref$iu);
}

function _extends$iv() { _extends$iv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iv.apply(this, arguments); }

var _ref$iv = /*#__PURE__*/createElement("path", {
  d: "M6 3h2v2H6V3zm2 2v2c1 0 1 1 2 1V6C9 6 9 5 8 5zm2-1h2v2h-2V4zm0-3c-.5 0-.75-.25-1-.5S8.5 0 8 0H3v10h5c.5 0 .75.25 1 .5s.5.5 1 .5h5V1h-5zm4 5h-2v2h2v2h-2V8h-2v2c-.5 0-.75-.25-1-.5S8.5 9 8 9V7H6v2H4V7h2V5H4V3h2V1h2v2c.5 0 .75.25 1 .5s.5.5 1 .5V2h2v2h2v2zM0 0h2v16H0V0z"
});

function SvgRacing(props) {
  return /*#__PURE__*/createElement("svg", _extends$iv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iv);
}

function _extends$iw() { _extends$iw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iw.apply(this, arguments); }

var _ref$iw = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12zM5 8a3 3 0 116 0 3 3 0 01-6 0z"
});

function SvgRadioChecked(props) {
  return /*#__PURE__*/createElement("svg", _extends$iw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iw);
}

function _extends$ix() { _extends$ix = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ix.apply(this, arguments); }

var _ref$ix = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 10a2 2 0 11-.001-3.999A2 2 0 018 10z"
});

function SvgRadioChecked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ix({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ix);
}

function _extends$iy() { _extends$iy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iy.apply(this, arguments); }

var _ref$iy = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
});

function SvgRadioUnchecked(props) {
  return /*#__PURE__*/createElement("svg", _extends$iy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iy);
}

function _extends$iz() { _extends$iz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iz.apply(this, arguments); }

var _ref$iz = /*#__PURE__*/createElement("path", {
  d: "M15 5H4.751L14.679.967a.499.499 0 00-.359-.933L.73 5.038c-.42.119-.73.506-.73.963v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zM2 15a1 1 0 110-2 1 1 0 010 2zm0-3a1 1 0 110-2 1 1 0 010 2zm1-5v1H1V6h7v2H4V7H3zm8.5 8a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
});

var _ref2$3$ = /*#__PURE__*/createElement("path", {
  d: "M11 9.5a.5.5 0 11-1 0 .5.5 0 011 0zM13 9.5a.5.5 0 11-1 0 .5.5 0 011 0zM11 11.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 10.5a.5.5 0 11-1 0 .5.5 0 011 0zM12 10.5a.5.5 0 11-1 0 .5.5 0 011 0zM13 11.5a.5.5 0 11-1 0 .5.5 0 011 0zM11 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM13 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM14 10.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 12.5a.5.5 0 11-1 0 .5.5 0 011 0zM12 12.5a.5.5 0 11-1 0 .5.5 0 011 0zM14 12.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgRadio(props) {
  return /*#__PURE__*/createElement("svg", _extends$iz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iz, _ref2$3$);
}

function _extends$iA() { _extends$iA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iA.apply(this, arguments); }

var _ref$iA = /*#__PURE__*/createElement("path", {
  d: "M1 13v2l7-3.5 7 3.5v-2L8 9.5z"
});

function SvgRating(props) {
  return /*#__PURE__*/createElement("svg", _extends$iA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iA);
}

function _extends$iB() { _extends$iB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iB.apply(this, arguments); }

var _ref$iB = /*#__PURE__*/createElement("path", {
  d: "M1 13v2l7-3.5 7 3.5v-2L8 9.5zm0-4v2l7-3.5 7 3.5V9L8 5.5z"
});

function SvgRating2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iB);
}

function _extends$iC() { _extends$iC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iC.apply(this, arguments); }

var _ref$iC = /*#__PURE__*/createElement("path", {
  d: "M1 13v2l7-3.5 7 3.5v-2L8 9.5zm0-4v2l7-3.5 7 3.5V9L8 5.5zm7-7.5L1 5v2l7-3.5L15 7V5z"
});

function SvgRating3(props) {
  return /*#__PURE__*/createElement("svg", _extends$iC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iC);
}

function _extends$iD() { _extends$iD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iD.apply(this, arguments); }

var _ref$iD = /*#__PURE__*/createElement("path", {
  d: "M5.5 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm10.281 8.875l-4-5A.996.996 0 0011 6H5a.998.998 0 00-.781.375l-4 5a.999.999 0 00.977 1.606L4 12.42V16h8v-3.58l2.804.561a1 1 0 00.977-1.606zM11 10.18l-.804-.161a1 1 0 00-.393 1.961l1.196.239v.78l-3 1-3-1v-.78l1.196-.239a.999.999 0 10-.393-1.961l-.804.161V8l3 1 3-1v2.18z"
});

function SvgReading(props) {
  return /*#__PURE__*/createElement("svg", _extends$iD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iD);
}

function _extends$iE() { _extends$iE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iE.apply(this, arguments); }

var _ref$iE = /*#__PURE__*/createElement("path", {
  d: "M11 4a3 3 0 11-6 0 3 3 0 016 0zM9.5 10a.5.5 0 000-1h-3a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h3a.5.5 0 000-1H7v-2h2.5a.5.5 0 000-1H7v-2h2.5zM4 11c0-1.103-.897-2-2-2H.5a.5.5 0 00-.5.5v6a.5.5 0 001 0V13h.691l1.362 2.724a.501.501 0 00.895-.447l-1.209-2.418a2.003 2.003 0 001.262-1.858zm-2 1H1v-2h1c.551 0 1 .449 1 1s-.449 1-1 1zM15.5 15H14c-.551 0-1-.449-1-1v-3c0-.551.449-1 1-1h1.5a.5.5 0 000-1H14c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h1.5a.5.5 0 000-1z"
});

function SvgRecording(props) {
  return /*#__PURE__*/createElement("svg", _extends$iE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iE);
}

function _extends$iF() { _extends$iF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iF.apply(this, arguments); }

var _ref$iF = /*#__PURE__*/createElement("path", {
  d: "M4 10a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm.049 2.137a.593.593 0 11.735.933c-.717.565-1.81.93-2.783.93s-2.066-.365-2.784-.93a.593.593 0 11.735-.933c.413.325 1.23.675 2.049.675s1.636-.35 2.049-.675zM16 8a2 2 0 00-3.748-.972c-1.028-.562-2.28-.926-3.645-1.01L9.8 3.338l2.284.659a1.5 1.5 0 10.094-1.209l-2.545-.735a.593.593 0 00-.707.329L7.305 6.023c-1.33.094-2.551.453-3.557 1.004a2 2 0 10-2.555 2.802A3.661 3.661 0 001 10.999c0 2.761 3.134 5 7 5s7-2.239 7-5c0-.403-.067-.795-.193-1.17A2 2 0 0016 7.999zm-2.5-5.062a.563.563 0 110 1.126.563.563 0 010-1.126zM1 8a1 1 0 011.904-.427 5.292 5.292 0 00-1.276 1.355A1.001 1.001 0 011 8zm7 6.813c-3.21 0-5.813-1.707-5.813-3.813S4.789 7.187 8 7.187c3.21 0 5.813 1.707 5.813 3.813S11.211 14.813 8 14.813zm6.372-5.885a5.276 5.276 0 00-1.276-1.355C13.257 7.235 13.601 7 14 7a1.001 1.001 0 01.372 1.928z"
});

function SvgReddit(props) {
  return /*#__PURE__*/createElement("svg", _extends$iF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iF);
}

function _extends$iG() { _extends$iG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iG.apply(this, arguments); }

var _ref$iG = /*#__PURE__*/createElement("path", {
  d: "M0 9a7.982 7.982 0 002.709 6l1.323-1.5a6 6 0 118.212-8.743L10.001 7h6V1l-2.343 2.343A8 8 0 00.001 9z"
});

function SvgRedo(props) {
  return /*#__PURE__*/createElement("svg", _extends$iG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iG);
}

function _extends$iH() { _extends$iH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iH.apply(this, arguments); }

var _ref$iH = /*#__PURE__*/createElement("path", {
  d: "M9 3.881V0l6 6-6 6V8.034C2.02 7.87 2.319 12.781 4.096 16-.29 11.259.641 3.663 9 3.881z"
});

function SvgRedo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iH);
}

function _extends$iI() { _extends$iI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iI.apply(this, arguments); }

var _ref$iI = /*#__PURE__*/createElement("path", {
  d: "M14.964 7.134c-.809-.467-1.915-.854-2.865-1.134.95-.28 2.056-.667 2.865-1.134a1 1 0 00-1-1.732c-.809.467-1.697 1.232-2.415 1.914.232-.963.45-2.114.45-3.048a1 1 0 00-2 0c0 .934.218 2.086.45 3.048-.717-.683-1.606-1.447-2.415-1.914a1 1 0 00-1 1.732c.809.467 1.915.854 2.865 1.134-.95.28-2.056.667-2.865 1.134a1 1 0 001 1.732c.809-.467 1.697-1.232 2.415-1.914-.232.963-.45 2.114-.45 3.048a1 1 0 002 0c0-.934-.218-2.086-.45-3.048.717.683 1.606 1.447 2.415 1.914a1 1 0 001-1.732zM7 13.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 017 13.5zM0 16L4 0h2L2 16zM15 16l4-16h2l-4 16z"
});

function SvgRegexp(props) {
  return /*#__PURE__*/createElement("svg", _extends$iI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16"
  }, props), _ref$iI);
}

function _extends$iJ() { _extends$iJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iJ.apply(this, arguments); }

var _ref$iJ = /*#__PURE__*/createElement("path", {
  d: "M15.15 0H3.915c-.562 0-1.106.442-1.21.983L.017 15.017c-.104.541.271.983.833.983h11.235c.562 0 1.106-.442 1.21-.983L15.983.983C16.087.442 15.712 0 15.15 0zm-3.186 9.134a1 1 0 01-1 1.732c-.809-.467-1.697-1.232-2.415-1.914.232.963.45 2.114.45 3.048a1 1 0 01-2 0c0-.934.218-2.085.45-3.048-.717.683-1.606 1.447-2.415 1.914a1 1 0 01-1-1.732C4.843 8.667 5.949 8.28 6.899 8c-.95-.28-2.056-.667-2.865-1.134a1 1 0 011-1.732c.809.467 1.697 1.232 2.415 1.914-.232-.963-.45-2.114-.45-3.048a1 1 0 012 0c0 .934-.218 2.086-.45 3.048.717-.683 1.606-1.447 2.415-1.914a1 1 0 011 1.732c-.809.467-1.915.854-2.865 1.134.95.28 2.056.667 2.865 1.134z"
});

function SvgRegexp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iJ);
}

function _extends$iK() { _extends$iK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iK.apply(this, arguments); }

var _ref$iK = /*#__PURE__*/createElement("path", {
  d: "M13.621 7.015L8 5.61V4.12c1.012.585 1.852.881 2.5.881 1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5c-.708 0-1.644.353-2.784 1.05a.5.5 0 00-.216-.05h-2a.493.493 0 00-.216.05C4.144.355 3.208.001 2.5.001 1.121.001 0 1.122 0 2.501s1.121 2.5 2.5 2.5c.648 0 1.488-.296 2.5-.881v5L3.384 7.181a.5.5 0 00-.661-.096l-1.5 1a.5.5 0 00-.147.681l2.5 4c.02.032.044.062.07.088l3 3A.5.5 0 007 16h5a.5.5 0 00.447-.276l1.5-3A.496.496 0 0014 12.5v-5a.5.5 0 00-.379-.485zM12 2.5c0 .827-.673 1.5-1.5 1.5-.673 0-1.677-.526-2.5-1.05v-.9C8.823 1.525 9.827 1 10.5 1c.827 0 1.5.673 1.5 1.5zM2.5 4C1.673 4 1 3.327 1 2.5S1.673 1 2.5 1c.673 0 1.677.526 2.5 1.05v.9C4.177 3.475 3.173 4 2.5 4zM13 12.382L11.691 15H7.207l-2.813-2.813-2.212-3.54.722-.481 2.212 2.655a.499.499 0 00.884-.32V3.487c.197-.135.367-.258.5-.357.133.098.303.221.5.357v6.014a.5.5 0 001 0v-2.86l1 .25v2.61a.5.5 0 001 0v-2.36l1 .25v3.11a.5.5 0 001 0v-2.86l1 .25v4.492z"
});

function SvgReminder(props) {
  return /*#__PURE__*/createElement("svg", _extends$iK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iK);
}

function _extends$iL() { _extends$iL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iL.apply(this, arguments); }

var _ref$iL = /*#__PURE__*/createElement("path", {
  d: "M6.644.166C2.875.8 0 4.079 0 8.028a7.96 7.96 0 001.887 5.15c2.791-1.35 4.744-4.406 4.756-7.966V.165zM9.356.166C13.125.8 16 4.079 16 8.028a7.96 7.96 0 01-1.887 5.15c-2.791-1.35-4.744-4.406-4.756-7.966V.165zM7.972 10.041c-.497 2.056-1.981 3.813-3.828 4.981 1.138.622 2.441.978 3.828.978s2.691-.356 3.828-.978c-1.847-1.169-3.331-2.925-3.828-4.981z"
});

function SvgRenren(props) {
  return /*#__PURE__*/createElement("svg", _extends$iL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iL);
}

function _extends$iM() { _extends$iM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iM.apply(this, arguments); }

var _ref$iM = /*#__PURE__*/createElement("path", {
  d: "M14.184 0c1.777 3.219 2.297 8.13-4.684 7.966V4.5L4 10l5.5 5.5v-3.381c7 0 9.07-7.378 4.684-12.119z"
});

var _ref2$40 = /*#__PURE__*/createElement("path", {
  d: "M6.5 5.5l-1-1L0 10l5 5 1-1-4-4z"
});

function SvgReplyAll(props) {
  return /*#__PURE__*/createElement("svg", _extends$iM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$iM, _ref2$40);
}

function _extends$iN() { _extends$iN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iN.apply(this, arguments); }

var _ref$iN = /*#__PURE__*/createElement("path", {
  d: "M7 12.119V16l-6-6 6-6v3.966c6.98.164 6.681-4.747 4.904-7.966C16.29 4.741 15.359 12.337 7 12.119z"
});

function SvgReply(props) {
  return /*#__PURE__*/createElement("svg", _extends$iN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iN);
}

function _extends$iO() { _extends$iO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iO.apply(this, arguments); }

var _ref$iO = /*#__PURE__*/createElement("path", {
  d: "M4.126 9A4 4 0 108 6v3L3 5l5-4v3a6 6 0 11-5.916 5h2.043z"
});

function SvgReset(props) {
  return /*#__PURE__*/createElement("svg", _extends$iO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iO);
}

function _extends$iP() { _extends$iP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iP.apply(this, arguments); }

var _ref$iP = /*#__PURE__*/createElement("path", {
  d: "M11 16h5L12 0H9l.5 4h-3L7 0H4L0 16h5l.5-4h5l.5 4zm-5.25-6l.5-4h3.5l.5 4h-4.5z"
});

function SvgRoad(props) {
  return /*#__PURE__*/createElement("svg", _extends$iP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iP);
}

function _extends$iQ() { _extends$iQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iQ.apply(this, arguments); }

var _ref$iQ = /*#__PURE__*/createElement("path", {
  d: "M11 1L6 6H3l-3 4s3.178-.885 5.032-.47L0 16l6.592-5.127C7.511 12.977 6 16 6 16l4-3v-3l5-5 1-5-5 1z"
});

function SvgRocket(props) {
  return /*#__PURE__*/createElement("svg", _extends$iQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iQ);
}

function _extends$iR() { _extends$iR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iR.apply(this, arguments); }

var _ref$iR = /*#__PURE__*/createElement("path", {
  d: "M1 8h10v8H1V8z"
});

var _ref2$41 = /*#__PURE__*/createElement("path", {
  d: "M8.5 4H7V1.5l-3 3 3 3V5h1.5c3.033 0 5.5 2.467 5.5 5.5v2a.5.5 0 001 0v-2C15 6.916 12.084 4 8.5 4z"
});

function SvgRotateCcw(props) {
  return /*#__PURE__*/createElement("svg", _extends$iR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iR, _ref2$41);
}

function _extends$iS() { _extends$iS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iS.apply(this, arguments); }

var _ref$iS = /*#__PURE__*/createElement("path", {
  d: "M2 9a7 7 0 1110.21 6.222C13.876 14.191 15 12.239 15 10c0-3.314-2.462-6-5.5-6-2.725 0-4.987 2.162-5.423 5H6l-3 3.5L0 9h2z"
});

function SvgRotateCcw2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iS);
}

function _extends$iT() { _extends$iT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iT.apply(this, arguments); }

var _ref$iT = /*#__PURE__*/createElement("path", {
  d: "M11 1a7 7 0 00-7 7H.5L5 12.5 9.5 8H6a5 5 0 115 5v2a7 7 0 100-14z"
});

function SvgRotateCcw3(props) {
  return /*#__PURE__*/createElement("svg", _extends$iT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$iT);
}

function _extends$iU() { _extends$iU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iU.apply(this, arguments); }

var _ref$iU = /*#__PURE__*/createElement("path", {
  d: "M15 8H5v8h10V8z"
});

var _ref2$42 = /*#__PURE__*/createElement("path", {
  d: "M7.5 4H9V1.5l3 3-3 3V5H7.5A5.506 5.506 0 002 10.5v2a.5.5 0 01-1 0v-2C1 6.916 3.916 4 7.5 4z"
});

function SvgRotateCw(props) {
  return /*#__PURE__*/createElement("svg", _extends$iU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iU, _ref2$42);
}

function _extends$iV() { _extends$iV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iV.apply(this, arguments); }

var _ref$iV = /*#__PURE__*/createElement("path", {
  d: "M14 9a7 7 0 10-10.21 6.222C2.124 14.191 1 12.239 1 10c0-3.314 2.462-6 5.5-6 2.725 0 4.987 2.162 5.423 5H10l3 3.5L16 9h-2z"
});

function SvgRotateCw2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iV);
}

function _extends$iW() { _extends$iW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iW.apply(this, arguments); }

var _ref$iW = /*#__PURE__*/createElement("path", {
  d: "M7 1a7 7 0 017 7h3.5L13 12.5 8.5 8H12a5 5 0 10-5 5v2A7 7 0 117 1z"
});

function SvgRotateCw3(props) {
  return /*#__PURE__*/createElement("svg", _extends$iW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$iW);
}

function _extends$iX() { _extends$iX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iX.apply(this, arguments); }

var _ref$iX = /*#__PURE__*/createElement("path", {
  d: "M2.13 11.733c-1.175 0-2.13.958-2.13 2.126 0 1.174.955 2.122 2.13 2.122a2.126 2.126 0 002.133-2.122 2.133 2.133 0 00-2.133-2.126zM.002 5.436v3.067c1.997 0 3.874.781 5.288 2.196a7.45 7.45 0 012.192 5.302h3.08c0-5.825-4.739-10.564-10.56-10.564zM.006 0v3.068C7.128 3.068 12.924 8.87 12.924 16H16C16 7.18 8.824 0 .006 0z"
});

function SvgRss(props) {
  return /*#__PURE__*/createElement("svg", _extends$iX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iX);
}

function _extends$iY() { _extends$iY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iY.apply(this, arguments); }

var _ref$iY = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM4.359 12.988c-.75 0-1.359-.603-1.359-1.353a1.36 1.36 0 012.718 0c0 .75-.609 1.353-1.359 1.353zM7.772 13a4.753 4.753 0 00-1.397-3.381A4.74 4.74 0 003 8.219V6.263c3.713 0 6.738 3.022 6.738 6.737H7.772zm3.472 0c0-4.547-3.697-8.25-8.241-8.25V2.794c5.625 0 10.203 4.581 10.203 10.206h-1.963z"
});

function SvgRss2(props) {
  return /*#__PURE__*/createElement("svg", _extends$iY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iY);
}

function _extends$iZ() { _extends$iZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$iZ.apply(this, arguments); }

var _ref$iZ = /*#__PURE__*/createElement("path", {
  d: "M4 0a4 4 0 000 8v8h2V2h2v14h2V2h2V0H4zm12 3l-4 4 4 4z"
});

function SvgRtl(props) {
  return /*#__PURE__*/createElement("svg", _extends$iZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$iZ);
}

function _extends$i_() { _extends$i_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i_.apply(this, arguments); }

var _ref$i_ = /*#__PURE__*/createElement("path", {
  d: "M7 0a3 3 0 100 6v5h1V1h1v10h1V1h2V0H7z"
});

var _ref2$43 = /*#__PURE__*/createElement("path", {
  d: "M4 12V9.5l-3 3 3 3V13h8v-1z"
});

function SvgRtl2(props) {
  return /*#__PURE__*/createElement("svg", _extends$i_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i_, _ref2$43);
}

function _extends$i$() { _extends$i$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i$.apply(this, arguments); }

var _ref$i$ = /*#__PURE__*/createElement("path", {
  d: "M16 8H0v6h16V8zm-2 5v-1h-1v1h-1v-2h-1v2h-1v-1H9v1H8v-2H7v2H6v-1H5v1H4v-2H3v2H1V9h14v4h-1z"
});

function SvgRuler(props) {
  return /*#__PURE__*/createElement("svg", _extends$i$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$i$);
}

function _extends$j0() { _extends$j0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j0.apply(this, arguments); }

var _ref$j0 = /*#__PURE__*/createElement("path", {
  d: "M8 2V0H2v2H0v6h2v8h6V8h8V2H8zM2 7H1V3h1v4zm5-5H5v1h2v1H5v1h2v1H5v1h2v1H5v1h2v1H5v1h2v1H5v1h2v2H3V1h4v1zm8 5h-1V5h-1v2h-1V5h-1v2h-1V5H9v2H8V3h7v4z"
});

function SvgRulers(props) {
  return /*#__PURE__*/createElement("svg", _extends$j0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j0);
}

function _extends$j1() { _extends$j1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j1.apply(this, arguments); }

var _ref$j1 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm-5.002 7.199l-1.286-.772C4.586 9.973 6.179 9 8 9s3.413.973 4.288 2.427l-1.286.772C10.39 11.181 9.275 10.5 8 10.5s-2.389.681-3.002 1.699z"
});

function SvgSad(props) {
  return /*#__PURE__*/createElement("svg", _extends$j1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j1);
}

function _extends$j2() { _extends$j2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j2.apply(this, arguments); }

var _ref$j2 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm6.002 8.199C10.39 11.181 9.275 10.5 8 10.5s-2.389.681-3.002 1.699l-1.286-.772C4.586 9.973 6.179 9 8 9s3.414.973 4.288 2.427l-1.286.772z"
});

function SvgSad2(props) {
  return /*#__PURE__*/createElement("svg", _extends$j2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j2);
}

function _extends$j3() { _extends$j3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j3.apply(this, arguments); }

var _ref$j3 = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zm6.975 7.388l-.016-.166c.003.056.009.109.016.166zM13.881 4.2l-.113-.169.113.169zm-.434-.597l-.069-.084c.025.028.047.056.069.084zm-.969-.984l-.084-.069.084.069zm-.509-.388l-.169-.112.169.112zM8.778 1.044l-.169-.016c.056.003.113.009.169.016zm-1.39-.019l-.169.016c.056-.003.112-.009.169-.016zM4.2 2.119l-.169.112.169-.112zm-.597.434l-.081.066.081-.066zm-.984.969l-.069.084c.025-.028.047-.056.069-.084zm-.388.509l-.112.169.112-.169zM1.044 7.222l-.016.169c.003-.056.009-.112.016-.169zm-.019 1.391l.016.169a2.413 2.413 0 00-.016-.169zm1.094 3.184l.112.169a2.915 2.915 0 01-.112-.169zm.131.197l1.247-.834-.138-.209-1.247.834A6.936 6.936 0 011.049 8.81l.747-.075-.025-.25-.747.075a7.016 7.016 0 01-.022-.438h1.5v-.25h-1.5a6.42 6.42 0 01.022-.438l.747.072.025-.25-.747-.072a6.94 6.94 0 011.066-2.975l1.247.834.138-.209-1.25-.828c.084-.119.169-.237.259-.35l.578.475.159-.194-.578-.475c.094-.112.194-.219.294-.325l1.059 1.059.178-.178L3.14 2.959c.106-.1.212-.2.322-.294l.475.581.194-.159-.475-.578c.116-.091.231-.178.35-.263l.834 1.247.209-.138-.834-1.247A6.941 6.941 0 017.19 1.045l.075.747.25-.025-.075-.747c.144-.012.291-.019.438-.022v1.5h.25v-1.5c.147.003.291.009.438.022l-.072.747.25.025.072-.747a6.94 6.94 0 012.975 1.066l-.834 1.247.209.138L12 2.249c.119.084.238.169.35.259l-.475.578.194.159.475-.578c.113.094.219.194.325.294l-.4.391L7 6.999l-3.647 5.469-.391.391a9.82 9.82 0 01-.294-.322l.578-.475-.159-.194-.578.475a6.874 6.874 0 01-.259-.35zm.369.484l-.066-.081.066.081zm.903.903l.081.066-.081-.066zm.509.385l.169.113a2.618 2.618 0 01-.169-.113zm3.191 1.19l.169.016a2.471 2.471 0 01-.169-.016zm1.391.019l.166-.016a2.387 2.387 0 00-.166.016zm3.187-1.094l.169-.113-.169.113zm.597-.434l.084-.069c-.028.025-.056.047-.084.069zm.547-.491l.012-.012-.012.012zm.437-.478l.069-.084c-.025.028-.047.056-.069.084zm.11-.134l-.578-.475-.159.194.578.475c-.094.113-.194.219-.294.325l-1.059-1.059-.178.178 1.059 1.059c-.106.1-.213.2-.322.294l-.475-.581-.194.159.475.578a8.61 8.61 0 01-.35.262l-.834-1.247-.209.137.834 1.247a6.936 6.936 0 01-2.975 1.063l-.075-.747-.25.025.075.747a7.016 7.016 0 01-.438.022v-1.5h-.25V15a6.42 6.42 0 01-.438-.022l.072-.747-.25-.025-.072.747a6.94 6.94 0 01-2.975-1.066l.834-1.247-.209-.137-.828 1.247a7.532 7.532 0 01-.35-.259l.475-.578-.194-.159-.475.578a7.556 7.556 0 01-.325-.294l.394-.391L9 9l3.647-5.469.391-.391c.1.106.2.212.294.322l-.578.475.159.194.578-.475c.091.116.178.231.262.35l-1.247.834.137.209 1.247-.834a6.941 6.941 0 011.063 2.975l-.747.075.025.25.747-.075c.012.144.019.291.022.438h-1.5v.25H15a6.42 6.42 0 01-.022.438l-.747-.072-.025.25.747.072a6.94 6.94 0 01-1.066 2.975l-1.247-.834-.137.209L13.75 12c-.081.113-.169.228-.259.344zm1.484-3.735c-.006.056-.009.113-.016.169l.016-.169zM13.881 11.8l-.113.169.113-.169z"
});

var _ref2$44 = /*#__PURE__*/createElement("path", {
  d: "M6.758 1.111l.293 1.471-.245.049-.293-1.471.245-.049zM9.245 14.89l-.293-1.471.245-.049.293 1.471-.245.049zM6.088 1.264l.218.718-.239.073-.218-.718.239-.073zM9.913 14.733l-.218-.718.239-.073.218.718-.239.073zM5.438 1.486l.574 1.386-.231.096-.574-1.386.231-.096zM10.564 14.515l-.574-1.386.231-.096.574 1.386-.231.096zM4.588 1.885l.22-.118.354.661-.22.118-.354-.661zM11.408 14.114l-.22.118-.354-.661.22-.118.354.661zM1.884 4.591l.662.353-.118.221-.661-.353.118-.221zM14.113 11.409l-.662-.353.118-.22.662.353-.118.22zM2.872 6.01l-1.386-.574.096-.231 1.386.574-.096.231zM13.13 9.989l1.386.574-.096.231-1.386-.574.096-.231zM1.337 5.85l.718.218-.073.239-.718-.218.073-.239zM14.661 10.151l-.718-.218.073-.239.718.218-.073.239zM1.157 6.512l1.471.293-.049.245-1.471-.293.049-.245zM14.84 9.488l-1.471-.293.049-.245 1.471.293-.049.245zM1.109 9.243L2.58 8.95l.049.245-1.471.293-.049-.245zM14.888 6.757l-1.471.293-.049-.245 1.471-.293.049.245zM1.265 9.914l.718-.218.073.239-.718.218-.073-.239zM14.734 6.089l-.718.218-.073-.239.718-.218.073.239zM1.58 10.796l-.096-.231 1.386-.574.096.231-1.386.574zM14.419 5.207l.096.231-1.386.574-.096-.231 1.386-.574zM1.888 11.41l-.118-.22.661-.354.118.22-.661.354zM14.116 4.59l.118.22-.661.354-.118-.22.661-.354zM4.811 14.232l-.22-.118.354-.661.22.118-.354.661zM11.189 1.767l.22.118-.353.661-.22-.118.353-.661zM5.207 14.419l.574-1.386.231.096-.574 1.386-.231-.096zM10.795 1.58l-.574 1.386-.231-.096.574-1.386.231.096zM6.088 14.735l-.239-.073.218-.718.239.073-.218.718zM9.912 1.264l.239.073-.218.718-.239-.073.218-.718zM6.757 14.888l-.245-.049.293-1.471.245.049-.293 1.471zM9.243 1.109l.245.049-.293 1.471-.245-.049.293-1.471z"
});

function SvgSafari(props) {
  return /*#__PURE__*/createElement("svg", _extends$j3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j3, _ref2$44);
}

function _extends$j4() { _extends$j4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j4.apply(this, arguments); }

var _ref$j4 = /*#__PURE__*/createElement("path", {
  d: "M15 0H2a1 1 0 00-1 1v1H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H1v4H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H1v1a1 1 0 001 1h13a1 1 0 001-1V1a1 1 0 00-1-1zm-1 14H3V2h11v12z"
});

var _ref2$45 = /*#__PURE__*/createElement("path", {
  d: "M10 8.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0110 8.5z"
});

var _ref3$r = /*#__PURE__*/createElement("path", {
  d: "M4 3v10h9V3H4zm4.5 8a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgSafe(props) {
  return /*#__PURE__*/createElement("svg", _extends$j4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j4, _ref2$45, _ref3$r);
}

function _extends$j5() { _extends$j5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j5.apply(this, arguments); }

var _ref$j5 = /*#__PURE__*/createElement("path", {
  d: "M15.973.625a.47.47 0 00-.598-.598L9.884 1.978a12.568 12.568 0 00-1.014-.634C7.746.716 6.699.384 5.844.384c-.679 0-1.25.212-1.651.613-.201.201-.352.44-.454.712a7.944 7.944 0 0010.565 10.548c.269-.103.505-.253.7-.448.757-.757.813-2.049.158-3.639a11.112 11.112 0 00-1.14-2.053l1.95-5.49zm-3.915 8.218a.47.47 0 00.884.314l.653-1.837c.264.435.485.863.656 1.278.427 1.037.483 1.891.147 2.228-.145.145-.382.218-.705.218-1.159 0-3.319-.99-5.532-3.203-1.302-1.302-2.31-2.726-2.838-4.009-.427-1.037-.484-1.891-.147-2.228.145-.145.382-.218.705-.218.664 0 1.658.326 2.801 1.02l-1.838.653a.47.47 0 00.314.884l6.574-2.336L9.169 6.17a.469.469 0 00.662.663l4.563-4.563-2.336 6.574zM9 15.5V15c0-.248-.03-.488-.087-.718a9.356 9.356 0 01-4.097-2.039A3 3 0 003 15v.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5z"
});

function SvgSatelliteDish(props) {
  return /*#__PURE__*/createElement("svg", _extends$j5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j5);
}

function _extends$j6() { _extends$j6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j6.apply(this, arguments); }

var _ref$j6 = /*#__PURE__*/createElement("path", {
  d: "M15 0a1 1 0 00-.876 1.483l-5.5 3.931a7.985 7.985 0 001.962 1.962l3.931-5.5A1 1 0 1015 0z"
});

var _ref2$46 = /*#__PURE__*/createElement("path", {
  d: "M13.476 5.374l-.619.866c.605.799 1.082 1.602 1.393 2.357.427 1.037.483 1.891.147 2.228-.145.145-.382.218-.705.218-1.159 0-3.319-.99-5.532-3.203-1.302-1.302-2.31-2.726-2.838-4.009-.427-1.037-.484-1.891-.147-2.228.145-.145.382-.218.705-.218.867 0 2.292.554 3.881 1.757l.865-.618A13.639 13.639 0 008.87 1.343C7.746.715 6.699.383 5.844.383c-.679 0-1.25.212-1.651.613-.201.201-.352.44-.454.712a7.944 7.944 0 0010.565 10.548c.269-.103.505-.253.7-.448.757-.757.813-2.049.158-3.639-.372-.902-.952-1.859-1.686-2.794zM9 15.5V15c0-.248-.03-.488-.087-.718a9.356 9.356 0 01-4.097-2.039A3 3 0 003 15v.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5z"
});

function SvgSatelliteDish2(props) {
  return /*#__PURE__*/createElement("svg", _extends$j6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j6, _ref2$46);
}

function _extends$j7() { _extends$j7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j7.apply(this, arguments); }

var _ref$j7 = /*#__PURE__*/createElement("path", {
  d: "M13.5 1h-12C.675 1 0 1.675 0 2.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5zm-3 7H8V4.5a.5.5 0 00-1 0V8H4.5L2.567 6.067a5.5 5.5 0 019.866 0L10.5 8z"
});

function SvgScale(props) {
  return /*#__PURE__*/createElement("svg", _extends$j7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j7);
}

function _extends$j8() { _extends$j8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j8.apply(this, arguments); }

var _ref$j8 = /*#__PURE__*/createElement("path", {
  d: "M12.218 16c-.85 0-1.912-.519-2.369-1.678-.064-.151-.133-.335-.214-.547-.259-.68-.65-1.707-1.059-2.132-.15-.156-.265-.269-.359-.36A4.882 4.882 0 018 11.064c-.063.069-.134.138-.217.219-.093.091-.209.204-.358.359-.409.425-.8 1.453-1.059 2.132-.081.212-.151.396-.214.547-.457 1.159-1.519 1.678-2.369 1.678-.166 0-.317-.02-.449-.06-.837-.251-1.344-1.186-1.263-2.325l.012-.131c.103-.919.662-1.827 1.576-2.556.792-.632 1.728-1.025 2.444-1.025.142 0 .272.015.391.046l.491-1.007A106.151 106.151 0 015.2 4.14a32.176 32.176 0 01-.69-2.241c-.23-.897-.215-1.2-.122-1.379L4.657 0l3.345 6.858L11.347 0l.269.52c.093.179.107.483-.122 1.379a32.011 32.011 0 01-.69 2.241 106.151 106.151 0 01-1.785 4.801l.491 1.007c.119-.031.25-.046.391-.046.715 0 1.652.393 2.444 1.025.781.624 1.304 1.378 1.503 2.158l.037-.018.048.548c.081 1.139-.426 2.073-1.263 2.325-.132.04-.283.06-.449.06zm-1.379-2.22c.592 1.074 1.12 1.234 1.383 1.234.358 0 .626-.289.678-.568a1.88 1.88 0 00.018-.561c-.089-.755-.604-1.403-1.021-1.814-.573-.565-1.215-.939-1.628-1.103a.247.247 0 00-.089-.015c-.12.078-.264.985.658 2.827zm-5.116-2.812c-.41.164-1.048.539-1.618 1.103-.414.411-.927 1.059-1.015 1.814-.022.188-.016.377.018.561.052.279.318.568.674.568.261 0 .787-.161 1.375-1.234.916-1.842.774-2.748.653-2.828s-.004-.001-.01-.001a.242.242 0 00-.077.016z"
});

function SvgScissors(props) {
  return /*#__PURE__*/createElement("svg", _extends$j8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j8);
}

function _extends$j9() { _extends$j9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j9.apply(this, arguments); }

var _ref$j9 = /*#__PURE__*/createElement("path", {
  d: "M4.655 0l-.269.52c-.093.179-.107.483.122 1.379.145.566.377 1.321.69 2.241a97.028 97.028 0 001.29 3.536l.955-1.959L4.654-.001zm9.275 13.616l-.048-.548-.037.018c-.199-.78-.722-1.534-1.503-2.158-.792-.633-1.729-1.025-2.444-1.025-.142 0-.272.015-.391.046l-.491-1.007a104.954 104.954 0 001.785-4.801c.313-.921.545-1.675.69-2.241.23-.897.215-1.2.122-1.379l-.269-.52-4.852 9.948a1.553 1.553 0 00-.391-.046c-.715 0-1.652.393-2.444 1.025-.914.73-1.473 1.638-1.576 2.556l-.012.131c-.081 1.139.426 2.073 1.263 2.325.132.04.283.06.449.06.85 0 1.912-.519 2.369-1.678.064-.151.133-.335.214-.547.259-.68.65-1.707 1.059-2.132a13.5 13.5 0 01.358-.359c.084-.082.154-.15.217-.219.063.069.134.138.217.219.093.091.209.204.359.36.409.425.8 1.453 1.059 2.132.081.212.151.396.214.547.457 1.159 1.519 1.678 2.369 1.678.166 0 .317-.02.449-.06.837-.252 1.344-1.186 1.263-2.325zm-8.773.164c-.588 1.073-1.114 1.234-1.375 1.234-.356 0-.622-.289-.674-.568a1.882 1.882 0 01-.018-.561c.088-.755.6-1.403 1.015-1.814.569-.565 1.208-.939 1.618-1.103a.247.247 0 01.077-.016l.01.001c.001 0 0 0 0 0 .121.08.263.986-.653 2.828zm7.743.666c-.052.279-.32.568-.678.568-.263 0-.791-.161-1.383-1.234-.922-1.842-.778-2.749-.658-2.827l.011-.001c.011 0 .037.002.078.016.412.164 1.055.539 1.628 1.103.417.411.933 1.059 1.021 1.814a1.88 1.88 0 01-.018.561z"
});

function SvgScissors2(props) {
  return /*#__PURE__*/createElement("svg", _extends$j9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j9);
}

function _extends$ja() { _extends$ja = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ja.apply(this, arguments); }

var _ref$ja = /*#__PURE__*/createElement("path", {
  d: "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-.1.064-.193.138-.277.218L8.769 7.295l2.867-4.5c.235-.433.321-.949.207-1.468A2.12 2.12 0 0011.091.12l-.192-.122-3.398 5.314L4.103-.002 3.911.12a2.12 2.12 0 00-.545 2.675l2.867 4.5-1.241 1.942a1.834 1.834 0 00-.277-.218c-1.163-.744-2.95-.028-3.992 1.601s-.944 3.551.219 4.296c1.163.744 2.95.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667.219-4.296zM3.67 12.507c-.469.733-1.071 1.089-1.478 1.179-.133.029-.317.047-.443-.033-.139-.089-.231-.324-.247-.629-.025-.494.151-1.076.483-1.594.469-.733 1.071-1.089 1.478-1.179.133-.029.317-.047.443.033.139.089.231.324.247.629.025.495-.151 1.076-.483 1.594zM7.5 8a.5.5 0 110-1 .5.5 0 010 1zm5.998 5.023c-.016.305-.108.54-.247.629-.125.08-.31.062-.443.033-.407-.089-1.009-.446-1.478-1.179-.332-.519-.508-1.1-.483-1.594.016-.305.108-.54.247-.629.125-.08.31-.062.443-.033.407.089 1.009.446 1.478 1.179.332.519.508 1.1.483 1.594z"
});

function SvgScissors3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ja({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ja);
}

function _extends$jb() { _extends$jb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jb.apply(this, arguments); }

var _ref$jb = /*#__PURE__*/createElement("path", {
  d: "M15.852 12.352L9.648 6.148c-.345-.345-1.2-.067-2.043.617L3 2.16 2.5 1 .899 0 0 .899 1 2.5l1.16.5 4.605 4.605c-.685.843-.962 1.698-.617 2.043l6.203 6.203c.405.405 1.518-.049 2.484-1.016s1.421-2.079 1.016-2.484zM13.92 13.92a.592.592 0 01-.84 0l-5-5a.594.594 0 11.84-.84l5 5a.594.594 0 010 .84z"
});

function SvgScrewdriver(props) {
  return /*#__PURE__*/createElement("svg", _extends$jb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jb);
}

function _extends$jc() { _extends$jc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jc.apply(this, arguments); }

var _ref$jc = /*#__PURE__*/createElement("path", {
  d: "M15.852 12.352l-3.403-3.403a2.002 2.002 0 01-2.398-2.398l-.403-.403c-.345-.345-1.2-.067-2.043.617L3 2.16 2.5 1 .899 0 0 .899 1 2.5l1.16.5 4.605 4.605c-.685.843-.962 1.698-.617 2.043l.403.403a2.002 2.002 0 012.398 2.398l3.403 3.403c.405.405 1.518-.049 2.484-1.016s1.421-2.079 1.016-2.484zM13.92 13.92a.592.592 0 01-.84 0l-5-5a.594.594 0 11.84-.84l5 5a.594.594 0 010 .84z"
});

function SvgScrewdriver2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jc);
}

function _extends$jd() { _extends$jd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jd.apply(this, arguments); }

var _ref$jd = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  d: "M23.345 0c12.893 0 23.344 10.453 23.344 23.347 0 3.943-.978 7.657-2.704 10.914l18.267 18.27s4.26 4.387-.52 9.186c-4.78 4.8-9.207.541-9.207.541L34.258 43.989a23.238 23.238 0 01-10.913 2.705C10.452 46.694 0 36.24 0 23.347 0 10.453 10.452 0 23.345 0zm0 7.782c-8.596 0-15.563 6.97-15.563 15.565 0 8.596 6.967 15.564 15.563 15.564 8.595 0 15.563-6.968 15.563-15.564 0-8.597-6.968-15.565-15.563-15.565zm1.988 5.551v8h8v4h-8v8h-4v-8h-8v-4h8v-8h4z"
});

function SvgSearchPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$jd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref$jd);
}

function _extends$je() { _extends$je = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$je.apply(this, arguments); }

var _ref$je = /*#__PURE__*/createElement("path", {
  d: "M16 13.5l-4.695-4.695a6 6 0 10-2.5 2.5L13.5 16l2.5-2.5zM2 6a4 4 0 118 0 4 4 0 01-8 0z"
});

function SvgSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$je({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$je);
}

function _extends$jf() { _extends$jf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jf.apply(this, arguments); }

var _ref$jf = /*#__PURE__*/createElement("path", {
  d: "M9.962 8.716A5.5 5.5 0 100 5.5a5.5 5.5 0 008.716 4.462L14 16l2-2-6.038-5.284zM5.5 9.5a4 4 0 110-8 4 4 0 010 8z"
});

function SvgSearch2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jf);
}

function _extends$jg() { _extends$jg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jg.apply(this, arguments); }

var _ref$jg = /*#__PURE__*/createElement("path", {
  d: "M15.504 13.616l-3.79-3.223c-.392-.353-.811-.514-1.149-.499a6 6 0 10-.672.672c-.016.338.146.757.499 1.149l3.223 3.79c.552.613 1.453.665 2.003.115s.498-1.452-.115-2.003zM6 10a4 4 0 110-8 4 4 0 010 8z"
});

function SvgSearch3(props) {
  return /*#__PURE__*/createElement("svg", _extends$jg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jg);
}

function _extends$jh() { _extends$jh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jh.apply(this, arguments); }

var _ref$jh = /*#__PURE__*/createElement("path", {
  d: "M15.504 13.616l-3.79-3.223c-.392-.353-.811-.514-1.149-.499a6 6 0 10-.672.672c-.016.338.146.757.499 1.149l3.223 3.79c.552.613 1.453.665 2.003.115s.498-1.452-.115-2.003zM8.977 9.125H3.023a4.777 4.777 0 01-.243-.25h6.439c-.078.086-.158.17-.243.25zm-4.241 1a4.35 4.35 0 01-.634-.25h3.796a4.35 4.35 0 01-.634.25H4.735zm-1.077-.5a4.502 4.502 0 01-.348-.25h5.378a4.502 4.502 0 01-.348.25H3.659zm-1.086-1a4.93 4.93 0 01-.179-.25h7.211a4.374 4.374 0 01-.179.25H2.572zm-.332-.5a5.396 5.396 0 01-.132-.25h7.782a3.974 3.974 0 01-.132.25H2.24zm-.243-.5a4.138 4.138 0 01-.093-.25h8.19c-.028.085-.06.168-.093.25H1.998zm-.169-.5a5.059 5.059 0 01-.06-.25h8.461a3.498 3.498 0 01-.06.25H1.829zM1.681 6l.002-.125h8.635L10.32 6l-.002.125H1.683L1.681 6zm1.342-3.125h5.954c.084.08.165.163.243.25H2.781c.078-.087.158-.17.243-.25zm4.241-1c.219.067.431.151.634.25H4.102a4.35 4.35 0 01.634-.25h2.529zm1.077.5c.12.078.236.161.348.25H3.311c.112-.089.228-.172.348-.25h4.682zm1.086 1c.062.081.122.164.179.25H2.395c.057-.086.116-.169.179-.25h6.854zm.332.5c.046.082.09.165.132.25H2.109c.041-.085.085-.168.132-.25H9.76zm.243.5c.034.082.065.165.093.25h-8.19c.028-.085.06-.168.093-.25h8.004zm.169.5c.022.082.042.166.06.25H1.77c.017-.084.038-.168.06-.25h8.341zm.103.5c.012.083.022.166.029.25H1.697c.007-.084.017-.167.029-.25h8.548zm.029 1a4.156 4.156 0 01-.029.25H1.726a4.156 4.156 0 01-.029-.25h8.606z"
});

function SvgSearch4(props) {
  return /*#__PURE__*/createElement("svg", _extends$jh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jh);
}

function _extends$ji() { _extends$ji = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ji.apply(this, arguments); }

var _ref$ji = /*#__PURE__*/createElement("path", {
  d: "M5 0a5 5 0 014.171 7.758v-.001l1.099 1.099c.545-.3 1.058-.357 1.319-.095l4.243 4.243c.391.391.074 1.34-.707 2.121s-1.731 1.098-2.121.707l-4.243-4.243c-.262-.262-.206-.774.095-1.319L7.757 9.171l.002-.001A5 5 0 115 0zM2.172 7.828C2.928 8.584 3.932 9 5 9s2.073-.416 2.828-1.172C8.584 7.073 9 6.068 9 5s-.416-2.073-1.172-2.828C7.072 1.416 6.068 1 5 1s-2.073.416-2.828 1.172C1.416 2.928 1 3.932 1 5s.416 2.073 1.172 2.828zM8 5c0 .45-.099.877-.277 1.26A4.502 4.502 0 003.74 2.277 3 3 0 018 5z"
});

function SvgSearch5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ji({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ji);
}

function _extends$jj() { _extends$jj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jj.apply(this, arguments); }

var _ref$jj = /*#__PURE__*/createElement("path", {
  d: "M13.772 14.748l-3.975-5.84a.362.362 0 00-.479-.106l-.502.302a.361.361 0 00-.132.472l3.29 6.252a.315.315 0 00.446.125l1.253-.753a.315.315 0 00.099-.452zM9.26 8.314c1.503-.958 1.568-3.454.148-5.684C8.201.735 6.365-.268 4.918.061c-.333.065-.758.243-1.185.515s-.769.583-.968.857c-.91 1.172-.777 3.259.431 5.154 1.42 2.23 3.71 3.226 5.214 2.268l.851-.542zm-.542-.851c-.992.632-2.742-.265-3.82-1.96s-1.153-3.658-.161-4.29c.991-.632 2.741.266 3.82 1.96s1.152 3.658.161 4.29z"
});

function SvgSearch6(props) {
  return /*#__PURE__*/createElement("svg", _extends$jj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jj);
}

function _extends$jk() { _extends$jk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jk.apply(this, arguments); }

var _ref$jk = /*#__PURE__*/createElement("path", {
  d: "M7.749 16c-.771 0-1.424-.225-1.939-.669-.519-.447-.782-.969-.782-1.552a.98.98 0 01.307-.726c.207-.202.465-.309.748-.309.281 0 .534.1.732.29.195.187.294.435.294.736 0 .177-.029.372-.086.58a1.53 1.53 0 00-.068.364c0 .058.014.126.121.199.199.138.439.204.732.204.353 0 .667-.123.962-.375.29-.249.431-.505.431-.782 0-.308-.082-.575-.252-.816-.287-.402-.826-.874-1.603-1.401-1.248-.835-2.079-1.559-2.54-2.211-.358-.511-.539-1.061-.539-1.636 0-.579.19-1.155.564-1.713.32-.477.794-.908 1.41-1.283-.33-.355-.577-.689-.736-.995a2.565 2.565 0 01-.303-1.189c0-.747.295-1.393.878-1.92S7.39.001 8.241.001c.783 0 1.441.22 1.956.654.521.439.785.952.785 1.524 0 .292-.109.553-.324.776l-.004.004c-.125.124-.353.271-.735.271-.299 0-.561-.098-.758-.283a.876.876 0 01-.296-.656c0-.108.027-.272.084-.515.028-.115.042-.221.042-.316a.476.476 0 00-.183-.39C8.679.962 8.494.909 8.243.909c-.389 0-.708.118-.975.361s-.399.533-.399.883c0 .315.071.574.212.771.267.374.731.778 1.378 1.201 1.315.853 2.233 1.636 2.727 2.325.365.518.549 1.068.549 1.637 0 .572-.186 1.148-.552 1.714-.316.487-.793.926-1.42 1.308.347.367.591.688.743.977.189.359.284.751.284 1.165 0 .776-.296 1.435-.879 1.96s-1.31.79-2.161.79zM6.975 5.568c-.753.452-1.12.972-1.12 1.583 0 .356.102.674.31.973.311.436.926.97 1.825 1.583.381.259.724.511 1.025.751.767-.461 1.14-.974 1.14-1.565 0-.322-.127-.668-.378-1.03-.263-.378-.826-.872-1.674-1.467a21.316 21.316 0 01-1.128-.827z"
});

function SvgSection(props) {
  return /*#__PURE__*/createElement("svg", _extends$jk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jk);
}

function _extends$jl() { _extends$jl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jl.apply(this, arguments); }

var _ref$jl = /*#__PURE__*/createElement("path", {
  d: "M.048 10.875H3v-.25H.006c.007.085.021.169.042.25zM.284 11.375H3v-.25H.138c.041.088.09.172.146.25zM.903 11.875H3v-.25H.511c.116.102.248.187.392.25zM13.097.125H.903a1.512 1.512 0 00-.392.25h12.978a1.512 1.512 0 00-.392-.25zM13.716.625H.284a1.485 1.485 0 00-.146.25h13.725a1.556 1.556 0 00-.146-.25zM13.952 1.125H.048a1.483 1.483 0 00-.042.25h13.989a1.483 1.483 0 00-.042-.25zM14 6.375v-.25h-.5l.333.25zM14 5.625h-1.167l.333.25h.833zM15.119 9.589L5 2v12.649l3.158-2.978L10.318 16l2.683-1.342-2.16-4.329z"
});

var _ref2$47 = /*#__PURE__*/createElement("path", {
  d: "M1.875 1.875h10.25v3.25l.062.016.313.234H14v-.25h-.125v-3.25H14v-.25H0v.25h.125v8.25H0v.25h3v-.25H1.875v-8.25zm-.25 8.25h-.25v-8.25h.25v8.25zm-.5 0h-.25v-8.25h.25v8.25zm11.25-5v-3.25h.25v3.25h-.25zm.5-3.25h.25v3.25h-.25v-3.25zm.75 3.25h-.25v-3.25h.25v3.25zM.375 1.875h.25v8.25h-.25v-8.25z"
});

function SvgSelect(props) {
  return /*#__PURE__*/createElement("svg", _extends$jl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jl, _ref2$47);
}

function _extends$jm() { _extends$jm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jm.apply(this, arguments); }

var _ref$jm = /*#__PURE__*/createElement("path", {
  d: "M13.002 14.658l-2.16-4.329 4.278-.74L5.001 2v12.649l3.158-2.978L10.319 16z"
});

var _ref2$48 = /*#__PURE__*/createElement("path", {
  d: "M1 10.5v-9c0-.271.229-.5.5-.5h11c.271 0 .5.229.5.5v4l1 .75V1.5c0-.825-.675-1.5-1.5-1.5h-11C.675 0 0 .675 0 1.5v9c0 .825.675 1.5 1.5 1.5H3v-1H1.5a.507.507 0 01-.5-.5z"
});

function SvgSelect2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jm, _ref2$48);
}

function _extends$jn() { _extends$jn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jn.apply(this, arguments); }

var _ref$jn = /*#__PURE__*/createElement("path", {
  d: "M13 0H3L0 4h16l-3-4zM0 5v3h16V5H0zm15 2h-1V6h1v1zM0 9v3h16V9H0zm15 2h-1v-1h1v1zM0 13v3h16v-3H0zm15 2h-1v-1h1v1z"
});

function SvgServer(props) {
  return /*#__PURE__*/createElement("svg", _extends$jn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jn);
}

function _extends$jo() { _extends$jo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jo.apply(this, arguments); }

var _ref$jo = /*#__PURE__*/createElement("path", {
  d: "M11 2l1-1-1-1H5L4 1l1 1zm1-.5l-1 1v4l1 1 1-1v-4zm-7 5v-4l-1-1-1 1v4l1 1zm6 3v4l1 1 1-1v-4l-1-1zm-6 4v-4l-1-1-1 1v4l1 1zm0 .5l-1 1 1 1h6l1-1-1-1z"
});

function SvgSevenSegment0(props) {
  return /*#__PURE__*/createElement("svg", _extends$jo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jo);
}

function _extends$jp() { _extends$jp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jp.apply(this, arguments); }

var _ref$jp = /*#__PURE__*/createElement("path", {
  d: "M12 1.5l-1 1v4l1 1 1-1v-4zm-1 8v4l1 1 1-1v-4l-1-1z"
});

function SvgSevenSegment1(props) {
  return /*#__PURE__*/createElement("svg", _extends$jp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jp);
}

function _extends$jq() { _extends$jq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jq.apply(this, arguments); }

var _ref$jq = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm8 6.5l-1-1v-4l1-1 1 1v4zm-8 7l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5zm0 7l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jq);
}

function _extends$jr() { _extends$jr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jr.apply(this, arguments); }

var _ref$jr = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm8 6.5l-1-1v-4l1-1 1 1v4zm0 7l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5zm0 7l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment3(props) {
  return /*#__PURE__*/createElement("svg", _extends$jr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jr);
}

function _extends$js() { _extends$js = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$js.apply(this, arguments); }

var _ref$js = /*#__PURE__*/createElement("path", {
  d: "M12 7.5l-1-1v-4l1-1 1 1v4zm-8 0l-1-1v-4l1-1 1 1v4zm8 7l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment4(props) {
  return /*#__PURE__*/createElement("svg", _extends$js({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$js);
}

function _extends$jt() { _extends$jt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jt.apply(this, arguments); }

var _ref$jt = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm0 6.5l-1-1v-4l1-1 1 1v4zm8 7l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5zm0 7l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment5(props) {
  return /*#__PURE__*/createElement("svg", _extends$jt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jt);
}

function _extends$ju() { _extends$ju = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ju.apply(this, arguments); }

var _ref$ju = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm0 6.5l-1-1v-4l1-1 1 1v4zm8 7l-1-1v-4l1-1 1 1v4zm-8 0l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5zm0 7l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment6(props) {
  return /*#__PURE__*/createElement("svg", _extends$ju({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ju);
}

function _extends$jv() { _extends$jv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jv.apply(this, arguments); }

var _ref$jv = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm8 6.5l-1-1v-4l1-1 1 1v4zm0 7l-1-1v-4l1-1 1 1v4z"
});

function SvgSevenSegment7(props) {
  return /*#__PURE__*/createElement("svg", _extends$jv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jv);
}

function _extends$jw() { _extends$jw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jw.apply(this, arguments); }

var _ref$jw = /*#__PURE__*/createElement("path", {
  d: "M11 2l1-1-1-1H5L4 1l1 1zm1-.5l-1 1v4l1 1 1-1v-4zm-7 5v-4l-1-1-1 1v4l1 1zm6 3v4l1 1 1-1v-4l-1-1zm-6 4v-4l-1-1-1 1v4l1 1zM4 8l1 1h6l1-1-1-1H5zm1 6l-1 1 1 1h6l1-1-1-1z"
});

function SvgSevenSegment8(props) {
  return /*#__PURE__*/createElement("svg", _extends$jw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jw);
}

function _extends$jx() { _extends$jx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jx.apply(this, arguments); }

var _ref$jx = /*#__PURE__*/createElement("path", {
  d: "M4 1l1-1h6l1 1-1 1H5zm8 6.5l-1-1v-4l1-1 1 1v4zm-8 0l-1-1v-4l1-1 1 1v4zm8 7l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1H5zm0 7l1-1h6l1 1-1 1H5z"
});

function SvgSevenSegment9(props) {
  return /*#__PURE__*/createElement("svg", _extends$jx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jx);
}

function _extends$jy() { _extends$jy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jy.apply(this, arguments); }

var _ref$jy = /*#__PURE__*/createElement("path", {
  d: "M10 7v2h3v5H3V9h3V7H1v9h14V7z"
});

var _ref2$49 = /*#__PURE__*/createElement("path", {
  d: "M7 5v8h2V5h3.5L8 .5 3.5 5z"
});

function SvgShare(props) {
  return /*#__PURE__*/createElement("svg", _extends$jy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jy, _ref2$49);
}

function _extends$jz() { _extends$jz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jz.apply(this, arguments); }

var _ref$jz = /*#__PURE__*/createElement("path", {
  d: "M4 10s.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zm7 2H2V6h1.967c.158-.186.327-.365.508-.534A6.933 6.933 0 016.914 4H0v10h13V9.803l-2 1.333V12z"
});

function SvgShare2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jz);
}

function _extends$jA() { _extends$jA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jA.apply(this, arguments); }

var _ref$jA = /*#__PURE__*/createElement("path", {
  d: "M13.5 11c-.706 0-1.342.293-1.797.763L4.969 8.396a2.46 2.46 0 000-.792l6.734-3.367a2.5 2.5 0 10-.672-1.341L4.297 6.263a2.5 2.5 0 100 3.474l6.734 3.367A2.5 2.5 0 1013.5 11z"
});

function SvgShare3(props) {
  return /*#__PURE__*/createElement("svg", _extends$jA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jA);
}

function _extends$jB() { _extends$jB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jB.apply(this, arguments); }

var _ref$jB = /*#__PURE__*/createElement("path", {
  d: "M6 8a2 2 0 113.999-.001A2 2 0 016 8zm2-4c1.105 0 2.105.448 2.828 1.172l1.414-1.414a6.003 6.003 0 00-9.901 2.243H-.001v2h4a4 4 0 014-4zm4 4a4 4 0 01-6.828 2.828l-1.414 1.414a6.003 6.003 0 009.901-2.243h2.342v-2h-4z"
});

function SvgShare4(props) {
  return /*#__PURE__*/createElement("svg", _extends$jB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jB);
}

function _extends$jC() { _extends$jC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jC.apply(this, arguments); }

var _ref$jC = /*#__PURE__*/createElement("path", {
  d: "M9 15H1a1 1 0 01-.895-1.447l6-12A1 1 0 016.999 1h8a1 1 0 01.895 1.447l-6 12A1 1 0 019 15zm-6.382-2h5.764l5-10H7.618l-5 10z"
});

function SvgShear(props) {
  return /*#__PURE__*/createElement("svg", _extends$jC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jC);
}

function _extends$jD() { _extends$jD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jD.apply(this, arguments); }

var _ref$jD = /*#__PURE__*/createElement("path", {
  d: "M13.739 3.061l-5.5-3a.497.497 0 00-.478 0l-5.5 3A.5.5 0 002 3.5v4c0 2.2.567 3.978 1.735 5.437.912 1.14 2.159 2.068 4.042 3.01a.502.502 0 00.448 0c1.883-.942 3.13-1.87 4.042-3.01 1.167-1.459 1.735-3.238 1.735-5.437v-4a.5.5 0 00-.261-.439zM6.5 11.296L3.704 8.5l.796-.795 2 2 5-5 .796.795-5.795 5.795z"
});

function SvgShieldCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$jD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jD);
}

function _extends$jE() { _extends$jE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jE.apply(this, arguments); }

var _ref$jE = /*#__PURE__*/createElement("path", {
  d: "M13.739 3.061l-5.5-3a.497.497 0 00-.478 0l-5.5 3A.5.5 0 002 3.5v4c0 2.2.567 3.978 1.735 5.437.912 1.14 2.159 2.068 4.042 3.01a.502.502 0 00.448 0c1.883-.942 3.13-1.87 4.042-3.01 1.167-1.459 1.735-3.238 1.735-5.437v-4a.5.5 0 00-.261-.439zM9 13H7v-2h2v2zm0-3H7V3h2v7z"
});

function SvgShieldNotice(props) {
  return /*#__PURE__*/createElement("svg", _extends$jE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jE);
}

function _extends$jF() { _extends$jF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jF.apply(this, arguments); }

var _ref$jF = /*#__PURE__*/createElement("path", {
  d: "M13.739 3.061l-5.5-3a.497.497 0 00-.478 0l-5.5 3A.5.5 0 002 3.5v4c0 2.2.567 3.978 1.735 5.437.912 1.14 2.159 2.068 4.042 3.01a.502.502 0 00.448 0c1.883-.942 3.13-1.87 4.042-3.01 1.167-1.459 1.735-3.238 1.735-5.437v-4a.5.5 0 00-.261-.439zM12.5 7.5c0 .953-.117 1.784-.359 2.541a6.01 6.01 0 01-1.047 1.96c-.699.874-1.664 1.617-3.094 2.375V1.64l4.5 2.455v3.406z"
});

function SvgShield(props) {
  return /*#__PURE__*/createElement("svg", _extends$jF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jF);
}

function _extends$jG() { _extends$jG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jG.apply(this, arguments); }

var _ref$jG = /*#__PURE__*/createElement("path", {
  d: "M8 1.639l4.5 2.455V7.5c0 .953-.117 1.784-.359 2.541a6.01 6.01 0 01-1.047 1.96c-.699.874-1.664 1.617-3.094 2.375-1.43-.758-2.395-1.501-3.094-2.375a6.01 6.01 0 01-1.047-1.96C3.618 9.285 3.5 8.453 3.5 7.5V4.094L8 1.639zM8 0a.494.494 0 00-.239.061l-5.5 3A.5.5 0 002 3.5v4c0 2.2.567 3.978 1.735 5.437.912 1.14 2.159 2.068 4.042 3.01a.502.502 0 00.448 0c1.883-.942 3.13-1.87 4.042-3.01 1.167-1.459 1.735-3.238 1.735-5.437v-4a.5.5 0 00-.261-.439l-5.5-3A.497.497 0 008.002 0z"
});

var _ref2$4a = /*#__PURE__*/createElement("path", {
  d: "M5 4.984V7.5c0 .796.094 1.478.288 2.085a4.54 4.54 0 00.79 1.479c.456.57 1.064 1.075 1.923 1.591.859-.516 1.467-1.021 1.923-1.591.356-.445.614-.928.789-1.479.194-.607.288-1.289.288-2.085V4.984l-3-1.636-3 1.636z"
});

function SvgShield2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jG, _ref2$4a);
}

function _extends$jH() { _extends$jH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jH.apply(this, arguments); }

var _ref$jH = /*#__PURE__*/createElement("path", {
  d: "M15 0L8 2 1 0S.93.808 1 2l7 2.189L15 2c.07-1.192 0-2 0-2zM1.128 3.049C1.503 6.966 2.901 13.553 8 16c5.099-2.448 6.497-9.034 6.872-12.951L8 5.633 1.128 3.049z"
});

function SvgShield3(props) {
  return /*#__PURE__*/createElement("svg", _extends$jH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jH);
}

function _extends$jI() { _extends$jI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jI.apply(this, arguments); }

var _ref$jI = /*#__PURE__*/createElement("path", {
  d: "M15 0L8 2 1 0S.93.808 1 2l7 2.189L15 2c.07-1.192 0-2 0-2zM1.128 3.049C1.503 6.966 2.901 13.553 8 16c5.099-2.448 6.497-9.034 6.872-12.951L8 5.633 1.128 3.049zm6.52 3.519l.151.057H2.726l-.058-.25h4.467l.514.193zM3.144 4.875l.665.25H2.416l-.043-.25h.771zm1.33.5l.665.25h-2.63l-.047-.25h2.013zm1.33.5l.665.25H2.612l-.053-.25h3.245zm7.872-1.308c-.238 1.549-.656 3.388-1.389 5.119-1.029 2.431-2.47 4.174-4.287 5.189v-.249h-.415a8.826 8.826 0 01-.368-.25h.782v-.25H6.888a8.76 8.76 0 01-.298-.25H8v-.25H6.318a9.887 9.887 0 01-.252-.25H8v-.25H5.832a10.817 10.817 0 01-.217-.25H8v-.25H5.412a12.613 12.613 0 01-.191-.25H8v-.25H5.041c-.057-.082-.113-.166-.169-.25H8v-.25H4.712a11.826 11.826 0 01-.152-.25h3.441v-.25H4.417a14.738 14.738 0 01-.137-.25h3.721v-.25H4.15c-.042-.082-.083-.166-.124-.25h3.975v-.25H3.908c-.038-.082-.075-.166-.112-.25h4.205v-.25H3.689a10.9 10.9 0 01-.102-.25h4.414v-.25H3.489a12.652 12.652 0 01-.093-.25h4.605v-.25H3.307l-.085-.25h4.779v-.25H3.142l-.078-.25h4.937v-.25H2.99a23.404 23.404 0 01-.071-.25h5.082v-.25H2.852l-.064-.25h5.213v-.174l5.676-2.134z"
});

function SvgShield4(props) {
  return /*#__PURE__*/createElement("svg", _extends$jI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jI);
}

function _extends$jJ() { _extends$jJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jJ.apply(this, arguments); }

var _ref$jJ = /*#__PURE__*/createElement("path", {
  d: "M10.5 14h-5a.5.5 0 01-.5-.5V8H3a.5.5 0 01-.354-.854l5-5a.5.5 0 01.707 0l5 5a.499.499 0 01-.354.854h-2v5.5a.5.5 0 01-.5.5zM6 13h4V7.5a.5.5 0 01.5-.5h1.293L8 3.207 4.207 7H5.5a.5.5 0 01.5.5V13z"
});

function SvgShift(props) {
  return /*#__PURE__*/createElement("svg", _extends$jJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jJ);
}

function _extends$jK() { _extends$jK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jK.apply(this, arguments); }

var _ref$jK = /*#__PURE__*/createElement("path", {
  d: "M4.26 12.656a1.5 1.5 0 011.239-.655h.004c.497.001.959.247 1.237.657.156.222.716.842 1.259.842.545 0 1.105-.623 1.26-.844a1.5 1.5 0 011.239-.655h.004c.497.001.959.247 1.237.657.144.205.632.749 1.133.832.961-1.607 2.126-5.489 2.126-5.489l-2.057-.881-.827-4.961a1.416 1.416 0 00-1.367-1.158h-5.5c-.658 0-1.258.508-1.367 1.158L3.053 7.12l-2.057.881s1.165 3.882 2.126 5.489c.503-.083.991-.629 1.135-.833zM9 2h1.75c.168 0 .352.156.38.322l.721 4.329-3.313-1.42L9 2zm-4.13.322A.422.422 0 015.25 2H7l.462 3.231-3.313 1.42.721-4.329z"
});

var _ref2$4b = /*#__PURE__*/createElement("path", {
  d: "M13 16c-1.143 0-2.018-.707-2.5-1.216C10.018 15.293 9.143 16 8 16s-2.018-.707-2.5-1.216C5.018 15.293 4.143 16 3 16 1.252 16 .131 14.348.084 14.277a.5.5 0 01.832-.555C.928 13.739 1.795 15 3.001 15c1.208 0 2.076-1.266 2.085-1.279a.501.501 0 01.415-.221h.001a.5.5 0 01.415.222c.008.012.876 1.277 2.084 1.277s2.076-1.266 2.085-1.279a.501.501 0 01.415-.221h.001a.5.5 0 01.415.222c.008.012.876 1.277 2.084 1.277s2.076-1.266 2.085-1.279a.5.5 0 01.831.556c-.047.07-1.169 1.723-2.916 1.723z"
});

function SvgShip(props) {
  return /*#__PURE__*/createElement("svg", _extends$jK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jK, _ref2$4b);
}

function _extends$jL() { _extends$jL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jL.apply(this, arguments); }

var _ref$jL = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM6 11a2 2 0 113.999-.001A2 2 0 016 11zm4-5.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5S11.552 7 11 7s-1-.672-1-1.5zm-6 0C4 4.672 4.448 4 5 4s1 .672 1 1.5S5.552 7 5 7s-1-.672-1-1.5z"
});

function SvgShocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$jL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jL);
}

function _extends$jM() { _extends$jM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jM.apply(this, arguments); }

var _ref$jM = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM5 7c-.552 0-1-.672-1-1.5S4.448 4 5 4s1 .672 1 1.5S5.552 7 5 7zm3 6a2 2 0 11-.001-3.999A2 2 0 018 13zm3-6c-.552 0-1-.672-1-1.5S10.448 4 11 4s1 .672 1 1.5S11.552 7 11 7z"
});

function SvgShocked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jM);
}

function _extends$jN() { _extends$jN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jN.apply(this, arguments); }

var _ref$jN = /*#__PURE__*/createElement("path", {
  d: "M14 3H1L0 14h6l1.5-5.972L9 14h6L14 3zM4 5H2V4h2v1zm3 0H5V4h2v1zm3 0H8V4h2v1zm3 0h-2V4h2v1z"
});

function SvgShorts(props) {
  return /*#__PURE__*/createElement("svg", _extends$jN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jN);
}

function _extends$jO() { _extends$jO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jO.apply(this, arguments); }

var _ref$jO = /*#__PURE__*/createElement("path", {
  d: "M4.5 16a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5zM6.5 15a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM8.5 15a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM10.5 16a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5z"
});

var _ref2$4c = /*#__PURE__*/createElement("path", {
  d: "M14.5 5H12v1H3V5H.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5H3V9h9v3h2.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM4 0h7v5H4V0z"
});

function SvgShredder(props) {
  return /*#__PURE__*/createElement("svg", _extends$jO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jO, _ref2$4c);
}

function _extends$jP() { _extends$jP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jP.apply(this, arguments); }

var _ref$jP = /*#__PURE__*/createElement("path", {
  d: "M3 0h2v4a1 1 0 01-1 1H0V3h3V0zM11 0h2v3h3v2h-4a1 1 0 01-1-1V0zM12 11h4v2h-3v3h-2v-4a1 1 0 011-1zM0 11h4a1 1 0 011 1v4H3v-3H0v-2z"
});

function SvgShrink(props) {
  return /*#__PURE__*/createElement("svg", _extends$jP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jP);
}

function _extends$jQ() { _extends$jQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jQ.apply(this, arguments); }

var _ref$jQ = /*#__PURE__*/createElement("path", {
  d: "M9 7h6.5L13 4.5l3-3L14.5 0l-3 3L9 .5zM9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3L15.5 9zM7 9H.5L3 11.5l-3 3L1.5 16l3-3L7 15.5zM7 7V.5L4.5 3l-3-3L0 1.5l3 3L.5 7z"
});

function SvgShrink2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jQ);
}

function _extends$jR() { _extends$jR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jR.apply(this, arguments); }

var _ref$jR = /*#__PURE__*/createElement("path", {
  d: "M14.5 4.5L10 6l1.5-4.5zM8.25 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1.031 0h.5v1h-.5zM2.25 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zM4.5 1.5L6 6 1.5 4.5zm-3 10L6 10l-1.5 4.5zm10 3L10 10l4.5 1.5zM1.25 0h.5v1h-.5zm7 15h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1.031 0h.5v1h-.5zM2.25 15h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm1 0h.5v1h-.5zm-6 0h.5v1h-.5zM.016 7.266h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1.032h1v.5h-1zm0 12.032h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0 6h1v.5h-1zm15-7h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1.032h1v.5h-1zm0 12.032h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0-1h1v.5h-1zm0 6h1v.5h-1zM10 6H6v4h4V6zm1-1v6H5V5h6z"
});

function SvgShrink3(props) {
  return /*#__PURE__*/createElement("svg", _extends$jR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jR);
}

function _extends$jS() { _extends$jS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jS.apply(this, arguments); }

var _ref$jS = /*#__PURE__*/createElement("path", {
  d: "M10 .5V6h5.5zM.5 6H6V.5zM10 10v5.5l5.5-5.5zM6 10H.5L6 15.5z"
});

function SvgShrink4(props) {
  return /*#__PURE__*/createElement("svg", _extends$jS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jS);
}

function _extends$jT() { _extends$jT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jT.apply(this, arguments); }

var _ref$jT = /*#__PURE__*/createElement("path", {
  d: "M12 4H3v9h9V4zm-1 8H4V5h7v7zM1.25 2.25v12.5h12.5V2.25H1.25zm12 12H1.75V2.75h11.5v11.5zM5 8h5v1H5z"
});

function SvgShrink5(props) {
  return /*#__PURE__*/createElement("svg", _extends$jT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jT);
}

function _extends$jU() { _extends$jU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jU.apply(this, arguments); }

var _ref$jU = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm15 8v7H1V1h14v7z"
});

var _ref2$4d = /*#__PURE__*/createElement("path", {
  d: "M10 6h4.5L10 1.5zM6 10v4.5L1.5 10z"
});

function SvgShrink6(props) {
  return /*#__PURE__*/createElement("svg", _extends$jU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jU, _ref2$4d);
}

function _extends$jV() { _extends$jV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jV.apply(this, arguments); }

var _ref$jV = /*#__PURE__*/createElement("path", {
  d: "M7 9v6.5L4.5 13l-3 3L0 14.5l3-3L.5 9zm9-7.5l-3 3L15.5 7H9V.5L11.5 3l3-3z"
});

function SvgShrink7(props) {
  return /*#__PURE__*/createElement("svg", _extends$jV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jV);
}

function _extends$jW() { _extends$jW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jW.apply(this, arguments); }

var _ref$jW = /*#__PURE__*/createElement("path", {
  d: "M12 11h-1.586l-2.5-2.5 2.5-2.5H12v2.5L15.5 5 12 1.5V4h-2a.997.997 0 00-.707.293L6.5 7.086 3.707 4.293A1 1 0 003 4H0v2h2.586l2.5 2.5-2.5 2.5H0v2h3c.265 0 .52-.105.707-.293L6.5 9.914l2.793 2.793A1 1 0 0010 13h2v2.5l3.5-3.5L12 8.5V11z"
});

function SvgShuffle(props) {
  return /*#__PURE__*/createElement("svg", _extends$jW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jW);
}

function _extends$jX() { _extends$jX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jX.apply(this, arguments); }

var _ref$jX = /*#__PURE__*/createElement("path", {
  d: "M13.854 10.146A.499.499 0 0013 10.5V12h-1.793l-3.5-3.5 3.5-3.5H13v1.5a.5.5 0 00.854.354l2-2a.5.5 0 000-.707l-2-2a.499.499 0 00-.854.354v1.5h-2a.504.504 0 00-.354.146L7 7.793 3.354 4.147A.5.5 0 003 4.001H.5a.5.5 0 000 1h2.293l3.5 3.5-3.5 3.5H.5a.5.5 0 000 1H3c.133 0 .26-.053.354-.146L7 9.209l3.646 3.646a.5.5 0 00.354.146h2v1.5a.5.5 0 00.854.354l2-2a.5.5 0 000-.707l-2-2z"
});

function SvgShuffle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$jX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jX);
}

function _extends$jY() { _extends$jY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jY.apply(this, arguments); }

var _ref$jY = /*#__PURE__*/createElement("path", {
  d: "M5.113 7L9.11.077a7.977 7.977 0 00-6.715 2.215L5.113 7zM7.423 5h7.995A8.022 8.022 0 0010.142.29L7.423 5zM5.691 10L1.694 3.077A7.965 7.965 0 000 8c0 .691.087 1.361.252 2h5.439zM10.309 6l3.997 6.923A7.965 7.965 0 0016 8c0-.691-.088-1.361-.252-2h-5.439zM8.577 11H.582a8.022 8.022 0 005.276 4.71L8.577 11zM10.887 9L6.89 15.923a7.977 7.977 0 006.715-2.215L10.887 9z"
});

function SvgShutter(props) {
  return /*#__PURE__*/createElement("svg", _extends$jY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jY);
}

function _extends$jZ() { _extends$jZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$jZ.apply(this, arguments); }

var _ref$jZ = /*#__PURE__*/createElement("path", {
  d: "M14.713 11.48l.694-1.48h.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18V0h15.313l.688 4h-.537l-.293-.607C14.62 2.247 14.205 2 13.002 2H2.658l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-.65 2.713-1.52z"
});

function SvgSigma(props) {
  return /*#__PURE__*/createElement("svg", _extends$jZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$jZ);
}

function _extends$j_() { _extends$j_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j_.apply(this, arguments); }

var _ref$j_ = /*#__PURE__*/createElement("path", {
  d: "M6.722 14.031c-2.65.262-4.938-.938-5.109-2.675-.172-1.741 1.837-3.359 4.484-3.622 2.65-.263 4.938.938 5.106 2.675.175 1.741-1.834 3.362-4.481 3.622zm5.297-5.772c-.225-.069-.381-.113-.262-.409.256-.644.281-1.197.003-1.594-.519-.741-1.941-.703-3.569-.019 0 0-.513.222-.381-.181.25-.806.213-1.478-.178-1.869-.884-.884-3.234.034-5.25 2.05C.876 7.74.001 9.343.001 10.728c0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188zM14.909 3.416a4.234 4.234 0 00-4.031-1.306.61.61 0 10.256 1.194 3.01 3.01 0 013.494 3.872.615.615 0 00.394.772.615.615 0 00.772-.394v-.003a4.222 4.222 0 00-.884-4.134z"
});

var _ref2$4e = /*#__PURE__*/createElement("path", {
  d: "M13.294 4.875a2.055 2.055 0 00-1.963-.634.527.527 0 10.219 1.031c.341-.072.709.034.959.309.25.278.319.656.209.987a.532.532 0 00.341.666.531.531 0 00.666-.341 2.062 2.062 0 00-.431-2.019zM6.869 10.884c-.094.159-.297.234-.456.169-.159-.063-.206-.244-.116-.397.094-.153.291-.228.447-.169.156.056.213.234.125.397zm-.847 1.082c-.256.409-.806.588-1.219.4-.406-.184-.528-.659-.272-1.059.253-.397.784-.575 1.194-.403.416.178.55.65.297 1.063zm.962-2.894c-1.259-.328-2.684.3-3.231 1.409-.559 1.131-.019 2.391 1.253 2.803 1.319.425 2.875-.228 3.416-1.447.534-1.197-.131-2.425-1.438-2.766z"
});

function SvgSinaWeibo(props) {
  return /*#__PURE__*/createElement("svg", _extends$j_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j_, _ref2$4e);
}

function _extends$j$() { _extends$j$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j$.apply(this, arguments); }

var _ref$j$ = /*#__PURE__*/createElement("path", {
  d: "M12.803 3.197C11.386 1.78 9.503 1 7.5 1s-3.887.78-5.303 2.197S0 6.497 0 8.5a.5.5 0 00.5.5C2.43 9 4 10.57 4 12.5v2a.5.5 0 001 0v-2a.5.5 0 011 0v3a.5.5 0 001 0v-3a.5.5 0 011 0v3a.5.5 0 001 0v-3a.5.5 0 011 0v2a.5.5 0 001 0v-2c0-1.93 1.57-3.5 3.5-3.5a.5.5 0 00.5-.5c0-2.003-.78-3.887-2.197-5.303zM6 7c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1zm6 0c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1z"
});

function SvgSkull(props) {
  return /*#__PURE__*/createElement("svg", _extends$j$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$j$);
}

function _extends$k0() { _extends$k0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k0.apply(this, arguments); }

var _ref$k0 = /*#__PURE__*/createElement("path", {
  d: "M6.5 16a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5zM8.5 16a.5.5 0 01-.5-.5v-4a.5.5 0 011 0v4a.5.5 0 01-.5.5z"
});

var _ref2$4f = /*#__PURE__*/createElement("path", {
  d: "M10.5 15a.5.5 0 01-.5-.5v-2a4.507 4.507 0 013.983-4.471C13.741 4.664 10.926 2 7.5 2S1.259 4.664 1.017 8.029A4.506 4.506 0 015 12.5v2a.5.5 0 01-1 0v-2C4 10.57 2.43 9 .5 9a.5.5 0 01-.5-.5c0-2.003.78-3.887 2.197-5.303S5.497 1 7.5 1s3.887.78 5.303 2.197S15 6.497 15 8.5a.5.5 0 01-.5.5c-1.93 0-3.5 1.57-3.5 3.5v2a.5.5 0 01-.5.5z"
});

var _ref3$s = /*#__PURE__*/createElement("path", {
  d: "M6 7c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1zM12 7c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1z"
});

function SvgSkull2(props) {
  return /*#__PURE__*/createElement("svg", _extends$k0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k0, _ref2$4f, _ref3$s);
}

function _extends$k1() { _extends$k1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k1.apply(this, arguments); }

var _ref$k1 = /*#__PURE__*/createElement("path", {
  d: "M6.65.584C6.625.568 6.597.556 6.572.543c-.028.006-.053.009-.081.016l.159.025zM.575 6.578c-.006.028-.009.056-.012.081.016.025.025.05.041.075l-.028-.156zM15.419 9.416c.006-.028.009-.056.016-.084-.016-.025-.025-.05-.041-.075l.025.159zM9.25 15.359c.025.016.053.028.078.041.028-.006.056-.009.084-.012l-.162-.028z"
});

var _ref2$4g = /*#__PURE__*/createElement("path", {
  d: "M15.434 9.331c-.006.028-.009.056-.016.084l-.028-.162c.016.028.028.053.044.078.081-.45.125-.909.125-1.369a7.54 7.54 0 00-2.213-5.344 7.56 7.56 0 00-2.4-1.619A7.51 7.51 0 008.005.405c-.481 0-.963.044-1.431.134h-.003c.025.012.053.025.078.041L6.49.555c.028-.006.053-.009.081-.016A4.492 4.492 0 004.474.014C3.28.014 2.155.48 1.311 1.323S.002 3.292.002 4.486c0 .759.197 1.509.563 2.169.006-.028.009-.056.012-.081l.028.159c-.016-.025-.028-.05-.041-.075a7.566 7.566 0 00-.112 1.303 7.514 7.514 0 002.213 5.341 7.54 7.54 0 006.666 2.094.64.64 0 00-.078-.041l.162.028c-.028.006-.056.009-.084.012a4.479 4.479 0 002.2.581c1.194 0 2.319-.466 3.162-1.309s1.309-1.969 1.309-3.162a4.532 4.532 0 00-.569-2.175zm-7.4 3.26c-2.684 0-3.884-1.319-3.884-2.309 0-.506.375-.863.891-.863 1.15 0 .85 1.65 2.994 1.65 1.097 0 1.703-.597 1.703-1.206 0-.366-.181-.772-.903-.95l-2.388-.597c-1.922-.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6.913 3.6 2.131 0 .522-.453.825-.969.825-.981 0-.8-1.356-2.775-1.356-.981 0-1.522.444-1.522 1.078s.775.838 1.447.991l1.769.394c1.934.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z"
});

function SvgSkype(props) {
  return /*#__PURE__*/createElement("svg", _extends$k1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k1, _ref2$4g);
}

function _extends$k2() { _extends$k2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k2.apply(this, arguments); }

var _ref$k2 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
});

var _ref2$4h = /*#__PURE__*/createElement("path", {
  d: "M10 10.5c0 1.381-.895 2.5-2 2.5s-2-1.119-2-2.5S6.895 8 8 8s2 1.119 2 2.5zM6.5 5.313a.502.502 0 01-.354-.146c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.354.853zM11.5 5.313a.502.502 0 01-.354-.146c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.354.853z"
});

function SvgSleepy(props) {
  return /*#__PURE__*/createElement("svg", _extends$k2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k2, _ref2$4h);
}

function _extends$k3() { _extends$k3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k3.apply(this, arguments); }

var _ref$k3 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4.854 5.166a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 01-.708.707c-.302-.302-.991-.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5S6.895 8 8 8s2 1.119 2 2.5S9.105 13 8 13zm3.854-7.834a.498.498 0 01-.708 0c-.302-.302-.991-.302-1.293 0a.5.5 0 01-.707-.707c.696-.696 2.011-.696 2.707 0a.5.5 0 010 .707z"
});

function SvgSleepy2(props) {
  return /*#__PURE__*/createElement("svg", _extends$k3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k3);
}

function _extends$k4() { _extends$k4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k4.apply(this, arguments); }

var _ref$k4 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm1.002 4.801l1.286.772C11.414 12.027 9.821 13 8 13s-3.413-.973-4.288-2.427l1.286-.772C5.61 10.819 6.725 11.5 8 11.5s2.389-.681 3.002-1.699z"
});

function SvgSmile(props) {
  return /*#__PURE__*/createElement("svg", _extends$k4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k4);
}

function _extends$k5() { _extends$k5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k5.apply(this, arguments); }

var _ref$k5 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm3 9a4.999 4.999 0 01-4.288-2.427l1.286-.772C5.61 10.819 6.725 11.5 8 11.5s2.389-.681 3.002-1.699l1.286.772A4.996 4.996 0 018 13z"
});

function SvgSmile2(props) {
  return /*#__PURE__*/createElement("svg", _extends$k5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k5);
}

function _extends$k6() { _extends$k6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k6.apply(this, arguments); }

var _ref$k6 = /*#__PURE__*/createElement("path", {
  d: "M15.31 11.339l-1.727-.997 1.499-.863-.757-1.315-2.261 1.301-2.547-1.47 2.537-1.465 2.271 1.307.757-1.315-1.509-.868 1.732-1-.759-1.314-1.727.997.002-1.73-1.518-.002-.004 2.609-2.547 1.47V3.755l2.267-1.313-.761-1.313-1.507.873v-2H7.233v1.994l-1.497-.867-.761 1.313L7.232 3.75v2.941L4.695 5.226l-.004-2.62-1.518.002.002 1.741-1.732-1-.759 1.314 1.727.997-1.499.863.757 1.315L3.93 6.537l2.547 1.47L3.94 9.472 1.669 8.165.912 9.48l1.509.868-1.732 1 .759 1.314 1.727-.997-.002 1.73 1.518.002.004-2.609 2.547-1.47v2.929L4.975 13.56l.761 1.313L7.243 14v2h1.518v-1.994l1.497.867.761-1.313-2.257-1.308V9.311l2.537 1.465.004 2.62 1.518-.002-.002-1.741 1.732 1z"
});

function SvgSnowflake(props) {
  return /*#__PURE__*/createElement("svg", _extends$k6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k6);
}

function _extends$k7() { _extends$k7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k7.apply(this, arguments); }

var _ref$k7 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 13.5a5.54 5.54 0 01-1.258-.144l-.965-1.871 1.063-1.463h2.32l1.063 1.463-.964 1.871a5.54 5.54 0 01-1.258.144zM5.869 2.927l1.881.947v1.808L5.872 7.047l-1.718-.558-.319-2.08A5.496 5.496 0 015.87 2.928zm6.02 1.184c.096.096.188.195.277.297l-.319 2.08-1.718.558-1.878-1.365V3.873l1.881-.947A5.496 5.496 0 0111.89 4.11zM3.998 6.963l1.72.559.717 2.207-1.062 1.462-2.078-.339a5.45 5.45 0 01-.776-2.395l1.479-1.494zm8.707 3.889l-2.078.339-1.062-1.462.717-2.207 1.72-.559 1.479 1.494a5.454 5.454 0 01-.776 2.395zm.598-8.155a7.45 7.45 0 011.107 1.408l-1.828.024a6.013 6.013 0 00-2.317-1.685L9.723.7a7.481 7.481 0 013.579 1.998zm-10.606 0A7.462 7.462 0 016.276.7l-.542 1.744a6.013 6.013 0 00-2.317 1.685l-1.828-.024c.31-.509.68-.98 1.107-1.408zM.5 8c0-.207.009-.412.025-.615l1.491 1.054c.072.995.387 1.923.885 2.724l-.587 1.729A7.448 7.448 0 01.5 8.001zm4.603 6.92l1.464-1.093a5.988 5.988 0 002.866 0l1.464 1.093c-.918.385-1.892.58-2.897.58s-1.979-.195-2.897-.58zm9.808-4.001a7.456 7.456 0 01-1.225 1.972l-.587-1.729a5.97 5.97 0 00.885-2.724l1.491-1.054a7.448 7.448 0 01-.564 3.534z"
});

function SvgSoccer(props) {
  return /*#__PURE__*/createElement("svg", _extends$k7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k7);
}

function _extends$k8() { _extends$k8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k8.apply(this, arguments); }

var _ref$k8 = /*#__PURE__*/createElement("path", {
  d: "M12.729 9.223L8.5 7.637c-.919-.345-1.179-.682-1.312-.967-.187-.401-.187-.906-.187-1.67V.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5v9c0 1.451.913 2.768 2.271 3.277l8 3c.396.149.809.224 1.228.224a3.518 3.518 0 003.278-2.272 3.504 3.504 0 00-2.048-4.506zM5 1h1v1H5V1zM3 1h1v1H3V1zM1 1h1v1H1V1zm3.803 11.659A3.5 3.5 0 001 8.036V3h5v2c0 .833 0 1.491.281 2.093.305.654.881 1.11 1.867 1.48l4.229 1.586c.342.128.639.325.883.567a3.501 3.501 0 00-2.123 4.248 2.517 2.517 0 01-.515-.133l-5.819-2.182z"
});

function SvgSock(props) {
  return /*#__PURE__*/createElement("svg", _extends$k8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k8);
}

function _extends$k9() { _extends$k9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k9.apply(this, arguments); }

var _ref$k9 = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM14.5 16h-4a.5.5 0 01-.416-.777L13.566 10H10.5a.5.5 0 010-1h4a.5.5 0 01.416.777L11.434 15H14.5a.5.5 0 010 1zM15.947 6.276l-3-6a.5.5 0 00-.894 0l-3 6a.5.5 0 00.895.447l.862-1.724h3.382l.862 1.724a.5.5 0 00.895-.447zM11.309 4L12.5 1.618 13.691 4h-2.382z"
});

function SvgSortAlphaAsc(props) {
  return /*#__PURE__*/createElement("svg", _extends$k9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k9);
}

function _extends$ka() { _extends$ka = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ka.apply(this, arguments); }

var _ref$ka = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM14.5 7h-4a.5.5 0 01-.416-.777L13.566 1H10.5a.5.5 0 010-1h4a.502.502 0 01.416.777L11.434 6H14.5a.5.5 0 010 1zM15.947 15.276l-3-6a.5.5 0 00-.894 0l-3 6a.5.5 0 00.895.447l.862-1.724h3.382l.862 1.724a.5.5 0 00.895-.447zM11.309 13l1.191-2.382L13.691 13h-2.382z"
});

function SvgSortAlphaDesc(props) {
  return /*#__PURE__*/createElement("svg", _extends$ka({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ka);
}

function _extends$kb() { _extends$kb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kb.apply(this, arguments); }

var _ref$kb = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5z"
});

var _ref2$4i = /*#__PURE__*/createElement("path", {
  d: "M7 9h9v2H7V9zM7 6h7v2H7V6zM7 3h5v2H7V3zM7 0h3v2H7V0z"
});

function SvgSortAmountAsc(props) {
  return /*#__PURE__*/createElement("svg", _extends$kb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kb, _ref2$4i);
}

function _extends$kc() { _extends$kc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kc.apply(this, arguments); }

var _ref$kc = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM7 0h9v2H7V0zM7 3h7v2H7V3zM7 6h5v2H7V6z"
});

var _ref2$4j = /*#__PURE__*/createElement("path", {
  d: "M7 9h3v2H7V9z"
});

function SvgSortAmountDesc(props) {
  return /*#__PURE__*/createElement("svg", _extends$kc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kc, _ref2$4j);
}

function _extends$kd() { _extends$kd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kd.apply(this, arguments); }

var _ref$kd = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM13.5 16a.5.5 0 01-.5-.5V10h-.5a.5.5 0 010-1h1a.5.5 0 01.5.5v6a.5.5 0 01-.5.5zM14.5 0h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H14v2h-2.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM12 1h2v2h-2V1z"
});

function SvgSortNumbericDesc(props) {
  return /*#__PURE__*/createElement("svg", _extends$kd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kd);
}

function _extends$ke() { _extends$ke = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ke.apply(this, arguments); }

var _ref$ke = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM13.5 7a.5.5 0 01-.5-.5V1h-.5a.5.5 0 010-1h1a.5.5 0 01.5.5v6a.5.5 0 01-.5.5zM14.5 9h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H14v2h-2.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM12 10h2v2h-2v-2z"
});

function SvgSortNumericAsc(props) {
  return /*#__PURE__*/createElement("svg", _extends$ke({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ke);
}

function _extends$kf() { _extends$kf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kf.apply(this, arguments); }

var _ref$kf = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM10.5 2a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h2a.5.5 0 000-1H11V2.5a.5.5 0 00-.5-.5z"
});

var _ref2$4k = /*#__PURE__*/createElement("path", {
  d: "M16 5c0-2.757-2.243-5-5-5S6 2.243 6 5v.5a.5.5 0 001 0V5c0-2.206 1.794-4 4-4s4 1.794 4 4a4.007 4.007 0 01-3 3.873V7L9 9.5l3 2.5V9.899c2.28-.465 4-2.485 4-4.899z"
});

function SvgSortTimeAsc(props) {
  return /*#__PURE__*/createElement("svg", _extends$kf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kf, _ref2$4k);
}

function _extends$kg() { _extends$kg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kg.apply(this, arguments); }

var _ref$kg = /*#__PURE__*/createElement("path", {
  d: "M5 12V0H3v12H.5L4 15.5 7.5 12H5zM10.5 2a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h2a.5.5 0 000-1H11V2.5a.5.5 0 00-.5-.5z"
});

var _ref2$4l = /*#__PURE__*/createElement("path", {
  d: "M6 5c0-2.757 2.243-5 5-5s5 2.243 5 5v.5a.5.5 0 01-1 0V5c0-2.206-1.794-4-4-4S7 2.794 7 5a4.007 4.007 0 003 3.873V7l3 2.5-3 2.5V9.899A5.01 5.01 0 016 5z"
});

function SvgSortTimeDesc(props) {
  return /*#__PURE__*/createElement("svg", _extends$kg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kg, _ref2$4l);
}

function _extends$kh() { _extends$kh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kh.apply(this, arguments); }

var _ref$kh = /*#__PURE__*/createElement("path", {
  d: "M6 4v11H4V4H1.5L5 .5 8.5 4zm4 8V1h2v11h2.5L11 15.5 7.5 12z"
});

function SvgSort(props) {
  return /*#__PURE__*/createElement("svg", _extends$kh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kh);
}

function _extends$ki() { _extends$ki = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ki.apply(this, arguments); }

var _ref$ki = /*#__PURE__*/createElement("path", {
  d: "M6.5 11H10V0h2v11h3.5L11 15.5 6.5 11zM6 5v11H4V5H.5L5 .5 9.5 5H6z"
});

function SvgSort2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ki({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ki);
}

function _extends$kj() { _extends$kj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kj.apply(this, arguments); }

var _ref$kj = /*#__PURE__*/createElement("path", {
  d: "M13.937 8.034c-.283 0-.552.055-.798.154C12.975 6.401 11.416 5 9.514 5c-.465 0-.917.088-1.317.237-.156.058-.197.117-.197.233v6.292c0 .121.098.222.221.234l5.717.003c1.139 0 2.062-.888 2.062-1.983s-.924-1.983-2.063-1.983zM6.25 12h.5L7 8.497 6.75 5h-.5L6 8.497zm-1.5 0h-.5L4 9.457 4.25 7h.5L5 9.5zm-2.5 0h.5L3 10l-.25-2h-.5L2 10zm-2-1h.5L1 10 .75 9h-.5L0 10z"
});

function SvgSoundcloud(props) {
  return /*#__PURE__*/createElement("svg", _extends$kj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kj);
}

function _extends$kk() { _extends$kk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kk.apply(this, arguments); }

var _ref$kk = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM2.75 11h-.5L2 9.5 2.25 8h.5L3 9.5 2.75 11zm2 0h-.5L4 9l.25-2h.5L5 9l-.25 2zm2 0h-.5L6 8l.25-3h.5L7 8l-.25 3zm6.144 0l-4.709-.003a.208.208 0 01-.184-.2V5.403c0-.1.034-.15.162-.2a3 3 0 014.075 2.531 1.701 1.701 0 012.356 1.569c0 .938-.762 1.697-1.7 1.697z"
});

function SvgSoundcloud2(props) {
  return /*#__PURE__*/createElement("svg", _extends$kk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kk);
}

function _extends$kl() { _extends$kl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kl.apply(this, arguments); }

var _ref$kl = /*#__PURE__*/createElement("path", {
  d: "M12.775 5.44C9.751 3.192 8.708 1.393 8.001 0c-.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-.303 9.182 3.965 6.238-.278 1.827-1.227 3.159-2.191 3.733v.59h6v-.59c-.964-.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z"
});

function SvgSpades(props) {
  return /*#__PURE__*/createElement("svg", _extends$kl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kl);
}

function _extends$km() { _extends$km = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$km.apply(this, arguments); }

var _ref$km = /*#__PURE__*/createElement("path", {
  d: "M16 11.5L11.5 0h-7L0 4.5v7L4.5 16h7l4.5-4.5v-7L11.5 0zM9 13H7v-2h2v2zm0-4H7V3h2v6z"
});

function SvgSpam(props) {
  return /*#__PURE__*/createElement("svg", _extends$km({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$km);
}

function _extends$kn() { _extends$kn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kn.apply(this, arguments); }

var _ref$kn = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM14.5 12h-5a.5.5 0 01-.5-.5v-7a.5.5 0 011 0V11h4.5a.5.5 0 010 1z"
});

function SvgSpeakerLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$kn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kn);
}

function _extends$ko() { _extends$ko = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ko.apply(this, arguments); }

var _ref$ko = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM14.854 11.146l-2.155-2.155A2.503 2.503 0 0015 6.5C15 5.122 13.879 4 12.5 4h-3a.5.5 0 00-.5.5v7a.5.5 0 001 0V9h1.293l2.854 2.854a.498.498 0 00.708 0 .5.5 0 000-.707zM10 5h2.5c.827 0 1.5.673 1.5 1.5S13.327 8 12.5 8H10V5z"
});

function SvgSpeakerRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$ko({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ko);
}

function _extends$kp() { _extends$kp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kp.apply(this, arguments); }

var _ref$kp = /*#__PURE__*/createElement("path", {
  d: "M12.5 0h-9C2.675 0 2 .675 2 1.5v13c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM8 1a2 2 0 11.001 3.999A2 2 0 018 1zm0 14a4 4 0 110-8 4 4 0 010 8z"
});

var _ref2$4m = /*#__PURE__*/createElement("path", {
  d: "M8 8a3 3 0 100 6 3 3 0 000-6zm0 4a1 1 0 110-2 1 1 0 010 2zM9 3a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgSpeakers(props) {
  return /*#__PURE__*/createElement("svg", _extends$kp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kp, _ref2$4m);
}

function _extends$kq() { _extends$kq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kq.apply(this, arguments); }

var _ref$kq = /*#__PURE__*/createElement("path", {
  d: "M2 4h2v3h1V1c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v6h1V4zm0-3h2v2H2V1zm13 0V0h-3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h3V6h-3V1h3zm-5 1.5V1c0-.55-.45-1-1-1H6v7h3c.55 0 1-.45 1-1V4.5c0-.55-.137-1-.688-1 .55 0 .688-.45.688-1zM9 6H7V4h2v2zm0-3H7V1h2v2zm4 6l-6.5 7L3 11.5l1.281-1.094L6.5 12.719 12 8z"
});

function SvgSpellCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$kq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kq);
}

function _extends$kr() { _extends$kr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kr.apply(this, arguments); }

var _ref$kr = /*#__PURE__*/createElement("path", {
  d: "M2.032 10l.9-3h4.137l.9 3h1.775l-3-10H3.256l-3 10h1.776zm2.4-8h1.137l.9 3H3.532l.9-3z"
});

var _ref2$4n = /*#__PURE__*/createElement("path", {
  d: "M14 7.5L8.5 13l-2-2L5 12.5 8.5 16l7-7z"
});

function SvgSpellCheck2(props) {
  return /*#__PURE__*/createElement("svg", _extends$kr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kr, _ref2$4n);
}

function _extends$ks() { _extends$ks = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ks.apply(this, arguments); }

var _ref$ks = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm4.244 10c.134-.632.219-1.303.246-2h1.991a6.443 6.443 0 01-.479 2h-1.758zM3.256 6a11.876 11.876 0 00-.246 2H1.019a6.443 6.443 0 01.479-2h1.758zm7.463 0c.15.64.241 1.31.27 2H8V6h2.719zM8 5V2.073c.228.066.454.178.675.334.415.293.813.744 1.149 1.304.233.388.434.819.601 1.289H7.999zM5.176 3.711c.336-.561.734-1.012 1.149-1.304.222-.156.447-.268.675-.334V5H4.574a7.29 7.29 0 01.601-1.289zM7 6v2H4.011c.029-.69.12-1.36.27-2H7zm-5.502 5a6.443 6.443 0 01-.479-2H3.01c.028.697.112 1.368.246 2H1.498zm2.513-2H7v2H4.281c-.15-.64-.241-1.31-.27-2zM7 12v2.927a2.27 2.27 0 01-.675-.334c-.415-.293-.813-.744-1.149-1.304A7.221 7.221 0 014.574 12H7zm2.825 1.289c-.336.561-.734 1.012-1.149 1.304a2.282 2.282 0 01-.675.334V12h2.426c-.168.47-.369.901-.602 1.289zM8 11V9h2.989c-.029.69-.12 1.36-.27 2H8zm3.99-3a11.98 11.98 0 00-.246-2h1.758c.267.639.427 1.309.479 2H11.99zm.989-3h-1.498c-.291-.918-.693-1.723-1.177-2.366a6.462 6.462 0 011.792 1.27c.336.336.631.702.883 1.096zM2.904 3.904a6.492 6.492 0 011.792-1.27C4.213 3.277 3.81 4.082 3.519 5H2.021c.252-.394.547-.761.883-1.096zM2.021 12h1.498c.291.918.693 1.723 1.177 2.366a6.462 6.462 0 01-1.792-1.27A6.505 6.505 0 012.021 12zm10.075 1.096a6.492 6.492 0 01-1.792 1.27c.483-.643.886-1.448 1.177-2.366h1.498a6.466 6.466 0 01-.883 1.096z"
});

function SvgSphere(props) {
  return /*#__PURE__*/createElement("svg", _extends$ks({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ks);
}

function _extends$kt() { _extends$kt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kt.apply(this, arguments); }

var _ref$kt = /*#__PURE__*/createElement("path", {
  d: "M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm4.244 10c.134-.632.219-1.303.246-2h1.991a6.443 6.443 0 01-.479 2h-1.758zm-1.025-5c.15.64.241 1.31.27 2H8V6h2.719zM8 5V2.073c.228.066.454.178.675.334.415.293.813.744 1.149 1.304.233.388.434.819.601 1.289H7.999zM5.176 3.711c.336-.561.734-1.012 1.149-1.304.222-.156.447-.268.675-.334V5H4.574a7.29 7.29 0 01.601-1.289zM7 6v2H4.011c.029-.69.12-1.36.27-2H7zM4.011 9H7v2H4.281c-.15-.64-.241-1.31-.27-2zM7 12v2.927a2.27 2.27 0 01-.675-.334c-.415-.293-.813-.744-1.149-1.304A7.221 7.221 0 014.574 12H7zm2.825 1.289c-.336.561-.734 1.012-1.149 1.304a2.282 2.282 0 01-.675.334V12h2.426c-.168.47-.369.901-.602 1.289zM8 11V9h2.989c-.029.69-.12 1.36-.27 2H8zm3.99-3a11.98 11.98 0 00-.246-2h1.758c.267.639.427 1.309.479 2H11.99zm.989-3h-1.498c-.291-.918-.693-1.723-1.177-2.366a6.462 6.462 0 011.792 1.27c.336.336.631.702.883 1.096zm-.883 8.096a6.492 6.492 0 01-1.792 1.27c.483-.643.886-1.448 1.177-2.366h1.498a6.466 6.466 0 01-.883 1.096z"
});

function SvgSphere2(props) {
  return /*#__PURE__*/createElement("svg", _extends$kt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kt);
}

function _extends$ku() { _extends$ku = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ku.apply(this, arguments); }

var _ref$ku = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm.282 14.698c-.118.26-.217.406-.282.485a2.115 2.115 0 01-.282-.485c-.181-.4-.351-.954-.493-1.602l-.026-.121a13.208 13.208 0 001.602 0 4.299 4.299 0 01-.026.121c-.141.648-.312 1.202-.493 1.602zM8 12.25c-.317 0-.631-.012-.941-.036a24.04 24.04 0 01-.246-2.236 32.811 32.811 0 002.372 0 24.078 24.078 0 01-.246 2.236c-.31.024-.624.036-.941.036zm0-3c-.413 0-.823-.008-1.226-.024a30.955 30.955 0 010-2.452 30.955 30.955 0 012.452 0 30.955 30.955 0 010 2.452c-.403.016-.813.024-1.226.024zM3.75 8c0-.317.012-.631.036-.941a24.04 24.04 0 012.236-.246 32.811 32.811 0 000 2.372 24.078 24.078 0 01-2.236-.246c-.024-.31-.036-.624-.036-.941zm-.725.801a4.299 4.299 0 01-.121-.026c-.648-.141-1.202-.312-1.602-.493A2.193 2.193 0 01.817 8c.079-.066.224-.165.485-.282.4-.181.954-.351 1.602-.493l.121-.026a13.208 13.208 0 000 1.602zm4.693-7.499c.118-.26.217-.406.282-.485.066.079.165.224.282.485.181.4.351.954.493 1.602l.026.121a13.208 13.208 0 00-1.602 0l.026-.121c.141-.648.312-1.202.493-1.602zM8 3.75c.317 0 .631.012.941.036.111.688.194 1.443.246 2.236a32.811 32.811 0 00-2.372 0c.052-.793.135-1.547.246-2.236.31-.024.624-.036.941-.036zm1.978 3.064c.793.052 1.547.135 2.236.246a12.194 12.194 0 010 1.882 24.04 24.04 0 01-2.236.246 32.811 32.811 0 000-2.372zm2.997.385l.121.026c.648.141 1.202.312 1.602.493.26.118.406.217.485.282a2.115 2.115 0 01-.485.282c-.4.181-.954.351-1.602.493l-.121.026a13.208 13.208 0 000-1.602zm-.073-.779a11.507 11.507 0 00-.342-1.703c.245.118.478.246.699.384.645.403 1.147.866 1.491 1.374.13.192.235.388.314.587-.533-.25-1.273-.469-2.162-.641zm-1.02-1.342c.104.393.186.797.246 1.209a25.527 25.527 0 00-2.187-.227 25.527 25.527 0 00-.227-2.187c.412.06.816.142 1.209.246.253.067.498.142.735.225.083.237.158.482.225.735zm-2.301-1.98C9.408 2.209 9.19 1.469 8.94.936c.199.079.395.184.587.314.508.344.97.845 1.374 1.491.138.221.266.454.384.699a11.664 11.664 0 00-1.703-.342zM6.474 1.25c.192-.13.388-.235.587-.314-.25.533-.469 1.273-.641 2.162-.594.074-1.165.19-1.703.342.118-.245.246-.478.384-.699.403-.645.866-1.147 1.374-1.491zM5.078 4.118c.393-.104.797-.186 1.209-.246a25.527 25.527 0 00-.227 2.187c-.781.049-1.516.126-2.187.227.06-.412.142-.816.246-1.209.067-.253.142-.498.225-.735.237-.083.482-.158.735-.225zM3.098 6.42c-.889.173-1.629.391-2.162.641.079-.199.184-.394.314-.587.344-.508.845-.97 1.491-1.374.221-.138.454-.266.699-.384a11.664 11.664 0 00-.342 1.703zM.936 8.939c.533.25 1.273.469 2.162.641.074.594.19 1.165.342 1.703a7.294 7.294 0 01-.699-.384c-.645-.403-1.147-.866-1.491-1.374a3.068 3.068 0 01-.314-.587zm3.182 1.983a10.826 10.826 0 01-.246-1.209c.671.101 1.406.178 2.187.227.049.781.126 1.516.227 2.187-.412-.06-.816-.142-1.209-.246a9.859 9.859 0 01-.735-.225 9.859 9.859 0 01-.225-.735zm2.302 1.98c.173.889.391 1.629.641 2.162a3.098 3.098 0 01-.587-.314c-.508-.344-.97-.845-1.374-1.491a7.294 7.294 0 01-.384-.699c.539.152 1.109.267 1.703.342zm3.106 1.848c-.192.13-.388.235-.587.314.25-.533.469-1.273.641-2.162.594-.074 1.165-.19 1.703-.342a7.294 7.294 0 01-.384.699c-.403.645-.866 1.147-1.374 1.491zm1.396-2.868c-.393.104-.797.186-1.209.246.101-.671.178-1.406.227-2.187a25.527 25.527 0 002.187-.227c-.06.412-.142.816-.246 1.209a9.859 9.859 0 01-.225.735 9.859 9.859 0 01-.735.225zm1.98-2.301c.889-.173 1.629-.391 2.162-.641-.08.199-.184.395-.314.587-.344.508-.845.97-1.491 1.374a7.294 7.294 0 01-.699.384c.152-.539.267-1.109.342-1.703zm.225-6.708a7.229 7.229 0 011.601 2.421c-.638-.619-1.489-1.143-2.487-1.534-.391-.999-.915-1.849-1.534-2.487l.116.047a7.229 7.229 0 012.305 1.554zm-10.254 0a7.229 7.229 0 012.42-1.601c-.618.638-1.143 1.489-1.534 2.487-.999.391-1.849.915-2.487 1.534l.047-.115a7.229 7.229 0 011.554-2.305zm0 10.254a7.218 7.218 0 01-1.601-2.42c.638.618 1.489 1.143 2.487 1.534.391.998.915 1.849 1.534 2.487l-.115-.047a7.229 7.229 0 01-2.305-1.554zm10.254 0a7.218 7.218 0 01-2.421 1.601c.619-.638 1.143-1.489 1.534-2.487.999-.391 1.849-.915 2.487-1.534l-.047.116a7.229 7.229 0 01-1.554 2.305z"
});

function SvgSphere3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ku({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ku);
}

function _extends$kv() { _extends$kv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kv.apply(this, arguments); }

var _ref$kv = /*#__PURE__*/createElement("path", {
  d: "M6 2a2 2 0 113.999-.001A2 2 0 016 2zm4.243 1.757a2 2 0 113.999-.001 2 2 0 01-3.999.001zM13 8a1 1 0 112 0 1 1 0 01-2 0zm-1.757 4.243a1 1 0 112 0 1 1 0 01-2 0zM7 14a1 1 0 012 0 1 1 0 01-2 0zm-4.243-1.757a1 1 0 012 0 1 1 0 01-2 0zm-.5-8.486a1.5 1.5 0 013 0 1.5 1.5 0 01-3 0zM.875 8a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
});

function SvgSpinner(props) {
  return /*#__PURE__*/createElement("svg", _extends$kv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kv);
}

function _extends$kw() { _extends$kw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kw.apply(this, arguments); }

var _ref$kw = /*#__PURE__*/createElement("path", {
  d: "M.001 8.025v.003c.002.061.009.12.021.177l.011.09.011.095.019.128.045.296.068.326c.011.058.028.117.044.178l.049.188c.009.032.016.065.027.097l.031.098.065.203.017.052.019.052.039.105.081.215.094.218.048.111c.016.037.035.073.053.111l.11.224c.039.075.081.149.123.224l.063.113c.021.038.045.074.068.112l.14.224c.198.295.417.587.66.864.245.275.511.535.792.775.284.236.582.452.886.642.306.188.619.349.928.487l.232.095c.038.015.076.032.115.046l.115.041c.038.014.151.054.226.078l.224.066c.037.011.073.022.109.031l.109.027.213.052.207.04.101.019.049.009.049.007.192.027.093.013.091.009.174.015c.056.005.111.011.164.012h.011a1 1 0 001 .982l.025-.001h.004a1.02 1.02 0 00.177-.021l.09-.011.095-.011.128-.019.296-.045.326-.068c.058-.011.117-.028.178-.044l.188-.049c.032-.009.065-.016.097-.027l.098-.031.203-.065.052-.017.052-.019.105-.039.215-.081.218-.094.111-.048c.037-.016.073-.035.111-.053l.224-.11c.075-.039.149-.081.224-.123l.113-.063c.038-.021.074-.045.112-.068l.224-.14c.295-.197.587-.417.864-.66.275-.245.535-.511.775-.792.236-.284.452-.582.642-.886.188-.306.349-.619.487-.928l.095-.232c.015-.038.032-.076.046-.115l.04-.115c.013-.038.054-.151.078-.226l.066-.224c.011-.037.022-.073.031-.109l.027-.109.052-.213.04-.207.019-.101.009-.049a.753.753 0 00.007-.05l.027-.192.013-.093.009-.091.015-.174c.005-.056.011-.111.012-.165l.001-.025a1 1 0 00.996-1l-.001-.025v-.003a1.02 1.02 0 00-.021-.177l-.011-.09-.011-.095-.019-.128-.045-.296-.068-.326c-.011-.058-.028-.117-.044-.178l-.049-.188c-.009-.032-.016-.065-.027-.097l-.031-.098-.065-.203-.017-.052-.019-.052-.039-.105-.081-.215-.094-.218-.048-.111c-.016-.037-.035-.073-.053-.111l-.11-.224c-.039-.075-.081-.149-.123-.224l-.063-.113c-.021-.038-.045-.074-.068-.112l-.14-.224a8.307 8.307 0 00-.66-.864 8.164 8.164 0 00-.792-.775 8.155 8.155 0 00-.886-.642 8.024 8.024 0 00-.928-.487l-.232-.095c-.038-.015-.076-.032-.115-.046l-.115-.04c-.038-.013-.151-.054-.226-.078l-.224-.066c-.037-.01-.073-.022-.109-.031l-.109-.027a54.114 54.114 0 00-.213-.052l-.207-.04-.101-.019-.049-.009-.049-.007-.192-.027-.093-.013-.091-.009-.174-.015C9.136.987 9.081.981 9.028.98L8.989.979a1 1 0 00-.999-.981l-.025.001h-.003a1.02 1.02 0 00-.177.021l-.09.011L7.6.042l-.128.019-.296.045-.326.068c-.058.011-.117.028-.178.044l-.188.049c-.032.009-.065.016-.097.027l-.098.031-.203.065-.052.017-.052.019-.105.039-.215.081-.218.094-.111.048c-.037.016-.073.035-.111.053l-.224.11c-.075.039-.149.081-.224.123l-.113.063c-.038.021-.074.045-.112.068l-.224.14a8.448 8.448 0 00-.864.66 8.164 8.164 0 00-.775.792 8.155 8.155 0 00-.642.886 8.024 8.024 0 00-.487.928l-.095.232c-.015.038-.032.076-.046.115l-.04.115c-.013.038-.054.151-.078.226l-.066.224-.032.109c-.01.036-.018.073-.027.109l-.052.213-.04.207-.019.101-.009.049a.753.753 0 00-.007.05l-.027.192-.013.093-.009.091-.015.174c-.005.056-.011.111-.012.165l-.001.025A1 1 0 00.002 8l.001.025zm1.148-1.014l.002-.009c.01-.051.026-.102.04-.155l.045-.163.024-.084.028-.086.058-.176.015-.045.017-.045.035-.091.073-.186.084-.189.043-.096.048-.096.098-.194c.034-.065.073-.128.109-.194l.056-.098c.019-.033.04-.064.061-.096l.124-.194a7.38 7.38 0 01.583-.744c.217-.236.451-.459.697-.665.25-.202.511-.385.776-.547.268-.159.541-.294.808-.41l.202-.079c.033-.013.066-.027.099-.038l.1-.033c.033-.011.131-.045.196-.065l.194-.054c.032-.009.063-.019.095-.026l.094-.021.184-.042.179-.032.087-.015.043-.008c.014-.003.029-.003.043-.005l.166-.02.08-.01.078-.006.15-.011c.049-.003.095-.008.142-.008l.256-.006.2.007.085.002a11.23 11.23 0 01.34.024l.022-.001h.004a1 1 0 00.962-.84l.025.006c.051.01.102.026.155.04l.163.045.084.024.086.028.176.058.045.015.045.017.091.035.186.073.189.084.096.043.096.048.194.098c.065.034.129.073.194.109l.098.056c.033.019.064.04.096.061l.194.124c.255.176.506.369.744.583.236.217.459.451.665.697.202.25.385.511.547.776.159.268.294.541.41.808l.079.202c.013.033.027.066.038.099l.033.1c.011.033.045.131.065.196l.054.194c.009.032.019.063.026.095l.021.094.042.184.032.179.015.087.008.043c.003.014.003.029.005.043l.02.166.01.08.006.078.011.15c.003.049.008.095.008.142l.006.256-.007.2-.002.085a11.23 11.23 0 01-.024.34l.001.022v.004a1 1 0 00.823.959l-.003.014c-.01.051-.025.102-.04.155l-.045.163-.024.084-.028.086-.058.176-.015.045-.017.045-.035.091-.073.186-.084.189-.043.096-.048.096-.098.194c-.034.065-.073.129-.109.194l-.056.098c-.019.033-.04.064-.061.096l-.124.194a7.38 7.38 0 01-.583.744 7.422 7.422 0 01-.697.665c-.25.202-.511.385-.776.547a7.227 7.227 0 01-.808.41l-.202.079c-.033.013-.066.027-.099.038l-.1.033c-.033.011-.131.045-.196.065l-.194.054c-.032.009-.063.019-.095.026l-.094.021-.184.042-.179.032-.087.015-.043.008c-.015.003-.029.003-.043.005l-.166.02-.08.01-.078.006-.15.011c-.049.003-.095.008-.142.008a77.64 77.64 0 00-.256.006l-.2-.007-.085-.002a11.23 11.23 0 01-.34-.024l-.022.001H7.96a1.001 1.001 0 00-.961.834c-.05-.01-.101-.025-.153-.039l-.163-.045-.084-.024-.086-.028-.176-.058-.045-.015-.045-.017-.091-.035a31.884 31.884 0 01-.186-.073 17.554 17.554 0 00-.189-.084l-.096-.043-.096-.048-.194-.098c-.065-.034-.129-.073-.194-.109l-.098-.056c-.033-.019-.064-.04-.096-.061l-.194-.124a7.238 7.238 0 01-.744-.583 7.422 7.422 0 01-.665-.697 7.276 7.276 0 01-.547-.776 7.227 7.227 0 01-.41-.808l-.079-.202c-.013-.033-.027-.066-.038-.099l-.033-.1c-.011-.033-.045-.131-.065-.196l-.054-.194c-.009-.032-.019-.063-.026-.095l-.021-.094a78.832 78.832 0 00-.042-.184l-.032-.179-.015-.087-.008-.043c-.003-.015-.003-.029-.005-.043a12.365 12.365 0 01-.02-.166l-.01-.08-.006-.078-.011-.15c-.003-.049-.008-.095-.008-.142a77.64 77.64 0 00-.006-.256l.007-.2.002-.085a11.23 11.23 0 01.024-.34L2 7.98v-.003a1 1 0 00-.851-.964z"
});

function SvgSpinner10(props) {
  return /*#__PURE__*/createElement("svg", _extends$kw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kw);
}

function _extends$kx() { _extends$kx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kx.apply(this, arguments); }

var _ref$kx = /*#__PURE__*/createElement("path", {
  d: "M16 6h-6l2.243-2.243C11.11 2.624 9.603 2 8 2s-3.109.624-4.243 1.757C2.624 4.89 2 6.397 2 8s.624 3.109 1.757 4.243C4.89 13.376 6.397 14 8 14a5.963 5.963 0 004.516-2.049l1.505 1.317a8 8 0 11-.364-10.924L16 0v6z"
});

function SvgSpinner11(props) {
  return /*#__PURE__*/createElement("svg", _extends$kx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kx);
}

function _extends$ky() { _extends$ky = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ky.apply(this, arguments); }

var _ref$ky = /*#__PURE__*/createElement("path", {
  d: "M16 8a7.917 7.917 0 00-2.431-5.568A7.776 7.776 0 005.057.896c-.923.405-1.758.992-2.449 1.712S1.371 4.182 1.011 5.105a7.531 7.531 0 00.115 5.742c.392.892.961 1.7 1.658 2.368S4.307 14.41 5.2 14.758a7.286 7.286 0 002.799.493 7.157 7.157 0 006.526-4.547 6.98 6.98 0 00.415-1.622l.059.002a1 1 0 00.996-1.083h.004zm-1.589 2.655c-.367.831-.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434a6.759 6.759 0 01-2.608.454 6.676 6.676 0 01-4.685-2.065 6.597 6.597 0 01-1.38-2.173 6.514 6.514 0 01.116-4.976c.342-.77.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c.771-.298 1.596-.438 2.416-.416s1.629.202 2.368.532c.74.329 1.41.805 1.963 1.387s.988 1.27 1.272 2.011a6.02 6.02 0 01.397 2.32h.004a1 1 0 00.888 1.077 6.872 6.872 0 01-.481 1.578z"
});

function SvgSpinner2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ky({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ky);
}

function _extends$kz() { _extends$kz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kz.apply(this, arguments); }

var _ref$kz = /*#__PURE__*/createElement("path", {
  d: "M8 4.736a.933.933 0 01-.933-.933V1.005a.933.933 0 011.866 0v2.798A.933.933 0 018 4.736zM8 15.577a.583.583 0 01-.583-.583v-2.798a.583.583 0 111.166 0v2.798a.583.583 0 01-.583.583zM5.902 5.24a.875.875 0 01-.758-.437L3.745 2.38a.874.874 0 011.514-.874l1.399 2.423a.874.874 0 01-.756 1.311zM11.498 14.582a.525.525 0 01-.455-.262l-1.399-2.423a.525.525 0 11.909-.525l1.399 2.423a.525.525 0 01-.454.787zM4.365 6.718a.813.813 0 01-.407-.109L1.535 5.21a.817.817 0 01.816-1.414l2.423 1.399a.817.817 0 01-.408 1.523zM14.057 11.964a.461.461 0 01-.233-.063l-2.423-1.399a.467.467 0 01.466-.808l2.423 1.399a.467.467 0 01-.233.87zM3.803 8.758H1.005a.758.758 0 010-1.516h2.798a.758.758 0 110 1.516zM14.995 8.466h-2.798a.466.466 0 110-.932h2.798a.466.466 0 110 .932zM1.943 12.197a.698.698 0 01-.35-1.305l2.423-1.399a.698.698 0 11.699 1.211l-2.423 1.399a.69.69 0 01-.349.094zM11.635 6.368a.466.466 0 01-.233-.87l2.423-1.399a.466.466 0 11.466.808l-2.423 1.399a.469.469 0 01-.233.063zM4.502 14.699a.64.64 0 01-.555-.962l1.399-2.423a.641.641 0 111.111.641l-1.399 2.423a.64.64 0 01-.556.321zM10.098 4.832a.467.467 0 01-.404-.7l1.399-2.423a.467.467 0 01.808.466l-1.399 2.423a.464.464 0 01-.404.233z"
});

function SvgSpinner3(props) {
  return /*#__PURE__*/createElement("svg", _extends$kz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kz);
}

function _extends$kA() { _extends$kA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kA.apply(this, arguments); }

var _ref$kA = /*#__PURE__*/createElement("path", {
  d: "M3 8c0-.19.011-.378.032-.563l-2.89-.939A8.085 8.085 0 00.001 8c0 2.3.971 4.374 2.526 5.833l1.786-2.458A4.982 4.982 0 013.001 8zm10 0a4.978 4.978 0 01-1.312 3.375l1.786 2.458A7.975 7.975 0 0016 8c0-.513-.049-1.015-.141-1.502l-2.89.939c.021.185.032.373.032.563zM9 3.1a5.01 5.01 0 013.351 2.435l2.89-.939A8.01 8.01 0 009 .062V3.1zM3.649 5.535A5.007 5.007 0 017 3.1V.062A8.005 8.005 0 00.759 4.596l2.89.939zm6.422 7.017C9.44 12.84 8.739 13 8 13s-1.44-.16-2.071-.448L4.143 15.01C5.287 15.641 6.601 16 8 16s2.713-.359 3.857-.99l-1.786-2.458z"
});

function SvgSpinner4(props) {
  return /*#__PURE__*/createElement("svg", _extends$kA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kA);
}

function _extends$kB() { _extends$kB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kB.apply(this, arguments); }

var _ref$kB = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 4a4 4 0 110 8 4 4 0 010-8zm4.773 8.773C11.498 14.048 9.803 14.75 8 14.75s-3.498-.702-4.773-1.977S1.25 9.803 1.25 8c0-1.803.702-3.498 1.977-4.773l1.061 1.061a5.256 5.256 0 000 7.425c.992.992 2.31 1.538 3.712 1.538s2.721-.546 3.712-1.538a5.256 5.256 0 000-7.425l1.061-1.061C14.048 4.502 14.75 6.197 14.75 8s-.702 3.498-1.977 4.773z"
});

function SvgSpinner5(props) {
  return /*#__PURE__*/createElement("svg", _extends$kB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kB);
}

function _extends$kC() { _extends$kC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kC.apply(this, arguments); }

var _ref$kC = /*#__PURE__*/createElement("path", {
  d: "M6 2a2 2 0 113.999-.001A2 2 0 016 2zm6.359 6a1.641 1.641 0 013.282 0 1.641 1.641 0 01-3.282 0zm-1.602 4.243a1.486 1.486 0 112.971 0 1.486 1.486 0 01-2.971 0zM6.654 14a1.346 1.346 0 112.693.001A1.346 1.346 0 016.654 14zm-4.116-1.757a1.22 1.22 0 112.439 0 1.22 1.22 0 01-2.439 0zM.896 8a1.104 1.104 0 112.207 0A1.104 1.104 0 01.896 8zm1.861-4.243a1 1 0 012 0 1 1 0 01-2 0zm11.297 0a1.811 1.811 0 11-3.623 0 1.811 1.811 0 013.623 0z"
});

function SvgSpinner6(props) {
  return /*#__PURE__*/createElement("svg", _extends$kC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kC);
}

function _extends$kD() { _extends$kD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kD.apply(this, arguments); }

var _ref$kD = /*#__PURE__*/createElement("path", {
  d: "M6.5 14.5a1.5 1.5 0 113.001.001A1.5 1.5 0 016.5 14.5zM0 8a1.5 1.5 0 113.001.001A1.5 1.5 0 010 8zm13 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0113 8zM1.904 3.404a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm9.192 9.192a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm-9.192 0a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001zm9.192-9.192a1.5 1.5 0 113.001.001 1.5 1.5 0 01-3.001-.001z"
});

function SvgSpinner7(props) {
  return /*#__PURE__*/createElement("svg", _extends$kD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kD);
}

function _extends$kE() { _extends$kE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kE.apply(this, arguments); }

var _ref$kE = /*#__PURE__*/createElement("path", {
  d: "M8 16c-2.137 0-4.146-.832-5.657-2.343S0 10.137 0 8c0-1.513.425-2.986 1.228-4.261A8.02 8.02 0 014.421.844l.672 1.341a6.53 6.53 0 00-2.596 2.354A6.48 6.48 0 001.5 8c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-.345-2.426-.997-3.461a6.515 6.515 0 00-2.596-2.354l.672-1.341a8.02 8.02 0 013.193 2.895A7.981 7.981 0 0116 8c0 2.137-.832 4.146-2.343 5.657S10.137 16 8 16z"
});

function SvgSpinner8(props) {
  return /*#__PURE__*/createElement("svg", _extends$kE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kE);
}

function _extends$kF() { _extends$kF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kF.apply(this, arguments); }

var _ref$kF = /*#__PURE__*/createElement("path", {
  d: "M8 0A8 8 0 00.002 7.812C.094 4.033 2.968 1 6.5 1 10.09 1 13 4.134 13 8a1.5 1.5 0 003 0 8 8 0 00-8-8zm0 16a8 8 0 007.998-7.812C15.906 11.967 13.032 15 9.5 15 5.91 15 3 11.866 3 8a1.5 1.5 0 00-3 0 8 8 0 008 8z"
});

function SvgSpinner9(props) {
  return /*#__PURE__*/createElement("svg", _extends$kF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kF);
}

function _extends$kG() { _extends$kG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kG.apply(this, arguments); }

var _ref$kG = /*#__PURE__*/createElement("path", {
  d: "M5.5 0H0v5.5l2.043-2.043L7 8.414V16h2V7.586L3.457 2.043zM15 0H9.5l2.043 2.043-3 3 1.414 1.414 3-3L15 5.5z"
});

function SvgSplit(props) {
  return /*#__PURE__*/createElement("svg", _extends$kG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kG);
}

function _extends$kH() { _extends$kH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kH.apply(this, arguments); }

var _ref$kH = /*#__PURE__*/createElement("path", {
  d: "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655.985 3.042 2.308 3.406l-.497 8.096A.931.931 0 003.25 16h.5c.55 0 .972-.449.939-.998l-.497-8.096C5.515 6.541 6.5 5.155 6.5 3.5c0-1.933-1.343-3.5-3-3.5zm10.083 0l-.833 5h-.625l-.417-5h-.417l-.417 5h-.625l-.833-5h-.417v6.5a.5.5 0 00.5.5h1.302l-.491 8.002a.931.931 0 00.939.998h.5c.55 0 .972-.449.939-.998L12.197 7h1.302a.5.5 0 00.5-.5V0h-.417z"
});

function SvgSpoonKnife(props) {
  return /*#__PURE__*/createElement("svg", _extends$kH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kH);
}

function _extends$kI() { _extends$kI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kI.apply(this, arguments); }

var _ref$kI = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zm3.681 11.559c-.159.241-.441.319-.681.159-1.881-1.159-4.241-1.4-7.041-.759-.281.081-.519-.119-.6-.359-.081-.281.119-.519.359-.6 3.041-.681 5.681-.4 7.759.881.281.119.322.438.203.678zm.96-2.2c-.2.281-.559.4-.841.2C9.641 8.24 6.359 7.84 3.841 8.64c-.319.081-.681-.081-.759-.4-.081-.319.081-.681.4-.759 2.919-.881 6.519-.441 9 1.081.238.119.359.519.159.797zm.078-2.24C10.16 5.6 5.878 5.438 3.438 6.2a.749.749 0 01-.919-.481c-.119-.4.119-.8.481-.919 2.841-.841 7.519-.681 10.481 1.081.359.2.481.681.281 1.041-.203.278-.681.397-1.044.197z"
});

function SvgSpotify(props) {
  return /*#__PURE__*/createElement("svg", _extends$kI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kI);
}

function _extends$kJ() { _extends$kJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kJ.apply(this, arguments); }

var _ref$kJ = /*#__PURE__*/createElement("path", {
  d: "M2 0h11v1H2V0zM5 5v11h5V5l2.625-3.5H2.375L5 5zm4 5.5a1.5 1.5 0 01-3 0v-2a1.5 1.5 0 013 0v2z"
});

var _ref2$4o = /*#__PURE__*/createElement("path", {
  d: "M7.5 11a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z"
});

function SvgSpotlight(props) {
  return /*#__PURE__*/createElement("svg", _extends$kJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kJ, _ref2$4o);
}

function _extends$kK() { _extends$kK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kK.apply(this, arguments); }

var _ref$kK = /*#__PURE__*/createElement("path", {
  d: "M15.582 13.736l-.11-.111h-.035a2.727 2.727 0 00-.453-.25h.241l-.247-.25h-.777c-.368-.08-.774-.125-1.2-.125s-.833.045-1.201.125H9.148l.136.25h1.732a2.727 2.727 0 00-.453.25H9.42l.136.25h.716c-.073.08-.133.164-.178.25h-.402l.136.25h.182a.745.745 0 00-.001.25h-.045l.094.173c.276.686 1.488 1.202 2.941 1.202 1.657 0 3-.672 3-1.5 0-.279-.153-.541-.418-.764zm-5.246.074zm-.293.436l-.002.006.002-.006zm.025-.065a.02.02 0 01-.004.008.02.02 0 01.004-.008zm-.025.571l.001.004-.001-.004zm-.024-.083v0zm.01.041l.001.004-.001-.004zM5.6 13.125C5.11 13.045 4.569 13 4 13s-1.11.045-1.6.125H1.154l-.264.25h.465l.002-.001a4.1 4.1 0 00-.605.251H.627l-.264.25h.001c-.233.19-.363.402-.363.625 0 .828 1.791 1.5 4 1.5 2.034 0 3.713-.569 3.967-1.306h.001l.033-.069h-.014a.584.584 0 000-.25h.134l.12-.25h-.366a1.198 1.198 0 00-.237-.25h.722l.12-.25h-1.23a4.088 4.088 0 00-.604-.25H8.6l.12-.25H5.602zm2.314 1.064l-.005-.008.005.008zm.031.063l-.003-.006.003.006zm-.641-.597zm6.2-10.53h-1.801l-.264.25h1.945zm-.239.5h-2.089l-.264.25h2.233zm.718-1.5h-1.225l-.264.25h1.369zm-.239.5h-1.513l-.264.25h1.657zm.478-1h-.937l-.264.25h1.081zm.24-.5h-.648l-.264.25h.793zm.478-1h-.072l-.264.25h.216zm-.239.5h-.36l-.264.25h.504zm-1.915 4H10.12l-.264.25h2.81zm.24-.5h-2.378l-.264.25h2.522zm-.718 1.5H9.066l-.264.25h3.386zm.239-.5H9.593l-.264.25h3.098zm2.184 7.75l-.247-.25H8.958l.12-.25h5.159l-.247-.25H9.198l.12-.25h4.425l-.247-.25H9.438l.12-.25h3.691l-.247-.25H9.677l.12-.25h2.958l-.247-.25H9.917l.12-.25h2.224l-.247-.25h-1.857l.12-.25h1.49l-.247-.25h-1.124l.12-.25h.757l-.247-.25h-.39l.12-.25h.023l-.016-.016.112-.234h-.344l-.247-.25h.711l.12-.25h-1.077l-.247-.25h1.444l.12-.25H9.544l-.247-.25h2.178l.12-.25H9.05l-.247-.25h2.912l.12-.25H8.556l-.247-.25h3.645l.12-.25h-3.53l-.249.236-.233-.236H5.341l.136.25H8.28l-.264.25H5.613l.136.25h2.003l-.264.25H5.885l.136.25h1.203l-.264.25h-.803l.136.25h.403l-.264.25h-.003l.001.002-.262.248h.397l.136.25h-.796l-.264.25h1.196l.136.25H5.377l-.264.25h1.996l.136.25H4.849l-.264.25h2.796l.136.25H4.321l-.264.25h3.596l.136.25H3.793l-.264.25h4.396l.136.25H3.266l-.264.25h5.195l.136.25H2.738l-.264.25h5.995l.136.25H2.21l-.264.25h6.795l.136.25H1.682l-.264.25h7.421l.081-.17.093.17zm-11.165-10h1.277l-.247-.25H3.43zm-.545-1h.833l-.247-.25h-.722zm.272.5h1.055l-.247-.25h-.944zm-.544-1h.611l-.247-.25h-.5zm-.378-1l-.247-.25h-.055l.136.25zm1.739 3.5h1.721l-.247-.25h-1.61zm-1.633-3h.389l-.247-.25h-.278zm1.361 2.5h1.499l-.247-.25H3.702zm.817 1.5H6.82l-.247-.25H4.519zm-.272-.5h1.943l-.247-.25H4.247zm.544 1h2.387l-.247-.25H4.791zm.273.5h2.609l-.247-.25H5.064z"
});

function SvgSpotlight2(props) {
  return /*#__PURE__*/createElement("svg", _extends$kK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kK);
}

function _extends$kL() { _extends$kL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kL.apply(this, arguments); }

var _ref$kL = /*#__PURE__*/createElement("path", {
  d: "M8 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM6 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM6 1.5a.5.5 0 11-1 0 .5.5 0 011 0zM4 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM2 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM1 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM3 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM2 1.5a.5.5 0 11-1 0 .5.5 0 011 0zM1 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM1 .5a.5.5 0 11-1 0 .5.5 0 011 0zM5 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM4 1.5a.5.5 0 11-1 0 .5.5 0 011 0zM3 .5a.5.5 0 11-1 0 .5.5 0 011 0zM5 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM3 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM2 5.5a.5.5 0 11-1 0 .5.5 0 011 0zM7 2.5a.5.5 0 11-1 0 .5.5 0 011 0zM14.45 4.308A10.14 10.14 0 0013 4.071v-1.57c0-.276-.672-.5-1.5-.5s-1.5.224-1.5.5v.5h.5c.276 0 .5.224.5.5s-.224.53-.5.53a11.1 11.1 0 00-1.95.277C8.167 4.404 7 4.696 7 5.5v9c0 .805 1.167 1.096 1.55 1.192.794.198 1.842.308 2.95.308s2.156-.109 2.95-.308c.383-.096 1.55-.388 1.55-1.192v-9c0-.805-1.167-1.096-1.55-1.192zm.55 6.165a5.21 5.21 0 00-.55-.165c-.673-.168-1.529-.272-2.45-.3V13.5a.5.5 0 01-1 0v-3.492c-.92.028-1.776.132-2.45.3-.124.031-.329.082-.55.165V6.528c.221.082.427.134.55.165.673.168 1.529.272 2.45.3v3.016a16.515 16.515 0 011 0V6.993c.92-.028 1.776-.132 2.45-.3.124-.031.329-.082.55-.165v3.945z"
});

function SvgSpray(props) {
  return /*#__PURE__*/createElement("svg", _extends$kL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kL);
}

function _extends$kM() { _extends$kM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kM.apply(this, arguments); }

var _ref$kM = /*#__PURE__*/createElement("path", {
  d: "M16 16V0H0v16h16zM2 2h12v12H2V2z"
});

var _ref2$4p = /*#__PURE__*/createElement("path", {
  d: "M10.5 4l-4 4L4 5.5V12h6.5L8 9.5l4-4z"
});

function SvgSquareDownLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$kM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kM, _ref2$4p);
}

function _extends$kN() { _extends$kN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kN.apply(this, arguments); }

var _ref$kN = /*#__PURE__*/createElement("path", {
  d: "M16 0H0v16h16V0zM2 14V2h12v12H2z"
});

var _ref2$4q = /*#__PURE__*/createElement("path", {
  d: "M4 5.5l4 4L5.5 12H12V5.5L9.5 8l-4-4z"
});

function SvgSquareDownRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$kN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kN, _ref2$4q);
}

function _extends$kO() { _extends$kO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kO.apply(this, arguments); }

var _ref$kO = /*#__PURE__*/createElement("path", {
  d: "M0 16V0h16v16H0zM14 2H2v12h12V2z"
});

var _ref2$4r = /*#__PURE__*/createElement("path", {
  d: "M3.5 8L8 12.5 12.5 8H9V3H7v5z"
});

function SvgSquareDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$kO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kO, _ref2$4r);
}

function _extends$kP() { _extends$kP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kP.apply(this, arguments); }

var _ref$kP = /*#__PURE__*/createElement("path", {
  d: "M0 16h16V0H0v16zM14 2v12H2V2h12z"
});

var _ref2$4s = /*#__PURE__*/createElement("path", {
  d: "M8 12.5L3.5 8 8 3.5V7h5v2H8z"
});

function SvgSquareLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$kP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kP, _ref2$4s);
}

function _extends$kQ() { _extends$kQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kQ.apply(this, arguments); }

var _ref$kQ = /*#__PURE__*/createElement("path", {
  d: "M16 0H0v16h16V0zM2 14V2h12v12H2z"
});

var _ref2$4t = /*#__PURE__*/createElement("path", {
  d: "M8 3.5L12.5 8 8 12.5V9H3V7h5z"
});

function SvgSquareRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$kQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kQ, _ref2$4t);
}

function _extends$kR() { _extends$kR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kR.apply(this, arguments); }

var _ref$kR = /*#__PURE__*/createElement("path", {
  d: "M0 16h16V0H0v16zM14 2v12H2V2h12z"
});

var _ref2$4u = /*#__PURE__*/createElement("path", {
  d: "M12 10.5l-4-4L10.5 4H4v6.5L6.5 8l4 4z"
});

function SvgSquareUpLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$kR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kR, _ref2$4u);
}

function _extends$kS() { _extends$kS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kS.apply(this, arguments); }

var _ref$kS = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm14 14H2V2h12v12z"
});

var _ref2$4v = /*#__PURE__*/createElement("path", {
  d: "M5.5 12l4-4 2.5 2.5V4H5.5L8 6.5l-4 4z"
});

function SvgSquareUpRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$kS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kS, _ref2$4v);
}

function _extends$kT() { _extends$kT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kT.apply(this, arguments); }

var _ref$kT = /*#__PURE__*/createElement("path", {
  d: "M0 0v16h16V0H0zm14 14H2V2h12v12z"
});

var _ref2$4w = /*#__PURE__*/createElement("path", {
  d: "M3.5 8L8 3.5 12.5 8H9v5H7V8z"
});

function SvgSquareUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$kT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kT, _ref2$4w);
}

function _extends$kU() { _extends$kU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kU.apply(this, arguments); }

var _ref$kU = /*#__PURE__*/createElement("path", {
  d: "M0 0h16v16H0z"
});

function SvgSquare(props) {
  return /*#__PURE__*/createElement("svg", _extends$kU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kU);
}

function _extends$kV() { _extends$kV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kV.apply(this, arguments); }

var _ref$kV = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-2-3.061V10h-1.061L10.5 8.561 9.061 10H8V8.939L9.439 7.5 8 6.061V5h1.061L10.5 6.439 11.939 5H13v1.061L11.561 7.5z"
});

function SvgStackCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$kV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kV);
}

function _extends$kW() { _extends$kW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kW.apply(this, arguments); }

var _ref$kW = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM6 12V2h9v2.5l-.707-.707L10 7.586 7.707 5.793l-.914.914L10 10.414l5-5.48V12H6z"
});

function SvgStackCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$kW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kW);
}

function _extends$kX() { _extends$kX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kX.apply(this, arguments); }

var _ref$kX = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zM7 7.5a1.5 1.5 0 113.001.001A1.5 1.5 0 017 7.5zm4 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0111 7.5zm1-2.656c0 .466-.212.881-.545 1.156C11 6.484 11 7 11 7.5v1c0 1 0 2 1 2v.5H9v-.5c1 0 1-1 1-2v-1c0-.5 0-1.016-.455-1.5A1.5 1.5 0 1112 4.844z"
});

function SvgStackClubs(props) {
  return /*#__PURE__*/createElement("svg", _extends$kX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kX);
}

function _extends$kY() { _extends$kY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kY.apply(this, arguments); }

var _ref$kY = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-4.5-1L8 7l2.5-4L13 7z"
});

function SvgStackDiamonds(props) {
  return /*#__PURE__*/createElement("svg", _extends$kY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kY);
}

function _extends$kZ() { _extends$kZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$kZ.apply(this, arguments); }

var _ref$kZ = /*#__PURE__*/createElement("path", {
  d: "M16 13V1H5v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16zM6 2h9v10H6V2zM5 3.07V13h2.543l-2.721.382L3.404 3.294l1.595-.224zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zM14.5 7l-4 4-4-4H9V4h3v3z"
});

function SvgStackDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$kZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$kZ);
}

function _extends$k_() { _extends$k_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k_.apply(this, arguments); }

var _ref$k_ = /*#__PURE__*/createElement("path", {
  d: "M16 13V1H5v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16zM6 2h9v10H6V2zM5 3.07V13h2.543l-2.721.382L3.404 3.294l1.595-.224zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894z"
});

function SvgStackEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$k_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k_);
}

function _extends$k$() { _extends$k$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k$.apply(this, arguments); }

var _ref$k$ = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-1.074-6.584c.048.133.074.305.074.521 0 2.5-3.5 2.5-3.5 5 0-2.5-3.5-2.5-3.5-5 0-.216.026-.388.074-.521.226-.782.821-1.354 1.676-1.354.695 0 1.426.597 1.75 1.159.324-.562 1.055-1.159 1.75-1.159.855 0 1.45.572 1.676 1.354z"
});

function SvgStackHearts(props) {
  return /*#__PURE__*/createElement("svg", _extends$k$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$k$);
}

function _extends$l0() { _extends$l0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l0.apply(this, arguments); }

var _ref$l0 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zM8 7h5v1H8z"
});

function SvgStackMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$l0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l0);
}

function _extends$l1() { _extends$l1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l1.apply(this, arguments); }

var _ref$l1 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-6.5-1A1.5 1.5 0 119 8.086V4l5-1v5.5a1.5 1.5 0 11-1-1.414V5.2l-3 .6v3.7A1.5 1.5 0 018.5 11z"
});

function SvgStackMusic(props) {
  return /*#__PURE__*/createElement("svg", _extends$l1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l1);
}

function _extends$l2() { _extends$l2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l2.apply(this, arguments); }

var _ref$l2 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-5-1H7l1-4h1l2.333 2.333L12 8h1l1 3zm1-6a1 1 0 112 0 1 1 0 01-2 0z"
});

function SvgStackPicture(props) {
  return /*#__PURE__*/createElement("svg", _extends$l2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l2);
}

function _extends$l3() { _extends$l3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l3.apply(this, arguments); }

var _ref$l3 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zM9 4l5 3-5 3z"
});

function SvgStackPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$l3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l3);
}

function _extends$l4() { _extends$l4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l4.apply(this, arguments); }

var _ref$l4 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-2-4h-2v2h-1V8H8V7h2V5h1v2h2z"
});

function SvgStackPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$l4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l4);
}

function _extends$l5() { _extends$l5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l5.apply(this, arguments); }

var _ref$l5 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-4.5-9.937c0 2.828 3.5 2.938 3.5 5.438a1.5 1.5 0 01-3 0v1c0 1 0 2 1 2v.5H9v-.5c1 0 1-1 1-2v-1a1.5 1.5 0 01-3 0c0-2.5 3.5-2.609 3.5-5.438z"
});

function SvgStackSpades(props) {
  return /*#__PURE__*/createElement("svg", _extends$l5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l5);
}

function _extends$l6() { _extends$l6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l6.apply(this, arguments); }

var _ref$l6 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-4.5-8.186l.715 2.202h2.315l-1.873 1.361.715 2.201-1.873-1.361-1.873 1.361.715-2.201-1.873-1.361h2.315z"
});

function SvgStackStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$l6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l6);
}

function _extends$l7() { _extends$l7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l7.apply(this, arguments); }

var _ref$l7 = /*#__PURE__*/createElement("path", {
  d: "M16 13V1H5v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16zM6 2h9v10H6V2zM5 3.07V13h2.543l-2.721.382L3.404 3.294l1.595-.224zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zM7 3h7v1H7zm0 2h7v1H7zm0 2h7v1H7zm0 2h5v1H7z"
});

function SvgStackText(props) {
  return /*#__PURE__*/createElement("svg", _extends$l7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l7);
}

function _extends$l8() { _extends$l8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l8.apply(this, arguments); }

var _ref$l8 = /*#__PURE__*/createElement("path", {
  d: "M16 13V1H5v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16zM6 2h9v10H6V2zM5 3.07V13h2.543l-2.721.382L3.404 3.294l1.595-.224zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zM6.5 7l4-4 4 4H12v3H9V7z"
});

function SvgStackUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$l8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l8);
}

function _extends$l9() { _extends$l9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l9.apply(this, arguments); }

var _ref$l9 = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zm-2-3v1H8V9c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zM9 6.5a1.5 1.5 0 113.001.001A1.5 1.5 0 019 6.5z"
});

function SvgStackUser(props) {
  return /*#__PURE__*/createElement("svg", _extends$l9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l9);
}

function _extends$la() { _extends$la = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$la.apply(this, arguments); }

var _ref$la = /*#__PURE__*/createElement("path", {
  d: "M13.75 4H13v-.75C13 2.561 12.439 2 11.75 2H11v-.75C11 .561 10.439 0 9.75 0h-7.5C1.561 0 1 .561 1 1.25v9.5c0 .689.561 1.25 1.25 1.25H3v.75c0 .689.561 1.25 1.25 1.25H5v.75c0 .689.561 1.25 1.25 1.25h7.5c.689 0 1.25-.561 1.25-1.25v-9.5C15 4.561 14.439 4 13.75 4zm-11.5 7a.25.25 0 01-.25-.25v-9.5A.25.25 0 012.25 1h7.5c.137 0 .25.113.25.25V2H4.25C3.561 2 3 2.561 3 3.25V11h-.75zm2 2a.25.25 0 01-.25-.25v-9.5A.25.25 0 014.25 3h7.5a.25.25 0 01.25.25V4H6.25C5.561 4 5 4.561 5 5.25V13h-.75zM14 14.75c0 .137-.113.25-.25.25h-7.5a.25.25 0 01-.25-.25v-9.5A.25.25 0 016.25 5h7.5a.25.25 0 01.25.25v9.5z"
});

function SvgStack(props) {
  return /*#__PURE__*/createElement("svg", _extends$la({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$la);
}

function _extends$lb() { _extends$lb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lb.apply(this, arguments); }

var _ref$lb = /*#__PURE__*/createElement("path", {
  d: "M16 5L8 1 0 5l8 4 8-4zM8 2.328L13.345 5 8 7.672 2.655 5 8 2.328zm6.398 4.871L16 8l-8 4-8-4 1.602-.801L8 10.398zm0 3L16 11l-8 4-8-4 1.602-.801L8 13.398z"
});

function SvgStack2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lb);
}

function _extends$lc() { _extends$lc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lc.apply(this, arguments); }

var _ref$lc = /*#__PURE__*/createElement("path", {
  d: "M8 9L0 5l8-4 8 4zm6.398-1.801L16 8l-8 4-8-4 1.602-.801L8 10.398zm0 3L16 11l-8 4-8-4 1.602-.801L8 13.398z"
});

function SvgStack3(props) {
  return /*#__PURE__*/createElement("svg", _extends$lc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lc);
}

function _extends$ld() { _extends$ld = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ld.apply(this, arguments); }

var _ref$ld = /*#__PURE__*/createElement("path", {
  d: "M5 1v1.155l-2.619.368.17 1.211L0 4.466l3.308 11.535 10.189-2.921.558-.079H16v-12H5zM3.929 14.879L1.121 5.086l1.558-.447 1.373 9.766 2.997-.421-3.119.894zm.893-1.497L3.404 3.294l1.595-.224V13h2.543l-2.721.382zM15 12H6V2h9v10zM7 7.125h7v.25H7zm0 .5h7v.25H7zm0 1h7v.25H7zm0-.5h7v.25H7zm0 1h7v.25H7zm0 1.5h7v.25H7zm0-1h7v.25H7zm0 .5h7v.25H7zm0-5.5h7v.25H7zm0-1h7v.25H7zm0 .5h7v.25H7zm0-1h7v.25H7zm0 3.5h7v.25H7zm0-.5h7v.25H7zm0-1h7v.25H7zm0 .5h7v.25H7z"
});

function SvgStack4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ld({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ld);
}

function _extends$le() { _extends$le = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$le.apply(this, arguments); }

var _ref$le = /*#__PURE__*/createElement("path", {
  d: "M16 10v6H0v-6h2v4h12v-4zM3 11h10v2H3zm.237-2.165l.433-1.953 9.763 2.164L13 10.999zM4.37 4.821l.845-1.813 9.063 4.226-.845 1.813zm11.126.827l-1.218 1.587-7.934-6.088L7.224 0h.91z"
});

function SvgStackoverflow(props) {
  return /*#__PURE__*/createElement("svg", _extends$le({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$le);
}

function _extends$lf() { _extends$lf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lf.apply(this, arguments); }

var _ref$lf = /*#__PURE__*/createElement("path", {
  d: "M4 2v3h3v3h3v3h3v3h3v2h-5v-3H8v-3H5V7H2V4H0V2zm3-2l7.406 7.5L16 6v4h-4l1.406-1.5L6 1z"
});

function SvgStairsDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$lf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lf);
}

function _extends$lg() { _extends$lg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lg.apply(this, arguments); }

var _ref$lg = /*#__PURE__*/createElement("path", {
  d: "M12 2v3H9v3H6v3H3v3H0v2h5v-3h3v-3h3V7h3V4h2V2zM1 10l7.406-7.5L10 4V0H6l1.406 1.5L0 9z"
});

function SvgStairsUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$lg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lg);
}

function _extends$lh() { _extends$lh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lh.apply(this, arguments); }

var _ref$lh = /*#__PURE__*/createElement("path", {
  d: "M5 2L4 3v2L2 7v3l-2 2v3h11l1-1v-2H1l2-2h10l1-1V7H3l2-2h10l1-1V2z"
});

function SvgStairs(props) {
  return /*#__PURE__*/createElement("svg", _extends$lh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lh);
}

function _extends$li() { _extends$li = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$li.apply(this, arguments); }

var _ref$li = /*#__PURE__*/createElement("path", {
  d: "M16 5V2H5L4 3v2L2 7v3l-2 2v3h11l1-1v-2H1l.125-.125h11.089l.237-.25H1.374l.25-.25h11.064l.237-.25H1.874l.25-.25h11.038l.237-.25H2.373l.25-.25h11.013l.237-.25h-11L2.998 10h11V7h-11l.125-.125h11.024l.247-.25H3.374l.25-.25h11.017l.247-.25H3.874l.25-.25h11.01l.247-.25H4.374l.25-.25h11.003l.247-.25h-11L4.999 5z"
});

function SvgStairs2(props) {
  return /*#__PURE__*/createElement("svg", _extends$li({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$li);
}

function _extends$lj() { _extends$lj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lj.apply(this, arguments); }

var _ref$lj = /*#__PURE__*/createElement("path", {
  d: "M15.5 11h-5A1.5 1.5 0 019 9.5V5.829A3.001 3.001 0 008 0a3 3 0 00-1 5.829V9.5A1.5 1.5 0 015.5 11h-5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM1 14.5v1a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-1H1z"
});

function SvgStamp(props) {
  return /*#__PURE__*/createElement("svg", _extends$lj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lj);
}

function _extends$lk() { _extends$lk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lk.apply(this, arguments); }

var _ref$lk = /*#__PURE__*/createElement("path", {
  d: "M12.635 15.777a.5.5 0 01-.293-.095L8 12.541l-4.342 3.141a.501.501 0 01-.769-.56l1.657-5.079-4.34-3.139a.5.5 0 01.293-.905h5.367L7.524.919a.5.5 0 01.95 0l1.658 5.08h5.367a.5.5 0 01.293.905l-4.34 3.139 1.657 5.079a.5.5 0 01-.476.655zM2.044 6.998l3.384 2.448c.176.127.25.354.182.56L4.316 13.97l3.39-2.452a.498.498 0 01.586 0l3.39 2.452-1.294-3.964a.5.5 0 01.182-.56l3.384-2.448H9.769a.5.5 0 01-.475-.345L7.999 2.684 6.704 6.653a.5.5 0 01-.475.345H2.044z"
});

function SvgStarEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$lk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lk);
}

function _extends$ll() { _extends$ll = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ll.apply(this, arguments); }

var _ref$ll = /*#__PURE__*/createElement("path", {
  d: "M15.976 6.345a.5.5 0 00-.476-.346h-5.367L8.475.919a.5.5 0 00-.95 0l-1.658 5.08H.5a.5.5 0 00-.293.905l4.34 3.139-1.657 5.079a.5.5 0 00.769.56l4.342-3.141 4.342 3.141a.5.5 0 00.769-.56l-1.657-5.079 4.34-3.139a.5.5 0 00.183-.559zm-5.404 3.102a.499.499 0 00-.182.56l1.294 3.964-3.39-2.452a.5.5 0 00-.293-.095V2.685l1.295 3.969a.5.5 0 00.475.345h4.185l-3.384 2.448z"
});

function SvgStarEmpty2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ll({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ll);
}

function _extends$lm() { _extends$lm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lm.apply(this, arguments); }

var _ref$lm = /*#__PURE__*/createElement("path", {
  d: "M16 6.204l-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103l4-3.899zm-8 5.569l-3.492 1.836.667-3.888L2.35 6.968l3.904-.567L8 2.864l1.746 3.537 3.904.567-2.825 2.753.667 3.888L8 11.773z"
});

function SvgStarEmpty3(props) {
  return /*#__PURE__*/createElement("svg", _extends$lm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lm);
}

function _extends$ln() { _extends$ln = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ln.apply(this, arguments); }

var _ref$ln = /*#__PURE__*/createElement("path", {
  d: "M15.976 6.345a.5.5 0 00-.476-.346h-5.367L8.475.919a.5.5 0 00-.95 0l-1.658 5.08H.5a.5.5 0 00-.293.905l4.34 3.139-1.657 5.079a.5.5 0 00.769.56l4.342-3.141 4.342 3.141a.5.5 0 00.769-.56l-1.657-5.079 4.34-3.139a.5.5 0 00.183-.559z"
});

function SvgStarFull(props) {
  return /*#__PURE__*/createElement("svg", _extends$ln({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ln);
}

function _extends$lo() { _extends$lo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lo.apply(this, arguments); }

var _ref$lo = /*#__PURE__*/createElement("path", {
  d: "M16 6.204l-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103l4-3.899z"
});

function SvgStarFull2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lo);
}

function _extends$lp() { _extends$lp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lp.apply(this, arguments); }

var _ref$lp = /*#__PURE__*/createElement("path", {
  d: "M16 6.204l-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103l4-3.899zm-8 5.569l-.015.008L8 2.863 9.746 6.4l3.904.567-2.825 2.753.667 3.888L8 11.772z"
});

function SvgStarHalf(props) {
  return /*#__PURE__*/createElement("svg", _extends$lp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lp);
}

function _extends$lq() { _extends$lq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lq.apply(this, arguments); }

var _ref$lq = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3.233 12.975L8 10.775l-3.233 2.2L5.86 9.221 2.769 6.826l3.908-.121L8 3.025l1.322 3.68 3.908.121-3.091 2.395 1.093 3.754z"
});

function SvgStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$lq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lq);
}

function _extends$lr() { _extends$lr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lr.apply(this, arguments); }

var _ref$lr = /*#__PURE__*/createElement("path", {
  d: "M8 1.25L9.267 0l.819 1.581 1.591-.798.29 1.756 1.76-.267-.267 1.76 1.756.29-.797 1.591L16 6.732l-1.25 1.267L16 9.266l-1.581.819.797 1.591-1.756.29.267 1.76-1.76-.267-.29 1.756-1.591-.798-.819 1.581L8 14.748l-1.267 1.25-.819-1.581-1.591.798-.29-1.756-1.76.267.267-1.76-1.756-.29.797-1.591L0 9.266l1.25-1.267L0 6.732l1.581-.819-.797-1.591 1.756-.29-.267-1.76 1.76.267.29-1.756 1.591.798L6.733 0z"
});

function SvgStarburst(props) {
  return /*#__PURE__*/createElement("svg", _extends$lr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lr);
}

function _extends$ls() { _extends$ls = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ls.apply(this, arguments); }

var _ref$ls = /*#__PURE__*/createElement("path", {
  d: "M4.5 7.152l.926 2.851h2.997l-2.425 1.762.926 2.851-2.425-1.762-2.425 1.762L3 11.765.575 10.003h2.997zM8.5.152l.926 2.851h2.997L9.998 4.765l.926 2.851-2.425-1.762-2.425 1.762L7 4.765 4.575 3.003h2.997zM12.5 7.152l.926 2.851h2.997l-2.425 1.762.926 2.851-2.425-1.762-2.425 1.762.926-2.851-2.425-1.762h2.997z"
});

function SvgStars(props) {
  return /*#__PURE__*/createElement("svg", _extends$ls({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$ls);
}

function _extends$lt() { _extends$lt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lt.apply(this, arguments); }

var _ref$lt = /*#__PURE__*/createElement("path", {
  d: "M10 5a2 2 0 10-3.075 1.686L4.385 16h1.231l.273-1h4.224l.273 1h1.231l-2.54-9.314c.556-.355.925-.977.925-1.686zm-.706 7H6.707l.273-1h2.042l.273 1zm-2.042-2L8 7.257 8.748 10H7.252zm-1.091 4l.273-1h3.133l.273 1H6.162zM10.38.602a4.999 4.999 0 010 8.796C11.069 8.302 11.5 6.738 11.5 5s-.431-3.302-1.12-4.398zm3 0a4.999 4.999 0 010 8.796C14.069 8.302 14.5 6.738 14.5 5s-.431-3.302-1.12-4.398zM5.62 9.398a4.999 4.999 0 010-8.796C4.931 1.698 4.5 3.262 4.5 5s.431 3.302 1.12 4.398zM0 5C0 3.1 1.059 1.448 2.62.602 1.931 1.698 1.5 3.262 1.5 5s.431 3.302 1.12 4.398A4.999 4.999 0 010 5z"
});

function SvgStation(props) {
  return /*#__PURE__*/createElement("svg", _extends$lt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lt);
}

function _extends$lu() { _extends$lu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lu.apply(this, arguments); }

var _ref$lu = /*#__PURE__*/createElement("path", {
  d: "M3.128 11.347l.643-1.415A6.488 6.488 0 012.928.94L1.754 0A7.94 7.94 0 000 5c0 2.137.832 4.146 2.343 5.657.249.249.511.478.785.69zM12.229 9.932l.643 1.415c.274-.211.536-.441.785-.69A7.948 7.948 0 0016 5c0-1.84-.618-3.585-1.754-5l-1.174.94a6.488 6.488 0 01-.843 8.992z"
});

var _ref2$4x = /*#__PURE__*/createElement("path", {
  d: "M11.006 7.242l.68 1.496.026-.025a5.257 5.257 0 00.386-6.993l-1.171.937a3.758 3.758 0 01.079 4.585zM4.288 8.712l.026.025.68-1.496a3.757 3.757 0 01.079-4.585l-1.171-.937a5.257 5.257 0 00.386 6.993z"
});

var _ref3$t = /*#__PURE__*/createElement("path", {
  d: "M10 5a2 2 0 10-3.352 1.473L2.318 16h1.648l.909-2h6.252l.909 2h1.648l-4.33-9.527c.398-.366.648-.89.648-1.473zM8 7.123L9.308 10H6.692L8 7.123zM10.671 13H5.328l.909-2h3.525l.909 2z"
});

function SvgStation2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lu, _ref2$4x, _ref3$t);
}

function _extends$lv() { _extends$lv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lv.apply(this, arguments); }

var _ref$lv = /*#__PURE__*/createElement("path", {
  d: "M15.25 3c.412 0 .75-.337.75-.75V.75a.753.753 0 00-.75-.75h-1.5a.753.753 0 00-.75.75V1H3V.75A.752.752 0 002.25 0H.75A.753.753 0 000 .75v1.5c0 .413.338.75.75.75H1v10H.75a.753.753 0 00-.75.75v1.5c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75V15h10v.25c0 .412.338.75.75.75h1.5c.412 0 .75-.338.75-.75v-1.5a.753.753 0 00-.75-.75H15V3h.25zM14 1h1v1h-1V1zM1 1h1v1H1V1zm1 14H1v-1h1v1zm13 0h-1v-1h1v1zm-1-2h-.25a.753.753 0 00-.75.75V14H3v-.25a.752.752 0 00-.75-.75H2V3h.25c.413 0 .75-.337.75-.75V2h10v.25c0 .413.338.75.75.75H14v10zM4 4h2v8H4zm3 4h2v4H7zm3-2h2v6h-2z"
});

function SvgStatsBars(props) {
  return /*#__PURE__*/createElement("svg", _extends$lv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lv);
}

function _extends$lw() { _extends$lw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lw.apply(this, arguments); }

var _ref$lw = /*#__PURE__*/createElement("path", {
  d: "M0 13h16v2H0zm2-4h2v3H2zm3-4h2v7H5zm3 3h2v4H8zm3-6h2v10h-2z"
});

function SvgStatsBars2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lw);
}

function _extends$lx() { _extends$lx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lx.apply(this, arguments); }

var _ref$lx = /*#__PURE__*/createElement("path", {
  d: "M10 4H6v12h4V4zM7 5.125V5h2v.125H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zm0 .5v-.25h2v.25H7zM7 15v-.125h2V15H7zM0 9h4v7H0zm12-9h4v16h-4z"
});

function SvgStatsBars3(props) {
  return /*#__PURE__*/createElement("svg", _extends$lx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lx);
}

function _extends$ly() { _extends$ly = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ly.apply(this, arguments); }

var _ref$ly = /*#__PURE__*/createElement("path", {
  d: "M4.5 6h-3c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm0 9h-3v-4h3v4zm5-11h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zm0 11h-3v-5h3v5zm5-13h-3c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5zm0 13h-3V9h3v6z"
});

function SvgStatsBars4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ly({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ly);
}

function _extends$lz() { _extends$lz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lz.apply(this, arguments); }

var _ref$lz = /*#__PURE__*/createElement("path", {
  d: "M9.5 4h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zm0 11h-3V9.875h3V15zm0-5.375h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3V5h3v.125zM4.5 6h-3c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm0 9h-3v-4.125h3V15zm0-4.375h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3V7h3v.125zM14.5 2h-3c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5zm0 13h-3V8.875h3V15zm0-6.375h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3v-.25h3v.25zm0-.5h-3V3h3v.125z"
});

function SvgStatsBars5(props) {
  return /*#__PURE__*/createElement("svg", _extends$lz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lz);
}

function _extends$lA() { _extends$lA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lA.apply(this, arguments); }

var _ref$lA = /*#__PURE__*/createElement("path", {
  d: "M4.5 6h-3c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm0 5v.125h-3V11h3zm-3 3.125v-.25h3v.25h-3zm3 .25v.25h-3v-.25h3zm-3-.75v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zM1.5 15v-.125h3V15h-3zm8-11h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zm0 6v.125h-3V10h3zm-3 4.125v-.25h3v.25h-3zm3 .25v.25h-3v-.25h3zm-3-.75v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zM6.5 15v-.125h3V15h-3zm8-13h-3c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5zm0 7v.125h-3V9h3zm-3 5.125v-.25h3v.25h-3zm3 .25v.25h-3v-.25h3zm-3-.75v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0 5.375v-.125h3V15h-3z"
});

function SvgStatsBars6(props) {
  return /*#__PURE__*/createElement("svg", _extends$lA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lA);
}

function _extends$lB() { _extends$lB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lB.apply(this, arguments); }

var _ref$lB = /*#__PURE__*/createElement("path", {
  d: "M3 6.561V16H1V4.561l2 2zM6 9.561V16H4V7.561l2 2zM9 16H7v-5.439l2-2V16z"
});

var _ref2$4y = /*#__PURE__*/createElement("path", {
  d: "M14.28 7.22L10 2.94l-3 3-4.22-4.22-1.061 1.061 5.28 5.28 3-3 3.22 3.22-1.72 1.72h4.5v-4.5zM13 11h2v5h-2v-5zM10 11h2v5h-2v-5z"
});

function SvgStatsDecline(props) {
  return /*#__PURE__*/createElement("svg", _extends$lB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lB, _ref2$4y);
}

function _extends$lC() { _extends$lC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lC.apply(this, arguments); }

var _ref$lC = /*#__PURE__*/createElement("path", {
  d: "M11.5 12l1.75-1.75L9.5 6.5l-3 3L0 3l1-1 5.5 5.5 3-3 4.75 4.75L16 7.5V12z"
});

function SvgStatsDecline2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lC);
}

function _extends$lD() { _extends$lD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lD.apply(this, arguments); }

var _ref$lD = /*#__PURE__*/createElement("path", {
  d: "M2 14h14v2H0V0h2zm2.5-1a1.5 1.5 0 11.131-2.994l1.612-2.687a1.5 1.5 0 112.514 0l1.612 2.687a1.42 1.42 0 01.23-.002l2.662-4.658a1.5 1.5 0 111.14.651l-2.662 4.658a1.5 1.5 0 11-2.496.026L7.631 7.994a1.42 1.42 0 01-.262 0l-1.612 2.687A1.5 1.5 0 014.5 13z"
});

function SvgStatsDots(props) {
  return /*#__PURE__*/createElement("svg", _extends$lD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lD);
}

function _extends$lE() { _extends$lE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lE.apply(this, arguments); }

var _ref$lE = /*#__PURE__*/createElement("path", {
  d: "M11.5 0l1.72 1.72L9 5.94l-3-3-5.5 5.5 1.061 1.061L6 5.062l3 3 5.28-5.28L16 4.502v-4.5z"
});

var _ref2$4z = /*#__PURE__*/createElement("path", {
  d: "M13 6.561V16h2V4.561zM10 9.561V16h2V7.561zM7 16h2v-5.439l-2-2zM4 16h2V7.561l-2 2zM1 12.561V16h2v-5.439z"
});

function SvgStatsGrowth(props) {
  return /*#__PURE__*/createElement("svg", _extends$lE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lE, _ref2$4z);
}

function _extends$lF() { _extends$lF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lF.apply(this, arguments); }

var _ref$lF = /*#__PURE__*/createElement("path", {
  d: "M11.5 4l1.75 1.75L9.5 9.5l-3-3L0 13l1 1 5.5-5.5 3 3 4.75-4.75L16 8.5V4z"
});

function SvgStatsGrowth2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lF);
}

function _extends$lG() { _extends$lG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lG.apply(this, arguments); }

var _ref$lG = /*#__PURE__*/createElement("path", {
  d: "M16 7c0-2.757-2.243-5-5-5-.957 0-1.896.263-2.715.76a4.832 4.832 0 00-1.863 2.023C6.066 5.522 5.115 6 4 6H3C1.346 6 0 7.346 0 9v1c0 1.491.869 2.812 2.448 3.719C3.886 14.545 5.858 15 8 15c2.175 0 4.171-.662 5.622-1.865a6.49 6.49 0 001.74-2.217 6.735 6.735 0 00.617-3.368c.013-.181.021-.364.021-.55zm-3.016 4.365C11.712 12.419 9.942 13 8 13c-1.971 0-3.766-.408-5.054-1.148C2.058 11.342 1 10.433 1 9c0-1.103.897-2 2-2h1a4.38 4.38 0 001.922-.426c.64-.314 1.125-.783 1.401-1.357C7.962 3.891 9.44 3 11 3c2.206 0 4 1.794 4 4 0 1.763-.697 3.272-2.016 4.365z"
});

var _ref2$4A = /*#__PURE__*/createElement("path", {
  d: "M11 4.125c-1.12 0-2.215.65-2.664 1.581-.387.802-1.05 1.452-1.919 1.878a5.511 5.511 0 01-2.418.541h-1A.877.877 0 002.124 9c0 .719.465 1.35 1.381 1.877 1.121.644 2.716.998 4.494.998 1.681 0 3.196-.489 4.266-1.376 1.067-.885 1.609-2.062 1.609-3.499a2.879 2.879 0 00-2.875-2.875zM11 8a1 1 0 110-2 1 1 0 010 2z"
});

function SvgSteak(props) {
  return /*#__PURE__*/createElement("svg", _extends$lG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lG, _ref2$4A);
}

function _extends$lH() { _extends$lH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lH.apply(this, arguments); }

var _ref$lH = /*#__PURE__*/createElement("path", {
  d: "M11 4.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0111 4.5zm3.975-2.475A3.5 3.5 0 009.036 4L5.838 8.847c-.43.022-.856.132-1.249.328L2.122 7.247A1.313 1.313 0 00.506 9.315l2.436 1.905a3.157 3.157 0 106.168.228l3.891-3.484a3.5 3.5 0 001.975-5.939zM6 14.105A2.105 2.105 0 013.895 12l.001-.033 1.046.817a1.31 1.31 0 101.616-2.068l-.992-.776A2.105 2.105 0 116 14.105zM12.5 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgSteam(props) {
  return /*#__PURE__*/createElement("svg", _extends$lH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lH);
}

function _extends$lI() { _extends$lI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lI.apply(this, arguments); }

var _ref$lI = /*#__PURE__*/createElement("path", {
  d: "M4.749 13.063a1.313 1.313 0 00.729-2.405L4.446 9.97a2.105 2.105 0 11-1.548 2.124l1.124.749c.224.149.477.221.727.221zM13.333 0C14.8 0 16 1.2 16 2.667v10.666C16 14.801 14.8 16 13.333 16H2.667A2.674 2.674 0 010 13.333v-3.172l1.896 1.264a3.157 3.157 0 106.213.024l3.892-3.484a3.5 3.5 0 10-3.964-3.964L4.839 8.848a3.14 3.14 0 00-1.433.428L.002 7.007V2.668c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm-4 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 4.5z"
});

function SvgSteam2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lI);
}

function _extends$lJ() { _extends$lJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lJ.apply(this, arguments); }

var _ref$lJ = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 2a6.002 6.002 0 015.917 5h-3.088a3 3 0 00-5.656 0H2.085a6.001 6.001 0 015.917-5zM7 13.917A6.006 6.006 0 012.083 9H5a2 2 0 012 2v2.917zM8 9a1 1 0 110-2 1 1 0 010 2zm1 4.917V11a2 2 0 012-2h2.917A6.006 6.006 0 019 13.917z"
});

function SvgSteeringWheel(props) {
  return /*#__PURE__*/createElement("svg", _extends$lJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lJ);
}

function _extends$lK() { _extends$lK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lK.apply(this, arguments); }

var _ref$lK = /*#__PURE__*/createElement("path", {
  d: "M14 6a2 2 0 00-1 3.732V13.5c0 .827-.673 1.5-1.5 1.5h-4c-.827 0-1.5-.673-1.5-1.5V12h.5a.5.5 0 00.5-.5v-.781c1.066-.418 1.999-1.296 2.746-2.599C10.569 6.684 11 4.96 11 4V2.5c0-.827-.673-1.5-1.5-1.5H8a1 1 0 101 1h.5a.5.5 0 01.5.5V4c0 1.082-.578 2.674-1.121 3.623C7.753 9.588 6.42 10 5.5 10s-2.253-.412-3.379-2.377C1.393 6.352 1 4.808 1 4V2.5a.5.5 0 01.5-.5H2a1 1 0 101-1H1.5C.673 1 0 1.673 0 2.5V4c0 .96.431 2.684 1.254 4.12.747 1.303 1.68 2.181 2.746 2.599v.781a.5.5 0 00.5.5H5v1.5C5 14.879 6.122 16 7.5 16h4c1.379 0 2.5-1.121 2.5-2.5V10a2 2 0 100-4zm0 3c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1c0 .551-.449 1-1 1z"
});

function SvgStethoscope(props) {
  return /*#__PURE__*/createElement("svg", _extends$lK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lK);
}

function _extends$lL() { _extends$lL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lL.apply(this, arguments); }

var _ref$lL = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zM5 5h6v6H5z"
});

function SvgStop(props) {
  return /*#__PURE__*/createElement("svg", _extends$lL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lL);
}

function _extends$lM() { _extends$lM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lM.apply(this, arguments); }

var _ref$lM = /*#__PURE__*/createElement("path", {
  d: "M2 2h12v12H2z"
});

function SvgStop2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lM);
}

function _extends$lN() { _extends$lN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lN.apply(this, arguments); }

var _ref$lN = /*#__PURE__*/createElement("path", {
  d: "M8 3.019V2h2V1a1 1 0 00-1-1H6a1 1 0 00-1 1v1h2v1.019a6.5 6.5 0 101 0zm3.036 10.017c-.944.944-2.2 1.464-3.536 1.464s-2.591-.52-3.536-1.464C3.02 12.092 2.5 10.836 2.5 9.5s.52-2.591 1.464-3.536a4.967 4.967 0 013.377-1.462l-.339 4.907c-.029.411.195.591.497.591s.527-.18.497-.591l-.339-4.907c1.276.04 2.47.555 3.377 1.462.944.944 1.464 2.2 1.464 3.536s-.52 2.591-1.464 3.536z"
});

function SvgStopwatchEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$lN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lN);
}

function _extends$lO() { _extends$lO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lO.apply(this, arguments); }

var _ref$lO = /*#__PURE__*/createElement("path", {
  d: "M8 3.019V2h2V1a1 1 0 00-1-1H6a1 1 0 00-1 1v1h2v1.019a6.5 6.5 0 101 0zm3.036 10.017c-.944.944-2.2 1.464-3.536 1.464s-2.591-.52-3.536-1.464C3.02 12.092 2.5 10.836 2.5 9.5s.52-2.591 1.464-3.536a4.967 4.967 0 013.377-1.462l-.339 4.907c-.029.411.195.591.497.591s.527-.18.497-.591l-.339-4.907c1.276.04 2.47.555 3.377 1.462.944.944 1.464 2.2 1.464 3.536s-.52 2.591-1.464 3.536z"
});

function SvgStopwatch(props) {
  return /*#__PURE__*/createElement("svg", _extends$lO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lO);
}

function _extends$lP() { _extends$lP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lP.apply(this, arguments); }

var _ref$lP = /*#__PURE__*/createElement("path", {
  d: "M14 15V9H2v6H1v1h14v-1h-1zm-6-1H4v-3h4v3zM14 1H2L0 5v3h3V6h1v2h2V6h1v2h2V6h1v2h2V6h1v2h3V5z"
});

function SvgStore(props) {
  return /*#__PURE__*/createElement("svg", _extends$lP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lP);
}

function _extends$lQ() { _extends$lQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lQ.apply(this, arguments); }

var _ref$lQ = /*#__PURE__*/createElement("path", {
  d: "M6.5 9h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM6 12H4v-2h2v2z"
});

var _ref2$4B = /*#__PURE__*/createElement("path", {
  d: "M16 6V1.5a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5V6a2 2 0 001 1.731V15H.5a.5.5 0 000 1h15a.5.5 0 000-1H15V7.731A2 2 0 0016 6zm-6-4h2v4c0 .551-.449 1-1 1s-1-.449-1-1V2zM4 2h2v4c0 .551-.449 1-1 1s-1-.449-1-1V2zm8 13h-2v-4h2v4zm2 0h-1v-4.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V15H2V8c.597 0 1.133-.263 1.5-.679a1.996 1.996 0 003 0 1.996 1.996 0 003 0 1.996 1.996 0 003 0c.367.416.903.679 1.5.679v7z"
});

function SvgStore2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lQ, _ref2$4B);
}

function _extends$lR() { _extends$lR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lR.apply(this, arguments); }

var _ref$lR = /*#__PURE__*/createElement("path", {
  d: "M3.5 7C5.43 7 7 5.43 7 3.5S5.43 0 3.5 0 0 1.57 0 3.5 1.57 7 3.5 7zm0-6C4.878 1 6 2.122 6 3.5S4.878 6 3.5 6 1 4.878 1 3.5 2.122 1 3.5 1z"
});

var _ref2$4C = /*#__PURE__*/createElement("path", {
  d: "M12.078 3H14.5l-3-3-3 3h2.422c0 .891-.25 1.842-.724 2.748-.485.929-1.207 1.814-2.087 2.562-1.984 1.685-4.654 2.613-7.516 2.613a.578.578 0 000 1.156c3.136 0 6.072-1.025 8.265-2.887.993-.843 1.81-1.848 2.364-2.907.56-1.071.856-2.206.856-3.284zM13.707 13l2.146-2.146a.5.5 0 00-.707-.707L13 12.293l-2.146-2.146a.5.5 0 00-.707.707L12.293 13l-2.146 2.146a.5.5 0 00.708.707l2.146-2.146 2.146 2.146a.498.498 0 00.708 0 .5.5 0 000-.707L13.709 13z"
});

function SvgStrategy(props) {
  return /*#__PURE__*/createElement("svg", _extends$lR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lR, _ref2$4C);
}

function _extends$lS() { _extends$lS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lS.apply(this, arguments); }

var _ref$lS = /*#__PURE__*/createElement("path", {
  d: "M15 8v1h-2.842c.532.715.842 1.575.842 2.5 0 2.485-2.239 4.5-5 4.5-2.574 0-4.693-1.75-4.969-4h2.031c.109.442.363.855.741 1.195.577.519 1.357.805 2.198.805s1.621-.286 2.198-.805c.517-.466.802-1.068.802-1.695s-.285-1.23-.802-1.695C9.623 9.286 8.842 9 8.001 9h-7V8h14zM8 7H3.842A4.168 4.168 0 013 4.5C3 2.015 5.239 0 8 0c2.574 0 4.693 1.75 4.969 4h-2.031a2.392 2.392 0 00-.741-1.195C9.621 2.286 8.84 2 7.999 2s-1.621.286-2.198.805c-.517.466-.802 1.068-.802 1.695s.285 1.23.802 1.695C6.378 6.714 7.158 7 7.999 7z"
});

function SvgStrikethrough(props) {
  return /*#__PURE__*/createElement("svg", _extends$lS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lS);
}

function _extends$lT() { _extends$lT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lT.apply(this, arguments); }

var _ref$lT = /*#__PURE__*/createElement("path", {
  d: "M1 0v5l2-3h4v5h2V2h4l2 3V0zm8 15v-5H7v5H5l-1 1h8l-1-1zM0 8h16v1H0z"
});

function SvgStrikethrough2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lT);
}

function _extends$lU() { _extends$lU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lU.apply(this, arguments); }

var _ref$lU = /*#__PURE__*/createElement("path", {
  d: "M16 8v1h-3.664c.43.602.664 1.292.664 2 0 1.107-.573 2.172-1.572 2.921C10.501 14.617 9.283 15 8 15s-2.501-.383-3.428-1.079C3.573 13.172 3 12.107 3 11h2c0 1.084 1.374 2 3 2s3-.916 3-2-1.374-2-3-2H0V8h4.68a3.003 3.003 0 01-.108-.079C3.573 7.172 3 6.107 3 5s.573-2.172 1.572-2.921C5.499 1.383 6.717 1 8 1s2.501.383 3.428 1.079C12.427 2.828 13 3.893 13 5h-2c0-1.084-1.374-2-3-2s-3 .916-3 2 1.374 2 3 2c1.234 0 2.407.354 3.32 1H16z"
});

function SvgStrikethrough3(props) {
  return /*#__PURE__*/createElement("svg", _extends$lU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lU);
}

function _extends$lV() { _extends$lV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lV.apply(this, arguments); }

var _ref$lV = /*#__PURE__*/createElement("path", {
  d: "M8 5c-.55 0-1 .45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3V8h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-1.653 1.347-3 3-3s3 1.347 3 2.781v.969l-1.281.375L9 6.75v-.969C9 5.45 8.55 5 8 5z"
});

var _ref2$4D = /*#__PURE__*/createElement("path", {
  d: "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219V7.843l.719.375L11 7.843v1.938c0 .769.45 1.219 1 1.219s1-.45 1-1V8h2v2z"
});

function SvgStumbleupon(props) {
  return /*#__PURE__*/createElement("svg", _extends$lV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lV, _ref2$4D);
}

function _extends$lW() { _extends$lW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lW.apply(this, arguments); }

var _ref$lW = /*#__PURE__*/createElement("path", {
  d: "M13.313 0H2.688A2.696 2.696 0 000 2.688v10.625a2.696 2.696 0 002.688 2.688h10.625a2.696 2.696 0 002.688-2.688V2.688A2.696 2.696 0 0013.313 0zM8 5c-.551 0-1 .449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3V8h2v2c0 .551.449 1 1 1s1-.449 1-1V6c0-1.654 1.346-3 3-3s3 1.346 3 2.781v.969l-1.281.375L9 6.75v-.969C9 5.448 8.551 5 8 5zm7 5c0 1.654-1.346 3-3 3s-3-1.346-3-3.219V7.843l.719.375L11 7.843v1.938c0 .77.449 1.219 1 1.219s1-.449 1-1V8h2v2z"
});

function SvgStumbleupon2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lW);
}

function _extends$lX() { _extends$lX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lX.apply(this, arguments); }

var _ref$lX = /*#__PURE__*/createElement("path", {
  d: "M12 14.219V15h2v1h-3v-2.281l2-.938V12h-2v-1h3v2.281zM10.563 4H8.438L5.5 6.938 2.562 4H.437l4 4-4 4h2.125L5.5 9.062 8.438 12h2.125l-4-4z"
});

function SvgSubscript(props) {
  return /*#__PURE__*/createElement("svg", _extends$lX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lX);
}

function _extends$lY() { _extends$lY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lY.apply(this, arguments); }

var _ref$lY = /*#__PURE__*/createElement("path", {
  d: "M3.032 13l.9-3h4.137l.9 3h1.775l-3-10H4.256l-3 10h1.776zm2.4-8h1.137l.9 3H4.532l.9-3zM16 3l-2.5 4L11 3h5zM13.5 13h-1a.5.5 0 010-1h2a.5.5 0 000-1h-2a1.502 1.502 0 00-1.117 2.5c.275.307.674.5 1.117.5h1a.5.5 0 010 1h-2a.5.5 0 000 1h2a1.502 1.502 0 001.117-2.5A1.496 1.496 0 0013.5 13z"
});

function SvgSubscript2(props) {
  return /*#__PURE__*/createElement("svg", _extends$lY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lY);
}

function _extends$lZ() { _extends$lZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$lZ.apply(this, arguments); }

var _ref$lZ = /*#__PURE__*/createElement("path", {
  d: "M11 5V0H0v11h5v5h11V5h-5zM9 4H4v.125H2v-.25h7V4zM2 9v-.125h2V9H2zm0-.375v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm0-.5v-.25h2v.25H2zm7-1H2v-.25h7v.25zm0-.5H2v-.25h7v.25zm0-.5H2v-.25h7v.25zm0-.5H2V2h7v.125zM15 15H6V6h9v9z"
});

function SvgSubtract(props) {
  return /*#__PURE__*/createElement("svg", _extends$lZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$lZ);
}

function _extends$l_() { _extends$l_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l_.apply(this, arguments); }

var _ref$l_ = /*#__PURE__*/createElement("path", {
  d: "M8 4a4 4 0 100 8 4 4 0 000-8zm0 9a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zM8 3a1 1 0 01-1-1V1a1 1 0 012 0v1a1 1 0 01-1 1zm7 4a1 1 0 010 2h-1a1 1 0 010-2h1zM3 8a1 1 0 01-1 1H1a1 1 0 010-2h1a1 1 0 011 1zm9.95 3.536l.707.707a1 1 0 01-1.414 1.414l-.707-.707a1 1 0 011.414-1.414zm-9.9-7.072l-.707-.707a.999.999 0 111.414-1.414l.707.707A.999.999 0 113.05 4.464zm9.9 0a.999.999 0 11-1.414-1.414l.707-.707a.999.999 0 111.414 1.414l-.707.707zm-9.9 7.072a1 1 0 011.414 1.414l-.707.707a1 1 0 01-1.414-1.414l.707-.707z"
});

function SvgSun(props) {
  return /*#__PURE__*/createElement("svg", _extends$l_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l_);
}

function _extends$l$() { _extends$l$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l$.apply(this, arguments); }

var _ref$l$ = /*#__PURE__*/createElement("path", {
  d: "M8 13a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zM8 3a1 1 0 01-1-1V1a1 1 0 012 0v1a1 1 0 01-1 1zm7 4a1 1 0 010 2h-1a1 1 0 010-2h1zM3 8a1 1 0 01-1 1H1a1 1 0 010-2h1a1 1 0 011 1zm9.95 3.536l.707.707a1 1 0 01-1.414 1.414l-.707-.707a1 1 0 011.414-1.414zm-9.9-7.072l-.707-.707a.999.999 0 111.414-1.414l.707.707A.999.999 0 113.05 4.464zm9.9 0a.999.999 0 11-1.414-1.414l.707-.707a.999.999 0 111.414 1.414l-.707.707zm-9.9 7.072a1 1 0 011.414 1.414l-.707.707a1 1 0 01-1.414-1.414l.707-.707zM8 4a4 4 0 100 8 4 4 0 000-8zm0 6.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgSun2(props) {
  return /*#__PURE__*/createElement("svg", _extends$l$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$l$);
}

function _extends$m0() { _extends$m0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m0.apply(this, arguments); }

var _ref$m0 = /*#__PURE__*/createElement("path", {
  d: "M14.374 8l1.425-1.78-2.056-.986.512-2.222-2.28.004-.503-2.224-2.053.993L8.001-.001 6.583 1.785 4.53.792l-.503 2.224-2.28-.004.512 2.222-2.056.986L1.628 8 .203 9.78l2.056.986-.512 2.222 2.28-.004.503 2.224 2.053-.993 1.418 1.786 1.418-1.786 2.053.993.503-2.224 2.28.004-.512-2.222 2.056-.986L14.374 8zM8 13.141c-2.743 0-4.966-2.302-4.966-5.141S5.257 2.859 8 2.859c2.743 0 4.966 2.302 4.966 5.141S10.743 13.141 8 13.141zM4 8a4 4 0 118 0 4 4 0 01-8 0z"
});

function SvgSun3(props) {
  return /*#__PURE__*/createElement("svg", _extends$m0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m0);
}

function _extends$m1() { _extends$m1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m1.apply(this, arguments); }

var _ref$m1 = /*#__PURE__*/createElement("path", {
  d: "M12 3.219V4h2v1h-3V2.719l2-.938V1h-2V0h3v2.281zM10.563 4H8.438L5.5 6.938 2.562 4H.437l4 4-4 4h2.125L5.5 9.062 8.438 12h2.125l-4-4z"
});

function SvgSuperscript(props) {
  return /*#__PURE__*/createElement("svg", _extends$m1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m1);
}

function _extends$m2() { _extends$m2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m2.apply(this, arguments); }

var _ref$m2 = /*#__PURE__*/createElement("path", {
  d: "M3.032 13l.9-3h4.137l.9 3h1.775l-3-10H4.256l-3 10h1.776zm2.4-8h1.137l.9 3H4.532l.9-3zM11 13l2.5-4 2.5 4h-5zM13.5 2h-1a.5.5 0 010-1h2a.5.5 0 000-1h-2a1.502 1.502 0 00-1.117 2.5c.275.307.674.5 1.117.5h1a.5.5 0 010 1h-2a.5.5 0 000 1h2a1.502 1.502 0 001.117-2.5A1.496 1.496 0 0013.5 2z"
});

function SvgSuperscript2(props) {
  return /*#__PURE__*/createElement("svg", _extends$m2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m2);
}

function _extends$m3() { _extends$m3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m3.apply(this, arguments); }

var _ref$m3 = /*#__PURE__*/createElement("path", {
  d: "M14.5 6.5c-.444 0-.843.193-1.118.5h-2.968l2.099-2.099a1.5 1.5 0 10-1.414-1.414L9 5.586V2.618a1.5 1.5 0 10-2 0v2.968L4.901 3.487a1.5 1.5 0 10-1.414 1.414L5.586 7H2.618a1.5 1.5 0 100 2h2.968l-2.099 2.099a1.5 1.5 0 101.414 1.414L7 10.414v2.968a1.5 1.5 0 102 0v-2.968l2.099 2.099a1.5 1.5 0 101.414-1.414L10.414 9h2.968A1.5 1.5 0 1014.5 6.5z"
});

function SvgSvg(props) {
  return /*#__PURE__*/createElement("svg", _extends$m3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m3);
}

function _extends$m4() { _extends$m4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m4.apply(this, arguments); }

var _ref$m4 = /*#__PURE__*/createElement("path", {
  d: "M10 2.29v2.124c.566.247 1.086.6 1.536 1.05C12.48 6.408 13 7.664 13 9s-.52 2.591-1.464 3.536C10.592 13.48 9.336 14 8 14s-2.591-.52-3.536-1.464C3.52 11.592 3 10.336 3 9s.52-2.591 1.464-3.536c.45-.45.97-.803 1.536-1.05V2.29a7 7 0 104 0zM7 0h2v8H7z"
});

function SvgSwitch(props) {
  return /*#__PURE__*/createElement("svg", _extends$m4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m4);
}

function _extends$m5() { _extends$m5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m5.apply(this, arguments); }

var _ref$m5 = /*#__PURE__*/createElement("path", {
  d: "M10 7.5c0 .275-.225.5-.5.5h-3a.501.501 0 01-.5-.5v-3c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5v3z"
});

var _ref2$4E = /*#__PURE__*/createElement("path", {
  d: "M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM2 15a1 1 0 110-2 1 1 0 010 2zM2 3a1 1 0 110-2 1 1 0 010 2zm9 9.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v9zm3 2.5a1 1 0 110-2 1 1 0 010 2zm0-12a1 1 0 110-2 1 1 0 010 2z"
});

function SvgSwitch2(props) {
  return /*#__PURE__*/createElement("svg", _extends$m5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m5, _ref2$4E);
}

function _extends$m6() { _extends$m6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m6.apply(this, arguments); }

var _ref$m6 = /*#__PURE__*/createElement("path", {
  d: "M15.707 14.293l-3.146-3.146 2.293-2.293a.5.5 0 000-.707l-1-1a.5.5 0 00-.707 0l-1.646 1.646L2.855.147a.5.5 0 00-.354-.146h-2a.5.5 0 00-.5.5v2c0 .133.053.26.146.354l8.646 8.646-1.646 1.646a.5.5 0 000 .707l1 1a.498.498 0 00.708 0l2.293-2.293 3.146 3.146a.999.999 0 101.414-1.414zM9.5 11L.75 2.25l.5-.5L10 10.5l-.5.5z"
});

function SvgSword(props) {
  return /*#__PURE__*/createElement("svg", _extends$m6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m6);
}

function _extends$m7() { _extends$m7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m7.apply(this, arguments); }

var _ref$m7 = /*#__PURE__*/createElement("path", {
  d: "M15.5 6l.5-2-4-4-2 .5.985.985-1.631 1.631L7.119.881 5.882 2.118l1.506 1.506a.915.915 0 00-.094.083L1.708 9.293a1.003 1.003 0 000 1.414l.293.293v1l.646.646-2.646 2.646.707.707 2.646-2.646.646.646h1l.293.293a.999.999 0 001.414 0l5.586-5.586c.03-.03.057-.062.083-.094l1.506 1.506 1.237-1.237-2.235-2.235 1.631-1.631L15.5 6zM3.854 8.383l.029-.029 3.984 3.541-.471.471-3.541-3.984zm3.513 4.013l-.471.471-3.541-3.984.029-.029 3.984 3.541zM4.354 7.883l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zm.5-.5l.029-.029 3.984 3.541-.471.471-3.541-3.984zM6 13.71a.122.122 0 01-.088-.035l-3.586-3.586c-.029-.029-.035-.064-.035-.088s.006-.059.035-.088l.057-.057 3.984 3.541-.279.279a.122.122 0 01-.088.035zm.396-.343L2.855 9.383l.029-.029 3.984 3.541-.471.471zm5.278-5.279l-.279.279-3.541-3.984.057-.057c.029-.029.064-.035.088-.035s.059.006.088.035l3.586 3.586a.129.129 0 010 .177zm.68-1.972l-2.47-2.47 1.631-1.631 2.47 2.47-1.631 1.631z"
});

function SvgSyringe(props) {
  return /*#__PURE__*/createElement("svg", _extends$m7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m7);
}

function _extends$m8() { _extends$m8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m8.apply(this, arguments); }

var _ref$m8 = /*#__PURE__*/createElement("path", {
  d: "M15.5 6l.5-2-4-4-2 .5.985.985-1.631 1.631L7.119.881 5.882 2.118l1.506 1.506a.915.915 0 00-.094.083L1.708 9.293a1.003 1.003 0 000 1.414l.293.293v1l.646.646-2.646 2.646.707.707 2.646-2.646.646.646h1l.293.293a.999.999 0 001.414 0l5.586-5.586c.03-.03.057-.062.083-.094l1.506 1.506 1.237-1.237-2.235-2.235 1.631-1.631L15.5 6zm-3.826 2.088l-5.586 5.586c-.029.029-.064.035-.088.035s-.059-.006-.088-.035l-3.586-3.586c-.029-.029-.035-.064-.035-.088s.006-.059.035-.088l5.586-5.586c.029-.029.064-.035.088-.035s.059.006.088.035l3.586 3.586a.129.129 0 010 .177zm.68-1.972l-2.47-2.47 1.631-1.631 2.47 2.47-1.631 1.631zm-6.119 5.649l-2-2 .53-.53 2 2zm3-3l-2-2 .53-.53 2 2zm-1.5 1.5l-2-2 .53-.53 2 2z"
});

function SvgSyringe2(props) {
  return /*#__PURE__*/createElement("svg", _extends$m8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m8);
}

function _extends$m9() { _extends$m9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m9.apply(this, arguments); }

var _ref$m9 = /*#__PURE__*/createElement("path", {
  d: "M15 0h1v8h-1V0zM0 8h1v8H0V8zM5 11h11v2H5v2.5L1.5 12 5 8.5V11zM11 5H0V3h11V.5L14.5 4 11 7.5z"
});

function SvgTab(props) {
  return /*#__PURE__*/createElement("svg", _extends$m9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m9);
}

function _extends$ma() { _extends$ma = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ma.apply(this, arguments); }

var _ref$ma = /*#__PURE__*/createElement("path", {
  d: "M0 3v11h16V3H0zm6 7V8h4v2H6zm4 1v2H6v-2h4zm0-6v2H6V5h4zM5 5v2H1V5h4zM1 8h4v2H1V8zm10 0h4v2h-4V8zm0-1V5h4v2h-4zM1 11h4v2H1v-2zm10 2v-2h4v2h-4z"
});

function SvgTable(props) {
  return /*#__PURE__*/createElement("svg", _extends$ma({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ma);
}

function _extends$mb() { _extends$mb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mb.apply(this, arguments); }

var _ref$mb = /*#__PURE__*/createElement("path", {
  d: "M0 1v14h16V1H0zm6 9V7h4v3H6zm4 1v3H6v-3h4zm0-8v3H6V3h4zM5 3v3H1V3h4zM1 7h4v3H1V7zm10 0h4v3h-4V7zm0-1V3h4v3h-4zM1 11h4v3H1v-3zm10 3v-3h4v3h-4z"
});

function SvgTable2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mb);
}

function _extends$mc() { _extends$mc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mc.apply(this, arguments); }

var _ref$mc = /*#__PURE__*/createElement("path", {
  d: "M12.5 0h-10C1.675 0 1 .675 1 1.5v13c0 .825.675 1.5 1.5 1.5h10c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-5 15.5a.5.5 0 110-1 .5.5 0 010 1zM12 14H3V2h9v12z"
});

function SvgTablet(props) {
  return /*#__PURE__*/createElement("svg", _extends$mc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mc);
}

function _extends$md() { _extends$md = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$md.apply(this, arguments); }

var _ref$md = /*#__PURE__*/createElement("path", {
  d: "M12.5 5a3.5 3.5 0 00-3.163 5H6.663A3.5 3.5 0 103.5 12h9a3.5 3.5 0 100-7zM2 8.5a1.5 1.5 0 113.001.001A1.5 1.5 0 012 8.5zM12.5 10a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112.5 10z"
});

function SvgTape(props) {
  return /*#__PURE__*/createElement("svg", _extends$md({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$md);
}

function _extends$me() { _extends$me = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$me.apply(this, arguments); }

var _ref$me = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14.222c-3.431 0-6.222-2.791-6.222-6.222S4.569 1.778 8 1.778 14.222 4.569 14.222 8A6.229 6.229 0 018 14.222zM8 3.556C5.549 3.556 3.556 5.55 3.556 8S5.55 12.444 8 12.444 12.444 10.45 12.444 8A4.449 4.449 0 008 3.556zm0 7.111c-1.471 0-2.667-1.196-2.667-2.667S6.529 5.333 8 5.333c1.47 0 2.667 1.196 2.667 2.667S9.471 10.667 8 10.667zM7 8a1 1 0 112 0 1 1 0 01-2 0z"
});

function SvgTarget(props) {
  return /*#__PURE__*/createElement("svg", _extends$me({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$me);
}

function _extends$mf() { _extends$mf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mf.apply(this, arguments); }

var _ref$mf = /*#__PURE__*/createElement("path", {
  d: "M16 7h-1.577A6.516 6.516 0 009 1.577V0H7v1.577A6.516 6.516 0 001.577 7H0v2h1.577A6.516 6.516 0 007 14.423V16h2v-1.577A6.516 6.516 0 0014.423 9H16V7zm-3.612 0h-1.559A3.008 3.008 0 009 5.171V3.612A4.516 4.516 0 0112.388 7zM8 9a1 1 0 110-2 1 1 0 010 2zM7 3.612v1.559A3.008 3.008 0 005.171 7H3.612A4.516 4.516 0 017 3.612zM3.612 9h1.559A3.008 3.008 0 007 10.829v1.559A4.516 4.516 0 013.612 9zM9 12.388v-1.559A3.008 3.008 0 0010.829 9h1.559A4.516 4.516 0 019 12.388z"
});

function SvgTarget2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mf);
}

function _extends$mg() { _extends$mg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mg.apply(this, arguments); }

var _ref$mg = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm4.243 12.243A5.956 5.956 0 019 13.918v-2.917H7v2.917c-1.222-.204-2.349-.781-3.243-1.675S2.286 10.223 2.082 9h2.917V7H2.082c.204-1.222.781-2.349 1.675-3.243S5.777 2.286 7 2.082v2.917h2V2.082c1.222.204 2.349.781 3.243 1.675S13.714 5.777 13.918 7h-2.917v2h2.917a5.959 5.959 0 01-1.675 3.243z"
});

function SvgTarget3(props) {
  return /*#__PURE__*/createElement("svg", _extends$mg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mg);
}

function _extends$mh() { _extends$mh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mh.apply(this, arguments); }

var _ref$mh = /*#__PURE__*/createElement("path", {
  d: "M35.9 0v4.6C48 6.3 57.6 15.9 59.4 28H64v8h-4.6C57.6 48.1 48 57.7 35.9 59.4V64H28v-4.6C15.9 57.6 6.4 48.1 4.6 36H0v-8h4.6C6.4 16 15.9 6.4 28 4.6V0h7.9zm0 12.7V20H28v-7.3c-7.7 1.6-13.7 7.6-15.3 15.3H20v8h-7.3c1.6 7.7 7.7 13.7 15.3 15.3V44h8v7.3c7.7-1.6 13.7-7.6 15.3-15.3H44v-8h7.2c-1.5-7.7-7.6-13.7-15.3-15.3zM32 28c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z"
});

function SvgTarget4(props) {
  return /*#__PURE__*/createElement("svg", _extends$mh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref$mh);
}

function _extends$mi() { _extends$mi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mi.apply(this, arguments); }

var _ref$mi = /*#__PURE__*/createElement("path", {
  d: "M16.25 6a2.74 2.74 0 00-1.953.817A5.983 5.983 0 0010 5a6.003 6.003 0 00-4.06 1.585A6.046 6.046 0 004.296 9.09a3.218 3.218 0 00-.081-.087C3.569 8.337 2.656 7.999 1.5 7.999h-1a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5c.735 0 1.298.283 1.773.892.453.58.756 1.358 1.05 2.11.236.604.458 1.175.751 1.619.385.584.865.88 1.426.88h9c.133 0 .26-.053.354-.146.555-.555.841-1.255.989-1.936.628-.165 1.299-.573 1.858-1.143.838-.856 1.3-1.93 1.3-3.025A2.754 2.754 0 0016.251 6zm.378 4.725a3.278 3.278 0 01-.629.503L16 11a5.967 5.967 0 00-.78-2.956 1.248 1.248 0 012.28.706c0 .944-.546 1.643-.872 1.975z"
});

var _ref2$4F = /*#__PURE__*/createElement("path", {
  d: "M11 4a1 1 0 11-2 0 1 1 0 012 0z"
});

function SvgTeapot(props) {
  return /*#__PURE__*/createElement("svg", _extends$mi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16"
  }, props), _ref$mi, _ref2$4F);
}

function _extends$mj() { _extends$mj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mj.apply(this, arguments); }

var _ref$mj = /*#__PURE__*/createElement("path", {
  d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zm3.931 5.484l-1.313 6.184c-.091.441-.356.544-.725.341l-2-1.478-.959.934c-.112.109-.2.2-.4.2-.259 0-.216-.097-.303-.344L5.55 9.084l-1.978-.616c-.428-.131-.431-.425.097-.634l7.706-2.975c.35-.159.691.084.556.625z"
});

function SvgTelegram(props) {
  return /*#__PURE__*/createElement("svg", _extends$mj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mj);
}

function _extends$mk() { _extends$mk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mk.apply(this, arguments); }

var _ref$mk = /*#__PURE__*/createElement("path", {
  d: "M6 10.268V4a1 1 0 00-2 0v6.268A1.999 1.999 0 005 14a2 2 0 001-3.732z"
});

var _ref2$4G = /*#__PURE__*/createElement("path", {
  d: "M5 16c-2.206 0-4-1.794-4-4 0-.983.354-1.915 1-2.646V3c0-1.654 1.346-3 3-3s3 1.346 3 3v6.354c.646.731 1 1.663 1 2.646 0 2.206-1.794 4-4 4zM5 1c-1.103 0-2 .897-2 2v6.551a.497.497 0 01-.143.35 2.982 2.982 0 00-.857 2.1c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.79-.304-1.535-.857-2.1A.497.497 0 017 9.551V3c0-1.103-.897-2-2-2zM14.5 2h-4a.5.5 0 010-1h4a.5.5 0 010 1zM13.5 4h-3a.5.5 0 010-1h3a.5.5 0 010 1zM14.5 6h-4a.5.5 0 010-1h4a.5.5 0 010 1zM13.5 8h-3a.5.5 0 010-1h3a.5.5 0 010 1zM14.5 10h-4a.5.5 0 010-1h4a.5.5 0 010 1z"
});

function SvgTemperature(props) {
  return /*#__PURE__*/createElement("svg", _extends$mk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mk, _ref2$4G);
}

function _extends$ml() { _extends$ml = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ml.apply(this, arguments); }

var _ref$ml = /*#__PURE__*/createElement("path", {
  d: "M12.5 2h-3a.5.5 0 010-1h3a.5.5 0 010 1zM11.5 4h-2a.5.5 0 010-1h2a.5.5 0 010 1zM12.5 6h-3a.5.5 0 010-1h3a.5.5 0 010 1zM11.5 8h-2a.5.5 0 010-1h2a.5.5 0 010 1zM12.5 10h-3a.5.5 0 010-1h3a.5.5 0 010 1zM7.143 9.9A.497.497 0 017 9.55V1.999c0-1.103-.897-2-2-2s-2 .897-2 2V9.55a.497.497 0 01-.143.35A2.982 2.982 0 002 12c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.79-.304-1.535-.857-2.1zM5 1c.551 0 1 .449 1 1v3H4V2c0-.551.449-1 1-1z"
});

function SvgTemperature2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ml({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ml);
}

function _extends$mm() { _extends$mm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mm.apply(this, arguments); }

var _ref$mm = /*#__PURE__*/createElement("path", {
  d: "M13 11.5c-1-1-1-2.5-1-4.5.001-1.682-.72-3.472-2.124-4.876C8.473.721 6.685-.001 5.004 0 3.654 0 2.373.466 1.42 1.42c-2.14 2.14-1.825 5.926.705 8.456C3.528 11.279 5.316 12 6.997 12c2.004 0 3.504 0 4.504 1l3 3c1 0 1.5-.5 1.5-1.5l-3-3zM8 2.048c.383.246.746.538 1.08.872s.625.695.872 1.08H8V2.048zM4 9.952a6.534 6.534 0 01-1.952-1.951H4v1.952zM4 7H1.529a5.434 5.434 0 01-.387-1.592A5.137 5.137 0 011.125 5H4v2zm0-3H1.238a3.686 3.686 0 01.978-1.785 3.598 3.598 0 011.255-.814 3.92 3.92 0 01.53-.163V4zm3 6.875h-.004A5.32 5.32 0 015 10.472V8h2v2.875zM7 7H5V5h2v2zm0-3H5V1.125h.004c.67 0 1.348.14 1.996.403V4zm2.785 5.785a3.598 3.598 0 01-1.255.814 3.92 3.92 0 01-.53.163V8h2.762a3.686 3.686 0 01-.978 1.785zM8 7V5h2.471c.212.522.342 1.056.387 1.592.011.138.017.274.017.408H8zM3 13.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 013 13.5z"
});

function SvgTennis(props) {
  return /*#__PURE__*/createElement("svg", _extends$mm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mm);
}

function _extends$mn() { _extends$mn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mn.apply(this, arguments); }

var _ref$mn = /*#__PURE__*/createElement("path", {
  d: "M16 14c0-.205-.063-.408-.186-.581L9.229 5.2l2.585-3.619A1 1 0 0010.187.419L8.001 3.48 5.815.419a1 1 0 10-1.627 1.162L6.773 5.2.188 13.419A1.004 1.004 0 00.002 14v2h8V8l4 8h4v-2z"
});

function SvgTent(props) {
  return /*#__PURE__*/createElement("svg", _extends$mn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mn);
}

function _extends$mo() { _extends$mo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mo.apply(this, arguments); }

var _ref$mo = /*#__PURE__*/createElement("path", {
  d: "M0 1v14h16V1H0zm15 13H1V2h14v12zM14 3H2v10h12V3zM7 8H6v1H5v1H4V9h1V8h1V7H5V6H4V5h1v1h1v1h1v1zm4 2H8V9h3v1z"
});

function SvgTerminal(props) {
  return /*#__PURE__*/createElement("svg", _extends$mo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mo);
}

function _extends$mp() { _extends$mp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mp.apply(this, arguments); }

var _ref$mp = /*#__PURE__*/createElement("path", {
  d: "M5.032 13l.9-3h4.137l.9 3h1.775l-3-10H6.256l-3 10h1.776zm2.4-8h1.137l.9 3H6.532l.9-3z"
});

function SvgTextColor(props) {
  return /*#__PURE__*/createElement("svg", _extends$mp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mp);
}

function _extends$mq() { _extends$mq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mq.apply(this, arguments); }

var _ref$mq = /*#__PURE__*/createElement("path", {
  d: "M14 12h2l-2.5 3-2.5-3h2V4h-2l2.5-3L16 4h-2zM10 1v4L9 3H6v11h2v1H2v-1h2V3H1L0 5V1z"
});

function SvgTextHeight(props) {
  return /*#__PURE__*/createElement("svg", _extends$mq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mq);
}

function _extends$mr() { _extends$mr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mr.apply(this, arguments); }

var _ref$mr = /*#__PURE__*/createElement("path", {
  d: "M4 14v2l-3-2.5L4 11v2h8v-2l3 2.5-3 2.5v-2zm9-13v4l-1-2H9v7h2v1H5v-1h2V3H4L3 5V1z"
});

function SvgTextWidth(props) {
  return /*#__PURE__*/createElement("svg", _extends$mr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mr);
}

function _extends$ms() { _extends$ms = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ms.apply(this, arguments); }

var _ref$ms = /*#__PURE__*/createElement("path", {
  d: "M16.977 0C15.256.611 13.204 1.215 11 1.215S6.744.61 5.023 0C5.008.318 5 .64 5 .965 5 7.059 7.686 12 11 12s6-4.94 6-11.035c0-.325-.008-.647-.023-.965zM7 4c0-.552.672-1 1.5-1s1.5.448 1.5 1H7zm4 6c-1.314 0-2.431-1.268-2.837-3.033C8.888 7.605 9.891 8 11 8s2.112-.395 2.837-1.033C13.431 8.732 12.315 10 11 10zm1-6c0-.552.672-1 1.5-1s1.5.448 1.5 1h-3z"
});

var _ref2$4H = /*#__PURE__*/createElement("path", {
  d: "M7.935 12.089c-.844-.657-1.592-1.577-2.221-2.735-.562-1.034-1.008-2.219-1.327-3.502C2.79 5.756 1.305 5.456.021 5 .007 5.292 0 5.587 0 5.885 0 11.471 2.462 16 5.5 16c1.547 0 2.945-1.175 3.944-3.066a5.489 5.489 0 01-1.508-.845zM2 8h2a1 1 0 01-2 0zm3.5 4.969c-.672 0-1.309.131-1.881.365.458-.837 1.131-1.365 1.881-1.365s1.423.529 1.881 1.365a4.964 4.964 0 00-1.881-.365z"
});

function SvgTheater(props) {
  return /*#__PURE__*/createElement("svg", _extends$ms({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$ms, _ref2$4H);
}

function _extends$mt() { _extends$mt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mt.apply(this, arguments); }

var _ref$mt = /*#__PURE__*/createElement("path", {
  d: "M56.216 34.649A3.784 3.784 0 0160 38.432v17.784A3.784 3.784 0 0156.216 60H38.432a3.783 3.783 0 01-3.783-3.784V38.432a3.783 3.783 0 013.783-3.783zm-30.648 0a3.783 3.783 0 013.783 3.783v17.784A3.784 3.784 0 0125.568 60H7.784A3.784 3.784 0 014 56.216V38.432a3.783 3.783 0 013.784-3.783zM56.216 4A3.784 3.784 0 0160 7.784v17.784a3.783 3.783 0 01-3.784 3.783H38.432a3.783 3.783 0 01-3.783-3.783V7.784A3.784 3.784 0 0138.432 4zM25.568 4a3.783 3.783 0 013.778 3.59l.005.194v17.784a3.783 3.783 0 01-3.589 3.778l-.194.005H7.784a3.785 3.785 0 01-3.78-3.589L4 25.568V7.784a3.785 3.785 0 013.59-3.78L7.783 4h17.784zm-.379 2.649H8.162c-.836 0-1.513.677-1.513 1.513V25.19c0 .836.677 1.514 1.513 1.514H25.19c.836 0 1.514-.678 1.514-1.514V8.162c0-.836-.678-1.513-1.514-1.513z"
});

function SvgThemes(props) {
  return /*#__PURE__*/createElement("svg", _extends$mt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref$mt);
}

function _extends$mu() { _extends$mu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mu.apply(this, arguments); }

var _ref$mu = /*#__PURE__*/createElement("path", {
  d: "M.5 6.5c0 .514.281.968.708 1.238A1.5 1.5 0 002.5 10h2.934a14.564 14.564 0 00-.528 3.906C4.906 15.061 5.845 16 7 16s2.094-.939 2.094-2.094c0-1.625.605-2.874 1.798-3.714A5.53 5.53 0 0112 9.597V11h4V1h-4v.984c-.936-.061-1.39-.296-1.831-.523C9.73 1.234 9.276 1 8.5 1h-5a1.5 1.5 0 00-1.394 2.053 1.5 1.5 0 00-.898 2.209C.781 5.532.5 5.986.5 6.5zm5 2.5h-3a.5.5 0 010-1h3a.5.5 0 010 1zm1.795-3.229a1.498 1.498 0 00.012-2.535A1.487 1.487 0 007.414 2H8.5c.533 0 .817.147 1.21.35.496.256 1.1.567 2.29.636v5.347a6.926 6.926 0 00-1.792.888c-1.506 1.06-2.302 2.68-2.302 4.685a.907.907 0 01-1.812 0c0-1.338.194-2.647.577-3.906.104-.387.202-.769.264-1.062.04-.13.062-.268.064-.411L7 8.5c0-.278-.076-.538-.208-.762.427-.27.708-.724.708-1.238a1.4 1.4 0 00-.205-.729zM3.5 2H6a.5.5 0 010 1H3.5a.5.5 0 010-1zm-1 2h4a.5.5 0 010 1h-4a.5.5 0 010-1zm-.375 2h3.75c.339 0 .625.229.625.5s-.286.5-.625.5h-3.75c-.339 0-.625-.229-.625-.5s.286-.5.625-.5zM14 2.5a.5.5 0 111 0 .5.5 0 01-1 0z"
});

function SvgThumbsDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$mu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mu);
}

function _extends$mv() { _extends$mv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mv.apply(this, arguments); }

var _ref$mv = /*#__PURE__*/createElement("path", {
  d: "M.5 6.5c0 .514.281.968.708 1.238A1.5 1.5 0 002.5 10h2.934a14.564 14.564 0 00-.528 3.906C4.906 15.061 5.845 16 7 16s2.094-.939 2.094-2.094c0-1.625.605-2.874 1.798-3.714A5.53 5.53 0 0112 9.597V11h4V1h-4v.984c-.936-.061-1.39-.296-1.831-.523C9.73 1.234 9.276 1 8.5 1h-5a1.5 1.5 0 00-1.394 2.053 1.5 1.5 0 00-.898 2.209C.781 5.532.5 5.986.5 6.5zm14-4.5a.5.5 0 110 1 .5.5 0 010-1zM2.125 6H3V5h-.5a.5.5 0 010-1h1V3a.5.5 0 010-1h5c.533 0 .817.147 1.21.35.496.256 1.1.567 2.29.636v5.347a6.926 6.926 0 00-1.792.888c-1.506 1.06-2.302 2.68-2.302 4.685a.907.907 0 01-1.812 0c0-1.338.194-2.647.577-3.906a21.4 21.4 0 00.25-1H2.499a.5.5 0 010-1h.5V7h-.875c-.339 0-.625-.229-.625-.5s.286-.5.625-.5z"
});

function SvgThumbsDown2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mv);
}

function _extends$mw() { _extends$mw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mw.apply(this, arguments); }

var _ref$mw = /*#__PURE__*/createElement("path", {
  d: "M1.5 7C.359 7 1 4 2 4c-.5 0 0-2.5 1-2.5C3 .5 4 0 5 0c4.224 0 2.739 1.057 7 1.5v8c-3.764 1.129-7.5 3.96-7.5 6.5-.828 0-3-1 0-6h-3c-1.5 0-1-3 0-3zM13 9.5v-8h-1V1h2c.55 0 1 .675 1 1.5v6c0 .825-.45 1.5-1 1.5h-2v-.5h1z"
});

function SvgThumbsDown3(props) {
  return /*#__PURE__*/createElement("svg", _extends$mw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mw);
}

function _extends$mx() { _extends$mx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mx.apply(this, arguments); }

var _ref$mx = /*#__PURE__*/createElement("path", {
  d: "M15.5 10.5c0-.514-.281-.968-.708-1.238A1.5 1.5 0 0013.5 7h-2.934c.351-1.264.528-2.572.528-3.906C11.094 1.939 10.155 1 9 1s-2.094.939-2.094 2.094c0 1.625-.605 2.874-1.798 3.714A5.53 5.53 0 014 7.403V6H0v10h4v-.984c.936.061 1.39.296 1.831.523.439.227.893.461 1.669.461h5a1.5 1.5 0 001.394-2.053 1.5 1.5 0 00.898-2.209c.427-.27.708-.724.708-1.238zm-5-2.5h3a.5.5 0 010 1h-3a.5.5 0 010-1zm-1.795 3.229a1.498 1.498 0 00-.012 2.535A1.487 1.487 0 008.586 15H7.5c-.533 0-.817-.147-1.21-.35-.496-.256-1.1-.568-2.29-.636V8.667a6.926 6.926 0 001.792-.888c1.506-1.06 2.302-2.68 2.302-4.685a.907.907 0 011.812 0A13.35 13.35 0 019.328 7c-.104.387-.202.769-.264 1.062-.04.13-.062.268-.064.411l-.001.027c0 .278.076.538.208.762-.427.27-.708.724-.708 1.238 0 .264.074.513.205.729zM12.5 15H10a.5.5 0 010-1h2.5a.5.5 0 010 1zm1-2h-4a.5.5 0 010-1h4a.5.5 0 010 1zm.375-2h-3.75c-.339 0-.625-.229-.625-.5s.286-.5.625-.5h3.75c.339 0 .625.229.625.5s-.286.5-.625.5zM2 14.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgThumbsUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$mx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mx);
}

function _extends$my() { _extends$my = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$my.apply(this, arguments); }

var _ref$my = /*#__PURE__*/createElement("path", {
  d: "M15.5 10.5c0-.514-.281-.968-.708-1.238A1.5 1.5 0 0013.5 7h-2.934c.351-1.264.528-2.572.528-3.906C11.094 1.939 10.155 1 9 1s-2.094.939-2.094 2.094c0 1.625-.605 2.874-1.798 3.714A5.53 5.53 0 014 7.403V6H0v10h4v-.984c.936.061 1.39.296 1.831.523.439.227.893.461 1.669.461h5a1.5 1.5 0 001.394-2.053 1.5 1.5 0 00.898-2.209c.427-.27.708-.724.708-1.238zM1.5 15a.5.5 0 110-1 .5.5 0 010 1zm12.375-4H13v1h.5a.5.5 0 010 1h-1v1a.5.5 0 010 1h-5c-.533 0-.817-.147-1.21-.35-.496-.256-1.1-.568-2.29-.636V8.667a6.926 6.926 0 001.792-.888c1.506-1.06 2.302-2.68 2.302-4.685a.907.907 0 011.812 0A13.35 13.35 0 019.328 7a21.4 21.4 0 00-.25 1H13.5a.5.5 0 010 1H13v1h.875c.339 0 .625.229.625.5s-.286.5-.625.5z"
});

function SvgThumbsUp2(props) {
  return /*#__PURE__*/createElement("svg", _extends$my({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$my);
}

function _extends$mz() { _extends$mz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mz.apply(this, arguments); }

var _ref$mz = /*#__PURE__*/createElement("path", {
  d: "M14.5 9c1.141 0 .5 3-.5 3 .5 0 0 2.5-1 2.5 0 1-1 1.5-2 1.5-4.224 0-2.739-1.057-7-1.5v-8c3.764-1.129 7.5-3.96 7.5-6.5.828 0 3 1 0 6h3c1.5 0 1 3 0 3zM3 6.5v8h1v.5H2c-.55 0-1-.675-1-1.5v-6C1 6.675 1.45 6 2 6h2v.5H3z"
});

function SvgThumbsUp3(props) {
  return /*#__PURE__*/createElement("svg", _extends$mz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mz);
}

function _extends$mA() { _extends$mA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mA.apply(this, arguments); }

var _ref$mA = /*#__PURE__*/createElement("path", {
  d: "M9 5l2 2-4 4-2-2zm6.649-.351L14.5 3.5 14 4a1.414 1.414 0 11-1.999-2l.5-.5L11.352.351a1.208 1.208 0 00-1.703 0L.352 9.648a1.208 1.208 0 000 1.703L1.501 12.5 2 12.001A1.414 1.414 0 114 14l-.5.5 1.149 1.149a1.208 1.208 0 001.703 0l9.297-9.297a1.208 1.208 0 000-1.703zM7 13L3 9l6-6 4 4-6 6z"
});

function SvgTicket(props) {
  return /*#__PURE__*/createElement("svg", _extends$mA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mA);
}

function _extends$mB() { _extends$mB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mB.apply(this, arguments); }

var _ref$mB = /*#__PURE__*/createElement("path", {
  d: "M16 6V3.75a.752.752 0 00-.75-.75H3.75a.25.25 0 110 .5.25.25 0 010-.5h-3a.752.752 0 00-.75.75V6a2 2 0 110 4v2.25c0 .412.338.75.75.75h3a.25.25 0 110-.5.25.25 0 010 .5h11.5c.412 0 .75-.338.75-.75V10a2 2 0 110-4zM3.75 12a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1.5a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm0-1a.25.25 0 110-.5.25.25 0 010 .5zm6.623 6.078L8.5 9.217l-1.873 1.361.715-2.201-1.873-1.361h2.315l.715-2.202.715 2.202h2.315L9.656 8.377l.715 2.201z"
});

function SvgTicket2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$mB);
}

function _extends$mC() { _extends$mC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mC.apply(this, arguments); }

var _ref$mC = /*#__PURE__*/createElement("path", {
  d: "M8 16.043a.501.501 0 01-.37-.164l-2.457-2.707a.499.499 0 01-.12-.434l1.941-9.703L5.117.824A.499.499 0 015.498 0h5.006a.5.5 0 01.381.824L9.008 3.035l1.941 9.703a.498.498 0 01-.12.434l-2.457 2.707a.501.501 0 01-.37.164z"
});

function SvgTie(props) {
  return /*#__PURE__*/createElement("svg", _extends$mC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mC);
}

function _extends$mD() { _extends$mD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mD.apply(this, arguments); }

var _ref$mD = /*#__PURE__*/createElement("path", {
  d: "M10.5 6c.935 0 1.814.364 2.475 1.025S14 8.565 14 9.5s-.364 1.814-1.025 2.475A3.477 3.477 0 0110.5 13h-5c-.935 0-1.814-.364-2.475-1.025S2 10.435 2 9.5s.364-1.814 1.025-2.475A3.477 3.477 0 015.5 6h5zm0-2h-5a5.5 5.5 0 100 11h5a5.5 5.5 0 100-11z"
});

var _ref2$4I = /*#__PURE__*/createElement("path", {
  d: "M8 9.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
});

function SvgToggleOff(props) {
  return /*#__PURE__*/createElement("svg", _extends$mD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mD, _ref2$4I);
}

function _extends$mE() { _extends$mE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mE.apply(this, arguments); }

var _ref$mE = /*#__PURE__*/createElement("path", {
  d: "M10.5 4h-5a5.5 5.5 0 100 11h5a5.5 5.5 0 100-11zm0 8a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
});

function SvgToggleOn(props) {
  return /*#__PURE__*/createElement("svg", _extends$mE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mE);
}

function _extends$mF() { _extends$mF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mF.apply(this, arguments); }

var _ref$mF = /*#__PURE__*/createElement("path", {
  d: "M14 6V2.5a.5.5 0 00-.5-.5H10V0L7.5 2.5 10 5V3h3v3h-2l2.5 2.5L16 6h-2zM11.25 8H8V4.75A.753.753 0 007.25 4H.75a.753.753 0 00-.75.75v6.5c0 .412.338.75.75.75H4v3.25c0 .412.338.75.75.75h6.5c.412 0 .75-.338.75-.75v-6.5a.753.753 0 00-.75-.75zM11 15H5v-3h2.25c.412 0 .75-.338.75-.75V9h3v6z"
});

function SvgToggle(props) {
  return /*#__PURE__*/createElement("svg", _extends$mF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mF);
}

function _extends$mG() { _extends$mG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mG.apply(this, arguments); }

var _ref$mG = /*#__PURE__*/createElement("path", {
  d: "M15.215 2.741C14.654 1.618 13.867 1 13 1H3c-.867 0-1.654.618-2.215 1.741C.279 3.753 0 5.088 0 6.5s.279 2.747.785 3.759C1.346 11.382 2.133 12 3 12h2v3.5a.5.5 0 00.854.354l.646-.646.646.646a.5.5 0 00.707 0l.646-.646.646.646a.5.5 0 00.707 0l.646-.646.646.646a.5.5 0 00.707 0l.646-.646.646.646a.5.5 0 00.707 0l.646-.646.646.646a.499.499 0 00.854-.353v-9c0-1.412-.279-2.747-.785-3.759zM1 6.5C1 3.848 2.054 2 3 2s2 1.848 2 4.5S3.946 11 3 11 1 9.152 1 6.5zm14 7.793l-.146-.146a.5.5 0 00-.707 0l-.646.646-.646-.646a.5.5 0 00-.707 0l-.646.646-.646-.646a.5.5 0 00-.707 0l-.646.646-.646-.646a.5.5 0 00-.707 0l-.646.646-.646-.646a.5.5 0 00-.707 0l-.146.146V6.5c0-1.412-.279-2.747-.785-3.759A4.609 4.609 0 004.763 2h8.242c.946 0 2 1.848 2 4.5v7.793z"
});

var _ref2$4J = /*#__PURE__*/createElement("path", {
  d: "M4 6.5C4 7.328 3.552 8 3 8s-1-.672-1-1.5S2.448 5 3 5s1 .672 1 1.5zM8 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM10 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM12 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM14 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgToiletpaper(props) {
  return /*#__PURE__*/createElement("svg", _extends$mG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mG, _ref2$4J);
}

function _extends$mH() { _extends$mH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mH.apply(this, arguments); }

var _ref$mH = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm2 4v1h-1v1.5a1.5 1.5 0 01-3 0V10H4V9h8z"
});

function SvgTongue(props) {
  return /*#__PURE__*/createElement("svg", _extends$mH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mH);
}

function _extends$mI() { _extends$mI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mI.apply(this, arguments); }

var _ref$mI = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zM5 4a1 1 0 110 2 1 1 0 010-2zm7 6h-1v1.5a1.5 1.5 0 01-3 0V10H4V9h8v1zm-1-4a1 1 0 110-2 1 1 0 010 2z"
});

function SvgTongue2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mI);
}

function _extends$mJ() { _extends$mJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mJ.apply(this, arguments); }

var _ref$mJ = /*#__PURE__*/createElement("path", {
  d: "M15.621 9.015L10 7.61V4.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v8.133l-3.25-1.879a.5.5 0 00-.648.13l-1 1.313a.5.5 0 00.072.683l3.5 3c.091.078.206.12.325.12h9.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.379-.485zM15 15H6.185l-3.001-2.572.447-.587 3.619 2.092A.502.502 0 008 13.5V5h1v7.5a.5.5 0 001 0V8.64l1 .25v2.61a.5.5 0 001 0V9.14l1 .25v3.11a.5.5 0 001 0V9.64l1 .25V15z"
});

var _ref2$4K = /*#__PURE__*/createElement("path", {
  d: "M5.854 6.146l-.75-.75.792-.792a.355.355 0 00-.501-.501l-.019.021-.772.772-.75-.75A.499.499 0 003 4.5v2a.5.5 0 00.5.5h2a.5.5 0 00.354-.854zM.146 7.854l.75.75-.792.792a.355.355 0 00.501.501l.019-.021.772-.773.75.75A.499.499 0 003 9.499v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.354.854z"
});

function SvgTouchPinch(props) {
  return /*#__PURE__*/createElement("svg", _extends$mJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mJ, _ref2$4K);
}

function _extends$mK() { _extends$mK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mK.apply(this, arguments); }

var _ref$mK = /*#__PURE__*/createElement("path", {
  d: "M15.621 9.015L10 7.61V4.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v8.133l-3.25-1.879a.5.5 0 00-.648.13l-1 1.313a.5.5 0 00.072.683l3.5 3c.091.078.206.12.325.12h9.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.379-.485zM15 15H6.185l-3.001-2.572.447-.587 3.619 2.092A.502.502 0 008 13.5V5h1v7.5a.5.5 0 001 0V8.64l1 .25v2.61a.5.5 0 001 0V9.14l1 .25v3.11a.5.5 0 001 0V9.64l1 .25V15z"
});

var _ref2$4L = /*#__PURE__*/createElement("path", {
  d: "M5.5 4h-2a.5.5 0 00-.354.854l.75.75-2.293 2.293-.75-.75a.499.499 0 00-.854.354v2a.5.5 0 00.5.5h2a.5.5 0 00.354-.854l-.75-.75 2.293-2.293.75.75A.499.499 0 006 6.5v-2a.5.5 0 00-.5-.5z"
});

function SvgTouchZoom(props) {
  return /*#__PURE__*/createElement("svg", _extends$mK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mK, _ref2$4L);
}

function _extends$mL() { _extends$mL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mL.apply(this, arguments); }

var _ref$mL = /*#__PURE__*/createElement("path", {
  d: "M13.5 16H4a.5.5 0 01-.424-.235l-2.5-4a.5.5 0 01.147-.681l1.5-1a.5.5 0 01.661.096L5 12.119V4.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3.11l5.621 1.405A.5.5 0 0114 9.5v6a.5.5 0 01-.5.5zm-9.223-1H13V9.89l-1-.25v2.86a.5.5 0 01-1 0V9.39l-1-.25v2.36a.5.5 0 01-1 0V8.89l-1-.25v3.86a.5.5 0 01-1 0V5H6v8.5a.5.5 0 01-.884.32l-2.212-2.655-.722.481 2.096 3.353z"
});

var _ref2$4M = /*#__PURE__*/createElement("path", {
  d: "M10 6.938a.5.5 0 01-.437-.743A3.501 3.501 0 006.5 1a3.504 3.504 0 00-3.063 5.195.5.5 0 11-.875.485 4.503 4.503 0 01-.563-2.18c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5a4.51 4.51 0 01-.563 2.181.5.5 0 01-.438.258z"
});

function SvgTouch(props) {
  return /*#__PURE__*/createElement("svg", _extends$mL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mL, _ref2$4M);
}

function _extends$mM() { _extends$mM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mM.apply(this, arguments); }

var _ref$mM = /*#__PURE__*/createElement("path", {
  d: "M14 14L9.806.952C9.638.428 9.163 0 8.75 0h-1.5c-.412 0-.888.428-1.056.952L2 14H0v2h16v-2h-2zM6.586 3h2.828l.643 2H5.943l.643-2zM5.3 7h5.399l.643 2H4.657L5.3 7zm-1.928 6l.643-2h7.971l.643 2H3.373z"
});

function SvgTrafficCone(props) {
  return /*#__PURE__*/createElement("svg", _extends$mM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mM);
}

function _extends$mN() { _extends$mN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mN.apply(this, arguments); }

var _ref$mN = /*#__PURE__*/createElement("path", {
  d: "M13 10l1.5-3H12V6h1l1.5-3H12V2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1H.5L2 6h1v1H.5L2 10h1v1H.5L2 14h1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1h1l1.5-3H12v-1h1zm-5.5 4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 14zm0-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 10zm0-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 6z"
});

function SvgTrafficLights(props) {
  return /*#__PURE__*/createElement("svg", _extends$mN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mN);
}

function _extends$mO() { _extends$mO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mO.apply(this, arguments); }

var _ref$mO = /*#__PURE__*/createElement("path", {
  d: "M13 8.5V7.187c0-.656-.5-1.188-1.125-1.188H11v-3l1-2H8l1 2v3H4v-2H0v9h1a2 2 0 104 0 2 2 0 104 0 2 2 0 104 0h3l-3-4.5zM3 14a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2z"
});

function SvgTrain(props) {
  return /*#__PURE__*/createElement("svg", _extends$mO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mO);
}

function _extends$mP() { _extends$mP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mP.apply(this, arguments); }

var _ref$mP = /*#__PURE__*/createElement("path", {
  d: "M14 11V1c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h1.5l-2.4 3.201a.5.5 0 00.4.799H13.502a.5.5 0 00.4-.8l-2.4-3.2h1.5c.55 0 1-.45 1-1zm-1-7.5v4a.5.5 0 01-.5.5H8V3h4.5a.5.5 0 01.5.5zM5 1h5v1H5V1zM2 3.5a.5.5 0 01.5-.5H7v5H2.5a.5.5 0 01-.5-.5v-4zM2 10a1 1 0 112 0 1 1 0 01-2 0zm10.5 5h-10l.75-1h8.5l.75 1zM11 13H4l.75-1h5.5l.75 1zm1-2a1 1 0 110-2 1 1 0 010 2z"
});

function SvgTrain2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mP);
}

function _extends$mQ() { _extends$mQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mQ.apply(this, arguments); }

var _ref$mQ = /*#__PURE__*/createElement("path", {
  d: "M12 6H1V4h11V1.5L15.5 5 12 8.5zm-8 4h11v2H4v2.5L.5 11 4 7.5z"
});

function SvgTransmission(props) {
  return /*#__PURE__*/createElement("svg", _extends$mQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mQ);
}

function _extends$mR() { _extends$mR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mR.apply(this, arguments); }

var _ref$mR = /*#__PURE__*/createElement("path", {
  d: "M11 9.5V6H0V4h11V.5L15.5 5 11 9.5zM5 10h11v2H5v3.5L.5 11 5 6.5V10z"
});

function SvgTransmission2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mR);
}

function _extends$mS() { _extends$mS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mS.apply(this, arguments); }

var _ref$mS = /*#__PURE__*/createElement("path", {
  d: "M13.887 13.182L11.5 10h1.001a.5.5 0 00.386-.818L10.5 6h1a.502.502 0 00.391-.812l-4-5a.5.5 0 00-.78 0l-4 5A.5.5 0 003.502 6h1l-2.4 3.2a.5.5 0 00.4.8h1l-2.4 3.2a.5.5 0 00.4.8h4.5v1.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V14h4.501a.5.5 0 00.386-.818z"
});

function SvgTree(props) {
  return /*#__PURE__*/createElement("svg", _extends$mS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mS);
}

function _extends$mT() { _extends$mT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mT.apply(this, arguments); }

var _ref$mT = /*#__PURE__*/createElement("path", {
  d: "M13.887 13.182L11.5 10h1.001a.5.5 0 00.386-.818L10.5 6h1a.502.502 0 00.391-.812l-4-5a.5.5 0 00-.78 0l-4 5A.5.5 0 003.502 6h1l-2.4 3.2a.5.5 0 00.4.8h1l-2.4 3.2a.5.5 0 00.4.8h4.5v1.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V14h4.501a.5.5 0 00.386-.818zM8 15H7v-1h1v1zm-5.5-2l2.4-3.2a.5.5 0 00-.4-.8h-1l2.4-3.2a.5.5 0 00-.4-.8h-.96L7.5 1.3 10.46 5H9.5a.5.5 0 00-.4.8L11.5 9h-1a.5.5 0 00-.4.8l2.4 3.2h-10z"
});

function SvgTree2(props) {
  return /*#__PURE__*/createElement("svg", _extends$mT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mT);
}

function _extends$mU() { _extends$mU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mU.apply(this, arguments); }

var _ref$mU = /*#__PURE__*/createElement("path", {
  d: "M11.852 3.354C11.344 1.426 9.586 0 7.5 0S3.656 1.426 3.148 3.354A5.01 5.01 0 000 8a5.006 5.006 0 006 4.899V15.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2.601A5.006 5.006 0 0015 8a4.995 4.995 0 00-3.148-4.646z"
});

function SvgTree3(props) {
  return /*#__PURE__*/createElement("svg", _extends$mU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mU);
}

function _extends$mV() { _extends$mV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mV.apply(this, arguments); }

var _ref$mV = /*#__PURE__*/createElement("path", {
  d: "M11.852 3.354C11.344 1.426 9.586 0 7.5 0S3.656 1.426 3.148 3.354A5.01 5.01 0 000 8c0 2.757 2.243 5 5 5h1v2.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V13h1c2.757 0 5-2.243 5-5a4.995 4.995 0 00-3.148-4.646zM8 15H7v-2h1v2zm2-3H5c-2.206 0-4-1.794-4-4a4.01 4.01 0 012.001-3.465c.003.369.05.735.141 1.09a.5.5 0 10.969-.25A3.504 3.504 0 017.501 1a3.504 3.504 0 013.39 4.375.5.5 0 10.969.249c.091-.355.139-.722.141-1.091a3.996 3.996 0 012.001 3.466c0 2.206-1.794 4-4 4z"
});

function SvgTree4(props) {
  return /*#__PURE__*/createElement("svg", _extends$mV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mV);
}

function _extends$mW() { _extends$mW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mW.apply(this, arguments); }

var _ref$mW = /*#__PURE__*/createElement("path", {
  d: "M15.25 11h-1.575L10 4.876V1.75A.752.752 0 009.25 1h-2.5a.752.752 0 00-.75.75v3.126L2.325 11H.75a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.413 0 .75-.338.75-.75v-3.126L7.675 5h.651l3.675 6.124v3.126c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75z"
});

function SvgTree5(props) {
  return /*#__PURE__*/createElement("svg", _extends$mW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mW);
}

function _extends$mX() { _extends$mX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mX.apply(this, arguments); }

var _ref$mX = /*#__PURE__*/createElement("path", {
  d: "M15.25 12H15V8.75C15 7.785 14.215 7 13.25 7H9V5h.25c.412 0 .75-.338.75-.75v-2.5A.752.752 0 009.25 1h-2.5a.752.752 0 00-.75.75v2.5c0 .412.338.75.75.75H7v2H2.75C1.785 7 1 7.785 1 8.75V12H.75a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.413 0 .75-.338.75-.75v-2.5a.752.752 0 00-.75-.75H3V9h4v3h-.25a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75H9V9h4v3h-.25a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75z"
});

function SvgTree6(props) {
  return /*#__PURE__*/createElement("svg", _extends$mX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mX);
}

function _extends$mY() { _extends$mY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mY.apply(this, arguments); }

var _ref$mY = /*#__PURE__*/createElement("path", {
  d: "M15.25 12H15V8.75C15 7.785 14.215 7 13.25 7H9V5h.25c.412 0 .75-.338.75-.75v-2.5A.752.752 0 009.25 1h-2.5a.752.752 0 00-.75.75v2.5c0 .412.338.75.75.75H7v2H2.75C1.785 7 1 7.785 1 8.75V12H.75a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.413 0 .75-.338.75-.75v-2.5a.752.752 0 00-.75-.75H3V9h4v3h-.25a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75H9V9h4v3h-.25a.753.753 0 00-.75.75v2.5c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75v-2.5a.753.753 0 00-.75-.75zM3 15H1v-2h2v2zm6 0H7v-2h2v2zM7 4V2h2v2H7zm8 11h-2v-2h2v2z"
});

function SvgTree7(props) {
  return /*#__PURE__*/createElement("svg", _extends$mY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mY);
}

function _extends$mZ() { _extends$mZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$mZ.apply(this, arguments); }

var _ref$mZ = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM7 12c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v8zm6-3c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v5z"
});

function SvgTrello(props) {
  return /*#__PURE__*/createElement("svg", _extends$mZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$mZ);
}

function _extends$m_() { _extends$m_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m_.apply(this, arguments); }

var _ref$m_ = /*#__PURE__*/createElement("path", {
  d: "M8 4.144l5.402 9.356H2.598L8 4.144zm0-3L0 15h16L8 1.144z"
});

function SvgTriangle(props) {
  return /*#__PURE__*/createElement("svg", _extends$m_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m_);
}

function _extends$m$() { _extends$m$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m$.apply(this, arguments); }

var _ref$m$ = /*#__PURE__*/createElement("path", {
  d: "M8 1.144L0 15h16z"
});

function SvgTriangle2(props) {
  return /*#__PURE__*/createElement("svg", _extends$m$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$m$);
}

function _extends$n0() { _extends$n0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n0.apply(this, arguments); }

var _ref$n0 = /*#__PURE__*/createElement("path", {
  d: "M16 1h-5v2H5V1H0c0 5 4 10.85 7 11.75V14c-1 0-2 .5-2 1h6c0-.5-1-1-2-1v-1.25C12 11.85 16 6 16 1zm-4.005 2.538L12 3V2h2.945c-.087.807-.277 1.66-.567 2.547a16.91 16.91 0 01-1.607 3.471c-.642 1.057-1.372 1.996-2.109 2.714a9.58 9.58 0 01-.211.2c1.326-2.658 1.518-5.984 1.545-7.394zm-6.656 7.194c-.737-.719-1.467-1.657-2.109-2.714a16.91 16.91 0 01-1.607-3.471c-.29-.886-.48-1.739-.567-2.547h2.945v1l.005.538c.028 1.409.22 4.735 1.545 7.394a7.764 7.764 0 01-.211-.2z"
});

function SvgTrophy(props) {
  return /*#__PURE__*/createElement("svg", _extends$n0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n0);
}

function _extends$n1() { _extends$n1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n1.apply(this, arguments); }

var _ref$n1 = /*#__PURE__*/createElement("path", {
  d: "M13 3V1H3v2H0v2a3 3 0 003.9 2.862A5 5 0 007 9.899v3.1H6a2 2 0 00-2 2h8a2 2 0 00-2-2H9v-3.1a5.003 5.003 0 003.1-2.037A3 3 0 0016 5V3h-3zM3 6.813A1.815 1.815 0 011.187 5V4H3v1c0 .628.116 1.229.327 1.782-.106.019-.216.03-.327.03zM14.813 5a1.815 1.815 0 01-2.14 1.783A4.994 4.994 0 0013 5.001v-1h1.813v1z"
});

function SvgTrophy2(props) {
  return /*#__PURE__*/createElement("svg", _extends$n1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n1);
}

function _extends$n2() { _extends$n2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n2.apply(this, arguments); }

var _ref$n2 = /*#__PURE__*/createElement("path", {
  d: "M13 3V1H3v2H0v2a3 3 0 003.9 2.862A5 5 0 007 9.899v3.1H6a2 2 0 00-2 2h8a2 2 0 00-2-2H9v-3.1a5.003 5.003 0 003.1-2.037A3 3 0 0016 5V3h-3zM3 6.813A1.815 1.815 0 011.187 5V4H3v1c0 .628.116 1.229.327 1.782-.106.019-.216.03-.327.03zM9.522 5.8l.953 2.913-2.476-1.807-2.476 1.807.953-2.913-2.483-1.796 3.065.007.941-2.917.941 2.917 3.065-.007L9.522 5.8zm5.291-.8a1.815 1.815 0 01-2.14 1.783A4.994 4.994 0 0013 5.001v-1h1.813v1z"
});

function SvgTrophy3(props) {
  return /*#__PURE__*/createElement("svg", _extends$n2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n2);
}

function _extends$n3() { _extends$n3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n3.apply(this, arguments); }

var _ref$n3 = /*#__PURE__*/createElement("path", {
  d: "M13 2H3L0 6l8 9-2.222-8h4.444L8 15l8-9-3-4zM1.25 6l2.282-3.043L5.222 6H1.25zm4.528 0l1.667-3h1.111l1.667 3H5.779zm6.69-3.043L14.75 6h-3.972l1.69-3.043z"
});

function SvgTrophy4(props) {
  return /*#__PURE__*/createElement("svg", _extends$n3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n3);
}

function _extends$n4() { _extends$n4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n4.apply(this, arguments); }

var _ref$n4 = /*#__PURE__*/createElement("path", {
  d: "M16 9l-2-4h-3V3c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v8l1 1h1.268a2 2 0 103.464 0h5.536a2 2 0 103.464 0H16V9zm-5 0V6h2.073l1.5 3H11z"
});

function SvgTruck(props) {
  return /*#__PURE__*/createElement("svg", _extends$n4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n4);
}

function _extends$n5() { _extends$n5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n5.apply(this, arguments); }

var _ref$n5 = /*#__PURE__*/createElement("path", {
  d: "M15.5 3a.5.5 0 00-.5.5c0 1.271-.739 2.08-1.358 2.534C12.805 6.648 11.66 7 10.5 7H10V5.5a.5.5 0 00-1 0V7H8V5.5a.5.5 0 00-1 0V7H6V5.5a.5.5 0 00-1 0V7H1v-.5a.5.5 0 00-1 0v3a.5.5 0 001 0V9h2.172A3.004 3.004 0 006 13h3a3.004 3.004 0 002.882-3.833 5.003 5.003 0 011.76.799C14.262 10.42 15 11.229 15 12.5a.5.5 0 001 0v-9a.5.5 0 00-.5-.5zM9 11H6c-.551 0-1-.449-1-1s.449-1 1-1h3c.551 0 1 .449 1 1s-.449 1-1 1z"
});

function SvgTrumpet(props) {
  return /*#__PURE__*/createElement("svg", _extends$n5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n5);
}

function _extends$n6() { _extends$n6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n6.apply(this, arguments); }

var _ref$n6 = /*#__PURE__*/createElement("path", {
  d: "M10.905 2L16 3v4h-3v8H3V7H0V3l5.095-1a3.001 3.001 0 005.81 0z"
});

function SvgTshirt(props) {
  return /*#__PURE__*/createElement("svg", _extends$n6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n6);
}

function _extends$n7() { _extends$n7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n7.apply(this, arguments); }

var _ref$n7 = /*#__PURE__*/createElement("path", {
  d: "M9.001 7v3.659c0 .928-.012 1.463.086 1.727.098.262.342.534.609.691.354.212.758.318 1.214.318.81 0 1.289-.107 2.09-.633v2.405a9.089 9.089 0 01-1.833.639A7.93 7.93 0 019.369 16a4.9 4.9 0 01-1.725-.276 4.195 4.195 0 01-1.438-.79c-.398-.343-.672-.706-.826-1.091s-.23-.944-.23-1.676V6.556H3.003V4.29c.628-.204 1.331-.497 1.778-.877a4.386 4.386 0 001.08-1.374C6.133 1.505 6.32.825 6.422 0h2.579v4H13v3H9.001z"
});

function SvgTumblr(props) {
  return /*#__PURE__*/createElement("svg", _extends$n7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n7);
}

function _extends$n8() { _extends$n8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n8.apply(this, arguments); }

var _ref$n8 = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-3.066 12.884c-.472.222-.9.378-1.281.469a5.522 5.522 0 01-1.241.134c-.506 0-.803-.063-1.191-.191s-.719-.309-.994-.544c-.275-.238-.463-.488-.569-.753s-.159-.65-.159-1.156V6.971h-1.5V5.408c.434-.141.938-.344 1.244-.606.309-.263.559-.578.744-.947.188-.369.316-.837.388-1.406h1.569v2.55H11v1.972H8.447v2.831c0 .641-.009 1.009.059 1.191s.238.369.422.475c.244.147.525.219.838.219.559 0 1.116-.181 1.669-.544v1.741z"
});

function SvgTumblr2(props) {
  return /*#__PURE__*/createElement("svg", _extends$n8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n8);
}

function _extends$n9() { _extends$n9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n9.apply(this, arguments); }

var _ref$n9 = /*#__PURE__*/createElement("path", {
  d: "M8.87 11.514c-1.28.596-2.471.589-3.271.532-.954-.069-1.721-.33-2.058-.558a.454.454 0 10-.509.753c.542.367 1.501.64 2.503.712.17.012.356.02.557.02.872 0 1.979-.083 3.163-.634a.454.454 0 10-.384-.824zm5.051-.673C13.965 6.893 14.37-.568 6.812.035-.651.636 1.328 8.519 1.217 11.159 1.118 12.556.655 14.263 0 16h2.017a12.3 12.3 0 00.425-2.159c.122.085.252.167.391.245.226.133.42.31.626.497.48.438 1.025.934 2.089.996.071.004.143.006.214.006 1.077 0 1.813-.471 2.404-.85.283-.181.528-.338.759-.413.655-.205 1.227-.536 1.655-.957.067-.066.129-.133.187-.202.238.873.564 1.856.926 2.836H16c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693v-.001c-.074-1.288.542-2.372 1.377-2.421s1.571.957 1.645 2.245v.001c.004.069.006.138.006.206a3.239 3.239 0 00-.717.275l-.002-.029c-.071-.731-.462-1.284-.873-1.234s-.686.684-.614 1.415a2 2 0 00.251.819 91.083 91.083 0 00-.511.376c-.311-.408-.524-.993-.562-1.655zm8.456 3.185c-.03.681-.92 1.322-1.743 1.579l-.005.002c-.342.111-.647.306-.97.513-.543.347-1.104.706-1.914.706-.053 0-.108-.002-.161-.005-.742-.043-1.09-.36-1.529-.761-.232-.211-.472-.43-.781-.611l-.007-.004c-.667-.377-1.081-.845-1.108-1.253-.013-.203.077-.378.268-.522.416-.312.695-.516.879-.651.205-.15.267-.195.313-.239l.106-.103c.382-.371 1.021-.993 2.002-.993.6 0 1.264.231 1.971.686.333.217.623.317.99.444.252.087.539.186.922.35l.006.003c.357.147.78.415.76.858zm-.197-1.6a2.645 2.645 0 00-.215-.098 12.404 12.404 0 00-.852-.328c.127-.248.206-.558.213-.894.018-.818-.395-1.483-.922-1.484s-.968.661-.986 1.479a1.067 1.067 0 000 .08 4.534 4.534 0 00-.956-.324l-.004-.092v-.001c-.03-1.491.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642v.001a3.184 3.184 0 01-.475 1.776z"
});

function SvgTux(props) {
  return /*#__PURE__*/createElement("svg", _extends$n9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n9);
}

function _extends$na() { _extends$na = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$na.apply(this, arguments); }

var _ref$na = /*#__PURE__*/createElement("path", {
  d: "M15.331 4.502a49.408 49.408 0 00-4.407-.425L13.5 1.501l-1-1L8.991 4.01A54.24 54.24 0 008 4.001l-4-4-1 1 3.034 3.034a50.304 50.304 0 00-5.365.467C.239 6.185 0 8.045 0 10s.239 3.815.669 5.498C2.913 15.821 5.393 16 8 16s5.087-.179 7.331-.502c.43-1.683.669-3.543.669-5.498s-.239-3.815-.669-5.498zm-1.833 9.164C11.815 13.881 9.955 14 8 14s-3.815-.119-5.498-.334C2.179 12.544 2 11.304 2 10s.179-2.543.502-3.666C4.185 6.119 6.045 6 8 6s3.815.119 5.498.334C13.821 7.456 14 8.696 14 10s-.179 2.543-.502 3.666z"
});

function SvgTv(props) {
  return /*#__PURE__*/createElement("svg", _extends$na({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$na);
}

function _extends$nb() { _extends$nb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nb.apply(this, arguments); }

var _ref$nb = /*#__PURE__*/createElement("path", {
  d: "M1.5 0L0 2.5V14h4v2h2l2-2h2.5L15 9.5V0H1.5zM13 8.5L10.5 11H8l-2 2v-2H3V2h10v6.5z"
});

var _ref2$4N = /*#__PURE__*/createElement("path", {
  d: "M9.5 4H11v4H9.5V4zM6.5 4H8v4H6.5V4z"
});

function SvgTwitch(props) {
  return /*#__PURE__*/createElement("svg", _extends$nb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nb, _ref2$4N);
}

function _extends$nc() { _extends$nc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nc.apply(this, arguments); }

var _ref$nc = /*#__PURE__*/createElement("path", {
  d: "M16 3.538a6.461 6.461 0 01-1.884.516 3.301 3.301 0 001.444-1.816 6.607 6.607 0 01-2.084.797 3.28 3.28 0 00-2.397-1.034 3.28 3.28 0 00-3.197 4.028 9.321 9.321 0 01-6.766-3.431 3.284 3.284 0 001.015 4.381A3.301 3.301 0 01.643 6.57v.041A3.283 3.283 0 003.277 9.83a3.291 3.291 0 01-1.485.057 3.293 3.293 0 003.066 2.281 6.586 6.586 0 01-4.862 1.359 9.286 9.286 0 005.034 1.475c6.037 0 9.341-5.003 9.341-9.341 0-.144-.003-.284-.009-.425a6.59 6.59 0 001.637-1.697z"
});

function SvgTwitter(props) {
  return /*#__PURE__*/createElement("svg", _extends$nc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nc);
}

function _extends$nd() { _extends$nd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nd.apply(this, arguments); }

var _ref$nd = /*#__PURE__*/createElement("path", {
  d: "M4 6V1h6.293L12 2.707V6h1V2.5a.504.504 0 00-.146-.354l-2-2A.5.5 0 0010.5 0h-7a.5.5 0 00-.5.5V6h1zM15.928 13.243v-.001l-2.546-4.243h1.617v-2h-14v2h1.617L.071 13.242a.499.499 0 00-.072.257v2a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-2a.49.49 0 00-.072-.257zM10.5 9h1a.5.5 0 010 1h-1a.5.5 0 010-1zm0 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3-2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm0 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3-2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm0 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm9 3h-11a.5.5 0 010-1h11a.5.5 0 010 1z"
});

var _ref2$4O = /*#__PURE__*/createElement("path", {
  d: "M5.5 3h4a.5.5 0 000-1h-4a.5.5 0 000 1zM10.5 4h-5a.5.5 0 000 1h5a.5.5 0 000-1z"
});

function SvgTypewriter(props) {
  return /*#__PURE__*/createElement("svg", _extends$nd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nd, _ref2$4O);
}

function _extends$ne() { _extends$ne = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ne.apply(this, arguments); }

var _ref$ne = /*#__PURE__*/createElement("path", {
  d: "M1 0v5l2-3h4v13H5l-1 1h8l-1-1H9V2h4l2 3V0z"
});

function SvgTypography(props) {
  return /*#__PURE__*/createElement("svg", _extends$ne({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ne);
}

function _extends$nf() { _extends$nf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nf.apply(this, arguments); }

var _ref$nf = /*#__PURE__*/createElement("path", {
  d: "M8.998 1.062A8.001 8.001 0 0116 9h-.268a1.999 1.999 0 00-3.464 0h-.537a1.999 1.999 0 00-2.732-.732V13.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5a1 1 0 012 0 .5.5 0 001 0V8.268A1.999 1.999 0 004.267 9h-.536A1.999 1.999 0 00.267 9h-.268a8.001 8.001 0 017.002-7.938A1 1 0 118.999 1l-.002.062z"
});

function SvgUmbrella(props) {
  return /*#__PURE__*/createElement("svg", _extends$nf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nf);
}

function _extends$ng() { _extends$ng = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ng.apply(this, arguments); }

var _ref$ng = /*#__PURE__*/createElement("path", {
  d: "M2 14h12v2H2zm9-14h3v1h-1v7A5 5 0 013 8V1H2V0h4v1H5v7c0 1.654 1.57 3.125 3.5 3.125S12 9.654 12 8V1h-1V0z"
});

function SvgUnderline(props) {
  return /*#__PURE__*/createElement("svg", _extends$ng({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ng);
}

function _extends$nh() { _extends$nh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nh.apply(this, arguments); }

var _ref$nh = /*#__PURE__*/createElement("path", {
  d: "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5S3 9.985 3 7.5V1h2v6.5c0 .628.285 1.23.802 1.695C6.379 9.714 7.159 10 8 10s1.621-.286 2.198-.805C10.715 8.729 11 8.127 11 7.5V1zM3 13h10v2H3z"
});

function SvgUnderline2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nh);
}

function _extends$ni() { _extends$ni = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ni.apply(this, arguments); }

var _ref$ni = /*#__PURE__*/createElement("path", {
  d: "M8 1a7.979 7.979 0 00-5.657 2.343L0 1v6h6L3.757 4.757a6 6 0 118.211 8.743l1.323 1.5A8 8 0 008 1z"
});

function SvgUndo(props) {
  return /*#__PURE__*/createElement("svg", _extends$ni({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ni);
}

function _extends$nj() { _extends$nj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nj.apply(this, arguments); }

var _ref$nj = /*#__PURE__*/createElement("path", {
  d: "M11.904 16C13.681 12.781 13.98 7.87 7 8.034V12L1 6l6-6v3.881c8.359-.218 9.29 7.378 4.904 12.119z"
});

function SvgUndo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nj);
}

function _extends$nk() { _extends$nk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nk.apply(this, arguments); }

var _ref$nk = /*#__PURE__*/createElement("path", {
  d: "M6 7.25c0 .412-.338.75-.75.75h-1.5A.752.752 0 013 7.25v-1.5c0-.412.337-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM11 7.25c0 .412-.338.75-.75.75h-1.5A.753.753 0 018 7.25v-1.5c0-.412.338-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM6 12.25c0 .412-.338.75-.75.75h-1.5a.752.752 0 01-.75-.75v-1.5c0-.412.337-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM11 12.25c0 .412-.338.75-.75.75h-1.5a.753.753 0 01-.75-.75v-1.5c0-.412.338-.75.75-.75h1.5c.412 0 .75.338.75.75v1.5zM14.251 2.5L16 .751V0h-.751L13.5 1.749 11.751 0H11v.751L12.749 2.5 11 4.249V5h.751L13.5 3.251 15.249 5H16v-.751zM0 12h1v2H0v-2zM0 9h1v2H0V9zM13 7h1v2h-1V7zM13 13h1v2h-1v-2zM13 10h1v2h-1v-2zM0 6h1v2H0V6zM0 3h1v2H0V3zM8 2h2v1H8V2zM5 2h2v1H5V2zM2 2h2v1H2V2zM7 15h2v1H7v-1zM10 15h2v1h-2v-1zM4 15h2v1H4v-1zM1 15h2v1H1v-1z"
});

function SvgUngroup(props) {
  return /*#__PURE__*/createElement("svg", _extends$nk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nk);
}

function _extends$nl() { _extends$nl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nl.apply(this, arguments); }

var _ref$nl = /*#__PURE__*/createElement("path", {
  d: "M16 10h-3V7h-1v3H9v1h3v3h1v-3h3zM6 4v8c0 1.103-.897 2-2 2s-2-.897-2-2V4H0v8a4 4 0 008 0V4H6z"
});

function SvgUnicode(props) {
  return /*#__PURE__*/createElement("svg", _extends$nl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nl);
}

function _extends$nm() { _extends$nm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nm.apply(this, arguments); }

var _ref$nm = /*#__PURE__*/createElement("path", {
  d: "M11 4V0H0v11h4v5h12V4h-5zm-1 1.125H5V5h5v.125zm4 1h-3V6h3v.125zm-9 3.75h5V10H5v-.125zm-3-1h2V9H2v-.125zm2-3v.25H2v-.25h2zm-2-.25v-.25h2v.25H2zm2 .75v.25H2v-.25h2zm1 1.75v-.25h5v.25H5zm5 .25v.25H5v-.25h5zm-5-.75v-.25h5v.25H5zm0-.5v-.25h5v.25H5zm0-.5v-.25h5v.25H5zm-1 .25v.25H2v-.25h2zm0 .5v.25H2v-.25h2zm0 .5v.25H2v-.25h2zm0 .5v.25H2v-.25h2zm1 .5h5v.25H5v-.25zm5 .5v.25H5v-.25h5zM6 14v-.125h8V14H6zm0-.375v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5v-.25h8v.25H6zm0-.5V11h5v-.125h3v.25H6zm5-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm0-.5v-.25h3v.25h-3zm-1-.5H5v-.25h5v.25zm-5-.5v-.25h5v.25H5zm-1-.5H2v-.25h2v.25zM9 2v.125H2V2h7zm0 .375v.25H2v-.25h7zm0 .5v.25H2v-.25h7zm0 .5v.25H2v-.25h7zm0 .5V4H4v.125H2v-.25h7zm-5 .5v.25H2v-.25h2z"
});

function SvgUnite(props) {
  return /*#__PURE__*/createElement("svg", _extends$nm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nm);
}

function _extends$nn() { _extends$nn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nn.apply(this, arguments); }

var _ref$nn = /*#__PURE__*/createElement("path", {
  d: "M6.879 9.934a.81.81 0 01-.575-.238 3.818 3.818 0 010-5.392l3-3C10.024.584 10.982.187 12 .187s1.976.397 2.696 1.117a3.818 3.818 0 010 5.392l-1.371 1.371a.813.813 0 01-1.149-1.149l1.371-1.371A2.19 2.19 0 0012 1.812c-.584 0-1.134.228-1.547.641l-3 3a2.19 2.19 0 000 3.094.813.813 0 01-.575 1.387z"
});

var _ref2$4P = /*#__PURE__*/createElement("path", {
  d: "M4 15.813a3.789 3.789 0 01-2.696-1.117 3.818 3.818 0 010-5.392l1.371-1.371a.813.813 0 011.149 1.149l-1.371 1.371A2.19 2.19 0 004 14.188c.585 0 1.134-.228 1.547-.641l3-3a2.19 2.19 0 000-3.094.813.813 0 011.149-1.149 3.818 3.818 0 010 5.392l-3 3A3.789 3.789 0 014 15.813zM14.5 13a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l2 2a.5.5 0 01-.354.853zM15.5 10h-2a.5.5 0 010-1h2a.5.5 0 010 1zM11.5 14a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM2.5 7h-2a.5.5 0 010-1h2a.5.5 0 010 1zM3.5 6a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l2 2A.5.5 0 013.499 6zM4.5 5a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
});

function SvgUnlink(props) {
  return /*#__PURE__*/createElement("svg", _extends$nn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nn, _ref2$4P);
}

function _extends$no() { _extends$no = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$no.apply(this, arguments); }

var _ref$no = /*#__PURE__*/createElement("path", {
  d: "M7.451 10.549c.071.141.109.299.109.464 0 .275-.105.532-.297.724L4.71 14.29c-.191.191-.448.297-.724.297s-.532-.105-.724-.297l-1.553-1.553c-.191-.191-.297-.448-.297-.724s.105-.532.297-.724l2.553-2.553c.191-.191.448-.297.724-.297.165 0 .323.038.464.109l1.021-1.021a2.43 2.43 0 00-1.485-.502 2.43 2.43 0 00-1.724.711L.709 10.289a2.444 2.444 0 000 3.447l1.553 1.553c.474.474 1.099.711 1.724.711s1.25-.237 1.724-.711l2.553-2.553a2.448 2.448 0 00.209-3.209l-1.021 1.021zm7.838-8.285L13.736.711C13.262.237 12.637 0 12.012 0s-1.25.237-1.724.711L7.735 3.264a2.445 2.445 0 00-.208 3.208l1.021-1.021a1.029 1.029 0 01-.109-.464c0-.275.105-.532.297-.724l2.553-2.553c.191-.191.448-.297.724-.297s.532.105.724.297l1.553 1.553c.191.191.297.448.297.724s-.105.532-.297.724l-2.553 2.553a1.016 1.016 0 01-.724.297c-.165 0-.323-.038-.464-.109L9.528 8.473c.435.335.96.502 1.485.502a2.43 2.43 0 001.724-.711l2.553-2.553a2.444 2.444 0 000-3.447zM3.646 4.354l-3-3 .707-.707 3 3zM6 0h1v3H6zM0 6h3v1H0zm12.354 5.646l3 3-.707.707-3-3zM9 13h1v3H9zm4-4h3v1h-3z"
});

function SvgUnlink2(props) {
  return /*#__PURE__*/createElement("svg", _extends$no({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$no);
}

function _extends$np() { _extends$np = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$np.apply(this, arguments); }

var _ref$np = /*#__PURE__*/createElement("path", {
  d: "M4.5 16C2.019 16 0 13.981 0 11.5S2.019 7 4.5 7a1 1 0 010 2C3.122 9 2 10.121 2 11.5S3.122 14 4.5 14 7 12.879 7 11.5a1 1 0 012 0C9 13.981 6.981 16 4.5 16zM11.5 9a1 1 0 010-2C12.879 7 14 5.878 14 4.5S12.879 2 11.5 2 9 3.122 9 4.5a1 1 0 01-2 0C7 2.019 9.019 0 11.5 0S16 2.019 16 4.5 13.981 9 11.5 9zM3.5 4a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l2 2A.5.5 0 013.499 4zM5.5 3a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM2.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zM14.5 15a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l2 2a.5.5 0 01-.354.853zM15.5 11h-2a.5.5 0 010-1h2a.5.5 0 010 1zM10.5 16a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
});

function SvgUnlink3(props) {
  return /*#__PURE__*/createElement("svg", _extends$np({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$np);
}

function _extends$nq() { _extends$nq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nq.apply(this, arguments); }

var _ref$nq = /*#__PURE__*/createElement("path", {
  d: "M8.086 10.586l-2.865 2.865c-.354.354-.829.549-1.337.549a1.873 1.873 0 01-1.883-1.884c0-.508.195-.983.549-1.337l2.865-2.865L4.001 6.5 1.136 9.365a3.9 3.9 0 00-.001 5.501C1.891 15.622 2.888 16 3.885 16s1.995-.378 2.752-1.135L9.502 12l-1.414-1.414zM10.586 8.086l2.865-2.865c.354-.354.549-.829.549-1.337a1.873 1.873 0 00-1.884-1.883c-.508 0-.983.195-1.337.549L7.914 5.415 6.5 4.001l2.865-2.865a3.9 3.9 0 015.501-.001C15.622 1.891 16 2.888 16 3.885s-.378 1.995-1.135 2.752L12 9.502l-1.414-1.414zM13 10h3v1h-3v-1zM10 13h1v3h-1v-3zM5 0h1v3H5V0zM0 5h3v1H0V5zM12.604 11.896l2.75 2.75-.707.707-2.75-2.75.707-.707zM1.354.646l2.75 2.75-.707.707-2.75-2.75.707-.707z"
});

function SvgUnlink4(props) {
  return /*#__PURE__*/createElement("svg", _extends$nq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nq);
}

function _extends$nr() { _extends$nr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nr.apply(this, arguments); }

var _ref$nr = /*#__PURE__*/createElement("path", {
  d: "M7 12H4c-2.206 0-4-1.794-4-4s1.794-4 4-4h3a1 1 0 010 2H4c-1.103 0-2 .897-2 2s.897 2 2 2h3a1 1 0 010 2zM13 12h-3a1 1 0 010-2h3c1.103 0 2-.897 2-2s-.897-2-2-2h-3a1 1 0 010-2h3c2.206 0 4 1.794 4 4s-1.794 4-4 4zM8.5 3a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM11.5 3a.5.5 0 01-.354-.853l2-2a.5.5 0 01.707.707l-2 2a.498.498 0 01-.354.146zM5.5 3a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l2 2A.5.5 0 015.499 3zM8.5 13a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zM5.5 13a.5.5 0 01.354.853l-2 2a.5.5 0 01-.707-.707l2-2A.498.498 0 015.501 13zM11.5 13c.128 0 .256.049.354.146l2 2a.5.5 0 01-.707.707l-2-2a.5.5 0 01.354-.853z"
});

function SvgUnlink5(props) {
  return /*#__PURE__*/createElement("svg", _extends$nr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$nr);
}

function _extends$ns() { _extends$ns = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ns.apply(this, arguments); }

var _ref$ns = /*#__PURE__*/createElement("path", {
  d: "M12 1c1.654 0 3 1.346 3 3v3h-2V4c0-.551-.449-1-1-1h-2c-.551 0-1 .449-1 1v3h.25c.412 0 .75.338.75.75v7.5c0 .412-.338.75-.75.75H.75a.753.753 0 01-.75-.75v-7.5C0 7.338.338 7 .75 7H7V4c0-1.654 1.346-3 3-3h2z"
});

function SvgUnlocked(props) {
  return /*#__PURE__*/createElement("svg", _extends$ns({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ns);
}

function _extends$nt() { _extends$nt = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nt.apply(this, arguments); }

var _ref$nt = /*#__PURE__*/createElement("path", {
  d: "M12 1h-2C8.346 1 7 2.346 7 4v3H.75a.753.753 0 00-.75.75v7.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-7.5A.753.753 0 009.25 7H9V4c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v3h2V4c0-1.654-1.346-3-3-3zM6 14H4l.435-2.175a1 1 0 111.13 0L6 14z"
});

function SvgUnlocked2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nt);
}

function _extends$nu() { _extends$nu = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nu.apply(this, arguments); }

var _ref$nu = /*#__PURE__*/createElement("path", {
  d: "M7 9h2V5h3L8 1 4 5h3zm3-2.25v1.542L14.579 10 8 12.453 1.421 10 6 8.292V6.75L0 9v4l8 3 8-3V9z"
});

function SvgUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$nu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nu);
}

function _extends$nv() { _extends$nv = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nv.apply(this, arguments); }

var _ref$nv = /*#__PURE__*/createElement("path", {
  d: "M7 3v5h1V3h2.5l-3-3-3 3z"
});

var _ref2$4Q = /*#__PURE__*/createElement("path", {
  d: "M9 4.6v1.077l4.703 1.881L7.5 10.866 1.297 7.558 6 5.677V4.6L0 7v5l7.5 4 7.5-4V7L9 4.6zm-2 10l-6-3.2V8.533l6 3.2V14.6zm7-3.2l-6 3.2v-2.867l6-3.2V11.4z"
});

function SvgUpload10(props) {
  return /*#__PURE__*/createElement("svg", _extends$nv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nv, _ref2$4Q);
}

function _extends$nw() { _extends$nw = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nw.apply(this, arguments); }

var _ref$nw = /*#__PURE__*/createElement("path", {
  d: "M2.5 6L8 .5 13.5 6H10v6H6V6z"
});

var _ref2$4R = /*#__PURE__*/createElement("path", {
  d: "M14 8v6H2V8H0v6.5c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5V8h-2z"
});

function SvgUpload2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nw, _ref2$4R);
}

function _extends$nx() { _extends$nx = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nx.apply(this, arguments); }

var _ref$nx = /*#__PURE__*/createElement("path", {
  d: "M13.5 6L8 .5 2.5 6H6v6h4V6zM.284 15.375h15.432c.056-.078.106-.162.146-.25H.137c.041.088.09.172.146.25zM.903 15.875h14.194c.144-.063.276-.148.392-.25H.511c.116.102.248.187.392.25zM.048 14.875h15.904c.021-.081.035-.165.042-.25H.005c.007.085.021.169.042.25z"
});

var _ref2$4S = /*#__PURE__*/createElement("path", {
  d: "M15.875 14.125V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H1.875V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125h-.25V8h-.25v6.125H0v.25h16v-.25z"
});

function SvgUpload3(props) {
  return /*#__PURE__*/createElement("svg", _extends$nx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nx, _ref2$4S);
}

function _extends$ny() { _extends$ny = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ny.apply(this, arguments); }

var _ref$ny = /*#__PURE__*/createElement("path", {
  d: "M14 11v2H2v-2H0v4h16v-4zM4 7h3v5h2V7h3L8 1z"
});

function SvgUpload4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ny({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ny);
}

function _extends$nz() { _extends$nz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nz.apply(this, arguments); }

var _ref$nz = /*#__PURE__*/createElement("path", {
  d: "M2 12h12v3H2v-3zM6 6v5h4V6h3.5L8 .5 2.5 6z"
});

function SvgUpload5(props) {
  return /*#__PURE__*/createElement("svg", _extends$nz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nz);
}

function _extends$nA() { _extends$nA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nA.apply(this, arguments); }

var _ref$nA = /*#__PURE__*/createElement("path", {
  d: "M3 16h10a3 3 0 003-3H0a3 3 0 003 3zm10-2h1v1h-1v-1zM3.5 5L8 .5 12.5 5H9v3H7V5zm12.481 6.519c.077.264-.089.481-.368.481H.387c-.279 0-.445-.216-.368-.481L1.77 6.481A.714.714 0 012.417 6H6v3h4V6h3.583c.279 0 .57.216.647.481l1.751 5.038z"
});

function SvgUpload6(props) {
  return /*#__PURE__*/createElement("svg", _extends$nA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nA);
}

function _extends$nB() { _extends$nB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nB.apply(this, arguments); }

var _ref$nB = /*#__PURE__*/createElement("path", {
  d: "M0 14h16v1H0zm16-2v1H0v-1l2-4h4v2h4V8h4zM3.5 5L8 .5 12.5 5H9v4H7V5z"
});

function SvgUpload7(props) {
  return /*#__PURE__*/createElement("svg", _extends$nB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nB);
}

function _extends$nC() { _extends$nC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nC.apply(this, arguments); }

var _ref$nC = /*#__PURE__*/createElement("path", {
  d: "M7.5 11H0v4h15v-4H7.5zm6.5 2h-2v-1h2v1zM3.5 5l4-4 4 4H9v5H6V5z"
});

function SvgUpload8(props) {
  return /*#__PURE__*/createElement("svg", _extends$nC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nC);
}

function _extends$nD() { _extends$nD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nD.apply(this, arguments); }

var _ref$nD = /*#__PURE__*/createElement("path", {
  d: "M7 10h2V6h3.5L8 2 3.5 6H7zm3-1.905v.519c2.33.275 4 1.015 4 1.886 0 1.105-2.686 2-6 2s-6-.895-6-2c0-.871 1.67-1.611 4-1.886v-.519C2.55 8.428 0 9.603 0 11c0 1.657 3.582 3 8 3s8-1.343 8-3c0-1.398-2.55-2.572-6-2.905z"
});

function SvgUpload9(props) {
  return /*#__PURE__*/createElement("svg", _extends$nD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nD);
}

function _extends$nE() { _extends$nE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nE.apply(this, arguments); }

var _ref$nE = /*#__PURE__*/createElement("path", {
  d: "M6.5 2a.5.5 0 00-.5.5v1a.5.5 0 001 0v-1a.5.5 0 00-.5-.5zM8.5 2a.5.5 0 00-.5.5v1a.5.5 0 001 0v-1a.5.5 0 00-.5-.5z"
});

var _ref2$4T = /*#__PURE__*/createElement("path", {
  d: "M11.5 5H11V.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5V5h-.5a.5.5 0 00-.5.5v9.375c1 1.5 8 1.5 9 0V5.5a.5.5 0 00-.5-.5zM5 13.5a.5.5 0 01-1 0v-6a.5.5 0 011 0v6zM10 5H5V1h5v4z"
});

function SvgUsbStick(props) {
  return /*#__PURE__*/createElement("svg", _extends$nE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nE, _ref2$4T);
}

function _extends$nF() { _extends$nF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nF.apply(this, arguments); }

var _ref$nF = /*#__PURE__*/createElement("path", {
  d: "M6 11.5a5.508 5.508 0 013.594-5.159A4.574 4.574 0 0010 4.5C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h6.208A5.5 5.5 0 016 11.5z"
});

var _ref2$4U = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM8 11.5a3.5 3.5 0 015.545-2.841L8.66 13.545A3.484 3.484 0 018 11.5zm3.5 3.5a3.49 3.49 0 01-2.045-.659l4.886-4.886A3.5 3.5 0 0111.5 15z"
});

function SvgUserBlock(props) {
  return /*#__PURE__*/createElement("svg", _extends$nF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nF, _ref2$4U);
}

function _extends$nG() { _extends$nG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nG.apply(this, arguments); }

var _ref$nG = /*#__PURE__*/createElement("path", {
  d: "M7.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999c2.119 0 3.874 1.966 3.993 4.476a.5.5 0 11-.999.047C8.9 3.546 7.584 1.998 5.999 1.998c-1.654 0-3 1.682-3 3.75 0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.1 14.998h6.4a.5.5 0 010 1z"
});

var _ref2$4V = /*#__PURE__*/createElement("path", {
  d: "M11.5 7C9.019 7 7 9.019 7 11.5S9.019 16 11.5 16s4.5-2.019 4.5-4.5S13.981 7 11.5 7zM8 11.5C8 9.57 9.57 8 11.5 8c.785 0 1.511.26 2.095.698l-4.897 4.897A3.482 3.482 0 018 11.5zm3.5 3.5c-.785 0-1.511-.26-2.095-.698l4.897-4.897c.438.584.698 1.31.698 2.095 0 1.93-1.57 3.5-3.5 3.5z"
});

function SvgUserBlock2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nG, _ref2$4V);
}

function _extends$nH() { _extends$nH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nH.apply(this, arguments); }

var _ref$nH = /*#__PURE__*/createElement("path", {
  d: "M6 11.5a5.508 5.508 0 013.594-5.159A4.574 4.574 0 0010 4.5C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h6.208A5.5 5.5 0 016 11.5z"
});

var _ref2$4W = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.398 6.102a.561.561 0 11-.796.795L11.5 12.295l-1.602 1.602a.561.561 0 01-.796 0 .561.561 0 010-.795l1.602-1.602-1.602-1.602a.561.561 0 11.795-.795l1.602 1.602 1.602-1.602a.561.561 0 11.795.795L12.294 11.5l1.602 1.602z"
});

function SvgUserCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$nH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nH, _ref2$4W);
}

function _extends$nI() { _extends$nI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nI.apply(this, arguments); }

var _ref$nI = /*#__PURE__*/createElement("path", {
  d: "M7.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999c2.119 0 3.874 1.966 3.993 4.476a.5.5 0 11-.999.047C8.9 3.546 7.584 1.998 5.999 1.998c-1.654 0-3 1.682-3 3.75 0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.1 14.998h6.4a.5.5 0 010 1z"
});

var _ref2$4X = /*#__PURE__*/createElement("path", {
  d: "M11.5 16C9.019 16 7 13.981 7 11.5S9.019 7 11.5 7 16 9.019 16 11.5 13.981 16 11.5 16zm0-8C9.57 8 8 9.57 8 11.5S9.57 15 11.5 15s3.5-1.57 3.5-3.5S13.43 8 11.5 8z"
});

var _ref3$u = /*#__PURE__*/createElement("path", {
  d: "M12.207 11.5l1.646-1.646a.5.5 0 00-.707-.707L11.5 10.793 9.854 9.147a.5.5 0 00-.707.707l1.646 1.646-1.646 1.646a.5.5 0 00.708.707l1.646-1.646 1.646 1.646a.498.498 0 00.708 0 .5.5 0 000-.707L12.209 11.5z"
});

function SvgUserCancel2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nI, _ref2$4X, _ref3$u);
}

function _extends$nJ() { _extends$nJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nJ.apply(this, arguments); }

var _ref$nJ = /*#__PURE__*/createElement("path", {
  d: "M15 9.5L10.5 14 9 12.5l-1 1 2.5 2.5 5.5-5.5z"
});

var _ref2$4Y = /*#__PURE__*/createElement("path", {
  d: "M7 12h5v-1.799c-1.05-.613-2.442-1.033-4-1.16v-.825c1.102-.621 2-2.168 2-3.716C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h7v-1z"
});

function SvgUserCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$nJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nJ, _ref2$4Y);
}

function _extends$nK() { _extends$nK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nK.apply(this, arguments); }

var _ref$nK = /*#__PURE__*/createElement("path", {
  d: "M6.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999s2.103.507 2.861 1.427C9.596 3.318 10 4.498 10 5.749c0 .901-.213 1.777-.615 2.535A4.41 4.41 0 018 9.866v.634a.5.5 0 01-1 0v-.909c0-.179.095-.344.25-.433C8.313 8.545 9 7.207 9 5.75 9 3.682 7.654 2 6 2S3 3.682 3 5.75c0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.101 15h5.4a.5.5 0 010 1z"
});

var _ref2$4Z = /*#__PURE__*/createElement("path", {
  d: "M10 16a.502.502 0 01-.354-.146l-2-2a.5.5 0 01.707-.707l1.646 1.646 4.646-4.646a.5.5 0 01.707.707l-5 5a.498.498 0 01-.354.146z"
});

function SvgUserCheck2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nK, _ref2$4Z);
}

function _extends$nL() { _extends$nL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nL.apply(this, arguments); }

var _ref$nL = /*#__PURE__*/createElement("path", {
  d: "M15.25 11H15v-1c0-1.103-.897-2-2-2s-2 .897-2 2v1h-.25a.753.753 0 00-.75.75v3.5c0 .412.338.75.75.75h4.5c.412 0 .75-.338.75-.75v-3.5a.753.753 0 00-.75-.75zM12 10c0-.551.449-1 1-1s1 .449 1 1v1h-2v-1zM9 9.166a11.668 11.668 0 00-1-.125v-.825c1.102-.621 2-2.168 2-3.716C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h9V9.166z"
});

function SvgUserLock(props) {
  return /*#__PURE__*/createElement("svg", _extends$nL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nL);
}

function _extends$nM() { _extends$nM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nM.apply(this, arguments); }

var _ref$nM = /*#__PURE__*/createElement("path", {
  d: "M7.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999s2.103.507 2.861 1.427C9.596 3.318 10 4.498 10 5.749c0 .276-.02.553-.06.823a.5.5 0 01-.989-.145c.033-.222.049-.45.049-.677C9 3.682 7.654 2 6 2S3 3.682 3 5.75c0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.101 15h6.4a.5.5 0 010 1z"
});

var _ref2$4_ = /*#__PURE__*/createElement("path", {
  d: "M15.5 10H15v-.5C15 8.121 13.879 7 12.5 7S10 8.121 10 9.5v.5h-.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zM11 9.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v.5h-3v-.5zm4 5.5h-5v-4h5v4z"
});

var _ref3$v = /*#__PURE__*/createElement("path", {
  d: "M12.5 14a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z"
});

function SvgUserLock2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nM, _ref2$4_, _ref3$v);
}

function _extends$nN() { _extends$nN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nN.apply(this, arguments); }

var _ref$nN = /*#__PURE__*/createElement("path", {
  d: "M6 11.5a5.508 5.508 0 013.594-5.159A4.574 4.574 0 0010 4.5C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h6.208A5.5 5.5 0 016 11.5z"
});

var _ref2$4$ = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.5 5H9v-1h5v1z"
});

function SvgUserMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$nN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nN, _ref2$4$);
}

function _extends$nO() { _extends$nO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nO.apply(this, arguments); }

var _ref$nO = /*#__PURE__*/createElement("path", {
  d: "M7.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999c2.119 0 3.874 1.966 3.993 4.476a.5.5 0 11-.999.047C8.9 3.546 7.584 1.998 5.999 1.998c-1.654 0-3 1.682-3 3.75 0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.1 14.998h6.4a.5.5 0 010 1z"
});

var _ref2$50 = /*#__PURE__*/createElement("path", {
  d: "M11.5 16C9.019 16 7 13.981 7 11.5S9.019 7 11.5 7 16 9.019 16 11.5 13.981 16 11.5 16zm0-8C9.57 8 8 9.57 8 11.5S9.57 15 11.5 15s3.5-1.57 3.5-3.5S13.43 8 11.5 8z"
});

var _ref3$w = /*#__PURE__*/createElement("path", {
  d: "M13.5 11h-4a.5.5 0 000 1h4a.5.5 0 000-1z"
});

function SvgUserMinus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nO, _ref2$50, _ref3$w);
}

function _extends$nP() { _extends$nP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nP.apply(this, arguments); }

var _ref$nP = /*#__PURE__*/createElement("path", {
  d: "M6 11.5a5.508 5.508 0 013.594-5.159A4.574 4.574 0 0010 4.5C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h6.208A5.5 5.5 0 016 11.5z"
});

var _ref2$51 = /*#__PURE__*/createElement("path", {
  d: "M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.5 5h-2v2h-1v-2H9v-1h2V9h1v2h2v1z"
});

function SvgUserPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$nP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nP, _ref2$51);
}

function _extends$nQ() { _extends$nQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nQ.apply(this, arguments); }

var _ref$nQ = /*#__PURE__*/createElement("path", {
  d: "M7.5 16H.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 014 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 012 5.749c0-1.251.405-2.431 1.139-3.323C3.897 1.506 4.913.999 6 .999c2.119 0 3.874 1.966 3.993 4.476a.5.5 0 11-.999.047C8.9 3.546 7.584 1.998 5.999 1.998c-1.654 0-3 1.682-3 3.75 0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.952 4.952 0 001.1 14.998h6.4a.5.5 0 010 1z"
});

var _ref2$52 = /*#__PURE__*/createElement("path", {
  d: "M11.5 16C9.019 16 7 13.981 7 11.5S9.019 7 11.5 7 16 9.019 16 11.5 13.981 16 11.5 16zm0-8C9.57 8 8 9.57 8 11.5S9.57 15 11.5 15s3.5-1.57 3.5-3.5S13.43 8 11.5 8z"
});

var _ref3$x = /*#__PURE__*/createElement("path", {
  d: "M13.5 11H12V9.5a.5.5 0 00-1 0V11H9.5a.5.5 0 000 1H11v1.5a.5.5 0 001 0V12h1.5a.5.5 0 000-1z"
});

function SvgUserPlus2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nQ, _ref2$52, _ref3$x);
}

function _extends$nR() { _extends$nR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nR.apply(this, arguments); }

var _ref$nR = /*#__PURE__*/createElement("path", {
  d: "M5 3a3 3 0 116 0 3 3 0 01-6 0zm7.001 4h-.553l-3.111 6.316L9.5 7.5 8 6 6.5 7.5l1.163 5.816L4.552 7h-.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"
});

function SvgUserTie(props) {
  return /*#__PURE__*/createElement("svg", _extends$nR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nR);
}

function _extends$nS() { _extends$nS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nS.apply(this, arguments); }

var _ref$nS = /*#__PURE__*/createElement("path", {
  d: "M9 11.041v-.825c1.102-.621 2-2.168 2-3.716C11 4.015 11 2 8 2S5 4.015 5 6.5c0 1.548.898 3.095 2 3.716v.825c-3.392.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
});

function SvgUser(props) {
  return /*#__PURE__*/createElement("svg", _extends$nS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nS);
}

function _extends$nT() { _extends$nT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nT.apply(this, arguments); }

var _ref$nT = /*#__PURE__*/createElement("path", {
  d: "M13.477 16H2.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 016 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 014 5.749c0-1.251.405-2.431 1.139-3.323C5.897 1.506 6.913.999 8 .999s2.103.507 2.861 1.427C11.596 3.318 12 4.498 12 5.749c0 .901-.213 1.777-.615 2.535A4.41 4.41 0 0110 9.866v.475a5.982 5.982 0 012.602 1.809 5.96 5.96 0 011.373 3.305.504.504 0 01-.498.545zM3.1 15h9.8a4.978 4.978 0 00-1.064-2.208 4.98 4.98 0 00-2.471-1.604.5.5 0 01-.364-.481V9.591c0-.179.095-.344.25-.433 1.063-.613 1.75-1.951 1.75-3.408 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.958 4.958 0 003.102 15z"
});

function SvgUser2(props) {
  return /*#__PURE__*/createElement("svg", _extends$nT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nT);
}

function _extends$nU() { _extends$nU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nU.apply(this, arguments); }

var _ref$nU = /*#__PURE__*/createElement("path", {
  d: "M4 5a4 4 0 118 0 4 4 0 01-8 0zm8 5H4a4 4 0 00-4 4v1h16v-1a4 4 0 00-4-4z"
});

function SvgUser3(props) {
  return /*#__PURE__*/createElement("svg", _extends$nU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nU);
}

function _extends$nV() { _extends$nV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nV.apply(this, arguments); }

var _ref$nV = /*#__PURE__*/createElement("path", {
  d: "M8 2c1.654 0 3 1.346 3 3S9.654 8 8 8 5 6.654 5 5s1.346-3 3-3zm0-1a4 4 0 100 8 4 4 0 000-8zm4 10c1.654 0 3 1.346 3 3H1c0-1.654 1.346-3 3-3h8zm0-1H4a4 4 0 00-4 4v1h16v-1a4 4 0 00-4-4z"
});

function SvgUser4(props) {
  return /*#__PURE__*/createElement("svg", _extends$nV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nV);
}

function _extends$nW() { _extends$nW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nW.apply(this, arguments); }

var _ref$nW = /*#__PURE__*/createElement("path", {
  d: "M8 9a4 4 0 100-8 4 4 0 000 8zM5 5c0-.042.001-.084.003-.125h5.994a2.576 2.576 0 010 .25H5.003A2.576 2.576 0 015 5zm.884-2.125h4.231c.079.079.154.163.225.25H5.66c.07-.087.145-.171.224-.25zm.285-.25c.12-.092.247-.176.38-.25h2.902c.133.074.26.158.38.25H6.17zm4.352.75c.052.081.101.164.145.25H5.334c.044-.086.093-.169.145-.25h5.041zm.26.5c.033.082.063.165.089.25H5.131a3.09 3.09 0 01.089-.25h5.562zm.153.5c.018.082.032.166.042.25H5.023a3.43 3.43 0 01.042-.25h5.869zm.043 1a3.43 3.43 0 01-.042.25H5.066a2.607 2.607 0 01-.042-.25h5.953zm-.107.5a3.09 3.09 0 01-.089.25H5.219a3.09 3.09 0 01-.089-.25h5.739zm-.204.5a2.955 2.955 0 01-.145.25H5.48a2.955 2.955 0 01-.145-.25h5.332zm-.55.75H5.885a3.121 3.121 0 01-.224-.25h4.68c-.07.087-.145.171-.225.25zm-.285.25a3 3 0 01-.38.25H6.549a3 3 0 01-.38-.25H9.83zm-2.688.5h1.714a2.995 2.995 0 01-1.714 0zm1.714-5.75H7.143a2.995 2.995 0 011.714 0zM12 10H4a4 4 0 00-4 4v1h16v-1a4 4 0 00-4-4zM1.884 11.875h12.231c.079.079.154.163.225.25H1.66c.07-.087.145-.171.224-.25zm.285-.25c.12-.092.247-.176.38-.25h10.902c.133.074.26.158.38.25H2.17zm12.352.75c.052.081.101.164.145.25H1.334c.044-.086.093-.169.145-.25H14.52zm.26.5c.033.082.063.165.089.25H1.131a3.09 3.09 0 01.089-.25h13.562zm.153.5c.018.082.032.166.042.25H1.023a3.43 3.43 0 01.042-.25h13.869zM12 11c.298 0 .585.044.857.125H3.143C3.415 11.044 3.702 11 4 11h8zM1 14c0-.042.001-.084.003-.125h13.994c.002.041.003.083.003.125H1z"
});

function SvgUser5(props) {
  return /*#__PURE__*/createElement("svg", _extends$nW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nW);
}

function _extends$nX() { _extends$nX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nX.apply(this, arguments); }

var _ref$nX = /*#__PURE__*/createElement("path", {
  d: "M11.5 5.5C11.5 7.985 9.933 10 8 10S4.5 7.985 4.5 5.5 6.067 1 8 1s3.5 2.015 3.5 4.5z"
});

var _ref2$53 = /*#__PURE__*/createElement("path", {
  d: "M7 8.922h2V11H7V8.922z"
});

var _ref3$y = /*#__PURE__*/createElement("path", {
  d: "M1 12c0-1.105 3.134-2 7-2s7 .895 7 2zM1 12h14v2H1v-2z"
});

function SvgUser6(props) {
  return /*#__PURE__*/createElement("svg", _extends$nX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nX, _ref2$53, _ref3$y);
}

function _extends$nY() { _extends$nY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nY.apply(this, arguments); }

var _ref$nY = /*#__PURE__*/createElement("path", {
  d: "M5 4a3 3 0 116 0 3 3 0 01-6 0zm3 4c-3.314 0-6 3.134-6 7h2c0-2.761 1.791-5 4-5s4 2.239 4 5h2c0-3.866-2.686-7-6-7z"
});

function SvgUser7(props) {
  return /*#__PURE__*/createElement("svg", _extends$nY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$nY);
}

function _extends$nZ() { _extends$nZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$nZ.apply(this, arguments); }

var _ref$nZ = /*#__PURE__*/createElement("path", {
  d: "M12 12.041v-.825c1.102-.621 2-2.168 2-3.716C14 5.015 14 3 11 3S8 5.015 8 7.5c0 1.548.898 3.095 2 3.716v.825c-3.392.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
});

var _ref2$54 = /*#__PURE__*/createElement("path", {
  d: "M5.112 12.427c.864-.565 1.939-.994 3.122-1.256a5.667 5.667 0 01-.633-.922 5.726 5.726 0 01-.726-2.748c0-1.344 0-2.614.478-3.653.464-1.008 1.299-1.633 2.488-1.867C9.577.786 8.873.001 7 .001c-3 0-3 2.015-3 4.5 0 1.548.898 3.095 2 3.716v.825c-3.392.277-6 1.944-6 3.959h4.359c.227-.202.478-.393.753-.573z"
});

function SvgUsers(props) {
  return /*#__PURE__*/createElement("svg", _extends$nZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$nZ, _ref2$54);
}

function _extends$n_() { _extends$n_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n_.apply(this, arguments); }

var _ref$n_ = /*#__PURE__*/createElement("path", {
  d: "M12 12.041v-.825c1.101-.621 2-2.168 2-3.716C14 5.015 14 3 11 3S8 5.015 8 7.5c0 1.548.898 3.095 2 3.716v.825c-3.392.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
});

var _ref2$55 = /*#__PURE__*/createElement("path", {
  d: "M3.242 9.625a8.282 8.282 0 00-.611.25h4.782a6.098 6.098 0 01-.109-.25H3.242zM.425 11.625a2.732 2.732 0 00-.144.25h5.834c.192-.089.389-.172.593-.25H.424zM1.367 10.625a4.941 4.941 0 00-.299.25h6.933a5.555 5.555 0 01-.174-.25H1.366zM5.261 9.125c-.424.062-.833.146-1.222.25h3.17a5.627 5.627 0 01-.083-.25H5.262zM6 8.625v.25h1.054a5.335 5.335 0 01-.059-.25H6zM5.851 8.125c.049.032.099.063.149.091v.159h.947a5.363 5.363 0 01-.035-.25H5.85zM.03 12.625a2.616 2.616 0 00-.027.25h4.501c.102-.085.209-.169.321-.25H.03zM1.719 10.375h5.955a14.405 14.405 0 01-.072-.127l-.066-.123H2.134a6.16 6.16 0 00-.415.25zM4.005 3.625c-.002.083-.003.166-.003.25h3.339l.012-.028c.035-.076.073-.15.112-.222h-3.46zM.168 12.125c-.032.082-.06.166-.083.25h5.109c.136-.087.277-.17.423-.25H.168zM4.643.875h4.713a1.97 1.97 0 00-.234-.25H4.877a1.97 1.97 0 00-.234.25zM.602 11.375h6.845c.256-.076.519-.145.787-.204l-.038-.046H.815a3.764 3.764 0 00-.213.25zM5.255 7.625c.085.089.173.173.263.25h1.371a5.227 5.227 0 01-.012-.25H5.255zM4.848 7.125c.06.086.123.17.188.25h1.84v-.25H4.849zM4.255 1.625c-.027.081-.05.164-.072.25h5.632a3.157 3.157 0 00-.072-.25H4.254zM4.13 2.125a6.209 6.209 0 00-.041.25h4.625c.179-.098.372-.181.578-.25H4.13zM4.022 3.125a10.04 10.04 0 00-.01.25h3.605c.058-.087.12-.17.185-.25h-3.78zM4.059 2.625a9.309 9.309 0 00-.022.25h3.995a3.03 3.03 0 01.292-.25H4.059zM5.866.125a2.572 2.572 0 00-.638.25h3.544a2.596 2.596 0 00-.639-.25H5.867zM4.544 6.625c.045.085.092.169.141.25h2.192l.003-.25H4.544zM4.475 1.125c-.046.08-.088.163-.125.25h5.3a2.331 2.331 0 00-.125-.25h-5.05zM4.152 5.625c.022.084.048.167.074.25h2.683c.005-.084.012-.167.019-.25H4.151zM4.316 6.125c.033.085.068.168.105.25h2.464l.009-.25H4.315zM4 4.125v.25h3.155c.025-.085.053-.168.084-.25H4.001zM4.002 4.625c.003.083.008.167.016.25h3.014c.016-.084.035-.168.055-.25H4.002zM4.048 5.125c.013.084.027.167.045.25h2.862c.01-.084.021-.167.034-.25H4.048z"
});

function SvgUsers2(props) {
  return /*#__PURE__*/createElement("svg", _extends$n_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$n_, _ref2$55);
}

function _extends$n$() { _extends$n$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n$.apply(this, arguments); }

var _ref$n$ = /*#__PURE__*/createElement("path", {
  d: "M15.477 16H4.523a.5.5 0 01-.498-.545 5.964 5.964 0 011.373-3.305A5.982 5.982 0 018 10.341v-.475a4.402 4.402 0 01-1.385-1.582A5.423 5.423 0 016 5.749c0-1.251.405-2.431 1.139-3.323C7.897 1.506 8.913.999 10 .999s2.103.507 2.861 1.427C13.596 3.318 14 4.498 14 5.749c0 .901-.213 1.777-.615 2.535A4.41 4.41 0 0112 9.866v.475a5.982 5.982 0 012.602 1.809 5.96 5.96 0 011.373 3.305.504.504 0 01-.498.545zM5.1 15h9.8a4.978 4.978 0 00-1.064-2.208 4.98 4.98 0 00-2.471-1.604.5.5 0 01-.364-.481V9.591c0-.179.095-.344.25-.433 1.063-.613 1.75-1.951 1.75-3.408 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457.687 2.795 1.75 3.408.155.089.25.254.25.433v1.116a.5.5 0 01-.364.481 4.98 4.98 0 00-2.471 1.604A4.958 4.958 0 005.102 15z"
});

var _ref2$56 = /*#__PURE__*/createElement("path", {
  d: "M4.535 11.428A7.157 7.157 0 016.349 9.88a5.774 5.774 0 01-.727-1.068 6.548 6.548 0 01-.746-3.063c0-1.511.496-2.945 1.396-4.038A5.221 5.221 0 017.741.467a3.484 3.484 0 00-1.74-.468c-1.087 0-2.103.507-2.861 1.427-.735.892-1.139 2.072-1.139 3.323 0 .901.213 1.778.615 2.535a4.41 4.41 0 001.385 1.582v.475a5.982 5.982 0 00-2.602 1.809 5.96 5.96 0 00-1.373 3.305.504.504 0 00.498.545h2.423a7.078 7.078 0 011.59-3.572z"
});

function SvgUsers3(props) {
  return /*#__PURE__*/createElement("svg", _extends$n$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$n$, _ref2$56);
}

function _extends$o0() { _extends$o0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o0.apply(this, arguments); }

var _ref$o0 = /*#__PURE__*/createElement("path", {
  d: "M12 11.02v-.207c1.446-.553 2.5-2.275 2.5-4.313C14.5 4.015 12.933 2 11 2S7.5 4.015 7.5 6.5c0 2.038 1.054 3.76 2.5 4.313v.207c-3.392.139-6 .972-6 1.98v2h14v-2c0-1.008-2.608-1.841-6-1.98z"
});

var _ref2$57 = /*#__PURE__*/createElement("path", {
  d: "M18 7.009V6.93c1.141-.324 2-1.737 2-3.43C20 1.567 18.881 0 17.5 0S15 1.567 15 3.5c0 1.693.859 3.106 2 3.43v.079c-.497.018-.97.064-1.404.131-.098 1.066-.439 2.051-.965 2.859H22v-1.5c0-.772-1.75-1.408-4-1.491zM6.404 7.141A11.932 11.932 0 005 7.01v-.079c1.141-.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5S2 1.568 2 3.501c0 1.693.859 3.106 2 3.43v.079c-2.25.083-4 .719-4 1.491v1.5h7.369c-.526-.809-.867-1.794-.965-2.859z"
});

function SvgUsers4(props) {
  return /*#__PURE__*/createElement("svg", _extends$o0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _ref$o0, _ref2$57);
}

function _extends$o1() { _extends$o1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o1.apply(this, arguments); }

var _ref$o1 = /*#__PURE__*/createElement("path", {
  d: "M3 6a2 2 0 113.999-.001A2 2 0 013 6zm6-3a2 2 0 113.999-.001A2 2 0 019 3zM5 9c-2.761 0-5 2.686-5 6h1.5c0-.64.103-1.258.308-1.837a4.678 4.678 0 01.809-1.446c.654-.785 1.501-1.218 2.383-1.218s1.729.432 2.383 1.218c.345.414.617.9.809 1.446.204.579.308 1.197.308 1.837H10c0-3.314-2.239-6-5-6zm6-3c-1.472 0-2.794.763-3.709 1.977a6.289 6.289 0 011.305.767l.022-.027c.654-.785 1.501-1.218 2.383-1.218s1.729.432 2.383 1.218c.345.414.617.9.809 1.446.204.579.308 1.197.308 1.837h1.5c0-3.314-2.239-6-5-6z"
});

function SvgUsers5(props) {
  return /*#__PURE__*/createElement("svg", _extends$o1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o1);
}

function _extends$o2() { _extends$o2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o2.apply(this, arguments); }

var _ref$o2 = /*#__PURE__*/createElement("path", {
  d: "M14 3H2C.9 3 0 3.9 0 5v7c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM2 12c0-2.209 1.119-4 2.5-4a1.5 1.5 0 11.001-3.001A1.5 1.5 0 014.5 8C5.881 8 7 9.791 7 12H2zm12 0H9v-1h5v1zm0-2H9V9h5v1zm0-2H9V7h5v1z"
});

function SvgVcard(props) {
  return /*#__PURE__*/createElement("svg", _extends$o2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o2);
}

function _extends$o3() { _extends$o3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o3.apply(this, arguments); }

var _ref$o3 = /*#__PURE__*/createElement("path", {
  d: "M5 5v2.339A13.94 13.94 0 002 16h1a12.93 12.93 0 012.751-8H8V5.751a12.91 12.91 0 012.94-1.73A12.909 12.909 0 0116 3V2a13.94 13.94 0 00-8.661 3H5zm0 10h2v1H5v-1zm4 0h2v1H9v-1zm6-2v2h-2v1h3v-3h-1zm0-8h1v2h-1V5zm0 4h1v2h-1V9z"
});

var _ref2$58 = /*#__PURE__*/createElement("path", {
  d: "M1 5a1 1 0 000 2v9h1V6a1 1 0 00-1-1zM7 1a1 1 0 10-1 1h10V1H7z"
});

function SvgVector(props) {
  return /*#__PURE__*/createElement("svg", _extends$o3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o3, _ref2$58);
}

function _extends$o4() { _extends$o4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o4.apply(this, arguments); }

var _ref$o4 = /*#__PURE__*/createElement("path", {
  d: "M11.635 8c.44-.275.825-.606 1.153-.993.824-.972 1.126-2.108 1.223-3.007H15V1h-3v3h1.001c-.092.731-.346 1.622-.981 2.367-.683.803-1.696 1.312-3.02 1.522V7H6v1H2a1 1 0 00-2 0v1h3.365c-.44.275-.825.606-1.153.993-.824.972-1.127 2.108-1.223 3.007H0v3h3v-3H1.999c.092-.731.346-1.622.981-2.367C3.663 9.83 4.676 9.321 6 9.111V10h3V9h5a1 1 0 002 0V8h-4.365zM13 3V2h1v1h-1zM2 14v1H1v-1h1zm6-5H7V8h1v1z"
});

function SvgVector2(props) {
  return /*#__PURE__*/createElement("svg", _extends$o4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o4);
}

function _extends$o5() { _extends$o5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o5.apply(this, arguments); }

var _ref$o5 = /*#__PURE__*/createElement("path", {
  d: "M1.5 3C.675 3 0 3.675 0 4.5v7c0 .361.13.694.344.954L6.646 3H1.499zM15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-.265L11.624.915 10.376.083l-10 15 1.248.832 1.944-2.916H10.5c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788z"
});

function SvgVideoCameraSlash(props) {
  return /*#__PURE__*/createElement("svg", _extends$o5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o5);
}

function _extends$o6() { _extends$o6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o6.apply(this, arguments); }

var _ref$o6 = /*#__PURE__*/createElement("path", {
  d: "M15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-.213L11.904.795a.5.5 0 00-.806-.592l-2.05 2.796H1.501c-.825 0-1.5.675-1.5 1.5v7c0 .825.675 1.5 1.5 1.5h.213L.097 15.203a.5.5 0 00.806.592l2.05-2.796H10.5c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788zM1.5 12a.507.507 0 01-.5-.5v-7c0-.271.229-.5.5-.5h6.813l-5.867 8h-.947zM15 10.743L12.531 9H11v2.5c0 .271-.229.5-.5.5H3.687l5.867-8h.947c.271 0 .5.229.5.5V7h1.531l2.469-1.743v5.486z"
});

function SvgVideoCameraSlash2(props) {
  return /*#__PURE__*/createElement("svg", _extends$o6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o6);
}

function _extends$o7() { _extends$o7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o7.apply(this, arguments); }

var _ref$o7 = /*#__PURE__*/createElement("path", {
  d: "M6 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm-6 0a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm12 5V8c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1.5l4 2.5V7l-4 2.5zM10 12H2V9h8v3z"
});

function SvgVideoCamera(props) {
  return /*#__PURE__*/createElement("svg", _extends$o7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o7);
}

function _extends$o8() { _extends$o8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o8.apply(this, arguments); }

var _ref$o8 = /*#__PURE__*/createElement("path", {
  d: "M15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-9c-.825 0-1.5.675-1.5 1.5v7c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788z"
});

function SvgVideoCamera2(props) {
  return /*#__PURE__*/createElement("svg", _extends$o8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o8);
}

function _extends$o9() { _extends$o9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o9.apply(this, arguments); }

var _ref$o9 = /*#__PURE__*/createElement("path", {
  d: "M15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-9c-.825 0-1.5.675-1.5 1.5v7c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788zM4 11V5l5 3-5 3z"
});

function SvgVideoCamera3(props) {
  return /*#__PURE__*/createElement("svg", _extends$o9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o9);
}

function _extends$oa() { _extends$oa = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oa.apply(this, arguments); }

var _ref$oa = /*#__PURE__*/createElement("path", {
  d: "M15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-9c-.825 0-1.5.675-1.5 1.5v7c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788zM15 10.743L12.531 9H11v2.5c0 .271-.229.5-.5.5h-9a.507.507 0 01-.5-.5v-7c0-.271.229-.5.5-.5h9c.271 0 .5.229.5.5V7h1.531L15 5.257v5.486z"
});

function SvgVideoCamera4(props) {
  return /*#__PURE__*/createElement("svg", _extends$oa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oa);
}

function _extends$ob() { _extends$ob = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ob.apply(this, arguments); }

var _ref$ob = /*#__PURE__*/createElement("path", {
  d: "M15.294 4.004a.858.858 0 00-.491.168L12 6.15V4.499c0-.825-.675-1.5-1.5-1.5h-9c-.825 0-1.5.675-1.5 1.5v7c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-1.65l2.803 1.978c.156.11.326.168.491.168.22 0 .421-.101.551-.278a.85.85 0 00.154-.51V4.792c0-.518-.355-.788-.706-.788zM15 10.743L12.531 9H11v2.5c0 .271-.229.5-.5.5h-9a.507.507 0 01-.5-.5v-7c0-.271.229-.5.5-.5h9c.271 0 .5.229.5.5V7h1.531L15 5.257v5.486z"
});

var _ref2$59 = /*#__PURE__*/createElement("path", {
  d: "M4 5l5 3-5 3z"
});

function SvgVideoCamera5(props) {
  return /*#__PURE__*/createElement("svg", _extends$ob({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ob, _ref2$59);
}

function _extends$oc() { _extends$oc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oc.apply(this, arguments); }

var _ref$oc = /*#__PURE__*/createElement("path", {
  d: "M15.994 4.281c-.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-.931 0-1.722-.859-2.366-2.581-.431-1.578-.859-3.156-1.291-4.734-.478-1.722-.991-2.581-1.541-2.581-.119 0-.538.253-1.256.753l-.753-.969c.791-.694 1.569-1.388 2.334-2.081 1.053-.909 1.844-1.387 2.372-1.438 1.244-.119 2.013.731 2.3 2.553.309 1.966.525 3.188.647 3.666.359 1.631.753 2.447 1.184 2.447.334 0 .838-.528 1.509-1.588.669-1.056 1.028-1.862 1.078-2.416.097-.912-.262-1.372-1.078-1.372a2.98 2.98 0 00-1.184.263c.787-2.575 2.287-3.825 4.506-3.753 1.641.044 2.416 1.109 2.322 3.194z"
});

function SvgVimeo(props) {
  return /*#__PURE__*/createElement("svg", _extends$oc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oc);
}

function _extends$od() { _extends$od = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$od.apply(this, arguments); }

var _ref$od = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-1.037 5.313c-.05 1.125-.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-.675 0-1.244-.622-1.709-1.866-.313-1.141-.622-2.281-.934-3.422-.344-1.244-.716-1.866-1.112-1.866-.087 0-.391.181-.906.544l-.544-.7c.572-.5 1.134-1.003 1.687-1.503.763-.656 1.331-1.003 1.712-1.038.9-.087 1.453.528 1.662 1.844.225 1.422.381 2.303.469 2.65.259 1.178.544 1.766.856 1.766.241 0 .606-.381 1.091-1.147s.744-1.347.778-1.747c.069-.659-.191-.991-.778-.991-.278 0-.563.063-.856.191.569-1.859 1.653-2.766 3.256-2.712 1.188.034 1.747.803 1.678 2.309z"
});

function SvgVimeo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$od({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$od);
}

function _extends$oe() { _extends$oe = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oe.apply(this, arguments); }

var _ref$oe = /*#__PURE__*/createElement("path", {
  d: "M15.012 7.953a5.297 5.297 0 01-1.169.137c-2.019 0-3.572-1.409-3.572-3.862 0-1.203.466-1.825 1.122-1.825.625 0 1.041.559 1.041 1.697 0 .647-.172 1.356-.3 1.775 0 0 .622 1.084 2.322.753.363-.803.556-1.841.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016H.987c1.259 9.675 5.006 12.756 6 13.347.559.337 1.044.322 1.556.031.806-.456 3.222-2.875 4.563-5.703.563 0 1.238-.066 1.909-.219V7.953z"
});

function SvgVine(props) {
  return /*#__PURE__*/createElement("svg", _extends$oe({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oe);
}

function _extends$of() { _extends$of = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$of.apply(this, arguments); }

var _ref$of = /*#__PURE__*/createElement("path", {
  d: "M43.5 19.5c-1.3 0-2.5.6-3.4 1.5h-8.9l6.3-6.3c1.2.1 2.5-.4 3.4-1.3 1.8-1.8 1.8-4.6 0-6.4s-4.6-1.8-6.4 0c-.9.9-1.4 2.2-1.3 3.4L27 16.8V7.9c.9-.8 1.5-2 1.5-3.4C28.5 2 26.5 0 24 0s-4.5 2-4.5 4.5c0 1.3.6 2.5 1.5 3.4v8.9l-6.3-6.3c.1-1.3-.4-2.5-1.3-3.5C11.6 5.3 8.8 5.3 7 7s-1.8 4.6 0 6.4c.9.9 2.2 1.4 3.4 1.3l6.3 6.3H7.9c-.8-.9-2-1.5-3.4-1.5C2 19.5 0 21.5 0 24s2 4.5 4.5 4.5c1.3 0 2.5-.6 3.4-1.5h8.9l-6.3 6.3c-1.3-.1-2.5.4-3.5 1.3-1.8 1.8-1.8 4.6 0 6.4s4.6 1.8 6.4 0c.9-.9 1.4-2.2 1.3-3.4l6.3-6.3v8.9c-.9.8-1.5 2-1.5 3.4 0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5c0-1.3-.6-2.5-1.5-3.4v-8.9l6.3 6.3c-.1 1.2.4 2.5 1.3 3.4 1.8 1.8 4.6 1.8 6.4 0s1.8-4.6 0-6.4c-.9-.9-2.2-1.4-3.4-1.3L31.2 27h8.9c.8.9 2 1.5 3.4 1.5 2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5z"
});

function SvgVirus(props) {
  return /*#__PURE__*/createElement("svg", _extends$of({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _ref$of);
}

function _extends$og() { _extends$og = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$og.apply(this, arguments); }

var _ref$og = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-1.541 11.2l-1.463.022s-.316.063-.728-.222c-.547-.375-1.063-1.353-1.466-1.225-.406.128-.394 1.006-.394 1.006s.003.188-.091.287c-.1.109-.3.131-.3.131h-.653s-1.444.088-2.716-1.238C3.76 8.517 2.536 5.652 2.536 5.652s-.072-.188.006-.278c.087-.103.322-.109.322-.109l1.566-.009s.147.025.253.103c.088.063.134.184.134.184s.253.641.588 1.219c.653 1.128.959 1.375 1.181 1.256.322-.175.225-1.597.225-1.597s.006-.516-.162-.744c-.131-.178-.378-.231-.484-.244-.088-.013.056-.216.244-.309.281-.138.778-.147 1.366-.141.456.003.591.034.769.075.541.131.356.634.356 1.841 0 .388-.069.931.209 1.109.119.078.412.012 1.147-1.234.347-.591.609-1.284.609-1.284s.056-.125.144-.178c.091-.053.213-.037.213-.037l1.647-.009s.494-.059.575.166c.084.234-.184.781-.856 1.678-1.103 1.472-1.228 1.334-.309 2.184.875.813 1.056 1.209 1.088 1.259.356.6-.406.647-.406.647z"
});

function SvgVk(props) {
  return /*#__PURE__*/createElement("svg", _extends$og({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$og);
}

function _extends$oh() { _extends$oh = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oh.apply(this, arguments); }

var _ref$oh = /*#__PURE__*/createElement("path", {
  d: "M0 5h3l5-5v16l-5-5H0V5z"
});

function SvgVolume0(props) {
  return /*#__PURE__*/createElement("svg", _extends$oh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oh);
}

function _extends$oi() { _extends$oi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oi.apply(this, arguments); }

var _ref$oi = /*#__PURE__*/createElement("path", {
  d: "M9 13h7v2H9zM0 5v6h3l5 5V0L3 5z"
});

function SvgVolume1(props) {
  return /*#__PURE__*/createElement("svg", _extends$oi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oi);
}

function _extends$oj() { _extends$oj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oj.apply(this, arguments); }

var _ref$oj = /*#__PURE__*/createElement("path", {
  d: "M9 10h7v2H9zm0 3h7v2H9zM0 5v6h3l5 5V0L3 5z"
});

function SvgVolume2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oj);
}

function _extends$ok() { _extends$ok = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ok.apply(this, arguments); }

var _ref$ok = /*#__PURE__*/createElement("path", {
  d: "M9 7h7v2H9zm0 3h7v2H9zm0 3h7v2H9zM0 5v6h3l5 5V0L3 5z"
});

function SvgVolume3(props) {
  return /*#__PURE__*/createElement("svg", _extends$ok({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ok);
}

function _extends$ol() { _extends$ol = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ol.apply(this, arguments); }

var _ref$ol = /*#__PURE__*/createElement("path", {
  d: "M9 4h7v2H9zm0 3h7v2H9zm0 3h7v2H9zm0 3h7v2H9zM0 5v6h3l5 5V0L3 5z"
});

function SvgVolume4(props) {
  return /*#__PURE__*/createElement("svg", _extends$ol({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ol);
}

function _extends$om() { _extends$om = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$om.apply(this, arguments); }

var _ref$om = /*#__PURE__*/createElement("path", {
  d: "M9 1h7v2H9zm0 3h7v2H9zm0 3h7v2H9zm0 3h7v2H9zm0 3h7v2H9zM0 5v6h3l5 5V0L3 5z"
});

function SvgVolume5(props) {
  return /*#__PURE__*/createElement("svg", _extends$om({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$om);
}

function _extends$on() { _extends$on = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$on.apply(this, arguments); }

var _ref$on = /*#__PURE__*/createElement("path", {
  d: "M8 7h8v2H8V7zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeDecrease(props) {
  return /*#__PURE__*/createElement("svg", _extends$on({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$on);
}

function _extends$oo() { _extends$oo = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oo.apply(this, arguments); }

var _ref$oo = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM14.5 9h-6a.5.5 0 010-1h6a.5.5 0 010 1z"
});

function SvgVolumeDecrease2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oo);
}

function _extends$op() { _extends$op = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$op.apply(this, arguments); }

var _ref$op = /*#__PURE__*/createElement("path", {
  d: "M15.854 1.146a.5.5 0 00-.707 0l-4.146 4.146V1.499a.5.5 0 00-.854-.354L6.293 4.999H4.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h.793l-3.146 3.146a.5.5 0 00.708.707l3.646-3.646 3.646 3.646a.5.5 0 00.854-.354V6.705l4.854-4.854a.5.5 0 000-.707zM5 10V6h1.5c.133 0 .26-.053.354-.146L10 2.708v3.586l-3.707 3.707H5zm5 3.293L7.207 10.5 10 7.707v5.586z"
});

function SvgVolumeDecrease3(props) {
  return /*#__PURE__*/createElement("svg", _extends$op({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$op);
}

function _extends$oq() { _extends$oq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oq.apply(this, arguments); }

var _ref$oq = /*#__PURE__*/createElement("path", {
  d: "M13.907 14.407a.75.75 0 01-.53-1.281c1.369-1.369 2.123-3.19 2.123-5.127s-.754-3.757-2.123-5.127a.75.75 0 111.061-1.061c1.653 1.653 2.563 3.85 2.563 6.187s-.91 4.534-2.563 6.187a.748.748 0 01-.53.22zm-2.664-1.414a.75.75 0 01-.53-1.281 5.256 5.256 0 000-7.425.75.75 0 111.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-.702 3.498-1.977 4.773a.748.748 0 01-.53.22zm-2.665-1.415a.75.75 0 01-.53-1.281 3.254 3.254 0 000-4.596.75.75 0 111.061-1.061 4.756 4.756 0 010 6.718.748.748 0 01-.53.22zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeHigh(props) {
  return /*#__PURE__*/createElement("svg", _extends$oq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$oq);
}

function _extends$or() { _extends$or = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$or.apply(this, arguments); }

var _ref$or = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM8.5 10a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5zM10.5 12a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zM12.5 14a.5.5 0 01-.5-.5v-11a.5.5 0 011 0v11a.5.5 0 01-.5.5zM14.5 16a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v15a.5.5 0 01-.5.5z"
});

function SvgVolumeHigh2(props) {
  return /*#__PURE__*/createElement("svg", _extends$or({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$or);
}

function _extends$os() { _extends$os = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$os.apply(this, arguments); }

var _ref$os = /*#__PURE__*/createElement("path", {
  d: "M16 9h-3v3h-2V9H8V7h3V4h2v3h3v2zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeIncrease(props) {
  return /*#__PURE__*/createElement("svg", _extends$os({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$os);
}

function _extends$ot() { _extends$ot = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ot.apply(this, arguments); }

var _ref$ot = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM14.5 8H12V5.5a.5.5 0 00-1 0V8H8.5a.5.5 0 000 1H11v2.5a.5.5 0 001 0V9h2.5a.5.5 0 000-1z"
});

function SvgVolumeIncrease2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ot({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ot);
}

function _extends$ou() { _extends$ou = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ou.apply(this, arguments); }

var _ref$ou = /*#__PURE__*/createElement("path", {
  d: "M8.578 11.578a.75.75 0 01-.53-1.281 3.254 3.254 0 000-4.596.75.75 0 111.061-1.061 4.756 4.756 0 010 6.718.748.748 0 01-.53.22zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeLow(props) {
  return /*#__PURE__*/createElement("svg", _extends$ou({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ou);
}

function _extends$ov() { _extends$ov = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ov.apply(this, arguments); }

var _ref$ov = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM8.5 10a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5z"
});

function SvgVolumeLow2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ov({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ov);
}

function _extends$ow() { _extends$ow = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ow.apply(this, arguments); }

var _ref$ow = /*#__PURE__*/createElement("path", {
  d: "M11.243 12.993a.75.75 0 01-.53-1.281 5.256 5.256 0 000-7.425.75.75 0 111.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-.702 3.498-1.977 4.773a.748.748 0 01-.53.22zm-2.665-1.415a.75.75 0 01-.53-1.281 3.254 3.254 0 000-4.596.75.75 0 111.061-1.061 4.756 4.756 0 010 6.718.748.748 0 01-.53.22zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeMedium(props) {
  return /*#__PURE__*/createElement("svg", _extends$ow({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ow);
}

function _extends$ox() { _extends$ox = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ox.apply(this, arguments); }

var _ref$ox = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM8.5 10a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5zM10.5 12a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zM12.5 14a.5.5 0 01-.5-.5v-11a.5.5 0 011 0v11a.5.5 0 01-.5.5z"
});

function SvgVolumeMedium2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ox({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ox);
}

function _extends$oy() { _extends$oy = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oy.apply(this, arguments); }

var _ref$oy = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4zM8.5 10a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5zM10.5 12a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"
});

function SvgVolumeMedium3(props) {
  return /*#__PURE__*/createElement("svg", _extends$oy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oy);
}

function _extends$oz() { _extends$oz = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oz.apply(this, arguments); }

var _ref$oz = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeMute(props) {
  return /*#__PURE__*/createElement("svg", _extends$oz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oz);
}

function _extends$oA() { _extends$oA = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oA.apply(this, arguments); }

var _ref$oA = /*#__PURE__*/createElement("path", {
  d: "M15 9.674V11h-1.326L12 9.326 10.326 11H9V9.674L10.674 8 9 6.326V5h1.326L12 6.674 13.674 5H15v1.326L13.326 8 15 9.674zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"
});

function SvgVolumeMute2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oA);
}

function _extends$oB() { _extends$oB = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oB.apply(this, arguments); }

var _ref$oB = /*#__PURE__*/createElement("path", {
  d: "M6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5zM1 10h1.5c.133 0 .26.053.354.146L6 13.292V2.706L2.854 5.852a.5.5 0 01-.354.146H1v4z"
});

function SvgVolumeMute3(props) {
  return /*#__PURE__*/createElement("svg", _extends$oB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oB);
}

function _extends$oC() { _extends$oC = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oC.apply(this, arguments); }

var _ref$oC = /*#__PURE__*/createElement("path", {
  d: "M0 5h3l5-5v16l-5-5H0V5zm14.326 3L16 9.674V11h-1.326L13 9.326 11.326 11H10V9.674L11.674 8 10 6.326V5h1.326L13 6.674 14.674 5H16v1.326L14.326 8z"
});

function SvgVolumeMute4(props) {
  return /*#__PURE__*/createElement("svg", _extends$oC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oC);
}

function _extends$oD() { _extends$oD = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oD.apply(this, arguments); }

var _ref$oD = /*#__PURE__*/createElement("path", {
  d: "M11 0L6 5H3v6l8-8zm3.909 1.091L1.091 14.909 2.182 16l4.409-4.409L11 16V7.182l5-5z"
});

function SvgVolumeMute5(props) {
  return /*#__PURE__*/createElement("svg", _extends$oD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oD);
}

function _extends$oE() { _extends$oE = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oE.apply(this, arguments); }

var _ref$oE = /*#__PURE__*/createElement("path", {
  d: "M0 13h4v2H0v-2zM5 13h4v2H5v-2zM10 13h6v2h-6v-2zM0 10h6v2H0v-2zM7 10h4v2H7v-2zM12 10h4v2h-4v-2zM0 7h4v2H0V7zM5 7h4v2H5V7zM10 7h6v2h-6V7zM0 4h6v2H0V4zM7 4h4v2H7V4zM12 4h4v2h-4V4zM0 1h4v2H0V1zM5 1h4v2H5V1zM10 1h6v2h-6V1z"
});

function SvgWall(props) {
  return /*#__PURE__*/createElement("svg", _extends$oE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oE);
}

function _extends$oF() { _extends$oF = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oF.apply(this, arguments); }

var _ref$oF = /*#__PURE__*/createElement("path", {
  d: "M15 2H2a2 2 0 00-2 2v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1h1c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM1 6h.5v1H1V6zm0 2h.5v1H1V8zm0 2h.5v1H1v-1zm0 2h.5v1H1v-1zm1 2H1v-.5h1v.5zm0-8.5H1V5h1v.5zM4 14H3v-.5h1v.5zm0-8.5H3V5h1v.5zM6 14H5v-.5h1v.5zm0-8.5H5V5h1v.5zM8 14H7v-.5h1v.5zm0-8.5H7V5h1v.5zm2 8.5H9v-.5h1v.5zm2 0h-1v-.5h1v.5zm3-7h-4v3h4v1.998l-.002.002H14v-1h-4V6h4V5c0-.55-.45-1-1-1H1c0-.551.449-1 1-1h12.998l.002.002V7zm-2 1.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgWallet(props) {
  return /*#__PURE__*/createElement("svg", _extends$oF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16"
  }, props), _ref$oF);
}

function _extends$oG() { _extends$oG = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oG.apply(this, arguments); }

var _ref$oG = /*#__PURE__*/createElement("path", {
  d: "M8 1.45l6.705 13.363H1.296L8.001 1.45zM8 0c-.345 0-.69.233-.951.698L.22 14.309C-.303 15.239.142 16 1.209 16h13.583c1.067 0 1.512-.761.989-1.691L8.952.698C8.69.233 8.346 0 8.001 0z"
});

var _ref2$5a = /*#__PURE__*/createElement("path", {
  d: "M9 13a1 1 0 11-2 0 1 1 0 012 0zM8 11a1 1 0 01-1-1V7a1 1 0 012 0v3a1 1 0 01-1 1z"
});

function SvgWarning(props) {
  return /*#__PURE__*/createElement("svg", _extends$oG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oG, _ref2$5a);
}

function _extends$oH() { _extends$oH = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oH.apply(this, arguments); }

var _ref$oH = /*#__PURE__*/createElement("path", {
  d: "M15.781 14.309L8.952.698C8.69.233 8.346 0 8.001 0s-.69.233-.951.698L.221 14.309C-.302 15.239.143 16 1.21 16h13.583c1.067 0 1.512-.761.989-1.691zM8 14a1 1 0 110-2 1 1 0 010 2zm1-4a1 1 0 01-2 0V7a1 1 0 012 0v3z"
});

function SvgWarning2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oH);
}

function _extends$oI() { _extends$oI = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oI.apply(this, arguments); }

var _ref$oI = /*#__PURE__*/createElement("path", {
  d: "M11 3h-.5L10 0H5l-.5 3H4c-1.1 0-2 .75-2 1.667v6.667c0 .917.9 1.667 2 1.667h.5l.5 3h5l.5-3h.5c1.1 0 2-.75 2-1.667V4.667C13 3.75 12.1 3 11 3zm1 8.333c0 .191-.143.338-.228.409A1.219 1.219 0 0111 12H4c-.294 0-.576-.094-.772-.258-.085-.071-.228-.218-.228-.409V4.666c0-.191.143-.338.228-.409.197-.164.478-.258.772-.258h7c.294 0 .576.094.772.258.085.071.228.218.228.409v6.667z"
});

var _ref2$5b = /*#__PURE__*/createElement("path", {
  d: "M6.5 6h-2a.5.5 0 000 1H6v1H4.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 000-1H5V9h1.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM10.5 6a.5.5 0 00-.5.5V8H9V6.5a.5.5 0 00-1 0v2a.5.5 0 00.5.5H10v1.5a.5.5 0 001 0v-4a.5.5 0 00-.5-.5z"
});

function SvgWatch(props) {
  return /*#__PURE__*/createElement("svg", _extends$oI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oI, _ref2$5b);
}

function _extends$oJ() { _extends$oJ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oJ.apply(this, arguments); }

var _ref$oJ = /*#__PURE__*/createElement("path", {
  d: "M9.5 8H8V5.5a.5.5 0 00-1 0v3a.5.5 0 00.5.5h2a.5.5 0 000-1z"
});

var _ref2$5c = /*#__PURE__*/createElement("path", {
  d: "M14 8a5.998 5.998 0 00-3.501-5.455h.001L10 0H6l-.5 2.545h.001a6 6 0 00-.001 10.91L6 16h4l.5-2.545h-.001A6 6 0 0014 8zm-6 4.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"
});

function SvgWatch2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oJ, _ref2$5c);
}

function _extends$oK() { _extends$oK = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oK.apply(this, arguments); }

var _ref$oK = /*#__PURE__*/createElement("path", {
  d: "M13 5h2v6a3.983 3.983 0 01-1.171 2.829 3.957 3.957 0 01-1.271.856C12.064 14.894 11.54 15 11 15a3.98 3.98 0 01-2.829-1.171 3.957 3.957 0 01-.856-1.271A3.976 3.976 0 017 11V5a2 2 0 10-4 0v6H1V5a3.983 3.983 0 011.171-2.829A3.98 3.98 0 015 1a3.983 3.983 0 012.829 1.171c.367.366.655.794.856 1.271C8.894 3.936 9 4.46 9 5v6a2 2 0 104 0V5z"
});

function SvgWave(props) {
  return /*#__PURE__*/createElement("svg", _extends$oK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oK);
}

function _extends$oL() { _extends$oL = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oL.apply(this, arguments); }

var _ref$oL = /*#__PURE__*/createElement("path", {
  d: "M16 4h2v8c0 1.654-1.346 3-3 3s-3-1.346-3-3V4c0-.551-.449-1-1-1s-1 .449-1 1v8c0 1.654-1.346 3-3 3s-3-1.346-3-3V4c0-.551-.449-1-1-1s-1 .449-1 1v8H0V4c0-1.654 1.346-3 3-3s3 1.346 3 3v8c0 .551.449 1 1 1s1-.449 1-1V4c0-1.654 1.346-3 3-3s3 1.346 3 3v8c0 .551.449 1 1 1s1-.449 1-1V4z"
});

function SvgWave2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16"
  }, props), _ref$oL);
}

function _extends$oM() { _extends$oM = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oM.apply(this, arguments); }

var _ref$oM = /*#__PURE__*/createElement("path", {
  d: "M13.922 10.626A2.726 2.726 0 0113.281 16H3.027C1.355 16 0 14.644 0 12.971a3.028 3.028 0 013.567-2.98 2.088 2.088 0 013.719-1.573A3.71 3.71 0 0110.206 7a3.72 3.72 0 013.717 3.626z"
});

var _ref2$5d = /*#__PURE__*/createElement("path", {
  d: "M5.634 6.856c.591 0 1.152.179 1.621.507a4.435 4.435 0 012.737-1.108 3.5 3.5 0 10-6.645 1.764 2.836 2.836 0 012.288-1.163zM6.5 0a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5zM0 6.5A.5.5 0 01.5 6h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM10.5 3a.5.5 0 01-.354-.853l1-1a.5.5 0 01.707.707l-1 1a.498.498 0 01-.354.146zM2.5 3a.502.502 0 01-.354-.146l-1-1a.5.5 0 01.707-.707l1 1A.5.5 0 012.499 3z"
});

function SvgWeatherCloudSun(props) {
  return /*#__PURE__*/createElement("svg", _extends$oM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oM, _ref2$5d);
}

function _extends$oN() { _extends$oN = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oN.apply(this, arguments); }

var _ref$oN = /*#__PURE__*/createElement("path", {
  d: "M6.5 0a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5zM0 6.5A.5.5 0 01.5 6h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM10.5 3a.5.5 0 01-.354-.853l1-1a.5.5 0 01.707.707l-1 1a.498.498 0 01-.354.146zM2.5 3a.502.502 0 01-.354-.146l-1-1a.5.5 0 01.707-.707l1 1A.5.5 0 012.499 3zM12 8a4.02 4.02 0 00-1.12.158 2.996 2.996 0 00-.89-1.4A3.504 3.504 0 006.5 3a3.504 3.504 0 00-3.043 5.229 2.503 2.503 0 00-1.398 2.811A2.503 2.503 0 000 13.5C0 14.879 1.121 16 2.5 16H12c1.068 0 2.073-.416 2.828-1.172S16 13.068 16 12c0-2.206-1.794-4-4-4zM4 6.5C4 5.122 5.122 4 6.5 4c1.264 0 2.312.944 2.477 2.164a3.005 3.005 0 00-3.834 1.92A2.527 2.527 0 004.5 8 2.493 2.493 0 014 6.5zm10.121 7.621A2.98 2.98 0 0112 15H2.5c-.827 0-1.5-.673-1.5-1.5S1.673 12 2.5 12h1a.5.5 0 000-1h-.414a1.502 1.502 0 011.915-1.914c.005.174.025.348.06.518a.5.5 0 10.98-.2A2.002 2.002 0 018 7c.947 0 1.751.665 1.952 1.562a4.037 4.037 0 00-.809.638.5.5 0 00.714.7 3.002 3.002 0 01.872-.62 3.004 3.004 0 014.27 2.72c0 .801-.312 1.555-.879 2.121z"
});

function SvgWeatherCloudSun2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oN);
}

function _extends$oO() { _extends$oO = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oO.apply(this, arguments); }

var _ref$oO = /*#__PURE__*/createElement("path", {
  d: "M4.253 12.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM4.253 15.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM13.922 3.626A2.726 2.726 0 0113.281 9H3.027C1.355 9 0 7.644 0 5.971a3.028 3.028 0 013.567-2.98 2.088 2.088 0 013.719-1.573A3.71 3.71 0 0110.206 0a3.72 3.72 0 013.717 3.626z"
});

function SvgWeatherCloudWind(props) {
  return /*#__PURE__*/createElement("svg", _extends$oO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oO);
}

function _extends$oP() { _extends$oP = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oP.apply(this, arguments); }

var _ref$oP = /*#__PURE__*/createElement("path", {
  d: "M12 2a4.02 4.02 0 00-1.12.158A3.008 3.008 0 008 0a3.005 3.005 0 00-2.857 2.084A2.503 2.503 0 002.059 5.04 2.503 2.503 0 000 7.5C0 8.879 1.121 10 2.5 10h3a.5.5 0 000-1h-3C1.673 9 1 8.327 1 7.5S1.673 6 2.5 6h1a.5.5 0 000-1h-.414a1.502 1.502 0 011.915-1.914c.005.174.025.348.06.518a.5.5 0 10.98-.2A2.002 2.002 0 018 1c.947 0 1.751.665 1.952 1.562a4.037 4.037 0 00-.809.638.5.5 0 00.714.7A2.977 2.977 0 0112 2.999c1.654 0 3 1.346 3 3 0 .801-.312 1.555-.879 2.121a.5.5 0 00.708.707 3.971 3.971 0 001.172-2.828c0-2.206-1.794-4-4-4zM4.253 12.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM4.253 15.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989z"
});

function SvgWeatherCloudWind2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oP);
}

function _extends$oQ() { _extends$oQ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oQ.apply(this, arguments); }

var _ref$oQ = /*#__PURE__*/createElement("path", {
  d: "M2.634 7.961a3.095 3.095 0 014.601-1.91 4.688 4.688 0 012.97-1.052c1.239 0 2.41.477 3.297 1.344a4.699 4.699 0 011.35 2.555c.144.068.284.145.419.231a2.726 2.726 0 00-1.349-4.504A3.72 3.72 0 0010.205.999a3.712 3.712 0 00-2.92 1.418A2.09 2.09 0 003.566 3.99 3.028 3.028 0 00.588 8.765a4.001 4.001 0 012.045-.805z"
});

var _ref2$5e = /*#__PURE__*/createElement("path", {
  d: "M13.922 9.626A2.726 2.726 0 0113.281 15H3.027C1.355 15 0 13.644 0 11.971a3.028 3.028 0 013.567-2.98 2.088 2.088 0 013.719-1.573A3.71 3.71 0 0110.206 6a3.72 3.72 0 013.717 3.626z"
});

function SvgWeatherCloudy(props) {
  return /*#__PURE__*/createElement("svg", _extends$oQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oQ, _ref2$5e);
}

function _extends$oR() { _extends$oR = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oR.apply(this, arguments); }

var _ref$oR = /*#__PURE__*/createElement("path", {
  d: "M2.059 11.04a2.388 2.388 0 01-.017-.082A2.503 2.503 0 010 8.501c0-1.228.89-2.251 2.059-2.46a2.503 2.503 0 013.084-2.956A3.005 3.005 0 018 1.001c1.354 0 2.514.907 2.88 2.158A4.004 4.004 0 0116 7.001c0 .921-.309 1.794-.879 2.502.549.685.879 1.554.879 2.498 0 2.206-1.794 4-4 4H2.5a2.502 2.502 0 01-2.5-2.5c0-1.228.89-2.251 2.059-2.46zM12 4a2.98 2.98 0 00-2.143.9.5.5 0 01-.714-.7c.245-.25.517-.463.809-.638A2.005 2.005 0 008 2a2.002 2.002 0 00-1.959 2.404.5.5 0 11-.98.2 2.99 2.99 0 01-.06-.518A1.502 1.502 0 003.086 6H3.5a.5.5 0 010 1h-1a1.5 1.5 0 00-.435 2.935 2.505 2.505 0 013.078-1.852A3.005 3.005 0 018 5.999c1.354 0 2.514.907 2.88 2.158A4.02 4.02 0 0112 7.999c.899 0 1.73.298 2.399.801.39-.517.601-1.143.601-1.801 0-1.654-1.346-3-3-3zM2.5 15H12c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.98 2.98 0 00-2.143.9.5.5 0 01-.714-.7c.245-.25.517-.463.809-.638A2.005 2.005 0 008 7a2.002 2.002 0 00-1.959 2.404.5.5 0 11-.98.2 2.99 2.99 0 01-.06-.518A1.502 1.502 0 003.086 11H3.5a.5.5 0 010 1h-1c-.827 0-1.5.673-1.5 1.5S1.673 15 2.5 15z"
});

function SvgWeatherCloudy2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oR);
}

function _extends$oS() { _extends$oS = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oS.apply(this, arguments); }

var _ref$oS = /*#__PURE__*/createElement("path", {
  d: "M13.922 4.626A3.72 3.72 0 0010.205 1a3.712 3.712 0 00-2.92 1.418 2.09 2.09 0 00-3.719 1.573 3.028 3.028 0 00-3.567 2.98A3.028 3.028 0 003.026 10h2.586l.667-2h5.339l-1 2h2.663a2.725 2.725 0 00.641-5.374zM10 9H7l-1 3h2l-1 3 4-4H9z"
});

function SvgWeatherLightning(props) {
  return /*#__PURE__*/createElement("svg", _extends$oS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oS);
}

function _extends$oT() { _extends$oT = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oT.apply(this, arguments); }

var _ref$oT = /*#__PURE__*/createElement("path", {
  d: "M12 3a4.02 4.02 0 00-1.12.158A3.008 3.008 0 008 1a3.005 3.005 0 00-2.857 2.084A2.503 2.503 0 002.059 6.04 2.503 2.503 0 000 8.5C0 9.879 1.121 11 2.5 11h3a.5.5 0 000-1h-3C1.673 10 1 9.327 1 8.5S1.673 7 2.5 7h1a.5.5 0 000-1h-.414a1.502 1.502 0 011.915-1.914c.005.174.025.348.06.518a.5.5 0 10.98-.2A2.002 2.002 0 018 2c.947 0 1.751.665 1.952 1.562a4.037 4.037 0 00-.809.638.5.5 0 00.714.7c.569-.581 1.33-.9 2.143-.9 1.654 0 3 1.346 3 3 0 .801-.312 1.555-.879 2.121S12.801 10 12 10h-.5a.5.5 0 000 1h.5c1.068 0 2.073-.416 2.828-1.172S16 8.068 16 7c0-2.206-1.794-4-4-4z"
});

var _ref2$5f = /*#__PURE__*/createElement("path", {
  d: "M8.5 15a.499.499 0 01-.474-.658L8.807 12H7.501a.499.499 0 01-.475-.658l1-3a.499.499 0 11.948.316L8.193 11h1.306a.499.499 0 01.475.658l-1 3A.5.5 0 018.5 15z"
});

function SvgWeatherLightning2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oT, _ref2$5f);
}

function _extends$oU() { _extends$oU = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oU.apply(this, arguments); }

var _ref$oU = /*#__PURE__*/createElement("path", {
  d: "M13.922 4.626A2.726 2.726 0 0113.281 10H3.027C1.355 10 0 8.644 0 6.971a3.028 3.028 0 013.567-2.98 2.088 2.088 0 013.719-1.573A3.71 3.71 0 0110.206 1a3.72 3.72 0 013.717 3.626zM13.999 14.449a1.484 1.484 0 00-.06-.374C13.657 12.928 12.501 11 12.501 11s-1.157 1.928-1.438 3.075a1.484 1.484 0 00-.06.374l-.001.051a1.5 1.5 0 003 0l-.001-.051zM9.499 13.449a1.484 1.484 0 00-.06-.374C9.157 11.928 8.001 10 8.001 10s-1.157 1.928-1.438 3.075a1.484 1.484 0 00-.06.374l-.001.051a1.5 1.5 0 003 0l-.001-.051zM4.999 14.449a1.484 1.484 0 00-.06-.374C4.657 12.928 3.501 11 3.501 11s-1.157 1.928-1.438 3.075a1.484 1.484 0 00-.06.374l-.001.051a1.5 1.5 0 003 0l-.001-.051z"
});

function SvgWeatherRain(props) {
  return /*#__PURE__*/createElement("svg", _extends$oU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oU);
}

function _extends$oV() { _extends$oV = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oV.apply(this, arguments); }

var _ref$oV = /*#__PURE__*/createElement("path", {
  d: "M0 8.5C0 9.879 1.121 11 2.5 11H12c1.068 0 2.073-.416 2.828-1.172S16 8.068 16 7a4.004 4.004 0 00-5.12-3.842A3.008 3.008 0 008 1a3.005 3.005 0 00-2.857 2.084A2.503 2.503 0 002.059 6.04 2.503 2.503 0 000 8.5zm1 0C1 7.673 1.673 7 2.5 7h1a.5.5 0 000-1h-.414a1.502 1.502 0 011.915-1.914c.005.174.025.348.06.518a.5.5 0 10.98-.2A2.002 2.002 0 018 2c.947 0 1.751.665 1.952 1.562a4.037 4.037 0 00-.809.638.5.5 0 00.714.7c.569-.581 1.33-.9 2.143-.9 1.654 0 3 1.346 3 3 0 .801-.312 1.555-.879 2.121S12.801 10 12 10H2.5C1.673 10 1 9.327 1 8.5zM3.5 16a1.502 1.502 0 01-1.299-2.251l.866-1.499a.499.499 0 01.866 0l.866 1.5A1.502 1.502 0 013.5 16zm0-2.5l-.433.75A.498.498 0 003.5 15a.5.5 0 00.433-.75L3.5 13.5zM13.5 16a1.502 1.502 0 01-1.299-2.251l.866-1.499a.499.499 0 01.866 0l.866 1.5A1.502 1.502 0 0113.5 16zm0-2.5l-.433.75a.498.498 0 00.433.75.5.5 0 00.433-.75l-.433-.75z"
});

var _ref2$5g = /*#__PURE__*/createElement("path", {
  d: "M8.5 15a1.502 1.502 0 01-1.299-2.251l.866-1.499a.499.499 0 01.866 0l.866 1.5A1.502 1.502 0 018.5 15zm0-2.5l-.433.75A.498.498 0 008.5 14a.5.5 0 00.433-.75L8.5 12.5z"
});

function SvgWeatherRain2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oV, _ref2$5g);
}

function _extends$oW() { _extends$oW = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oW.apply(this, arguments); }

var _ref$oW = /*#__PURE__*/createElement("path", {
  d: "M13.922 4.626A2.726 2.726 0 0113.281 10H3.027C1.355 10 0 8.644 0 6.971a3.028 3.028 0 013.567-2.98 2.088 2.088 0 013.719-1.573A3.71 3.71 0 0110.206 1a3.72 3.72 0 013.717 3.626zm.077 8.002c.005.078-.026.133-.094.164l-1.732.709 1.732.715c.067.027.098.079.094.157s-.062.204-.173.378c-.11.178-.2.287-.27.328s-.133.04-.19 0l-1.531-1.036.201 1.751c.014.067-.017.118-.094.154s-.225.054-.446.054c-.22 0-.369-.018-.445-.054s-.108-.087-.094-.154l.201-1.751-1.524 1.036c-.057.04-.122.04-.194 0s-.163-.149-.273-.328c-.111-.174-.167-.3-.169-.378s.03-.13.097-.157l1.732-.715-1.732-.709c-.067-.031-.1-.086-.097-.164s.058-.204.169-.378c.11-.174.201-.28.273-.321s.136-.04.194 0l1.524 1.029-.201-1.745c-.014-.071.017-.125.094-.16s.225-.054.445-.054.369.018.446.054.108.089.094.16l-.201 1.745 1.531-1.029c.057-.04.121-.04.19 0s.159.149.27.327c.111.169.168.293.173.371zm-6.999 0c.005.078-.026.133-.093.164l-1.732.709 1.732.715c.067.027.098.079.093.157s-.062.204-.173.378c-.11.178-.2.287-.27.328s-.133.04-.19 0l-1.531-1.036.201 1.751c.014.067-.017.118-.094.154s-.225.054-.446.054c-.22 0-.369-.018-.445-.054s-.108-.087-.094-.154l.201-1.751-1.524 1.036c-.058.04-.122.04-.194 0s-.163-.149-.273-.328c-.111-.174-.167-.3-.169-.378s.03-.13.097-.157l1.732-.715-1.732-.709c-.067-.031-.1-.086-.097-.164s.058-.204.169-.378c.11-.174.201-.28.273-.321s.136-.04.194 0l1.524 1.029-.201-1.745c-.014-.071.017-.125.094-.16s.225-.054.445-.054c.221 0 .369.018.446.054s.108.089.094.16l-.201 1.745 1.531-1.029c.058-.04.121-.04.19 0s.159.149.27.327c.111.169.168.293.173.371z"
});

function SvgWeatherSnow(props) {
  return /*#__PURE__*/createElement("svg", _extends$oW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oW);
}

function _extends$oX() { _extends$oX = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oX.apply(this, arguments); }

var _ref$oX = /*#__PURE__*/createElement("path", {
  d: "M0 7.5C0 8.878 1.121 10 2.5 10H12c1.068 0 2.073-.416 2.828-1.172S16 7.068 16 6a4.004 4.004 0 00-5.12-3.842A3.008 3.008 0 008 0a3.005 3.005 0 00-2.857 2.084A2.503 2.503 0 002.059 5.04 2.503 2.503 0 000 7.5zm1 0C1 6.673 1.673 6 2.5 6h1a.5.5 0 000-1h-.414a1.502 1.502 0 011.915-1.914c.005.174.025.348.06.518a.5.5 0 10.98-.2A2.002 2.002 0 018 1c.947 0 1.751.665 1.952 1.562a4.037 4.037 0 00-.809.638.5.5 0 00.714.7c.569-.581 1.33-.9 2.143-.9 1.654 0 3 1.346 3 3 0 .801-.312 1.555-.879 2.121S12.801 9 12 9H2.5C1.673 9 1 8.327 1 7.5zM13.999 12.628c.005.078-.026.133-.094.164l-1.732.709 1.732.715c.067.027.098.079.094.157s-.062.204-.173.378c-.11.178-.2.287-.27.328s-.133.04-.19 0l-1.531-1.036.201 1.751c.014.067-.017.118-.094.154s-.225.054-.446.054c-.22 0-.369-.018-.445-.054s-.108-.087-.094-.154l.201-1.751-1.524 1.036c-.057.04-.122.04-.194 0s-.163-.149-.273-.327c-.111-.174-.167-.3-.169-.378s.03-.13.097-.157l1.732-.715-1.732-.709c-.067-.031-.1-.086-.097-.164s.058-.204.169-.378c.11-.174.201-.28.273-.321s.136-.04.194 0l1.524 1.029-.201-1.745c-.014-.071.017-.125.094-.16s.225-.054.445-.054.369.018.446.054.108.089.094.16l-.201 1.745 1.531-1.029c.057-.04.121-.04.19 0s.159.149.27.327c.111.169.168.293.173.371zm-6.999 0c.005.078-.026.133-.093.164l-1.732.709 1.732.715c.067.027.098.079.093.157s-.062.204-.173.378c-.11.178-.2.287-.27.328s-.133.04-.19 0l-1.531-1.036.201 1.751c.014.067-.017.118-.094.154s-.225.054-.446.054c-.22 0-.369-.018-.445-.054s-.108-.087-.094-.154l.201-1.751-1.524 1.036c-.058.04-.122.04-.194 0s-.163-.149-.273-.327c-.111-.174-.167-.3-.169-.378s.03-.13.097-.157l1.732-.715-1.732-.709c-.067-.031-.1-.086-.097-.164s.058-.204.169-.378c.11-.174.201-.28.273-.321s.136-.04.194 0l1.524 1.029-.201-1.745c-.014-.071.017-.125.094-.16S4.277 11 4.497 11c.221 0 .369.018.446.054s.108.089.094.16l-.201 1.745 1.531-1.029c.058-.04.121-.04.19 0s.159.149.27.327c.111.169.168.293.173.371z"
});

function SvgWeatherSnow2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oX);
}

function _extends$oY() { _extends$oY = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oY.apply(this, arguments); }

var _ref$oY = /*#__PURE__*/createElement("path", {
  d: "M6.5 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6.5 0a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5zM11 6.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM0 6.5A.5.5 0 01.5 6h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM4.253 12.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM4.253 15.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM10.5 3a.5.5 0 01-.354-.853l1-1a.5.5 0 01.707.707l-1 1a.498.498 0 01-.354.146zM2.5 3a.502.502 0 01-.354-.146l-1-1a.5.5 0 01.707-.707l1 1A.5.5 0 012.499 3z"
});

function SvgWeatherSunWind(props) {
  return /*#__PURE__*/createElement("svg", _extends$oY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oY);
}

function _extends$oZ() { _extends$oZ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$oZ.apply(this, arguments); }

var _ref$oZ = /*#__PURE__*/createElement("path", {
  d: "M6.5 9C5.122 9 4 7.878 4 6.5S5.122 4 6.5 4 9 5.122 9 6.5 7.879 9 6.5 9zm0 1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6.5 0a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5zM11 6.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM0 6.5A.5.5 0 01.5 6h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM4.253 12.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM4.253 15.936c-1.328 0-2.656-.33-3.976-.989a.5.5 0 01.447-.895c1.176.587 2.364.885 3.53.885s2.351-.298 3.523-.885c2.641-1.319 5.315-1.318 7.948 0a.5.5 0 11-.448.894c-1.172-.587-2.357-.885-3.523-.885s-2.354.298-3.53.885c-1.316.659-2.643.989-3.97.989zM10.5 3a.5.5 0 01-.354-.853l1-1a.5.5 0 01.707.707l-1 1a.498.498 0 01-.354.146zM2.5 3a.502.502 0 01-.354-.146l-1-1a.5.5 0 01.707-.707l1 1A.5.5 0 012.499 3z"
});

function SvgWeatherSunWind2(props) {
  return /*#__PURE__*/createElement("svg", _extends$oZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$oZ);
}

function _extends$o_() { _extends$o_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o_.apply(this, arguments); }

var _ref$o_ = /*#__PURE__*/createElement("path", {
  d: "M10.5 5a1.5 1.5 0 111.485-1.288l.99.141A2.5 2.5 0 1010.5 5.999H16v-1h-5.5zM2 12a3 3 0 105.911-.728l-.971.243A2 2 0 115 10h11V9H5a3 3 0 00-3 3zM1 4.5a2.5 2.5 0 114.776 1.034l.911.414A3.5 3.5 0 103.5 7.999H16v-1H3.5a2.5 2.5 0 01-2.5-2.5z"
});

function SvgWeatherWindy(props) {
  return /*#__PURE__*/createElement("svg", _extends$o_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o_);
}

function _extends$o$() { _extends$o$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o$.apply(this, arguments); }

var _ref$o$ = /*#__PURE__*/createElement("path", {
  d: "M5.5 0a2.5 2.5 0 011 4.792V7h3a2 2 0 011.995 1.85L11.5 9v2.208a2.5 2.5 0 11-2 0V9h-3a2 2 0 01-1.995-1.85L4.5 7V4.792A2.5 2.5 0 015.5 0z",
  fillRule: "evenodd"
});

function SvgIcoWegstrecke(props) {
  return /*#__PURE__*/createElement("svg", _extends$o$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$o$);
}

function _extends$p0() { _extends$p0 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p0.apply(this, arguments); }

var _ref$p0 = /*#__PURE__*/createElement("path", {
  d: "M13.641 2.325A7.869 7.869 0 008.032 0C3.663 0 .107 3.556.107 7.928c0 1.397.366 2.763 1.059 3.963L.041 16l4.203-1.103a7.929 7.929 0 003.787.966h.003c4.369 0 7.928-3.556 7.928-7.928a7.887 7.887 0 00-2.322-5.609zm-5.607 12.2a6.583 6.583 0 01-3.356-.919l-.241-.144-2.494.653.666-2.431-.156-.25a6.537 6.537 0 01-1.009-3.506 6.599 6.599 0 016.594-6.591c1.759 0 3.416.688 4.659 1.931a6.554 6.554 0 011.928 4.662c-.003 3.637-2.959 6.594-6.591 6.594zm3.613-4.937c-.197-.1-1.172-.578-1.353-.644s-.313-.1-.447.1c-.131.197-.512.644-.628.778-.116.131-.231.15-.428.05s-.838-.309-1.594-.984c-.588-.525-.987-1.175-1.103-1.372s-.013-.306.088-.403c.091-.088.197-.231.297-.347s.131-.197.197-.331c.066-.131.034-.247-.016-.347s-.447-1.075-.609-1.472c-.159-.388-.325-.334-.447-.341-.116-.006-.247-.006-.378-.006s-.347.05-.528.247c-.181.197-.694.678-.694 1.653s.709 1.916.809 2.05c.1.131 1.397 2.134 3.384 2.991.472.203.841.325 1.128.419.475.15.906.128 1.247.078.381-.056 1.172-.478 1.338-.941s.166-.859.116-.941c-.047-.088-.178-.137-.378-.238z"
});

function SvgWhatsapp(props) {
  return /*#__PURE__*/createElement("svg", _extends$p0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p0);
}

function _extends$p1() { _extends$p1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p1.apply(this, arguments); }

var _ref$p1 = /*#__PURE__*/createElement("path", {
  d: "M4 14v2l-3-2.5L4 11v2h8v-2l3 2.5-3 2.5v-2zm9-11H3v5h10V3zm2-2v9H1V1h14z"
});

function SvgWidth(props) {
  return /*#__PURE__*/createElement("svg", _extends$p1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p1);
}

function _extends$p2() { _extends$p2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p2.apply(this, arguments); }

var _ref$p2 = /*#__PURE__*/createElement("path", {
  d: "M15.106 3.65c0 .05-.016.097-.047.141-.031.041-.066.063-.106.063-.313.031-.569.131-.766.3-.2.169-.403.497-.613.975l-3.225 7.272c-.022.069-.081.1-.178.1a.205.205 0 01-.178-.1L8.184 8.62l-2.081 3.781c-.044.069-.1.1-.178.1-.094 0-.153-.034-.184-.1L2.575 5.132c-.197-.45-.406-.766-.625-.944s-.525-.291-.916-.331C1 3.857.968 3.838.94 3.804a.173.173 0 01-.044-.122c0-.119.034-.178.1-.178.281 0 .578.013.888.038.288.025.556.038.809.038.256 0 .563-.013.913-.038.366-.025.691-.038.975-.038.069 0 .1.059.1.178s-.022.175-.063.175c-.281.022-.506.094-.669.216s-.244.281-.244.481c0 .1.034.228.1.378l2.616 5.912 1.487-2.806-1.384-2.903c-.25-.519-.453-.853-.612-1.003s-.403-.241-.728-.275c-.031 0-.056-.019-.084-.053s-.041-.075-.041-.122c0-.119.028-.178.088-.178.281 0 .541.013.778.038.228.025.469.038.728.038.253 0 .519-.013.803-.038.291-.025.578-.038.859-.038.069 0 .1.059.1.178s-.019.175-.063.175c-.566.038-.847.2-.847.481 0 .125.066.322.197.588l.916 1.859.912-1.7c.125-.241.191-.444.191-.606 0-.388-.281-.594-.847-.619-.05 0-.075-.059-.075-.175 0-.044.012-.081.037-.119s.05-.056.075-.056c.203 0 .45.013.747.038.281.025.516.038.697.038.131 0 .322-.013.575-.031.319-.028.588-.044.803-.044.05 0 .075.05.075.15 0 .134-.047.203-.137.203-.328.034-.594.125-.794.272s-.45.481-.75 1.006L8.905 7.379l1.644 3.35 2.428-5.647c.084-.206.125-.397.125-.569 0-.412-.281-.631-.847-.659-.05 0-.075-.059-.075-.175 0-.119.037-.178.113-.178.206 0 .45.013.734.038.262.025.481.038.656.038.188 0 .4-.013.644-.038.253-.025.481-.038.684-.038.063 0 .094.05.094.15z"
});

function SvgWikipedia(props) {
  return /*#__PURE__*/createElement("svg", _extends$p2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p2);
}

function _extends$p3() { _extends$p3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p3.apply(this, arguments); }

var _ref$p3 = /*#__PURE__*/createElement("path", {
  d: "M6.441 7.999c-.745-.383-1.47-.577-2.154-.577-.093 0-.187.003-.28.011a9.082 9.082 0 00-2.603.643L.001 12.942c.964-.357 1.817-.53 2.598-.53 1.263 0 2.18.472 2.937.958.359-1.217 1.219-4.158 1.476-5.036a12.34 12.34 0 00-.571-.333zm1.814 1.236l-1.413 4.909c.419.24 1.83 1.001 2.91 1.001.872 0 1.848-.223 2.982-.684l1.349-4.718c-.916.296-1.795.446-2.617.446-1.499 0-2.549-.486-3.211-.952zm-3.68-3.473c1.205.012 2.096.472 2.835.945l1.449-4.958c-.305-.175-1.106-.611-1.685-.759A5.28 5.28 0 005.968.855c-.809.015-1.694.218-2.701.622L1.885 6.33c1.013-.382 1.885-.568 2.689-.568h.002zM16 3.096c-.919.357-1.816.539-2.672.539-1.433 0-2.489-.497-3.173-.974L8.718 7.633c.965.62 2.005.936 3.096.936.89 0 1.812-.214 2.742-.636l-.003-.035.058-.014 1.39-4.788z"
});

function SvgWindows(props) {
  return /*#__PURE__*/createElement("svg", _extends$p3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p3);
}

function _extends$p4() { _extends$p4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p4.apply(this, arguments); }

var _ref$p4 = /*#__PURE__*/createElement("path", {
  d: "M.005 8L0 3.124l6-.815V8zM7 2.164L14.998 1v7H7zM15 9l-.002 7L7 14.875V9zm-9 5.747l-5.995-.822V8.999H6z"
});

function SvgWindows8(props) {
  return /*#__PURE__*/createElement("svg", _extends$p4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p4);
}

function _extends$p5() { _extends$p5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p5.apply(this, arguments); }

var _ref$p5 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm.48 9.61c2.191-.433 3.892-1.43 4.507-2.759C12.649 10.975 10.463 13 7.817 13c-1.863 0-3.498-1.004-4.42-2.515 1.1.86 3.04 1.028 5.083.625zM10 5.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5S11.552 7 11 7s-1-.672-1-1.5zm-4.5.305c-.653 0-1.208.245-1.414.586C4.031 6.299 4 5.888 4 5.786c0-.485.672-.879 1.5-.879s1.5.394 1.5.879c0 .103-.03.514-.086.605-.206-.341-.761-.586-1.414-.586z"
});

function SvgWink(props) {
  return /*#__PURE__*/createElement("svg", _extends$p5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p5);
}

function _extends$p6() { _extends$p6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p6.apply(this, arguments); }

var _ref$p6 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4c.552 0 1 .672 1 1.5S11.552 7 11 7s-1-.672-1-1.5.448-1.5 1-1.5zm-5.5.876c.932 0 1.594.349 1.594.895 0 .116.06.672-.003.775-.232-.384-.856-.659-1.591-.659s-1.359.275-1.591.659c-.062-.103-.003-.659-.003-.775 0-.546.662-.895 1.594-.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1.86 3.04 1.028 5.083.625 2.191-.433 3.892-1.43 4.507-2.759C12.65 10.975 10.464 13 7.818 13z"
});

function SvgWink2(props) {
  return /*#__PURE__*/createElement("svg", _extends$p6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p6);
}

function _extends$p7() { _extends$p7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p7.apply(this, arguments); }

var _ref$p7 = /*#__PURE__*/createElement("path", {
  d: "M9 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 1.5zM11.234 8L12 7.445 9.917 4.224a.5.5 0 00-.417-.225h-4a.497.497 0 00-.417.225L3 7.445 3.766 8l1.729-2.244.601 1.402-2.095 3.841h1.917l.333 5h1v-5h.5v5h1l.333-5h1.917L8.906 7.157l.601-1.402 1.729 2.244z"
});

function SvgWoman(props) {
  return /*#__PURE__*/createElement("svg", _extends$p7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p7);
}

function _extends$p8() { _extends$p8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p8.apply(this, arguments); }

var _ref$p8 = /*#__PURE__*/createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm3.652 7.9l.351 1.2-6.828 2-.351-1.2zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0z"
});

function SvgWondering(props) {
  return /*#__PURE__*/createElement("svg", _extends$p8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p8);
}

function _extends$p9() { _extends$p9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p9.apply(this, arguments); }

var _ref$p9 = /*#__PURE__*/createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM4 5a1 1 0 112 0 1 1 0 01-2 0zm1.176 7.6l-.351-1.2 6.828-2 .351 1.2-6.828 2z"
});

function SvgWondering2(props) {
  return /*#__PURE__*/createElement("svg", _extends$p9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$p9);
}

function _extends$pa() { _extends$pa = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pa.apply(this, arguments); }

var _ref$pa = /*#__PURE__*/createElement("path", {
  d: "M2 8c0 2.313 1.38 4.312 3.382 5.259L2.52 5.622A5.693 5.693 0 002 8zm10.05-.295c0-.722-.266-1.222-.495-1.612-.304-.482-.589-.889-.589-1.371 0-.537.418-1.037 1.008-1.037.027 0 .052.003.078.005A6.064 6.064 0 008 2.156 6.036 6.036 0 002.987 4.79c.141.004.274.007.386.007.627 0 1.599-.074 1.599-.074.323-.018.361.444.038.482 0 0-.325.037-.687.055l2.185 6.33 1.313-3.835-.935-2.495a12.304 12.304 0 01-.629-.055c-.323-.019-.285-.5.038-.482 0 0 .991.074 1.58.074.627 0 1.599-.074 1.599-.074.323-.018.362.444.038.482 0 0-.326.037-.687.055l2.168 6.282.599-1.947c.259-.809.457-1.389.457-1.889zm-3.945.806l-1.8 5.095a6.148 6.148 0 003.687-.093.52.52 0 01-.043-.081L8.105 8.511zm5.16-3.315c.026.186.04.386.04.601 0 .593-.114 1.259-.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051a5.697 5.697 0 00-.735-2.803zM8 0a8 8 0 100 16A8 8 0 008 0zm0 15A7 7 0 118 1a7 7 0 010 14z"
});

function SvgWordpress(props) {
  return /*#__PURE__*/createElement("svg", _extends$pa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pa);
}

function _extends$pb() { _extends$pb = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pb.apply(this, arguments); }

var _ref$pb = /*#__PURE__*/createElement("path", {
  d: "M15.671 12.779L8.475 6.611A4.5 4.5 0 003.193.193l2.6 2.6a1.003 1.003 0 010 1.414L4.207 5.793a1.003 1.003 0 01-1.414 0l-2.6-2.6a4.5 4.5 0 006.418 5.282l6.168 7.196a.914.914 0 001.358.052l1.586-1.586a.914.914 0 00-.052-1.358z"
});

function SvgWrench(props) {
  return /*#__PURE__*/createElement("svg", _extends$pb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pb);
}

function _extends$pc() { _extends$pc = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pc.apply(this, arguments); }

var _ref$pc = /*#__PURE__*/createElement("path", {
  d: "M13.139 16a1.37 1.37 0 01-1.038-.483L6.567 9.061A4.724 4.724 0 01.201 3.349l.242-.799L3.47 5.577c.082.082.192.127.309.127s.227-.045.309-.127L5.575 4.09a.438.438 0 000-.619L2.548.444l.799-.242a4.724 4.724 0 015.712 6.366l6.456 5.534a1.355 1.355 0 01.077 2.006l-1.487 1.487a1.363 1.363 0 01-.968.406zM6.817 7.815l6.043 7.051a.366.366 0 00.278.134c.068 0 .168-.02.261-.113l1.487-1.487c.077-.077.117-.174.113-.275s-.051-.195-.134-.265L7.814 6.817l.188-.354a3.72 3.72 0 00-3.479-5.458l1.76 1.76c.56.56.56 1.472 0 2.033L4.796 6.285c-.271.271-.632.42-1.016.42s-.746-.149-1.016-.42l-1.76-1.76a3.723 3.723 0 005.458 3.479l.354-.188z"
});

function SvgWrench2(props) {
  return /*#__PURE__*/createElement("svg", _extends$pc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pc);
}

function _extends$pd() { _extends$pd = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pd.apply(this, arguments); }

var _ref$pd = /*#__PURE__*/createElement("path", {
  d: "M2.129.629L4 2.5l-2 2L.129 2.629a3 3 0 003.742 3.742l5.757 5.757a3 3 0 003.742 3.742l-1.871-1.871 2-2 1.871 1.871a3 3 0 00-3.742-3.742L5.871 4.371A3 3 0 002.129.629z"
});

function SvgWrench3(props) {
  return /*#__PURE__*/createElement("svg", _extends$pd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pd);
}

function _extends$pe() { _extends$pe = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pe.apply(this, arguments); }

var _ref$pe = /*#__PURE__*/createElement("path", {
  d: "M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM4.884 10.406H3.156a.253.253 0 01-.225-.119c-.047-.075-.047-.169 0-.266l1.838-3.244c.003-.003.003-.006 0-.009L3.6 4.743c-.047-.097-.056-.191-.009-.266.044-.072.131-.109.237-.109h1.731c.266 0 .397.172.481.325 0 0 1.181 2.063 1.191 2.075-.069.125-1.869 3.303-1.869 3.303-.094.162-.219.334-.478.334zm8.185-8.028L9.238 9.153a.01.01 0 000 .012l2.441 4.456c.047.097.05.194.003.269-.044.072-.125.109-.231.109H9.723c-.266 0-.397-.175-.484-.328L6.78 9.159l3.85-6.828c.094-.166.206-.328.463-.328h1.753c.103 0 .188.041.231.109.044.072.044.169-.006.266z"
});

function SvgXing(props) {
  return /*#__PURE__*/createElement("svg", _extends$pe({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pe);
}

function _extends$pf() { _extends$pf = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pf.apply(this, arguments); }

var _ref$pf = /*#__PURE__*/createElement("path", {
  d: "M2.431 3.159c-.138 0-.256.05-.316.144-.059.1-.05.225.013.353l1.559 2.7c.003.006.003.009 0 .013L1.237 10.7c-.063.128-.059.256 0 .353a.34.34 0 00.3.156h2.306c.344 0 .513-.234.628-.447l2.491-4.406L5.374 3.59c-.116-.203-.287-.431-.644-.431h-2.3zM12.125 0c-.344 0-.494.216-.619.441 0 0-4.972 8.816-5.134 9.106l3.278 6.016c.116.203.291.441.644.441H12.6c.137 0 .247-.053.306-.147.063-.1.059-.228-.006-.356L9.65 9.554c-.003-.006-.003-.009 0-.016L14.759.504c.063-.128.066-.256.006-.356-.059-.094-.169-.147-.306-.147h-2.334z"
});

function SvgXing2(props) {
  return /*#__PURE__*/createElement("svg", _extends$pf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pf);
}

function _extends$pg() { _extends$pg = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pg.apply(this, arguments); }

var _ref$pg = /*#__PURE__*/createElement("path", {
  d: "M8.878 9.203C10.637 6.115 13.544 1.078 14.341 0c-.35.234-.887.353-1.381.466L12.213 0c-.6 1.119-2.813 4.734-4.222 7.05C6.563 4.684 4.872 1.953 3.769 0 2.894.188 2.532.197 1.66 0c1.731 2.606 4.503 7.572 5.447 9.203L6.979 16l1.013-.466v-.012L9.004 16l-.125-6.797z"
});

function SvgYahoo(props) {
  return /*#__PURE__*/createElement("svg", _extends$pg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pg);
}

function _extends$ph() { _extends$ph = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$ph.apply(this, arguments); }

var _ref$ph = /*#__PURE__*/createElement("path", {
  d: "M8.019 1.087C5.191 1.087 2.519.715 0 0v16c2.522-.716 5.194-1.088 8.019-1.088 2.794 0 5.459.363 7.981 1.088V0c-2.522.725-5.184 1.087-7.981 1.087zm4.431 1.366l-.097.153c-.091.144-.172.266-.284.438-.15.225-.431.672-.769 1.247-.094.159-.209.35-.328.556l-.688 1.162-.256.447-.678 1.181c-.228.403-.453.8-.678 1.194v.397c0 .55.012 1.15.031 1.684.009.244.019.678.031 1.137.012.547.025 1.113.041 1.4l.003.088v.009l-.094-.025-.109-.028a3.093 3.093 0 00-.353-.056 2.691 2.691 0 00-.444 0 3.058 3.058 0 00-.462.084l-.094.025v-.009l.003-.088c.013-.284.028-.853.041-1.4.009-.459.022-.894.031-1.137a42.53 42.53 0 00.031-1.684v-.397L6.65 7.637c-.222-.391-.453-.791-.675-1.181-.088-.15-.172-.3-.256-.447-.2-.347-.459-.781-.688-1.162a31.856 31.856 0 01-.328-.556 31.033 31.033 0 00-.769-1.247c-.112-.172-.194-.294-.284-.438l-.097-.153.175.05c.222.063.45.094.694.094s.478-.031.697-.094l.053-.016.028.047c.431.778 1.591 2.684 2.284 3.825.237.394.428.703.522.862v-.003.003l.522-.862c.694-1.138 1.853-3.044 2.284-3.825l.028-.047.053.016c.219.063.453.094.697.094s.472-.031.694-.094l.166-.05z"
});

function SvgYahoo2(props) {
  return /*#__PURE__*/createElement("svg", _extends$ph({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$ph);
}

function _extends$pi() { _extends$pi = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pi.apply(this, arguments); }

var _ref$pi = /*#__PURE__*/createElement("path", {
  d: "M9.514 10.21c-.27.272-.042.768-.042.768l2.033 3.394s.334.447.623.447c.29 0 .577-.239.577-.239l1.607-2.297s.162-.29.166-.544c.006-.361-.538-.46-.538-.46l-3.805-1.222s-.373-.099-.621.152zM9.321 8.5c.195.33.732.234.732.234l3.796-1.109s.517-.21.591-.491c.072-.281-.085-.619-.085-.619l-1.814-2.137s-.157-.27-.483-.297c-.36-.031-.581.405-.581.405L9.332 7.861s-.19.336-.01.64zM7.527 7.184c.447-.11.518-.759.518-.759l-.03-5.404S7.948.354 7.648.174c-.47-.285-.609-.136-.744-.116L3.753 1.229s-.309.102-.469.36c-.23.365.233.899.233.899l3.276 4.465s.323.334.735.233zm-.778 2.187c.011-.417-.5-.667-.5-.667L2.862 6.993s-.502-.207-.746-.063c-.187.11-.352.31-.368.486l-.221 2.716s-.033.471.089.685c.173.304.741.092.741.092l3.955-.874c.154-.103.423-.113.438-.664zm.983 1.466c-.339-.174-.746.187-.746.187l-2.648 2.915s-.33.446-.246.72c.079.257.21.384.396.474l2.659.839s.322.067.567-.004c.347-.1.283-.643.283-.643l.06-3.947s-.014-.38-.324-.541z"
});

function SvgYelp(props) {
  return /*#__PURE__*/createElement("svg", _extends$pi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pi);
}

function _extends$pj() { _extends$pj = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pj.apply(this, arguments); }

var _ref$pj = /*#__PURE__*/createElement("path", {
  d: "M7 4a1 1 0 112 0 1 1 0 01-2 0zm1-4a8 8 0 100 16A8 8 0 008 0zm0 13a1 1 0 110-2 1 1 0 010 2zm0-5a3.25 3.25 0 100 6.5 6.5 6.5 0 110-13A3.25 3.25 0 118 8z"
});

function SvgYinYang(props) {
  return /*#__PURE__*/createElement("svg", _extends$pj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pj);
}

function _extends$pk() { _extends$pk = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pk.apply(this, arguments); }

var _ref$pk = /*#__PURE__*/createElement("path", {
  d: "M15.841 4.8s-.156-1.103-.637-1.587c-.609-.637-1.291-.641-1.603-.678-2.237-.163-5.597-.163-5.597-.163h-.006s-3.359 0-5.597.163c-.313.038-.994.041-1.603.678C.317 3.697.164 4.8.164 4.8S.005 6.094.005 7.391v1.213c0 1.294.159 2.591.159 2.591s.156 1.103.634 1.588c.609.637 1.409.616 1.766.684 1.281.122 5.441.159 5.441.159s3.363-.006 5.6-.166c.313-.037.994-.041 1.603-.678.481-.484.637-1.588.637-1.588s.159-1.294.159-2.591V7.39c-.003-1.294-.162-2.591-.162-2.591zm-9.494 5.275V5.578l4.322 2.256-4.322 2.241z"
});

function SvgYoutube(props) {
  return /*#__PURE__*/createElement("svg", _extends$pk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pk);
}

function _extends$pl() { _extends$pl = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pl.apply(this, arguments); }

var _ref$pl = /*#__PURE__*/createElement("path", {
  d: "M5.375 2.647l.006-.028.016-.118-.74-.004c-.668-.004-.873 0-.891.017-.009.008-.24.885-.651 2.473-.196.758-.361 1.363-.367 1.345s-.24-.883-.522-1.922a107.288 107.288 0 00-.524-1.901c-.01-.01-.906-.014-1.632-.008-.105.001-.164-.205.938 3.299.152.485.381 1.172.507 1.526.146.408.25.724.321.987.126.501.13.815.103 1.182-.032.423-.036 3.413-.005 3.463.024.038 1.425.056 1.558.02.021-.006.035-.026.045-.139.033-.097.036-.484.036-2.09V8.698l.09-.283c.059-.185.206-.672.328-1.082l.327-1.09c.529-1.724 1.033-3.419 1.047-3.516l.011-.079zM13.221 5.135v.107h-.017l-.009 2.953-.009 2.863-.229.233c-.257.261-.462.361-.648.314-.203-.051-.197.028-.214-3.356l-.016-3.115h-1.474v.107h-.017v3.38c0 3.621 0 3.619.184 3.982.146.29.36.431.725.479.481.064 1-.154 1.481-.622l.209-.203v.351c0 .303.009.353.064.368.09.025 1.206.027 1.326.002l.1-.021v-.104l.017-.003V5.114l-1.472.02zM9.483 6.661c-.14-.599-.401-1.002-.832-1.28-.676-.437-1.449-.484-2.165-.13-.522.258-.859.686-1.032 1.314a1.383 1.383 0 00-.047.231c-.044.222-.049.552-.061 2.093-.018 2.374.01 2.656.307 3.195.292.529.897.917 1.556.997.198.024.6-.013.832-.078.525-.146 1.029-.561 1.252-1.032a1.8 1.8 0 00.189-.604c.065-.353.07-.925.07-2.381 0-1.857-.006-2.06-.068-2.326zM7.802 11.5a.688.688 0 01-.515.098c-.135-.029-.318-.241-.374-.434-.07-.241-.075-3.594-.015-4.251.1-.329.378-.501.682-.419.237.064.358.212.427.523.051.231.057.518.046 2.207-.007 1.12-.011 1.668-.048 1.962-.037.185-.099.235-.203.315zM35.944 8.346h.712l-.011-.645c-.011-.592-.02-.659-.099-.82-.125-.253-.309-.366-.601-.366-.351 0-.573.17-.678.518-.045.148-.092 1.167-.058 1.255.019.049.121.058.735.058zM31.184 6.879a.49.49 0 00-.477-.278.914.914 0 00-.508.203l-.127.097v4.634l.127.097c.288.22.604.266.822.12a.482.482 0 00.186-.263c.057-.164.062-.375.055-2.325-.008-2.032-.012-2.152-.078-2.285z"
});

var _ref2$5h = /*#__PURE__*/createElement("path", {
  d: "M40.014 4.791c-.142-1.701-.255-2.253-.605-2.962C38.944.89 38.273.395 37.317.286c-.739-.084-3.521-.203-6.094-.26-4.456-.099-11.782.092-12.718.331a2.252 2.252 0 00-1.094.634c-.591.588-.944 1.432-1.085 2.6-.323 2.666-.33 5.886-.019 8.649.134 1.188.41 1.96.928 2.596.323.397.881.734 1.379.835.35.071 2.1.169 4.65.26.38.014 1.385.037 2.235.052 1.77.031 5.025.013 6.886-.039 1.252-.035 3.534-.128 3.961-.161.12-.009.398-.027.618-.039.739-.042 1.209-.196 1.65-.543.571-.449 1.013-1.278 1.2-2.251.177-.92.295-2.559.319-4.42.02-1.555-.007-2.393-.119-3.741zM22.27 4.175l-.828.01-.036 8.83-.718.009c-.555.008-.724-.001-.737-.036-.01-.025-.021-2.016-.026-4.424l-.009-4.379-1.617-.02v-1.38l4.779.019.02 1.36-.828.01zm5.077 5.061v3.797h-1.308v-.4c0-.301-.011-.4-.047-.4-.026 0-.144.099-.263.22-.259.263-.565.474-.827.572-.542.203-1.056.084-1.275-.293-.201-.345-.204-.423-.204-4.005v-3.29h1.307l.01 3.098c.01 3.044.011 3.1.084 3.224.097.164.244.209.478.144.138-.038.232-.105.455-.327l.282-.28V5.437h1.308v3.797zm5.102 3.255c-.115.257-.372.508-.583.57-.549.162-.99.03-1.499-.449-.158-.149-.305-.269-.327-.269-.027 0-.041.116-.041.345v.345h-1.308V2.785h1.308v1.672c0 .919.012 1.672.027 1.672s.153-.122.307-.27c.354-.341.649-.491 1.024-.519.669-.051 1.068.294 1.25 1.08.057.245.062.525.062 2.798 0 2.768 0 2.78-.221 3.273zm5.535-1.52a4.706 4.706 0 01-.077.727c-.182.674-.666 1.152-1.366 1.348-.942.264-1.98-.168-2.394-.997-.232-.465-.241-.558-.241-2.831 0-1.853.007-2.081.066-2.334.168-.715.584-1.178 1.289-1.435.204-.074.417-.113.63-.117.761-.016 1.515.393 1.832 1.059.213.449.24.642.261 1.908l.019 1.136-2.789.019-.01.763c-.015 1.077.058 1.408.349 1.603.244.165.62.152.824-.027.192-.168.246-.349.265-.877l.017-.463h1.347l-.022.518z"
});

function SvgYoutube2(props) {
  return /*#__PURE__*/createElement("svg", _extends$pl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 16,
    viewBox: "0 0 40 16"
  }, props), _ref$pl, _ref2$5h);
}

function _extends$pm() { _extends$pm = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pm.apply(this, arguments); }

var _ref$pm = /*#__PURE__*/createElement("path", {
  d: "M16 13.5l-4.695-4.695a6 6 0 10-2.5 2.5L13.5 16l2.5-2.5zM2 6a4 4 0 118 0 4 4 0 01-8 0z"
});

var _ref2$5i = /*#__PURE__*/createElement("path", {
  d: "M9 5H7V3H5v2H3v2h2v2h2V7h2z"
});

function SvgZoomIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$pm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pm, _ref2$5i);
}

function _extends$pn() { _extends$pn = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pn.apply(this, arguments); }

var _ref$pn = /*#__PURE__*/createElement("path", {
  d: "M6 3H5v2H3v1h2v2h1V6h2V5H6zm3.962 5.716A5.5 5.5 0 100 5.5a5.5 5.5 0 008.716 4.462L14 16l2-2-6.038-5.284zM5.5 9.5a4 4 0 110-8 4 4 0 010 8z"
});

function SvgZoomIn2(props) {
  return /*#__PURE__*/createElement("svg", _extends$pn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pn);
}

function _extends$po() { _extends$po = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$po.apply(this, arguments); }

var _ref$po = /*#__PURE__*/createElement("path", {
  d: "M15.504 13.616l-3.79-3.223c-.392-.353-.811-.514-1.149-.499a6 6 0 10-.672.672c-.016.338.146.757.499 1.149l3.223 3.79c.552.613 1.453.665 2.003.115s.498-1.452-.115-2.003zM6 10a4 4 0 110-8 4 4 0 010 8zm1-7H5v2H3v2h2v2h2V7h2V5H7z"
});

function SvgZoomIn3(props) {
  return /*#__PURE__*/createElement("svg", _extends$po({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$po);
}

function _extends$pp() { _extends$pp = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pp.apply(this, arguments); }

var _ref$pp = /*#__PURE__*/createElement("path", {
  d: "M16 13.5l-4.695-4.695a6 6 0 10-2.5 2.5L13.5 16l2.5-2.5zM2 6a4 4 0 118 0 4 4 0 01-8 0z"
});

var _ref2$5j = /*#__PURE__*/createElement("path", {
  d: "M3 5h6v2H3V5z"
});

function SvgZoomOut(props) {
  return /*#__PURE__*/createElement("svg", _extends$pp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pp, _ref2$5j);
}

function _extends$pq() { _extends$pq = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pq.apply(this, arguments); }

var _ref$pq = /*#__PURE__*/createElement("path", {
  d: "M3 5h5v1H3zm6.962 3.716A5.5 5.5 0 100 5.5a5.5 5.5 0 008.716 4.462L14 16l2-2-6.038-5.284zM5.5 9.5a4 4 0 110-8 4 4 0 010 8z"
});

function SvgZoomOut2(props) {
  return /*#__PURE__*/createElement("svg", _extends$pq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pq);
}

function _extends$pr() { _extends$pr = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$pr.apply(this, arguments); }

var _ref$pr = /*#__PURE__*/createElement("path", {
  d: "M15.504 13.616l-3.79-3.223c-.392-.353-.811-.514-1.149-.499a6 6 0 10-.672.672c-.016.338.146.757.499 1.149l3.223 3.79c.552.613 1.453.665 2.003.115s.498-1.452-.115-2.003zM6 10a4 4 0 110-8 4 4 0 010 8zM3 5h6v2H3z"
});

function SvgZoomOut3(props) {
  return /*#__PURE__*/createElement("svg", _extends$pr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref$pr);
}

var Five00px = function Five00px(props) {
  return /*#__PURE__*/React.createElement(Svg500Px, props);
};
var Accessibility = function Accessibility(props) {
  return /*#__PURE__*/React.createElement(SvgAccessibility, props);
};
var Accessibility2 = function Accessibility2(props) {
  return /*#__PURE__*/React.createElement(SvgAccessibility2, props);
};
var AddressBook = function AddressBook(props) {
  return /*#__PURE__*/React.createElement(SvgAddressBook, props);
};
var AddressBook2 = function AddressBook2(props) {
  return /*#__PURE__*/React.createElement(SvgAddressBook2, props);
};
var AddressBook3 = function AddressBook3(props) {
  return /*#__PURE__*/React.createElement(SvgAddressBook3, props);
};
var AidKit = function AidKit(props) {
  return /*#__PURE__*/React.createElement(SvgAidKit, props);
};
var AidKit2 = function AidKit2(props) {
  return /*#__PURE__*/React.createElement(SvgAidKit2, props);
};
var Airplane = function Airplane(props) {
  return /*#__PURE__*/React.createElement(SvgAirplane, props);
};
var Airplane2 = function Airplane2(props) {
  return /*#__PURE__*/React.createElement(SvgAirplane2, props);
};
var Airplane3 = function Airplane3(props) {
  return /*#__PURE__*/React.createElement(SvgAirplane3, props);
};
var Airplane4 = function Airplane4(props) {
  return /*#__PURE__*/React.createElement(SvgAirplane4, props);
};
var AlarmAdd = function AlarmAdd(props) {
  return /*#__PURE__*/React.createElement(SvgAlarmAdd, props);
};
var AlarmCancel = function AlarmCancel(props) {
  return /*#__PURE__*/React.createElement(SvgAlarmCancel, props);
};
var AlarmCheck = function AlarmCheck(props) {
  return /*#__PURE__*/React.createElement(SvgAlarmCheck, props);
};
var Alarm = function Alarm(props) {
  return /*#__PURE__*/React.createElement(SvgAlarm, props);
};
var Alarm2 = function Alarm2(props) {
  return /*#__PURE__*/React.createElement(SvgAlarm2, props);
};
var Album = function Album(props) {
  return /*#__PURE__*/React.createElement(SvgAlbum, props);
};
var AlignBottom = function AlignBottom(props) {
  return /*#__PURE__*/React.createElement(SvgAlignBottom, props);
};
var AlignCenterHorizontal = function AlignCenterHorizontal(props) {
  return /*#__PURE__*/React.createElement(SvgAlignCenterHorizontal, props);
};
var AlignCenterVertical = function AlignCenterVertical(props) {
  return /*#__PURE__*/React.createElement(SvgAlignCenterVertical, props);
};
var AlignLeft = function AlignLeft(props) {
  return /*#__PURE__*/React.createElement(SvgAlignLeft, props);
};
var AlignRight = function AlignRight(props) {
  return /*#__PURE__*/React.createElement(SvgAlignRight, props);
};
var AlignTop = function AlignTop(props) {
  return /*#__PURE__*/React.createElement(SvgAlignTop, props);
};
var Amazon = function Amazon(props) {
  return /*#__PURE__*/React.createElement(SvgAmazon, props);
};
var Ambulance = function Ambulance(props) {
  return /*#__PURE__*/React.createElement(SvgAmbulance, props);
};
var Ammo = function Ammo(props) {
  return /*#__PURE__*/React.createElement(SvgAmmo, props);
};
var Ampersand = function Ampersand(props) {
  return /*#__PURE__*/React.createElement(SvgAmpersand, props);
};
var Anchor = function Anchor(props) {
  return /*#__PURE__*/React.createElement(SvgAnchor, props);
};
var Android = function Android(props) {
  return /*#__PURE__*/React.createElement(SvgAndroid, props);
};
var Angle = function Angle(props) {
  return /*#__PURE__*/React.createElement(SvgAngle, props);
};
var Angry = function Angry(props) {
  return /*#__PURE__*/React.createElement(SvgAngry, props);
};
var Angry2 = function Angry2(props) {
  return /*#__PURE__*/React.createElement(SvgAngry2, props);
};
var Antenna = function Antenna(props) {
  return /*#__PURE__*/React.createElement(SvgAntenna, props);
};
var Antenna2 = function Antenna2(props) {
  return /*#__PURE__*/React.createElement(SvgAntenna2, props);
};
var Apple = function Apple(props) {
  return /*#__PURE__*/React.createElement(SvgApple, props);
};
var Appleinc = function Appleinc(props) {
  return /*#__PURE__*/React.createElement(SvgAppleinc, props);
};
var Archery = function Archery(props) {
  return /*#__PURE__*/React.createElement(SvgArchery, props);
};
var Archive = function Archive(props) {
  return /*#__PURE__*/React.createElement(SvgArchive, props);
};
var ArrowDownLeft = function ArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownLeft, props);
};
var ArrowDownLeft2 = function ArrowDownLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownLeft2, props);
};
var ArrowDownLeft3 = function ArrowDownLeft3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownLeft3, props);
};
var ArrowDownLeft4 = function ArrowDownLeft4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownLeft4, props);
};
var ArrowDownLeft5 = function ArrowDownLeft5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownLeft5, props);
};
var ArrowDownRight = function ArrowDownRight(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownRight, props);
};
var ArrowDownRight2 = function ArrowDownRight2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownRight2, props);
};
var ArrowDownRight3 = function ArrowDownRight3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownRight3, props);
};
var ArrowDownRight4 = function ArrowDownRight4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownRight4, props);
};
var ArrowDownRight5 = function ArrowDownRight5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDownRight5, props);
};
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, props);
};
var ArrowDown10 = function ArrowDown10(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown10, props);
};
var ArrowDown11 = function ArrowDown11(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown11, props);
};
var ArrowDown12 = function ArrowDown12(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown12, props);
};
var ArrowDown13 = function ArrowDown13(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown13, props);
};
var ArrowDown14 = function ArrowDown14(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown14, props);
};
var ArrowDown15 = function ArrowDown15(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown15, props);
};
var ArrowDown16 = function ArrowDown16(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown16, props);
};
var ArrowDown2 = function ArrowDown2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown2, props);
};
var ArrowDown3 = function ArrowDown3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown3, props);
};
var ArrowDown4 = function ArrowDown4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown4, props);
};
var ArrowDown5 = function ArrowDown5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown5, props);
};
var ArrowDown6 = function ArrowDown6(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown6, props);
};
var ArrowDown7 = function ArrowDown7(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown7, props);
};
var ArrowDown8 = function ArrowDown8(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown8, props);
};
var ArrowDown9 = function ArrowDown9(props) {
  return /*#__PURE__*/React.createElement(SvgArrowDown9, props);
};
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, props);
};
var ArrowLeft10 = function ArrowLeft10(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft10, props);
};
var ArrowLeft11 = function ArrowLeft11(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft11, props);
};
var ArrowLeft12 = function ArrowLeft12(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft12, props);
};
var ArrowLeft13 = function ArrowLeft13(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft13, props);
};
var ArrowLeft14 = function ArrowLeft14(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft14, props);
};
var ArrowLeft15 = function ArrowLeft15(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft15, props);
};
var ArrowLeft16 = function ArrowLeft16(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft16, props);
};
var ArrowLeft2 = function ArrowLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft2, props);
};
var ArrowLeft3 = function ArrowLeft3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft3, props);
};
var ArrowLeft4 = function ArrowLeft4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft4, props);
};
var ArrowLeft5 = function ArrowLeft5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft5, props);
};
var ArrowLeft6 = function ArrowLeft6(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft6, props);
};
var ArrowLeft7 = function ArrowLeft7(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft7, props);
};
var ArrowLeft8 = function ArrowLeft8(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft8, props);
};
var ArrowLeft9 = function ArrowLeft9(props) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft9, props);
};
var ArrowResize = function ArrowResize(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize, props);
};
var ArrowResize2 = function ArrowResize2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize2, props);
};
var ArrowResize3 = function ArrowResize3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize3, props);
};
var ArrowResize4 = function ArrowResize4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize4, props);
};
var ArrowResize5 = function ArrowResize5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize5, props);
};
var ArrowResize6 = function ArrowResize6(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize6, props);
};
var ArrowResize7 = function ArrowResize7(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize7, props);
};
var ArrowResize8 = function ArrowResize8(props) {
  return /*#__PURE__*/React.createElement(SvgArrowResize8, props);
};
var ArrowRightFilled = function ArrowRightFilled(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRightFilled, props);
};
var ArrowRightOutline = function ArrowRightOutline(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRightOutline, props);
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, props);
};
var ArrowRight10 = function ArrowRight10(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight10, props);
};
var ArrowRight11 = function ArrowRight11(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight11, props);
};
var ArrowRight12 = function ArrowRight12(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight12, props);
};
var ArrowRight13 = function ArrowRight13(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight13, props);
};
var ArrowRight14 = function ArrowRight14(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight14, props);
};
var ArrowRight15 = function ArrowRight15(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight15, props);
};
var ArrowRight16 = function ArrowRight16(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight16, props);
};
var ArrowRight2 = function ArrowRight2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight2, props);
};
var ArrowRight3 = function ArrowRight3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight3, props);
};
var ArrowRight4 = function ArrowRight4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight4, props);
};
var ArrowRight5 = function ArrowRight5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight5, props);
};
var ArrowRight6 = function ArrowRight6(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight6, props);
};
var ArrowRight7 = function ArrowRight7(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight7, props);
};
var ArrowRight8 = function ArrowRight8(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight8, props);
};
var ArrowRight9 = function ArrowRight9(props) {
  return /*#__PURE__*/React.createElement(SvgArrowRight9, props);
};
var ArrowUpLeft = function ArrowUpLeft(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft, props);
};
var ArrowUpLeft2 = function ArrowUpLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft2, props);
};
var ArrowUpLeft3 = function ArrowUpLeft3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft3, props);
};
var ArrowUpLeft4 = function ArrowUpLeft4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft4, props);
};
var ArrowUpLeft5 = function ArrowUpLeft5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpLeft5, props);
};
var ArrowUpRight = function ArrowUpRight(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpRight, props);
};
var ArrowUpRight2 = function ArrowUpRight2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpRight2, props);
};
var ArrowUpRight3 = function ArrowUpRight3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpRight3, props);
};
var ArrowUpRight4 = function ArrowUpRight4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpRight4, props);
};
var ArrowUpRight5 = function ArrowUpRight5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUpRight5, props);
};
var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, props);
};
var ArrowUp10 = function ArrowUp10(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp10, props);
};
var ArrowUp11 = function ArrowUp11(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp11, props);
};
var ArrowUp12 = function ArrowUp12(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp12, props);
};
var ArrowUp13 = function ArrowUp13(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp13, props);
};
var ArrowUp14 = function ArrowUp14(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp14, props);
};
var ArrowUp15 = function ArrowUp15(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp15, props);
};
var ArrowUp16 = function ArrowUp16(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp16, props);
};
var ArrowUp2 = function ArrowUp2(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp2, props);
};
var ArrowUp3 = function ArrowUp3(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp3, props);
};
var ArrowUp4 = function ArrowUp4(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp4, props);
};
var ArrowUp5 = function ArrowUp5(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp5, props);
};
var ArrowUp6 = function ArrowUp6(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp6, props);
};
var ArrowUp7 = function ArrowUp7(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp7, props);
};
var ArrowUp8 = function ArrowUp8(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp8, props);
};
var ArrowUp9 = function ArrowUp9(props) {
  return /*#__PURE__*/React.createElement(SvgArrowUp9, props);
};
var AtSign = function AtSign(props) {
  return /*#__PURE__*/React.createElement(SvgAtSign, props);
};
var Atom = function Atom(props) {
  return /*#__PURE__*/React.createElement(SvgAtom, props);
};
var Atom2 = function Atom2(props) {
  return /*#__PURE__*/React.createElement(SvgAtom2, props);
};
var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement(SvgAttachment, props);
};
var Attachment2 = function Attachment2(props) {
  return /*#__PURE__*/React.createElement(SvgAttachment2, props);
};
var Backspace = function Backspace(props) {
  return /*#__PURE__*/React.createElement(SvgBackspace, props);
};
var Backspace2 = function Backspace2(props) {
  return /*#__PURE__*/React.createElement(SvgBackspace2, props);
};
var Backward = function Backward(props) {
  return /*#__PURE__*/React.createElement(SvgBackward, props);
};
var Backward2 = function Backward2(props) {
  return /*#__PURE__*/React.createElement(SvgBackward2, props);
};
var Baffled = function Baffled(props) {
  return /*#__PURE__*/React.createElement(SvgBaffled, props);
};
var Baffled2 = function Baffled2(props) {
  return /*#__PURE__*/React.createElement(SvgBaffled2, props);
};
var Bag = function Bag(props) {
  return /*#__PURE__*/React.createElement(SvgBag, props);
};
var Bag2 = function Bag2(props) {
  return /*#__PURE__*/React.createElement(SvgBag2, props);
};
var Balance = function Balance(props) {
  return /*#__PURE__*/React.createElement(SvgBalance, props);
};
var Balloon = function Balloon(props) {
  return /*#__PURE__*/React.createElement(SvgBalloon, props);
};
var Barcode = function Barcode(props) {
  return /*#__PURE__*/React.createElement(SvgBarcode, props);
};
var Barcode2 = function Barcode2(props) {
  return /*#__PURE__*/React.createElement(SvgBarcode2, props);
};
var Baseball = function Baseball(props) {
  return /*#__PURE__*/React.createElement(SvgBaseball, props);
};
var Basecamp = function Basecamp(props) {
  return /*#__PURE__*/React.createElement(SvgBasecamp, props);
};
var Basket = function Basket(props) {
  return /*#__PURE__*/React.createElement(SvgBasket, props);
};
var Basketball = function Basketball(props) {
  return /*#__PURE__*/React.createElement(SvgBasketball, props);
};
var BatteryZero = function BatteryZero(props) {
  return /*#__PURE__*/React.createElement(SvgBattery0, props);
};
var BatteryOne = function BatteryOne(props) {
  return /*#__PURE__*/React.createElement(SvgBattery1, props);
};
var BatteryTwo = function BatteryTwo(props) {
  return /*#__PURE__*/React.createElement(SvgBattery2, props);
};
var BatteryThree = function BatteryThree(props) {
  return /*#__PURE__*/React.createElement(SvgBattery3, props);
};
var BatteryFour = function BatteryFour(props) {
  return /*#__PURE__*/React.createElement(SvgBattery4, props);
};
var BatteryFive = function BatteryFive(props) {
  return /*#__PURE__*/React.createElement(SvgBattery5, props);
};
var BatterySix = function BatterySix(props) {
  return /*#__PURE__*/React.createElement(SvgBattery6, props);
};
var BatteryCharging = function BatteryCharging(props) {
  return /*#__PURE__*/React.createElement(SvgBatteryCharging, props);
};
var Bed = function Bed(props) {
  return /*#__PURE__*/React.createElement(SvgBed, props);
};
var Bed2 = function Bed2(props) {
  return /*#__PURE__*/React.createElement(SvgBed2, props);
};
var Behance = function Behance(props) {
  return /*#__PURE__*/React.createElement(SvgBehance, props);
};
var Behance2 = function Behance2(props) {
  return /*#__PURE__*/React.createElement(SvgBehance2, props);
};
var BellCheck = function BellCheck(props) {
  return /*#__PURE__*/React.createElement(SvgBellCheck, props);
};
var BellCross = function BellCross(props) {
  return /*#__PURE__*/React.createElement(SvgBellCross, props);
};
var BellMinus = function BellMinus(props) {
  return /*#__PURE__*/React.createElement(SvgBellMinus, props);
};
var BellPlus = function BellPlus(props) {
  return /*#__PURE__*/React.createElement(SvgBellPlus, props);
};
var Bell = function Bell(props) {
  return /*#__PURE__*/React.createElement(SvgBell, props);
};
var Bell2 = function Bell2(props) {
  return /*#__PURE__*/React.createElement(SvgBell2, props);
};
var Bell3 = function Bell3(props) {
  return /*#__PURE__*/React.createElement(SvgBell3, props);
};
var Bike = function Bike(props) {
  return /*#__PURE__*/React.createElement(SvgBike, props);
};
var Bin = function Bin(props) {
  return /*#__PURE__*/React.createElement(SvgBin, props);
};
var Bin2 = function Bin2(props) {
  return /*#__PURE__*/React.createElement(SvgBin2, props);
};
var Bin3 = function Bin3(props) {
  return /*#__PURE__*/React.createElement(SvgBin3, props);
};
var Bin4 = function Bin4(props) {
  return /*#__PURE__*/React.createElement(SvgBin4, props);
};
var Bin5 = function Bin5(props) {
  return /*#__PURE__*/React.createElement(SvgBin5, props);
};
var Binoculars = function Binoculars(props) {
  return /*#__PURE__*/React.createElement(SvgBinoculars, props);
};
var Binoculars2 = function Binoculars2(props) {
  return /*#__PURE__*/React.createElement(SvgBinoculars2, props);
};
var Blocked = function Blocked(props) {
  return /*#__PURE__*/React.createElement(SvgBlocked, props);
};
var Blog = function Blog(props) {
  return /*#__PURE__*/React.createElement(SvgBlog, props);
};
var Blog2 = function Blog2(props) {
  return /*#__PURE__*/React.createElement(SvgBlog2, props);
};
var Blogger = function Blogger(props) {
  return /*#__PURE__*/React.createElement(SvgBlogger, props);
};
var Blogger2 = function Blogger2(props) {
  return /*#__PURE__*/React.createElement(SvgBlogger2, props);
};
var Boat = function Boat(props) {
  return /*#__PURE__*/React.createElement(SvgBoat, props);
};
var Bold = function Bold(props) {
  return /*#__PURE__*/React.createElement(SvgBold, props);
};
var Bold2 = function Bold2(props) {
  return /*#__PURE__*/React.createElement(SvgBold2, props);
};
var Bomb = function Bomb(props) {
  return /*#__PURE__*/React.createElement(SvgBomb, props);
};
var BookPlay = function BookPlay(props) {
  return /*#__PURE__*/React.createElement(SvgBookPlay, props);
};
var Book = function Book(props) {
  return /*#__PURE__*/React.createElement(SvgBook, props);
};
var Book2 = function Book2(props) {
  return /*#__PURE__*/React.createElement(SvgBook2, props);
};
var Book3 = function Book3(props) {
  return /*#__PURE__*/React.createElement(SvgBook3, props);
};
var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/React.createElement(SvgBookmark, props);
};
var Bookmark2 = function Bookmark2(props) {
  return /*#__PURE__*/React.createElement(SvgBookmark2, props);
};
var Bookmark3 = function Bookmark3(props) {
  return /*#__PURE__*/React.createElement(SvgBookmark3, props);
};
var Bookmark4 = function Bookmark4(props) {
  return /*#__PURE__*/React.createElement(SvgBookmark4, props);
};
var Bookmarks = function Bookmarks(props) {
  return /*#__PURE__*/React.createElement(SvgBookmarks, props);
};
var Books = function Books(props) {
  return /*#__PURE__*/React.createElement(SvgBooks, props);
};
var Bottle = function Bottle(props) {
  return /*#__PURE__*/React.createElement(SvgBottle, props);
};
var Bottle2 = function Bottle2(props) {
  return /*#__PURE__*/React.createElement(SvgBottle2, props);
};
var Bottle3 = function Bottle3(props) {
  return /*#__PURE__*/React.createElement(SvgBottle3, props);
};
var Bottle4 = function Bottle4(props) {
  return /*#__PURE__*/React.createElement(SvgBottle4, props);
};
var Bow = function Bow(props) {
  return /*#__PURE__*/React.createElement(SvgBow, props);
};
var Bowling = function Bowling(props) {
  return /*#__PURE__*/React.createElement(SvgBowling, props);
};
var Bowling2 = function Bowling2(props) {
  return /*#__PURE__*/React.createElement(SvgBowling2, props);
};
var Bowtie = function Bowtie(props) {
  return /*#__PURE__*/React.createElement(SvgBowtie, props);
};
var BoxAdd = function BoxAdd(props) {
  return /*#__PURE__*/React.createElement(SvgBoxAdd, props);
};
var BoxRemove = function BoxRemove(props) {
  return /*#__PURE__*/React.createElement(SvgBoxRemove, props);
};
var Box = function Box(props) {
  return /*#__PURE__*/React.createElement(SvgBox, props);
};
var Brain = function Brain(props) {
  return /*#__PURE__*/React.createElement(SvgBrain, props);
};
var Bread = function Bread(props) {
  return /*#__PURE__*/React.createElement(SvgBread, props);
};
var Briefcase = function Briefcase(props) {
  return /*#__PURE__*/React.createElement(SvgBriefcase, props);
};
var Briefcase2 = function Briefcase2(props) {
  return /*#__PURE__*/React.createElement(SvgBriefcase2, props);
};
var Briefcase3 = function Briefcase3(props) {
  return /*#__PURE__*/React.createElement(SvgBriefcase3, props);
};
var BrightnessContrast = function BrightnessContrast(props) {
  return /*#__PURE__*/React.createElement(SvgBrightnessContrast, props);
};
var BrightnessHigh = function BrightnessHigh(props) {
  return /*#__PURE__*/React.createElement(SvgBrightnessHigh, props);
};
var BrightnessLow = function BrightnessLow(props) {
  return /*#__PURE__*/React.createElement(SvgBrightnessLow, props);
};
var BrightnessMedium = function BrightnessMedium(props) {
  return /*#__PURE__*/React.createElement(SvgBrightnessMedium, props);
};
var Broom = function Broom(props) {
  return /*#__PURE__*/React.createElement(SvgBroom, props);
};
var Brush = function Brush(props) {
  return /*#__PURE__*/React.createElement(SvgBrush, props);
};
var BubbleBlocked = function BubbleBlocked(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleBlocked, props);
};
var BubbleCancel = function BubbleCancel(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleCancel, props);
};
var BubbleCheck = function BubbleCheck(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleCheck, props);
};
var BubbleDots = function BubbleDots(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleDots, props);
};
var BubbleDots2 = function BubbleDots2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleDots2, props);
};
var BubbleDots3 = function BubbleDots3(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleDots3, props);
};
var BubbleDots4 = function BubbleDots4(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleDots4, props);
};
var BubbleFirst = function BubbleFirst(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleFirst, props);
};
var BubbleForward = function BubbleForward(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleForward, props);
};
var BubbleForward2 = function BubbleForward2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleForward2, props);
};
var BubbleHeart = function BubbleHeart(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleHeart, props);
};
var BubbleLast = function BubbleLast(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLast, props);
};
var BubbleLeft = function BubbleLeft(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLeft, props);
};
var BubbleLines = function BubbleLines(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLines, props);
};
var BubbleLines2 = function BubbleLines2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLines2, props);
};
var BubbleLines3 = function BubbleLines3(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLines3, props);
};
var BubbleLines4 = function BubbleLines4(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLines4, props);
};
var BubbleLink = function BubbleLink(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLink, props);
};
var BubbleLock = function BubbleLock(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleLock, props);
};
var BubbleMinus = function BubbleMinus(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleMinus, props);
};
var BubbleNotification = function BubbleNotification(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleNotification, props);
};
var BubbleNotification2 = function BubbleNotification2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleNotification2, props);
};
var BubblePaperclip = function BubblePaperclip(props) {
  return /*#__PURE__*/React.createElement(SvgBubblePaperclip, props);
};
var BubblePlus = function BubblePlus(props) {
  return /*#__PURE__*/React.createElement(SvgBubblePlus, props);
};
var BubbleQuote = function BubbleQuote(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleQuote, props);
};
var BubbleReply = function BubbleReply(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleReply, props);
};
var BubbleReply2 = function BubbleReply2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleReply2, props);
};
var BubbleRight = function BubbleRight(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleRight, props);
};
var BubbleSmiley = function BubbleSmiley(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleSmiley, props);
};
var BubbleStar = function BubbleStar(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleStar, props);
};
var BubbleUser = function BubbleUser(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleUser, props);
};
var BubbleVideo = function BubbleVideo(props) {
  return /*#__PURE__*/React.createElement(SvgBubbleVideo, props);
};
var Bubble = function Bubble(props) {
  return /*#__PURE__*/React.createElement(SvgBubble, props);
};
var Bubble2 = function Bubble2(props) {
  return /*#__PURE__*/React.createElement(SvgBubble2, props);
};
var Bubble3 = function Bubble3(props) {
  return /*#__PURE__*/React.createElement(SvgBubble3, props);
};
var Bubble4 = function Bubble4(props) {
  return /*#__PURE__*/React.createElement(SvgBubble4, props);
};
var Bubble5 = function Bubble5(props) {
  return /*#__PURE__*/React.createElement(SvgBubble5, props);
};
var Bubble6 = function Bubble6(props) {
  return /*#__PURE__*/React.createElement(SvgBubble6, props);
};
var Bubble7 = function Bubble7(props) {
  return /*#__PURE__*/React.createElement(SvgBubble7, props);
};
var Bubble8 = function Bubble8(props) {
  return /*#__PURE__*/React.createElement(SvgBubble8, props);
};
var Bubble9 = function Bubble9(props) {
  return /*#__PURE__*/React.createElement(SvgBubble9, props);
};
var Bubbles = function Bubbles(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles, props);
};
var Bubbles10 = function Bubbles10(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles10, props);
};
var Bubbles2 = function Bubbles2(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles2, props);
};
var Bubbles3 = function Bubbles3(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles3, props);
};
var Bubbles4 = function Bubbles4(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles4, props);
};
var Bubbles5 = function Bubbles5(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles5, props);
};
var Bubbles6 = function Bubbles6(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles6, props);
};
var Bubbles7 = function Bubbles7(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles7, props);
};
var Bubbles8 = function Bubbles8(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles8, props);
};
var Bubbles9 = function Bubbles9(props) {
  return /*#__PURE__*/React.createElement(SvgBubbles9, props);
};
var Bucket = function Bucket(props) {
  return /*#__PURE__*/React.createElement(SvgBucket, props);
};
var Bucket2 = function Bucket2(props) {
  return /*#__PURE__*/React.createElement(SvgBucket2, props);
};
var Bug = function Bug(props) {
  return /*#__PURE__*/React.createElement(SvgBug, props);
};
var Bug2 = function Bug2(props) {
  return /*#__PURE__*/React.createElement(SvgBug2, props);
};
var Bullhorn = function Bullhorn(props) {
  return /*#__PURE__*/React.createElement(SvgBullhorn, props);
};
var Bus = function Bus(props) {
  return /*#__PURE__*/React.createElement(SvgBus, props);
};
var Cabinet = function Cabinet(props) {
  return /*#__PURE__*/React.createElement(SvgCabinet, props);
};
var Cactus = function Cactus(props) {
  return /*#__PURE__*/React.createElement(SvgCactus, props);
};
var Cake = function Cake(props) {
  return /*#__PURE__*/React.createElement(SvgCake, props);
};
var Calculator = function Calculator(props) {
  return /*#__PURE__*/React.createElement(SvgCalculator, props);
};
var Calculator2 = function Calculator2(props) {
  return /*#__PURE__*/React.createElement(SvgCalculator2, props);
};
var Calculator3 = function Calculator3(props) {
  return /*#__PURE__*/React.createElement(SvgCalculator3, props);
};
var CalendarDay = function CalendarDay(props) {
  return /*#__PURE__*/React.createElement(SvgCalendarDay, props);
};
var CalendarEmpty = function CalendarEmpty(props) {
  return /*#__PURE__*/React.createElement(SvgCalendarEmpty, props);
};
var CalendarWeek = function CalendarWeek(props) {
  return /*#__PURE__*/React.createElement(SvgCalendarWeek, props);
};
var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement(SvgCalendar, props);
};
var Calendar2 = function Calendar2(props) {
  return /*#__PURE__*/React.createElement(SvgCalendar2, props);
};
var Calendar3 = function Calendar3(props) {
  return /*#__PURE__*/React.createElement(SvgCalendar3, props);
};
var Calendar4 = function Calendar4(props) {
  return /*#__PURE__*/React.createElement(SvgCalendar4, props);
};
var Calendar5 = function Calendar5(props) {
  return /*#__PURE__*/React.createElement(SvgCalendar5, props);
};
var Camera = function Camera(props) {
  return /*#__PURE__*/React.createElement(SvgCamera, props);
};
var Camera2 = function Camera2(props) {
  return /*#__PURE__*/React.createElement(SvgCamera2, props);
};
var Camera3 = function Camera3(props) {
  return /*#__PURE__*/React.createElement(SvgCamera3, props);
};
var CancelCircle = function CancelCircle(props) {
  return /*#__PURE__*/React.createElement(SvgCancelCircle, props);
};
var CancelCircle2 = function CancelCircle2(props) {
  return /*#__PURE__*/React.createElement(SvgCancelCircle2, props);
};
var CancelSquare = function CancelSquare(props) {
  return /*#__PURE__*/React.createElement(SvgCancelSquare, props);
};
var CancelSquare2 = function CancelSquare2(props) {
  return /*#__PURE__*/React.createElement(SvgCancelSquare2, props);
};
var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement(SvgCancel, props);
};
var Car = function Car(props) {
  return /*#__PURE__*/React.createElement(SvgCar, props);
};
var Car2 = function Car2(props) {
  return /*#__PURE__*/React.createElement(SvgCar2, props);
};
var CartAdd = function CartAdd(props) {
  return /*#__PURE__*/React.createElement(SvgCartAdd, props);
};
var CartAdd2 = function CartAdd2(props) {
  return /*#__PURE__*/React.createElement(SvgCartAdd2, props);
};
var CartRemove = function CartRemove(props) {
  return /*#__PURE__*/React.createElement(SvgCartRemove, props);
};
var Cart = function Cart(props) {
  return /*#__PURE__*/React.createElement(SvgCart, props);
};
var Cart2 = function Cart2(props) {
  return /*#__PURE__*/React.createElement(SvgCart2, props);
};
var Cart3 = function Cart3(props) {
  return /*#__PURE__*/React.createElement(SvgCart3, props);
};
var Cart4 = function Cart4(props) {
  return /*#__PURE__*/React.createElement(SvgCart4, props);
};
var Cart5 = function Cart5(props) {
  return /*#__PURE__*/React.createElement(SvgCart5, props);
};
var Cash = function Cash(props) {
  return /*#__PURE__*/React.createElement(SvgCash, props);
};
var Cash2 = function Cash2(props) {
  return /*#__PURE__*/React.createElement(SvgCash2, props);
};
var Cash3 = function Cash3(props) {
  return /*#__PURE__*/React.createElement(SvgCash3, props);
};
var Cash4 = function Cash4(props) {
  return /*#__PURE__*/React.createElement(SvgCash4, props);
};
var Cassette = function Cassette(props) {
  return /*#__PURE__*/React.createElement(SvgCassette, props);
};
var Cc = function Cc(props) {
  return /*#__PURE__*/React.createElement(SvgCc, props);
};
var Certificate = function Certificate(props) {
  return /*#__PURE__*/React.createElement(SvgCertificate, props);
};
var Chair = function Chair(props) {
  return /*#__PURE__*/React.createElement(SvgChair, props);
};
var Chart = function Chart(props) {
  return /*#__PURE__*/React.createElement(SvgChart, props);
};
var CheckboxChecked = function CheckboxChecked(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxChecked, props);
};
var CheckboxChecked2 = function CheckboxChecked2(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxChecked2, props);
};
var CheckboxPartial = function CheckboxPartial(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxPartial, props);
};
var CheckboxPartial2 = function CheckboxPartial2(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxPartial2, props);
};
var CheckboxUnchecked = function CheckboxUnchecked(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxUnchecked, props);
};
var CheckboxUnchecked2 = function CheckboxUnchecked2(props) {
  return /*#__PURE__*/React.createElement(SvgCheckboxUnchecked2, props);
};
var CheckmarkCircle = function CheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkCircle, props);
};
var Checkmark = function Checkmark(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmark, props);
};
var Checkmark2 = function Checkmark2(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmark2, props);
};
var Checkmark3 = function Checkmark3(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmark3, props);
};
var Checkmark4 = function Checkmark4(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmark4, props);
};
var Checkmark5 = function Checkmark5(props) {
  return /*#__PURE__*/React.createElement(SvgCheckmark5, props);
};
var Cheese = function Cheese(props) {
  return /*#__PURE__*/React.createElement(SvgCheese, props);
};
var Cherry = function Cherry(props) {
  return /*#__PURE__*/React.createElement(SvgCherry, props);
};
var ChessBishop = function ChessBishop(props) {
  return /*#__PURE__*/React.createElement(SvgChessBishop, props);
};
var ChessKing = function ChessKing(props) {
  return /*#__PURE__*/React.createElement(SvgChessKing, props);
};
var ChessKnight = function ChessKnight(props) {
  return /*#__PURE__*/React.createElement(SvgChessKnight, props);
};
var ChessPawn = function ChessPawn(props) {
  return /*#__PURE__*/React.createElement(SvgChessPawn, props);
};
var ChessQueen = function ChessQueen(props) {
  return /*#__PURE__*/React.createElement(SvgChessQueen, props);
};
var ChessRook = function ChessRook(props) {
  return /*#__PURE__*/React.createElement(SvgChessRook, props);
};
var Chess = function Chess(props) {
  return /*#__PURE__*/React.createElement(SvgChess, props);
};
var Chicken = function Chicken(props) {
  return /*#__PURE__*/React.createElement(SvgChicken, props);
};
var Chip = function Chip(props) {
  return /*#__PURE__*/React.createElement(SvgChip, props);
};
var Chopper = function Chopper(props) {
  return /*#__PURE__*/React.createElement(SvgChopper, props);
};
var Chopper2 = function Chopper2(props) {
  return /*#__PURE__*/React.createElement(SvgChopper2, props);
};
var Chrome = function Chrome(props) {
  return /*#__PURE__*/React.createElement(SvgChrome, props);
};
var CircleCode = function CircleCode(props) {
  return /*#__PURE__*/React.createElement(SvgCircleCode, props);
};
var CircleCss = function CircleCss(props) {
  return /*#__PURE__*/React.createElement(SvgCircleCss, props);
};
var CircleDownLeft = function CircleDownLeft(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDownLeft, props);
};
var CircleDownLeft2 = function CircleDownLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDownLeft2, props);
};
var CircleDownRight = function CircleDownRight(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDownRight, props);
};
var CircleDownRight2 = function CircleDownRight2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDownRight2, props);
};
var CircleDown = function CircleDown(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown, props);
};
var CircleDown2 = function CircleDown2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown2, props);
};
var CircleDown3 = function CircleDown3(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown3, props);
};
var CircleDown4 = function CircleDown4(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown4, props);
};
var CircleDown5 = function CircleDown5(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown5, props);
};
var CircleDown6 = function CircleDown6(props) {
  return /*#__PURE__*/React.createElement(SvgCircleDown6, props);
};
var CircleLeft = function CircleLeft(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft, props);
};
var CircleLeft2 = function CircleLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft2, props);
};
var CircleLeft3 = function CircleLeft3(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft3, props);
};
var CircleLeft4 = function CircleLeft4(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft4, props);
};
var CircleLeft5 = function CircleLeft5(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft5, props);
};
var CircleLeft6 = function CircleLeft6(props) {
  return /*#__PURE__*/React.createElement(SvgCircleLeft6, props);
};
var CircleRight = function CircleRight(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight, props);
};
var CircleRight2 = function CircleRight2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight2, props);
};
var CircleRight3 = function CircleRight3(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight3, props);
};
var CircleRight4 = function CircleRight4(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight4, props);
};
var CircleRight5 = function CircleRight5(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight5, props);
};
var CircleRight6 = function CircleRight6(props) {
  return /*#__PURE__*/React.createElement(SvgCircleRight6, props);
};
var CircleSmall = function CircleSmall(props) {
  return /*#__PURE__*/React.createElement(SvgCircleSmall, props);
};
var CircleUpLeft = function CircleUpLeft(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUpLeft, props);
};
var CircleUpLeft2 = function CircleUpLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUpLeft2, props);
};
var CircleUpRight = function CircleUpRight(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUpRight, props);
};
var CircleUpRight2 = function CircleUpRight2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUpRight2, props);
};
var CircleUp = function CircleUp(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp, props);
};
var CircleUp2 = function CircleUp2(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp2, props);
};
var CircleUp3 = function CircleUp3(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp3, props);
};
var CircleUp4 = function CircleUp4(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp4, props);
};
var CircleUp5 = function CircleUp5(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp5, props);
};
var CircleUp6 = function CircleUp6(props) {
  return /*#__PURE__*/React.createElement(SvgCircleUp6, props);
};
var Circle = function Circle(props) {
  return /*#__PURE__*/React.createElement(SvgCircle, props);
};
var Circle2 = function Circle2(props) {
  return /*#__PURE__*/React.createElement(SvgCircle2, props);
};
var Circles = function Circles(props) {
  return /*#__PURE__*/React.createElement(SvgCircles, props);
};
var Circles2 = function Circles2(props) {
  return /*#__PURE__*/React.createElement(SvgCircles2, props);
};
var City = function City(props) {
  return /*#__PURE__*/React.createElement(SvgCity, props);
};
var ClapboardPlay = function ClapboardPlay(props) {
  return /*#__PURE__*/React.createElement(SvgClapboardPlay, props);
};
var Clapboard = function Clapboard(props) {
  return /*#__PURE__*/React.createElement(SvgClapboard, props);
};
var ClearFormatting = function ClearFormatting(props) {
  return /*#__PURE__*/React.createElement(SvgClearFormatting, props);
};
var Clipboard = function Clipboard(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard, props);
};
var Clipboard2 = function Clipboard2(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard2, props);
};
var Clipboard3 = function Clipboard3(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard3, props);
};
var Clipboard4 = function Clipboard4(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard4, props);
};
var Clipboard5 = function Clipboard5(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard5, props);
};
var Clipboard6 = function Clipboard6(props) {
  return /*#__PURE__*/React.createElement(SvgClipboard6, props);
};
var Clock = function Clock(props) {
  return /*#__PURE__*/React.createElement(SvgClock, props);
};
var Clock2 = function Clock2(props) {
  return /*#__PURE__*/React.createElement(SvgClock2, props);
};
var Clock3 = function Clock3(props) {
  return /*#__PURE__*/React.createElement(SvgClock3, props);
};
var Clock4 = function Clock4(props) {
  return /*#__PURE__*/React.createElement(SvgClock4, props);
};
var CloudCheck = function CloudCheck(props) {
  return /*#__PURE__*/React.createElement(SvgCloudCheck, props);
};
var CloudCheck2 = function CloudCheck2(props) {
  return /*#__PURE__*/React.createElement(SvgCloudCheck2, props);
};
var CloudDownload = function CloudDownload(props) {
  return /*#__PURE__*/React.createElement(SvgCloudDownload, props);
};
var CloudDownload2 = function CloudDownload2(props) {
  return /*#__PURE__*/React.createElement(SvgCloudDownload2, props);
};
var CloudUpload = function CloudUpload(props) {
  return /*#__PURE__*/React.createElement(SvgCloudUpload, props);
};
var CloudUpload2 = function CloudUpload2(props) {
  return /*#__PURE__*/React.createElement(SvgCloudUpload2, props);
};
var Cloud = function Cloud(props) {
  return /*#__PURE__*/React.createElement(SvgCloud, props);
};
var Cloud2 = function Cloud2(props) {
  return /*#__PURE__*/React.createElement(SvgCloud2, props);
};
var Clubs = function Clubs(props) {
  return /*#__PURE__*/React.createElement(SvgClubs, props);
};
var Code = function Code(props) {
  return /*#__PURE__*/React.createElement(SvgCode, props);
};
var Codepen = function Codepen(props) {
  return /*#__PURE__*/React.createElement(SvgCodepen, props);
};
var CoffeeBean = function CoffeeBean(props) {
  return /*#__PURE__*/React.createElement(SvgCoffeeBean, props);
};
var Coffee = function Coffee(props) {
  return /*#__PURE__*/React.createElement(SvgCoffee, props);
};
var Cog = function Cog(props) {
  return /*#__PURE__*/React.createElement(SvgCog, props);
};
var Cog2 = function Cog2(props) {
  return /*#__PURE__*/React.createElement(SvgCog2, props);
};
var Cog3 = function Cog3(props) {
  return /*#__PURE__*/React.createElement(SvgCog3, props);
};
var Cog4 = function Cog4(props) {
  return /*#__PURE__*/React.createElement(SvgCog4, props);
};
var Cog5 = function Cog5(props) {
  return /*#__PURE__*/React.createElement(SvgCog5, props);
};
var Cog6 = function Cog6(props) {
  return /*#__PURE__*/React.createElement(SvgCog6, props);
};
var Cog7 = function Cog7(props) {
  return /*#__PURE__*/React.createElement(SvgCog7, props);
};
var Cogs = function Cogs(props) {
  return /*#__PURE__*/React.createElement(SvgCogs, props);
};
var CoinDollar = function CoinDollar(props) {
  return /*#__PURE__*/React.createElement(SvgCoinDollar, props);
};
var CoinEuro = function CoinEuro(props) {
  return /*#__PURE__*/React.createElement(SvgCoinEuro, props);
};
var CoinPound = function CoinPound(props) {
  return /*#__PURE__*/React.createElement(SvgCoinPound, props);
};
var CoinYen = function CoinYen(props) {
  return /*#__PURE__*/React.createElement(SvgCoinYen, props);
};
var Coins = function Coins(props) {
  return /*#__PURE__*/React.createElement(SvgCoins, props);
};
var Collaboration = function Collaboration(props) {
  return /*#__PURE__*/React.createElement(SvgCollaboration, props);
};
var ColorClear = function ColorClear(props) {
  return /*#__PURE__*/React.createElement(SvgColorClear, props);
};
var ColorSampler = function ColorSampler(props) {
  return /*#__PURE__*/React.createElement(SvgColorSampler, props);
};
var Comb = function Comb(props) {
  return /*#__PURE__*/React.createElement(SvgComb, props);
};
var Command = function Command(props) {
  return /*#__PURE__*/React.createElement(SvgCommand, props);
};
var Compass = function Compass(props) {
  return /*#__PURE__*/React.createElement(SvgCompass, props);
};
var Compass2 = function Compass2(props) {
  return /*#__PURE__*/React.createElement(SvgCompass2, props);
};
var Compass3 = function Compass3(props) {
  return /*#__PURE__*/React.createElement(SvgCompass3, props);
};
var Compass4 = function Compass4(props) {
  return /*#__PURE__*/React.createElement(SvgCompass4, props);
};
var Compass5 = function Compass5(props) {
  return /*#__PURE__*/React.createElement(SvgCompass5, props);
};
var Compass6 = function Compass6(props) {
  return /*#__PURE__*/React.createElement(SvgCompass6, props);
};
var Confused = function Confused(props) {
  return /*#__PURE__*/React.createElement(SvgConfused, props);
};
var Confused2 = function Confused2(props) {
  return /*#__PURE__*/React.createElement(SvgConfused2, props);
};
var Connection = function Connection(props) {
  return /*#__PURE__*/React.createElement(SvgConnection, props);
};
var Connection2 = function Connection2(props) {
  return /*#__PURE__*/React.createElement(SvgConnection2, props);
};
var Connection3 = function Connection3(props) {
  return /*#__PURE__*/React.createElement(SvgConnection3, props);
};
var Connection4 = function Connection4(props) {
  return /*#__PURE__*/React.createElement(SvgConnection4, props);
};
var Construction = function Construction(props) {
  return /*#__PURE__*/React.createElement(SvgConstruction, props);
};
var Contrast = function Contrast(props) {
  return /*#__PURE__*/React.createElement(SvgContrast, props);
};
var Cook = function Cook(props) {
  return /*#__PURE__*/React.createElement(SvgCook, props);
};
var Cool = function Cool(props) {
  return /*#__PURE__*/React.createElement(SvgCool, props);
};
var Cool2 = function Cool2(props) {
  return /*#__PURE__*/React.createElement(SvgCool2, props);
};
var Copy = function Copy(props) {
  return /*#__PURE__*/React.createElement(SvgCopy, props);
};
var Copy2 = function Copy2(props) {
  return /*#__PURE__*/React.createElement(SvgCopy2, props);
};
var Copy3 = function Copy3(props) {
  return /*#__PURE__*/React.createElement(SvgCopy3, props);
};
var Copy4 = function Copy4(props) {
  return /*#__PURE__*/React.createElement(SvgCopy4, props);
};
var CreditCard = function CreditCard(props) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, props);
};
var CreditCard2 = function CreditCard2(props) {
  return /*#__PURE__*/React.createElement(SvgCreditCard2, props);
};
var Crop = function Crop(props) {
  return /*#__PURE__*/React.createElement(SvgCrop, props);
};
var Crop2 = function Crop2(props) {
  return /*#__PURE__*/React.createElement(SvgCrop2, props);
};
var Cross = function Cross(props) {
  return /*#__PURE__*/React.createElement(SvgCross, props);
};
var Cross2 = function Cross2(props) {
  return /*#__PURE__*/React.createElement(SvgCross2, props);
};
var Cross3 = function Cross3(props) {
  return /*#__PURE__*/React.createElement(SvgCross3, props);
};
var Crown = function Crown(props) {
  return /*#__PURE__*/React.createElement(SvgCrown, props);
};
var Crying = function Crying(props) {
  return /*#__PURE__*/React.createElement(SvgCrying, props);
};
var Crying2 = function Crying2(props) {
  return /*#__PURE__*/React.createElement(SvgCrying2, props);
};
var Css3 = function Css3(props) {
  return /*#__PURE__*/React.createElement(SvgCss3, props);
};
var Ctrl = function Ctrl(props) {
  return /*#__PURE__*/React.createElement(SvgCtrl, props);
};
var Cube = function Cube(props) {
  return /*#__PURE__*/React.createElement(SvgCube, props);
};
var Cube2 = function Cube2(props) {
  return /*#__PURE__*/React.createElement(SvgCube2, props);
};
var Cube3 = function Cube3(props) {
  return /*#__PURE__*/React.createElement(SvgCube3, props);
};
var Cube4 = function Cube4(props) {
  return /*#__PURE__*/React.createElement(SvgCube4, props);
};
var Cup = function Cup(props) {
  return /*#__PURE__*/React.createElement(SvgCup, props);
};
var Cup2 = function Cup2(props) {
  return /*#__PURE__*/React.createElement(SvgCup2, props);
};
var Cursor = function Cursor(props) {
  return /*#__PURE__*/React.createElement(SvgCursor, props);
};
var Cursor2 = function Cursor2(props) {
  return /*#__PURE__*/React.createElement(SvgCursor2, props);
};
var DatabaseAdd = function DatabaseAdd(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseAdd, props);
};
var DatabaseArrow = function DatabaseArrow(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseArrow, props);
};
var DatabaseCheck = function DatabaseCheck(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseCheck, props);
};
var DatabaseDiff = function DatabaseDiff(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseDiff, props);
};
var DatabaseEdit = function DatabaseEdit(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseEdit, props);
};
var DatabaseEdit2 = function DatabaseEdit2(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseEdit2, props);
};
var DatabaseExport = function DatabaseExport(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseExport, props);
};
var DatabaseInsert = function DatabaseInsert(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseInsert, props);
};
var DatabaseMenu = function DatabaseMenu(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseMenu, props);
};
var DatabaseRefresh = function DatabaseRefresh(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseRefresh, props);
};
var DatabaseRemove = function DatabaseRemove(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseRemove, props);
};
var DatabaseTime = function DatabaseTime(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseTime, props);
};
var DatabaseTime2 = function DatabaseTime2(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseTime2, props);
};
var DatabaseUpload = function DatabaseUpload(props) {
  return /*#__PURE__*/React.createElement(SvgDatabaseUpload, props);
};
var Database = function Database(props) {
  return /*#__PURE__*/React.createElement(SvgDatabase, props);
};
var Database2 = function Database2(props) {
  return /*#__PURE__*/React.createElement(SvgDatabase2, props);
};
var Database3 = function Database3(props) {
  return /*#__PURE__*/React.createElement(SvgDatabase3, props);
};
var Database4 = function Database4(props) {
  return /*#__PURE__*/React.createElement(SvgDatabase4, props);
};
var DayNight = function DayNight(props) {
  return /*#__PURE__*/React.createElement(SvgDayNight, props);
};
var DayNight2 = function DayNight2(props) {
  return /*#__PURE__*/React.createElement(SvgDayNight2, props);
};
var Delicious = function Delicious(props) {
  return /*#__PURE__*/React.createElement(SvgDelicious, props);
};
var Design = function Design(props) {
  return /*#__PURE__*/React.createElement(SvgDesign, props);
};
var Deviantart = function Deviantart(props) {
  return /*#__PURE__*/React.createElement(SvgDeviantart, props);
};
var Diamond = function Diamond(props) {
  return /*#__PURE__*/React.createElement(SvgDiamond, props);
};
var Diamond2 = function Diamond2(props) {
  return /*#__PURE__*/React.createElement(SvgDiamond2, props);
};
var Diamond3 = function Diamond3(props) {
  return /*#__PURE__*/React.createElement(SvgDiamond3, props);
};
var Diamond4 = function Diamond4(props) {
  return /*#__PURE__*/React.createElement(SvgDiamond4, props);
};
var Diamonds = function Diamonds(props) {
  return /*#__PURE__*/React.createElement(SvgDiamonds, props);
};
var Dice = function Dice(props) {
  return /*#__PURE__*/React.createElement(SvgDice, props);
};
var Direction = function Direction(props) {
  return /*#__PURE__*/React.createElement(SvgDirection, props);
};
var Disk = function Disk(props) {
  return /*#__PURE__*/React.createElement(SvgDisk, props);
};
var Disk2 = function Disk2(props) {
  return /*#__PURE__*/React.createElement(SvgDisk2, props);
};
var Display = function Display(props) {
  return /*#__PURE__*/React.createElement(SvgDisplay, props);
};
var Display2 = function Display2(props) {
  return /*#__PURE__*/React.createElement(SvgDisplay2, props);
};
var Display3 = function Display3(props) {
  return /*#__PURE__*/React.createElement(SvgDisplay3, props);
};
var Display4 = function Display4(props) {
  return /*#__PURE__*/React.createElement(SvgDisplay4, props);
};
var Dots = function Dots(props) {
  return /*#__PURE__*/React.createElement(SvgDots, props);
};
var Download = function Download(props) {
  return /*#__PURE__*/React.createElement(SvgDownload, props);
};
var Download11 = function Download11(props) {
  return /*#__PURE__*/React.createElement(SvgDownload11, props);
};
var Download10 = function Download10(props) {
  return /*#__PURE__*/React.createElement(SvgDownload10, props);
};
var Download2 = function Download2(props) {
  return /*#__PURE__*/React.createElement(SvgDownload2, props);
};
var Download3 = function Download3(props) {
  return /*#__PURE__*/React.createElement(SvgDownload3, props);
};
var Download4 = function Download4(props) {
  return /*#__PURE__*/React.createElement(SvgDownload4, props);
};
var Download5 = function Download5(props) {
  return /*#__PURE__*/React.createElement(SvgDownload5, props);
};
var Download6 = function Download6(props) {
  return /*#__PURE__*/React.createElement(SvgDownload6, props);
};
var Download7 = function Download7(props) {
  return /*#__PURE__*/React.createElement(SvgDownload7, props);
};
var Download8 = function Download8(props) {
  return /*#__PURE__*/React.createElement(SvgDownload8, props);
};
var Download9 = function Download9(props) {
  return /*#__PURE__*/React.createElement(SvgDownload9, props);
};
var DragLeftRight = function DragLeftRight(props) {
  return /*#__PURE__*/React.createElement(SvgDragLeftRight, props);
};
var DragLeft = function DragLeft(props) {
  return /*#__PURE__*/React.createElement(SvgDragLeft, props);
};
var DragRight = function DragRight(props) {
  return /*#__PURE__*/React.createElement(SvgDragRight, props);
};
var DrawerIn = function DrawerIn(props) {
  return /*#__PURE__*/React.createElement(SvgDrawerIn, props);
};
var DrawerOut = function DrawerOut(props) {
  return /*#__PURE__*/React.createElement(SvgDrawerOut, props);
};
var Drawer = function Drawer(props) {
  return /*#__PURE__*/React.createElement(SvgDrawer, props);
};
var Drawer2 = function Drawer2(props) {
  return /*#__PURE__*/React.createElement(SvgDrawer2, props);
};
var Drawer3 = function Drawer3(props) {
  return /*#__PURE__*/React.createElement(SvgDrawer3, props);
};
var Dribbble = function Dribbble(props) {
  return /*#__PURE__*/React.createElement(SvgDribbble, props);
};
var Drive = function Drive(props) {
  return /*#__PURE__*/React.createElement(SvgDrive, props);
};
var Dropbox = function Dropbox(props) {
  return /*#__PURE__*/React.createElement(SvgDropbox, props);
};
var DropletContrast = function DropletContrast(props) {
  return /*#__PURE__*/React.createElement(SvgDropletContrast, props);
};
var Droplet = function Droplet(props) {
  return /*#__PURE__*/React.createElement(SvgDroplet, props);
};
var Droplet2 = function Droplet2(props) {
  return /*#__PURE__*/React.createElement(SvgDroplet2, props);
};
var Dumbbell = function Dumbbell(props) {
  return /*#__PURE__*/React.createElement(SvgDumbbell, props);
};
var Earth = function Earth(props) {
  return /*#__PURE__*/React.createElement(SvgEarth, props);
};
var Earth2 = function Earth2(props) {
  return /*#__PURE__*/React.createElement(SvgEarth2, props);
};
var Earth3 = function Earth3(props) {
  return /*#__PURE__*/React.createElement(SvgEarth3, props);
};
var Edge = function Edge(props) {
  return /*#__PURE__*/React.createElement(SvgEdge, props);
};
var EightBall = function EightBall(props) {
  return /*#__PURE__*/React.createElement(SvgEightBall, props);
};
var Eject = function Eject(props) {
  return /*#__PURE__*/React.createElement(SvgEject, props);
};
var Ello = function Ello(props) {
  return /*#__PURE__*/React.createElement(SvgEllo, props);
};
var Embed = function Embed(props) {
  return /*#__PURE__*/React.createElement(SvgEmbed, props);
};
var Embed2 = function Embed2(props) {
  return /*#__PURE__*/React.createElement(SvgEmbed2, props);
};
var Enlarge = function Enlarge(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge, props);
};
var Enlarge2 = function Enlarge2(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge2, props);
};
var Enlarge3 = function Enlarge3(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge3, props);
};
var Enlarge4 = function Enlarge4(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge4, props);
};
var Enlarge5 = function Enlarge5(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge5, props);
};
var Enlarge6 = function Enlarge6(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge6, props);
};
var Enlarge7 = function Enlarge7(props) {
  return /*#__PURE__*/React.createElement(SvgEnlarge7, props);
};
var Enter = function Enter(props) {
  return /*#__PURE__*/React.createElement(SvgEnter, props);
};
var Enter2 = function Enter2(props) {
  return /*#__PURE__*/React.createElement(SvgEnter2, props);
};
var Enter3 = function Enter3(props) {
  return /*#__PURE__*/React.createElement(SvgEnter3, props);
};
var Enter4 = function Enter4(props) {
  return /*#__PURE__*/React.createElement(SvgEnter4, props);
};
var Enter5 = function Enter5(props) {
  return /*#__PURE__*/React.createElement(SvgEnter5, props);
};
var Enter6 = function Enter6(props) {
  return /*#__PURE__*/React.createElement(SvgEnter6, props);
};
var Envelop = function Envelop(props) {
  return /*#__PURE__*/React.createElement(SvgEnvelop, props);
};
var Envelop2 = function Envelop2(props) {
  return /*#__PURE__*/React.createElement(SvgEnvelop2, props);
};
var Envelop3 = function Envelop3(props) {
  return /*#__PURE__*/React.createElement(SvgEnvelop3, props);
};
var Envelop4 = function Envelop4(props) {
  return /*#__PURE__*/React.createElement(SvgEnvelop4, props);
};
var Envelop5 = function Envelop5(props) {
  return /*#__PURE__*/React.createElement(SvgEnvelop5, props);
};
var Equalizer = function Equalizer(props) {
  return /*#__PURE__*/React.createElement(SvgEqualizer, props);
};
var Equalizer2 = function Equalizer2(props) {
  return /*#__PURE__*/React.createElement(SvgEqualizer2, props);
};
var Equalizer3 = function Equalizer3(props) {
  return /*#__PURE__*/React.createElement(SvgEqualizer3, props);
};
var Equalizer4 = function Equalizer4(props) {
  return /*#__PURE__*/React.createElement(SvgEqualizer4, props);
};
var Eraser = function Eraser(props) {
  return /*#__PURE__*/React.createElement(SvgEraser, props);
};
var Eraser2 = function Eraser2(props) {
  return /*#__PURE__*/React.createElement(SvgEraser2, props);
};
var Eraser3 = function Eraser3(props) {
  return /*#__PURE__*/React.createElement(SvgEraser3, props);
};
var Esc = function Esc(props) {
  return /*#__PURE__*/React.createElement(SvgEsc, props);
};
var Evil = function Evil(props) {
  return /*#__PURE__*/React.createElement(SvgEvil, props);
};
var Evil2 = function Evil2(props) {
  return /*#__PURE__*/React.createElement(SvgEvil2, props);
};
var Exclude = function Exclude(props) {
  return /*#__PURE__*/React.createElement(SvgExclude, props);
};
var Exit = function Exit(props) {
  return /*#__PURE__*/React.createElement(SvgExit, props);
};
var Exit2 = function Exit2(props) {
  return /*#__PURE__*/React.createElement(SvgExit2, props);
};
var Exit3 = function Exit3(props) {
  return /*#__PURE__*/React.createElement(SvgExit3, props);
};
var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement(SvgExternalLink, props);
};
var EyeBlocked = function EyeBlocked(props) {
  return /*#__PURE__*/React.createElement(SvgEyeBlocked, props);
};
var EyeBlocked2 = function EyeBlocked2(props) {
  return /*#__PURE__*/React.createElement(SvgEyeBlocked2, props);
};
var EyeBlocked3 = function EyeBlocked3(props) {
  return /*#__PURE__*/React.createElement(SvgEyeBlocked3, props);
};
var EyeMinus = function EyeMinus(props) {
  return /*#__PURE__*/React.createElement(SvgEyeMinus, props);
};
var EyePlus = function EyePlus(props) {
  return /*#__PURE__*/React.createElement(SvgEyePlus, props);
};
var Eye = function Eye(props) {
  return /*#__PURE__*/React.createElement(SvgEye, props);
};
var Eye2 = function Eye2(props) {
  return /*#__PURE__*/React.createElement(SvgEye2, props);
};
var Eye3 = function Eye3(props) {
  return /*#__PURE__*/React.createElement(SvgEye3, props);
};
var Eye4 = function Eye4(props) {
  return /*#__PURE__*/React.createElement(SvgEye4, props);
};
var Eyedropper = function Eyedropper(props) {
  return /*#__PURE__*/React.createElement(SvgEyedropper, props);
};
var Eyedropper2 = function Eyedropper2(props) {
  return /*#__PURE__*/React.createElement(SvgEyedropper2, props);
};
var Eyedropper3 = function Eyedropper3(props) {
  return /*#__PURE__*/React.createElement(SvgEyedropper3, props);
};
var Facebook = function Facebook(props) {
  return /*#__PURE__*/React.createElement(SvgFacebook, props);
};
var Facebook2 = function Facebook2(props) {
  return /*#__PURE__*/React.createElement(SvgFacebook2, props);
};
var Factory = function Factory(props) {
  return /*#__PURE__*/React.createElement(SvgFactory, props);
};
var Fan = function Fan(props) {
  return /*#__PURE__*/React.createElement(SvgFan, props);
};
var Feed = function Feed(props) {
  return /*#__PURE__*/React.createElement(SvgFeed, props);
};
var Female = function Female(props) {
  return /*#__PURE__*/React.createElement(SvgFemale, props);
};
var Fence = function Fence(props) {
  return /*#__PURE__*/React.createElement(SvgFence, props);
};
var FileCheck = function FileCheck(props) {
  return /*#__PURE__*/React.createElement(SvgFileCheck, props);
};
var FileCheck2 = function FileCheck2(props) {
  return /*#__PURE__*/React.createElement(SvgFileCheck2, props);
};
var FileCss = function FileCss(props) {
  return /*#__PURE__*/React.createElement(SvgFileCss, props);
};
var FileCss2 = function FileCss2(props) {
  return /*#__PURE__*/React.createElement(SvgFileCss2, props);
};
var FileDownload = function FileDownload(props) {
  return /*#__PURE__*/React.createElement(SvgFileDownload, props);
};
var FileDownload2 = function FileDownload2(props) {
  return /*#__PURE__*/React.createElement(SvgFileDownload2, props);
};
var FileEmpty = function FileEmpty(props) {
  return /*#__PURE__*/React.createElement(SvgFileEmpty, props);
};
var FileEmpty2 = function FileEmpty2(props) {
  return /*#__PURE__*/React.createElement(SvgFileEmpty2, props);
};
var FileExcel = function FileExcel(props) {
  return /*#__PURE__*/React.createElement(SvgFileExcel, props);
};
var FileEye = function FileEye(props) {
  return /*#__PURE__*/React.createElement(SvgFileEye, props);
};
var FileEye2 = function FileEye2(props) {
  return /*#__PURE__*/React.createElement(SvgFileEye2, props);
};
var FileLocked = function FileLocked(props) {
  return /*#__PURE__*/React.createElement(SvgFileLocked, props);
};
var FileLocked2 = function FileLocked2(props) {
  return /*#__PURE__*/React.createElement(SvgFileLocked2, props);
};
var FileMinus = function FileMinus(props) {
  return /*#__PURE__*/React.createElement(SvgFileMinus, props);
};
var FileMinus2 = function FileMinus2(props) {
  return /*#__PURE__*/React.createElement(SvgFileMinus2, props);
};
var FileMusic = function FileMusic(props) {
  return /*#__PURE__*/React.createElement(SvgFileMusic, props);
};
var FileMusic2 = function FileMusic2(props) {
  return /*#__PURE__*/React.createElement(SvgFileMusic2, props);
};
var FileOpenoffice = function FileOpenoffice(props) {
  return /*#__PURE__*/React.createElement(SvgFileOpenoffice, props);
};
var FilePdf = function FilePdf(props) {
  return /*#__PURE__*/React.createElement(SvgFilePdf, props);
};
var FilePicture = function FilePicture(props) {
  return /*#__PURE__*/React.createElement(SvgFilePicture, props);
};
var FilePicture2 = function FilePicture2(props) {
  return /*#__PURE__*/React.createElement(SvgFilePicture2, props);
};
var FilePlay = function FilePlay(props) {
  return /*#__PURE__*/React.createElement(SvgFilePlay, props);
};
var FilePlay2 = function FilePlay2(props) {
  return /*#__PURE__*/React.createElement(SvgFilePlay2, props);
};
var FilePlus = function FilePlus(props) {
  return /*#__PURE__*/React.createElement(SvgFilePlus, props);
};
var FilePlus2 = function FilePlus2(props) {
  return /*#__PURE__*/React.createElement(SvgFilePlus2, props);
};
var FilePresentation = function FilePresentation(props) {
  return /*#__PURE__*/React.createElement(SvgFilePresentation, props);
};
var FilePresentation2 = function FilePresentation2(props) {
  return /*#__PURE__*/React.createElement(SvgFilePresentation2, props);
};
var FileSpreadsheet = function FileSpreadsheet(props) {
  return /*#__PURE__*/React.createElement(SvgFileSpreadsheet, props);
};
var FileSpreadsheet2 = function FileSpreadsheet2(props) {
  return /*#__PURE__*/React.createElement(SvgFileSpreadsheet2, props);
};
var FileStats = function FileStats(props) {
  return /*#__PURE__*/React.createElement(SvgFileStats, props);
};
var FileStats2 = function FileStats2(props) {
  return /*#__PURE__*/React.createElement(SvgFileStats2, props);
};
var FileText = function FileText(props) {
  return /*#__PURE__*/React.createElement(SvgFileText, props);
};
var FileText2 = function FileText2(props) {
  return /*#__PURE__*/React.createElement(SvgFileText2, props);
};
var FileText3 = function FileText3(props) {
  return /*#__PURE__*/React.createElement(SvgFileText3, props);
};
var FileUpload = function FileUpload(props) {
  return /*#__PURE__*/React.createElement(SvgFileUpload, props);
};
var FileUpload2 = function FileUpload2(props) {
  return /*#__PURE__*/React.createElement(SvgFileUpload2, props);
};
var FileVideo = function FileVideo(props) {
  return /*#__PURE__*/React.createElement(SvgFileVideo, props);
};
var FileVideo2 = function FileVideo2(props) {
  return /*#__PURE__*/React.createElement(SvgFileVideo2, props);
};
var FileWord = function FileWord(props) {
  return /*#__PURE__*/React.createElement(SvgFileWord, props);
};
var FileXml = function FileXml(props) {
  return /*#__PURE__*/React.createElement(SvgFileXml, props);
};
var FileXml2 = function FileXml2(props) {
  return /*#__PURE__*/React.createElement(SvgFileXml2, props);
};
var FileZip = function FileZip(props) {
  return /*#__PURE__*/React.createElement(SvgFileZip, props);
};
var FileZip2 = function FileZip2(props) {
  return /*#__PURE__*/React.createElement(SvgFileZip2, props);
};
var FilesEmpty = function FilesEmpty(props) {
  return /*#__PURE__*/React.createElement(SvgFilesEmpty, props);
};
var FilesEmpty2 = function FilesEmpty2(props) {
  return /*#__PURE__*/React.createElement(SvgFilesEmpty2, props);
};
var Film = function Film(props) {
  return /*#__PURE__*/React.createElement(SvgFilm, props);
};
var Film2 = function Film2(props) {
  return /*#__PURE__*/React.createElement(SvgFilm2, props);
};
var Film3 = function Film3(props) {
  return /*#__PURE__*/React.createElement(SvgFilm3, props);
};
var Film4 = function Film4(props) {
  return /*#__PURE__*/React.createElement(SvgFilm4, props);
};
var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement(SvgFilter, props);
};
var Filter2 = function Filter2(props) {
  return /*#__PURE__*/React.createElement(SvgFilter2, props);
};
var Filter3 = function Filter3(props) {
  return /*#__PURE__*/React.createElement(SvgFilter3, props);
};
var Filter4 = function Filter4(props) {
  return /*#__PURE__*/React.createElement(SvgFilter4, props);
};
var Finder = function Finder(props) {
  return /*#__PURE__*/React.createElement(SvgFinder, props);
};
var Finish = function Finish(props) {
  return /*#__PURE__*/React.createElement(SvgFinish, props);
};
var Fire = function Fire(props) {
  return /*#__PURE__*/React.createElement(SvgFire, props);
};
var Fire2 = function Fire2(props) {
  return /*#__PURE__*/React.createElement(SvgFire2, props);
};
var Firefox = function Firefox(props) {
  return /*#__PURE__*/React.createElement(SvgFirefox, props);
};
var First = function First(props) {
  return /*#__PURE__*/React.createElement(SvgFirst, props);
};
var First2 = function First2(props) {
  return /*#__PURE__*/React.createElement(SvgFirst2, props);
};
var Fish = function Fish(props) {
  return /*#__PURE__*/React.createElement(SvgFish, props);
};
var Flag = function Flag(props) {
  return /*#__PURE__*/React.createElement(SvgFlag, props);
};
var Flag2 = function Flag2(props) {
  return /*#__PURE__*/React.createElement(SvgFlag2, props);
};
var Flag3 = function Flag3(props) {
  return /*#__PURE__*/React.createElement(SvgFlag3, props);
};
var Flag4 = function Flag4(props) {
  return /*#__PURE__*/React.createElement(SvgFlag4, props);
};
var Flag5 = function Flag5(props) {
  return /*#__PURE__*/React.createElement(SvgFlag5, props);
};
var Flag6 = function Flag6(props) {
  return /*#__PURE__*/React.createElement(SvgFlag6, props);
};
var Flag7 = function Flag7(props) {
  return /*#__PURE__*/React.createElement(SvgFlag7, props);
};
var Flag8 = function Flag8(props) {
  return /*#__PURE__*/React.createElement(SvgFlag8, props);
};
var Flattr = function Flattr(props) {
  return /*#__PURE__*/React.createElement(SvgFlattr, props);
};
var Flickr = function Flickr(props) {
  return /*#__PURE__*/React.createElement(SvgFlickr, props);
};
var Flickr2 = function Flickr2(props) {
  return /*#__PURE__*/React.createElement(SvgFlickr2, props);
};
var Flickr3 = function Flickr3(props) {
  return /*#__PURE__*/React.createElement(SvgFlickr3, props);
};
var Flickr4 = function Flickr4(props) {
  return /*#__PURE__*/React.createElement(SvgFlickr4, props);
};
var FlipHorizontal = function FlipHorizontal(props) {
  return /*#__PURE__*/React.createElement(SvgFlipHorizontal, props);
};
var FlipHorizontal2 = function FlipHorizontal2(props) {
  return /*#__PURE__*/React.createElement(SvgFlipHorizontal2, props);
};
var FlipVertical = function FlipVertical(props) {
  return /*#__PURE__*/React.createElement(SvgFlipVertical, props);
};
var FlipVertical2 = function FlipVertical2(props) {
  return /*#__PURE__*/React.createElement(SvgFlipVertical2, props);
};
var FlipVertical3 = function FlipVertical3(props) {
  return /*#__PURE__*/React.createElement(SvgFlipVertical3, props);
};
var FlipVertical4 = function FlipVertical4(props) {
  return /*#__PURE__*/React.createElement(SvgFlipVertical4, props);
};
var FloppyDisk = function FloppyDisk(props) {
  return /*#__PURE__*/React.createElement(SvgFloppyDisk, props);
};
var FloppyDisk2 = function FloppyDisk2(props) {
  return /*#__PURE__*/React.createElement(SvgFloppyDisk2, props);
};
var FloppyDisk3 = function FloppyDisk3(props) {
  return /*#__PURE__*/React.createElement(SvgFloppyDisk3, props);
};
var FloppyDisks = function FloppyDisks(props) {
  return /*#__PURE__*/React.createElement(SvgFloppyDisks, props);
};
var FloppyDisks2 = function FloppyDisks2(props) {
  return /*#__PURE__*/React.createElement(SvgFloppyDisks2, props);
};
var Flower = function Flower(props) {
  return /*#__PURE__*/React.createElement(SvgFlower, props);
};
var Flower2 = function Flower2(props) {
  return /*#__PURE__*/React.createElement(SvgFlower2, props);
};
var FolderCheck = function FolderCheck(props) {
  return /*#__PURE__*/React.createElement(SvgFolderCheck, props);
};
var FolderDownload = function FolderDownload(props) {
  return /*#__PURE__*/React.createElement(SvgFolderDownload, props);
};
var FolderDownload2 = function FolderDownload2(props) {
  return /*#__PURE__*/React.createElement(SvgFolderDownload2, props);
};
var FolderDownload3 = function FolderDownload3(props) {
  return /*#__PURE__*/React.createElement(SvgFolderDownload3, props);
};
var FolderHeart = function FolderHeart(props) {
  return /*#__PURE__*/React.createElement(SvgFolderHeart, props);
};
var FolderMinus = function FolderMinus(props) {
  return /*#__PURE__*/React.createElement(SvgFolderMinus, props);
};
var FolderMinus2 = function FolderMinus2(props) {
  return /*#__PURE__*/React.createElement(SvgFolderMinus2, props);
};
var FolderMinus3 = function FolderMinus3(props) {
  return /*#__PURE__*/React.createElement(SvgFolderMinus3, props);
};
var FolderMinus4 = function FolderMinus4(props) {
  return /*#__PURE__*/React.createElement(SvgFolderMinus4, props);
};
var FolderOpen = function FolderOpen(props) {
  return /*#__PURE__*/React.createElement(SvgFolderOpen, props);
};
var FolderOpen2 = function FolderOpen2(props) {
  return /*#__PURE__*/React.createElement(SvgFolderOpen2, props);
};
var FolderOpen3 = function FolderOpen3(props) {
  return /*#__PURE__*/React.createElement(SvgFolderOpen3, props);
};
var FolderPlus = function FolderPlus(props) {
  return /*#__PURE__*/React.createElement(SvgFolderPlus, props);
};
var FolderPlus2 = function FolderPlus2(props) {
  return /*#__PURE__*/React.createElement(SvgFolderPlus2, props);
};
var FolderPlus3 = function FolderPlus3(props) {
  return /*#__PURE__*/React.createElement(SvgFolderPlus3, props);
};
var FolderPlus4 = function FolderPlus4(props) {
  return /*#__PURE__*/React.createElement(SvgFolderPlus4, props);
};
var FolderRemove = function FolderRemove(props) {
  return /*#__PURE__*/React.createElement(SvgFolderRemove, props);
};
var FolderSearch = function FolderSearch(props) {
  return /*#__PURE__*/React.createElement(SvgFolderSearch, props);
};
var FolderUpload = function FolderUpload(props) {
  return /*#__PURE__*/React.createElement(SvgFolderUpload, props);
};
var FolderUpload2 = function FolderUpload2(props) {
  return /*#__PURE__*/React.createElement(SvgFolderUpload2, props);
};
var FolderUpload3 = function FolderUpload3(props) {
  return /*#__PURE__*/React.createElement(SvgFolderUpload3, props);
};
var Folder = function Folder(props) {
  return /*#__PURE__*/React.createElement(SvgFolder, props);
};
var Folder2 = function Folder2(props) {
  return /*#__PURE__*/React.createElement(SvgFolder2, props);
};
var Folder3 = function Folder3(props) {
  return /*#__PURE__*/React.createElement(SvgFolder3, props);
};
var Folder4 = function Folder4(props) {
  return /*#__PURE__*/React.createElement(SvgFolder4, props);
};
var Folder5 = function Folder5(props) {
  return /*#__PURE__*/React.createElement(SvgFolder5, props);
};
var Folder6 = function Folder6(props) {
  return /*#__PURE__*/React.createElement(SvgFolder6, props);
};
var FontSize = function FontSize(props) {
  return /*#__PURE__*/React.createElement(SvgFontSize, props);
};
var FontSize2 = function FontSize2(props) {
  return /*#__PURE__*/React.createElement(SvgFontSize2, props);
};
var Font = function Font(props) {
  return /*#__PURE__*/React.createElement(SvgFont, props);
};
var Football = function Football(props) {
  return /*#__PURE__*/React.createElement(SvgFootball, props);
};
var Footprint = function Footprint(props) {
  return /*#__PURE__*/React.createElement(SvgFootprint, props);
};
var ForkKnife = function ForkKnife(props) {
  return /*#__PURE__*/React.createElement(SvgForkKnife, props);
};
var Forward = function Forward(props) {
  return /*#__PURE__*/React.createElement(SvgForward, props);
};
var Forward2 = function Forward2(props) {
  return /*#__PURE__*/React.createElement(SvgForward2, props);
};
var Forward3 = function Forward3(props) {
  return /*#__PURE__*/React.createElement(SvgForward3, props);
};
var Foursquare = function Foursquare(props) {
  return /*#__PURE__*/React.createElement(SvgFoursquare, props);
};
var Frustrated = function Frustrated(props) {
  return /*#__PURE__*/React.createElement(SvgFrustrated, props);
};
var Frustrated2 = function Frustrated2(props) {
  return /*#__PURE__*/React.createElement(SvgFrustrated2, props);
};
var Furniture = function Furniture(props) {
  return /*#__PURE__*/React.createElement(SvgFurniture, props);
};
var Gamepad = function Gamepad(props) {
  return /*#__PURE__*/React.createElement(SvgGamepad, props);
};
var Gamepad2 = function Gamepad2(props) {
  return /*#__PURE__*/React.createElement(SvgGamepad2, props);
};
var Gamepad3 = function Gamepad3(props) {
  return /*#__PURE__*/React.createElement(SvgGamepad3, props);
};
var Gas = function Gas(props) {
  return /*#__PURE__*/React.createElement(SvgGas, props);
};
var Gebaerdensprache = function Gebaerdensprache(props) {
  return /*#__PURE__*/React.createElement(SvgGebaerdensprache, props);
};
var Gift = function Gift(props) {
  return /*#__PURE__*/React.createElement(SvgGift, props);
};
var Gift2 = function Gift2(props) {
  return /*#__PURE__*/React.createElement(SvgGift2, props);
};
var Git = function Git(props) {
  return /*#__PURE__*/React.createElement(SvgGit, props);
};
var Github = function Github(props) {
  return /*#__PURE__*/React.createElement(SvgGithub, props);
};
var Glass = function Glass(props) {
  return /*#__PURE__*/React.createElement(SvgGlass, props);
};
var Glass2 = function Glass2(props) {
  return /*#__PURE__*/React.createElement(SvgGlass2, props);
};
var Glass3 = function Glass3(props) {
  return /*#__PURE__*/React.createElement(SvgGlass3, props);
};
var Glass4 = function Glass4(props) {
  return /*#__PURE__*/React.createElement(SvgGlass4, props);
};
var GlassesThreed = function GlassesThreed(props) {
  return /*#__PURE__*/React.createElement(SvgGlasses3D, props);
};
var GlassesThreed2 = function GlassesThreed2(props) {
  return /*#__PURE__*/React.createElement(SvgGlasses3D2, props);
};
var Glasses = function Glasses(props) {
  return /*#__PURE__*/React.createElement(SvgGlasses, props);
};
var Glasses2 = function Glasses2(props) {
  return /*#__PURE__*/React.createElement(SvgGlasses2, props);
};
var Golf = function Golf(props) {
  return /*#__PURE__*/React.createElement(SvgGolf, props);
};
var Golf2 = function Golf2(props) {
  return /*#__PURE__*/React.createElement(SvgGolf2, props);
};
var GoogleDrive = function GoogleDrive(props) {
  return /*#__PURE__*/React.createElement(SvgGoogleDrive, props);
};
var GooglePlus = function GooglePlus(props) {
  return /*#__PURE__*/React.createElement(SvgGooglePlus, props);
};
var GooglePlus2 = function GooglePlus2(props) {
  return /*#__PURE__*/React.createElement(SvgGooglePlus2, props);
};
var GooglePlus3 = function GooglePlus3(props) {
  return /*#__PURE__*/React.createElement(SvgGooglePlus3, props);
};
var Google = function Google(props) {
  return /*#__PURE__*/React.createElement(SvgGoogle, props);
};
var Google2 = function Google2(props) {
  return /*#__PURE__*/React.createElement(SvgGoogle2, props);
};
var Google3 = function Google3(props) {
  return /*#__PURE__*/React.createElement(SvgGoogle3, props);
};
var Grab = function Grab(props) {
  return /*#__PURE__*/React.createElement(SvgGrab, props);
};
var Gradient = function Gradient(props) {
  return /*#__PURE__*/React.createElement(SvgGradient, props);
};
var Graduation = function Graduation(props) {
  return /*#__PURE__*/React.createElement(SvgGraduation, props);
};
var Grapes = function Grapes(props) {
  return /*#__PURE__*/React.createElement(SvgGrapes, props);
};
var Grid = function Grid(props) {
  return /*#__PURE__*/React.createElement(SvgGrid, props);
};
var Grid2 = function Grid2(props) {
  return /*#__PURE__*/React.createElement(SvgGrid2, props);
};
var Grid3 = function Grid3(props) {
  return /*#__PURE__*/React.createElement(SvgGrid3, props);
};
var Grid4 = function Grid4(props) {
  return /*#__PURE__*/React.createElement(SvgGrid4, props);
};
var Grid5 = function Grid5(props) {
  return /*#__PURE__*/React.createElement(SvgGrid5, props);
};
var Grid6 = function Grid6(props) {
  return /*#__PURE__*/React.createElement(SvgGrid6, props);
};
var Grid7 = function Grid7(props) {
  return /*#__PURE__*/React.createElement(SvgGrid7, props);
};
var Grin = function Grin(props) {
  return /*#__PURE__*/React.createElement(SvgGrin, props);
};
var Grin2 = function Grin2(props) {
  return /*#__PURE__*/React.createElement(SvgGrin2, props);
};
var Guitar = function Guitar(props) {
  return /*#__PURE__*/React.createElement(SvgGuitar, props);
};
var GunForbidden = function GunForbidden(props) {
  return /*#__PURE__*/React.createElement(SvgGunForbidden, props);
};
var Gun = function Gun(props) {
  return /*#__PURE__*/React.createElement(SvgGun, props);
};
var Hackernews = function Hackernews(props) {
  return /*#__PURE__*/React.createElement(SvgHackernews, props);
};
var Haircut = function Haircut(props) {
  return /*#__PURE__*/React.createElement(SvgHaircut, props);
};
var Hamburger = function Hamburger(props) {
  return /*#__PURE__*/React.createElement(SvgHamburger, props);
};
var HammerWrench = function HammerWrench(props) {
  return /*#__PURE__*/React.createElement(SvgHammerWrench, props);
};
var Hammer = function Hammer(props) {
  return /*#__PURE__*/React.createElement(SvgHammer, props);
};
var Hammer2 = function Hammer2(props) {
  return /*#__PURE__*/React.createElement(SvgHammer2, props);
};
var Hand = function Hand(props) {
  return /*#__PURE__*/React.createElement(SvgHand, props);
};
var Hanger = function Hanger(props) {
  return /*#__PURE__*/React.createElement(SvgHanger, props);
};
var Hangouts = function Hangouts(props) {
  return /*#__PURE__*/React.createElement(SvgHangouts, props);
};
var Happy = function Happy(props) {
  return /*#__PURE__*/React.createElement(SvgHappy, props);
};
var Happy2 = function Happy2(props) {
  return /*#__PURE__*/React.createElement(SvgHappy2, props);
};
var Hat = function Hat(props) {
  return /*#__PURE__*/React.createElement(SvgHat, props);
};
var Headphones = function Headphones(props) {
  return /*#__PURE__*/React.createElement(SvgHeadphones, props);
};
var Headset = function Headset(props) {
  return /*#__PURE__*/React.createElement(SvgHeadset, props);
};
var HeartBroken = function HeartBroken(props) {
  return /*#__PURE__*/React.createElement(SvgHeartBroken, props);
};
var HeartBroken2 = function HeartBroken2(props) {
  return /*#__PURE__*/React.createElement(SvgHeartBroken2, props);
};
var HeartBroken3 = function HeartBroken3(props) {
  return /*#__PURE__*/React.createElement(SvgHeartBroken3, props);
};
var Heart = function Heart(props) {
  return /*#__PURE__*/React.createElement(SvgHeart, props);
};
var Heart2 = function Heart2(props) {
  return /*#__PURE__*/React.createElement(SvgHeart2, props);
};
var Heart3 = function Heart3(props) {
  return /*#__PURE__*/React.createElement(SvgHeart3, props);
};
var Heart4 = function Heart4(props) {
  return /*#__PURE__*/React.createElement(SvgHeart4, props);
};
var Heart5 = function Heart5(props) {
  return /*#__PURE__*/React.createElement(SvgHeart5, props);
};
var Heart6 = function Heart6(props) {
  return /*#__PURE__*/React.createElement(SvgHeart6, props);
};
var Heart7 = function Heart7(props) {
  return /*#__PURE__*/React.createElement(SvgHeart7, props);
};
var Heart8 = function Heart8(props) {
  return /*#__PURE__*/React.createElement(SvgHeart8, props);
};
var Height = function Height(props) {
  return /*#__PURE__*/React.createElement(SvgHeight, props);
};
var Height2 = function Height2(props) {
  return /*#__PURE__*/React.createElement(SvgHeight2, props);
};
var Highlight = function Highlight(props) {
  return /*#__PURE__*/React.createElement(SvgHighlight, props);
};
var Hipster = function Hipster(props) {
  return /*#__PURE__*/React.createElement(SvgHipster, props);
};
var Hipster2 = function Hipster2(props) {
  return /*#__PURE__*/React.createElement(SvgHipster2, props);
};
var History = function History(props) {
  return /*#__PURE__*/React.createElement(SvgHistory, props);
};
var Hockey = function Hockey(props) {
  return /*#__PURE__*/React.createElement(SvgHockey, props);
};
var Home = function Home(props) {
  return /*#__PURE__*/React.createElement(SvgHome, props);
};
var Home2 = function Home2(props) {
  return /*#__PURE__*/React.createElement(SvgHome2, props);
};
var Home3 = function Home3(props) {
  return /*#__PURE__*/React.createElement(SvgHome3, props);
};
var Home4 = function Home4(props) {
  return /*#__PURE__*/React.createElement(SvgHome4, props);
};
var Home5 = function Home5(props) {
  return /*#__PURE__*/React.createElement(SvgHome5, props);
};
var Home6 = function Home6(props) {
  return /*#__PURE__*/React.createElement(SvgHome6, props);
};
var Home7 = function Home7(props) {
  return /*#__PURE__*/React.createElement(SvgHome7, props);
};
var Home8 = function Home8(props) {
  return /*#__PURE__*/React.createElement(SvgHome8, props);
};
var Home9 = function Home9(props) {
  return /*#__PURE__*/React.createElement(SvgHome9, props);
};
var HourGlass = function HourGlass(props) {
  return /*#__PURE__*/React.createElement(SvgHourGlass, props);
};
var HourGlass2 = function HourGlass2(props) {
  return /*#__PURE__*/React.createElement(SvgHourGlass2, props);
};
var HourGlass3 = function HourGlass3(props) {
  return /*#__PURE__*/React.createElement(SvgHourGlass3, props);
};
var HtmlFive = function HtmlFive(props) {
  return /*#__PURE__*/React.createElement(SvgHtmlFive, props);
};
var HtmlFive2 = function HtmlFive2(props) {
  return /*#__PURE__*/React.createElement(SvgHtmlFive2, props);
};
var Icecream = function Icecream(props) {
  return /*#__PURE__*/React.createElement(SvgIcecream, props);
};
var IcoMoon = function IcoMoon(props) {
  return /*#__PURE__*/React.createElement(SvgIcoMoon, props);
};
var IE = function IE(props) {
  return /*#__PURE__*/React.createElement(SvgIe, props);
};
var ImageCompare = function ImageCompare(props) {
  return /*#__PURE__*/React.createElement(SvgImageCompare, props);
};
var Image = function Image(props) {
  return /*#__PURE__*/React.createElement(SvgImage, props);
};
var Image2 = function Image2(props) {
  return /*#__PURE__*/React.createElement(SvgImage2, props);
};
var Image3 = function Image3(props) {
  return /*#__PURE__*/React.createElement(SvgImage3, props);
};
var Image4 = function Image4(props) {
  return /*#__PURE__*/React.createElement(SvgImage4, props);
};
var Image5 = function Image5(props) {
  return /*#__PURE__*/React.createElement(SvgImage5, props);
};
var Image6 = function Image6(props) {
  return /*#__PURE__*/React.createElement(SvgImage6, props);
};
var Images = function Images(props) {
  return /*#__PURE__*/React.createElement(SvgImages, props);
};
var Images2 = function Images2(props) {
  return /*#__PURE__*/React.createElement(SvgImages2, props);
};
var Images3 = function Images3(props) {
  return /*#__PURE__*/React.createElement(SvgImages3, props);
};
var Import = function Import(props) {
  return /*#__PURE__*/React.createElement(SvgImport, props);
};
var Import2 = function Import2(props) {
  return /*#__PURE__*/React.createElement(SvgImport2, props);
};
var IndentDecrease = function IndentDecrease(props) {
  return /*#__PURE__*/React.createElement(SvgIndentDecrease, props);
};
var IndentDecrease2 = function IndentDecrease2(props) {
  return /*#__PURE__*/React.createElement(SvgIndentDecrease2, props);
};
var IndentIncrease = function IndentIncrease(props) {
  return /*#__PURE__*/React.createElement(SvgIndentIncrease, props);
};
var IndentIncrease2 = function IndentIncrease2(props) {
  return /*#__PURE__*/React.createElement(SvgIndentIncrease2, props);
};
var InfiniteSquare = function InfiniteSquare(props) {
  return /*#__PURE__*/React.createElement(SvgInfiniteSquare, props);
};
var Infinite = function Infinite(props) {
  return /*#__PURE__*/React.createElement(SvgInfinite, props);
};
var Infinite2 = function Infinite2(props) {
  return /*#__PURE__*/React.createElement(SvgInfinite2, props);
};
var Info = function Info(props) {
  return /*#__PURE__*/React.createElement(SvgInfo, props);
};
var Info2 = function Info2(props) {
  return /*#__PURE__*/React.createElement(SvgInfo2, props);
};
var InsertTemplate = function InsertTemplate(props) {
  return /*#__PURE__*/React.createElement(SvgInsertTemplate, props);
};
var Instagram = function Instagram(props) {
  return /*#__PURE__*/React.createElement(SvgInstagram, props);
};
var Interset = function Interset(props) {
  return /*#__PURE__*/React.createElement(SvgInterset, props);
};
var Italic = function Italic(props) {
  return /*#__PURE__*/React.createElement(SvgItalic, props);
};
var Italic2 = function Italic2(props) {
  return /*#__PURE__*/React.createElement(SvgItalic2, props);
};
var Joomla = function Joomla(props) {
  return /*#__PURE__*/React.createElement(SvgJoomla, props);
};
var KeyA = function KeyA(props) {
  return /*#__PURE__*/React.createElement(SvgKeyA, props);
};
var KeyDown = function KeyDown(props) {
  return /*#__PURE__*/React.createElement(SvgKeyDown, props);
};
var KeyKeyboard = function KeyKeyboard(props) {
  return /*#__PURE__*/React.createElement(SvgKeyKeyboard, props);
};
var KeyLeft = function KeyLeft(props) {
  return /*#__PURE__*/React.createElement(SvgKeyLeft, props);
};
var KeyRight = function KeyRight(props) {
  return /*#__PURE__*/React.createElement(SvgKeyRight, props);
};
var KeyUp = function KeyUp(props) {
  return /*#__PURE__*/React.createElement(SvgKeyUp, props);
};
var Key = function Key(props) {
  return /*#__PURE__*/React.createElement(SvgKey, props);
};
var Key2 = function Key2(props) {
  return /*#__PURE__*/React.createElement(SvgKey2, props);
};
var Key3 = function Key3(props) {
  return /*#__PURE__*/React.createElement(SvgKey3, props);
};
var Key4 = function Key4(props) {
  return /*#__PURE__*/React.createElement(SvgKey4, props);
};
var Key5 = function Key5(props) {
  return /*#__PURE__*/React.createElement(SvgKey5, props);
};
var Keyboard = function Keyboard(props) {
  return /*#__PURE__*/React.createElement(SvgKeyboard, props);
};
var Keyboard2 = function Keyboard2(props) {
  return /*#__PURE__*/React.createElement(SvgKeyboard2, props);
};
var Keyhole = function Keyhole(props) {
  return /*#__PURE__*/React.createElement(SvgKeyhole, props);
};
var Knife = function Knife(props) {
  return /*#__PURE__*/React.createElement(SvgKnife, props);
};
var Lab = function Lab(props) {
  return /*#__PURE__*/React.createElement(SvgLab, props);
};
var Ladder = function Ladder(props) {
  return /*#__PURE__*/React.createElement(SvgLadder, props);
};
var Lamp = function Lamp(props) {
  return /*#__PURE__*/React.createElement(SvgLamp, props);
};
var Lamp2 = function Lamp2(props) {
  return /*#__PURE__*/React.createElement(SvgLamp2, props);
};
var Lamp3 = function Lamp3(props) {
  return /*#__PURE__*/React.createElement(SvgLamp3, props);
};
var Lamp4 = function Lamp4(props) {
  return /*#__PURE__*/React.createElement(SvgLamp4, props);
};
var Lamp5 = function Lamp5(props) {
  return /*#__PURE__*/React.createElement(SvgLamp5, props);
};
var Lamp6 = function Lamp6(props) {
  return /*#__PURE__*/React.createElement(SvgLamp6, props);
};
var Lamp7 = function Lamp7(props) {
  return /*#__PURE__*/React.createElement(SvgLamp7, props);
};
var Lamp8 = function Lamp8(props) {
  return /*#__PURE__*/React.createElement(SvgLamp8, props);
};
var Lan = function Lan(props) {
  return /*#__PURE__*/React.createElement(SvgLan, props);
};
var Lan2 = function Lan2(props) {
  return /*#__PURE__*/React.createElement(SvgLan2, props);
};
var Lan3 = function Lan3(props) {
  return /*#__PURE__*/React.createElement(SvgLan3, props);
};
var Lanyrd = function Lanyrd(props) {
  return /*#__PURE__*/React.createElement(SvgLanyrd, props);
};
var Laptop = function Laptop(props) {
  return /*#__PURE__*/React.createElement(SvgLaptop, props);
};
var Lasso = function Lasso(props) {
  return /*#__PURE__*/React.createElement(SvgLasso, props);
};
var Lasso2 = function Lasso2(props) {
  return /*#__PURE__*/React.createElement(SvgLasso2, props);
};
var Last = function Last(props) {
  return /*#__PURE__*/React.createElement(SvgLast, props);
};
var Last2 = function Last2(props) {
  return /*#__PURE__*/React.createElement(SvgLast2, props);
};
var Lastfm = function Lastfm(props) {
  return /*#__PURE__*/React.createElement(SvgLastfm, props);
};
var Lastfm2 = function Lastfm2(props) {
  return /*#__PURE__*/React.createElement(SvgLastfm2, props);
};
var Laundry = function Laundry(props) {
  return /*#__PURE__*/React.createElement(SvgLaundry, props);
};
var Leaf = function Leaf(props) {
  return /*#__PURE__*/React.createElement(SvgLeaf, props);
};
var Leaf2 = function Leaf2(props) {
  return /*#__PURE__*/React.createElement(SvgLeaf2, props);
};
var LeichteSprache = function LeichteSprache(props) {
  return /*#__PURE__*/React.createElement(SvgLeichteSprache, props);
};
var Library = function Library(props) {
  return /*#__PURE__*/React.createElement(SvgLibrary, props);
};
var Library2 = function Library2(props) {
  return /*#__PURE__*/React.createElement(SvgLibrary2, props);
};
var Libreoffice = function Libreoffice(props) {
  return /*#__PURE__*/React.createElement(SvgLibreoffice, props);
};
var Lifebuoy = function Lifebuoy(props) {
  return /*#__PURE__*/React.createElement(SvgLifebuoy, props);
};
var Ligature = function Ligature(props) {
  return /*#__PURE__*/React.createElement(SvgLigature, props);
};
var Ligature2 = function Ligature2(props) {
  return /*#__PURE__*/React.createElement(SvgLigature2, props);
};
var Link = function Link(props) {
  return /*#__PURE__*/React.createElement(SvgLink, props);
};
var Link2 = function Link2(props) {
  return /*#__PURE__*/React.createElement(SvgLink2, props);
};
var Link3 = function Link3(props) {
  return /*#__PURE__*/React.createElement(SvgLink3, props);
};
var Link4 = function Link4(props) {
  return /*#__PURE__*/React.createElement(SvgLink4, props);
};
var Link5 = function Link5(props) {
  return /*#__PURE__*/React.createElement(SvgLink5, props);
};
var Linkedin = function Linkedin(props) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, props);
};
var Linkedin2 = function Linkedin2(props) {
  return /*#__PURE__*/React.createElement(SvgLinkedin2, props);
};
var Lips = function Lips(props) {
  return /*#__PURE__*/React.createElement(SvgLips, props);
};
var Lips2 = function Lips2(props) {
  return /*#__PURE__*/React.createElement(SvgLips2, props);
};
var ListNumbered = function ListNumbered(props) {
  return /*#__PURE__*/React.createElement(SvgListNumbered, props);
};
var List = function List(props) {
  return /*#__PURE__*/React.createElement(SvgList, props);
};
var List2 = function List2(props) {
  return /*#__PURE__*/React.createElement(SvgList2, props);
};
var Load = function Load(props) {
  return /*#__PURE__*/React.createElement(SvgLoad, props);
};
var LoadingCircle = function LoadingCircle(props) {
  return /*#__PURE__*/React.createElement(SvgLoadingCircle, props);
};
var Location = function Location(props) {
  return /*#__PURE__*/React.createElement(SvgLocation, props);
};
var Location2 = function Location2(props) {
  return /*#__PURE__*/React.createElement(SvgLocation2, props);
};
var Location3 = function Location3(props) {
  return /*#__PURE__*/React.createElement(SvgLocation3, props);
};
var Location4 = function Location4(props) {
  return /*#__PURE__*/React.createElement(SvgLocation4, props);
};
var Location5 = function Location5(props) {
  return /*#__PURE__*/React.createElement(SvgLocation5, props);
};
var Location6 = function Location6(props) {
  return /*#__PURE__*/React.createElement(SvgLocation6, props);
};
var Location7 = function Location7(props) {
  return /*#__PURE__*/React.createElement(SvgLocation7, props);
};
var Lock = function Lock(props) {
  return /*#__PURE__*/React.createElement(SvgLock, props);
};
var Lock2 = function Lock2(props) {
  return /*#__PURE__*/React.createElement(SvgLock2, props);
};
var Lock3 = function Lock3(props) {
  return /*#__PURE__*/React.createElement(SvgLock3, props);
};
var Lock4 = function Lock4(props) {
  return /*#__PURE__*/React.createElement(SvgLock4, props);
};
var Lock5 = function Lock5(props) {
  return /*#__PURE__*/React.createElement(SvgLock5, props);
};
var Login = function Login(props) {
  return /*#__PURE__*/React.createElement(SvgLogin, props);
};
var Loop = function Loop(props) {
  return /*#__PURE__*/React.createElement(SvgLoop, props);
};
var Loop2 = function Loop2(props) {
  return /*#__PURE__*/React.createElement(SvgLoop2, props);
};
var Loop3 = function Loop3(props) {
  return /*#__PURE__*/React.createElement(SvgLoop3, props);
};
var Loop4 = function Loop4(props) {
  return /*#__PURE__*/React.createElement(SvgLoop4, props);
};
var Ltr = function Ltr(props) {
  return /*#__PURE__*/React.createElement(SvgLtr, props);
};
var Ltr2 = function Ltr2(props) {
  return /*#__PURE__*/React.createElement(SvgLtr2, props);
};
var Magazine = function Magazine(props) {
  return /*#__PURE__*/React.createElement(SvgMagazine, props);
};
var MagicWand = function MagicWand(props) {
  return /*#__PURE__*/React.createElement(SvgMagicWand, props);
};
var MagicWand2 = function MagicWand2(props) {
  return /*#__PURE__*/React.createElement(SvgMagicWand2, props);
};
var Magnet = function Magnet(props) {
  return /*#__PURE__*/React.createElement(SvgMagnet, props);
};
var Magnet2 = function Magnet2(props) {
  return /*#__PURE__*/React.createElement(SvgMagnet2, props);
};
var MagnifierMenu = function MagnifierMenu(props) {
  return /*#__PURE__*/React.createElement(SvgMagnifierMenu, props);
};
var Magnifier = function Magnifier(props) {
  return /*#__PURE__*/React.createElement(SvgMagnifier, props);
};
var Mail = function Mail(props) {
  return /*#__PURE__*/React.createElement(SvgMail, props);
};
var Mail2 = function Mail2(props) {
  return /*#__PURE__*/React.createElement(SvgMail2, props);
};
var Mail3 = function Mail3(props) {
  return /*#__PURE__*/React.createElement(SvgMail3, props);
};
var Mail4 = function Mail4(props) {
  return /*#__PURE__*/React.createElement(SvgMail4, props);
};
var Mailbox = function Mailbox(props) {
  return /*#__PURE__*/React.createElement(SvgMailbox, props);
};
var MakeGroup = function MakeGroup(props) {
  return /*#__PURE__*/React.createElement(SvgMakeGroup, props);
};
var Male = function Male(props) {
  return /*#__PURE__*/React.createElement(SvgMale, props);
};
var ManWoman = function ManWoman(props) {
  return /*#__PURE__*/React.createElement(SvgManWoman, props);
};
var Man = function Man(props) {
  return /*#__PURE__*/React.createElement(SvgMan, props);
};
var Map = function Map(props) {
  return /*#__PURE__*/React.createElement(SvgMap, props);
};
var Map2 = function Map2(props) {
  return /*#__PURE__*/React.createElement(SvgMap2, props);
};
var Map3 = function Map3(props) {
  return /*#__PURE__*/React.createElement(SvgMap3, props);
};
var Map4 = function Map4(props) {
  return /*#__PURE__*/React.createElement(SvgMap4, props);
};
var Map5 = function Map5(props) {
  return /*#__PURE__*/React.createElement(SvgMap5, props);
};
var Marker = function Marker(props) {
  return /*#__PURE__*/React.createElement(SvgMarker, props);
};
var Marker2 = function Marker2(props) {
  return /*#__PURE__*/React.createElement(SvgMarker2, props);
};
var Markup = function Markup(props) {
  return /*#__PURE__*/React.createElement(SvgMarkup, props);
};
var MedalFirst = function MedalFirst(props) {
  return /*#__PURE__*/React.createElement(SvgMedalFirst, props);
};
var MedalSecond = function MedalSecond(props) {
  return /*#__PURE__*/React.createElement(SvgMedalSecond, props);
};
var MedalStar = function MedalStar(props) {
  return /*#__PURE__*/React.createElement(SvgMedalStar, props);
};
var MedalThird = function MedalThird(props) {
  return /*#__PURE__*/React.createElement(SvgMedalThird, props);
};
var Medal = function Medal(props) {
  return /*#__PURE__*/React.createElement(SvgMedal, props);
};
var Medal2 = function Medal2(props) {
  return /*#__PURE__*/React.createElement(SvgMedal2, props);
};
var Media = function Media(props) {
  return /*#__PURE__*/React.createElement(SvgMedia, props);
};
var Megaphone = function Megaphone(props) {
  return /*#__PURE__*/React.createElement(SvgMegaphone, props);
};
var MenuClose = function MenuClose(props) {
  return /*#__PURE__*/React.createElement(SvgMenuClose, props);
};
var MenuClose2 = function MenuClose2(props) {
  return /*#__PURE__*/React.createElement(SvgMenuClose2, props);
};
var MenuOpen = function MenuOpen(props) {
  return /*#__PURE__*/React.createElement(SvgMenuOpen, props);
};
var MenuOpen2 = function MenuOpen2(props) {
  return /*#__PURE__*/React.createElement(SvgMenuOpen2, props);
};
var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement(SvgMenu, props);
};
var Menu10 = function Menu10(props) {
  return /*#__PURE__*/React.createElement(SvgMenu10, props);
};
var Menu2 = function Menu2(props) {
  return /*#__PURE__*/React.createElement(SvgMenu2, props);
};
var Menu3 = function Menu3(props) {
  return /*#__PURE__*/React.createElement(SvgMenu3, props);
};
var Menu4 = function Menu4(props) {
  return /*#__PURE__*/React.createElement(SvgMenu4, props);
};
var Menu5 = function Menu5(props) {
  return /*#__PURE__*/React.createElement(SvgMenu5, props);
};
var Menu6 = function Menu6(props) {
  return /*#__PURE__*/React.createElement(SvgMenu6, props);
};
var Menu7 = function Menu7(props) {
  return /*#__PURE__*/React.createElement(SvgMenu7, props);
};
var Menu8 = function Menu8(props) {
  return /*#__PURE__*/React.createElement(SvgMenu8, props);
};
var Menu9 = function Menu9(props) {
  return /*#__PURE__*/React.createElement(SvgMenu9, props);
};
var Merge = function Merge(props) {
  return /*#__PURE__*/React.createElement(SvgMerge, props);
};
var MeterFast = function MeterFast(props) {
  return /*#__PURE__*/React.createElement(SvgMeterFast, props);
};
var MeterMedium = function MeterMedium(props) {
  return /*#__PURE__*/React.createElement(SvgMeterMedium, props);
};
var MeterSlow = function MeterSlow(props) {
  return /*#__PURE__*/React.createElement(SvgMeterSlow, props);
};
var Meter = function Meter(props) {
  return /*#__PURE__*/React.createElement(SvgMeter, props);
};
var Meter2 = function Meter2(props) {
  return /*#__PURE__*/React.createElement(SvgMeter2, props);
};
var Meter3 = function Meter3(props) {
  return /*#__PURE__*/React.createElement(SvgMeter3, props);
};
var MicOff = function MicOff(props) {
  return /*#__PURE__*/React.createElement(SvgMicOff, props);
};
var MicOff2 = function MicOff2(props) {
  return /*#__PURE__*/React.createElement(SvgMicOff2, props);
};
var Mic = function Mic(props) {
  return /*#__PURE__*/React.createElement(SvgMic, props);
};
var Mic2 = function Mic2(props) {
  return /*#__PURE__*/React.createElement(SvgMic2, props);
};
var Mic3 = function Mic3(props) {
  return /*#__PURE__*/React.createElement(SvgMic3, props);
};
var Mic4 = function Mic4(props) {
  return /*#__PURE__*/React.createElement(SvgMic4, props);
};
var Mic5 = function Mic5(props) {
  return /*#__PURE__*/React.createElement(SvgMic5, props);
};
var Microscope = function Microscope(props) {
  return /*#__PURE__*/React.createElement(SvgMicroscope, props);
};
var Milk = function Milk(props) {
  return /*#__PURE__*/React.createElement(SvgMilk, props);
};
var MinusCircle = function MinusCircle(props) {
  return /*#__PURE__*/React.createElement(SvgMinusCircle, props);
};
var MinusCircle2 = function MinusCircle2(props) {
  return /*#__PURE__*/React.createElement(SvgMinusCircle2, props);
};
var Minus = function Minus(props) {
  return /*#__PURE__*/React.createElement(SvgMinus, props);
};
var Minus2 = function Minus2(props) {
  return /*#__PURE__*/React.createElement(SvgMinus2, props);
};
var Minus3 = function Minus3(props) {
  return /*#__PURE__*/React.createElement(SvgMinus3, props);
};
var Mobile = function Mobile(props) {
  return /*#__PURE__*/React.createElement(SvgMobile, props);
};
var Mobile2 = function Mobile2(props) {
  return /*#__PURE__*/React.createElement(SvgMobile2, props);
};
var Mobile3 = function Mobile3(props) {
  return /*#__PURE__*/React.createElement(SvgMobile3, props);
};
var Moon = function Moon(props) {
  return /*#__PURE__*/React.createElement(SvgMoon, props);
};
var More = function More(props) {
  return /*#__PURE__*/React.createElement(SvgMore, props);
};
var More2 = function More2(props) {
  return /*#__PURE__*/React.createElement(SvgMore2, props);
};
var Mountains = function Mountains(props) {
  return /*#__PURE__*/React.createElement(SvgMountains, props);
};
var MouseLeft = function MouseLeft(props) {
  return /*#__PURE__*/React.createElement(SvgMouseLeft, props);
};
var MouseRight = function MouseRight(props) {
  return /*#__PURE__*/React.createElement(SvgMouseRight, props);
};
var Mouse = function Mouse(props) {
  return /*#__PURE__*/React.createElement(SvgMouse, props);
};
var Mouse2 = function Mouse2(props) {
  return /*#__PURE__*/React.createElement(SvgMouse2, props);
};
var MoveDown = function MoveDown(props) {
  return /*#__PURE__*/React.createElement(SvgMoveDown, props);
};
var MoveUp = function MoveUp(props) {
  return /*#__PURE__*/React.createElement(SvgMoveUp, props);
};
var Move = function Move(props) {
  return /*#__PURE__*/React.createElement(SvgMove, props);
};
var Movie = function Movie(props) {
  return /*#__PURE__*/React.createElement(SvgMovie, props);
};
var Mug = function Mug(props) {
  return /*#__PURE__*/React.createElement(SvgMug, props);
};
var Multitouch = function Multitouch(props) {
  return /*#__PURE__*/React.createElement(SvgMultitouch, props);
};
var Music = function Music(props) {
  return /*#__PURE__*/React.createElement(SvgMusic, props);
};
var Music2 = function Music2(props) {
  return /*#__PURE__*/React.createElement(SvgMusic2, props);
};
var Music3 = function Music3(props) {
  return /*#__PURE__*/React.createElement(SvgMusic3, props);
};
var Music4 = function Music4(props) {
  return /*#__PURE__*/React.createElement(SvgMusic4, props);
};
var Music5 = function Music5(props) {
  return /*#__PURE__*/React.createElement(SvgMusic5, props);
};
var Music6 = function Music6(props) {
  return /*#__PURE__*/React.createElement(SvgMusic6, props);
};
var Mustache = function Mustache(props) {
  return /*#__PURE__*/React.createElement(SvgMustache, props);
};
var Mustache2 = function Mustache2(props) {
  return /*#__PURE__*/React.createElement(SvgMustache2, props);
};
var Nbsp = function Nbsp(props) {
  return /*#__PURE__*/React.createElement(SvgNbsp, props);
};
var Neutral = function Neutral(props) {
  return /*#__PURE__*/React.createElement(SvgNeutral, props);
};
var Neutral2 = function Neutral2(props) {
  return /*#__PURE__*/React.createElement(SvgNeutral2, props);
};
var NewTab = function NewTab(props) {
  return /*#__PURE__*/React.createElement(SvgNewTab, props);
};
var NewTab2 = function NewTab2(props) {
  return /*#__PURE__*/React.createElement(SvgNewTab2, props);
};
var New = function New(props) {
  return /*#__PURE__*/React.createElement(SvgNew, props);
};
var Newspaper = function Newspaper(props) {
  return /*#__PURE__*/React.createElement(SvgNewspaper, props);
};
var Next = function Next(props) {
  return /*#__PURE__*/React.createElement(SvgNext, props);
};
var Next2 = function Next2(props) {
  return /*#__PURE__*/React.createElement(SvgNext2, props);
};
var Notebook = function Notebook(props) {
  return /*#__PURE__*/React.createElement(SvgNotebook, props);
};
var Notification = function Notification(props) {
  return /*#__PURE__*/React.createElement(SvgNotification, props);
};
var Notification2 = function Notification2(props) {
  return /*#__PURE__*/React.createElement(SvgNotification2, props);
};
var Npm = function Npm(props) {
  return /*#__PURE__*/React.createElement(SvgNpm, props);
};
var Office = function Office(props) {
  return /*#__PURE__*/React.createElement(SvgOffice, props);
};
var Omega = function Omega(props) {
  return /*#__PURE__*/React.createElement(SvgOmega, props);
};
var Onedrive = function Onedrive(props) {
  return /*#__PURE__*/React.createElement(SvgOnedrive, props);
};
var Opera = function Opera(props) {
  return /*#__PURE__*/React.createElement(SvgOpera, props);
};
var Opt = function Opt(props) {
  return /*#__PURE__*/React.createElement(SvgOpt, props);
};
var Outlet = function Outlet(props) {
  return /*#__PURE__*/React.createElement(SvgOutlet, props);
};
var Package = function Package(props) {
  return /*#__PURE__*/React.createElement(SvgPackage, props);
};
var Pacman = function Pacman(props) {
  return /*#__PURE__*/React.createElement(SvgPacman, props);
};
var PageBreak = function PageBreak(props) {
  return /*#__PURE__*/React.createElement(SvgPageBreak, props);
};
var PageBreak2 = function PageBreak2(props) {
  return /*#__PURE__*/React.createElement(SvgPageBreak2, props);
};
var Pagebreak = function Pagebreak(props) {
  return /*#__PURE__*/React.createElement(SvgPagebreak, props);
};
var PaintFormat = function PaintFormat(props) {
  return /*#__PURE__*/React.createElement(SvgPaintFormat, props);
};
var Palette = function Palette(props) {
  return /*#__PURE__*/React.createElement(SvgPalette, props);
};
var Palette2 = function Palette2(props) {
  return /*#__PURE__*/React.createElement(SvgPalette2, props);
};
var Pandage = function Pandage(props) {
  return /*#__PURE__*/React.createElement(SvgPandage, props);
};
var Pandage2 = function Pandage2(props) {
  return /*#__PURE__*/React.createElement(SvgPandage2, props);
};
var Pants = function Pants(props) {
  return /*#__PURE__*/React.createElement(SvgPants, props);
};
var Paperplane = function Paperplane(props) {
  return /*#__PURE__*/React.createElement(SvgPaperplane, props);
};
var ParagraphCenter = function ParagraphCenter(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphCenter, props);
};
var ParagraphCenter2 = function ParagraphCenter2(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphCenter2, props);
};
var ParagraphCenter3 = function ParagraphCenter3(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphCenter3, props);
};
var ParagraphJustify = function ParagraphJustify(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphJustify, props);
};
var ParagraphJustify2 = function ParagraphJustify2(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphJustify2, props);
};
var ParagraphJustify3 = function ParagraphJustify3(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphJustify3, props);
};
var ParagraphLeft = function ParagraphLeft(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphLeft, props);
};
var ParagraphLeft2 = function ParagraphLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphLeft2, props);
};
var ParagraphLeft3 = function ParagraphLeft3(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphLeft3, props);
};
var ParagraphRight = function ParagraphRight(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphRight, props);
};
var ParagraphRight2 = function ParagraphRight2(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphRight2, props);
};
var ParagraphRight3 = function ParagraphRight3(props) {
  return /*#__PURE__*/React.createElement(SvgParagraphRight3, props);
};
var Paste = function Paste(props) {
  return /*#__PURE__*/React.createElement(SvgPaste, props);
};
var Paste2 = function Paste2(props) {
  return /*#__PURE__*/React.createElement(SvgPaste2, props);
};
var Paste3 = function Paste3(props) {
  return /*#__PURE__*/React.createElement(SvgPaste3, props);
};
var Paste4 = function Paste4(props) {
  return /*#__PURE__*/React.createElement(SvgPaste4, props);
};
var Pause = function Pause(props) {
  return /*#__PURE__*/React.createElement(SvgPause, props);
};
var Pause2 = function Pause2(props) {
  return /*#__PURE__*/React.createElement(SvgPause2, props);
};
var Paw = function Paw(props) {
  return /*#__PURE__*/React.createElement(SvgPaw, props);
};
var Paypal = function Paypal(props) {
  return /*#__PURE__*/React.createElement(SvgPaypal, props);
};
var Peace = function Peace(props) {
  return /*#__PURE__*/React.createElement(SvgPeace, props);
};
var PenMinus = function PenMinus(props) {
  return /*#__PURE__*/React.createElement(SvgPenMinus, props);
};
var PenPlus = function PenPlus(props) {
  return /*#__PURE__*/React.createElement(SvgPenPlus, props);
};
var Pen = function Pen(props) {
  return /*#__PURE__*/React.createElement(SvgPen, props);
};
var Pen2 = function Pen2(props) {
  return /*#__PURE__*/React.createElement(SvgPen2, props);
};
var Pen3 = function Pen3(props) {
  return /*#__PURE__*/React.createElement(SvgPen3, props);
};
var Pen4 = function Pen4(props) {
  return /*#__PURE__*/React.createElement(SvgPen4, props);
};
var Pen5 = function Pen5(props) {
  return /*#__PURE__*/React.createElement(SvgPen5, props);
};
var Pen6 = function Pen6(props) {
  return /*#__PURE__*/React.createElement(SvgPen6, props);
};
var PencilRuler = function PencilRuler(props) {
  return /*#__PURE__*/React.createElement(SvgPencilRuler, props);
};
var Pencil = function Pencil(props) {
  return /*#__PURE__*/React.createElement(SvgPencil, props);
};
var Pencil2 = function Pencil2(props) {
  return /*#__PURE__*/React.createElement(SvgPencil2, props);
};
var Pencil3 = function Pencil3(props) {
  return /*#__PURE__*/React.createElement(SvgPencil3, props);
};
var Pencil4 = function Pencil4(props) {
  return /*#__PURE__*/React.createElement(SvgPencil4, props);
};
var Pencil5 = function Pencil5(props) {
  return /*#__PURE__*/React.createElement(SvgPencil5, props);
};
var Pencil6 = function Pencil6(props) {
  return /*#__PURE__*/React.createElement(SvgPencil6, props);
};
var Pencil7 = function Pencil7(props) {
  return /*#__PURE__*/React.createElement(SvgPencil7, props);
};
var Percent = function Percent(props) {
  return /*#__PURE__*/React.createElement(SvgPercent, props);
};
var PhoneHangUp = function PhoneHangUp(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneHangUp, props);
};
var PhoneHangUp2 = function PhoneHangUp2(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneHangUp2, props);
};
var PhoneIncoming = function PhoneIncoming(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneIncoming, props);
};
var PhoneMinus = function PhoneMinus(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneMinus, props);
};
var PhoneMinus2 = function PhoneMinus2(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneMinus2, props);
};
var PhoneOutgoing = function PhoneOutgoing(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneOutgoing, props);
};
var PhonePlus = function PhonePlus(props) {
  return /*#__PURE__*/React.createElement(SvgPhonePlus, props);
};
var PhonePlus2 = function PhonePlus2(props) {
  return /*#__PURE__*/React.createElement(SvgPhonePlus2, props);
};
var PhoneSlash = function PhoneSlash(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneSlash, props);
};
var PhoneSlash2 = function PhoneSlash2(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneSlash2, props);
};
var PhoneWave = function PhoneWave(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneWave, props);
};
var PhoneWave2 = function PhoneWave2(props) {
  return /*#__PURE__*/React.createElement(SvgPhoneWave2, props);
};
var Phone = function Phone(props) {
  return /*#__PURE__*/React.createElement(SvgPhone, props);
};
var Phone2 = function Phone2(props) {
  return /*#__PURE__*/React.createElement(SvgPhone2, props);
};
var Phone3 = function Phone3(props) {
  return /*#__PURE__*/React.createElement(SvgPhone3, props);
};
var Piano = function Piano(props) {
  return /*#__PURE__*/React.createElement(SvgPiano, props);
};
var PieChart = function PieChart(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart, props);
};
var PieChart2 = function PieChart2(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart2, props);
};
var PieChart3 = function PieChart3(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart3, props);
};
var PieChart4 = function PieChart4(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart4, props);
};
var PieChart5 = function PieChart5(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart5, props);
};
var PieChart6 = function PieChart6(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart6, props);
};
var PieChart7 = function PieChart7(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart7, props);
};
var PieChart8 = function PieChart8(props) {
  return /*#__PURE__*/React.createElement(SvgPieChart8, props);
};
var PiggyBank = function PiggyBank(props) {
  return /*#__PURE__*/React.createElement(SvgPiggyBank, props);
};
var Pilcrow = function Pilcrow(props) {
  return /*#__PURE__*/React.createElement(SvgPilcrow, props);
};
var Pill = function Pill(props) {
  return /*#__PURE__*/React.createElement(SvgPill, props);
};
var Pingpong = function Pingpong(props) {
  return /*#__PURE__*/React.createElement(SvgPingpong, props);
};
var Pinterest = function Pinterest(props) {
  return /*#__PURE__*/React.createElement(SvgPinterest, props);
};
var Pinterest2 = function Pinterest2(props) {
  return /*#__PURE__*/React.createElement(SvgPinterest2, props);
};
var Pipe = function Pipe(props) {
  return /*#__PURE__*/React.createElement(SvgPipe, props);
};
var Pizza = function Pizza(props) {
  return /*#__PURE__*/React.createElement(SvgPizza, props);
};
var Planet = function Planet(props) {
  return /*#__PURE__*/React.createElement(SvgPlanet, props);
};
var Planet2 = function Planet2(props) {
  return /*#__PURE__*/React.createElement(SvgPlanet2, props);
};
var Plate = function Plate(props) {
  return /*#__PURE__*/React.createElement(SvgPlate, props);
};
var Play = function Play(props) {
  return /*#__PURE__*/React.createElement(SvgPlay, props);
};
var Play2 = function Play2(props) {
  return /*#__PURE__*/React.createElement(SvgPlay2, props);
};
var Play3 = function Play3(props) {
  return /*#__PURE__*/React.createElement(SvgPlay3, props);
};
var Play4 = function Play4(props) {
  return /*#__PURE__*/React.createElement(SvgPlay4, props);
};
var PlaylistAdd = function PlaylistAdd(props) {
  return /*#__PURE__*/React.createElement(SvgPlaylistAdd, props);
};
var Playlist = function Playlist(props) {
  return /*#__PURE__*/React.createElement(SvgPlaylist, props);
};
var PlusCircle = function PlusCircle(props) {
  return /*#__PURE__*/React.createElement(SvgPlusCircle, props);
};
var PlusCircle2 = function PlusCircle2(props) {
  return /*#__PURE__*/React.createElement(SvgPlusCircle2, props);
};
var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement(SvgPlus, props);
};
var Plus2 = function Plus2(props) {
  return /*#__PURE__*/React.createElement(SvgPlus2, props);
};
var Plus3 = function Plus3(props) {
  return /*#__PURE__*/React.createElement(SvgPlus3, props);
};
var Podcast = function Podcast(props) {
  return /*#__PURE__*/React.createElement(SvgPodcast, props);
};
var Podcast2 = function Podcast2(props) {
  return /*#__PURE__*/React.createElement(SvgPodcast2, props);
};
var Podium = function Podium(props) {
  return /*#__PURE__*/React.createElement(SvgPodium, props);
};
var PointDown = function PointDown(props) {
  return /*#__PURE__*/React.createElement(SvgPointDown, props);
};
var PointLeft = function PointLeft(props) {
  return /*#__PURE__*/React.createElement(SvgPointLeft, props);
};
var PointRight = function PointRight(props) {
  return /*#__PURE__*/React.createElement(SvgPointRight, props);
};
var PointUp = function PointUp(props) {
  return /*#__PURE__*/React.createElement(SvgPointUp, props);
};
var Pointer = function Pointer(props) {
  return /*#__PURE__*/React.createElement(SvgPointer, props);
};
var Popout = function Popout(props) {
  return /*#__PURE__*/React.createElement(SvgPopout, props);
};
var PowerCord = function PowerCord(props) {
  return /*#__PURE__*/React.createElement(SvgPowerCord, props);
};
var PowerCord2 = function PowerCord2(props) {
  return /*#__PURE__*/React.createElement(SvgPowerCord2, props);
};
var Power = function Power(props) {
  return /*#__PURE__*/React.createElement(SvgPower, props);
};
var Power2 = function Power2(props) {
  return /*#__PURE__*/React.createElement(SvgPower2, props);
};
var Power3 = function Power3(props) {
  return /*#__PURE__*/React.createElement(SvgPower3, props);
};
var Presentation = function Presentation(props) {
  return /*#__PURE__*/React.createElement(SvgPresentation, props);
};
var Previous = function Previous(props) {
  return /*#__PURE__*/React.createElement(SvgPrevious, props);
};
var Previous2 = function Previous2(props) {
  return /*#__PURE__*/React.createElement(SvgPrevious2, props);
};
var PriceTag = function PriceTag(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTag, props);
};
var PriceTag2 = function PriceTag2(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTag2, props);
};
var PriceTag3 = function PriceTag3(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTag3, props);
};
var PriceTag4 = function PriceTag4(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTag4, props);
};
var PriceTag5 = function PriceTag5(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTag5, props);
};
var PriceTags = function PriceTags(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTags, props);
};
var PriceTags2 = function PriceTags2(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTags2, props);
};
var PriceTags3 = function PriceTags3(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTags3, props);
};
var PriceTags4 = function PriceTags4(props) {
  return /*#__PURE__*/React.createElement(SvgPriceTags4, props);
};
var Printer = function Printer(props) {
  return /*#__PURE__*/React.createElement(SvgPrinter, props);
};
var Printer2 = function Printer2(props) {
  return /*#__PURE__*/React.createElement(SvgPrinter2, props);
};
var Printer3 = function Printer3(props) {
  return /*#__PURE__*/React.createElement(SvgPrinter3, props);
};
var Printer4 = function Printer4(props) {
  return /*#__PURE__*/React.createElement(SvgPrinter4, props);
};
var Profile = function Profile(props) {
  return /*#__PURE__*/React.createElement(SvgProfile, props);
};
var Pulse = function Pulse(props) {
  return /*#__PURE__*/React.createElement(SvgPulse, props);
};
var Pulse2 = function Pulse2(props) {
  return /*#__PURE__*/React.createElement(SvgPulse2, props);
};
var Pushpin = function Pushpin(props) {
  return /*#__PURE__*/React.createElement(SvgPushpin, props);
};
var Pushpin2 = function Pushpin2(props) {
  return /*#__PURE__*/React.createElement(SvgPushpin2, props);
};
var Puzzle = function Puzzle(props) {
  return /*#__PURE__*/React.createElement(SvgPuzzle, props);
};
var Puzzle2 = function Puzzle2(props) {
  return /*#__PURE__*/React.createElement(SvgPuzzle2, props);
};
var Puzzle3 = function Puzzle3(props) {
  return /*#__PURE__*/React.createElement(SvgPuzzle3, props);
};
var Puzzle4 = function Puzzle4(props) {
  return /*#__PURE__*/React.createElement(SvgPuzzle4, props);
};
var Pyramid = function Pyramid(props) {
  return /*#__PURE__*/React.createElement(SvgPyramid, props);
};
var Pyramid2 = function Pyramid2(props) {
  return /*#__PURE__*/React.createElement(SvgPyramid2, props);
};
var Qrcode = function Qrcode(props) {
  return /*#__PURE__*/React.createElement(SvgQrcode, props);
};
var Question = function Question(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion, props);
};
var Question2 = function Question2(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion2, props);
};
var Question3 = function Question3(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion3, props);
};
var Question4 = function Question4(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion4, props);
};
var Question5 = function Question5(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion5, props);
};
var Question6 = function Question6(props) {
  return /*#__PURE__*/React.createElement(SvgQuestion6, props);
};
var Quill = function Quill(props) {
  return /*#__PURE__*/React.createElement(SvgQuill, props);
};
var Quill2 = function Quill2(props) {
  return /*#__PURE__*/React.createElement(SvgQuill2, props);
};
var Quill3 = function Quill3(props) {
  return /*#__PURE__*/React.createElement(SvgQuill3, props);
};
var Quill4 = function Quill4(props) {
  return /*#__PURE__*/React.createElement(SvgQuill4, props);
};
var QuotesLeft = function QuotesLeft(props) {
  return /*#__PURE__*/React.createElement(SvgQuotesLeft, props);
};
var QuotesLeft2 = function QuotesLeft2(props) {
  return /*#__PURE__*/React.createElement(SvgQuotesLeft2, props);
};
var QuotesRight = function QuotesRight(props) {
  return /*#__PURE__*/React.createElement(SvgQuotesRight, props);
};
var QuotesRight2 = function QuotesRight2(props) {
  return /*#__PURE__*/React.createElement(SvgQuotesRight2, props);
};
var Quotes = function Quotes(props) {
  return /*#__PURE__*/React.createElement(SvgQuotes, props);
};
var Racing = function Racing(props) {
  return /*#__PURE__*/React.createElement(SvgRacing, props);
};
var RadioChecked = function RadioChecked(props) {
  return /*#__PURE__*/React.createElement(SvgRadioChecked, props);
};
var RadioChecked2 = function RadioChecked2(props) {
  return /*#__PURE__*/React.createElement(SvgRadioChecked2, props);
};
var RadioUnchecked = function RadioUnchecked(props) {
  return /*#__PURE__*/React.createElement(SvgRadioUnchecked, props);
};
var Radio = function Radio(props) {
  return /*#__PURE__*/React.createElement(SvgRadio, props);
};
var Rating = function Rating(props) {
  return /*#__PURE__*/React.createElement(SvgRating, props);
};
var Rating2 = function Rating2(props) {
  return /*#__PURE__*/React.createElement(SvgRating2, props);
};
var Rating3 = function Rating3(props) {
  return /*#__PURE__*/React.createElement(SvgRating3, props);
};
var Reading = function Reading(props) {
  return /*#__PURE__*/React.createElement(SvgReading, props);
};
var Recording = function Recording(props) {
  return /*#__PURE__*/React.createElement(SvgRecording, props);
};
var Reddit = function Reddit(props) {
  return /*#__PURE__*/React.createElement(SvgReddit, props);
};
var Redo = function Redo(props) {
  return /*#__PURE__*/React.createElement(SvgRedo, props);
};
var Redo2 = function Redo2(props) {
  return /*#__PURE__*/React.createElement(SvgRedo2, props);
};
var Regexp = function Regexp(props) {
  return /*#__PURE__*/React.createElement(SvgRegexp, props);
};
var Regexp2 = function Regexp2(props) {
  return /*#__PURE__*/React.createElement(SvgRegexp2, props);
};
var Reminder = function Reminder(props) {
  return /*#__PURE__*/React.createElement(SvgReminder, props);
};
var Renren = function Renren(props) {
  return /*#__PURE__*/React.createElement(SvgRenren, props);
};
var ReplyAll = function ReplyAll(props) {
  return /*#__PURE__*/React.createElement(SvgReplyAll, props);
};
var Reply = function Reply(props) {
  return /*#__PURE__*/React.createElement(SvgReply, props);
};
var Reset = function Reset(props) {
  return /*#__PURE__*/React.createElement(SvgReset, props);
};
var Road = function Road(props) {
  return /*#__PURE__*/React.createElement(SvgRoad, props);
};
var Rocket = function Rocket(props) {
  return /*#__PURE__*/React.createElement(SvgRocket, props);
};
var RotateCcw = function RotateCcw(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCcw, props);
};
var RotateCcw2 = function RotateCcw2(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCcw2, props);
};
var RotateCcw3 = function RotateCcw3(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCcw3, props);
};
var RotateCw = function RotateCw(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCw, props);
};
var RotateCw2 = function RotateCw2(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCw2, props);
};
var RotateCw3 = function RotateCw3(props) {
  return /*#__PURE__*/React.createElement(SvgRotateCw3, props);
};
var Rss = function Rss(props) {
  return /*#__PURE__*/React.createElement(SvgRss, props);
};
var Rss2 = function Rss2(props) {
  return /*#__PURE__*/React.createElement(SvgRss2, props);
};
var Rtl = function Rtl(props) {
  return /*#__PURE__*/React.createElement(SvgRtl, props);
};
var Rtl2 = function Rtl2(props) {
  return /*#__PURE__*/React.createElement(SvgRtl2, props);
};
var Ruler = function Ruler(props) {
  return /*#__PURE__*/React.createElement(SvgRuler, props);
};
var Rulers = function Rulers(props) {
  return /*#__PURE__*/React.createElement(SvgRulers, props);
};
var Sad = function Sad(props) {
  return /*#__PURE__*/React.createElement(SvgSad, props);
};
var Sad2 = function Sad2(props) {
  return /*#__PURE__*/React.createElement(SvgSad2, props);
};
var Safari = function Safari(props) {
  return /*#__PURE__*/React.createElement(SvgSafari, props);
};
var Safe = function Safe(props) {
  return /*#__PURE__*/React.createElement(SvgSafe, props);
};
var SatelliteDish = function SatelliteDish(props) {
  return /*#__PURE__*/React.createElement(SvgSatelliteDish, props);
};
var SatelliteDish2 = function SatelliteDish2(props) {
  return /*#__PURE__*/React.createElement(SvgSatelliteDish2, props);
};
var Scale = function Scale(props) {
  return /*#__PURE__*/React.createElement(SvgScale, props);
};
var Scissors = function Scissors(props) {
  return /*#__PURE__*/React.createElement(SvgScissors, props);
};
var Scissors2 = function Scissors2(props) {
  return /*#__PURE__*/React.createElement(SvgScissors2, props);
};
var Scissors3 = function Scissors3(props) {
  return /*#__PURE__*/React.createElement(SvgScissors3, props);
};
var Screwdriver = function Screwdriver(props) {
  return /*#__PURE__*/React.createElement(SvgScrewdriver, props);
};
var Screwdriver2 = function Screwdriver2(props) {
  return /*#__PURE__*/React.createElement(SvgScrewdriver2, props);
};
var SearchPlus = function SearchPlus(props) {
  return /*#__PURE__*/React.createElement(SvgSearchPlus, props);
};
var Search = function Search(props) {
  return /*#__PURE__*/React.createElement(SvgSearch, props);
};
var Search2 = function Search2(props) {
  return /*#__PURE__*/React.createElement(SvgSearch2, props);
};
var Search3 = function Search3(props) {
  return /*#__PURE__*/React.createElement(SvgSearch3, props);
};
var Search4 = function Search4(props) {
  return /*#__PURE__*/React.createElement(SvgSearch4, props);
};
var Search5 = function Search5(props) {
  return /*#__PURE__*/React.createElement(SvgSearch5, props);
};
var Search6 = function Search6(props) {
  return /*#__PURE__*/React.createElement(SvgSearch6, props);
};
var Section = function Section(props) {
  return /*#__PURE__*/React.createElement(SvgSection, props);
};
var Select = function Select(props) {
  return /*#__PURE__*/React.createElement(SvgSelect, props);
};
var Select2 = function Select2(props) {
  return /*#__PURE__*/React.createElement(SvgSelect2, props);
};
var Server = function Server(props) {
  return /*#__PURE__*/React.createElement(SvgServer, props);
};
var SevenSegmentZero = function SevenSegmentZero(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment0, props);
};
var SevenSegmentOne = function SevenSegmentOne(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment1, props);
};
var SevenSegmentTwo = function SevenSegmentTwo(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment2, props);
};
var SevenSegmentThree = function SevenSegmentThree(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment3, props);
};
var SevenSegmentFour = function SevenSegmentFour(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment4, props);
};
var SevenSegmentFive = function SevenSegmentFive(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment5, props);
};
var SevenSegmentSix = function SevenSegmentSix(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment6, props);
};
var SevenSegmentSeven = function SevenSegmentSeven(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment7, props);
};
var SevenSegmentEight = function SevenSegmentEight(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment8, props);
};
var SevenSegmentNine = function SevenSegmentNine(props) {
  return /*#__PURE__*/React.createElement(SvgSevenSegment9, props);
};
var Share = function Share(props) {
  return /*#__PURE__*/React.createElement(SvgShare, props);
};
var Share2 = function Share2(props) {
  return /*#__PURE__*/React.createElement(SvgShare2, props);
};
var Share3 = function Share3(props) {
  return /*#__PURE__*/React.createElement(SvgShare3, props);
};
var Share4 = function Share4(props) {
  return /*#__PURE__*/React.createElement(SvgShare4, props);
};
var Shear = function Shear(props) {
  return /*#__PURE__*/React.createElement(SvgShear, props);
};
var ShieldCheck = function ShieldCheck(props) {
  return /*#__PURE__*/React.createElement(SvgShieldCheck, props);
};
var ShieldNotice = function ShieldNotice(props) {
  return /*#__PURE__*/React.createElement(SvgShieldNotice, props);
};
var Shield = function Shield(props) {
  return /*#__PURE__*/React.createElement(SvgShield, props);
};
var Shield2 = function Shield2(props) {
  return /*#__PURE__*/React.createElement(SvgShield2, props);
};
var Shield3 = function Shield3(props) {
  return /*#__PURE__*/React.createElement(SvgShield3, props);
};
var Shield4 = function Shield4(props) {
  return /*#__PURE__*/React.createElement(SvgShield4, props);
};
var Shift = function Shift(props) {
  return /*#__PURE__*/React.createElement(SvgShift, props);
};
var Ship = function Ship(props) {
  return /*#__PURE__*/React.createElement(SvgShip, props);
};
var Shocked = function Shocked(props) {
  return /*#__PURE__*/React.createElement(SvgShocked, props);
};
var Shocked2 = function Shocked2(props) {
  return /*#__PURE__*/React.createElement(SvgShocked2, props);
};
var Shorts = function Shorts(props) {
  return /*#__PURE__*/React.createElement(SvgShorts, props);
};
var Shredder = function Shredder(props) {
  return /*#__PURE__*/React.createElement(SvgShredder, props);
};
var Shrink = function Shrink(props) {
  return /*#__PURE__*/React.createElement(SvgShrink, props);
};
var Shrink2 = function Shrink2(props) {
  return /*#__PURE__*/React.createElement(SvgShrink2, props);
};
var Shrink3 = function Shrink3(props) {
  return /*#__PURE__*/React.createElement(SvgShrink3, props);
};
var Shrink4 = function Shrink4(props) {
  return /*#__PURE__*/React.createElement(SvgShrink4, props);
};
var Shrink5 = function Shrink5(props) {
  return /*#__PURE__*/React.createElement(SvgShrink5, props);
};
var Shrink6 = function Shrink6(props) {
  return /*#__PURE__*/React.createElement(SvgShrink6, props);
};
var Shrink7 = function Shrink7(props) {
  return /*#__PURE__*/React.createElement(SvgShrink7, props);
};
var Shuffle = function Shuffle(props) {
  return /*#__PURE__*/React.createElement(SvgShuffle, props);
};
var Shuffle2 = function Shuffle2(props) {
  return /*#__PURE__*/React.createElement(SvgShuffle2, props);
};
var Shutter = function Shutter(props) {
  return /*#__PURE__*/React.createElement(SvgShutter, props);
};
var Sigma = function Sigma(props) {
  return /*#__PURE__*/React.createElement(SvgSigma, props);
};
var SinaWeibo = function SinaWeibo(props) {
  return /*#__PURE__*/React.createElement(SvgSinaWeibo, props);
};
var Skull = function Skull(props) {
  return /*#__PURE__*/React.createElement(SvgSkull, props);
};
var Skull2 = function Skull2(props) {
  return /*#__PURE__*/React.createElement(SvgSkull2, props);
};
var Skype = function Skype(props) {
  return /*#__PURE__*/React.createElement(SvgSkype, props);
};
var Sleepy = function Sleepy(props) {
  return /*#__PURE__*/React.createElement(SvgSleepy, props);
};
var Sleepy2 = function Sleepy2(props) {
  return /*#__PURE__*/React.createElement(SvgSleepy2, props);
};
var Smile = function Smile(props) {
  return /*#__PURE__*/React.createElement(SvgSmile, props);
};
var Smile2 = function Smile2(props) {
  return /*#__PURE__*/React.createElement(SvgSmile2, props);
};
var Snowflake = function Snowflake(props) {
  return /*#__PURE__*/React.createElement(SvgSnowflake, props);
};
var Soccer = function Soccer(props) {
  return /*#__PURE__*/React.createElement(SvgSoccer, props);
};
var Sock = function Sock(props) {
  return /*#__PURE__*/React.createElement(SvgSock, props);
};
var SortAlphaAsc = function SortAlphaAsc(props) {
  return /*#__PURE__*/React.createElement(SvgSortAlphaAsc, props);
};
var SortAlphaDesc = function SortAlphaDesc(props) {
  return /*#__PURE__*/React.createElement(SvgSortAlphaDesc, props);
};
var SortAmountAsc = function SortAmountAsc(props) {
  return /*#__PURE__*/React.createElement(SvgSortAmountAsc, props);
};
var SortAmountDesc = function SortAmountDesc(props) {
  return /*#__PURE__*/React.createElement(SvgSortAmountDesc, props);
};
var SortNumbericDesc = function SortNumbericDesc(props) {
  return /*#__PURE__*/React.createElement(SvgSortNumbericDesc, props);
};
var SortNumericAsc = function SortNumericAsc(props) {
  return /*#__PURE__*/React.createElement(SvgSortNumericAsc, props);
};
var SortTimeAsc = function SortTimeAsc(props) {
  return /*#__PURE__*/React.createElement(SvgSortTimeAsc, props);
};
var SortTimeDesc = function SortTimeDesc(props) {
  return /*#__PURE__*/React.createElement(SvgSortTimeDesc, props);
};
var Sort = function Sort(props) {
  return /*#__PURE__*/React.createElement(SvgSort, props);
};
var Sort2 = function Sort2(props) {
  return /*#__PURE__*/React.createElement(SvgSort2, props);
};
var Soundcloud = function Soundcloud(props) {
  return /*#__PURE__*/React.createElement(SvgSoundcloud, props);
};
var Soundcloud2 = function Soundcloud2(props) {
  return /*#__PURE__*/React.createElement(SvgSoundcloud2, props);
};
var Spades = function Spades(props) {
  return /*#__PURE__*/React.createElement(SvgSpades, props);
};
var Spam = function Spam(props) {
  return /*#__PURE__*/React.createElement(SvgSpam, props);
};
var SpeakerLeft = function SpeakerLeft(props) {
  return /*#__PURE__*/React.createElement(SvgSpeakerLeft, props);
};
var SpeakerRight = function SpeakerRight(props) {
  return /*#__PURE__*/React.createElement(SvgSpeakerRight, props);
};
var Speakers = function Speakers(props) {
  return /*#__PURE__*/React.createElement(SvgSpeakers, props);
};
var SpellCheck = function SpellCheck(props) {
  return /*#__PURE__*/React.createElement(SvgSpellCheck, props);
};
var SpellCheck2 = function SpellCheck2(props) {
  return /*#__PURE__*/React.createElement(SvgSpellCheck2, props);
};
var Sphere = function Sphere(props) {
  return /*#__PURE__*/React.createElement(SvgSphere, props);
};
var Sphere2 = function Sphere2(props) {
  return /*#__PURE__*/React.createElement(SvgSphere2, props);
};
var Sphere3 = function Sphere3(props) {
  return /*#__PURE__*/React.createElement(SvgSphere3, props);
};
var Spinner = function Spinner(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner, props);
};
var Spinner10 = function Spinner10(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner10, props);
};
var Spinner11 = function Spinner11(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner11, props);
};
var Spinner2 = function Spinner2(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner2, props);
};
var Spinner3 = function Spinner3(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner3, props);
};
var Spinner4 = function Spinner4(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner4, props);
};
var Spinner5 = function Spinner5(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner5, props);
};
var Spinner6 = function Spinner6(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner6, props);
};
var Spinner7 = function Spinner7(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner7, props);
};
var Spinner8 = function Spinner8(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner8, props);
};
var Spinner9 = function Spinner9(props) {
  return /*#__PURE__*/React.createElement(SvgSpinner9, props);
};
var Split = function Split(props) {
  return /*#__PURE__*/React.createElement(SvgSplit, props);
};
var SpoonKnife = function SpoonKnife(props) {
  return /*#__PURE__*/React.createElement(SvgSpoonKnife, props);
};
var Spotify = function Spotify(props) {
  return /*#__PURE__*/React.createElement(SvgSpotify, props);
};
var Spotlight = function Spotlight(props) {
  return /*#__PURE__*/React.createElement(SvgSpotlight, props);
};
var Spotlight2 = function Spotlight2(props) {
  return /*#__PURE__*/React.createElement(SvgSpotlight2, props);
};
var Spray = function Spray(props) {
  return /*#__PURE__*/React.createElement(SvgSpray, props);
};
var SquareDownLeft = function SquareDownLeft(props) {
  return /*#__PURE__*/React.createElement(SvgSquareDownLeft, props);
};
var SquareDownRight = function SquareDownRight(props) {
  return /*#__PURE__*/React.createElement(SvgSquareDownRight, props);
};
var SquareDown = function SquareDown(props) {
  return /*#__PURE__*/React.createElement(SvgSquareDown, props);
};
var SquareLeft = function SquareLeft(props) {
  return /*#__PURE__*/React.createElement(SvgSquareLeft, props);
};
var SquareRight = function SquareRight(props) {
  return /*#__PURE__*/React.createElement(SvgSquareRight, props);
};
var SquareUpLeft = function SquareUpLeft(props) {
  return /*#__PURE__*/React.createElement(SvgSquareUpLeft, props);
};
var SquareUpRight = function SquareUpRight(props) {
  return /*#__PURE__*/React.createElement(SvgSquareUpRight, props);
};
var SquareUp = function SquareUp(props) {
  return /*#__PURE__*/React.createElement(SvgSquareUp, props);
};
var Square = function Square(props) {
  return /*#__PURE__*/React.createElement(SvgSquare, props);
};
var StackCancel = function StackCancel(props) {
  return /*#__PURE__*/React.createElement(SvgStackCancel, props);
};
var StackCheck = function StackCheck(props) {
  return /*#__PURE__*/React.createElement(SvgStackCheck, props);
};
var StackClubs = function StackClubs(props) {
  return /*#__PURE__*/React.createElement(SvgStackClubs, props);
};
var StackDiamonds = function StackDiamonds(props) {
  return /*#__PURE__*/React.createElement(SvgStackDiamonds, props);
};
var StackDown = function StackDown(props) {
  return /*#__PURE__*/React.createElement(SvgStackDown, props);
};
var StackEmpty = function StackEmpty(props) {
  return /*#__PURE__*/React.createElement(SvgStackEmpty, props);
};
var StackHearts = function StackHearts(props) {
  return /*#__PURE__*/React.createElement(SvgStackHearts, props);
};
var StackMinus = function StackMinus(props) {
  return /*#__PURE__*/React.createElement(SvgStackMinus, props);
};
var StackMusic = function StackMusic(props) {
  return /*#__PURE__*/React.createElement(SvgStackMusic, props);
};
var StackPicture = function StackPicture(props) {
  return /*#__PURE__*/React.createElement(SvgStackPicture, props);
};
var StackPlay = function StackPlay(props) {
  return /*#__PURE__*/React.createElement(SvgStackPlay, props);
};
var StackPlus = function StackPlus(props) {
  return /*#__PURE__*/React.createElement(SvgStackPlus, props);
};
var StackSpades = function StackSpades(props) {
  return /*#__PURE__*/React.createElement(SvgStackSpades, props);
};
var StackStar = function StackStar(props) {
  return /*#__PURE__*/React.createElement(SvgStackStar, props);
};
var StackText = function StackText(props) {
  return /*#__PURE__*/React.createElement(SvgStackText, props);
};
var StackUp = function StackUp(props) {
  return /*#__PURE__*/React.createElement(SvgStackUp, props);
};
var StackUser = function StackUser(props) {
  return /*#__PURE__*/React.createElement(SvgStackUser, props);
};
var Stack = function Stack(props) {
  return /*#__PURE__*/React.createElement(SvgStack, props);
};
var Stack2 = function Stack2(props) {
  return /*#__PURE__*/React.createElement(SvgStack2, props);
};
var Stack3 = function Stack3(props) {
  return /*#__PURE__*/React.createElement(SvgStack3, props);
};
var Stack4 = function Stack4(props) {
  return /*#__PURE__*/React.createElement(SvgStack4, props);
};
var Stackoverflow = function Stackoverflow(props) {
  return /*#__PURE__*/React.createElement(SvgStackoverflow, props);
};
var StairsDown = function StairsDown(props) {
  return /*#__PURE__*/React.createElement(SvgStairsDown, props);
};
var StairsUp = function StairsUp(props) {
  return /*#__PURE__*/React.createElement(SvgStairsUp, props);
};
var Stairs = function Stairs(props) {
  return /*#__PURE__*/React.createElement(SvgStairs, props);
};
var Stairs2 = function Stairs2(props) {
  return /*#__PURE__*/React.createElement(SvgStairs2, props);
};
var Stamp = function Stamp(props) {
  return /*#__PURE__*/React.createElement(SvgStamp, props);
};
var StarEmpty = function StarEmpty(props) {
  return /*#__PURE__*/React.createElement(SvgStarEmpty, props);
};
var StarEmpty2 = function StarEmpty2(props) {
  return /*#__PURE__*/React.createElement(SvgStarEmpty2, props);
};
var StarEmpty3 = function StarEmpty3(props) {
  return /*#__PURE__*/React.createElement(SvgStarEmpty3, props);
};
var StarFull = function StarFull(props) {
  return /*#__PURE__*/React.createElement(SvgStarFull, props);
};
var StarFull2 = function StarFull2(props) {
  return /*#__PURE__*/React.createElement(SvgStarFull2, props);
};
var StarHalf = function StarHalf(props) {
  return /*#__PURE__*/React.createElement(SvgStarHalf, props);
};
var Star = function Star(props) {
  return /*#__PURE__*/React.createElement(SvgStar, props);
};
var Starburst = function Starburst(props) {
  return /*#__PURE__*/React.createElement(SvgStarburst, props);
};
var Stars = function Stars(props) {
  return /*#__PURE__*/React.createElement(SvgStars, props);
};
var Station = function Station(props) {
  return /*#__PURE__*/React.createElement(SvgStation, props);
};
var Station2 = function Station2(props) {
  return /*#__PURE__*/React.createElement(SvgStation2, props);
};
var StatsBars = function StatsBars(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars, props);
};
var StatsBars2 = function StatsBars2(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars2, props);
};
var StatsBars3 = function StatsBars3(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars3, props);
};
var StatsBars4 = function StatsBars4(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars4, props);
};
var StatsBars5 = function StatsBars5(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars5, props);
};
var StatsBars6 = function StatsBars6(props) {
  return /*#__PURE__*/React.createElement(SvgStatsBars6, props);
};
var StatsDecline = function StatsDecline(props) {
  return /*#__PURE__*/React.createElement(SvgStatsDecline, props);
};
var StatsDecline2 = function StatsDecline2(props) {
  return /*#__PURE__*/React.createElement(SvgStatsDecline2, props);
};
var StatsDots = function StatsDots(props) {
  return /*#__PURE__*/React.createElement(SvgStatsDots, props);
};
var StatsGrowth = function StatsGrowth(props) {
  return /*#__PURE__*/React.createElement(SvgStatsGrowth, props);
};
var StatsGrowth2 = function StatsGrowth2(props) {
  return /*#__PURE__*/React.createElement(SvgStatsGrowth2, props);
};
var Steak = function Steak(props) {
  return /*#__PURE__*/React.createElement(SvgSteak, props);
};
var Steam = function Steam(props) {
  return /*#__PURE__*/React.createElement(SvgSteam, props);
};
var Steam2 = function Steam2(props) {
  return /*#__PURE__*/React.createElement(SvgSteam2, props);
};
var SteeringWheel = function SteeringWheel(props) {
  return /*#__PURE__*/React.createElement(SvgSteeringWheel, props);
};
var Stethoscope = function Stethoscope(props) {
  return /*#__PURE__*/React.createElement(SvgStethoscope, props);
};
var Stop = function Stop(props) {
  return /*#__PURE__*/React.createElement(SvgStop, props);
};
var Stop2 = function Stop2(props) {
  return /*#__PURE__*/React.createElement(SvgStop2, props);
};
var StopwatchEdit = function StopwatchEdit(props) {
  return /*#__PURE__*/React.createElement(SvgStopwatchEdit, props);
};
var Stopwatch = function Stopwatch(props) {
  return /*#__PURE__*/React.createElement(SvgStopwatch, props);
};
var Store = function Store(props) {
  return /*#__PURE__*/React.createElement(SvgStore, props);
};
var Store2 = function Store2(props) {
  return /*#__PURE__*/React.createElement(SvgStore2, props);
};
var Strategy = function Strategy(props) {
  return /*#__PURE__*/React.createElement(SvgStrategy, props);
};
var Strikethrough = function Strikethrough(props) {
  return /*#__PURE__*/React.createElement(SvgStrikethrough, props);
};
var Strikethrough2 = function Strikethrough2(props) {
  return /*#__PURE__*/React.createElement(SvgStrikethrough2, props);
};
var Strikethrough3 = function Strikethrough3(props) {
  return /*#__PURE__*/React.createElement(SvgStrikethrough3, props);
};
var Stumbleupon = function Stumbleupon(props) {
  return /*#__PURE__*/React.createElement(SvgStumbleupon, props);
};
var Stumbleupon2 = function Stumbleupon2(props) {
  return /*#__PURE__*/React.createElement(SvgStumbleupon2, props);
};
var Subscript = function Subscript(props) {
  return /*#__PURE__*/React.createElement(SvgSubscript, props);
};
var Subscript2 = function Subscript2(props) {
  return /*#__PURE__*/React.createElement(SvgSubscript2, props);
};
var Subtract = function Subtract(props) {
  return /*#__PURE__*/React.createElement(SvgSubtract, props);
};
var Sun = function Sun(props) {
  return /*#__PURE__*/React.createElement(SvgSun, props);
};
var Sun2 = function Sun2(props) {
  return /*#__PURE__*/React.createElement(SvgSun2, props);
};
var Sun3 = function Sun3(props) {
  return /*#__PURE__*/React.createElement(SvgSun3, props);
};
var Superscript = function Superscript(props) {
  return /*#__PURE__*/React.createElement(SvgSuperscript, props);
};
var Superscript2 = function Superscript2(props) {
  return /*#__PURE__*/React.createElement(SvgSuperscript2, props);
};
var Svg = function Svg(props) {
  return /*#__PURE__*/React.createElement(SvgSvg, props);
};
var Switch = function Switch(props) {
  return /*#__PURE__*/React.createElement(SvgSwitch, props);
};
var Switch2 = function Switch2(props) {
  return /*#__PURE__*/React.createElement(SvgSwitch2, props);
};
var Sword = function Sword(props) {
  return /*#__PURE__*/React.createElement(SvgSword, props);
};
var Syringe = function Syringe(props) {
  return /*#__PURE__*/React.createElement(SvgSyringe, props);
};
var Syringe2 = function Syringe2(props) {
  return /*#__PURE__*/React.createElement(SvgSyringe2, props);
};
var Tab = function Tab(props) {
  return /*#__PURE__*/React.createElement(SvgTab, props);
};
var Table = function Table(props) {
  return /*#__PURE__*/React.createElement(SvgTable, props);
};
var Table2 = function Table2(props) {
  return /*#__PURE__*/React.createElement(SvgTable2, props);
};
var Tablet = function Tablet(props) {
  return /*#__PURE__*/React.createElement(SvgTablet, props);
};
var Tape = function Tape(props) {
  return /*#__PURE__*/React.createElement(SvgTape, props);
};
var Target = function Target(props) {
  return /*#__PURE__*/React.createElement(SvgTarget, props);
};
var Target2 = function Target2(props) {
  return /*#__PURE__*/React.createElement(SvgTarget2, props);
};
var Target3 = function Target3(props) {
  return /*#__PURE__*/React.createElement(SvgTarget3, props);
};
var Target4 = function Target4(props) {
  return /*#__PURE__*/React.createElement(SvgTarget4, props);
};
var Teapot = function Teapot(props) {
  return /*#__PURE__*/React.createElement(SvgTeapot, props);
};
var Telegram = function Telegram(props) {
  return /*#__PURE__*/React.createElement(SvgTelegram, props);
};
var Temperature = function Temperature(props) {
  return /*#__PURE__*/React.createElement(SvgTemperature, props);
};
var Temperature2 = function Temperature2(props) {
  return /*#__PURE__*/React.createElement(SvgTemperature2, props);
};
var Tennis = function Tennis(props) {
  return /*#__PURE__*/React.createElement(SvgTennis, props);
};
var Tent = function Tent(props) {
  return /*#__PURE__*/React.createElement(SvgTent, props);
};
var Terminal = function Terminal(props) {
  return /*#__PURE__*/React.createElement(SvgTerminal, props);
};
var TextColor = function TextColor(props) {
  return /*#__PURE__*/React.createElement(SvgTextColor, props);
};
var TextHeight = function TextHeight(props) {
  return /*#__PURE__*/React.createElement(SvgTextHeight, props);
};
var TextWidth = function TextWidth(props) {
  return /*#__PURE__*/React.createElement(SvgTextWidth, props);
};
var Theater = function Theater(props) {
  return /*#__PURE__*/React.createElement(SvgTheater, props);
};
var Themes = function Themes(props) {
  return /*#__PURE__*/React.createElement(SvgThemes, props);
};
var ThumbsDown = function ThumbsDown(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsDown, props);
};
var ThumbsDown2 = function ThumbsDown2(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsDown2, props);
};
var ThumbsDown3 = function ThumbsDown3(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsDown3, props);
};
var ThumbsUp = function ThumbsUp(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp, props);
};
var ThumbsUp2 = function ThumbsUp2(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp2, props);
};
var ThumbsUp3 = function ThumbsUp3(props) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp3, props);
};
var Ticket = function Ticket(props) {
  return /*#__PURE__*/React.createElement(SvgTicket, props);
};
var Ticket2 = function Ticket2(props) {
  return /*#__PURE__*/React.createElement(SvgTicket2, props);
};
var Tie = function Tie(props) {
  return /*#__PURE__*/React.createElement(SvgTie, props);
};
var ToggleOff = function ToggleOff(props) {
  return /*#__PURE__*/React.createElement(SvgToggleOff, props);
};
var ToggleOn = function ToggleOn(props) {
  return /*#__PURE__*/React.createElement(SvgToggleOn, props);
};
var Toggle = function Toggle(props) {
  return /*#__PURE__*/React.createElement(SvgToggle, props);
};
var Toiletpaper = function Toiletpaper(props) {
  return /*#__PURE__*/React.createElement(SvgToiletpaper, props);
};
var Tongue = function Tongue(props) {
  return /*#__PURE__*/React.createElement(SvgTongue, props);
};
var Tongue2 = function Tongue2(props) {
  return /*#__PURE__*/React.createElement(SvgTongue2, props);
};
var TouchPinch = function TouchPinch(props) {
  return /*#__PURE__*/React.createElement(SvgTouchPinch, props);
};
var TouchZoom = function TouchZoom(props) {
  return /*#__PURE__*/React.createElement(SvgTouchZoom, props);
};
var Touch = function Touch(props) {
  return /*#__PURE__*/React.createElement(SvgTouch, props);
};
var TrafficCone = function TrafficCone(props) {
  return /*#__PURE__*/React.createElement(SvgTrafficCone, props);
};
var TrafficLights = function TrafficLights(props) {
  return /*#__PURE__*/React.createElement(SvgTrafficLights, props);
};
var Train = function Train(props) {
  return /*#__PURE__*/React.createElement(SvgTrain, props);
};
var Train2 = function Train2(props) {
  return /*#__PURE__*/React.createElement(SvgTrain2, props);
};
var Transmission = function Transmission(props) {
  return /*#__PURE__*/React.createElement(SvgTransmission, props);
};
var Transmission2 = function Transmission2(props) {
  return /*#__PURE__*/React.createElement(SvgTransmission2, props);
};
var Tree = function Tree(props) {
  return /*#__PURE__*/React.createElement(SvgTree, props);
};
var Tree2 = function Tree2(props) {
  return /*#__PURE__*/React.createElement(SvgTree2, props);
};
var Tree3 = function Tree3(props) {
  return /*#__PURE__*/React.createElement(SvgTree3, props);
};
var Tree4 = function Tree4(props) {
  return /*#__PURE__*/React.createElement(SvgTree4, props);
};
var Tree5 = function Tree5(props) {
  return /*#__PURE__*/React.createElement(SvgTree5, props);
};
var Tree6 = function Tree6(props) {
  return /*#__PURE__*/React.createElement(SvgTree6, props);
};
var Tree7 = function Tree7(props) {
  return /*#__PURE__*/React.createElement(SvgTree7, props);
};
var Trello = function Trello(props) {
  return /*#__PURE__*/React.createElement(SvgTrello, props);
};
var Triangle = function Triangle(props) {
  return /*#__PURE__*/React.createElement(SvgTriangle, props);
};
var Triangle2 = function Triangle2(props) {
  return /*#__PURE__*/React.createElement(SvgTriangle2, props);
};
var Trophy = function Trophy(props) {
  return /*#__PURE__*/React.createElement(SvgTrophy, props);
};
var Trophy2 = function Trophy2(props) {
  return /*#__PURE__*/React.createElement(SvgTrophy2, props);
};
var Trophy3 = function Trophy3(props) {
  return /*#__PURE__*/React.createElement(SvgTrophy3, props);
};
var Trophy4 = function Trophy4(props) {
  return /*#__PURE__*/React.createElement(SvgTrophy4, props);
};
var Truck = function Truck(props) {
  return /*#__PURE__*/React.createElement(SvgTruck, props);
};
var Trumpet = function Trumpet(props) {
  return /*#__PURE__*/React.createElement(SvgTrumpet, props);
};
var Tshirt = function Tshirt(props) {
  return /*#__PURE__*/React.createElement(SvgTshirt, props);
};
var Tumblr = function Tumblr(props) {
  return /*#__PURE__*/React.createElement(SvgTumblr, props);
};
var Tumblr2 = function Tumblr2(props) {
  return /*#__PURE__*/React.createElement(SvgTumblr2, props);
};
var Tux = function Tux(props) {
  return /*#__PURE__*/React.createElement(SvgTux, props);
};
var Tv = function Tv(props) {
  return /*#__PURE__*/React.createElement(SvgTv, props);
};
var Twitch = function Twitch(props) {
  return /*#__PURE__*/React.createElement(SvgTwitch, props);
};
var Twitter = function Twitter(props) {
  return /*#__PURE__*/React.createElement(SvgTwitter, props);
};
var Typewriter = function Typewriter(props) {
  return /*#__PURE__*/React.createElement(SvgTypewriter, props);
};
var Typography = function Typography(props) {
  return /*#__PURE__*/React.createElement(SvgTypography, props);
};
var Umbrella = function Umbrella(props) {
  return /*#__PURE__*/React.createElement(SvgUmbrella, props);
};
var Underline = function Underline(props) {
  return /*#__PURE__*/React.createElement(SvgUnderline, props);
};
var Underline2 = function Underline2(props) {
  return /*#__PURE__*/React.createElement(SvgUnderline2, props);
};
var Undo = function Undo(props) {
  return /*#__PURE__*/React.createElement(SvgUndo, props);
};
var Undo2 = function Undo2(props) {
  return /*#__PURE__*/React.createElement(SvgUndo2, props);
};
var Ungroup = function Ungroup(props) {
  return /*#__PURE__*/React.createElement(SvgUngroup, props);
};
var Unicode = function Unicode(props) {
  return /*#__PURE__*/React.createElement(SvgUnicode, props);
};
var Unite = function Unite(props) {
  return /*#__PURE__*/React.createElement(SvgUnite, props);
};
var Unlink = function Unlink(props) {
  return /*#__PURE__*/React.createElement(SvgUnlink, props);
};
var Unlink2 = function Unlink2(props) {
  return /*#__PURE__*/React.createElement(SvgUnlink2, props);
};
var Unlink3 = function Unlink3(props) {
  return /*#__PURE__*/React.createElement(SvgUnlink3, props);
};
var Unlink4 = function Unlink4(props) {
  return /*#__PURE__*/React.createElement(SvgUnlink4, props);
};
var Unlink5 = function Unlink5(props) {
  return /*#__PURE__*/React.createElement(SvgUnlink5, props);
};
var Unlocked = function Unlocked(props) {
  return /*#__PURE__*/React.createElement(SvgUnlocked, props);
};
var Unlocked2 = function Unlocked2(props) {
  return /*#__PURE__*/React.createElement(SvgUnlocked2, props);
};
var Upload = function Upload(props) {
  return /*#__PURE__*/React.createElement(SvgUpload, props);
};
var Upload10 = function Upload10(props) {
  return /*#__PURE__*/React.createElement(SvgUpload10, props);
};
var Upload2 = function Upload2(props) {
  return /*#__PURE__*/React.createElement(SvgUpload2, props);
};
var Upload3 = function Upload3(props) {
  return /*#__PURE__*/React.createElement(SvgUpload3, props);
};
var Upload4 = function Upload4(props) {
  return /*#__PURE__*/React.createElement(SvgUpload4, props);
};
var Upload5 = function Upload5(props) {
  return /*#__PURE__*/React.createElement(SvgUpload5, props);
};
var Upload6 = function Upload6(props) {
  return /*#__PURE__*/React.createElement(SvgUpload6, props);
};
var Upload7 = function Upload7(props) {
  return /*#__PURE__*/React.createElement(SvgUpload7, props);
};
var Upload8 = function Upload8(props) {
  return /*#__PURE__*/React.createElement(SvgUpload8, props);
};
var Upload9 = function Upload9(props) {
  return /*#__PURE__*/React.createElement(SvgUpload9, props);
};
var UsbStick = function UsbStick(props) {
  return /*#__PURE__*/React.createElement(SvgUsbStick, props);
};
var UserBlock = function UserBlock(props) {
  return /*#__PURE__*/React.createElement(SvgUserBlock, props);
};
var UserBlock2 = function UserBlock2(props) {
  return /*#__PURE__*/React.createElement(SvgUserBlock2, props);
};
var UserCancel = function UserCancel(props) {
  return /*#__PURE__*/React.createElement(SvgUserCancel, props);
};
var UserCancel2 = function UserCancel2(props) {
  return /*#__PURE__*/React.createElement(SvgUserCancel2, props);
};
var UserCheck = function UserCheck(props) {
  return /*#__PURE__*/React.createElement(SvgUserCheck, props);
};
var UserCheck2 = function UserCheck2(props) {
  return /*#__PURE__*/React.createElement(SvgUserCheck2, props);
};
var UserLock = function UserLock(props) {
  return /*#__PURE__*/React.createElement(SvgUserLock, props);
};
var UserLock2 = function UserLock2(props) {
  return /*#__PURE__*/React.createElement(SvgUserLock2, props);
};
var UserMinus = function UserMinus(props) {
  return /*#__PURE__*/React.createElement(SvgUserMinus, props);
};
var UserMinus2 = function UserMinus2(props) {
  return /*#__PURE__*/React.createElement(SvgUserMinus2, props);
};
var UserPlus = function UserPlus(props) {
  return /*#__PURE__*/React.createElement(SvgUserPlus, props);
};
var UserPlus2 = function UserPlus2(props) {
  return /*#__PURE__*/React.createElement(SvgUserPlus2, props);
};
var UserTie = function UserTie(props) {
  return /*#__PURE__*/React.createElement(SvgUserTie, props);
};
var User = function User(props) {
  return /*#__PURE__*/React.createElement(SvgUser, props);
};
var User2 = function User2(props) {
  return /*#__PURE__*/React.createElement(SvgUser2, props);
};
var User3 = function User3(props) {
  return /*#__PURE__*/React.createElement(SvgUser3, props);
};
var User4 = function User4(props) {
  return /*#__PURE__*/React.createElement(SvgUser4, props);
};
var User5 = function User5(props) {
  return /*#__PURE__*/React.createElement(SvgUser5, props);
};
var User6 = function User6(props) {
  return /*#__PURE__*/React.createElement(SvgUser6, props);
};
var User7 = function User7(props) {
  return /*#__PURE__*/React.createElement(SvgUser7, props);
};
var Users = function Users(props) {
  return /*#__PURE__*/React.createElement(SvgUsers, props);
};
var Users2 = function Users2(props) {
  return /*#__PURE__*/React.createElement(SvgUsers2, props);
};
var Users3 = function Users3(props) {
  return /*#__PURE__*/React.createElement(SvgUsers3, props);
};
var Users4 = function Users4(props) {
  return /*#__PURE__*/React.createElement(SvgUsers4, props);
};
var Users5 = function Users5(props) {
  return /*#__PURE__*/React.createElement(SvgUsers5, props);
};
var Vcard = function Vcard(props) {
  return /*#__PURE__*/React.createElement(SvgVcard, props);
};
var Vector = function Vector(props) {
  return /*#__PURE__*/React.createElement(SvgVector, props);
};
var Vector2 = function Vector2(props) {
  return /*#__PURE__*/React.createElement(SvgVector2, props);
};
var VideoCameraSlash = function VideoCameraSlash(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCameraSlash, props);
};
var VideoCameraSlash2 = function VideoCameraSlash2(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCameraSlash2, props);
};
var VideoCamera = function VideoCamera(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera, props);
};
var VideoCamera2 = function VideoCamera2(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera2, props);
};
var VideoCamera3 = function VideoCamera3(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera3, props);
};
var VideoCamera4 = function VideoCamera4(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera4, props);
};
var VideoCamera5 = function VideoCamera5(props) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera5, props);
};
var Vimeo = function Vimeo(props) {
  return /*#__PURE__*/React.createElement(SvgVimeo, props);
};
var Vimeo2 = function Vimeo2(props) {
  return /*#__PURE__*/React.createElement(SvgVimeo2, props);
};
var Vine = function Vine(props) {
  return /*#__PURE__*/React.createElement(SvgVine, props);
};
var Virus = function Virus(props) {
  return /*#__PURE__*/React.createElement(SvgVirus, props);
};
var Vk = function Vk(props) {
  return /*#__PURE__*/React.createElement(SvgVk, props);
};
var VolumeZero = function VolumeZero(props) {
  return /*#__PURE__*/React.createElement(SvgVolume0, props);
};
var VolumeOne = function VolumeOne(props) {
  return /*#__PURE__*/React.createElement(SvgVolume1, props);
};
var VolumeTwo = function VolumeTwo(props) {
  return /*#__PURE__*/React.createElement(SvgVolume2, props);
};
var VolumeThree = function VolumeThree(props) {
  return /*#__PURE__*/React.createElement(SvgVolume3, props);
};
var VolumeFour = function VolumeFour(props) {
  return /*#__PURE__*/React.createElement(SvgVolume4, props);
};
var VolumeFive = function VolumeFive(props) {
  return /*#__PURE__*/React.createElement(SvgVolume5, props);
};
var VolumeDecrease = function VolumeDecrease(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeDecrease, props);
};
var VolumeDecrease2 = function VolumeDecrease2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeDecrease2, props);
};
var VolumeDecrease3 = function VolumeDecrease3(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeDecrease3, props);
};
var VolumeHigh = function VolumeHigh(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeHigh, props);
};
var VolumeHigh2 = function VolumeHigh2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeHigh2, props);
};
var VolumeIncrease = function VolumeIncrease(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeIncrease, props);
};
var VolumeIncrease2 = function VolumeIncrease2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeIncrease2, props);
};
var VolumeLow = function VolumeLow(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeLow, props);
};
var VolumeLow2 = function VolumeLow2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeLow2, props);
};
var VolumeMedium = function VolumeMedium(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMedium, props);
};
var VolumeMedium2 = function VolumeMedium2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMedium2, props);
};
var VolumeMedium3 = function VolumeMedium3(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMedium3, props);
};
var VolumeMute = function VolumeMute(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute, props);
};
var VolumeMute2 = function VolumeMute2(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute2, props);
};
var VolumeMute3 = function VolumeMute3(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute3, props);
};
var VolumeMute4 = function VolumeMute4(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute4, props);
};
var VolumeMute5 = function VolumeMute5(props) {
  return /*#__PURE__*/React.createElement(SvgVolumeMute5, props);
};
var Wall = function Wall(props) {
  return /*#__PURE__*/React.createElement(SvgWall, props);
};
var Wallet = function Wallet(props) {
  return /*#__PURE__*/React.createElement(SvgWallet, props);
};
var Warning = function Warning(props) {
  return /*#__PURE__*/React.createElement(SvgWarning, props);
};
var Warning2 = function Warning2(props) {
  return /*#__PURE__*/React.createElement(SvgWarning2, props);
};
var Watch = function Watch(props) {
  return /*#__PURE__*/React.createElement(SvgWatch, props);
};
var Watch2 = function Watch2(props) {
  return /*#__PURE__*/React.createElement(SvgWatch2, props);
};
var Wave = function Wave(props) {
  return /*#__PURE__*/React.createElement(SvgWave, props);
};
var Wave2 = function Wave2(props) {
  return /*#__PURE__*/React.createElement(SvgWave2, props);
};
var WeatherCloudSun = function WeatherCloudSun(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudSun, props);
};
var WeatherCloudSun2 = function WeatherCloudSun2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudSun2, props);
};
var WeatherCloudWind = function WeatherCloudWind(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudWind, props);
};
var WeatherCloudWind2 = function WeatherCloudWind2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudWind2, props);
};
var WeatherCloudy = function WeatherCloudy(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudy, props);
};
var WeatherCloudy2 = function WeatherCloudy2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherCloudy2, props);
};
var WeatherLightning = function WeatherLightning(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherLightning, props);
};
var WeatherLightning2 = function WeatherLightning2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherLightning2, props);
};
var WeatherRain = function WeatherRain(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherRain, props);
};
var WeatherRain2 = function WeatherRain2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherRain2, props);
};
var WeatherSnow = function WeatherSnow(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherSnow, props);
};
var WeatherSnow2 = function WeatherSnow2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherSnow2, props);
};
var WeatherSunWind = function WeatherSunWind(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherSunWind, props);
};
var WeatherSunWind2 = function WeatherSunWind2(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherSunWind2, props);
};
var WeatherWindy = function WeatherWindy(props) {
  return /*#__PURE__*/React.createElement(SvgWeatherWindy, props);
};
var Wegstrecke = function Wegstrecke(props) {
  return /*#__PURE__*/React.createElement(SvgIcoWegstrecke, props);
};
var Whatsapp = function Whatsapp(props) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, props);
};
var Width = function Width(props) {
  return /*#__PURE__*/React.createElement(SvgWidth, props);
};
var Wikipedia = function Wikipedia(props) {
  return /*#__PURE__*/React.createElement(SvgWikipedia, props);
};
var Windows = function Windows(props) {
  return /*#__PURE__*/React.createElement(SvgWindows, props);
};
var Windows8 = function Windows8(props) {
  return /*#__PURE__*/React.createElement(SvgWindows8, props);
};
var Wink = function Wink(props) {
  return /*#__PURE__*/React.createElement(SvgWink, props);
};
var Wink2 = function Wink2(props) {
  return /*#__PURE__*/React.createElement(SvgWink2, props);
};
var Woman = function Woman(props) {
  return /*#__PURE__*/React.createElement(SvgWoman, props);
};
var Wondering = function Wondering(props) {
  return /*#__PURE__*/React.createElement(SvgWondering, props);
};
var Wondering2 = function Wondering2(props) {
  return /*#__PURE__*/React.createElement(SvgWondering2, props);
};
var Wordpress = function Wordpress(props) {
  return /*#__PURE__*/React.createElement(SvgWordpress, props);
};
var Wrench = function Wrench(props) {
  return /*#__PURE__*/React.createElement(SvgWrench, props);
};
var Wrench2 = function Wrench2(props) {
  return /*#__PURE__*/React.createElement(SvgWrench2, props);
};
var Wrench3 = function Wrench3(props) {
  return /*#__PURE__*/React.createElement(SvgWrench3, props);
};
var Xing = function Xing(props) {
  return /*#__PURE__*/React.createElement(SvgXing, props);
};
var Xing2 = function Xing2(props) {
  return /*#__PURE__*/React.createElement(SvgXing2, props);
};
var Yahoo = function Yahoo(props) {
  return /*#__PURE__*/React.createElement(SvgYahoo, props);
};
var Yahoo2 = function Yahoo2(props) {
  return /*#__PURE__*/React.createElement(SvgYahoo2, props);
};
var Yelp = function Yelp(props) {
  return /*#__PURE__*/React.createElement(SvgYelp, props);
};
var YinYang = function YinYang(props) {
  return /*#__PURE__*/React.createElement(SvgYinYang, props);
};
var Youtube = function Youtube(props) {
  return /*#__PURE__*/React.createElement(SvgYoutube, props);
};
var Youtube2 = function Youtube2(props) {
  return /*#__PURE__*/React.createElement(SvgYoutube2, props);
};
var ZoomIn = function ZoomIn(props) {
  return /*#__PURE__*/React.createElement(SvgZoomIn, props);
};
var ZoomIn2 = function ZoomIn2(props) {
  return /*#__PURE__*/React.createElement(SvgZoomIn2, props);
};
var ZoomIn3 = function ZoomIn3(props) {
  return /*#__PURE__*/React.createElement(SvgZoomIn3, props);
};
var ZoomOut = function ZoomOut(props) {
  return /*#__PURE__*/React.createElement(SvgZoomOut, props);
};
var ZoomOut2 = function ZoomOut2(props) {
  return /*#__PURE__*/React.createElement(SvgZoomOut2, props);
};
var ZoomOut3 = function ZoomOut3(props) {
  return /*#__PURE__*/React.createElement(SvgZoomOut3, props);
};

export { Accessibility, Accessibility2, AddressBook, AddressBook2, AddressBook3, AidKit, AidKit2, Airplane, Airplane2, Airplane3, Airplane4, Alarm, Alarm2, AlarmAdd, AlarmCancel, AlarmCheck, Album, AlignBottom, AlignCenterHorizontal, AlignCenterVertical, AlignLeft, AlignRight, AlignTop, Amazon, Ambulance, Ammo, Ampersand, Anchor, Android, Angle, Angry, Angry2, Antenna, Antenna2, Apple, Appleinc, Archery, Archive, ArrowDown, ArrowDown10, ArrowDown11, ArrowDown12, ArrowDown13, ArrowDown14, ArrowDown15, ArrowDown16, ArrowDown2, ArrowDown3, ArrowDown4, ArrowDown5, ArrowDown6, ArrowDown7, ArrowDown8, ArrowDown9, ArrowDownLeft, ArrowDownLeft2, ArrowDownLeft3, ArrowDownLeft4, ArrowDownLeft5, ArrowDownRight, ArrowDownRight2, ArrowDownRight3, ArrowDownRight4, ArrowDownRight5, ArrowLeft, ArrowLeft10, ArrowLeft11, ArrowLeft12, ArrowLeft13, ArrowLeft14, ArrowLeft15, ArrowLeft16, ArrowLeft2, ArrowLeft3, ArrowLeft4, ArrowLeft5, ArrowLeft6, ArrowLeft7, ArrowLeft8, ArrowLeft9, ArrowResize, ArrowResize2, ArrowResize3, ArrowResize4, ArrowResize5, ArrowResize6, ArrowResize7, ArrowResize8, ArrowRight, ArrowRight10, ArrowRight11, ArrowRight12, ArrowRight13, ArrowRight14, ArrowRight15, ArrowRight16, ArrowRight2, ArrowRight3, ArrowRight4, ArrowRight5, ArrowRight6, ArrowRight7, ArrowRight8, ArrowRight9, ArrowRightFilled, ArrowRightOutline, ArrowUp, ArrowUp10, ArrowUp11, ArrowUp12, ArrowUp13, ArrowUp14, ArrowUp15, ArrowUp16, ArrowUp2, ArrowUp3, ArrowUp4, ArrowUp5, ArrowUp6, ArrowUp7, ArrowUp8, ArrowUp9, ArrowUpLeft, ArrowUpLeft2, ArrowUpLeft3, ArrowUpLeft4, ArrowUpLeft5, ArrowUpRight, ArrowUpRight2, ArrowUpRight3, ArrowUpRight4, ArrowUpRight5, AtSign, Atom, Atom2, Attachment, Attachment2, Backspace, Backspace2, Backward, Backward2, Baffled, Baffled2, Bag, Bag2, Balance, Balloon, Barcode, Barcode2, Baseball, Basecamp, Basket, Basketball, BatteryCharging, BatteryFive, BatteryFour, BatteryOne, BatterySix, BatteryThree, BatteryTwo, BatteryZero, Bed, Bed2, Behance, Behance2, Bell, Bell2, Bell3, BellCheck, BellCross, BellMinus, BellPlus, Bike, Bin, Bin2, Bin3, Bin4, Bin5, Binoculars, Binoculars2, Blocked, Blog, Blog2, Blogger, Blogger2, Boat, Bold, Bold2, Bomb, Book, Book2, Book3, BookPlay, Bookmark, Bookmark2, Bookmark3, Bookmark4, Bookmarks, Books, Bottle, Bottle2, Bottle3, Bottle4, Bow, Bowling, Bowling2, Bowtie, Box, BoxAdd, BoxRemove, Brain, Bread, Briefcase, Briefcase2, Briefcase3, BrightnessContrast, BrightnessHigh, BrightnessLow, BrightnessMedium, Broom, Brush, Bubble, Bubble2, Bubble3, Bubble4, Bubble5, Bubble6, Bubble7, Bubble8, Bubble9, BubbleBlocked, BubbleCancel, BubbleCheck, BubbleDots, BubbleDots2, BubbleDots3, BubbleDots4, BubbleFirst, BubbleForward, BubbleForward2, BubbleHeart, BubbleLast, BubbleLeft, BubbleLines, BubbleLines2, BubbleLines3, BubbleLines4, BubbleLink, BubbleLock, BubbleMinus, BubbleNotification, BubbleNotification2, BubblePaperclip, BubblePlus, BubbleQuote, BubbleReply, BubbleReply2, BubbleRight, BubbleSmiley, BubbleStar, BubbleUser, BubbleVideo, Bubbles, Bubbles10, Bubbles2, Bubbles3, Bubbles4, Bubbles5, Bubbles6, Bubbles7, Bubbles8, Bubbles9, Bucket, Bucket2, Bug, Bug2, Bullhorn, Bus, Cabinet, Cactus, Cake, Calculator, Calculator2, Calculator3, Calendar, Calendar2, Calendar3, Calendar4, Calendar5, CalendarDay, CalendarEmpty, CalendarWeek, Camera, Camera2, Camera3, Cancel, CancelCircle, CancelCircle2, CancelSquare, CancelSquare2, Car, Car2, Cart, Cart2, Cart3, Cart4, Cart5, CartAdd, CartAdd2, CartRemove, Cash, Cash2, Cash3, Cash4, Cassette, Cc, Certificate, Chair, Chart, CheckboxChecked, CheckboxChecked2, CheckboxPartial, CheckboxPartial2, CheckboxUnchecked, CheckboxUnchecked2, Checkmark, Checkmark2, Checkmark3, Checkmark4, Checkmark5, CheckmarkCircle, Cheese, Cherry, Chess, ChessBishop, ChessKing, ChessKnight, ChessPawn, ChessQueen, ChessRook, Chicken, Chip, Chopper, Chopper2, Chrome, Circle, Circle2, CircleCode, CircleCss, CircleDown, CircleDown2, CircleDown3, CircleDown4, CircleDown5, CircleDown6, CircleDownLeft, CircleDownLeft2, CircleDownRight, CircleDownRight2, CircleLeft, CircleLeft2, CircleLeft3, CircleLeft4, CircleLeft5, CircleLeft6, CircleRight, CircleRight2, CircleRight3, CircleRight4, CircleRight5, CircleRight6, CircleSmall, CircleUp, CircleUp2, CircleUp3, CircleUp4, CircleUp5, CircleUp6, CircleUpLeft, CircleUpLeft2, CircleUpRight, CircleUpRight2, Circles, Circles2, City, Clapboard, ClapboardPlay, ClearFormatting, Clipboard, Clipboard2, Clipboard3, Clipboard4, Clipboard5, Clipboard6, Clock, Clock2, Clock3, Clock4, Cloud, Cloud2, CloudCheck, CloudCheck2, CloudDownload, CloudDownload2, CloudUpload, CloudUpload2, Clubs, Code, Codepen, Coffee, CoffeeBean, Cog, Cog2, Cog3, Cog4, Cog5, Cog6, Cog7, Cogs, CoinDollar, CoinEuro, CoinPound, CoinYen, Coins, Collaboration, ColorClear, ColorSampler, Comb, Command, Compass, Compass2, Compass3, Compass4, Compass5, Compass6, Confused, Confused2, Connection, Connection2, Connection3, Connection4, Construction, Contrast, Cook, Cool, Cool2, Copy, Copy2, Copy3, Copy4, CreditCard, CreditCard2, Crop, Crop2, Cross, Cross2, Cross3, Crown, Crying, Crying2, Css3, Ctrl, Cube, Cube2, Cube3, Cube4, Cup, Cup2, Cursor, Cursor2, Database, Database2, Database3, Database4, DatabaseAdd, DatabaseArrow, DatabaseCheck, DatabaseDiff, DatabaseEdit, DatabaseEdit2, DatabaseExport, DatabaseInsert, DatabaseMenu, DatabaseRefresh, DatabaseRemove, DatabaseTime, DatabaseTime2, DatabaseUpload, DayNight, DayNight2, Delicious, Design, Deviantart, Diamond, Diamond2, Diamond3, Diamond4, Diamonds, Dice, Direction, Disk, Disk2, Display, Display2, Display3, Display4, Dots, Download, Download10, Download11, Download2, Download3, Download4, Download5, Download6, Download7, Download8, Download9, DragLeft, DragLeftRight, DragRight, Drawer, Drawer2, Drawer3, DrawerIn, DrawerOut, Dribbble, Drive, Dropbox, Droplet, Droplet2, DropletContrast, Dumbbell, Earth, Earth2, Earth3, Edge, EightBall, Eject, Ello, Embed, Embed2, Enlarge, Enlarge2, Enlarge3, Enlarge4, Enlarge5, Enlarge6, Enlarge7, Enter, Enter2, Enter3, Enter4, Enter5, Enter6, Envelop, Envelop2, Envelop3, Envelop4, Envelop5, Equalizer, Equalizer2, Equalizer3, Equalizer4, Eraser, Eraser2, Eraser3, Esc, Evil, Evil2, Exclude, Exit, Exit2, Exit3, ExternalLink, Eye, Eye2, Eye3, Eye4, EyeBlocked, EyeBlocked2, EyeBlocked3, EyeMinus, EyePlus, Eyedropper, Eyedropper2, Eyedropper3, Facebook, Facebook2, Factory, Fan, Feed, Female, Fence, FileCheck, FileCheck2, FileCss, FileCss2, FileDownload, FileDownload2, FileEmpty, FileEmpty2, FileExcel, FileEye, FileEye2, FileLocked, FileLocked2, FileMinus, FileMinus2, FileMusic, FileMusic2, FileOpenoffice, FilePdf, FilePicture, FilePicture2, FilePlay, FilePlay2, FilePlus, FilePlus2, FilePresentation, FilePresentation2, FileSpreadsheet, FileSpreadsheet2, FileStats, FileStats2, FileText, FileText2, FileText3, FileUpload, FileUpload2, FileVideo, FileVideo2, FileWord, FileXml, FileXml2, FileZip, FileZip2, FilesEmpty, FilesEmpty2, Film, Film2, Film3, Film4, Filter, Filter2, Filter3, Filter4, Finder, Finish, Fire, Fire2, Firefox, First, First2, Fish, Five00px, Flag, Flag2, Flag3, Flag4, Flag5, Flag6, Flag7, Flag8, Flattr, Flickr, Flickr2, Flickr3, Flickr4, FlipHorizontal, FlipHorizontal2, FlipVertical, FlipVertical2, FlipVertical3, FlipVertical4, FloppyDisk, FloppyDisk2, FloppyDisk3, FloppyDisks, FloppyDisks2, Flower, Flower2, Folder, Folder2, Folder3, Folder4, Folder5, Folder6, FolderCheck, FolderDownload, FolderDownload2, FolderDownload3, FolderHeart, FolderMinus, FolderMinus2, FolderMinus3, FolderMinus4, FolderOpen, FolderOpen2, FolderOpen3, FolderPlus, FolderPlus2, FolderPlus3, FolderPlus4, FolderRemove, FolderSearch, FolderUpload, FolderUpload2, FolderUpload3, Font, FontSize, FontSize2, Football, Footprint, ForkKnife, Forward, Forward2, Forward3, Foursquare, Frustrated, Frustrated2, Furniture, Gamepad, Gamepad2, Gamepad3, Gas, Gebaerdensprache, Gift, Gift2, Git, Github, Glass, Glass2, Glass3, Glass4, Glasses, Glasses2, GlassesThreed, GlassesThreed2, Golf, Golf2, Google, Google2, Google3, GoogleDrive, GooglePlus, GooglePlus2, GooglePlus3, Grab, Gradient, Graduation, Grapes, Grid, Grid2, Grid3, Grid4, Grid5, Grid6, Grid7, Grin, Grin2, Guitar, Gun, GunForbidden, Hackernews, Haircut, Hamburger, Hammer, Hammer2, HammerWrench, Hand, Hanger, Hangouts, Happy, Happy2, Hat, Headphones, Headset, Heart, Heart2, Heart3, Heart4, Heart5, Heart6, Heart7, Heart8, HeartBroken, HeartBroken2, HeartBroken3, Height, Height2, Highlight, Hipster, Hipster2, History, Hockey, Home, Home2, Home3, Home4, Home5, Home6, Home7, Home8, Home9, HourGlass, HourGlass2, HourGlass3, HtmlFive, HtmlFive2, IE, Icecream, IcoMoon, Image, Image2, Image3, Image4, Image5, Image6, ImageCompare, Images, Images2, Images3, Import, Import2, IndentDecrease, IndentDecrease2, IndentIncrease, IndentIncrease2, Infinite, Infinite2, InfiniteSquare, Info, Info2, InsertTemplate, Instagram, Interset, Italic, Italic2, Joomla, Key, Key2, Key3, Key4, Key5, KeyA, KeyDown, KeyKeyboard, KeyLeft, KeyRight, KeyUp, Keyboard, Keyboard2, Keyhole, Knife, Lab, Ladder, Lamp, Lamp2, Lamp3, Lamp4, Lamp5, Lamp6, Lamp7, Lamp8, Lan, Lan2, Lan3, Lanyrd, Laptop, Lasso, Lasso2, Last, Last2, Lastfm, Lastfm2, Laundry, Leaf, Leaf2, LeichteSprache, Library, Library2, Libreoffice, Lifebuoy, Ligature, Ligature2, Link, Link2, Link3, Link4, Link5, Linkedin, Linkedin2, Lips, Lips2, List, List2, ListNumbered, Load, LoadingCircle, Location, Location2, Location3, Location4, Location5, Location6, Location7, Lock, Lock2, Lock3, Lock4, Lock5, Login, Loop, Loop2, Loop3, Loop4, Ltr, Ltr2, Magazine, MagicWand, MagicWand2, Magnet, Magnet2, Magnifier, MagnifierMenu, Mail, Mail2, Mail3, Mail4, Mailbox, MakeGroup, Male, Man, ManWoman, Map, Map2, Map3, Map4, Map5, Marker, Marker2, Markup, Medal, Medal2, MedalFirst, MedalSecond, MedalStar, MedalThird, Media, Megaphone, Menu, Menu10, Menu2, Menu3, Menu4, Menu5, Menu6, Menu7, Menu8, Menu9, MenuClose, MenuClose2, MenuOpen, MenuOpen2, Merge, Meter, Meter2, Meter3, MeterFast, MeterMedium, MeterSlow, Mic, Mic2, Mic3, Mic4, Mic5, MicOff, MicOff2, Microscope, Milk, Minus, Minus2, Minus3, MinusCircle, MinusCircle2, Mobile, Mobile2, Mobile3, Moon, More, More2, Mountains, Mouse, Mouse2, MouseLeft, MouseRight, Move, MoveDown, MoveUp, Movie, Mug, Multitouch, Music, Music2, Music3, Music4, Music5, Music6, Mustache, Mustache2, Nbsp, Neutral, Neutral2, New, NewTab, NewTab2, Newspaper, Next, Next2, Notebook, Notification, Notification2, Npm, Office, Omega, Onedrive, Opera, Opt, Outlet, Package, Pacman, PageBreak, PageBreak2, Pagebreak, PaintFormat, Palette, Palette2, Pandage, Pandage2, Pants, Paperplane, ParagraphCenter, ParagraphCenter2, ParagraphCenter3, ParagraphJustify, ParagraphJustify2, ParagraphJustify3, ParagraphLeft, ParagraphLeft2, ParagraphLeft3, ParagraphRight, ParagraphRight2, ParagraphRight3, Paste, Paste2, Paste3, Paste4, Pause, Pause2, Paw, Paypal, Peace, Pen, Pen2, Pen3, Pen4, Pen5, Pen6, PenMinus, PenPlus, Pencil, Pencil2, Pencil3, Pencil4, Pencil5, Pencil6, Pencil7, PencilRuler, Percent, Phone, Phone2, Phone3, PhoneHangUp, PhoneHangUp2, PhoneIncoming, PhoneMinus, PhoneMinus2, PhoneOutgoing, PhonePlus, PhonePlus2, PhoneSlash, PhoneSlash2, PhoneWave, PhoneWave2, Piano, PieChart, PieChart2, PieChart3, PieChart4, PieChart5, PieChart6, PieChart7, PieChart8, PiggyBank, Pilcrow, Pill, Pingpong, Pinterest, Pinterest2, Pipe, Pizza, Planet, Planet2, Plate, Play, Play2, Play3, Play4, Playlist, PlaylistAdd, Plus, Plus2, Plus3, PlusCircle, PlusCircle2, Podcast, Podcast2, Podium, PointDown, PointLeft, PointRight, PointUp, Pointer, Popout, Power, Power2, Power3, PowerCord, PowerCord2, Presentation, Previous, Previous2, PriceTag, PriceTag2, PriceTag3, PriceTag4, PriceTag5, PriceTags, PriceTags2, PriceTags3, PriceTags4, Printer, Printer2, Printer3, Printer4, Profile, Pulse, Pulse2, Pushpin, Pushpin2, Puzzle, Puzzle2, Puzzle3, Puzzle4, Pyramid, Pyramid2, Qrcode, Question, Question2, Question3, Question4, Question5, Question6, Quill, Quill2, Quill3, Quill4, Quotes, QuotesLeft, QuotesLeft2, QuotesRight, QuotesRight2, Racing, Radio, RadioChecked, RadioChecked2, RadioUnchecked, Rating, Rating2, Rating3, Reading, Recording, Reddit, Redo, Redo2, Regexp, Regexp2, Reminder, Renren, Reply, ReplyAll, Reset, Road, Rocket, RotateCcw, RotateCcw2, RotateCcw3, RotateCw, RotateCw2, RotateCw3, Rss, Rss2, Rtl, Rtl2, Ruler, Rulers, Sad, Sad2, Safari, Safe, SatelliteDish, SatelliteDish2, Scale, Scissors, Scissors2, Scissors3, Screwdriver, Screwdriver2, Search, Search2, Search3, Search4, Search5, Search6, SearchPlus, Section, Select, Select2, Server, SevenSegmentEight, SevenSegmentFive, SevenSegmentFour, SevenSegmentNine, SevenSegmentOne, SevenSegmentSeven, SevenSegmentSix, SevenSegmentThree, SevenSegmentTwo, SevenSegmentZero, Share, Share2, Share3, Share4, Shear, Shield, Shield2, Shield3, Shield4, ShieldCheck, ShieldNotice, Shift, Ship, Shocked, Shocked2, Shorts, Shredder, Shrink, Shrink2, Shrink3, Shrink4, Shrink5, Shrink6, Shrink7, Shuffle, Shuffle2, Shutter, Sigma, SinaWeibo, Skull, Skull2, Skype, Sleepy, Sleepy2, Smile, Smile2, Snowflake, Soccer, Sock, Sort, Sort2, SortAlphaAsc, SortAlphaDesc, SortAmountAsc, SortAmountDesc, SortNumbericDesc, SortNumericAsc, SortTimeAsc, SortTimeDesc, Soundcloud, Soundcloud2, Spades, Spam, SpeakerLeft, SpeakerRight, Speakers, SpellCheck, SpellCheck2, Sphere, Sphere2, Sphere3, Spinner, Spinner10, Spinner11, Spinner2, Spinner3, Spinner4, Spinner5, Spinner6, Spinner7, Spinner8, Spinner9, Split, SpoonKnife, Spotify, Spotlight, Spotlight2, Spray, Square, SquareDown, SquareDownLeft, SquareDownRight, SquareLeft, SquareRight, SquareUp, SquareUpLeft, SquareUpRight, Stack, Stack2, Stack3, Stack4, StackCancel, StackCheck, StackClubs, StackDiamonds, StackDown, StackEmpty, StackHearts, StackMinus, StackMusic, StackPicture, StackPlay, StackPlus, StackSpades, StackStar, StackText, StackUp, StackUser, Stackoverflow, Stairs, Stairs2, StairsDown, StairsUp, Stamp, Star, StarEmpty, StarEmpty2, StarEmpty3, StarFull, StarFull2, StarHalf, Starburst, Stars, Station, Station2, StatsBars, StatsBars2, StatsBars3, StatsBars4, StatsBars5, StatsBars6, StatsDecline, StatsDecline2, StatsDots, StatsGrowth, StatsGrowth2, Steak, Steam, Steam2, SteeringWheel, Stethoscope, Stop, Stop2, Stopwatch, StopwatchEdit, Store, Store2, Strategy, Strikethrough, Strikethrough2, Strikethrough3, Stumbleupon, Stumbleupon2, Subscript, Subscript2, Subtract, Sun, Sun2, Sun3, Superscript, Superscript2, Svg, Switch, Switch2, Sword, Syringe, Syringe2, Tab, Table, Table2, Tablet, Tape, Target, Target2, Target3, Target4, Teapot, Telegram, Temperature, Temperature2, Tennis, Tent, Terminal, TextColor, TextHeight, TextWidth, Theater, Themes, ThumbsDown, ThumbsDown2, ThumbsDown3, ThumbsUp, ThumbsUp2, ThumbsUp3, Ticket, Ticket2, Tie, Toggle, ToggleOff, ToggleOn, Toiletpaper, Tongue, Tongue2, Touch, TouchPinch, TouchZoom, TrafficCone, TrafficLights, Train, Train2, Transmission, Transmission2, Tree, Tree2, Tree3, Tree4, Tree5, Tree6, Tree7, Trello, Triangle, Triangle2, Trophy, Trophy2, Trophy3, Trophy4, Truck, Trumpet, Tshirt, Tumblr, Tumblr2, Tux, Tv, Twitch, Twitter, Typewriter, Typography, Umbrella, Underline, Underline2, Undo, Undo2, Ungroup, Unicode, Unite, Unlink, Unlink2, Unlink3, Unlink4, Unlink5, Unlocked, Unlocked2, Upload, Upload10, Upload2, Upload3, Upload4, Upload5, Upload6, Upload7, Upload8, Upload9, UsbStick, User, User2, User3, User4, User5, User6, User7, UserBlock, UserBlock2, UserCancel, UserCancel2, UserCheck, UserCheck2, UserLock, UserLock2, UserMinus, UserMinus2, UserPlus, UserPlus2, UserTie, Users, Users2, Users3, Users4, Users5, Vcard, Vector, Vector2, VideoCamera, VideoCamera2, VideoCamera3, VideoCamera4, VideoCamera5, VideoCameraSlash, VideoCameraSlash2, Vimeo, Vimeo2, Vine, Virus, Vk, VolumeDecrease, VolumeDecrease2, VolumeDecrease3, VolumeFive, VolumeFour, VolumeHigh, VolumeHigh2, VolumeIncrease, VolumeIncrease2, VolumeLow, VolumeLow2, VolumeMedium, VolumeMedium2, VolumeMedium3, VolumeMute, VolumeMute2, VolumeMute3, VolumeMute4, VolumeMute5, VolumeOne, VolumeThree, VolumeTwo, VolumeZero, Wall, Wallet, Warning, Warning2, Watch, Watch2, Wave, Wave2, WeatherCloudSun, WeatherCloudSun2, WeatherCloudWind, WeatherCloudWind2, WeatherCloudy, WeatherCloudy2, WeatherLightning, WeatherLightning2, WeatherRain, WeatherRain2, WeatherSnow, WeatherSnow2, WeatherSunWind, WeatherSunWind2, WeatherWindy, Wegstrecke, Whatsapp, Width, Wikipedia, Windows, Windows8, Wink, Wink2, Woman, Wondering, Wondering2, Wordpress, Wrench, Wrench2, Wrench3, Xing, Xing2, Yahoo, Yahoo2, Yelp, YinYang, Youtube, Youtube2, ZoomIn, ZoomIn2, ZoomIn3, ZoomOut, ZoomOut2, ZoomOut3 };
